webpackJsonp(["pages.projects.merge_requests.show","emoji"],{

/***/ "../../../fixtures/emojis/aliases.json":
/***/ (function(module, exports) {

module.exports = {"small_airplane":"airplane_small","right_anger_bubble":"anger_right","keycap_asterisk":"asterisk","atom_symbol":"atom","ballot_box_with_ballot":"ballot_box","person_with_ball":"basketball_player","person_with_ball_tone1":"basketball_player_tone1","person_with_ball_tone2":"basketball_player_tone2","person_with_ball_tone3":"basketball_player_tone3","person_with_ball_tone4":"basketball_player_tone4","person_with_ball_tone5":"basketball_player_tone5","beach_with_umbrella":"beach","umbrella_on_ground":"beach_umbrella","bellhop_bell":"bellhop","biohazard_sign":"biohazard","archery":"bow_and_arrow","boxing_gloves":"boxing_glove","spiral_calendar_pad":"calendar_spiral","call_me_hand":"call_me","call_me_hand_tone1":"call_me_tone1","call_me_hand_tone2":"call_me_tone2","call_me_hand_tone3":"call_me_tone3","call_me_hand_tone4":"call_me_tone4","call_me_hand_tone5":"call_me_tone5","kayak":"canoe","card_file_box":"card_box","person_doing_cartwheel":"cartwheel","person_doing_cartwheel_tone1":"cartwheel_tone1","person_doing_cartwheel_tone2":"cartwheel_tone2","person_doing_cartwheel_tone3":"cartwheel_tone3","person_doing_cartwheel_tone4":"cartwheel_tone4","person_doing_cartwheel_tone5":"cartwheel_tone5","bottle_with_popping_cork":"champagne","clinking_glass":"champagne_glass","cheese_wedge":"cheese","city_sunrise":"city_sunset","mantlepiece_clock":"clock","cloud_with_lightning":"cloud_lightning","cloud_with_rain":"cloud_rain","cloud_with_snow":"cloud_snow","cloud_with_tornado":"cloud_tornado","clown_face":"clown","building_construction":"construction_site","couch_and_lamp":"couch","couple_with_heart_mm":"couple_mm","couple_with_heart_ww":"couple_ww","face_with_cowboy_hat":"cowboy","lower_left_crayon":"crayon","cricket_bat_ball":"cricket","latin_cross":"cross","passenger_ship":"cruise_ship","dagger_knife":"dagger","desktop_computer":"desktop","card_index_dividers":"dividers","dove_of_peace":"dove","drool":"drooling_face","drum_with_drumsticks":"drum","email":"e-mail","eject_symbol":"eject","facepalm":"face_palm","facepalm_tone1":"face_palm_tone1","facepalm_tone2":"face_palm_tone2","facepalm_tone3":"face_palm_tone3","facepalm_tone4":"face_palm_tone4","facepalm_tone5":"face_palm_tone5","fencing":"fencer","hand_with_index_and_middle_finger_crossed":"fingers_crossed","hand_with_index_and_middle_fingers_crossed_tone1":"fingers_crossed_tone1","hand_with_index_and_middle_fingers_crossed_tone2":"fingers_crossed_tone2","hand_with_index_and_middle_fingers_crossed_tone3":"fingers_crossed_tone3","hand_with_index_and_middle_fingers_crossed_tone4":"fingers_crossed_tone4","hand_with_index_and_middle_fingers_crossed_tone5":"fingers_crossed_tone5","flame":"fire","first_place_medal":"first_place","ac":"flag_ac","ad":"flag_ad","ae":"flag_ae","af":"flag_af","ag":"flag_ag","ai":"flag_ai","al":"flag_al","am":"flag_am","ao":"flag_ao","aq":"flag_aq","ar":"flag_ar","as":"flag_as","at":"flag_at","au":"flag_au","aw":"flag_aw","ax":"flag_ax","az":"flag_az","ba":"flag_ba","bb":"flag_bb","bd":"flag_bd","be":"flag_be","bf":"flag_bf","bg":"flag_bg","bh":"flag_bh","bi":"flag_bi","bj":"flag_bj","bl":"flag_bl","waving_black_flag":"flag_black","bm":"flag_bm","bn":"flag_bn","bo":"flag_bo","bq":"flag_bq","br":"flag_br","bs":"flag_bs","bt":"flag_bt","bv":"flag_bv","bw":"flag_bw","by":"flag_by","bz":"flag_bz","ca":"flag_ca","cc":"flag_cc","congo":"flag_cd","cf":"flag_cf","cg":"flag_cg","ch":"flag_ch","ci":"flag_ci","ck":"flag_ck","chile":"flag_cl","cm":"flag_cm","cn":"flag_cn","co":"flag_co","cp":"flag_cp","cr":"flag_cr","cu":"flag_cu","cv":"flag_cv","cw":"flag_cw","cx":"flag_cx","cy":"flag_cy","cz":"flag_cz","de":"flag_de","dg":"flag_dg","dj":"flag_dj","dk":"flag_dk","dm":"flag_dm","do":"flag_do","dz":"flag_dz","ea":"flag_ea","ec":"flag_ec","ee":"flag_ee","eg":"flag_eg","eh":"flag_eh","er":"flag_er","es":"flag_es","et":"flag_et","eu":"flag_eu","fi":"flag_fi","fj":"flag_fj","fk":"flag_fk","fm":"flag_fm","fo":"flag_fo","fr":"flag_fr","ga":"flag_ga","gb":"flag_gb","gd":"flag_gd","ge":"flag_ge","gf":"flag_gf","gg":"flag_gg","gh":"flag_gh","gi":"flag_gi","gl":"flag_gl","gm":"flag_gm","gn":"flag_gn","gp":"flag_gp","gq":"flag_gq","gr":"flag_gr","gs":"flag_gs","gt":"flag_gt","gu":"flag_gu","gw":"flag_gw","gy":"flag_gy","hk":"flag_hk","hm":"flag_hm","hn":"flag_hn","hr":"flag_hr","ht":"flag_ht","hu":"flag_hu","ic":"flag_ic","indonesia":"flag_id","ie":"flag_ie","il":"flag_il","im":"flag_im","in":"flag_in","io":"flag_io","iq":"flag_iq","ir":"flag_ir","is":"flag_is","it":"flag_it","je":"flag_je","jm":"flag_jm","jo":"flag_jo","jp":"flag_jp","ke":"flag_ke","kg":"flag_kg","kh":"flag_kh","ki":"flag_ki","km":"flag_km","kn":"flag_kn","kp":"flag_kp","kr":"flag_kr","kw":"flag_kw","ky":"flag_ky","kz":"flag_kz","la":"flag_la","lb":"flag_lb","lc":"flag_lc","li":"flag_li","lk":"flag_lk","lr":"flag_lr","ls":"flag_ls","lt":"flag_lt","lu":"flag_lu","lv":"flag_lv","ly":"flag_ly","ma":"flag_ma","mc":"flag_mc","md":"flag_md","me":"flag_me","mf":"flag_mf","mg":"flag_mg","mh":"flag_mh","mk":"flag_mk","ml":"flag_ml","mm":"flag_mm","mn":"flag_mn","mo":"flag_mo","mp":"flag_mp","mq":"flag_mq","mr":"flag_mr","ms":"flag_ms","mt":"flag_mt","mu":"flag_mu","mv":"flag_mv","mw":"flag_mw","mx":"flag_mx","my":"flag_my","mz":"flag_mz","na":"flag_na","nc":"flag_nc","ne":"flag_ne","nf":"flag_nf","nigeria":"flag_ng","ni":"flag_ni","nl":"flag_nl","no":"flag_no","np":"flag_np","nr":"flag_nr","nu":"flag_nu","nz":"flag_nz","om":"flag_om","pa":"flag_pa","pe":"flag_pe","pf":"flag_pf","pg":"flag_pg","ph":"flag_ph","pk":"flag_pk","pl":"flag_pl","pm":"flag_pm","pn":"flag_pn","pr":"flag_pr","ps":"flag_ps","pt":"flag_pt","pw":"flag_pw","py":"flag_py","qa":"flag_qa","re":"flag_re","ro":"flag_ro","rs":"flag_rs","ru":"flag_ru","rw":"flag_rw","saudiarabia":"flag_sa","saudi":"flag_sa","sb":"flag_sb","sc":"flag_sc","sd":"flag_sd","se":"flag_se","sg":"flag_sg","sh":"flag_sh","si":"flag_si","sj":"flag_sj","sk":"flag_sk","sl":"flag_sl","sm":"flag_sm","sn":"flag_sn","so":"flag_so","sr":"flag_sr","ss":"flag_ss","st":"flag_st","sv":"flag_sv","sx":"flag_sx","sy":"flag_sy","sz":"flag_sz","ta":"flag_ta","tc":"flag_tc","td":"flag_td","tf":"flag_tf","tg":"flag_tg","th":"flag_th","tj":"flag_tj","tk":"flag_tk","tl":"flag_tl","turkmenistan":"flag_tm","tn":"flag_tn","to":"flag_to","tr":"flag_tr","tt":"flag_tt","tuvalu":"flag_tv","tw":"flag_tw","tz":"flag_tz","ua":"flag_ua","ug":"flag_ug","um":"flag_um","us":"flag_us","uy":"flag_uy","uz":"flag_uz","va":"flag_va","vc":"flag_vc","ve":"flag_ve","vg":"flag_vg","vi":"flag_vi","vn":"flag_vn","vu":"flag_vu","wf":"flag_wf","waving_white_flag":"flag_white","ws":"flag_ws","xk":"flag_xk","ye":"flag_ye","yt":"flag_yt","za":"flag_za","zm":"flag_zm","zw":"flag_zw","fork_and_knife_with_plate":"fork_knife_plate","fox_face":"fox","frame_with_picture":"frame_photo","baguette_bread":"french_bread","anguished":"frowning","white_frowning_face":"frowning2","rainbow_flag":"gay_pride_flag","goal_net":"goal","hammer_and_pick":"hammer_pick","raised_hand_with_fingers_splayed":"hand_splayed","raised_hand_with_fingers_splayed_tone1":"hand_splayed_tone1","raised_hand_with_fingers_splayed_tone2":"hand_splayed_tone2","raised_hand_with_fingers_splayed_tone3":"hand_splayed_tone3","raised_hand_with_fingers_splayed_tone4":"hand_splayed_tone4","raised_hand_with_fingers_splayed_tone5":"hand_splayed_tone5","shaking_hands":"handshake","shaking_hands_tone1":"handshake_tone1","shaking_hands_tone2":"handshake_tone2","shaking_hands_tone3":"handshake_tone3","shaking_hands_tone4":"handshake_tone4","shaking_hands_tone5":"handshake_tone5","face_with_head_bandage":"head_bandage","heavy_heart_exclamation_mark_ornament":"heart_exclamation","helmet_with_white_cross":"helmet_with_cross","house_buildings":"homes","hot_dog":"hotdog","derelict_house_building":"house_abandoned","hugging_face":"hugging","desert_island":"island","juggler":"juggling","juggler_tone1":"juggling_tone1","juggler_tone2":"juggling_tone2","juggler_tone3":"juggling_tone3","juggler_tone4":"juggling_tone4","juggler_tone5":"juggling_tone5","old_key":"key2","couplekiss_mm":"kiss_mm","couplekiss_ww":"kiss_ww","kiwifruit":"kiwi","satisfied":"laughing","left_fist":"left_facing_fist","left_fist_tone1":"left_facing_fist_tone1","left_fist_tone2":"left_facing_fist_tone2","left_fist_tone3":"left_facing_fist_tone3","left_fist_tone4":"left_facing_fist_tone4","left_fist_tone5":"left_facing_fist_tone5","man_in_business_suit_levitating":"levitate","weight_lifter":"lifter","weight_lifter_tone1":"lifter_tone1","weight_lifter_tone2":"lifter_tone2","weight_lifter_tone3":"lifter_tone3","weight_lifter_tone4":"lifter_tone4","weight_lifter_tone5":"lifter_tone5","lion":"lion_face","liar":"lying_face","male_dancer":"man_dancing","male_dancer_tone1":"man_dancing_tone1","male_dancer_tone2":"man_dancing_tone2","male_dancer_tone3":"man_dancing_tone3","male_dancer_tone4":"man_dancing_tone4","male_dancer_tone5":"man_dancing_tone5","tuxedo_tone1":"man_in_tuxedo_tone1","tuxedo_tone2":"man_in_tuxedo_tone2","tuxedo_tone3":"man_in_tuxedo_tone3","tuxedo_tone4":"man_in_tuxedo_tone4","tuxedo_tone5":"man_in_tuxedo_tone5","world_map":"map","karate_uniform":"martial_arts_uniform","sports_medal":"medal","sign_of_the_horns":"metal","sign_of_the_horns_tone1":"metal_tone1","sign_of_the_horns_tone2":"metal_tone2","sign_of_the_horns_tone3":"metal_tone3","sign_of_the_horns_tone4":"metal_tone4","sign_of_the_horns_tone5":"metal_tone5","studio_microphone":"microphone2","reversed_hand_with_middle_finger_extended":"middle_finger","reversed_hand_with_middle_finger_extended_tone1":"middle_finger_tone1","reversed_hand_with_middle_finger_extended_tone2":"middle_finger_tone2","reversed_hand_with_middle_finger_extended_tone3":"middle_finger_tone3","reversed_hand_with_middle_finger_extended_tone4":"middle_finger_tone4","reversed_hand_with_middle_finger_extended_tone5":"middle_finger_tone5","glass_of_milk":"milk","money_mouth_face":"money_mouth","motorbike":"motor_scooter","racing_motorcycle":"motorcycle","snow_capped_mountain":"mountain_snow","three_button_mouse":"mouse_three_button","mother_christmas":"mrs_claus","mother_christmas_tone1":"mrs_claus_tone1","mother_christmas_tone2":"mrs_claus_tone2","mother_christmas_tone3":"mrs_claus_tone3","mother_christmas_tone4":"mrs_claus_tone4","mother_christmas_tone5":"mrs_claus_tone5","sick":"nauseated_face","nerd_face":"nerd","rolled_up_newspaper":"newspaper2","spiral_note_pad":"notepad_spiral","stop_sign":"octagonal_sign","oil_drum":"oil","grandma":"older_woman","grandma_tone1":"older_woman_tone1","grandma_tone2":"older_woman_tone2","grandma_tone3":"older_woman_tone3","grandma_tone4":"older_woman_tone4","grandma_tone5":"older_woman_tone5","lower_left_paintbrush":"paintbrush","linked_paperclips":"paperclips","national_park":"park","double_vertical_bar":"pause_button","peace_symbol":"peace","shelled_peanut":"peanuts","lower_left_ballpoint_pen":"pen_ballpoint","lower_left_fountain_pen":"pen_fountain","memo":"pencil","table_tennis":"ping_pong","worship_symbol":"place_of_worship","shit":"poop","hankey":"poop","poo":"poop","expecting_woman":"pregnant_woman","expecting_woman_tone1":"pregnant_woman_tone1","expecting_woman_tone2":"pregnant_woman_tone2","expecting_woman_tone3":"pregnant_woman_tone3","expecting_woman_tone4":"pregnant_woman_tone4","expecting_woman_tone5":"pregnant_woman_tone5","film_projector":"projector","racing_car":"race_car","radioactive_sign":"radioactive","railroad_track":"railway_track","back_of_hand":"raised_back_of_hand","back_of_hand_tone1":"raised_back_of_hand_tone1","back_of_hand_tone2":"raised_back_of_hand_tone2","back_of_hand_tone3":"raised_back_of_hand_tone3","back_of_hand_tone4":"raised_back_of_hand_tone4","back_of_hand_tone5":"raised_back_of_hand_tone5","rhinoceros":"rhino","right_fist":"right_facing_fist","right_fist_tone1":"right_facing_fist_tone1","right_fist_tone2":"right_facing_fist_tone2","right_fist_tone3":"right_facing_fist_tone3","right_fist_tone4":"right_facing_fist_tone4","right_fist_tone5":"right_facing_fist_tone5","robot_face":"robot","rolling_on_the_floor_laughing":"rofl","face_with_rolling_eyes":"rolling_eyes","green_salad":"salad","second_place_medal":"second_place","paella":"shallow_pan_of_food","shopping_trolley":"shopping_cart","skeleton":"skull","skull_and_crossbones":"skull_crossbones","slightly_frowning_face":"slight_frown","slightly_smiling_face":"slight_smile","sneeze":"sneezing_face","speaking_head_in_silhouette":"speaking_head","left_speech_bubble":"speech_left","sleuth_or_spy":"spy","sleuth_or_spy_tone1":"spy_tone1","sleuth_or_spy_tone2":"spy_tone2","sleuth_or_spy_tone3":"spy_tone3","sleuth_or_spy_tone4":"spy_tone4","sleuth_or_spy_tone5":"spy_tone5","stuffed_pita":"stuffed_flatbread","face_with_thermometer":"thermometer_face","thinking_face":"thinking","third_place_medal":"third_place","-1":"thumbsdown","-1_tone1":"thumbsdown_tone1","-1_tone2":"thumbsdown_tone2","-1_tone3":"thumbsdown_tone3","-1_tone4":"thumbsdown_tone4","-1_tone5":"thumbsdown_tone5","+1":"thumbsup","+1_tone1":"thumbsup_tone1","+1_tone2":"thumbsup_tone2","+1_tone3":"thumbsup_tone3","+1_tone4":"thumbsup_tone4","+1_tone5":"thumbsup_tone5","thunder_cloud_and_rain":"thunder_cloud_rain","admission_tickets":"tickets","timer_clock":"timer","hammer_and_wrench":"tools","next_track":"track_next","previous_track":"track_previous","whisky":"tumbler_glass","unicorn_face":"unicorn","upside_down_face":"upside_down","funeral_urn":"urn","raised_hand_with_part_between_middle_and_ring_fingers":"vulcan","raised_hand_with_part_between_middle_and_ring_fingers_tone1":"vulcan_tone1","raised_hand_with_part_between_middle_and_ring_fingers_tone2":"vulcan_tone2","raised_hand_with_part_between_middle_and_ring_fingers_tone3":"vulcan_tone3","raised_hand_with_part_between_middle_and_ring_fingers_tone4":"vulcan_tone4","raised_hand_with_part_between_middle_and_ring_fingers_tone5":"vulcan_tone5","white_sun_behind_cloud":"white_sun_cloud","white_sun_behind_cloud_with_rain":"white_sun_rain_cloud","white_sun_with_small_cloud":"white_sun_small_cloud","wilted_flower":"wilted_rose","wrestling":"wrestlers","wrestling_tone1":"wrestlers_tone1","wrestling_tone2":"wrestlers_tone2","wrestling_tone3":"wrestlers_tone3","wrestling_tone4":"wrestlers_tone4","wrestling_tone5":"wrestlers_tone5","zipper_mouth_face":"zipper_mouth"}

/***/ }),

/***/ "../../../fixtures/emojis/digests.json":
/***/ (function(module, exports) {

module.exports = {"100":{"category":"symbols","moji":"💯","description":"hundred points symbol","unicodeVersion":"6.0","digest":"add3bd7d06b6dd445788b277f8c9e5dcf42a54d3ec8b7fb9e7a39695dd95d094"},"1234":{"category":"symbols","moji":"🔢","description":"input symbol for numbers","unicodeVersion":"6.0","digest":"c5ac5c8147f5bfd644fad6b470432bba86ffc7bcee04a0e0d277cd1ca485207f"},"8ball":{"category":"activity","moji":"🎱","description":"billiards","unicodeVersion":"6.0","digest":"a6e6855775b66c505adee65926a264103ebddf2e2d963db7c009b4fec3a24178"},"a":{"category":"symbols","moji":"🅰","description":"negative squared latin capital letter a","unicodeVersion":"6.0","digest":"bddbb39e8a1d35d42b7c08e7d47f63988cb4d8614b79f74e70b9c67c221896cc"},"ab":{"category":"symbols","moji":"🆎","description":"negative squared ab","unicodeVersion":"6.0","digest":"67430fe5fce981160e2ea9052962e49f264322d3abfc2828fbc311b6cdf67ae8"},"abc":{"category":"symbols","moji":"🔤","description":"input symbol for latin letters","unicodeVersion":"6.0","digest":"282c817ee3414d77a74b815962c33dd9fe71fabaea8c7a9cec466100fbe32187"},"abcd":{"category":"symbols","moji":"🔡","description":"input symbol for latin small letters","unicodeVersion":"6.0","digest":"686728c759f4683c64762ee4eda0a91bf2041f0ae4f358aacf6c09bf51892eff"},"accept":{"category":"symbols","moji":"🉑","description":"circled ideograph accept","unicodeVersion":"6.0","digest":"7208d34c761f10a7fd28f98e25535eba13ff91a64442fc282a98bb77722614f1"},"aerial_tramway":{"category":"travel","moji":"🚡","description":"aerial tramway","unicodeVersion":"6.0","digest":"98df666f34370fc34ce280d84bba5a7e617f733fbbfe66caa424b2afa6ab6777"},"airplane":{"category":"travel","moji":"✈","description":"airplane","unicodeVersion":"1.1","digest":"cc12cf259ef88e57717620cd2bd5aa6a02a8631ee532a3bde24bee78edc5de33"},"airplane_arriving":{"category":"travel","moji":"🛬","description":"airplane arriving","unicodeVersion":"7.0","digest":"80d5b4675f91c4cff06d146d795a065b0ce2a74557df4d9e3314e3d3b5c4ae82"},"airplane_departure":{"category":"travel","moji":"🛫","description":"airplane departure","unicodeVersion":"7.0","digest":"5544eace06b8e1b6ea91940e893e013d33d6b166e14e6d128a87f2cd2de88332"},"airplane_small":{"category":"travel","moji":"🛩","description":"small airplane","unicodeVersion":"7.0","digest":"1a2e07abbbe90d05cee7ff8dd52f443d595ccb38959f3089fe016b77e5d6de7d"},"alarm_clock":{"category":"objects","moji":"⏰","description":"alarm clock","unicodeVersion":"6.0","digest":"fef05a3cd1cddbeca4de8091b94bddb93790b03fa213da86c0eec420f8c49599"},"alembic":{"category":"objects","moji":"⚗","description":"alembic","unicodeVersion":"4.1","digest":"c94b2a4bf24ccf4db27a22c9725cfe900f4a99ec49ef2411d67952bcb2ca1bfb"},"alien":{"category":"people","moji":"👽","description":"extraterrestrial alien","unicodeVersion":"6.0","digest":"856ba98202b244c13a5ee3014a6f7ad592d8c119a30d79e4fc790b74b0e321f7"},"ambulance":{"category":"travel","moji":"🚑","description":"ambulance","unicodeVersion":"6.0","digest":"d9b3c1873de496a4554e715342c72290fb69a9c6766d7885f38bfe9491d052da"},"amphora":{"category":"objects","moji":"🏺","description":"amphora","unicodeVersion":"8.0","digest":"4015f907b649b5e348502cc0e3685ed184e180dca5cc81c43ec516e14df127bf"},"anchor":{"category":"travel","moji":"⚓","description":"anchor","unicodeVersion":"4.1","digest":"2b29b34ef896ebab70016301e3d1880209bbc3c5a5b8d832e43afff9b17ad792"},"angel":{"category":"people","moji":"👼","description":"baby angel","unicodeVersion":"6.0","digest":"db75c2460aaf9cd07cb41fe22c8a6079f3667ffe612a71611358720e2b5512a4"},"angel_tone1":{"category":"people","moji":"👼🏻","description":"baby angel tone 1","unicodeVersion":"8.0","digest":"5871a622469b96296365adaf77d83167759692124c20e5a6e062a525af33472a"},"angel_tone2":{"category":"people","moji":"👼🏼","description":"baby angel tone 2","unicodeVersion":"8.0","digest":"f5993198a5d9daf39e761c783461f07bca237f4e9b739ac300bb8ca001a69a1a"},"angel_tone3":{"category":"people","moji":"👼🏽","description":"baby angel tone 3","unicodeVersion":"8.0","digest":"f0c97a7c4354626267d6ab0f388e4297ad255ab9b061f9c68fbcaa0abfc52783"},"angel_tone4":{"category":"people","moji":"👼🏾","description":"baby angel tone 4","unicodeVersion":"8.0","digest":"6e5dc724c1939d1b0d1a91343662b5bd61ced7709c97802977145ffab6a1f7ac"},"angel_tone5":{"category":"people","moji":"👼🏿","description":"baby angel tone 5","unicodeVersion":"8.0","digest":"52186e1de350c27d25d6010edf44f64a30338b65912ca178429fbcfbd88113c2"},"anger":{"category":"symbols","moji":"💢","description":"anger symbol","unicodeVersion":"6.0","digest":"332493913891aa0eda2743b4bb16c4682400f249998bf34eb292246c9009e17f"},"anger_right":{"category":"symbols","moji":"🗯","description":"right anger bubble","unicodeVersion":"7.0","digest":"8b049511ef3b1b28325841e2f87c60773eaf2f65cabba58d8b0ec3de9b10c0ae"},"angry":{"category":"people","moji":"😠","description":"angry face","unicodeVersion":"6.0","digest":"7e09e7e821f511606341fb5ce4011a8ed9809766ab86b7983ffa6ea352b39ec1"},"ant":{"category":"nature","moji":"🐜","description":"ant","unicodeVersion":"6.0","digest":"929abeaff7ba21ab71cd1ab798af7a6b611e3b3ce1af80cede09a116b223e442"},"apple":{"category":"food","moji":"🍎","description":"red apple","unicodeVersion":"6.0","digest":"2a1b85ce57e3d236ae7777dcf332ec37d03bfd7b19806521a353bc532083224d"},"aquarius":{"category":"symbols","moji":"♒","description":"aquarius","unicodeVersion":"1.1","digest":"fdc42cd41b0dace5eae6baba3143f1e40295d48a29e7103a5bba1d84a056c39d"},"aries":{"category":"symbols","moji":"♈","description":"aries","unicodeVersion":"1.1","digest":"deb135debcde0a98f40361a84ab64d57c18b5b445cd2f4199e8936f052899737"},"arrow_backward":{"category":"symbols","moji":"◀","description":"black left-pointing triangle","unicodeVersion":"1.1","digest":"e162ac82e90d1e925d479fa5c45b9340e0a53287be04e43cbbb2a89c7e7e45e4"},"arrow_double_down":{"category":"symbols","moji":"⏬","description":"black down-pointing double triangle","unicodeVersion":"6.0","digest":"03ca890b05338d40972c7a056d672df620a203c6ca52ff3ff530f1a710905507"},"arrow_double_up":{"category":"symbols","moji":"⏫","description":"black up-pointing double triangle","unicodeVersion":"6.0","digest":"e753f05bce993d62d5dc79e33c441ced059381b6ce21fa3ea4200f1b3236e59d"},"arrow_down":{"category":"symbols","moji":"⬇","description":"downwards black arrow","unicodeVersion":"4.0","digest":"9bf1bd2ea652ca9321087de58c7a112ea04c35676a6ee0766154183f8b95af6c"},"arrow_down_small":{"category":"symbols","moji":"🔽","description":"down-pointing small red triangle","unicodeVersion":"6.0","digest":"7766198bc60cf59d6cdaeeaa700c2282bfff2f0fdeb22cf4581ca284b87a3bb7"},"arrow_forward":{"category":"symbols","moji":"▶","description":"black right-pointing triangle","unicodeVersion":"1.1","digest":"db77d9accd1e02224f5d612f79cd691e6befdf22063475204836be6572510fb7"},"arrow_heading_down":{"category":"symbols","moji":"⤵","description":"arrow pointing rightwards then curving downwards","unicodeVersion":"3.2","digest":"f5396069c8f63c13e6c3e0ecd34267c932451309ade9c1171d410563153bf909"},"arrow_heading_up":{"category":"symbols","moji":"⤴","description":"arrow pointing rightwards then curving upwards","unicodeVersion":"3.2","digest":"1cad71923fa3df24cf543cae4ce775b0f74936f2edd685fd86a7525c41a14568"},"arrow_left":{"category":"symbols","moji":"⬅","description":"leftwards black arrow","unicodeVersion":"4.0","digest":"b629bb3dbe161ef89cfcfced0c7968a68e44a019ad509132987e4973bdc874e7"},"arrow_lower_left":{"category":"symbols","moji":"↙","description":"south west arrow","unicodeVersion":"1.1","digest":"879136ba0e24e6bf3be70118abcb716d71bd74f7b62347bc052b6533c0ea534d"},"arrow_lower_right":{"category":"symbols","moji":"↘","description":"south east arrow","unicodeVersion":"1.1","digest":"86d52ac9b961991e3aaa6a9f9b5ace4db6ffd1b5c171c09c23b516473b55066d"},"arrow_right":{"category":"symbols","moji":"➡","description":"black rightwards arrow","unicodeVersion":"1.1","digest":"45f26a1cbb0f00ed3609b39da52e9d9e896a77e361c4c8036b1bf8038171bd49"},"arrow_right_hook":{"category":"symbols","moji":"↪","description":"rightwards arrow with hook","unicodeVersion":"1.1","digest":"4f452679c71bcea4fc4a701c55156fef3ddc1ebbc70570bedfc9d3a029637ab1"},"arrow_up":{"category":"symbols","moji":"⬆","description":"upwards black arrow","unicodeVersion":"4.0","digest":"982b988ef6651d8a71867ba7c87f640f62dd0eeb0b7c358f5a5c37e8fe507b8b"},"arrow_up_down":{"category":"symbols","moji":"↕","description":"up down arrow","unicodeVersion":"1.1","digest":"645ed8fb6646f49bfd95af1752336deacdadbe5cba13904023a704288f3b0e2c"},"arrow_up_small":{"category":"symbols","moji":"🔼","description":"up-pointing small red triangle","unicodeVersion":"6.0","digest":"4a8c5789c13a852517e639e7a62c2d331464e6fb0358985aa97c1515e97b5e8b"},"arrow_upper_left":{"category":"symbols","moji":"↖","description":"north west arrow","unicodeVersion":"1.1","digest":"79026f828d6ceb7c55a9542770962ba6dcd08203995f6ceeb70333a12307d376"},"arrow_upper_right":{"category":"symbols","moji":"↗","description":"north east arrow","unicodeVersion":"1.1","digest":"7e0f33dfbe65628991c170130d366a3e2cedaf8862ddfcaf3960f395d3da1926"},"arrows_clockwise":{"category":"symbols","moji":"🔃","description":"clockwise downwards and upwards open circle arrows","unicodeVersion":"6.0","digest":"88669679977f7157f0acaa9d6a1b77ccf84d25eb78c5bc8afcde38d3635e7144"},"arrows_counterclockwise":{"category":"symbols","moji":"🔄","description":"anticlockwise downwards and upwards open circle ar","unicodeVersion":"6.0","digest":"a2c6a6d3643c128aee3304cd03bb3d7cfe4d35d3ba825bc9c1142d7832b4426e"},"art":{"category":"activity","moji":"🎨","description":"artist palette","unicodeVersion":"6.0","digest":"b6bc6c4bfb594aadcbb641d006031867678504764bbe0ab84e7b08567a9498da"},"articulated_lorry":{"category":"travel","moji":"🚛","description":"articulated lorry","unicodeVersion":"6.0","digest":"c115e6613ebd718268aa31d265e017138b9fb58bbb8201eb3f40de2380e460aa"},"asterisk":{"category":"symbols","moji":"*⃣","description":"keycap asterisk","unicodeVersion":"3.0","digest":"33d92093f2914448d5a939cf62e8ee3e32931923abdef5f0210e8a8150fa312d"},"astonished":{"category":"people","moji":"😲","description":"astonished face","unicodeVersion":"6.0","digest":"f8531bdda5070d10492709085f4ff652b8be9be6458758940358b9fc594a1f14"},"athletic_shoe":{"category":"people","moji":"👟","description":"athletic shoe","unicodeVersion":"6.0","digest":"1f90dc390e0dea679085465b7f9e786dfd7dd56a3b219987144ed37ab1e9bf95"},"atm":{"category":"symbols","moji":"🏧","description":"automated teller machine","unicodeVersion":"6.0","digest":"7d3ce6a6afb4951546883404b8e36904179f88f1aa533706cf7bf0bbe0d6fd3c"},"atom":{"category":"symbols","moji":"⚛","description":"atom symbol","unicodeVersion":"4.1","digest":"6b6bb83b00707a314e46ff8eefbda40978a291ec7881caba1b1ee273f49c1368"},"avocado":{"category":"food","moji":"🥑","description":"avocado","unicodeVersion":"9.0","digest":"bc1fb203d63b18985598400925de24050bb192afda1cbf0813f85cb139869eff"},"b":{"category":"symbols","moji":"🅱","description":"negative squared latin capital letter b","unicodeVersion":"6.0","digest":"722f9db9442e7c0fc0d0ac0f5291fbf47c6a0ac4d8abd42e97957da705fb82bf"},"baby":{"category":"people","moji":"👶","description":"baby","unicodeVersion":"6.0","digest":"219ae5a571aaf90c060956cd1c56dcc27708c827cecdca3ba1122058a3c4847b"},"baby_bottle":{"category":"food","moji":"🍼","description":"baby bottle","unicodeVersion":"6.0","digest":"4fb71689e9d634e8d1699cf454a71e43f2b5b1a5dbab0bf186626934fdf5b782"},"baby_chick":{"category":"nature","moji":"🐤","description":"baby chick","unicodeVersion":"6.0","digest":"14119874e9b5548028dfb9cc593a541efc1d075ac839a565b92e0c3253cffe7e"},"baby_symbol":{"category":"symbols","moji":"🚼","description":"baby symbol","unicodeVersion":"6.0","digest":"fb4db66868cda45ea3879ffc2ff4f763c56d2d889ae0ab17fe171129ede02f98"},"baby_tone1":{"category":"people","moji":"👶🏻","description":"baby tone 1","unicodeVersion":"8.0","digest":"cd3faf223a298c34e05d469d9d0db08438d97df7fd82c0973f8a9e07d553f5b1"},"baby_tone2":{"category":"people","moji":"👶🏼","description":"baby tone 2","unicodeVersion":"8.0","digest":"5b4539e22e0dd726c27eb8af2357f9240a52aed3f710f3234571cff029cc6198"},"baby_tone3":{"category":"people","moji":"👶🏽","description":"baby tone 3","unicodeVersion":"8.0","digest":"720e740e1ac63c6372269132b1fb6e07a6b91f5c808cc3adef59f0b4500e5e72"},"baby_tone4":{"category":"people","moji":"👶🏾","description":"baby tone 4","unicodeVersion":"8.0","digest":"5e43b69c509bd526ad6f081764578c30b6f3285fb7442222e05ccf62e53bfb64"},"baby_tone5":{"category":"people","moji":"👶🏿","description":"baby tone 5","unicodeVersion":"8.0","digest":"85bba6e0940ccfb99999fe124e815f9dd340d00a5568e13967b02245a62dbf54"},"back":{"category":"symbols","moji":"🔙","description":"back with leftwards arrow above","unicodeVersion":"6.0","digest":"083e4e48b51092c28efb4532e840e1091b5d4b685c6e0f221aa0228f061cd91e"},"bacon":{"category":"food","moji":"🥓","description":"bacon","unicodeVersion":"9.0","digest":"18ad3817f1f88a69706db5727a58e763dde6c21a2d4f184c3d728c32dc5fa05a"},"badminton":{"category":"activity","moji":"🏸","description":"badminton racquet","unicodeVersion":"8.0","digest":"353eb7ee93decd9fe0072e4d78a5618d5e2d9e77a6e4de9fe171870d75e02a66"},"baggage_claim":{"category":"symbols","moji":"🛄","description":"baggage claim","unicodeVersion":"6.0","digest":"7d6bceca92c266da6d2b91dfcf244546fc11022e039e7da8e6888c1696bb2186"},"balloon":{"category":"objects","moji":"🎈","description":"balloon","unicodeVersion":"6.0","digest":"65760aedc1503b426927cff78c24449d563843a274961d962718fa9638375d54"},"ballot_box":{"category":"objects","moji":"🗳","description":"ballot box with ballot","unicodeVersion":"7.0","digest":"4175a56eca5c6458574a681e109b1403fbb143cf27f69ae6c1917650f3e08892"},"ballot_box_with_check":{"category":"symbols","moji":"☑","description":"ballot box with check","unicodeVersion":"1.1","digest":"c98d6f3588dd87e2f318bbfe6c646399a905450edfd814edae4e5b1bddef2134"},"bamboo":{"category":"nature","moji":"🎍","description":"pine decoration","unicodeVersion":"6.0","digest":"e4ee65088df43d7081b1ce6fd996f66f3e0accd88840855c47a98a22997823dd"},"banana":{"category":"food","moji":"🍌","description":"banana","unicodeVersion":"6.0","digest":"f9e8ff910c282c20a8907ff64926b5de4ee250529a1ed718fb33302e6fff8dd9"},"bangbang":{"category":"symbols","moji":"‼","description":"double exclamation mark","unicodeVersion":"1.1","digest":"76536fee63fe964a3f3839d309b1f45028fb0c43f4d1eeee495f17e1532b4def"},"bank":{"category":"travel","moji":"🏦","description":"bank","unicodeVersion":"6.0","digest":"f5d2976bf6d521638ccacc74be06bd4abfeab06c5d898a9d245edad45a5b6306"},"bar_chart":{"category":"objects","moji":"📊","description":"bar chart","unicodeVersion":"6.0","digest":"65a328a1b2d7a5332dd4d93f4dbca13d976f0a505b00835c3fc458e394804240"},"barber":{"category":"objects","moji":"💈","description":"barber pole","unicodeVersion":"6.0","digest":"5e8053d3bb3765a8632fd1cbfe21163f74ed79f6be377eb9603eaaf883d8dc46"},"baseball":{"category":"activity","moji":"⚾","description":"baseball","unicodeVersion":"5.2","digest":"46ac16f8b5455b942f6dbff9483a6fd277721e6719d2731573baabd21c44b34f"},"basketball":{"category":"activity","moji":"🏀","description":"basketball and hoop","unicodeVersion":"6.0","digest":"cc83e2aea8fcd2e9a5789e1932ee3766c40843c142fd3565c4e77dafb21ec7d7"},"basketball_player":{"category":"activity","moji":"⛹","description":"person with ball","unicodeVersion":"5.2","digest":"793ba53c95e8def769383b612037bc9b9bceecaf1e0430c50a4cc128ad18d9b9"},"basketball_player_tone1":{"category":"activity","moji":"⛹🏻","description":"person with ball tone 1","unicodeVersion":"8.0","digest":"2a06522b971e68ee5b8777a58253009b548f4da2fb723c638acb3d7b04edba8f"},"basketball_player_tone2":{"category":"activity","moji":"⛹🏼","description":"person with ball tone 2","unicodeVersion":"8.0","digest":"ecc0e44ab9bc478ba45a055fd69a3a38377b917aac5047963fe80ff8ae5fd8e3"},"basketball_player_tone3":{"category":"activity","moji":"⛹🏽","description":"person with ball tone 3","unicodeVersion":"8.0","digest":"2d38f1851c685d29532c042461d7b5b996e5f04f0ed54857c66073c62a99ceac"},"basketball_player_tone4":{"category":"activity","moji":"⛹🏾","description":"person with ball tone 4","unicodeVersion":"8.0","digest":"09e957c6e9ffc196415f28073aa261feba8efba0bdc694dc08f8f7cd1f88f720"},"basketball_player_tone5":{"category":"activity","moji":"⛹🏿","description":"person with ball tone 5","unicodeVersion":"8.0","digest":"c631cefc5d2a0a31bdb9f0a0d97ea68b1c6928e565468998403034644572a0b0"},"bat":{"category":"nature","moji":"🦇","description":"bat","unicodeVersion":"9.0","digest":"8fc19e0d7d6f80906bdbc06d616a810de66180d96cf28070a53fa61b88904535"},"bath":{"category":"activity","moji":"🛀","description":"bath","unicodeVersion":"6.0","digest":"33b371832f90aad50baf5296f3ad4cc081c319b279f989c74409903d8568e917"},"bath_tone1":{"category":"activity","moji":"🛀🏻","description":"bath tone 1","unicodeVersion":"8.0","digest":"7ae2989e47788ba71359d52da68feec95aaff68a77d5a6556957df1617af8536"},"bath_tone2":{"category":"activity","moji":"🛀🏼","description":"bath tone 2","unicodeVersion":"8.0","digest":"2e86f8edad54d15a7094cd52160cbe51d10aa1750cfb0b3b58e93533f070e327"},"bath_tone3":{"category":"activity","moji":"🛀🏽","description":"bath tone 3","unicodeVersion":"8.0","digest":"654c0cd083a67ff330a38d07352876d265390e5399e5352598d64a6c7e5eeba7"},"bath_tone4":{"category":"activity","moji":"🛀🏾","description":"bath tone 4","unicodeVersion":"8.0","digest":"adad88c6830f31c4b5be194d1987d6aadf4adf45e4cb7f2e4657f0d20c0d663a"},"bath_tone5":{"category":"activity","moji":"🛀🏿","description":"bath tone 5","unicodeVersion":"8.0","digest":"952c4c9bf24e001e23a33ebf97bd92969cd9143e28ce93f9aafc708a8f966903"},"bathtub":{"category":"objects","moji":"🛁","description":"bathtub","unicodeVersion":"6.0","digest":"844dffb87ef872594195069b0d0df27c3fe51f3967ccbc8b2df811a086dd483a"},"battery":{"category":"objects","moji":"🔋","description":"battery","unicodeVersion":"6.0","digest":"949ae06648667fb13d9121a6dfdd03bf8692794b28c36e9a8e8ac4515664449a"},"beach":{"category":"travel","moji":"🏖","description":"beach with umbrella","unicodeVersion":"7.0","digest":"37fa2158977d470186caaa1aa06669b6dc5026ba49a0c44c5255541f8e974e26"},"beach_umbrella":{"category":"objects","moji":"⛱","description":"umbrella on ground","unicodeVersion":"5.2","digest":"d045f1de10038b9fb1eaa2529b2f80b7e3be1cff503efcc2d680663d1fbbc18f"},"bear":{"category":"nature","moji":"🐻","description":"bear face","unicodeVersion":"6.0","digest":"a4b9066eaa5681e6af06e596a96a5217037460ffc3b013e8db4d34d762413246"},"bed":{"category":"objects","moji":"🛏","description":"bed","unicodeVersion":"7.0","digest":"08f6e20db51b1fb650b390a0a3074938646772f3fcee8c295d47742e44fe1e30"},"bee":{"category":"nature","moji":"🐝","description":"honeybee","unicodeVersion":"6.0","digest":"5beb9a1650681b4adf69999d4808231c38f41a3ec693480b807cda86f964c570"},"beer":{"category":"food","moji":"🍺","description":"beer mug","unicodeVersion":"6.0","digest":"69e227104976548ee0f37375fe1526fd65ef0a328d2d92db2feb1edfd7032bd4"},"beers":{"category":"food","moji":"🍻","description":"clinking beer mugs","unicodeVersion":"6.0","digest":"db8b32d93bf6d161a3b027e55651d8f51231b13928b3610987ef62bb634d7501"},"beetle":{"category":"nature","moji":"🐞","description":"lady beetle","unicodeVersion":"6.0","digest":"5aaa428e3f63f7cd1696839ab05be03fa0cd0cbed30a05c36cb270da330c3849"},"beginner":{"category":"symbols","moji":"🔰","description":"japanese symbol for beginner","unicodeVersion":"6.0","digest":"2de4fdf92f182c42b12b7527034eaf767d996848b61f31ee69167728411ca0b1"},"bell":{"category":"symbols","moji":"🔔","description":"bell","unicodeVersion":"6.0","digest":"18d419417746ead408072b78fe2edb6314cdb49492873966fa9f9f06be09899b"},"bellhop":{"category":"objects","moji":"🛎","description":"bellhop bell","unicodeVersion":"7.0","digest":"b8187bc4059f6a0924a47fe3f6c07f656bed0334bbcbfa1e89f800fe6594ff08"},"bento":{"category":"food","moji":"🍱","description":"bento box","unicodeVersion":"6.0","digest":"d46d4f681c5da7f7678b51be3445454a8ed18d917e132ae79077f05310e485f1"},"bicyclist":{"category":"activity","moji":"🚴","description":"bicyclist","unicodeVersion":"6.0","digest":"3302147b6b47c16adb97d78b7b761a1ca80e6d0b41d0b60f4da338d2f55f968b"},"bicyclist_tone1":{"category":"activity","moji":"🚴🏻","description":"bicyclist tone 1","unicodeVersion":"8.0","digest":"27eaae0eb61f5e7b3cd9faf02c042d6643a368051a7c9d7da4e0fb9802d39242"},"bicyclist_tone2":{"category":"activity","moji":"🚴🏼","description":"bicyclist tone 2","unicodeVersion":"8.0","digest":"39ee9e1071700da7079ad0146bf5711c3a222991eeca8b29b72a65677604444d"},"bicyclist_tone3":{"category":"activity","moji":"🚴🏽","description":"bicyclist tone 3","unicodeVersion":"8.0","digest":"03e1d2c4232c896147a9d4bf43becd61edbb5c84fc7193ecea474c0f9fb36817"},"bicyclist_tone4":{"category":"activity","moji":"🚴🏾","description":"bicyclist tone 4","unicodeVersion":"8.0","digest":"61393d9c4805be0379d86dd5bec9a1b02314433ab36cfd85bb48dfd073746617"},"bicyclist_tone5":{"category":"activity","moji":"🚴🏿","description":"bicyclist tone 5","unicodeVersion":"8.0","digest":"2b46d5f8303e5710dbf5db3a4edc9d88a032fe123fe79158024c9f51df5458c6"},"bike":{"category":"travel","moji":"🚲","description":"bicycle","unicodeVersion":"6.0","digest":"b41daa7c549d483e2336186a28baaa8ecb11986f490c0c54c793c44900c8f652"},"bikini":{"category":"people","moji":"👙","description":"bikini","unicodeVersion":"6.0","digest":"07fe156f64673818d69ce3bf03950ca59e3b5d346e45ca541da4078ab791f5ae"},"biohazard":{"category":"symbols","moji":"☣","description":"biohazard sign","unicodeVersion":"1.1","digest":"96163e31f0b8dc5a59772133ede9cc2f40f94330d0b15e3d044b28747e2be788"},"bird":{"category":"nature","moji":"🐦","description":"bird","unicodeVersion":"6.0","digest":"f916eaf8f271b3767ade9eabb69594c0479f45472d471cabaf59f6e965c161e0"},"birthday":{"category":"food","moji":"🎂","description":"birthday cake","unicodeVersion":"6.0","digest":"89e7c4c598ebee8ec8ab11ebe4ccc6defb7c4d2987ee2379a19b3b59827dd98a"},"black_circle":{"category":"symbols","moji":"⚫","description":"medium black circle","unicodeVersion":"4.1","digest":"c2ba672994ad0f99d7fdc449f3fee45a2dca68a58f9fe95825b38465a30ef44e"},"black_heart":{"category":"symbols","moji":"🖤","description":"black heart","unicodeVersion":"9.0","digest":"f334679168d6dd7328c28e9ae3cb2b1fca0e9c2777938d586bfe623db2a688b9"},"black_joker":{"category":"symbols","moji":"🃏","description":"playing card black joker","unicodeVersion":"6.0","digest":"d004b25f186494d5b2c65204caa9daecd749c840a0bea5718735e18109e5394d"},"black_large_square":{"category":"symbols","moji":"⬛","description":"black large square","unicodeVersion":"5.1","digest":"cbd90dcbc2f674eafa53820548b5263c18c9845ab39937f085e85aca0aebb479"},"black_medium_small_square":{"category":"symbols","moji":"◾","description":"black medium small square","unicodeVersion":"3.2","digest":"ab38363c2e862b8f67c719397a09a18e1ef996eec190691fdf769f5cfb209660"},"black_medium_square":{"category":"symbols","moji":"◼","description":"black medium square","unicodeVersion":"3.2","digest":"c9ffa87c37e8ee65fadcf755176949901aec7367e02abb85e63cad60cd922116"},"black_nib":{"category":"objects","moji":"✒","description":"black nib","unicodeVersion":"1.1","digest":"58fb23b1155102970eaa23765e7d529a21e8e545e076ec1158bf11b4de5f51a8"},"black_small_square":{"category":"symbols","moji":"▪","description":"black small square","unicodeVersion":"1.1","digest":"f69be6de578fffce5a3e60eda690104b2ef6a855c630040104fb760a02ff1aef"},"black_square_button":{"category":"symbols","moji":"🔲","description":"black square button","unicodeVersion":"6.0","digest":"9d818fcd08ed38cd0bbbcfd83e665aa29b3761c0d8b9806d8954d36785e267a8"},"blossom":{"category":"nature","moji":"🌼","description":"blossom","unicodeVersion":"6.0","digest":"e8cf369d4e4cdb4eccc2ebcbb35439b0344221115701daae642e58dff8544922"},"blowfish":{"category":"nature","moji":"🐡","description":"blowfish","unicodeVersion":"6.0","digest":"e706849ed00f08a82312381c76f6f9ba6cc261fbf87a839c85e7dd54138f9dc3"},"blue_book":{"category":"objects","moji":"📘","description":"blue book","unicodeVersion":"6.0","digest":"4c845748fe890516b32981b0b62bf3e8e9d906840c2060179f4f844100780615"},"blue_car":{"category":"travel","moji":"🚙","description":"recreational vehicle","unicodeVersion":"6.0","digest":"eca91934eb5481726cfd897b1ed5eac306e14d02499fbe49316aaec6c72b6707"},"blue_heart":{"category":"symbols","moji":"💙","description":"blue heart","unicodeVersion":"6.0","digest":"2caa0c8d18538cc871c6fe328a52f71e1df8aabf4d1cc2f5324b261d1b8cb99a"},"blush":{"category":"people","moji":"😊","description":"smiling face with smiling eyes","unicodeVersion":"6.0","digest":"3bfe8d603cfa39999c164779f666d39bbc507f124ba80233ee72da7b3b0c0457"},"boar":{"category":"nature","moji":"🐗","description":"boar","unicodeVersion":"6.0","digest":"c9d67479cace427ac3c30460fcffa1bf9a8e5262c0390962405dbbe6bf830fa6"},"bomb":{"category":"objects","moji":"💣","description":"bomb","unicodeVersion":"6.0","digest":"0155559abc4084f80e9b0b2a2091b8710ddd6369993b7fdd0685f4f8c2fd7e6c"},"book":{"category":"objects","moji":"📖","description":"open book","unicodeVersion":"6.0","digest":"9d912a9d1bb10dc7f2645b345ed09e90461e83df0de275acb806f1f75cef1fcf"},"bookmark":{"category":"objects","moji":"🔖","description":"bookmark","unicodeVersion":"6.0","digest":"5705e3108259d6900649157843c50e22d0086c3630b291d3f942da1a736e3e3d"},"bookmark_tabs":{"category":"objects","moji":"📑","description":"bookmark tabs","unicodeVersion":"6.0","digest":"c8fc7c9f3f82e1ccc97fc591345fdd88b09eec0fca428d8d4632a121cf1bc39a"},"books":{"category":"objects","moji":"📚","description":"books","unicodeVersion":"6.0","digest":"cbcf55d39dd05d26ef7350bc51e0e2f064f78bb8f59d407b516d63f68558f8e4"},"boom":{"category":"nature","moji":"💥","description":"collision symbol","unicodeVersion":"6.0","digest":"f5400e9583f7f997cd2385f21379f6229424a9b221445bc8f36c0bb64bdb3168"},"boot":{"category":"people","moji":"👢","description":"womans boots","unicodeVersion":"6.0","digest":"b4706ff35909a6fb759a3b8a797e90cb67ffc60e4853386a7d89ace9693a9364"},"bouquet":{"category":"nature","moji":"💐","description":"bouquet","unicodeVersion":"6.0","digest":"b93751a27b40f6185a22b3e8b413f0fe09b6010d1057c672e1a23088e0b8286f"},"bow":{"category":"people","moji":"🙇","description":"person bowing deeply","unicodeVersion":"6.0","digest":"33cd6da4d408f18d98bebc6a277dea8b914150e32ee472586ce3f1eb814462bd"},"bow_and_arrow":{"category":"activity","moji":"🏹","description":"bow and arrow","unicodeVersion":"8.0","digest":"051b4d50ab21a68b8583a6313ec183e3e1e96f493b0f4541fbb888f0b95fdd4d"},"bow_tone1":{"category":"people","moji":"🙇🏻","description":"person bowing deeply tone 1","unicodeVersion":"8.0","digest":"995c8400ad60d5adc66c9ae5e3c0ecf56c48b478ad79418d45b6289933d25bdd"},"bow_tone2":{"category":"people","moji":"🙇🏼","description":"person bowing deeply tone 2","unicodeVersion":"8.0","digest":"af89eec2fccda99d9bdd373b2345595882fee1c0a15d29af9028089e20255325"},"bow_tone3":{"category":"people","moji":"🙇🏽","description":"person bowing deeply tone 3","unicodeVersion":"8.0","digest":"015d8122abdf2d0caa03815545f50fb7a71e05dacd46aaa133cc9ace5192f266"},"bow_tone4":{"category":"people","moji":"🙇🏾","description":"person bowing deeply tone 4","unicodeVersion":"8.0","digest":"e8409096a795b775def654d36aeccb8eb91e83d7d1b32145cd73fd0b7b9e885c"},"bow_tone5":{"category":"people","moji":"🙇🏿","description":"person bowing deeply tone 5","unicodeVersion":"8.0","digest":"d87042cde8dbad9fb1a91a2ec60116e27b4a76388b5779d771a0bbae12a2814d"},"bowling":{"category":"activity","moji":"🎳","description":"bowling","unicodeVersion":"6.0","digest":"737f2cdfa4ac964baade585a39771b18080bd5e9b55c8661d3518f468f344662"},"boxing_glove":{"category":"activity","moji":"🥊","description":"boxing glove","unicodeVersion":"9.0","digest":"c914b2ce45f20afad66ad6f0d1b0750c4469e4f48b686dfc4aad1ec8d289c563"},"boy":{"category":"people","moji":"👦","description":"boy","unicodeVersion":"6.0","digest":"7bc0173d8c88f3f12d41f213f7a3a9f5ebf65efad610fd5a2a31935128a6a6c1"},"boy_tone1":{"category":"people","moji":"👦🏻","description":"boy tone 1","unicodeVersion":"8.0","digest":"c0e2f0483715b239fe145b0056566f7a3a722319d9a87c1e66733dff1916a19f"},"boy_tone2":{"category":"people","moji":"👦🏼","description":"boy tone 2","unicodeVersion":"8.0","digest":"0001d0bd1ff4dbd898604ba965b4039d09667d955bc0349301b992f9ab6dd7fd"},"boy_tone3":{"category":"people","moji":"👦🏽","description":"boy tone 3","unicodeVersion":"8.0","digest":"e0f08755955fd2e0bd1c5d5e84429b2a234b24a744bb50bb9f1148495b2b29f9"},"boy_tone4":{"category":"people","moji":"👦🏾","description":"boy tone 4","unicodeVersion":"8.0","digest":"04b6bfee58a26b1ce2e5b403504a7033aaf395f03f5cd23e824f32c90c395fe6"},"boy_tone5":{"category":"people","moji":"👦🏿","description":"boy tone 5","unicodeVersion":"8.0","digest":"0f76e97237203950da36c737dcc6f56dcd6c123401a8c817a0636376c7f38ef5"},"bread":{"category":"food","moji":"🍞","description":"bread","unicodeVersion":"6.0","digest":"81739830f16f33e6a1dd7cc17c25df207846062bb5167bb8abed7fdd49268b86"},"bride_with_veil":{"category":"people","moji":"👰","description":"bride with veil","unicodeVersion":"6.0","digest":"8e24bd91c3f564cf6148f2b3b4a7d692c11dd059e76a13331fdfb04ae060ea70"},"bride_with_veil_tone1":{"category":"people","moji":"👰🏻","description":"bride with veil tone 1","unicodeVersion":"8.0","digest":"0bd2f16f72586f50e768b14b9b353f2e98ccbb2581a568c33b06be56e70ca063"},"bride_with_veil_tone2":{"category":"people","moji":"👰🏼","description":"bride with veil tone 2","unicodeVersion":"8.0","digest":"e5463f811b2075754f0718b891757cd2e81071edf7af2215581227e1aad1d068"},"bride_with_veil_tone3":{"category":"people","moji":"👰🏽","description":"bride with veil tone 3","unicodeVersion":"8.0","digest":"e5a053a26f7ccebae7eb12f638be5ed80f77b744708d783eab2eb8aa091cf516"},"bride_with_veil_tone4":{"category":"people","moji":"👰🏾","description":"bride with veil tone 4","unicodeVersion":"8.0","digest":"410e23825e4401460946dc67a618bd3ace6e1a7c07dd88580a2349423685261f"},"bride_with_veil_tone5":{"category":"people","moji":"👰🏿","description":"bride with veil tone 5","unicodeVersion":"8.0","digest":"454e87e5a74e13e5b4993541231516fbbe6dbe9f990e1a6f3f4a744d7d4c1615"},"bridge_at_night":{"category":"travel","moji":"🌉","description":"bridge at night","unicodeVersion":"6.0","digest":"9d3cda5a59e27e3c90939f1ddbe7e998b3ea4fcacfa1467dea0edf39613c2d7f"},"briefcase":{"category":"people","moji":"💼","description":"briefcase","unicodeVersion":"6.0","digest":"9d00d6a92632aaadc71b017f448c883b27eb31a7554ebb51f7e3a9841f0f7f2b"},"broken_heart":{"category":"symbols","moji":"💔","description":"broken heart","unicodeVersion":"6.0","digest":"c7ca53f444d72e596af46b61ffbc9e7c18a645020c22691e44f967db98dbf853"},"bug":{"category":"nature","moji":"🐛","description":"bug","unicodeVersion":"6.0","digest":"0dccb1d5eb91769377b4c5b310f007b60f54a5c48ba9e467b3a06898a4831b90"},"bulb":{"category":"objects","moji":"💡","description":"electric light bulb","unicodeVersion":"6.0","digest":"ccdaa2dfde5a88a347035a94b9d4d86cfc335ce0a73292423f5788a4bd21a5a8"},"bullettrain_front":{"category":"travel","moji":"🚅","description":"high-speed train with bullet nose","unicodeVersion":"6.0","digest":"5195a6a6d23f28e1aa5ebac6ede0f6c6a8b7ff33a9edf034814f227fe976177a"},"bullettrain_side":{"category":"travel","moji":"🚄","description":"high-speed train","unicodeVersion":"6.0","digest":"96e74842e919716b7bbbab57339bfd70f099a9bcb4710dffd7c80cf38a7bbff7"},"burrito":{"category":"food","moji":"🌯","description":"burrito","unicodeVersion":"8.0","digest":"b2cf81f1efdf87e674461f73f67cd4b58a5f695e65598d0dd3899f2597da43cf"},"bus":{"category":"travel","moji":"🚌","description":"bus","unicodeVersion":"6.0","digest":"192850b762edad21ac8770df38b9cae6d2bc1697a838462f3e36066bfb4eee50"},"busstop":{"category":"travel","moji":"🚏","description":"bus stop","unicodeVersion":"6.0","digest":"adabb1ec36402b33feb636eae3656e5a8b51ff1071bcb14125d8ab80d6d12d2a"},"bust_in_silhouette":{"category":"people","moji":"👤","description":"bust in silhouette","unicodeVersion":"6.0","digest":"277ae43301f1e49e0be03c8e52f0dc7b70c67f9d146bca0a14172e0098f115e6"},"busts_in_silhouette":{"category":"people","moji":"👥","description":"busts in silhouette","unicodeVersion":"6.0","digest":"7fee96f1b68bb2c6002e47f2ed13c06baa6a3168441b9aca572db7ec45612f7b"},"butterfly":{"category":"nature","moji":"🦋","description":"butterfly","unicodeVersion":"9.0","digest":"a91b6598c17b44a8dc8935a1d99e25f4483ea41470cdd2da343039a9eec29ef1"},"cactus":{"category":"nature","moji":"🌵","description":"cactus","unicodeVersion":"6.0","digest":"2c5c4c35f26c7046fdc002b337e0d939729b33a26980e675950f9934c91e40fd"},"cake":{"category":"food","moji":"🍰","description":"shortcake","unicodeVersion":"6.0","digest":"b928902df8084210d51c1da36f9119164a325393c391b28cd8ea914e0b95c17b"},"calendar":{"category":"objects","moji":"📆","description":"tear-off calendar","unicodeVersion":"6.0","digest":"9d990be27778daab041a3583edbd8f83fc8957e42a3aec729c0e2e224a8d05e3"},"calendar_spiral":{"category":"objects","moji":"🗓","description":"spiral calendar pad","unicodeVersion":"7.0","digest":"441a0750eade7ce33e28e58bec76958990c412b68409fcdde59ebad1f25361bb"},"call_me":{"category":"people","moji":"🤙","description":"call me hand","unicodeVersion":"9.0","digest":"83d2ed96dcb8b4adf4f4d030ffd07e25ca16351e1a4fbefdf9f46f5ca496a55f"},"call_me_tone1":{"category":"people","moji":"🤙🏻","description":"call me hand tone 1","unicodeVersion":"9.0","digest":"4a5748efa83e7294e8338b8795d4d315ff1cd31ead6759004d0eb330e50de8cd"},"call_me_tone2":{"category":"people","moji":"🤙🏼","description":"call me hand tone 2","unicodeVersion":"9.0","digest":"54feaa6e3c5789ae6e15622127f0e0213234b4b886e1588ce95814348b1f1519"},"call_me_tone3":{"category":"people","moji":"🤙🏽","description":"call me hand tone 3","unicodeVersion":"9.0","digest":"57e949b951e14843b712dab5a828f915ee255f5bb973db33946aab4057427419"},"call_me_tone4":{"category":"people","moji":"🤙🏾","description":"call me hand tone 4","unicodeVersion":"9.0","digest":"f7787e933978a09c7b8ab8d3b1e1ab395aaae998c455e93bb3db24a4c8a60fe0"},"call_me_tone5":{"category":"people","moji":"🤙🏿","description":"call me hand tone 5","unicodeVersion":"9.0","digest":"1fdb7d833d000b117d20d48142d3026a61cc9c8b712ebb498fa66bf75c74d7a5"},"calling":{"category":"objects","moji":"📲","description":"mobile phone with rightwards arrow at left","unicodeVersion":"6.0","digest":"acf668c75c11c36686005788266524a972fa1c5bcf666ff3403d909edc5cee91"},"camel":{"category":"nature","moji":"🐫","description":"bactrian camel","unicodeVersion":"6.0","digest":"5f927927a7ab1277d0dc8b8211436957968b1e11365a8bf535e9bb94f92c5631"},"camera":{"category":"objects","moji":"📷","description":"camera","unicodeVersion":"6.0","digest":"fde03e396822a36cd6ae756ede885b945a074395264162731ca5db47a3b39d80"},"camera_with_flash":{"category":"objects","moji":"📸","description":"camera with flash","unicodeVersion":"7.0","digest":"9afd380208187780f00244c45d4db6c5ea1ea088d4a1bd8fc92a8f3877149750"},"camping":{"category":"travel","moji":"🏕","description":"camping","unicodeVersion":"7.0","digest":"a42a4ff9521affa72db7b0f01da169b4cb6afb9db1c5dfad47dd4c507bfc30d9"},"cancer":{"category":"symbols","moji":"♋","description":"cancer","unicodeVersion":"1.1","digest":"528c6f21df99a756b553d93a7f395b0f662b30a323affd05f0cedee8ff7b41d6"},"candle":{"category":"objects","moji":"🕯","description":"candle","unicodeVersion":"7.0","digest":"211c04dc3a91b071c284d4180ed09f9d3320e3fd6ba8a9fddd0677bc97fd12cb"},"candy":{"category":"food","moji":"🍬","description":"candy","unicodeVersion":"6.0","digest":"9cff4538918f60f770fceb96e964f5dc3ce31fd08ddd2ab3bfdf2981bfa74100"},"canoe":{"category":"travel","moji":"🛶","description":"canoe","unicodeVersion":"9.0","digest":"56ca308cc2ad4827468cf58c4ccf6ef6b3382835a91e935540a2b973e01d2572"},"capital_abcd":{"category":"symbols","moji":"🔠","description":"input symbol for latin capital letters","unicodeVersion":"6.0","digest":"a416d0b3f564037b680f801fb773b6eaf67225e2cbbfd2cb8a5db0de044321fa"},"capricorn":{"category":"symbols","moji":"♑","description":"capricorn","unicodeVersion":"1.1","digest":"f11abad102603737b55486fe2ea4d01f28b203394bcd84f19a7948156e6c4b96"},"card_box":{"category":"objects","moji":"🗃","description":"card file box","unicodeVersion":"7.0","digest":"7a6199d562f30e02ed31094de6aebeb99eae8ac156f6910463dfed73256f4c9a"},"card_index":{"category":"objects","moji":"📇","description":"card index","unicodeVersion":"6.0","digest":"86e187e0a72ca5d00207d6ef34d66ce15046848a831c2b5184fb840c5332a2a8"},"carousel_horse":{"category":"travel","moji":"🎠","description":"carousel horse","unicodeVersion":"6.0","digest":"c0e7059efc39a64233f774c02ddb1ab51888fff180f906ce13a6e4f9509672fe"},"carrot":{"category":"food","moji":"🥕","description":"carrot","unicodeVersion":"9.0","digest":"3a6fd98b63ee73d982a9cdacb08cf7b4014368cde8ffce6056b7df25a5a472b1"},"cartwheel":{"category":"activity","moji":"🤸","description":"person doing cartwheel","unicodeVersion":"9.0","digest":"d78de3435e0b04a9b1a1048ae12e63e3248f9ace3a0db4d3bda584f22af18863"},"cartwheel_tone1":{"category":"activity","moji":"🤸🏻","description":"person doing cartwheel tone 1","unicodeVersion":"9.0","digest":"39a49781a269bb40d8efc8fd73c973b00fb2e192850ea6073062b5dea0cd5b74"},"cartwheel_tone2":{"category":"activity","moji":"🤸🏼","description":"person doing cartwheel tone 2","unicodeVersion":"9.0","digest":"6231eb35be45457fd648f8f4b79983f03705c9d983a18067f7e6d9ae47bc1958"},"cartwheel_tone3":{"category":"activity","moji":"🤸🏽","description":"person doing cartwheel tone 3","unicodeVersion":"9.0","digest":"ca483c78cc823811a8c279c501d9b283e4c990dafc5995ad40e68ecb0af554df"},"cartwheel_tone4":{"category":"activity","moji":"🤸🏾","description":"person doing cartwheel tone 4","unicodeVersion":"9.0","digest":"8253afb672431c84e498014c30babb00b9284bec773009e79f7f06aa7108643e"},"cartwheel_tone5":{"category":"activity","moji":"🤸🏿","description":"person doing cartwheel tone 5","unicodeVersion":"9.0","digest":"6fd92baff57c38b3adb6753d9e7e547e762971a8872fd3f1e71c6aaf0b1d3ab9"},"cat":{"category":"nature","moji":"🐱","description":"cat face","unicodeVersion":"6.0","digest":"e52d0d3a205a0ba99094717e171a7f572b713a0e21b276ffa4a826596fe5cafc"},"cat2":{"category":"nature","moji":"🐈","description":"cat","unicodeVersion":"6.0","digest":"46aa67a99f782935932c77b8de93287142297abe52928c173191cf55bb8f4339"},"cd":{"category":"objects","moji":"💿","description":"optical disc","unicodeVersion":"6.0","digest":"16363d8a34b873c12df6354b99f575cae3d80e0d27100ed7eea70f0310953c7b"},"chains":{"category":"objects","moji":"⛓","description":"chains","unicodeVersion":"5.2","digest":"3884cdbc6f2b433062af06f942552e563231c24727a2f10fa280b3bb7aa614e2"},"champagne":{"category":"food","moji":"🍾","description":"bottle with popping cork","unicodeVersion":"8.0","digest":"9e6e8987f30a37ae0f3d7dab2f5eeb50aa32b4f31402b29315eb2994afc72457"},"champagne_glass":{"category":"food","moji":"🥂","description":"clinking glasses","unicodeVersion":"9.0","digest":"5a2e4773f7eb126a00122cbfa4dc535da51ce00e0bf0d8d6ff8bab8b3365f8d2"},"chart":{"category":"symbols","moji":"💹","description":"chart with upwards trend and yen sign","unicodeVersion":"6.0","digest":"a092dbc08f925b028286b2b495a5f59033b8537a586a694f46f4c1e7c3a1e27f"},"chart_with_downwards_trend":{"category":"objects","moji":"📉","description":"chart with downwards trend","unicodeVersion":"6.0","digest":"5db7ccbc37665736a9c0b2f50247dcc09e404ec37f39db45b7b8b9464172a18c"},"chart_with_upwards_trend":{"category":"objects","moji":"📈","description":"chart with upwards trend","unicodeVersion":"6.0","digest":"bc4ea250b102fe5c09847e471478aff065ad3df755d9717896d38d887d9c6733"},"checkered_flag":{"category":"travel","moji":"🏁","description":"chequered flag","unicodeVersion":"6.0","digest":"0e77180e0cf9fc87e755a5a42cf23aec6bf30931db41331311e97ba0be178b78"},"cheese":{"category":"food","moji":"🧀","description":"cheese wedge","unicodeVersion":"8.0","digest":"50a6cb906c2120e2bbc0e22105924262007cfe1554d7b02b8cc84b6adedc6a0b"},"cherries":{"category":"food","moji":"🍒","description":"cherries","unicodeVersion":"6.0","digest":"13b8db9e7e6eec8509aa80c762966e1bf3538fcb1ac3d6eab18ee4da1528cf84"},"cherry_blossom":{"category":"nature","moji":"🌸","description":"cherry blossom","unicodeVersion":"6.0","digest":"af3083f5f8dd94936113f2e16caba5aec7a774d5589aa08bf5de82a2d278cc66"},"chestnut":{"category":"nature","moji":"🌰","description":"chestnut","unicodeVersion":"6.0","digest":"9f85b79b207a69ab81ab88dcef04954000965b039b4cf57de5f1b381745ab98b"},"chicken":{"category":"nature","moji":"🐔","description":"chicken","unicodeVersion":"6.0","digest":"57ceb4459d183740009caac6ebed089d2f1e12f67c138e1be1d0f992313c0ac4"},"children_crossing":{"category":"symbols","moji":"🚸","description":"children crossing","unicodeVersion":"6.0","digest":"0ded7d9aca0161e8ef8e2858c3c198e70e4badc7105ac3a6886e06975de19106"},"chipmunk":{"category":"nature","moji":"🐿","description":"chipmunk","unicodeVersion":"7.0","digest":"5b0dc1a859163097727ba2ba5ffca38b0a54d925eebb089977d28d0b4d917a3f"},"chocolate_bar":{"category":"food","moji":"🍫","description":"chocolate bar","unicodeVersion":"6.0","digest":"dd273e5050488acaf885f8a18b6e2b3901f69c5b39fa6465fb60621783d4109a"},"christmas_tree":{"category":"nature","moji":"🎄","description":"christmas tree","unicodeVersion":"6.0","digest":"ce60cbe2ebbe8057be8edea2392455fedd2bcda64a0a831f6a1942028af7e747"},"church":{"category":"travel","moji":"⛪","description":"church","unicodeVersion":"5.2","digest":"2c328456528f7336e59443e20ec3ab22fe71f1fccb1dd50d0ad68eb206937557"},"cinema":{"category":"symbols","moji":"🎦","description":"cinema","unicodeVersion":"6.0","digest":"4c26dcdc76f93dbc2a1dc49ed4e132b8e8f2b7cdc1acf5e09b3dfd99430d97cd"},"circus_tent":{"category":"activity","moji":"🎪","description":"circus tent","unicodeVersion":"6.0","digest":"fec5f2a06222be8be549178b29720343cc00145177ec387ca4e6f3432481fe77"},"city_dusk":{"category":"travel","moji":"🌆","description":"cityscape at dusk","unicodeVersion":"6.0","digest":"bba345e949dcc51f5f018220f000223797970c82ead2ab9c822f9dc0847aa155"},"city_sunset":{"category":"travel","moji":"🌇","description":"sunset over buildings","unicodeVersion":"6.0","digest":"a846df1a4c7c778f8e1729804aece86eb29d2fcb95dc39eaaf2aae1897f3dcc7"},"cityscape":{"category":"travel","moji":"🏙","description":"cityscape","unicodeVersion":"7.0","digest":"ee360be7514c4bfb0d539dd28f3b2031ebcef04e850723ec0685fb54bd8e6d5f"},"cl":{"category":"symbols","moji":"🆑","description":"squared cl","unicodeVersion":"6.0","digest":"fcec2855dbad9fda11d6e2802bc0dcaabab0b5be233508f5e439f156f07602c1"},"clap":{"category":"people","moji":"👏","description":"clapping hands sign","unicodeVersion":"6.0","digest":"a1860ce7812a9f6fb55e45761e1b79a2f8f0620eb04f80748a38420889d58a2a"},"clap_tone1":{"category":"people","moji":"👏🏻","description":"clapping hands sign tone 1","unicodeVersion":"8.0","digest":"18a7022e08223fb2109af5a9b9a5b4f47dc870ce4453f4987d2d0b729ef54586"},"clap_tone2":{"category":"people","moji":"👏🏼","description":"clapping hands sign tone 2","unicodeVersion":"8.0","digest":"5954c8658b15e755d2018d8674df84d38e22ffededc4d726c6a33b709f71426a"},"clap_tone3":{"category":"people","moji":"👏🏽","description":"clapping hands sign tone 3","unicodeVersion":"8.0","digest":"22639b6bd3c53784a2f855d6db7bdf31621519f19dfc29a6bc310eee6421f742"},"clap_tone4":{"category":"people","moji":"👏🏾","description":"clapping hands sign tone 4","unicodeVersion":"8.0","digest":"e55248dc163d1bbd118b50cd8767750ead86d082151febbc0a75b32d63abceec"},"clap_tone5":{"category":"people","moji":"👏🏿","description":"clapping hands sign tone 5","unicodeVersion":"8.0","digest":"76046b8157dabbe048a07fc318122456020c9c980fc1b8ab76802330e07b3b53"},"clapper":{"category":"activity","moji":"🎬","description":"clapper board","unicodeVersion":"6.0","digest":"8149752a0e3e8abede2d433d1afab6d217877d0c76adb1e2845a0142c0cdcbaa"},"classical_building":{"category":"travel","moji":"🏛","description":"classical building","unicodeVersion":"7.0","digest":"9ee0d00c43d6e22b6a3ddea67619737270cc7e9294797a19c7c60d5f92aa44fa"},"clipboard":{"category":"objects","moji":"📋","description":"clipboard","unicodeVersion":"6.0","digest":"bdd7f7d973c714e59d2903d401a876e6018794c7987c9ca57108c137c5edc25f"},"clock":{"category":"objects","moji":"🕰","description":"mantlepiece clock","unicodeVersion":"7.0","digest":"302835eab2637db799acf69b3d795571ef3432251267050db0704f2954e8b190"},"clock1":{"category":"symbols","moji":"🕐","description":"clock face one oclock","unicodeVersion":"6.0","digest":"1778eec07ce061c9393e5abee5ca83b24e1ce61d8a75fa2e39efcb31aa160395"},"clock10":{"category":"symbols","moji":"🕙","description":"clock face ten oclock","unicodeVersion":"6.0","digest":"601fc12ea5280a54c2e69dbb685f454e4165fe771756ed6f89016e29e683a24f"},"clock1030":{"category":"symbols","moji":"🕥","description":"clock face ten-thirty","unicodeVersion":"6.0","digest":"4fd155f08f797542d52cff4b0aa3ca9f080f37a41c301b82f90ff6d4693c890e"},"clock11":{"category":"symbols","moji":"🕚","description":"clock face eleven oclock","unicodeVersion":"6.0","digest":"5c79dc812e812e8a01993ea633b323d654ce3a7ea258692781a4896e4ad2017e"},"clock1130":{"category":"symbols","moji":"🕦","description":"clock face eleven-thirty","unicodeVersion":"6.0","digest":"41497ee2020ee5ac9aa5f9b07560f7afca7c422b04214449cfc5cea9f020f52e"},"clock12":{"category":"symbols","moji":"🕛","description":"clock face twelve oclock","unicodeVersion":"6.0","digest":"046bb7ffa5f5d27c2e3411ba543484d9dabb8ebf6d6e7a7e9bfb088c1813500c"},"clock1230":{"category":"symbols","moji":"🕧","description":"clock face twelve-thirty","unicodeVersion":"6.0","digest":"bbfe9db5a2043aaba19a7a2a0185c7efcebf1e8c9263b8233f75b53c4825f0f4"},"clock130":{"category":"symbols","moji":"🕜","description":"clock face one-thirty","unicodeVersion":"6.0","digest":"8662cb395ee680c2781123305c4c8ce8c0df9565c2c942668940be540cc0c094"},"clock2":{"category":"symbols","moji":"🕑","description":"clock face two oclock","unicodeVersion":"6.0","digest":"42f7429748b612dce7de77221cbbc710655811f7bb23e2a986c36e6d662f0ec4"},"clock230":{"category":"symbols","moji":"🕝","description":"clock face two-thirty","unicodeVersion":"6.0","digest":"e710b6ef14227cd240ea3e2a867c8ef45b5c060adf3cb30ba9077c2351fe6677"},"clock3":{"category":"symbols","moji":"🕒","description":"clock face three oclock","unicodeVersion":"6.0","digest":"7340d465b398a378211dff9ec806db579d061206fd6fc238623d070cfe0a55ce"},"clock330":{"category":"symbols","moji":"🕞","description":"clock face three-thirty","unicodeVersion":"6.0","digest":"7aa4a15cc8de04ed3bdeb0f8a54a7915065f2809a07054e002d89926c9766831"},"clock4":{"category":"symbols","moji":"🕓","description":"clock face four oclock","unicodeVersion":"6.0","digest":"36fd88e81ad488b0ec49a911a838693281573fa14736ae4a6dd1c40a4ff69bb1"},"clock430":{"category":"symbols","moji":"🕟","description":"clock face four-thirty","unicodeVersion":"6.0","digest":"7bd5dd71e89d95dcf18b9e8c1fe2a353a7da3b69aadb8dda80ee9bafb05da58d"},"clock5":{"category":"symbols","moji":"🕔","description":"clock face five oclock","unicodeVersion":"6.0","digest":"aa406409e56a0bfd8c850e44efe45fd190ffd7bf7061e934ed7928dfbdfc9eba"},"clock530":{"category":"symbols","moji":"🕠","description":"clock face five-thirty","unicodeVersion":"6.0","digest":"25dd3bcc53ddd98eeea498d7dbd4c306ef39dd033f15909063388a0800febf41"},"clock6":{"category":"symbols","moji":"🕕","description":"clock face six oclock","unicodeVersion":"6.0","digest":"0a321eaf1bc5db8436bbadac66c45ba257fc98ad4c7569ce3fc6602c824b6d7c"},"clock630":{"category":"symbols","moji":"🕡","description":"clock face six-thirty","unicodeVersion":"6.0","digest":"55a4c5a665fdd38a724e9357a93c55401fcd5f1b13078c25754bd70c3fc4ccec"},"clock7":{"category":"symbols","moji":"🕖","description":"clock face seven oclock","unicodeVersion":"6.0","digest":"6154306545716e865da0ec537ee4f22bfe6c7294502a64a2dcf425c587d0e2a2"},"clock730":{"category":"symbols","moji":"🕢","description":"clock face seven-thirty","unicodeVersion":"6.0","digest":"6925654de642e50f84661f94364a96c87757d73fffe766aacbf4bbd70130547b"},"clock8":{"category":"symbols","moji":"🕗","description":"clock face eight oclock","unicodeVersion":"6.0","digest":"9be2d189c7ea56d39fd259f84853d753c1cf33e64f8ed57f86f822d9ae23a1ee"},"clock830":{"category":"symbols","moji":"🕣","description":"clock face eight-thirty","unicodeVersion":"6.0","digest":"16878613c0000d2f558c88d080551f424a8bd9df1358e0f931dd25c3da68f2d9"},"clock9":{"category":"symbols","moji":"🕘","description":"clock face nine oclock","unicodeVersion":"6.0","digest":"1d1e7e3c9d085ffa5b7c0f3d9fd394b734f16ae3b60df09af50fe6c8d4f3c8bb"},"clock930":{"category":"symbols","moji":"🕤","description":"clock face nine-thirty","unicodeVersion":"6.0","digest":"9fdef6a4939315c017b165e1dbac7710fb335df8c309be3fe2a011ef7fc28d74"},"closed_book":{"category":"objects","moji":"📕","description":"closed book","unicodeVersion":"6.0","digest":"b18288629d201bfdfc5d66ec47df89809d00642b15732757e6a04789f36a7d9f"},"closed_lock_with_key":{"category":"objects","moji":"🔐","description":"closed lock with key","unicodeVersion":"6.0","digest":"e39adfe9b30973bca16472c2b7e6462b064a93b9d452aa48edd74c727641a83d"},"closed_umbrella":{"category":"people","moji":"🌂","description":"closed umbrella","unicodeVersion":"6.0","digest":"2cc0592c74601f7439e88c3c1ec4f05e3459608ef1ea6558c5824ed7c3889727"},"cloud":{"category":"nature","moji":"☁","description":"cloud","unicodeVersion":"1.1","digest":"5b3a19718dfa8a381929665afdc2284464d24020c8dd0caff4dad465a1f536ba"},"cloud_lightning":{"category":"nature","moji":"🌩","description":"cloud with lightning","unicodeVersion":"7.0","digest":"2b32f6d87726df2935ad81870879ccec30ce9b4fd5861d1a6317f9eca2f013d9"},"cloud_rain":{"category":"nature","moji":"🌧","description":"cloud with rain","unicodeVersion":"7.0","digest":"1e1e8bc59e168e1d2e72bf11f2d43cb578cbf0a5f1daf383bba5c56fb750ee71"},"cloud_snow":{"category":"nature","moji":"🌨","description":"cloud with snow","unicodeVersion":"7.0","digest":"2d364f859b83e684213e8eece1640208d80a8de0a49d0fc8e0e24c5a8493a3b1"},"cloud_tornado":{"category":"nature","moji":"🌪","description":"cloud with tornado","unicodeVersion":"7.0","digest":"7cbed2343c280ba3996082b3d0fb9d8cd57d6e62fe6c9ecb159f46b4a2e49151"},"clown":{"category":"people","moji":"🤡","description":"clown face","unicodeVersion":"9.0","digest":"eea95687caabc9e808514c2450ba599e5e24ef47923dbec86f5297a64438e2e5"},"clubs":{"category":"symbols","moji":"♣","description":"black club suit","unicodeVersion":"1.1","digest":"b8cf72ecd8568ced077b475d94788fb282bdb06d25031b5d54dd63e25effb138"},"cocktail":{"category":"food","moji":"🍸","description":"cocktail glass","unicodeVersion":"6.0","digest":"3792def2cde885cf32167f04904d3b0b788388e8af410c63e4cd31550feba775"},"coffee":{"category":"food","moji":"☕","description":"hot beverage","unicodeVersion":"4.0","digest":"0d29615a7a67d3aafa257b909bb915dc74fa8f854acb0d9a2c29e94eedf80326"},"coffin":{"category":"objects","moji":"⚰","description":"coffin","unicodeVersion":"4.1","digest":"78eccc1aad2a822649fba8503d4d30354bef367c4271193c40ddb692308f9db8"},"cold_sweat":{"category":"people","moji":"😰","description":"face with open mouth and cold sweat","unicodeVersion":"6.0","digest":"f53aab523ed3fa2224a16881d263fb5e039f163380f92feb2c63c20f9b14dcd2"},"comet":{"category":"nature","moji":"☄","description":"comet","unicodeVersion":"1.1","digest":"40ce93e55c6e57a88d80670b37171190bd5ffc87b7078891d8de5b15795385c5"},"compression":{"category":"objects","moji":"🗜","description":"compression","unicodeVersion":"7.0","digest":"c8841f7afb5345f1c31da116a7fb41d07232ea58d3f7f1a75c5890aa1a80bfd6"},"computer":{"category":"objects","moji":"💻","description":"personal computer","unicodeVersion":"6.0","digest":"c970ce76b5607434895b0407bdaa93140f887930781a17dd7dcf16f711451d93"},"confetti_ball":{"category":"objects","moji":"🎊","description":"confetti ball","unicodeVersion":"6.0","digest":"a638b16f1acdbcf69edf760161b1bd7ff1fd5426c5b1203ad9d294dcc0701f10"},"confounded":{"category":"people","moji":"😖","description":"confounded face","unicodeVersion":"6.0","digest":"e2ff3b4df65d00c1ca9ae0cb379f959ea2cecefb3d676d4f8c2c5f2c103da4f6"},"confused":{"category":"people","moji":"😕","description":"confused face","unicodeVersion":"6.1","digest":"118d7f830ec08a3ac4b798eebb77a989b8c142f2588727181be4a2548e3c4f06"},"congratulations":{"category":"symbols","moji":"㊗","description":"circled ideograph congratulation","unicodeVersion":"1.1","digest":"02fd1338c54fe5f9a0fd861f23c56edc1d39bcd3140b68f0f626f9e2494d2d1c"},"construction":{"category":"travel","moji":"🚧","description":"construction sign","unicodeVersion":"6.0","digest":"c3a0401331111b9eda1206bee5f322db80b0870547d307b10dcac1314e4078c8"},"construction_site":{"category":"travel","moji":"🏗","description":"building construction","unicodeVersion":"7.0","digest":"c611f0a5de10f000a0756935f226845c7292f19ff5581d1f7a7554316338bbcb"},"construction_worker":{"category":"people","moji":"👷","description":"construction worker","unicodeVersion":"6.0","digest":"8c094733987e7c4da8d3aa4588b530ae07042bd70cf337b1fd412a70ee8f0ed6"},"construction_worker_tone1":{"category":"people","moji":"👷🏻","description":"construction worker tone 1","unicodeVersion":"8.0","digest":"fcd927405fef4486105cd3aff62155467d21cebbc013924d4b52b717b566602b"},"construction_worker_tone2":{"category":"people","moji":"👷🏼","description":"construction worker tone 2","unicodeVersion":"8.0","digest":"d1ec773828936c703dd6e334e696dc3cf7c34c0a8ec691564a384b735cdeaaba"},"construction_worker_tone3":{"category":"people","moji":"👷🏽","description":"construction worker tone 3","unicodeVersion":"8.0","digest":"37c114d6879b9b32b800b0d4cf770dcbe04d1455698130ecd709a0cb9dea880b"},"construction_worker_tone4":{"category":"people","moji":"👷🏾","description":"construction worker tone 4","unicodeVersion":"8.0","digest":"5264996c1bedb6061a0dfdddce233d863bf308d27127ad152b63bfd983162cf7"},"construction_worker_tone5":{"category":"people","moji":"👷🏿","description":"construction worker tone 5","unicodeVersion":"8.0","digest":"87051aec81fd5dfd4dc44ff0411a528ee08253e9494d37efa550694e28dde6d3"},"control_knobs":{"category":"objects","moji":"🎛","description":"control knobs","unicodeVersion":"7.0","digest":"0d7f33ff7acc1cc3a81e6a786ff007df20da145e3070f338505dfed5100e9fcb"},"convenience_store":{"category":"travel","moji":"🏪","description":"convenience store","unicodeVersion":"6.0","digest":"975dcf9b8e9e3fb1e29574b41300b9d96fd64703b3c18ff52f9f1875d1cf1b52"},"cookie":{"category":"food","moji":"🍪","description":"cookie","unicodeVersion":"6.0","digest":"4bed3522bd50091ac5b68ca760661eb484d7f1b9c9d564d2097bd812b7f28ae4"},"cooking":{"category":"food","moji":"🍳","description":"cooking","unicodeVersion":"6.0","digest":"563ffd6cae381ce1e318cdacc54e70040d6a01a50d0db8aeb50edbbe413eac58"},"cool":{"category":"symbols","moji":"🆒","description":"squared cool","unicodeVersion":"6.0","digest":"5739a37341c782a4736adfce804e12776ae33081098a3d052d8ae9a64b4d22d1"},"cop":{"category":"people","moji":"👮","description":"police officer","unicodeVersion":"6.0","digest":"78996521bbe231d03ebea355226d8a1515f47cde7b2fbeca1037e7b7e5133466"},"cop_tone1":{"category":"people","moji":"👮🏻","description":"police officer tone 1","unicodeVersion":"8.0","digest":"8a38cd107f5f4c0b821ac43f32df5dc57facaf39fbafb98483ec00fd7df41baf"},"cop_tone2":{"category":"people","moji":"👮🏼","description":"police officer tone 2","unicodeVersion":"8.0","digest":"8ab8ab086f3ff82aa4bf4760c3c822846ec2696c41d21dffdac12d5afbe398b7"},"cop_tone3":{"category":"people","moji":"👮🏽","description":"police officer tone 3","unicodeVersion":"8.0","digest":"fce710a99fd44a7c8af3ea01b2007e46d3ff38d7a0dff1ef26d6f893ede7e6d2"},"cop_tone4":{"category":"people","moji":"👮🏾","description":"police officer tone 4","unicodeVersion":"8.0","digest":"3017dd73ef475379911c5e6c79bd0f9f533dbbc5057bce6a11244faa12996ba0"},"cop_tone5":{"category":"people","moji":"👮🏿","description":"police officer tone 5","unicodeVersion":"8.0","digest":"a3b8807b3f2a8d6ee9bcec0339355bda486e8c930f727139f5447a4b046a6307"},"copyright":{"category":"symbols","moji":"©","description":"copyright sign","unicodeVersion":"1.1","digest":"cc28663cdd3f8333d9bb57b511348cde4e51bda19cf0629dccb05c8fc425e079"},"corn":{"category":"food","moji":"🌽","description":"ear of maize","unicodeVersion":"6.0","digest":"a099a0b291fa758690e6ee6c762b9ade9a0e3350a707c52d968dfffbcc467de5"},"couch":{"category":"objects","moji":"🛋","description":"couch and lamp","unicodeVersion":"7.0","digest":"84cd734dbaa7f9f519438036d687e7a53217130779bc3de30258f163521b9474"},"couple":{"category":"people","moji":"👫","description":"man and woman holding hands","unicodeVersion":"6.0","digest":"c897ba76e24e2f43a4aa261c2754800a8473f43c7ce53f9909a6af2c4897732a"},"couple_mm":{"category":"people","moji":"👨‍❤️‍👨","description":"couple (man,man)","unicodeVersion":"6.0","digest":"c812471d35d46e12270653039a907d1dfa2dea0defd65596283e5b8e03cea803"},"couple_with_heart":{"category":"people","moji":"💑","description":"couple with heart","unicodeVersion":"6.0","digest":"420bfa81bad10365550c77a98e1c07eb00d03663fe7b610fab1aca8a0a9d201b"},"couple_ww":{"category":"people","moji":"👩‍❤️‍👩","description":"couple (woman,woman)","unicodeVersion":"6.0","digest":"7ac49153a612d63302299eee996308b7dcafa0a152473dab679215036fe6567e"},"couplekiss":{"category":"people","moji":"💏","description":"kiss","unicodeVersion":"6.0","digest":"1acfef9d375c4c1deb235babd856b0f90ad4f3194751694cb6abb44f00f29e42"},"cow":{"category":"nature","moji":"🐮","description":"cow face","unicodeVersion":"6.0","digest":"d71c854ff8b343ee24b8c2b9d56c7cb3fc6fa1a6dc0d7a137841b9f646e6d71b"},"cow2":{"category":"nature","moji":"🐄","description":"cow","unicodeVersion":"6.0","digest":"e7a5131d7dee0f3356814b0ac1ea8ff280b12a7b580181e20ddb0b7eeb7e7339"},"cowboy":{"category":"people","moji":"🤠","description":"face with cowboy hat","unicodeVersion":"9.0","digest":"1aabf23f6b95a9b772fdb8eb45b8ec93584a5357f9131c6eabc9d1b83fe67e89"},"crab":{"category":"nature","moji":"🦀","description":"crab","unicodeVersion":"8.0","digest":"e6be16699fdb5d87f42f28f6cc141a44b7ffd834ecdd536813c4b5b86d3fc4a5"},"crayon":{"category":"objects","moji":"🖍","description":"lower left crayon","unicodeVersion":"7.0","digest":"b180d6afa4777861222a4228164ce284230fe90c589f52ffa9351bac777e901a"},"credit_card":{"category":"objects","moji":"💳","description":"credit card","unicodeVersion":"6.0","digest":"808cd120fd3738eb2be1f6c6c029d98387b0e03fca7d1451e8fbf9c5ab3f643f"},"crescent_moon":{"category":"nature","moji":"🌙","description":"crescent moon","unicodeVersion":"6.0","digest":"042e7e01e6e88b97a763b7cc41e2a2b3fe68a649bacf4a090cd28fc653baf640"},"cricket":{"category":"activity","moji":"🏏","description":"cricket bat and ball","unicodeVersion":"8.0","digest":"4c4559d0b4efe24cc248fa57f413541307992e519d0cb9fb8828637ac2f4cc16"},"crocodile":{"category":"nature","moji":"🐊","description":"crocodile","unicodeVersion":"6.0","digest":"59cb4164c50b6bc9ae311ce6f7610467c1aaafa848b5fff7614f064715f91992"},"croissant":{"category":"food","moji":"🥐","description":"croissant","unicodeVersion":"9.0","digest":"b751e287157a1e276617a841a5b5f7f1208ca226cfd8fa947f144390b65a5e16"},"cross":{"category":"symbols","moji":"✝","description":"latin cross","unicodeVersion":"1.1","digest":"a6b07c838fb75ef2ebefa2df6005e8d784753239ec03c37695a13e3b1954d653"},"crossed_flags":{"category":"objects","moji":"🎌","description":"crossed flags","unicodeVersion":"6.0","digest":"2841c671075e6f1a79c61c2d716423159fb0bc0786e3fb0049697766533bf262"},"crossed_swords":{"category":"objects","moji":"⚔","description":"crossed swords","unicodeVersion":"4.1","digest":"3771a5b26b514236521ce44e15f7730fa9148c6a782b9b600ab870a1f7de6f9f"},"crown":{"category":"people","moji":"👑","description":"crown","unicodeVersion":"6.0","digest":"6741e58d8f823194e0a3484ac1563e20d9e0b44c1bc46d82444dfffa092cdfc7"},"cruise_ship":{"category":"travel","moji":"🛳","description":"passenger ship","unicodeVersion":"7.0","digest":"2b7b62db5d118a632673564099e3405ea6d61ea9b8e123b5a2aaf011bb2a54a4"},"cry":{"category":"people","moji":"😢","description":"crying face","unicodeVersion":"6.0","digest":"fc3307ec4fe75539770c1123a0e8e721d9e021009a502655132f68d7cc453816"},"crying_cat_face":{"category":"people","moji":"😿","description":"crying cat face","unicodeVersion":"6.0","digest":"4942c24935c22babdcb8af41d2c0a7588356b6b674bc238902e2f10ad03e2c5b"},"crystal_ball":{"category":"objects","moji":"🔮","description":"crystal ball","unicodeVersion":"6.0","digest":"05f73b30b1e5b0fc66fb5dc6caddd2d547ee7b9d2f97513dc908ba1a2e352e30"},"cucumber":{"category":"food","moji":"🥒","description":"cucumber","unicodeVersion":"9.0","digest":"d1196e23f2f155ef5c1330f8497f40957a7357cb177127f457c5c471f0a23727"},"cupid":{"category":"symbols","moji":"💘","description":"heart with arrow","unicodeVersion":"6.0","digest":"246e71f44c6ebc2e4f887e25438e4f894e8cc92e06069e711b893ff391abb658"},"curly_loop":{"category":"symbols","moji":"➰","description":"curly loop","unicodeVersion":"6.0","digest":"9e4eb98d6597888f91208080c6a79824adb432ea34f46c85da26cb630bd1cc73"},"currency_exchange":{"category":"symbols","moji":"💱","description":"currency exchange","unicodeVersion":"6.0","digest":"b85377265b9876888969aa42b65bba0be523a370175baf226f20131e535af554"},"curry":{"category":"food","moji":"🍛","description":"curry and rice","unicodeVersion":"6.0","digest":"a01c0a713662817720b485f7739f57e61afc025f5c43792f4de961c94f92f31e"},"custard":{"category":"food","moji":"🍮","description":"custard","unicodeVersion":"6.0","digest":"85c2b9ac904134a6c3587eb0a0806f2ab4282c5ed5c79d41734f3203998f757e"},"customs":{"category":"symbols","moji":"🛃","description":"customs","unicodeVersion":"6.0","digest":"eb2546e1e617d4c1a1f614318af5e5dacf3e8d9479ffa08108977defa83ded32"},"cyclone":{"category":"symbols","moji":"🌀","description":"cyclone","unicodeVersion":"6.0","digest":"7a0f8564d76adf2d0ed272f56dc0d01fb7b557852e0ca797e73f5472b8630bf3"},"dagger":{"category":"objects","moji":"🗡","description":"dagger knife","unicodeVersion":"7.0","digest":"35a179168198d03295e626cc27d3b92d30a732c55a2ca75d7a11a0fbed414772"},"dancer":{"category":"people","moji":"💃","description":"dancer","unicodeVersion":"6.0","digest":"66ffa86827e85acae4aa870c0859fe3a9dad03d21ff4bc800b61c95c902a8a90"},"dancer_tone1":{"category":"people","moji":"💃🏻","description":"dancer tone 1","unicodeVersion":"8.0","digest":"bdbee740addc890e369d3469a3585eb0d1e4fbc7e04dd6f6aca762d8aeee6a8c"},"dancer_tone2":{"category":"people","moji":"💃🏼","description":"dancer tone 2","unicodeVersion":"8.0","digest":"9f7b4c627241eaa2def9717a5286a423f0b9c1b044dd9ea4442a76f1858d14a4"},"dancer_tone3":{"category":"people","moji":"💃🏽","description":"dancer tone 3","unicodeVersion":"8.0","digest":"a6bd49a377ce6c2004bf126b6f66d0b21d8c14103c2add7b10f12ed9e1c2d302"},"dancer_tone4":{"category":"people","moji":"💃🏾","description":"dancer tone 4","unicodeVersion":"8.0","digest":"4ec2a7629c01b0e9006b5cda4deae3bf297ce3b71d18063f93eeb5c14be19a1a"},"dancer_tone5":{"category":"people","moji":"💃🏿","description":"dancer tone 5","unicodeVersion":"8.0","digest":"2b48e3a6b366c6f55f73b816e6fb03c39e9890f586f7e9c9043cf0c013d9cdd5"},"dancers":{"category":"people","moji":"👯","description":"woman with bunny ears","unicodeVersion":"6.0","digest":"12be66ed19d232bb387270f40bece68bd0cb2342b318f6c9bb8b49c64ff7d0ad"},"dango":{"category":"food","moji":"🍡","description":"dango","unicodeVersion":"6.0","digest":"34e8cd153c50f2d725abe8934c35c96a3ab533f0cc5fbb1e1474eafad1dc1fc2"},"dark_sunglasses":{"category":"people","moji":"🕶","description":"dark sunglasses","unicodeVersion":"7.0","digest":"d0a735ad5bf0ece00af2a21abf950b89292ebd8ca6e28b1dbb1368252fb44afe"},"dart":{"category":"activity","moji":"🎯","description":"direct hit","unicodeVersion":"6.0","digest":"998642f06a875905e0a6bf30963c025baff1cf55b8e76884b9119f2d71188b0c"},"dash":{"category":"nature","moji":"💨","description":"dash symbol","unicodeVersion":"6.0","digest":"f7aae7d3887c67d76f3329c2dc9e6807dc580a4b07ab35599c7805e41823a345"},"date":{"category":"objects","moji":"📅","description":"calendar","unicodeVersion":"6.0","digest":"d0b695e4a7cfbbe71b4fbebf345b66ca98f0cf1c751362928e54c23ca78d4c7b"},"deciduous_tree":{"category":"nature","moji":"🌳","description":"deciduous tree","unicodeVersion":"6.0","digest":"3c70f1a77f2754f41c830e88d43b7d53c14311d64626ded164aa9ac7d2695790"},"deer":{"category":"nature","moji":"🦌","description":"deer","unicodeVersion":"9.0","digest":"7f4302ca68fd121ee73be48d0a0a0fb9e7e2741071a491ad2b7b0eab9f11ad25"},"department_store":{"category":"travel","moji":"🏬","description":"department store","unicodeVersion":"6.0","digest":"4be910d2efe74d8ce2c1f41d7753c8873579faca83fcf779a4887d8ab9e5923b"},"desert":{"category":"travel","moji":"🏜","description":"desert","unicodeVersion":"7.0","digest":"d4b1a11c5130debe042df6cc2b3389f15c68a5cb32dc1b3a82b78f733d0c9e4e"},"desktop":{"category":"objects","moji":"🖥","description":"desktop computer","unicodeVersion":"7.0","digest":"cde5bfb6c71bb7d663808a3561b24cb5b5560f95f510b40f81250cac1b21933e"},"diamond_shape_with_a_dot_inside":{"category":"symbols","moji":"💠","description":"diamond shape with a dot inside","unicodeVersion":"6.0","digest":"e91323577ab89e95b0fa0b9272ea0c797b76908f24d36992630e9325273a4ce3"},"diamonds":{"category":"symbols","moji":"♦","description":"black diamond suit","unicodeVersion":"1.1","digest":"bf3d9a020afe8aa226db73590bc193a9c2c3e6e642edd2445c5960c3e67cf153"},"disappointed":{"category":"people","moji":"😞","description":"disappointed face","unicodeVersion":"6.0","digest":"c0f406c6beea0fd1328adefc097d04aa16b72f7a5afa0867967d8ea25d72db17"},"disappointed_relieved":{"category":"people","moji":"😥","description":"disappointed but relieved face","unicodeVersion":"6.0","digest":"c826f5dd4f2f7e5289d720851d4826ab8284d915606c1b152ab229b7fadbba14"},"dividers":{"category":"objects","moji":"🗂","description":"card index dividers","unicodeVersion":"7.0","digest":"4b2c653b18cf0fa31f1f0ac94a6fbd214ea0d1b0a90a450ab6e169906fc5764f"},"dizzy":{"category":"nature","moji":"💫","description":"dizzy symbol","unicodeVersion":"6.0","digest":"d577545c2de42389695447c6ebbfef895f30f0fda84eef45684f9bf4a9c27ff1"},"dizzy_face":{"category":"people","moji":"😵","description":"dizzy face","unicodeVersion":"6.0","digest":"7b3aeaffb4e15ccf633b91dda4a44847a1eb28d78ce58b4d171b20a771bde414"},"do_not_litter":{"category":"symbols","moji":"🚯","description":"do not litter symbol","unicodeVersion":"6.0","digest":"98b07fbbcdb438d1b8a755869fa2de8e180a77fce359ec830eb46d38ec3e67cb"},"dog":{"category":"nature","moji":"🐶","description":"dog face","unicodeVersion":"6.0","digest":"3b31ce067b13e463284ce85536512cb1f8cd8b52fe73659f69971d0d6c1dfc11"},"dog2":{"category":"nature","moji":"🐕","description":"dog","unicodeVersion":"6.0","digest":"0a8901bce5ed994533ff84299b2a1364de28d872c9f9510d3426a83e8a9d2e34"},"dollar":{"category":"objects","moji":"💵","description":"banknote with dollar sign","unicodeVersion":"6.0","digest":"52438e38867aedc021740bb41f9ba336e75a50faa148419412a01d75d8c93155"},"dolls":{"category":"objects","moji":"🎎","description":"japanese dolls","unicodeVersion":"6.0","digest":"a687184e9a0915deef44bb3cacfb19d3f3f19cf2c110f1da90191dd567333c57"},"dolphin":{"category":"nature","moji":"🐬","description":"dolphin","unicodeVersion":"6.0","digest":"0b7ee08f4236232ca533ed3a3023d28020d36f178efaec5ce8b0e13a84778512"},"door":{"category":"objects","moji":"🚪","description":"door","unicodeVersion":"6.0","digest":"984a9ca88852ebdb539e0c385d9c6ffe5010e9189bc372a3d00f5c8d44c8e6f5"},"doughnut":{"category":"food","moji":"🍩","description":"doughnut","unicodeVersion":"6.0","digest":"27634587e6a53807baa32157bb06b0e115c8ad8aefebba7ebb0b65a084170e3a"},"dove":{"category":"nature","moji":"🕊","description":"dove of peace","unicodeVersion":"7.0","digest":"7c665f8594ffa53e72b01647e9d27360fb87d52d02fe9f20fc5fda08f9797dc3"},"dragon":{"category":"nature","moji":"🐉","description":"dragon","unicodeVersion":"6.0","digest":"2abcb3d945d848e34ffc76203b29ef26df7458856166fffd155611f7bbe72652"},"dragon_face":{"category":"nature","moji":"🐲","description":"dragon face","unicodeVersion":"6.0","digest":"0030548931b931e3b51f26cf660394aee36499e688ba83ce9cfccb635dcd4d54"},"dress":{"category":"people","moji":"👗","description":"dress","unicodeVersion":"6.0","digest":"96ceba928fb356f7c0ae99bf22552321f08a65d5f1c0340ab89641219ad366ad"},"dromedary_camel":{"category":"nature","moji":"🐪","description":"dromedary camel","unicodeVersion":"6.0","digest":"e06ef69c29f0fb12481727c0b4124e700572d3d7955e173279320f43f286518d"},"drooling_face":{"category":"people","moji":"🤤","description":"drooling face","unicodeVersion":"9.0","digest":"5203cb05cd266d7a7c929ab40364ad68571d380d9c7ff93a8d6d55261abaa1ba"},"droplet":{"category":"nature","moji":"💧","description":"droplet","unicodeVersion":"6.0","digest":"6475b4a4460a672c436a68f282ac97fb31e2934db4b80620063ee816159aa7c3"},"drum":{"category":"activity","moji":"🥁","description":"drum with drumsticks","unicodeVersion":"9.0","digest":"0d0639980b1a5dcbf1c3e7ef47263fb6543b871242c58452a8c2f642525d9dd8"},"duck":{"category":"nature","moji":"🦆","description":"duck","unicodeVersion":"9.0","digest":"8f8373798a7727368b32328e7a9a349727a949e7391ddd243b6456141a4f7e94"},"dvd":{"category":"objects","moji":"📀","description":"dvd","unicodeVersion":"6.0","digest":"3b7903285d91277181c26fdc9df857761bbac509d352e320c2519ea3b132704f"},"e-mail":{"category":"objects","moji":"📧","description":"e-mail symbol","unicodeVersion":"6.0","digest":"39b5a57a2376e4a1137e381be02a1775bd580e0371438f5297a401ea634f1830"},"eagle":{"category":"nature","moji":"🦅","description":"eagle","unicodeVersion":"9.0","digest":"b44fd4f61b83c5114358a272343ac9b0eabbc70847f739bbdbf8aae3ade5bc1d"},"ear":{"category":"people","moji":"👂","description":"ear","unicodeVersion":"6.0","digest":"4fdeb5a46e69311ecfd09c5b45c9018c24b625e28475cca8fa516b086ef952f8"},"ear_of_rice":{"category":"nature","moji":"🌾","description":"ear of rice","unicodeVersion":"6.0","digest":"2997c340c2b333d6ba9b73f94ff1a1881735fe0cc4f0c72d7719b305499fc425"},"ear_tone1":{"category":"people","moji":"👂🏻","description":"ear tone 1","unicodeVersion":"8.0","digest":"5ca759b8569a377a4e63e30d94b585b9f76d15348a8a0c1ba19fdc522790615e"},"ear_tone2":{"category":"people","moji":"👂🏼","description":"ear tone 2","unicodeVersion":"8.0","digest":"12aafb3ef2cfcdc892b2877c2e24920620f0f77f850e12afbfe55eadce9e37df"},"ear_tone3":{"category":"people","moji":"👂🏽","description":"ear tone 3","unicodeVersion":"8.0","digest":"f4d28d9f72cf116ac92d80061eb84c918d6523bf53b2ad526f5457aba487d527"},"ear_tone4":{"category":"people","moji":"👂🏾","description":"ear tone 4","unicodeVersion":"8.0","digest":"eaa9453670f7e3adc6ec6934ee70efc9bf60fe6c99c5804b7ba9e3804aec65de"},"ear_tone5":{"category":"people","moji":"👂🏿","description":"ear tone 5","unicodeVersion":"8.0","digest":"54bd0782419489556b80e9e0d15b05df74757aa4e04ba565f45c20d3dd60e3f1"},"earth_africa":{"category":"nature","moji":"🌍","description":"earth globe europe-africa","unicodeVersion":"6.0","digest":"c691a6f591f5a07b268fd64efe113e81cec8d5963ad83ced2537422343ff7ecf"},"earth_americas":{"category":"nature","moji":"🌎","description":"earth globe americas","unicodeVersion":"6.0","digest":"a9c60cf8341ff59a9cc1a715b7144af734fcd28915a8e003a31ebf2abf9aedb1"},"earth_asia":{"category":"nature","moji":"🌏","description":"earth globe asia-australia","unicodeVersion":"6.0","digest":"ee2beb61fb8c87279161c5a8c4ad17bb71ce790123f8fa33522941d027e060a5"},"egg":{"category":"food","moji":"🥚","description":"egg","unicodeVersion":"9.0","digest":"72b9c841af784e7cbccbbe48ba833df5cecdd284397c199cab079872e879d92f"},"eggplant":{"category":"food","moji":"🍆","description":"aubergine","unicodeVersion":"6.0","digest":"ec0a460e0cf0e615f51279677594a899672e1b4ecd9396e17a8cfa2a3efe5238"},"eight":{"category":"symbols","moji":"8️⃣","description":"keycap digit eight","unicodeVersion":"3.0","digest":"57ff905033a32747690adba6486d12b09eb4d45de556f4e1ab6fb04e1fb861a8"},"eight_pointed_black_star":{"category":"symbols","moji":"✴","description":"eight pointed black star","unicodeVersion":"1.1","digest":"7bf11f6e28591e3d0625296aaabf4ecb75c982e425abf3049339e93494acc17e"},"eight_spoked_asterisk":{"category":"symbols","moji":"✳","description":"eight spoked asterisk","unicodeVersion":"1.1","digest":"bb0758e7cc0e357285937671a91489bd32ce9d248eecdcc9c275a53a66325b26"},"eject":{"category":"symbols","moji":"⏏","description":"eject symbol","unicodeVersion":"4.0","digest":"eeb0cd23ead0c965e307de517a6805265f0c780c3e454e64bc4c1425dfe7548e"},"electric_plug":{"category":"objects","moji":"🔌","description":"electric plug","unicodeVersion":"6.0","digest":"b10ce87af86fa4f4022572ceb5ecd73bea867347a86832a7ea248364b0aad8d0"},"elephant":{"category":"nature","moji":"🐘","description":"elephant","unicodeVersion":"6.0","digest":"b7750f4b013fbd28ac5330e1694ef4d3b4a9c6fc7b807879db0c24b035a16c29"},"end":{"category":"symbols","moji":"🔚","description":"end with leftwards arrow above","unicodeVersion":"6.0","digest":"dd93aee6986eb637a8b58f234da47568b88525599f73246e322af030351997a2"},"envelope":{"category":"objects","moji":"✉","description":"envelope","unicodeVersion":"1.1","digest":"f5a512022a2f5280f372ff39c22cbda815f698710ca66f8f8c4d08418f98ca78"},"envelope_with_arrow":{"category":"objects","moji":"📩","description":"envelope with downwards arrow above","unicodeVersion":"6.0","digest":"f8643212e6a94f58ccf2bcedc54c5fda8ebeab274f4a8803f253de5f50ddb1d6"},"euro":{"category":"objects","moji":"💶","description":"banknote with euro sign","unicodeVersion":"6.0","digest":"3af3e223e8f26468a94f6f5c17198432656e8d20b3bab31566c2b5a86e717df4"},"european_castle":{"category":"travel","moji":"🏰","description":"european castle","unicodeVersion":"6.0","digest":"21082d0be7e3b2794e59ff0170da0cfe42a9b734cf02704603e3b52ff48202ba"},"european_post_office":{"category":"travel","moji":"🏤","description":"european post office","unicodeVersion":"6.0","digest":"02b4c7602939f0cb9cb2b4e05996bcdb6bd93cf8025c2ea02db8cbe13ca397d0"},"evergreen_tree":{"category":"nature","moji":"🌲","description":"evergreen tree","unicodeVersion":"6.0","digest":"74b226098e66c0a94a92e0f22b9d631736e12dca72c34182c9d0ba56aa593172"},"exclamation":{"category":"symbols","moji":"❗","description":"heavy exclamation mark symbol","unicodeVersion":"5.2","digest":"45b87ae4593656d7da49ff5645fb6a2a18d582553295358da9f09f1ae8272445"},"expressionless":{"category":"people","moji":"😑","description":"expressionless face","unicodeVersion":"6.1","digest":"34e2a1c8121f4f0bc4ce33d226d8cc1a4ebf5260746df2b23e29eef24ee9372e"},"eye":{"category":"people","moji":"👁","description":"eye","unicodeVersion":"7.0","digest":"79ecff79c2edee630e72725b54e67ee2e96d24ca03fef2954a56a09c0a2227f8"},"eye_in_speech_bubble":{"category":"symbols","moji":"👁‍🗨","description":"eye in speech bubble","unicodeVersion":"7.0","digest":"c0050c026c2a3060723cab2df2603c1c7da7ed81faedb9ebe16cd89721928a55"},"eyeglasses":{"category":"people","moji":"👓","description":"eyeglasses","unicodeVersion":"6.0","digest":"d4a9585d6c43ef514a97c45c64607162e775a45544821f1470c6f8f25b93ab81"},"eyes":{"category":"people","moji":"👀","description":"eyes","unicodeVersion":"6.0","digest":"1d5cae0b9b2e51e1de54295685d7f0c72ee794e2e6335a95b1d056c7e77260e8"},"face_palm":{"category":"people","moji":"🤦","description":"face palm","unicodeVersion":"9.0","digest":"4ec873048b34b1bb34430724cf28e4bee6c0a9eee88ce39b9d1565047dc92420"},"face_palm_tone1":{"category":"people","moji":"🤦🏻","description":"face palm tone 1","unicodeVersion":"9.0","digest":"e93ef92b4c01dbea6c400e708e23dd36da92ccfbf5eb4f177b3b20c3a46bdc19"},"face_palm_tone2":{"category":"people","moji":"🤦🏼","description":"face palm tone 2","unicodeVersion":"9.0","digest":"22c8bf9fd9fa2ed9dca7a6397ed00ba6cfe9aeef2b0fb7b516ee4dda0df050ea"},"face_palm_tone3":{"category":"people","moji":"🤦🏽","description":"face palm tone 3","unicodeVersion":"9.0","digest":"c0b8bb9d2423e6787b6bdf1ca5a13f52853e4f48a9a1af0f2d4af1364fff022e"},"face_palm_tone4":{"category":"people","moji":"🤦🏾","description":"face palm tone 4","unicodeVersion":"9.0","digest":"f522ab186adcbb4549ea2c03500cdd7a86add548e43ebf7a54d58cc24deea072"},"face_palm_tone5":{"category":"people","moji":"🤦🏿","description":"face palm tone 5","unicodeVersion":"9.0","digest":"363507ae7178b5ec583635f47bcab10c897346f48b85d8759b1004c32cd8ad65"},"factory":{"category":"travel","moji":"🏭","description":"factory","unicodeVersion":"6.0","digest":"c7aeb61ed8b0ac5c91d5197c73f1e2bb801921c22a76bb82c7659d990680dcb0"},"fallen_leaf":{"category":"nature","moji":"🍂","description":"fallen leaf","unicodeVersion":"6.0","digest":"81fce04231d48db0e55f3697f930e9a7e3306bed5e35f1234e98c40a24ac5626"},"family":{"category":"people","moji":"👪","description":"family","unicodeVersion":"6.0","digest":"06f2ce63768ffe43b3d9b2a9660b34d043f37b3c91610dd62343ba21df8ecbe5"},"family_mmb":{"category":"people","moji":"👨‍👨‍👦","description":"family (man,man,boy)","unicodeVersion":"6.0","digest":"41a18405be796699a7eb7c36ab6f7d898e322749997f45387377acf5bb16a50f"},"family_mmbb":{"category":"people","moji":"👨‍👨‍👦‍👦","description":"family (man,man,boy,boy)","unicodeVersion":"6.0","digest":"87255d1d18c6971c8c083c818e598424c1bd717eed892478b7e9516639dbfb45"},"family_mmg":{"category":"people","moji":"👨‍👨‍👧","description":"family (man,man,girl)","unicodeVersion":"6.0","digest":"a132b1b8f10b318d8e23aee15dab4caa14528aeb3c89966d4bcc25fb54af72ad"},"family_mmgb":{"category":"people","moji":"👨‍👨‍👧‍👦","description":"family (man,man,girl,boy)","unicodeVersion":"6.0","digest":"eb2bc1966df406aaf38ce5a58db9324162799cdacf31f74f40e6384807a8efc2"},"family_mmgg":{"category":"people","moji":"👨‍👨‍👧‍👧","description":"family (man,man,girl,girl)","unicodeVersion":"6.0","digest":"24f3d60f98fbd6b687f7cacfb629390b90509a754036e5439ae5294759c0606b"},"family_mwbb":{"category":"people","moji":"👨‍👩‍👦‍👦","description":"family (man,woman,boy,boy)","unicodeVersion":"6.0","digest":"2f77692bcb9275c4df501b64a18401dcaf8c68b21f26fbdad59b1feab0c98fd1"},"family_mwg":{"category":"people","moji":"👨‍👩‍👧","description":"family (man,woman,girl)","unicodeVersion":"6.0","digest":"1a976d13127665d9386cebfdb24e5572dc499bda484c0ee05585886edc616130"},"family_mwgb":{"category":"people","moji":"👨‍👩‍👧‍👦","description":"family (man,woman,girl,boy)","unicodeVersion":"6.0","digest":"960ec2cbac13ef208e73644cd36711b83e6c070c36950f834f3669812839b7f8"},"family_mwgg":{"category":"people","moji":"👨‍👩‍👧‍👧","description":"family (man,woman,girl,girl)","unicodeVersion":"6.0","digest":"8353b03dfa5c24aba75a0abdfdac01603f593819d54b4c7f2f88aafb31da0c6a"},"family_wwb":{"category":"people","moji":"👩‍👩‍👦","description":"family (woman,woman,boy)","unicodeVersion":"6.0","digest":"07a5dd397718c553573689f6512f386729c13a12d5dc78be47c06405769cd98a"},"family_wwbb":{"category":"people","moji":"👩‍👩‍👦‍👦","description":"family (woman,woman,boy,boy)","unicodeVersion":"6.0","digest":"b627f460f1da0d47b0b662402940b2b77c9538d380d05436dfca4b456c50c939"},"family_wwg":{"category":"people","moji":"👩‍👩‍👧","description":"family (woman,woman,girl)","unicodeVersion":"6.0","digest":"2d6f373bed53f1028f0fbe9caf036465a351f37b9e00fca7d722cc5a1984f251"},"family_wwgb":{"category":"people","moji":"👩‍👩‍👧‍👦","description":"family (woman,woman,girl,boy)","unicodeVersion":"6.0","digest":"72be5c85e1621f73d6794edd6e428febdb366b9e4c816f7829897fd1ab34642b"},"family_wwgg":{"category":"people","moji":"👩‍👩‍👧‍👧","description":"family (woman,woman,girl,girl)","unicodeVersion":"6.0","digest":"c39e0916069460d2d9741bddf58e76f5d6a09254cba0eeb262345adf8630bc32"},"fast_forward":{"category":"symbols","moji":"⏩","description":"black right-pointing double triangle","unicodeVersion":"6.0","digest":"e7d2d8085cfd406c2b096e8dd147dd3722290a5727b1f7df185989526a2335ec"},"fax":{"category":"objects","moji":"📠","description":"fax machine","unicodeVersion":"6.0","digest":"ff85ffa440c5379c9b138ebe2d7912d6098da3b37a051b80442d5557b7f993b0"},"fearful":{"category":"people","moji":"😨","description":"fearful face","unicodeVersion":"6.0","digest":"b72bdf7d075d5c4e38bbd8512fb45fda2e85c9c8732a47e67575ae9f2ed4c5df"},"feet":{"category":"nature","moji":"🐾","description":"paw prints","unicodeVersion":"6.0","digest":"45aca538d3a9831a0c7de491e5656c17705c07b8f4ac8e85254656b608976016"},"fencer":{"category":"activity","moji":"🤺","description":"fencer","unicodeVersion":"9.0","digest":"5db00fa456af9f6c7cb88d300579dd63e426bcb97ad25486b664aff25c688e21"},"ferris_wheel":{"category":"travel","moji":"🎡","description":"ferris wheel","unicodeVersion":"6.0","digest":"24b4551b7b79a2a5fd73de61542f2b444f896a52030c5f29791c8fcfcc28b95c"},"ferry":{"category":"travel","moji":"⛴","description":"ferry","unicodeVersion":"5.2","digest":"5002a72af2e3c4cef9a36ad5987aeed7d99f96bfd13e56f78957315ec7e749a3"},"field_hockey":{"category":"activity","moji":"🏑","description":"field hockey stick and ball","unicodeVersion":"8.0","digest":"4ee091d96161ba719ab8fd6f2b03f96d902a6f22cffe0563b930618bb8ac2b67"},"file_cabinet":{"category":"objects","moji":"🗄","description":"file cabinet","unicodeVersion":"7.0","digest":"92914147bf93e6d64271ff99d217a18a9850a367d08a5f9f458ecf9311a5bbe9"},"file_folder":{"category":"objects","moji":"📁","description":"file folder","unicodeVersion":"6.0","digest":"62a42a929267cfbfdb795ead381c9657c343458bc5fca95ea8a0ab892c61d4f6"},"film_frames":{"category":"objects","moji":"🎞","description":"film frames","unicodeVersion":"7.0","digest":"4da212148cadb9c4ea91e60d2d8316e38cea99ef4f14afc023711dd7c54ade5a"},"fingers_crossed":{"category":"people","moji":"🤞","description":"hand with first and index finger crossed","unicodeVersion":"9.0","digest":"a5c797ead191b9712e185083266b455cdf09f6a34c10f8c51aa145e6073427e1"},"fingers_crossed_tone1":{"category":"people","moji":"🤞🏻","description":"hand with index and middle fingers crossed tone 1","unicodeVersion":"9.0","digest":"db56d47bf887f2d8459a3aaba23f15c0087234ae5a54125052e7046e034a4988"},"fingers_crossed_tone2":{"category":"people","moji":"🤞🏼","description":"hand with index and middle fingers crossed tone 2","unicodeVersion":"9.0","digest":"19f1bcca3991db7ed2037278c0baab6cd7f12aeaf2e0074de402c4d9e45c1899"},"fingers_crossed_tone3":{"category":"people","moji":"🤞🏽","description":"hand with index and middle fingers crossed tone 3","unicodeVersion":"9.0","digest":"895a3314f6a310f31f7e728bcca20ff834fbfac62ce00e27e3ea5ad0dfc1ba35"},"fingers_crossed_tone4":{"category":"people","moji":"🤞🏾","description":"hand with index and middle fingers crossed tone 4","unicodeVersion":"9.0","digest":"fcb5c4de2001d23a5df1b8702624d134b7f94e93e2dcc8adf6c1033c77722b0e"},"fingers_crossed_tone5":{"category":"people","moji":"🤞🏿","description":"hand with index and middle fingers crossed tone 5","unicodeVersion":"9.0","digest":"50132c78d530b048c21be4e788b446872a79b3b3a91009db12f4021c44c8469d"},"fire":{"category":"nature","moji":"🔥","description":"fire","unicodeVersion":"6.0","digest":"b3e67c913903d900f5e50e7e7e4d7e9370bb6ceedfbee548be39e4c9e4b69416"},"fire_engine":{"category":"travel","moji":"🚒","description":"fire engine","unicodeVersion":"6.0","digest":"c3a518f27d625e3b62dffa227eb82764bf0a147f10ec0e7f4f43f3f96751af20"},"fireworks":{"category":"travel","moji":"🎆","description":"fireworks","unicodeVersion":"6.0","digest":"b62ae08a00c0cc6eba8f9666c8fd9946ce57c3cfc01fe99542a8690a4a566a65"},"first_place":{"category":"activity","moji":"🥇","description":"first place medal","unicodeVersion":"9.0","digest":"e3de5d9f14f05544dbee5965cc2baa20e7b417a488c8a18598979038860fd901"},"first_quarter_moon":{"category":"nature","moji":"🌓","description":"first quarter moon symbol","unicodeVersion":"6.0","digest":"a207ce93084448622a4a5c49c85c566a9fda6be7337c86a013eeb713fe47fd29"},"first_quarter_moon_with_face":{"category":"nature","moji":"🌛","description":"first quarter moon with face","unicodeVersion":"6.0","digest":"1d1f54a5075f2311bcc017c44898b9d8c58edc13b298d58c238fff9ab8ee2ef3"},"fish":{"category":"nature","moji":"🐟","description":"fish","unicodeVersion":"6.0","digest":"8f62f08fbeaf39694c19816b5c7d4f292017fe5bf9f8dd7e40f1630f5f83b28b"},"fish_cake":{"category":"food","moji":"🍥","description":"fish cake with swirl design","unicodeVersion":"6.0","digest":"5a6ca2100c8830927b22afa6f1d2fc821f5692cd23507fe5a776f6e085cbbfb2"},"fishing_pole_and_fish":{"category":"activity","moji":"🎣","description":"fishing pole and fish","unicodeVersion":"6.0","digest":"f8fb84eccceec88321b0a2a46f732ecfc378f787c19c27ac1327735f1ca9a48b"},"fist":{"category":"people","moji":"✊","description":"raised fist","unicodeVersion":"6.0","digest":"557f96d85615b8d78436bc67266115bfc8556c97c14f7909dfda1cf134e8344f"},"fist_tone1":{"category":"people","moji":"✊🏻","description":"raised fist tone 1","unicodeVersion":"8.0","digest":"6c1b946f9e01abc39b5085e24e8b6077fc0e34188e8daa30c6a3adddd387413e"},"fist_tone2":{"category":"people","moji":"✊🏼","description":"raised fist tone 2","unicodeVersion":"8.0","digest":"e9b9e1ec638dca4d5e1519bca7338f58cce2f2a282ee4c3581e8643166fc415f"},"fist_tone3":{"category":"people","moji":"✊🏽","description":"raised fist tone 3","unicodeVersion":"8.0","digest":"8c14d24055c143960b3d2a27fe23c55d2d3ac5f84f87e4e876616235e8698c7f"},"fist_tone4":{"category":"people","moji":"✊🏾","description":"raised fist tone 4","unicodeVersion":"8.0","digest":"923f034f481e952e6e5d1664588f99f79bd5416d4197b0ade6621f2669ce5765"},"fist_tone5":{"category":"people","moji":"✊🏿","description":"raised fist tone 5","unicodeVersion":"8.0","digest":"d691d2902216080916a29047e07d7a5bf2aed07e062067ca9d01cbf6fdf48c8d"},"five":{"category":"symbols","moji":"5️⃣","description":"keycap digit five","unicodeVersion":"3.0","digest":"8f03f62fdbf744ae49c8a60fbf715ebfccbd6b62d91148e0923907006f3c2726"},"flag_ac":{"category":"flags","moji":"🇦🇨","description":"ascension","unicodeVersion":"6.0","digest":"2e5c08535dc8ea96422d56a36b4fffc0b3bd2a13f2ab0d8dbd0e3a29bf3fc40c"},"flag_ad":{"category":"flags","moji":"🇦🇩","description":"andorra","unicodeVersion":"6.0","digest":"184fdcf790b8e2fd851b2b2b32f8636c595dd289734d12dc01ae4aa177e2043a"},"flag_ae":{"category":"flags","moji":"🇦🇪","description":"the united arab emirates","unicodeVersion":"6.0","digest":"4a3257a9ce118e97567e76280f24d60fb555f1bada2eb26a2442a47f9398d21e"},"flag_af":{"category":"flags","moji":"🇦🇫","description":"afghanistan","unicodeVersion":"6.0","digest":"0f6c719cac7ab3140694f6b580787ecdbf503e38f16de7ec5803f7d06a088ec3"},"flag_ag":{"category":"flags","moji":"🇦🇬","description":"antigua and barbuda","unicodeVersion":"6.0","digest":"92bf5a0e74564739862e9ba79331ffa656b7bae2ace0fc8dfd288984e4d510d4"},"flag_ai":{"category":"flags","moji":"🇦🇮","description":"anguilla","unicodeVersion":"6.0","digest":"aeaadc7ffafd8a1e01fdabc69d35f725d5f737b4c284a36191d96729f4e66e8f"},"flag_al":{"category":"flags","moji":"🇦🇱","description":"albania","unicodeVersion":"6.0","digest":"5ce7866d214d18c5f3438d480d14e77d104c4de679f0fdfca8cf0a44ce48eeea"},"flag_am":{"category":"flags","moji":"🇦🇲","description":"armenia","unicodeVersion":"6.0","digest":"b40f5705f0cf9ef0fa7ffff0b371c4099319001ce79f894c317912f4dc5de4c8"},"flag_ao":{"category":"flags","moji":"🇦🇴","description":"angola","unicodeVersion":"6.0","digest":"eab6fbc1824d6e3cd152e8ec1d82e1beaebe02b53b35c6f7a883b8548af02f3a"},"flag_aq":{"category":"flags","moji":"🇦🇶","description":"antarctica","unicodeVersion":"6.0","digest":"367f6677a683a5f0e7248ab3a8f46d06ba146a0fd75004c70bac0e913147cdaa"},"flag_ar":{"category":"flags","moji":"🇦🇷","description":"argentina","unicodeVersion":"6.0","digest":"f0dc466b3216957f2679d7208c2d7cf288448b0739b9270a7c5fa717577bdf25"},"flag_as":{"category":"flags","moji":"🇦🇸","description":"american samoa","unicodeVersion":"6.0","digest":"fcb7a865c7763c63b23485cc27207b99a3a8492e83d5b5ee2df259a9f68f77d6"},"flag_at":{"category":"flags","moji":"🇦🇹","description":"austria","unicodeVersion":"6.0","digest":"1d3d58e9abc034f9a093a94716eddf9811d54dfaf27969fd322b3809fac70217"},"flag_au":{"category":"flags","moji":"🇦🇺","description":"australia","unicodeVersion":"6.0","digest":"789563b64c71a5ad49078d335dc166ef614edb56d1e401885d32fb191c198fbd"},"flag_aw":{"category":"flags","moji":"🇦🇼","description":"aruba","unicodeVersion":"6.0","digest":"1504dc3fd8457b44fdf75c15e136dc46a13e8342d1f98949728cdc1238843e0c"},"flag_ax":{"category":"flags","moji":"🇦🇽","description":"åland islands","unicodeVersion":"6.0","digest":"e96fa3525f3be25016a4cf8428261735f3ed5fc9fe5b827b461746a3f08877bf"},"flag_az":{"category":"flags","moji":"🇦🇿","description":"azerbaijan","unicodeVersion":"6.0","digest":"12c366ac2c38b91314fb29056e09fa6e7417766cebde3045859cdb127549f4a2"},"flag_ba":{"category":"flags","moji":"🇧🇦","description":"bosnia and herzegovina","unicodeVersion":"6.0","digest":"0819ea3901510ac20c7f10e67e5f6c818210f17a362c1d12e299c41feb07f828"},"flag_bb":{"category":"flags","moji":"🇧🇧","description":"barbados","unicodeVersion":"6.0","digest":"cf32778a272ed6cbc8e783b59befd9b204009c69c61a425e148d867808b7fab9"},"flag_bd":{"category":"flags","moji":"🇧🇩","description":"bangladesh","unicodeVersion":"6.0","digest":"e6ed186644a874588e879513aec92f8107220dcdd14c766dee61f266ce045665"},"flag_be":{"category":"flags","moji":"🇧🇪","description":"belgium","unicodeVersion":"6.0","digest":"4d941011d15d9f6e755d6f7694884758baf17ac0691bf5d63700f8d6dbcdb948"},"flag_bf":{"category":"flags","moji":"🇧🇫","description":"burkina faso","unicodeVersion":"6.0","digest":"fcc57dbda9a86f725f558b6c6309484c97e65f1644aae4f9fb5e642681f6c2e0"},"flag_bg":{"category":"flags","moji":"🇧🇬","description":"bulgaria","unicodeVersion":"6.0","digest":"816c47ed96c36c90723da150645902ea8ba18b44757fdd776c7b3542cfecfb18"},"flag_bh":{"category":"flags","moji":"🇧🇭","description":"bahrain","unicodeVersion":"6.0","digest":"2cd5c21775a6e73f59d08c9ee0cedf4e8241e562eab939573501d47681987737"},"flag_bi":{"category":"flags","moji":"🇧🇮","description":"burundi","unicodeVersion":"6.0","digest":"2da82acbec5518360633c1b0b56d55a79b67237f67d92af5e5cd75a2f3bd550e"},"flag_bj":{"category":"flags","moji":"🇧🇯","description":"benin","unicodeVersion":"6.0","digest":"8fe8c34651eb4e28ab395261a5b72b6f37579535ed676d15de131914e19c0436"},"flag_bl":{"category":"flags","moji":"🇧🇱","description":"saint barthélemy","unicodeVersion":"6.0","digest":"d37f2a215ee7ef5b5ab62d2a0c87e90553b17c6ee310f803a71e9fd72db880e7"},"flag_black":{"category":"objects","moji":"🏴","description":"waving black flag","unicodeVersion":"6.0","digest":"3740bfc9bcb3b46b697b8b7c47ab2c3e95eca9dbcba12f2bf98a01302704f203"},"flag_bm":{"category":"flags","moji":"🇧🇲","description":"bermuda","unicodeVersion":"6.0","digest":"ccd21655573f3c955d616c5c7b1eac2be1d4772ff611648d6713ba55d9e4aa9b"},"flag_bn":{"category":"flags","moji":"🇧🇳","description":"brunei","unicodeVersion":"6.0","digest":"54330c3d7a37392e69098c213fd8c78f3faab4e7e5909c039188110422514228"},"flag_bo":{"category":"flags","moji":"🇧🇴","description":"bolivia","unicodeVersion":"6.0","digest":"32aff973b26f4f91ca19dddd7861b564da43cfbee87603d8c004f1111342366c"},"flag_bq":{"category":"flags","moji":"🇧🇶","description":"caribbean netherlands","unicodeVersion":"6.0","digest":"b1ebc959c43f706ca430d8633d9efaa9c60133871506b5f030b730cfb4c19e6f"},"flag_br":{"category":"flags","moji":"🇧🇷","description":"brazil","unicodeVersion":"6.0","digest":"64fb154d71fa34ff4838bc405f3e58a4102cf0cb49ca4b06fc3c7a6bf39671f0"},"flag_bs":{"category":"flags","moji":"🇧🇸","description":"the bahamas","unicodeVersion":"6.0","digest":"c4b07e5f652ab06ece95d3774ce8b1399a935f8a28d440cb13cc8bd0b9728ed5"},"flag_bt":{"category":"flags","moji":"🇧🇹","description":"bhutan","unicodeVersion":"6.0","digest":"901ddbd999dd89a87c1e1208b1470cb4e604a9bc023d0cbcdee64e1bc54079ba"},"flag_bv":{"category":"flags","moji":"🇧🇻","description":"bouvet island","unicodeVersion":"6.0","digest":"bbf6daa6174c6fbbbf541c8274f31b6757c3a16007c2687015ea041fd1e2c6b6"},"flag_bw":{"category":"flags","moji":"🇧🇼","description":"botswana","unicodeVersion":"6.0","digest":"05aa351bc04dc0fe2669441ab500e000d48b1f0d7ad9e885c7abfb898aa0eb3f"},"flag_by":{"category":"flags","moji":"🇧🇾","description":"belarus","unicodeVersion":"6.0","digest":"6eda3b87336ecf0aae4963986d86b916a055d8268c70520303288f235a93b0d9"},"flag_bz":{"category":"flags","moji":"🇧🇿","description":"belize","unicodeVersion":"6.0","digest":"d76ed945b1408558a30a99b8eed6712de968fc49fba1721b5660b8f48087e45a"},"flag_ca":{"category":"flags","moji":"🇨🇦","description":"canada","unicodeVersion":"6.0","digest":"2fd036047d89751c05de5577909b58347883bc89c3b7d90bec28ad4770a98ecd"},"flag_cc":{"category":"flags","moji":"🇨🇨","description":"cocos (keeling) islands","unicodeVersion":"6.0","digest":"837ba181a01c71f05d438d205efaaee99f93b2370c97b13e6132f99860323e36"},"flag_cd":{"category":"flags","moji":"🇨🇩","description":"the democratic republic of the congo","unicodeVersion":"6.0","digest":"318689274b4b3b58aed7fc1654127499a9da69bff1b83e592e86e69d167ce16f"},"flag_cf":{"category":"flags","moji":"🇨🇫","description":"central african republic","unicodeVersion":"6.0","digest":"06d6042849d3b7b217c2b18ba787aae449e8c7d2537e2e5974744ec196062228"},"flag_cg":{"category":"flags","moji":"🇨🇬","description":"the republic of the congo","unicodeVersion":"6.0","digest":"09f45d2dcb5a24d8349ef86e7405cc29ef3d65a908c0bff3221c3b4546547813"},"flag_ch":{"category":"flags","moji":"🇨🇭","description":"switzerland","unicodeVersion":"6.0","digest":"53d6d35aeeebb0b4b1ad858dc3691e649ac73d30b3be76f96d5fe9605fa99386"},"flag_ci":{"category":"flags","moji":"🇨🇮","description":"cote d'ivoire","unicodeVersion":"6.0","digest":"7d85a0c314b7397c9397a54ce2f3a4dc5f40d0234e586dbd8a541a8666f0f51e"},"flag_ck":{"category":"flags","moji":"🇨🇰","description":"cook islands","unicodeVersion":"6.0","digest":"c1aa105fe106ed09ed59a596859a0ce4e65a415c59f63df51961491cb947b136"},"flag_cl":{"category":"flags","moji":"🇨🇱","description":"chile","unicodeVersion":"6.0","digest":"0fffdad0d892f5c08aaa332af1ed2c228583d89a43190e979a3c3cb020d5a723"},"flag_cm":{"category":"flags","moji":"🇨🇲","description":"cameroon","unicodeVersion":"6.0","digest":"e9f55e41a1fd2735a82ad7a7ac39326a944cb20423ffba3608ac53a46036caad"},"flag_cn":{"category":"flags","moji":"🇨🇳","description":"china","unicodeVersion":"6.0","digest":"e2c8fee7e3bd51b13d6083d5bf344abe6b9b642e3cbb099d38b4ce341c99d890"},"flag_co":{"category":"flags","moji":"🇨🇴","description":"colombia","unicodeVersion":"6.0","digest":"51c60d0979bf8342eaff7cda9faf4b0dfab38efaf5ddf3717eb8f0e2a595b15f"},"flag_cp":{"category":"flags","moji":"🇨🇵","description":"clipperton island","unicodeVersion":"6.0","digest":"a0124683aa88cd7da886da70c65796c5ad84eb3751e356e9b2aa8ac249cf0bf9"},"flag_cr":{"category":"flags","moji":"🇨🇷","description":"costa rica","unicodeVersion":"6.0","digest":"907905971b219e617a34eef4839b0bd08d98f3480e2631bce523120dcef95196"},"flag_cu":{"category":"flags","moji":"🇨🇺","description":"cuba","unicodeVersion":"6.0","digest":"d88cea729dc9dbbbcadac0409ec561995f061b2280577c01c6c6b37de347f150"},"flag_cv":{"category":"flags","moji":"🇨🇻","description":"cape verde","unicodeVersion":"6.0","digest":"5ce97944adfce09e96387e6f872256482ac99ccbc60017c4d58ddd15b6fb67a7"},"flag_cw":{"category":"flags","moji":"🇨🇼","description":"curaçao","unicodeVersion":"6.0","digest":"a6fc31bd66ddc2ee8e7bde3aeabfe1c4ad00c9688abae234a541cc1236d68c1b"},"flag_cx":{"category":"flags","moji":"🇨🇽","description":"christmas island","unicodeVersion":"6.0","digest":"1261b32bfa22fa1441f5390ff499ac6b921d7ac59cc8acda3deb3a2beb4fb345"},"flag_cy":{"category":"flags","moji":"🇨🇾","description":"cyprus","unicodeVersion":"6.0","digest":"82b1baa05ecffa0ea1f9a83b518163cbd7910985a21955740520bb16b7bb624f"},"flag_cz":{"category":"flags","moji":"🇨🇿","description":"the czech republic","unicodeVersion":"6.0","digest":"a169b18968992a52299b67c24fba495e84de28dec2ebb947a08e0d615ac54a5a"},"flag_de":{"category":"flags","moji":"🇩🇪","description":"germany","unicodeVersion":"6.0","digest":"99d1906944966a188c72ae592362ed907e2a0bfe95263955c34a0941507b30c1"},"flag_dg":{"category":"flags","moji":"🇩🇬","description":"diego garcia","unicodeVersion":"6.0","digest":"dd45e1afe792fca57d4161434bf611bcb7170072d63e4a27fb9dcd6e8912621e"},"flag_dj":{"category":"flags","moji":"🇩🇯","description":"djibouti","unicodeVersion":"6.0","digest":"e90ba4e98fca71ff0ca5e65c28b911cc52f043428f375d8f954ecbd3b0c8f4dd"},"flag_dk":{"category":"flags","moji":"🇩🇰","description":"denmark","unicodeVersion":"6.0","digest":"65b3b5f31935a4969d81fedbb8279c7ad32da454d15c5eafcceba5d140927c77"},"flag_dm":{"category":"flags","moji":"🇩🇲","description":"dominica","unicodeVersion":"6.0","digest":"f6225ded6d2cfd6c182ab1a53b8c49dc9df195df11eb7ff27b15f5d3721ba0eb"},"flag_do":{"category":"flags","moji":"🇩🇴","description":"the dominican republic","unicodeVersion":"6.0","digest":"dc2ad6856cebbe47c5bd7f5dcf087e4f680d396b2d49440a9b71f0ad49fb8102"},"flag_dz":{"category":"flags","moji":"🇩🇿","description":"algeria","unicodeVersion":"6.0","digest":"ea69fffc4d545f9c0fcef6768257501952955ba4d274c9b81843229a1265c5ed"},"flag_ea":{"category":"flags","moji":"🇪🇦","description":"ceuta, melilla","unicodeVersion":"6.0","digest":"e63bfe15428c481dd23b569e7aaf0a76106e58a946995b4415a81097ecd53b7d"},"flag_ec":{"category":"flags","moji":"🇪🇨","description":"ecuador","unicodeVersion":"6.0","digest":"0cdabf85cd567047fda1d9a4508220cab829943a7c542c315078db0aac33edac"},"flag_ee":{"category":"flags","moji":"🇪🇪","description":"estonia","unicodeVersion":"6.0","digest":"6dc4e3377e8e2af3ff40cf940a914bc7840980b4a14e7da86954343f2b1025fe"},"flag_eg":{"category":"flags","moji":"🇪🇬","description":"egypt","unicodeVersion":"6.0","digest":"2ed6bc056015694d75993eb5ee3c1850921d5630681207b04dfbdb982ab346a2"},"flag_eh":{"category":"flags","moji":"🇪🇭","description":"western sahara","unicodeVersion":"6.0","digest":"72adb55943e4df99c00843c65463718609d937480f73dcf4a4451d46b9967a5e"},"flag_er":{"category":"flags","moji":"🇪🇷","description":"eritrea","unicodeVersion":"6.0","digest":"3fa59331eb5300c8c1f7b1f1bc15cfcfe688da6fa4a79341854598086a44eebc"},"flag_es":{"category":"flags","moji":"🇪🇸","description":"spain","unicodeVersion":"6.0","digest":"1fa1d5cb0a7e8b14aaec758b2e7bf49cdf8f3d09bbcc7dfd589053a432eeae25"},"flag_et":{"category":"flags","moji":"🇪🇹","description":"ethiopia","unicodeVersion":"6.0","digest":"72771decfb214394e4beb594e848ea590c3615800adbba24b5df4c5db6ee9617"},"flag_eu":{"category":"flags","moji":"🇪🇺","description":"european union","unicodeVersion":"6.0","digest":"4bfa1b2ef23764ead5ef7899806f93e13fd29a09c75e61431579a4116c836aa4"},"flag_fi":{"category":"flags","moji":"🇫🇮","description":"finland","unicodeVersion":"6.0","digest":"d0208cdd5b153a2865f9f674179c62871d4675abb0fb639fba88fcd62553f54e"},"flag_fj":{"category":"flags","moji":"🇫🇯","description":"fiji","unicodeVersion":"6.0","digest":"6c5ec41114af3846b093a418f6e2b5ff7a83cb72cecde75a7dc62e8cb6dcfe45"},"flag_fk":{"category":"flags","moji":"🇫🇰","description":"falkland islands","unicodeVersion":"6.0","digest":"c69ad641d53785deff5c3934b7dcfcd3dc32ffc31b6d3e799d0555b03c23fc15"},"flag_fm":{"category":"flags","moji":"🇫🇲","description":"micronesia","unicodeVersion":"6.0","digest":"1e29fb06b273f253c23a9e4aa8ff84bfe22cffb5fa158a0c6f4cdeabe0216990"},"flag_fo":{"category":"flags","moji":"🇫🇴","description":"faroe islands","unicodeVersion":"6.0","digest":"f4907d2f606f4f9d3bef06c6d38e8e88f2a148197b1573668866431a007afc2e"},"flag_fr":{"category":"flags","moji":"🇫🇷","description":"france","unicodeVersion":"6.0","digest":"5a1308ab3cbf6bffcab12588cf3325151a6c72990db7408c2b8605d89f94ed6e"},"flag_ga":{"category":"flags","moji":"🇬🇦","description":"gabon","unicodeVersion":"6.0","digest":"ddc32dee2976507be878ec3d3d2408632ca21bc434cd9f58db4f6ac9774a2db5"},"flag_gb":{"category":"flags","moji":"🇬🇧","description":"great britain","unicodeVersion":"6.0","digest":"6b3bb254d134870b02cb066b06e206f652638a915c84b8649ceb30ec67fbebde"},"flag_gd":{"category":"flags","moji":"🇬🇩","description":"grenada","unicodeVersion":"6.0","digest":"b6a210541ca22d816405f2a7d0d5241dc4d5488c8a36e15bd1e3063f9c41327f"},"flag_ge":{"category":"flags","moji":"🇬🇪","description":"georgia","unicodeVersion":"6.0","digest":"e9a5035b7a46b925737e7f7b0ae2419cc4af0e980fbee5bd916edeef13823367"},"flag_gf":{"category":"flags","moji":"🇬🇫","description":"french guiana","unicodeVersion":"6.0","digest":"ce1bcd8c303897c1c22c5994182f21240b4aa635f0d7ce9944f76cbdbf0e4956"},"flag_gg":{"category":"flags","moji":"🇬🇬","description":"guernsey","unicodeVersion":"6.0","digest":"a435aab3609533ab2d68acd97deba844bfb0fc27b2adac68668223011f23ae5d"},"flag_gh":{"category":"flags","moji":"🇬🇭","description":"ghana","unicodeVersion":"6.0","digest":"7cad43b40f69b9b00cc1b38036789ce774fd3d597c89f0bf38433847ea69be26"},"flag_gi":{"category":"flags","moji":"🇬🇮","description":"gibraltar","unicodeVersion":"6.0","digest":"70e9b17d18bf3e0e4d03f4f824323a57909416e4082ca9d8a0796a6959de4f07"},"flag_gl":{"category":"flags","moji":"🇬🇱","description":"greenland","unicodeVersion":"6.0","digest":"1963d8cca1c1f06b7536b7fb8f5a4782ac0bb05afdf6e481101bce45c58cdd4b"},"flag_gm":{"category":"flags","moji":"🇬🇲","description":"the gambia","unicodeVersion":"6.0","digest":"6c776a8daa3f4daa2597b0025aec06fc0a53aed262e845d4da3897cd7a89c6a1"},"flag_gn":{"category":"flags","moji":"🇬🇳","description":"guinea","unicodeVersion":"6.0","digest":"134cf7c839370d171ae80a72e5d18d32ea1967df19c191d1a4ea446d649e9558"},"flag_gp":{"category":"flags","moji":"🇬🇵","description":"guadeloupe","unicodeVersion":"6.0","digest":"be3e906b039ba4884053c78f4f14de9aa87c5573860ccb69ec766068ae3887c2"},"flag_gq":{"category":"flags","moji":"🇬🇶","description":"equatorial guinea","unicodeVersion":"6.0","digest":"d476059c4ab41f5a1ef88583087362a5bc57cede930126f37041d1546564ab70"},"flag_gr":{"category":"flags","moji":"🇬🇷","description":"greece","unicodeVersion":"6.0","digest":"b9fa9304647aaa08167a07858bb18d778dcc399375f86f580b8d4244794678bc"},"flag_gs":{"category":"flags","moji":"🇬🇸","description":"south georgia","unicodeVersion":"6.0","digest":"de33fbef6e294eb7af36e5b94d8ff573b354a4ff1ebdccf50ca528b86ed601d9"},"flag_gt":{"category":"flags","moji":"🇬🇹","description":"guatemala","unicodeVersion":"6.0","digest":"4160843e5d642df597c8423eb8e3b74deafe304f3d141c8a4d2fc07509e44832"},"flag_gu":{"category":"flags","moji":"🇬🇺","description":"guam","unicodeVersion":"6.0","digest":"3b0cb257ba5b1c3e15d9102410c5f7418da03372e91ce90513de25b9f45283e3"},"flag_gw":{"category":"flags","moji":"🇬🇼","description":"guinea-bissau","unicodeVersion":"6.0","digest":"bdf07a8f93c0f0a573af5f5361be404a3ba65b729c1a4c05b7632c03d85efc72"},"flag_gy":{"category":"flags","moji":"🇬🇾","description":"guyana","unicodeVersion":"6.0","digest":"b47d8c98b747556f827ad0d1169264eb68ecaf9d2fb76595e8c31866361cbfc6"},"flag_hk":{"category":"flags","moji":"🇭🇰","description":"hong kong","unicodeVersion":"6.0","digest":"8e5a54b2e4bd4f5182085299b9648062463da05d535cf0e46a7d9c58eaeb171f"},"flag_hm":{"category":"flags","moji":"🇭🇲","description":"heard island and mcdonald islands","unicodeVersion":"6.0","digest":"63c3e080c5e82a72c6d4cf5997ac823dc02184719ec59aadea6dd41b127abf22"},"flag_hn":{"category":"flags","moji":"🇭🇳","description":"honduras","unicodeVersion":"6.0","digest":"87c1d160db810b5ed208fb33add54f96c17b0f08d87b81f6f09429abf6ec93ac"},"flag_hr":{"category":"flags","moji":"🇭🇷","description":"croatia","unicodeVersion":"6.0","digest":"8b68112f79baea38565673acf4f1cb90675a5829ff17e4cf9415c928b62aed88"},"flag_ht":{"category":"flags","moji":"🇭🇹","description":"haiti","unicodeVersion":"6.0","digest":"05dbd548c310ef1ebd1724aa85d821f8320106b16ddbf1f6442ea37e4407d5e1"},"flag_hu":{"category":"flags","moji":"🇭🇺","description":"hungary","unicodeVersion":"6.0","digest":"5079f3d6f1459e6df8dda5c19d2367ead8f5a755b8874ac999bae58e3c9f47a7"},"flag_ic":{"category":"flags","moji":"🇮🇨","description":"canary islands","unicodeVersion":"6.0","digest":"8dcb18c4b75a60867a68d2f6edbf81e782aafb4b9a0404c8081f872dfe71e432"},"flag_id":{"category":"flags","moji":"🇮🇩","description":"indonesia","unicodeVersion":"6.0","digest":"1b0eb69a158ed3afe24be448d44751f95dcc5cbc7d1393a5753293f16ef0a66c"},"flag_ie":{"category":"flags","moji":"🇮🇪","description":"ireland","unicodeVersion":"6.0","digest":"5fc8c101ad7296224455f72f73c335aa4f676023b68645bafaf69087f69af390"},"flag_il":{"category":"flags","moji":"🇮🇱","description":"israel","unicodeVersion":"6.0","digest":"5aea4207415b7615dcdd69413705aefda700aefd0d27010cd0a0a338d879d9b8"},"flag_im":{"category":"flags","moji":"🇮🇲","description":"isle of man","unicodeVersion":"6.0","digest":"1ee9b3a5f1a52fc6d8369bfd81995fc0567e7a61deacd013701b3ec5fd64502e"},"flag_in":{"category":"flags","moji":"🇮🇳","description":"india","unicodeVersion":"6.0","digest":"202ede502f34d55d180726ac2f29141c6875516f1b3e7ee99f266b16c2fe4bfd"},"flag_io":{"category":"flags","moji":"🇮🇴","description":"british indian ocean territory","unicodeVersion":"6.0","digest":"dd45e1afe792fca57d4161434bf611bcb7170072d63e4a27fb9dcd6e8912621e"},"flag_iq":{"category":"flags","moji":"🇮🇶","description":"iraq","unicodeVersion":"6.0","digest":"bef294772b5ffccd6c061c19d60af66f61b248d78705faf347ade9ebfca2b46d"},"flag_ir":{"category":"flags","moji":"🇮🇷","description":"iran","unicodeVersion":"6.0","digest":"d4faca93577a5546330ab6a09252307e19fb420d89912c0b48ceb90bf409d48e"},"flag_is":{"category":"flags","moji":"🇮🇸","description":"iceland","unicodeVersion":"6.0","digest":"b2fc04226b274009b4d99d92bcb72b255b534b6fd4b76d82dce1575ad975a456"},"flag_it":{"category":"flags","moji":"🇮🇹","description":"italy","unicodeVersion":"6.0","digest":"735760f193855d55460a0fb93dad55ff67253cab63176eceb90b9bde1faead1e"},"flag_je":{"category":"flags","moji":"🇯🇪","description":"jersey","unicodeVersion":"6.0","digest":"671a487a60571d928d2abaf306d0a9ba50239ec54ada14ea29a9a99df658d3cc"},"flag_jm":{"category":"flags","moji":"🇯🇲","description":"jamaica","unicodeVersion":"6.0","digest":"fb9047199d030b78fc0dcfc58d9b524fdb929238d922809da88147b7cebf4211"},"flag_jo":{"category":"flags","moji":"🇯🇴","description":"jordan","unicodeVersion":"6.0","digest":"19f7d536d0293ebf3db49e05a158097cbde467115ef96523a0553808fd0b4178"},"flag_jp":{"category":"flags","moji":"🇯🇵","description":"japan","unicodeVersion":"6.0","digest":"51e971f777fe481ca9f7e077ecb2ce252c3cc0086b76384e7b965cdc337f3f9e"},"flag_ke":{"category":"flags","moji":"🇰🇪","description":"kenya","unicodeVersion":"6.0","digest":"0cec8f068548cfd3e7a20c10af84f97ca415fd6f8ab8b50783bf982e77d7260e"},"flag_kg":{"category":"flags","moji":"🇰🇬","description":"kyrgyzstan","unicodeVersion":"6.0","digest":"5803ea6ab028261923fd7570c670a50518c6f462a2fb4d463531b12c3e382e6f"},"flag_kh":{"category":"flags","moji":"🇰🇭","description":"cambodia","unicodeVersion":"6.0","digest":"287d357afe47179853fd485fb102834ead145598ed892664fc62d245cac16080"},"flag_ki":{"category":"flags","moji":"🇰🇮","description":"kiribati","unicodeVersion":"6.0","digest":"ae4aee0d9cd7a21d4e250d45a484f5f641acdab3d79b437337b25fe34a0b49b0"},"flag_km":{"category":"flags","moji":"🇰🇲","description":"the comoros","unicodeVersion":"6.0","digest":"2d1730acbf5421fd02bd5483e26a86d82ec2fa99f0ff75bfd728a9df7914ad3b"},"flag_kn":{"category":"flags","moji":"🇰🇳","description":"saint kitts and nevis","unicodeVersion":"6.0","digest":"b9ed979db9c6d243b00f61f19a9ec0f2c2390b2e5cace5ad61d9371dc8c670ac"},"flag_kp":{"category":"flags","moji":"🇰🇵","description":"north korea","unicodeVersion":"6.0","digest":"1bab0b9cab8028a95ce7231ad8d88ebcd31601cfa321284bba017ead47f6c729"},"flag_kr":{"category":"flags","moji":"🇰🇷","description":"korea","unicodeVersion":"6.0","digest":"33be8c09ebe273e203aa703cc827d52a6d9bf1699f5445bba13a77af2df45fa6"},"flag_kw":{"category":"flags","moji":"🇰🇼","description":"kuwait","unicodeVersion":"6.0","digest":"04d901a92ea55b13dc4983a9e3adb52dc89c9f3decee86fd06022aa902678b6d"},"flag_ky":{"category":"flags","moji":"🇰🇾","description":"cayman islands","unicodeVersion":"6.0","digest":"10f4d02f33cadd34da89de71a3b763809bad480cd9ae9d2ec000db026bd94cd1"},"flag_kz":{"category":"flags","moji":"🇰🇿","description":"kazakhstan","unicodeVersion":"6.0","digest":"dfaff69a78cf635f7fad41bd5bdcc8003298454708a6178ba7348b1b40c360c1"},"flag_la":{"category":"flags","moji":"🇱🇦","description":"laos","unicodeVersion":"6.0","digest":"4fcfbdc694cf99ae3f832500cdcdedb88c444b6df88bc9b7141f4f26ba3d5bfd"},"flag_lb":{"category":"flags","moji":"🇱🇧","description":"lebanon","unicodeVersion":"6.0","digest":"af4b1f784bea0ec7a712495491dffbd1152cc857a99fd433f76bfeb313819a62"},"flag_lc":{"category":"flags","moji":"🇱🇨","description":"saint lucia","unicodeVersion":"6.0","digest":"40784aa558b75d07ae499c004e2cc5d0b2efdfc3e5be705b5a9f6b70d681c396"},"flag_li":{"category":"flags","moji":"🇱🇮","description":"liechtenstein","unicodeVersion":"6.0","digest":"c4eb4c43f457ce60ff9d046adb512c1d3462203403eeb595bff3ebc010ed6633"},"flag_lk":{"category":"flags","moji":"🇱🇰","description":"sri lanka","unicodeVersion":"6.0","digest":"a5285cdfdc3715fa3941f5f0eb03dc425969eaaf22c719c27ab4418628d09bc5"},"flag_lr":{"category":"flags","moji":"🇱🇷","description":"liberia","unicodeVersion":"6.0","digest":"ed04334264953b4da570db8c392b99d2fab4e0b7efc2331427016c6a08e818be"},"flag_ls":{"category":"flags","moji":"🇱🇸","description":"lesotho","unicodeVersion":"6.0","digest":"cd56022106d027317cc9bf4c848758cf29ffe277ce71fdb9c1cf89ac4fd6e6db"},"flag_lt":{"category":"flags","moji":"🇱🇹","description":"lithuania","unicodeVersion":"6.0","digest":"3c4395b068e421100fd97a102f170cb8d5c093885eef7cb40d3faff4f4e47fe9"},"flag_lu":{"category":"flags","moji":"🇱🇺","description":"luxembourg","unicodeVersion":"6.0","digest":"df15a2c47eecad17e0cc169bdf0d31c6a51eb22de7ca4e70d2431359a33f930d"},"flag_lv":{"category":"flags","moji":"🇱🇻","description":"latvia","unicodeVersion":"6.0","digest":"9b53c6ce23287935200da8ca8a8af78013a4b1572f9821e7e1724cbad248e7e2"},"flag_ly":{"category":"flags","moji":"🇱🇾","description":"libya","unicodeVersion":"6.0","digest":"42efa9f3526ef006d6723fa17538a98ab9556ae25f14df1b06d21361bf7e1a44"},"flag_ma":{"category":"flags","moji":"🇲🇦","description":"morocco","unicodeVersion":"6.0","digest":"96c07296cfd7aa1cb642faed8ace26744105b81ca880157a4ef4caee0befe26e"},"flag_mc":{"category":"flags","moji":"🇲🇨","description":"monaco","unicodeVersion":"6.0","digest":"6b44608842fe849ae2b4bae5eb87ccd436459a427051dfda25080196273d4b9f"},"flag_md":{"category":"flags","moji":"🇲🇩","description":"moldova","unicodeVersion":"6.0","digest":"78c7b01c698873a9129d52ba38b3eb4cfc683ef2ae10b7b922b17c07f1c938c8"},"flag_me":{"category":"flags","moji":"🇲🇪","description":"montenegro","unicodeVersion":"6.0","digest":"01aa0f9df89302edc4ae319b5dd78069ba8807c3f38cc7bfe01bff67c8efd416"},"flag_mf":{"category":"flags","moji":"🇲🇫","description":"saint martin","unicodeVersion":"6.0","digest":"a0124683aa88cd7da886da70c65796c5ad84eb3751e356e9b2aa8ac249cf0bf9"},"flag_mg":{"category":"flags","moji":"🇲🇬","description":"madagascar","unicodeVersion":"6.0","digest":"56ebcd2a2e144d656d3b38a62595138fe6e50f9c1144f70b0a120cce7a72eb5b"},"flag_mh":{"category":"flags","moji":"🇲🇭","description":"the marshall islands","unicodeVersion":"6.0","digest":"008660adc4c2e4d04830498988184d1ef8a372a6c085da369a94ee6b820dbbb7"},"flag_mk":{"category":"flags","moji":"🇲🇰","description":"macedonia","unicodeVersion":"6.0","digest":"f3c4c5106ace81c21fc0c6a7cc5c5e04e9453468fbc6ccbc851bb8dd61ff237f"},"flag_ml":{"category":"flags","moji":"🇲🇱","description":"mali","unicodeVersion":"6.0","digest":"e70a6b30e46adc2e19684308a848fef2c3ad76e2cac4bb493ee3270ad39f9d1b"},"flag_mm":{"category":"flags","moji":"🇲🇲","description":"myanmar","unicodeVersion":"6.0","digest":"720f5d38887202ba049cd5a46c183679be6a01f169d99e6e656c73b515793a7d"},"flag_mn":{"category":"flags","moji":"🇲🇳","description":"mongolia","unicodeVersion":"6.0","digest":"5f0fd6fcb2ed73a5a6d9396c3703612503c1f16283bbb4e9362a1c8324b762ad"},"flag_mo":{"category":"flags","moji":"🇲🇴","description":"macau","unicodeVersion":"6.0","digest":"fc2a9e7323867cf195f551e59afdab778c56b84c96af28c20207c9870caa2c39"},"flag_mp":{"category":"flags","moji":"🇲🇵","description":"northern mariana islands","unicodeVersion":"6.0","digest":"ddce3be9d72914240c42e1b97ea97af01016d0a3879999cb0e447552682c06ba"},"flag_mq":{"category":"flags","moji":"🇲🇶","description":"martinique","unicodeVersion":"6.0","digest":"888f455b1322d6fb83dc9f469f5505fea3dd6ece77d17d0d7345319c3ebcec0e"},"flag_mr":{"category":"flags","moji":"🇲🇷","description":"mauritania","unicodeVersion":"6.0","digest":"72621914c92dd9c9f3ac9973ee3589583bfe42b841cdd35f47af75e2f629726c"},"flag_ms":{"category":"flags","moji":"🇲🇸","description":"montserrat","unicodeVersion":"6.0","digest":"5944996295132f41ec55261ff7927518bd47aec95d274a6ff257c357b43657bc"},"flag_mt":{"category":"flags","moji":"🇲🇹","description":"malta","unicodeVersion":"6.0","digest":"95f0550e8823441a4e69b26c540baea94f3ddcc282100fd0239021c00df0b469"},"flag_mu":{"category":"flags","moji":"🇲🇺","description":"mauritius","unicodeVersion":"6.0","digest":"5fda78a6df0ea7f5cac5fb4c8fd68529c14c5e15bac4e0b167493cb6ac459253"},"flag_mv":{"category":"flags","moji":"🇲🇻","description":"maldives","unicodeVersion":"6.0","digest":"f75c8f6fd3a68f2944a04c833c649d4b576997f491100cf3f3160fe77117fabb"},"flag_mw":{"category":"flags","moji":"🇲🇼","description":"malawi","unicodeVersion":"6.0","digest":"d46b484a97e5b90b6b259f8de1712b553f93f0dfb6391209200358bb9429ebf5"},"flag_mx":{"category":"flags","moji":"🇲🇽","description":"mexico","unicodeVersion":"6.0","digest":"dc57c10307fc0aa09bd7fcd25ee0fca561f3b382276faa8432a927c1baea53fd"},"flag_my":{"category":"flags","moji":"🇲🇾","description":"malaysia","unicodeVersion":"6.0","digest":"15ca00660a1eb0096fdaa00b85a7b95fcf192bf2ee4781ba72c36d2d2cb015ef"},"flag_mz":{"category":"flags","moji":"🇲🇿","description":"mozambique","unicodeVersion":"6.0","digest":"0c8605a9319dcf86672a833b4c4d6acea5f6aa25a3f8e1dfac78fbf7c452ba97"},"flag_na":{"category":"flags","moji":"🇳🇦","description":"namibia","unicodeVersion":"6.0","digest":"e63cde5ee49d3ada1e33d2ab15dc24fbb129b90d65b6fd1d7c07455f71a53601"},"flag_nc":{"category":"flags","moji":"🇳🇨","description":"new caledonia","unicodeVersion":"6.0","digest":"a4a350ce7404ba7bdda9a341e7a48fcfe16312be4964b1bd6eed7115acd2e329"},"flag_ne":{"category":"flags","moji":"🇳🇪","description":"niger","unicodeVersion":"6.0","digest":"6b32483b4445bc52855509f618c570b9c9606de5649e4878b71b44ff2acbc9fd"},"flag_nf":{"category":"flags","moji":"🇳🇫","description":"norfolk island","unicodeVersion":"6.0","digest":"96b1ec33acbd2b1ffe42703c11a2a633b036e6779849b0e6fa8f399167820584"},"flag_ng":{"category":"flags","moji":"🇳🇬","description":"nigeria","unicodeVersion":"6.0","digest":"f97d0630cbfa5e75440251df7529a67b58c22598643390cbeea82fb04a1cd956"},"flag_ni":{"category":"flags","moji":"🇳🇮","description":"nicaragua","unicodeVersion":"6.0","digest":"c52fb5f9134122a91defa75425be2c6b3c909e051d546244e0e7bdf5f9ee1710"},"flag_nl":{"category":"flags","moji":"🇳🇱","description":"the netherlands","unicodeVersion":"6.0","digest":"b8918f9c0c92513aa0ec6ba6cee5448270168cbe6f0a970fb06e7ceb9f52ec71"},"flag_no":{"category":"flags","moji":"🇳🇴","description":"norway","unicodeVersion":"6.0","digest":"05ce84095f8d93407d611b39d8b6a67fd9f11df6cfab7a185bcb4eec186d85ef"},"flag_np":{"category":"flags","moji":"🇳🇵","description":"nepal","unicodeVersion":"6.0","digest":"cc41c2f97ec2b38fe5781d553792f6aab5d37cc3be02586f361fe89d12683bee"},"flag_nr":{"category":"flags","moji":"🇳🇷","description":"nauru","unicodeVersion":"6.0","digest":"7837edf59ec33a25380d76afea5f04cfcab4f17df4e33fca0dcaacb517c5cbec"},"flag_nu":{"category":"flags","moji":"🇳🇺","description":"niue","unicodeVersion":"6.0","digest":"fd9ab45c6f32bc4da47542392e5beba73ddac302a4a9a00e6deedc913a4c087d"},"flag_nz":{"category":"flags","moji":"🇳🇿","description":"new zealand","unicodeVersion":"6.0","digest":"0719830dcca400cefb30ce399bb03f49dd84c9a98f7d6a28270f9278e2a7af75"},"flag_om":{"category":"flags","moji":"🇴🇲","description":"oman","unicodeVersion":"6.0","digest":"3f9039becd52e3454fdf7611cdb0d7fb1196e053eea29ef87daab6c21a94f1ee"},"flag_pa":{"category":"flags","moji":"🇵🇦","description":"panama","unicodeVersion":"6.0","digest":"1adf0e5d4084e072aa44bd9978829e77546e0be75785e9be69f92e326bd714a7"},"flag_pe":{"category":"flags","moji":"🇵🇪","description":"peru","unicodeVersion":"6.0","digest":"f8a4e257676f4ab8962ffe5509b8417777a8be2f0e9dc7735d3e014ff221aab1"},"flag_pf":{"category":"flags","moji":"🇵🇫","description":"french polynesia","unicodeVersion":"6.0","digest":"1ace6cc71d130cdf09246297740a911f14828c322e35330cc548ca5975015c23"},"flag_pg":{"category":"flags","moji":"🇵🇬","description":"papua new guinea","unicodeVersion":"6.0","digest":"9c37719d9f51ef31fec0f898d38e522b4253cd00344408e3f660132514efddb7"},"flag_ph":{"category":"flags","moji":"🇵🇭","description":"the philippines","unicodeVersion":"6.0","digest":"f1af628cf6d1d290cedef3d564b2386e2d6f14ba4426d3fefc0312cb8772e517"},"flag_pk":{"category":"flags","moji":"🇵🇰","description":"pakistan","unicodeVersion":"6.0","digest":"61c77f73d2a10a5acb289fadfe0d25d1a1c343e1223bd802099ff4e0e9356521"},"flag_pl":{"category":"flags","moji":"🇵🇱","description":"poland","unicodeVersion":"6.0","digest":"38c2c8618446e1f72cf983ab33e736d943f0db7c4cce52a187299e8cec2ea895"},"flag_pm":{"category":"flags","moji":"🇵🇲","description":"saint pierre and miquelon","unicodeVersion":"6.0","digest":"656be9ea1a79c3885a759c7ce353d338345a198d7939556949affaf5490cb644"},"flag_pn":{"category":"flags","moji":"🇵🇳","description":"pitcairn","unicodeVersion":"6.0","digest":"2792260d8087ab0253b1214c1420f0160ab2eef9afe7315f9e7ff0b87cd15d72"},"flag_pr":{"category":"flags","moji":"🇵🇷","description":"puerto rico","unicodeVersion":"6.0","digest":"c4cfa1f2201dcda9de310a8247e6ce32d2798ae426a14dd70a9ebb00a2804d46"},"flag_ps":{"category":"flags","moji":"🇵🇸","description":"palestinian authority","unicodeVersion":"6.0","digest":"197f2ec6294bf0ee4a08cf2f2d1e237ee867c98b3085454a3f42abc955eeb289"},"flag_pt":{"category":"flags","moji":"🇵🇹","description":"portugal","unicodeVersion":"6.0","digest":"86a50827963756b5bf471ed9df5b3f2a2058b4c5d778a303414b6b0556e2082b"},"flag_pw":{"category":"flags","moji":"🇵🇼","description":"palau","unicodeVersion":"6.0","digest":"a6321c47a0cd188fbfdf3b55f17a7170c63080d28d50e4f5463eb1ee09af2412"},"flag_py":{"category":"flags","moji":"🇵🇾","description":"paraguay","unicodeVersion":"6.0","digest":"1a169e8d8703c510c5a2265b57dbed2f811b03ec375bcb341ab4cd0b100a9dd6"},"flag_qa":{"category":"flags","moji":"🇶🇦","description":"qatar","unicodeVersion":"6.0","digest":"de6283965cd98a244b7fa6288174f9ff0d8feb497f191f2e4ab3b690138a3d5d"},"flag_re":{"category":"flags","moji":"🇷🇪","description":"réunion","unicodeVersion":"6.0","digest":"260e1b97abc1562e5a73d7e53652ffed8059fc9b1c969741c466f48ec6ab0e80"},"flag_ro":{"category":"flags","moji":"🇷🇴","description":"romania","unicodeVersion":"6.0","digest":"6d648e03955fa2a9fd2bad6f60ec96d3e20ee57f5855f3721a4d4e0c8e99f95c"},"flag_rs":{"category":"flags","moji":"🇷🇸","description":"serbia","unicodeVersion":"6.0","digest":"95cd5e197ed364e403eeb7f1d18a83487d89166910ba8119ea994e5e19d6a7ee"},"flag_ru":{"category":"flags","moji":"🇷🇺","description":"russia","unicodeVersion":"6.0","digest":"a4a81617a59d9eaf3c526431ca6f90ed334a7c1f516bf70cbd3f1fdc6e6103d7"},"flag_rw":{"category":"flags","moji":"🇷🇼","description":"rwanda","unicodeVersion":"6.0","digest":"7a369f60db0876ffef111c319a3e8c9eaed620c875c51b98ed9ad5207b836dca"},"flag_sa":{"category":"flags","moji":"🇸🇦","description":"saudi arabia","unicodeVersion":"6.0","digest":"b249fbfd7ed415943f60bbd841965cf721979f960ccbe09396aebac1eca913d7"},"flag_sb":{"category":"flags","moji":"🇸🇧","description":"the solomon islands","unicodeVersion":"6.0","digest":"526b411260024ea7b6ea6c47f2549345c6cc6960e9a29bfa9aaec0772664d2dc"},"flag_sc":{"category":"flags","moji":"🇸🇨","description":"the seychelles","unicodeVersion":"6.0","digest":"d036b0d068745926120eaf746fa2e4433306e2e14c6b540d0cd6265e34471056"},"flag_sd":{"category":"flags","moji":"🇸🇩","description":"sudan","unicodeVersion":"6.0","digest":"889615bdb9b1f9c59c5f83ed4d22d54a0ed5dd5de263e729c58544cb06c55885"},"flag_se":{"category":"flags","moji":"🇸🇪","description":"sweden","unicodeVersion":"6.0","digest":"f471d80cfff340960a752c8c152ed4fb482df2a3712b0a56dfab31b9b806926a"},"flag_sg":{"category":"flags","moji":"🇸🇬","description":"singapore","unicodeVersion":"6.0","digest":"82f58a09f98593cc87e545f7e5c03d2aedaf82e54e73f71f58c18e994c3085ac"},"flag_sh":{"category":"flags","moji":"🇸🇭","description":"saint helena","unicodeVersion":"6.0","digest":"53914b1fa8c1b4f30bae6c1f6717f138fb4dbf482c3e20e33f7aea4ecfc0438d"},"flag_si":{"category":"flags","moji":"🇸🇮","description":"slovenia","unicodeVersion":"6.0","digest":"65d491daa69f9a11cec9ccc4df3a669f12ef95a5c312137776d4472719940ba3"},"flag_sj":{"category":"flags","moji":"🇸🇯","description":"svalbard and jan mayen","unicodeVersion":"6.0","digest":"bbf6daa6174c6fbbbf541c8274f31b6757c3a16007c2687015ea041fd1e2c6b6"},"flag_sk":{"category":"flags","moji":"🇸🇰","description":"slovakia","unicodeVersion":"6.0","digest":"d4fd03eca5bd3c9fb324ee04fae37c9a2d852bac8335369e3e720ef9b98fff36"},"flag_sl":{"category":"flags","moji":"🇸🇱","description":"sierra leone","unicodeVersion":"6.0","digest":"1455c98c11c248623d82be5484ab1c4dcd1dae449adc393eb1aa2d8c74aa3f02"},"flag_sm":{"category":"flags","moji":"🇸🇲","description":"san marino","unicodeVersion":"6.0","digest":"daec5864ac50c625d7bf49d6c1a170a094cf0d1b9a0bdf62a62406e7ec500a94"},"flag_sn":{"category":"flags","moji":"🇸🇳","description":"senegal","unicodeVersion":"6.0","digest":"4e4d43c467e5eb84c70f535f37f4f468319bd4b06c6ec3db3b54f69efdafd334"},"flag_so":{"category":"flags","moji":"🇸🇴","description":"somalia","unicodeVersion":"6.0","digest":"c1434dca361563a8e3ba88f1ad19c3f6c9cbb8f3ebc17ce128fde2351ff67d0c"},"flag_sr":{"category":"flags","moji":"🇸🇷","description":"suriname","unicodeVersion":"6.0","digest":"f3c6bfee2a052f03d56ba917b88595450cef111ffa9e92c7f39ef8c3c3bd12d1"},"flag_ss":{"category":"flags","moji":"🇸🇸","description":"south sudan","unicodeVersion":"6.0","digest":"c0ed7e4f41206f5363e8ebdc6c3f28080e2f07d99e6fb73c1f6226d83310e69d"},"flag_st":{"category":"flags","moji":"🇸🇹","description":"sao tome and principe","unicodeVersion":"6.0","digest":"b022ae5d6885e28c6e9c83c17dd0c24c731d4f3d5773c49051768cdd4df51330"},"flag_sv":{"category":"flags","moji":"🇸🇻","description":"el salvador","unicodeVersion":"6.0","digest":"5bafdd04d243ee3f3998f4ec0a3d03ff5a3975e771b1f94f89d7713193d7a242"},"flag_sx":{"category":"flags","moji":"🇸🇽","description":"sint maarten","unicodeVersion":"6.0","digest":"fb92e9f514bcc2f7abbd4e146edde50f030c940c833f184618cbb48e56af22bd"},"flag_sy":{"category":"flags","moji":"🇸🇾","description":"syria","unicodeVersion":"6.0","digest":"ee330da644d4ce1fdba98be5eaab5054aed8d91a34ab617199a4b2b77f62a10b"},"flag_sz":{"category":"flags","moji":"🇸🇿","description":"swaziland","unicodeVersion":"6.0","digest":"7fe0c7429efd9682cc39e57f4bba8d1491d301643ba999d57c4e1bc37517ed64"},"flag_ta":{"category":"flags","moji":"🇹🇦","description":"tristan da cunha","unicodeVersion":"6.0","digest":"b47e245a2708072a4dbaf190c9606baa4daf02e51627eeae6f20c3b4c95024c0"},"flag_tc":{"category":"flags","moji":"🇹🇨","description":"turks and caicos islands","unicodeVersion":"6.0","digest":"18cfff14c2503b9d24c91c668583d4a14efb17657d800eca86ae49b547c9da5c"},"flag_td":{"category":"flags","moji":"🇹🇩","description":"chad","unicodeVersion":"6.0","digest":"73d1db3365736915c4cdf9ba9343d9fd78962203b60334e8f3724d4b330b17db"},"flag_tf":{"category":"flags","moji":"🇹🇫","description":"french southern territories","unicodeVersion":"6.0","digest":"3bffeb4bc9ceb9cbb150de88e957b6e46509862ca7d616d5693124af084eb435"},"flag_tg":{"category":"flags","moji":"🇹🇬","description":"togo","unicodeVersion":"6.0","digest":"eb13a0e85baf73326f3ae3bc75e8406eca42000d7e42b0641120e64c0ab7ebaa"},"flag_th":{"category":"flags","moji":"🇹🇭","description":"thailand","unicodeVersion":"6.0","digest":"a4e42efa4bb94e90f3a92ae9ce14affaacd3a142c1e0da40d8cc839500e771fd"},"flag_tj":{"category":"flags","moji":"🇹🇯","description":"tajikistan","unicodeVersion":"6.0","digest":"ff926fa3e86e095683a61c4754355a5b4dd0ecb74393306bd791d130fd1a909d"},"flag_tk":{"category":"flags","moji":"🇹🇰","description":"tokelau","unicodeVersion":"6.0","digest":"3fa732d457ded6c83cd5f73d934f64c4e687eb0cde7c157d2fdcdccaf3b5fb52"},"flag_tl":{"category":"flags","moji":"🇹🇱","description":"east timor","unicodeVersion":"6.0","digest":"0ec2a4d22fb832060693089e518bbe370a4e13bfc28748f110fc13726409f473"},"flag_tm":{"category":"flags","moji":"🇹🇲","description":"turkmenistan","unicodeVersion":"6.0","digest":"b4724aa7ad13352f16a0936e61cbb85f0bd147583fc66597aff7e8ee7cf19c21"},"flag_tn":{"category":"flags","moji":"🇹🇳","description":"tunisia","unicodeVersion":"6.0","digest":"5ab308ffdde40f504d6ee080817bbddbe4f3f4ddb71f508c75e0144a8c8044d9"},"flag_to":{"category":"flags","moji":"🇹🇴","description":"tonga","unicodeVersion":"6.0","digest":"75b7e7198fa42f87986882b8ca251a229afcaa0a1188ae7b9f5ece87dc31a723"},"flag_tr":{"category":"flags","moji":"🇹🇷","description":"turkey","unicodeVersion":"6.0","digest":"9cc48a8f8fa9c17c1627272f68d4740da0e7ce17a2cf8c6b5c08cc9b95e1390c"},"flag_tt":{"category":"flags","moji":"🇹🇹","description":"trinidad and tobago","unicodeVersion":"6.0","digest":"f9e63543121bb3cd2e41bc7b0c2c4ba662bc1cc0520b79fc4e201ec6456fdf59"},"flag_tv":{"category":"flags","moji":"🇹🇻","description":"tuvalu","unicodeVersion":"6.0","digest":"6431e5f06cc7995ae7208c429ecf39339b545854cb6d6b7447f465fe53614dfc"},"flag_tw":{"category":"flags","moji":"🇹🇼","description":"the republic of china","unicodeVersion":"6.0","digest":"8395ab3c6a595023b006518a5345ac3612f2893d3a8f011b7e5802414236b03c"},"flag_tz":{"category":"flags","moji":"🇹🇿","description":"tanzania","unicodeVersion":"6.0","digest":"716181733cd9ac7a8f51a9a64bc5d21020e8112f6768e8c49c4d651a3ee0b8a4"},"flag_ua":{"category":"flags","moji":"🇺🇦","description":"ukraine","unicodeVersion":"6.0","digest":"304570736345e28734f5ff84a2b0481c2bb00bf29d9892bd749b57dec7741e30"},"flag_ug":{"category":"flags","moji":"🇺🇬","description":"uganda","unicodeVersion":"6.0","digest":"a1bafb74c54ee8c92cb025b55aebdb6081eec3fda6a7f86f2ee14d1b801a8e9c"},"flag_um":{"category":"flags","moji":"🇺🇲","description":"united states minor outlying islands","unicodeVersion":"6.0","digest":"b3c9ac72211f481f50cde09e10b92aa03b1ea90abf85418e60a35b84963273ee"},"flag_us":{"category":"flags","moji":"🇺🇸","description":"united states","unicodeVersion":"6.0","digest":"da79f9af0a188178a82e7dc3a62298fa416f4cfbcae432838df1abebca5c0d63"},"flag_uy":{"category":"flags","moji":"🇺🇾","description":"uruguay","unicodeVersion":"6.0","digest":"8348e901d775722497ee911c9c9b4bd767710760c507630a67ecb6d47cc646c7"},"flag_uz":{"category":"flags","moji":"🇺🇿","description":"uzbekistan","unicodeVersion":"6.0","digest":"2a1dc1e9469e01c58ea91f545ef3fe0bdfe5544a73a80407f8960d01b1e5db5c"},"flag_va":{"category":"flags","moji":"🇻🇦","description":"the vatican city","unicodeVersion":"6.0","digest":"0e8134ec94bff032bfc63b0b08587d5298c9b7f31edd5a5b35633ae911434e61"},"flag_vc":{"category":"flags","moji":"🇻🇨","description":"saint vincent and the grenadines","unicodeVersion":"6.0","digest":"e0290e1be72c8939ee6c398f00a107703b21b97d91b9bf465e553ffbf00304a7"},"flag_ve":{"category":"flags","moji":"🇻🇪","description":"venezuela","unicodeVersion":"6.0","digest":"76a6a6c2353def1f984d1a6980831e63f3aea5af2201b574197834e7c203d57a"},"flag_vg":{"category":"flags","moji":"🇻🇬","description":"british virgin islands","unicodeVersion":"6.0","digest":"56fc9317b8dd62cccc60010819f8b895dd4569a9b06368a9250f815c39177b8a"},"flag_vi":{"category":"flags","moji":"🇻🇮","description":"u.s. virgin islands","unicodeVersion":"6.0","digest":"2526a3e13b8ccd301f0763580430898c227bd209e3ce482c7951140b28948375"},"flag_vn":{"category":"flags","moji":"🇻🇳","description":"vietnam","unicodeVersion":"6.0","digest":"0cf6b9896bbe4da8ed7718d0abfd56cef1a8321e26f89d3ad1b48488eaffb7a5"},"flag_vu":{"category":"flags","moji":"🇻🇺","description":"vanuatu","unicodeVersion":"6.0","digest":"9dfa282ce1aafc62beacab76e1fc19a141c8bdeaa30898f69b083067b775d362"},"flag_wf":{"category":"flags","moji":"🇼🇫","description":"wallis and futuna","unicodeVersion":"6.0","digest":"a0124683aa88cd7da886da70c65796c5ad84eb3751e356e9b2aa8ac249cf0bf9"},"flag_white":{"category":"objects","moji":"🏳","description":"waving white flag","unicodeVersion":"6.0","digest":"d9be4b7ceb8309c48f88cfd07a9f7ce6758ea6e620e73293cf14baec03ca381c"},"flag_ws":{"category":"flags","moji":"🇼🇸","description":"samoa","unicodeVersion":"6.0","digest":"53addd0dc304a3c8893389ed227986ef2431828b8c071926aa09f9efd815b649"},"flag_xk":{"category":"flags","moji":"🇽🇰","description":"kosovo","unicodeVersion":"6.0","digest":"eba1a832e489e1c2734e773e685df5d128271fa5559d23c060e68be067bf6469"},"flag_ye":{"category":"flags","moji":"🇾🇪","description":"yemen","unicodeVersion":"6.0","digest":"edfa14266785042b6d5fe0f64fafa630b16a3ee7d010501de7cc8554c959afb0"},"flag_yt":{"category":"flags","moji":"🇾🇹","description":"mayotte","unicodeVersion":"6.0","digest":"472ebc676b5d31dec2ac5e02ce69014a3dd94609d30a95f39f3a752f49c85e8b"},"flag_za":{"category":"flags","moji":"🇿🇦","description":"south africa","unicodeVersion":"6.0","digest":"dad162942a43392b4cff6929bd5cbf58c382a03dbc0e552f03c07ad2d8ff08ce"},"flag_zm":{"category":"flags","moji":"🇿🇲","description":"zambia","unicodeVersion":"6.0","digest":"1521ecaf1d1fdc8c15f0c96a6b04e6d4050f26f943a826b3d3d661f6ded6d438"},"flag_zw":{"category":"flags","moji":"🇿🇼","description":"zimbabwe","unicodeVersion":"6.0","digest":"46d05b597c5c77c8e2dc7bd6d8dd62ebca01bc9c9dc9915dafe694ca56402825"},"flags":{"category":"objects","moji":"🎏","description":"carp streamer","unicodeVersion":"6.0","digest":"f860aa4df587cf140c3e9735bbd101e9fd5a1bfcea42e420d85ac0a9877fa21d"},"flashlight":{"category":"objects","moji":"🔦","description":"electric torch","unicodeVersion":"6.0","digest":"e929bbe76e0fd2dc5bd6476858a0bbc717fd21467710435d35d80efb38033d73"},"fleur-de-lis":{"category":"symbols","moji":"⚜","description":"fleur-de-lis","unicodeVersion":"4.1","digest":"ebf49007f367dc05580e9dab942e93e9dda12fa1dc2caa410ac7f8d8cd55d2a3"},"floppy_disk":{"category":"objects","moji":"💾","description":"floppy disk","unicodeVersion":"6.0","digest":"4ee0b5bba41b9e301ed125d3ee1c263bef171ca499e6e1b89276b09af2bc03a0"},"flower_playing_cards":{"category":"symbols","moji":"🎴","description":"flower playing cards","unicodeVersion":"6.0","digest":"edba47c2e3051b2c7effd98794ec977174052782edcb491daec82a2b0d853869"},"flushed":{"category":"people","moji":"😳","description":"flushed face","unicodeVersion":"6.0","digest":"e759d46bab92af5494d78b6c712c06568759afe397e7828ca0a0de1e3eab0165"},"fog":{"category":"nature","moji":"🌫","description":"fog","unicodeVersion":"7.0","digest":"0cbd4733961d30fe0f40f95dd1f37254aebbef26f82dd18ad2000e799eb2898e"},"foggy":{"category":"travel","moji":"🌁","description":"foggy","unicodeVersion":"6.0","digest":"bc3631a4e9e8473b92e842008937add2cd9ffad5b7d772ce759fb5ff6c0e3dca"},"football":{"category":"activity","moji":"🏈","description":"american football","unicodeVersion":"6.0","digest":"ebd790471c3a28d3077818e3b31d915ffe443e06e299bc5cf0dd2534d080634c"},"footprints":{"category":"people","moji":"👣","description":"footprints","unicodeVersion":"6.0","digest":"85bbf2bc0ae8e6259d83a06f513600095d7fcfc44372670f5b2405d380b78811"},"fork_and_knife":{"category":"food","moji":"🍴","description":"fork and knife","unicodeVersion":"6.0","digest":"f228accd36ddccb4ec636207c19d7185191ec79723b780a1bd5c3d00a4b1ef3b"},"fork_knife_plate":{"category":"food","moji":"🍽","description":"fork and knife with plate","unicodeVersion":"7.0","digest":"ec6be99dac8efd3d145807fa60d2b6d8f6d3c02cb95552b55cc0fac39a4db48e"},"fountain":{"category":"travel","moji":"⛲","description":"fountain","unicodeVersion":"5.2","digest":"87043f9256e1d4615159307fcfd21bf6ae2aba0bada7de2bd50d7d6f2ab82395"},"four":{"category":"symbols","moji":"4️⃣","description":"keycap digit four","unicodeVersion":"3.0","digest":"c2c82a966bbb599aae557d930a4fc42604f2081aa45528872f5caf4942ee79d9"},"four_leaf_clover":{"category":"nature","moji":"🍀","description":"four leaf clover","unicodeVersion":"6.0","digest":"ebee16e86bc9be843dfc72ab5372fb462f06be4486b5b25d7d4cac9b2c8b01c8"},"fox":{"category":"nature","moji":"🦊","description":"fox face","unicodeVersion":"9.0","digest":"e9903cb0396f7e49bdd2c384b38e614c13bfa576b3ecc1ec7b9819e4a40d91d1"},"frame_photo":{"category":"objects","moji":"🖼","description":"frame with picture","unicodeVersion":"7.0","digest":"d5074f748a15055ec1fb812c1e5e169e6e3cc73c522c54be1359b0e26c0fc75c"},"free":{"category":"symbols","moji":"🆓","description":"squared free","unicodeVersion":"6.0","digest":"9973522457158362fc5bdd7da858e6371e28a8403d1ef9e4b6427195c7f72cfa"},"french_bread":{"category":"food","moji":"🥖","description":"baguette bread","unicodeVersion":"9.0","digest":"47518a4312f57207b8e8c38188d4a2bd8b16830a885cfcf2d281cfab50c1bc6e"},"fried_shrimp":{"category":"food","moji":"🍤","description":"fried shrimp","unicodeVersion":"6.0","digest":"0792bdc4484852de970c8f43bc3a1a339dc0e48090ec77d6de97cbfcdd17f9e1"},"fries":{"category":"food","moji":"🍟","description":"french fries","unicodeVersion":"6.0","digest":"47915aea67251d358d91a0e4dc3dcc347155336007d6b931a192be72a743b4e9"},"frog":{"category":"nature","moji":"🐸","description":"frog face","unicodeVersion":"6.0","digest":"d024b2ce771df64040534fb0906737d18b562bc3578dee62c2f25ec03c7caffd"},"frowning":{"category":"people","moji":"😦","description":"frowning face with open mouth","unicodeVersion":"6.1","digest":"c01af48537b0011d313d8f65103e1401fce4f5c0269c68e0e9806926c59acc44"},"frowning2":{"category":"people","moji":"☹","description":"white frowning face","unicodeVersion":"1.1","digest":"6568ee393b950c852d440112e86908c456b89fb7780e27778c5fcec168373fbf"},"fuelpump":{"category":"travel","moji":"⛽","description":"fuel pump","unicodeVersion":"5.2","digest":"105e736469f19911b8bab4ab6d29f949ded4b061b54e3dd763726577d6453095"},"full_moon":{"category":"nature","moji":"🌕","description":"full moon symbol","unicodeVersion":"6.0","digest":"aaa87f4676a5aaa29c1b721a3b582e89db6c1f35a25c52e4b480bd193ef39c43"},"full_moon_with_face":{"category":"nature","moji":"🌝","description":"full moon with face","unicodeVersion":"6.0","digest":"05c4b9c339fcdf81ae67027641522baa99c370d87873ff4c8133b8349e627e33"},"game_die":{"category":"activity","moji":"🎲","description":"game die","unicodeVersion":"6.0","digest":"00d19ce8e21dba2cdfeb18709fa8741f3af9d6207f81d5657b68e05e64f105a8"},"gear":{"category":"objects","moji":"⚙","description":"gear","unicodeVersion":"4.1","digest":"c5ba354c0f7a36dce95477091984e352ecc59af8c9f26a94ad8e296dc042b9de"},"gem":{"category":"objects","moji":"💎","description":"gem stone","unicodeVersion":"6.0","digest":"180e66f19d9285e02d0a5e859722c608206826e80323942b9938fc49d44973b1"},"gay_pride_flag":{"category":"flags","moji":"🏳🌈","description":"gay_pride_flag","unicodeVersion":"6.0","digest":"924e668c559db61b7f4724a661223081c2fc60d55169f3fe1ad6156934d1d37f"},"gemini":{"category":"symbols","moji":"♊","description":"gemini","unicodeVersion":"1.1","digest":"278239c598d490a110f1f3f52fc3b85259be8e76034b38228ef3f68d7ddd8cdd"},"ghost":{"category":"people","moji":"👻","description":"ghost","unicodeVersion":"6.0","digest":"80d528fcf8ef9198631527547e43a608a4332a799f9e5550b8318dec67c9c4d2"},"gift":{"category":"objects","moji":"🎁","description":"wrapped present","unicodeVersion":"6.0","digest":"4061a84a59f0300473299678c43e533341eb965db09597fffc6e221fd7b77376"},"gift_heart":{"category":"symbols","moji":"💝","description":"heart with ribbon","unicodeVersion":"6.0","digest":"5420199b515b9b32c964a3c19d87e07461639e3068a939dae26c6436335c0cee"},"girl":{"category":"people","moji":"👧","description":"girl","unicodeVersion":"6.0","digest":"8d2d0b72a91e6e44921b71030ffc4c89c0f50f1364787784afe1e7e568cf1bc6"},"girl_tone1":{"category":"people","moji":"👧🏻","description":"girl tone 1","unicodeVersion":"8.0","digest":"bda12a6b38994a578ee65166bbdd93ea04df4101697b52ed236de8d687df09de"},"girl_tone2":{"category":"people","moji":"👧🏼","description":"girl tone 2","unicodeVersion":"8.0","digest":"de7a0925c30b7181a289f71b1a849c1b7751ee8c104e8f2029bd9c2fe3f91c64"},"girl_tone3":{"category":"people","moji":"👧🏽","description":"girl tone 3","unicodeVersion":"8.0","digest":"e41272816db0e642d003dce7cb262e1593a592251f46729f7830f4515149e1f2"},"girl_tone4":{"category":"people","moji":"👧🏾","description":"girl tone 4","unicodeVersion":"8.0","digest":"8d6a4513ecbf08408c0ecc5336767777a2216f7a19437faf9e51f65101822469"},"girl_tone5":{"category":"people","moji":"👧🏿","description":"girl tone 5","unicodeVersion":"8.0","digest":"f55e4b16a41b6f5e3c817a301420360ba4486e4e82e1092a56a3e3cc4069087d"},"globe_with_meridians":{"category":"symbols","moji":"🌐","description":"globe with meridians","unicodeVersion":"6.0","digest":"725bebeb3c09a9e3701ebe49e672dcfbf2b73575e05f0821263511577b013b75"},"goal":{"category":"activity","moji":"🥅","description":"goal net","unicodeVersion":"9.0","digest":"7088c432f276ff6f447dc0d431b9062b394fb401de1072fe59ca56267bfd6717"},"goat":{"category":"nature","moji":"🐐","description":"goat","unicodeVersion":"6.0","digest":"d07e384d08529ddcaddd2710f2ad913e5665dc15d5f99c28e16dadd245a111e8"},"golf":{"category":"activity","moji":"⛳","description":"flag in hole","unicodeVersion":"5.2","digest":"eed79364754eec97855e3c7b584f347ae139d9ddb4eb7fb66c00867610b8f1c1"},"golfer":{"category":"activity","moji":"🏌","description":"golfer","unicodeVersion":"7.0","digest":"7d7ecc6e226596f646030a4109c2b0001ef0cc690e4863e450bf5d29e7a90344"},"gorilla":{"category":"nature","moji":"🦍","description":"gorilla","unicodeVersion":"9.0","digest":"4a564dc14f8ae5450d094f6410ec7f099a7f07dc5254b6395f44a35527bdb4b7"},"grapes":{"category":"food","moji":"🍇","description":"grapes","unicodeVersion":"6.0","digest":"74d1a09ab411234a84d025a2e717e7ec5791bc02aad29853896d21c0f0283c50"},"green_apple":{"category":"food","moji":"🍏","description":"green apple","unicodeVersion":"6.0","digest":"457490e9b2b20894f50768262d63f1021717079da104d4847076b3fa779e9a21"},"green_book":{"category":"objects","moji":"📗","description":"green book","unicodeVersion":"6.0","digest":"370f635b200efe5e4a9f17da58bd22500e258e61d17795cef375f19c9a45468f"},"green_heart":{"category":"symbols","moji":"💚","description":"green heart","unicodeVersion":"6.0","digest":"f71e30416d9019873f2ed38ef375c48386424ff60b5a07b89b15dc9e0a3970f9"},"grey_exclamation":{"category":"symbols","moji":"❕","description":"white exclamation mark ornament","unicodeVersion":"6.0","digest":"2fa1d356e12c17cc4025e43afb6c3070385f677102a35223302fda46c47a9b03"},"grey_question":{"category":"symbols","moji":"❔","description":"white question mark ornament","unicodeVersion":"6.0","digest":"e1035bcbf0f66d238ef478ba451f5cf2c51627fbf101ed03bad3b2bf38db8aa2"},"grimacing":{"category":"people","moji":"😬","description":"grimacing face","unicodeVersion":"6.1","digest":"2cedad13b8b2a1d4385ca6fa88a251eb7757a4c65dd6d362267864a01247846b"},"grin":{"category":"people","moji":"😁","description":"grinning face with smiling eyes","unicodeVersion":"6.0","digest":"634b2f37e32e57ed6edc7f371993a92e34137dd21ba393de5227cfbbe2422815"},"grinning":{"category":"people","moji":"😀","description":"grinning face","unicodeVersion":"6.1","digest":"cef76aa41771db9fd1d6bd9b4233c22c1fb1931494af54cab29e6347ed9b678d"},"guardsman":{"category":"people","moji":"💂","description":"guardsman","unicodeVersion":"6.0","digest":"17bc7fad6b8c8dbd015bb709380d129f8b8e1e971062d15e6ab0b2e63e500564"},"guardsman_tone1":{"category":"people","moji":"💂🏻","description":"guardsman tone 1","unicodeVersion":"8.0","digest":"c531ecb101bdf9ce1db18e1567882e6db927410237100b0a2492a1401860246e"},"guardsman_tone2":{"category":"people","moji":"💂🏼","description":"guardsman tone 2","unicodeVersion":"8.0","digest":"602168c5204af0f1de8b4aa5863b192ef20c19d263999377aa5eb60f98311732"},"guardsman_tone3":{"category":"people","moji":"💂🏽","description":"guardsman tone 3","unicodeVersion":"8.0","digest":"d0a85de46dd02c7bd6cb14bff0f22d2db9083d4b171a8806c83363b49f3dd9ef"},"guardsman_tone4":{"category":"people","moji":"💂🏾","description":"guardsman tone 4","unicodeVersion":"8.0","digest":"1c9d4d72b6b50bdac8271613b6d2a38340ec2067bc344e8ee2a3c863fd5c23a1"},"guardsman_tone5":{"category":"people","moji":"💂🏿","description":"guardsman tone 5","unicodeVersion":"8.0","digest":"9899a796d01842e495d716fbe737a16d85724f7d3e23f50807ec2bc70f057318"},"guitar":{"category":"activity","moji":"🎸","description":"guitar","unicodeVersion":"6.0","digest":"a1027ceae4dd3ea270740587c9d373329e5677e375c9e00af6ae3275e0b67500"},"gun":{"category":"objects","moji":"🔫","description":"pistol","unicodeVersion":"6.0","digest":"fc12b577df2283e7b336f23774f9cfe5b79f1d26ddd28a64a560519b28d94ca5"},"haircut":{"category":"people","moji":"💇","description":"haircut","unicodeVersion":"6.0","digest":"b243a04f5ca889accd45e7abe095ac5caa92274ed95103f5966a36b415fff412"},"haircut_tone1":{"category":"people","moji":"💇🏻","description":"haircut tone 1","unicodeVersion":"8.0","digest":"a58d0cff1427b80dfd7a9ea5267b4a181e9faaac6a51a0165db522f668b4cf91"},"haircut_tone2":{"category":"people","moji":"💇🏼","description":"haircut tone 2","unicodeVersion":"8.0","digest":"675083ff40001405f8de99268477d50dd8594ff6ca40ddfd442dd42ad76e8216"},"haircut_tone3":{"category":"people","moji":"💇🏽","description":"haircut tone 3","unicodeVersion":"8.0","digest":"70d7581e49c315a3771dd61a3713229886db32aaaeb3af078a69cc042f809150"},"haircut_tone4":{"category":"people","moji":"💇🏾","description":"haircut tone 4","unicodeVersion":"8.0","digest":"ec5e3e909eb3bc375ef9cc0fe0e0f90b33f44f273ada91ccf415bbc43b8ffbfc"},"haircut_tone5":{"category":"people","moji":"💇🏿","description":"haircut tone 5","unicodeVersion":"8.0","digest":"7c89739ee458546a808fded7f96d9354c47a76883ebb262d5f5abeafd021260e"},"hamburger":{"category":"food","moji":"🍔","description":"hamburger","unicodeVersion":"6.0","digest":"48204235238bd89d3a69f319f65135102f3d6b181eec241d4d86b302bbffa9bf"},"hammer":{"category":"objects","moji":"🔨","description":"hammer","unicodeVersion":"6.0","digest":"d0e7830539d935fcd82820c4e0c1d724f0756dfc83a51171fe0f4b36b69fac42"},"hammer_pick":{"category":"objects","moji":"⚒","description":"hammer and pick","unicodeVersion":"4.1","digest":"aa0445f43bca58d17afa7f3577632ca7775f5a28336385b3020b268b15b18142"},"hamster":{"category":"nature","moji":"🐹","description":"hamster face","unicodeVersion":"6.0","digest":"a7e7582e8b1bccd5b7df27ccb05e353a3f0e39bdeb40877732706b9d74a70de1"},"hand_splayed":{"category":"people","moji":"🖐","description":"raised hand with fingers splayed","unicodeVersion":"7.0","digest":"c51a30cb7e575d29ffed16780a6c95ae3f300b8ac523012f4a6e116d68c1fd15"},"hand_splayed_tone1":{"category":"people","moji":"🖐🏻","description":"raised hand with fingers splayed tone 1","unicodeVersion":"8.0","digest":"c31fb44a982ed8808e1c311ec1b0b9c5afcb47f16bb1fc731dc483adf8f0d049"},"hand_splayed_tone2":{"category":"people","moji":"🖐🏼","description":"raised hand with fingers splayed tone 2","unicodeVersion":"8.0","digest":"56a236881184e9ffad54613fa08a67368c432af738f5254fb1cd87b20368acdf"},"hand_splayed_tone3":{"category":"people","moji":"🖐🏽","description":"raised hand with fingers splayed tone 3","unicodeVersion":"8.0","digest":"9242ca97dfd2bbc1947228f6535029afb31f8feb72c14ff4b7f2deea30217425"},"hand_splayed_tone4":{"category":"people","moji":"🖐🏾","description":"raised hand with fingers splayed tone 4","unicodeVersion":"8.0","digest":"43348d9fd3d43b3c45cebaf663bf181bcad3b6df841a5aeed838180db2cdd481"},"hand_splayed_tone5":{"category":"people","moji":"🖐🏿","description":"raised hand with fingers splayed tone 5","unicodeVersion":"8.0","digest":"4b3a0aba7829772fec09f26d6facc19a2f822d2998015297b18b5cab85190ee2"},"handbag":{"category":"people","moji":"👜","description":"handbag","unicodeVersion":"6.0","digest":"45410a3eed0c2e3f68748d7649fa9e33a90f4e80d5291206bdd0b40380c6da45"},"handball":{"category":"activity","moji":"🤾","description":"handball","unicodeVersion":"9.0","digest":"94ceb28024eb3259d8b137cafd7438773e717fbc04f5da810f85e43ca0fa9e00"},"handball_tone1":{"category":"activity","moji":"🤾🏻","description":"handball tone 1","unicodeVersion":"9.0","digest":"8bec4de0d05c80e335e44d65598d186ca92696977353c9fd9c2a5efa122cb842"},"handball_tone2":{"category":"activity","moji":"🤾🏼","description":"handball tone 2","unicodeVersion":"9.0","digest":"2ff4131e1e2f089b315d8e176c9348877c26c2bd03706fb75d41bc61bc99bf93"},"handball_tone3":{"category":"activity","moji":"🤾🏽","description":"handball tone 3","unicodeVersion":"9.0","digest":"224a71f94dd37d3729325d11412334667a81422e21f6d7c008730ff350f51a80"},"handball_tone4":{"category":"activity","moji":"🤾🏾","description":"handball tone 4","unicodeVersion":"9.0","digest":"a5f7a9db790565981bad2d0d9e09554c8c509a8179b4705a418300d58a7894b4"},"handball_tone5":{"category":"activity","moji":"🤾🏿","description":"handball tone 5","unicodeVersion":"9.0","digest":"00404572d4683f2e8e8a494aa733e96fbec1723634d0a8cb8d75f2829a789d27"},"handshake":{"category":"people","moji":"🤝","description":"handshake","unicodeVersion":"9.0","digest":"cb4b08b70560908f96bda0aecd2f4c966bea180f9b7200e4c81d342dc8d36087"},"handshake_tone1":{"category":"people","moji":"🤝🏻","description":"handshake tone 1","unicodeVersion":"9.0","digest":"40470e224683ba375ed8698c0cbd560556be5a8898237ddf504377a3a7e89ff0"},"handshake_tone2":{"category":"people","moji":"🤝🏼","description":"handshake tone 2","unicodeVersion":"9.0","digest":"77ed378243bf682f1f4f1a8caeabcbedf772f54631cc40ea46c099e46a499b18"},"handshake_tone3":{"category":"people","moji":"🤝🏽","description":"handshake tone 3","unicodeVersion":"9.0","digest":"81b95050f0878b617f5d2640e34031c26a0072e46ca5a688eb4356e48bc74c92"},"handshake_tone4":{"category":"people","moji":"🤝🏾","description":"handshake tone 4","unicodeVersion":"9.0","digest":"74919a6f026fbbd0ccdbdbd4288d1b2ef3bda8930e9142c07736db4a7f3ef345"},"handshake_tone5":{"category":"people","moji":"🤝🏿","description":"handshake tone 5","unicodeVersion":"9.0","digest":"a30d662bfad0074ca7e32cf6f7229b643b636c4beaec496777eb7e1d5b6fc470"},"hash":{"category":"symbols","moji":"#⃣","description":"number sign","unicodeVersion":"3.0","digest":"01c8b577953010bff0c20f797c2c96ab5d98d4e6ac179c4895a78f34ea904655"},"hatched_chick":{"category":"nature","moji":"🐥","description":"front-facing baby chick","unicodeVersion":"6.0","digest":"006571b9e9e839ec9fcb1a911b935c8ca71eb8bcdce9775bee6a2a4c7c927277"},"hatching_chick":{"category":"nature","moji":"🐣","description":"hatching chick","unicodeVersion":"6.0","digest":"fd7f69fa186407f80de59dec5116e318325a5743ee0e8bba1db541f1e57e7f74"},"head_bandage":{"category":"people","moji":"🤕","description":"face with head-bandage","unicodeVersion":"8.0","digest":"d09019a73e203b38cc43729a96163147de88e09eab8adb073888e55366854c72"},"headphones":{"category":"activity","moji":"🎧","description":"headphone","unicodeVersion":"6.0","digest":"34f9d5598158d5d6f978a5ea5c5aa9948bb2990625565a3afad7710f864fbe2f"},"hear_no_evil":{"category":"nature","moji":"🙉","description":"hear-no-evil monkey","unicodeVersion":"6.0","digest":"53b030b6d6f4ed1a734fa7d48b46f42eb1b2b01653202c1838b742082f08c4bf"},"heart":{"category":"symbols","moji":"❤","description":"heavy black heart","unicodeVersion":"1.1","digest":"92be652ec3e50c6e7393440b5d52b88a367f98a28dffe12660095ed3253aa6c0"},"heart_decoration":{"category":"symbols","moji":"💟","description":"heart decoration","unicodeVersion":"6.0","digest":"6ec5bbf3aa75c6f43eb3dc05e9204366936e8b6b4219310bacdc2fc45f51e245"},"heart_exclamation":{"category":"symbols","moji":"❣","description":"heavy heart exclamation mark ornament","unicodeVersion":"1.1","digest":"5985ea4d82232a2a07052a59db268aed9ac943895d0c82f637595bb5386329a6"},"heart_eyes":{"category":"people","moji":"😍","description":"smiling face with heart-shaped eyes","unicodeVersion":"6.0","digest":"0eff616517a6252ec89d47d9b4ad85589bcf2bdc7f490578934350acb84b2fcc"},"heart_eyes_cat":{"category":"people","moji":"😻","description":"smiling cat face with heart-shaped eyes","unicodeVersion":"6.0","digest":"8a1f28b97d661ca4cff5ee13889ca61b5fa745ccb590e80832b7d7701df101d6"},"heartbeat":{"category":"symbols","moji":"💓","description":"beating heart","unicodeVersion":"6.0","digest":"c9ec024943439d476df6f5ec3a6b30508365a7af3427671a80de3ef2f4f95ffe"},"heartpulse":{"category":"symbols","moji":"💗","description":"growing heart","unicodeVersion":"6.0","digest":"281d8aebfea37db5b7fe82d9115be167006881fe29ab64a5b09ac92ac27a2309"},"hearts":{"category":"symbols","moji":"♥","description":"black heart suit","unicodeVersion":"1.1","digest":"271429d12c40be921897005b7bdd08f9518960af1e1e6f56bb0060f1f183651e"},"heavy_check_mark":{"category":"symbols","moji":"✔","description":"heavy check mark","unicodeVersion":"1.1","digest":"e347728e1290eb9e7b0742d628e2fd124fc049e0774f8a6ddf8e5286e7318718"},"heavy_division_sign":{"category":"symbols","moji":"➗","description":"heavy division sign","unicodeVersion":"6.0","digest":"c1e8c40f0788f140b1c5fcb81ed9b5ce1bcfa5988bb8140ed2808e9cb7e0d651"},"heavy_dollar_sign":{"category":"symbols","moji":"💲","description":"heavy dollar sign","unicodeVersion":"6.0","digest":"7cdeef38348654b93d566e01a48973281cb404a63d0b75b3bad51032887f3f55"},"heavy_minus_sign":{"category":"symbols","moji":"➖","description":"heavy minus sign","unicodeVersion":"6.0","digest":"e5335cc6b22abdce49a6127c34269b65a4a6643ddd3253d9baac425089143e7d"},"heavy_multiplication_x":{"category":"symbols","moji":"✖","description":"heavy multiplication x","unicodeVersion":"1.1","digest":"64bbe9e9716a922e405d2f6d3b6d803863a53fac80ff8cd775899971046cb1ca"},"heavy_plus_sign":{"category":"symbols","moji":"➕","description":"heavy plus sign","unicodeVersion":"6.0","digest":"d0d8ade2020ceb252205180b85c66e665856e6cb505518d395b9913b0b24b746"},"helicopter":{"category":"travel","moji":"🚁","description":"helicopter","unicodeVersion":"6.0","digest":"4bd6fd13650fbe3a19cfffeffe6c21b1cda74bd6af64c5dc5999185e35444bc3"},"helmet_with_cross":{"category":"people","moji":"⛑","description":"helmet with white cross","unicodeVersion":"5.2","digest":"8286107391d44b9cd7fce5dc83bfdebbcdcf5a8214c46a8990732ec40263ed77"},"herb":{"category":"nature","moji":"🌿","description":"herb","unicodeVersion":"6.0","digest":"9fe8ed65515ede59d0926dcf98f14e2498785e1965610aa0dd56eca9b4bedad9"},"hibiscus":{"category":"nature","moji":"🌺","description":"hibiscus","unicodeVersion":"6.0","digest":"c442e8eacbd8727bd154bd39692a9a2a03ea2f674b9670ad8361f78a038afe49"},"high_brightness":{"category":"symbols","moji":"🔆","description":"high brightness symbol","unicodeVersion":"6.0","digest":"35ced42426dcfd5214c2c6c577dce84bb708156433945e6b6adaff7ea530cc57"},"high_heel":{"category":"people","moji":"👠","description":"high-heeled shoe","unicodeVersion":"6.0","digest":"1e7c7aba50eb1d02cf1d9aa372caca741a6005cf47f68dfa75b7310c3cb18f05"},"hockey":{"category":"activity","moji":"🏒","description":"ice hockey stick and puck","unicodeVersion":"8.0","digest":"2d00fb17baa617e799db8e9b1771cc365bb4545c7633df0123e66e1a6e2ed25d"},"hole":{"category":"objects","moji":"🕳","description":"hole","unicodeVersion":"7.0","digest":"8b5539f6f24f09d5d68ffd56be5aa2a8a2f753a8dfbf64892fb02c8f2703e920"},"homes":{"category":"travel","moji":"🏘","description":"house buildings","unicodeVersion":"7.0","digest":"cd512f2b4ce747325607d47da48e083dbfe38a44b85b2522bc372bd105afd25f"},"honey_pot":{"category":"food","moji":"🍯","description":"honey pot","unicodeVersion":"6.0","digest":"f6eec8c32fbd1b461446dc6c5d5031c43e6ee9685dc9b1ea1b839114e48c4eee"},"horse":{"category":"nature","moji":"🐴","description":"horse face","unicodeVersion":"6.0","digest":"e377649a9549835770a2a721a92570f699255f88efa646029638eb8ec5f10e3d"},"horse_racing":{"category":"activity","moji":"🏇","description":"horse racing","unicodeVersion":"6.0","digest":"3b98e94e9c028ad85b9a750cc61db5ee3ac23cf5ad9243ea3e996b1f772bad54"},"horse_racing_tone1":{"category":"activity","moji":"🏇🏻","description":"horse racing tone 1","unicodeVersion":"8.0","digest":"382d8e4502ed34fc1bbf1779ce483bc2e22b83f89c91746c11a5d7aea656d446"},"horse_racing_tone2":{"category":"activity","moji":"🏇🏼","description":"horse racing tone 2","unicodeVersion":"8.0","digest":"198df9973b492ea63e5cfc210dd9591750ccce04a6380adc1dc5b4cb0462a8cd"},"horse_racing_tone3":{"category":"activity","moji":"🏇🏽","description":"horse racing tone 3","unicodeVersion":"8.0","digest":"a67f95fc92c366750ebad3c4db92982893d67a5ed78163c8cc809ac40d2ab9a3"},"horse_racing_tone4":{"category":"activity","moji":"🏇🏾","description":"horse racing tone 4","unicodeVersion":"8.0","digest":"986b1706c4a3395b58a8ae3b7609ffdd4424dfefcbf26c88c8085f4f6379734e"},"horse_racing_tone5":{"category":"activity","moji":"🏇🏿","description":"horse racing tone 5","unicodeVersion":"8.0","digest":"66656b5e3d0f43f16f983f9db6214b07aac73b143eeff6475782f98aa5b9ba53"},"hospital":{"category":"travel","moji":"🏥","description":"hospital","unicodeVersion":"6.0","digest":"034573e76df444f5b0eb7aff3a4103e4b49a1813869155ab3ae29a6fc0c6c8a2"},"hot_pepper":{"category":"food","moji":"🌶","description":"hot pepper","unicodeVersion":"7.0","digest":"0b05777d42698196a10db17d04030175b1dfa772d06288f71d666d5f8d3fddbc"},"hotdog":{"category":"food","moji":"🌭","description":"hot dog","unicodeVersion":"8.0","digest":"7a25bbd1a7531fd34a22c654c0931d9e74bea2bbe7baa9f9cbd88f43baa79fb5"},"hotel":{"category":"travel","moji":"🏨","description":"hotel","unicodeVersion":"6.0","digest":"2d78e0ad4cfb0caad778c7de49fefd6e8356afe902a43e3f1c40bceb6b0be422"},"hotsprings":{"category":"symbols","moji":"♨","description":"hot springs","unicodeVersion":"1.1","digest":"4c10c3a974b44693e8cbe91365c8b8d7f14f62db234cc516b6e54c08a6bacaed"},"hourglass":{"category":"objects","moji":"⌛","description":"hourglass","unicodeVersion":"1.1","digest":"f0bae8392aaf6f75a83f5d8914936b8650665b24ba1b232fa546b71545dd9acd"},"hourglass_flowing_sand":{"category":"objects","moji":"⏳","description":"hourglass with flowing sand","unicodeVersion":"6.0","digest":"2d077729f40fc04007a933e97356bd511cbd8be76b8c55962ca3fa0d8b828e23"},"house":{"category":"travel","moji":"🏠","description":"house building","unicodeVersion":"6.0","digest":"b4ac25979fbe161ada0d2a75769aa7552d2371d37d78cddba4ffdc7f076d3279"},"house_abandoned":{"category":"travel","moji":"🏚","description":"derelict house building","unicodeVersion":"7.0","digest":"6e1a58533fbfe88a0eb03668c9f17c5c654a6cc7734ed798d4a885400f823610"},"house_with_garden":{"category":"travel","moji":"🏡","description":"house with garden","unicodeVersion":"6.0","digest":"817463f23ec0a849393ba75c333e822b4d253cd4db998c127e90d1b924f35d20"},"hugging":{"category":"people","moji":"🤗","description":"hugging face","unicodeVersion":"8.0","digest":"69810a98b1247e1f1e496aa757e428189ef5cc086764fabd8189cf1eef82234f"},"hushed":{"category":"people","moji":"😯","description":"hushed face","unicodeVersion":"6.1","digest":"22586107f7399eff64538a52929dade152633aa268fc5ec4e6fe1c0e00a7bd89"},"ice_cream":{"category":"food","moji":"🍨","description":"ice cream","unicodeVersion":"6.0","digest":"d1a8e685f2ecf83dead28733859e369d6ce120a2669cdab97dc4423547d472ac"},"ice_skate":{"category":"activity","moji":"⛸","description":"ice skate","unicodeVersion":"5.2","digest":"41ef65c143bc068868fa64080ffd447d91aa3fe2a39e69ecaa97022820af4dcd"},"icecream":{"category":"food","moji":"🍦","description":"soft ice cream","unicodeVersion":"6.0","digest":"22cfe17b80cbd2a0377ee90da45bd40d33533c914b2639d363fbb1f00714e194"},"id":{"category":"symbols","moji":"🆔","description":"squared id","unicodeVersion":"6.0","digest":"bcf0922e083821d3be7951893084ea0d72a0110ef0b20d11dfec24dd70633893"},"ideograph_advantage":{"category":"symbols","moji":"🉐","description":"circled ideograph advantage","unicodeVersion":"6.0","digest":"0b6bf59f63fda1afa92d652814a778a056c3f4abdd9cf3f6796068bd71783051"},"imp":{"category":"people","moji":"👿","description":"imp","unicodeVersion":"6.0","digest":"52598cf2441988f875ccb4e479637baefc679e3ca64e9a6400e56488b0fde811"},"inbox_tray":{"category":"objects","moji":"📥","description":"inbox tray","unicodeVersion":"6.0","digest":"d5d9497022b5318fcfbfdfcd56df9c65dd8f4a4cb5e6283ca260836df57da301"},"incoming_envelope":{"category":"objects","moji":"📨","description":"incoming envelope","unicodeVersion":"6.0","digest":"310b7bdcca93452fe10c72c03d0aafa12b98e5d3408896d275d06d3693812c7a"},"information_desk_person":{"category":"people","moji":"💁","description":"information desk person","unicodeVersion":"6.0","digest":"9f12a4a58a650e8e1d3836ef857003c3ccd42ad4203a2479eb95100bf6559064"},"information_desk_person_tone1":{"category":"people","moji":"💁🏻","description":"information desk person tone 1","unicodeVersion":"8.0","digest":"6674f2e059eff7cfd7fd6abc800da37c4f1087feb4ff26c9e4e31aa29fdf9921"},"information_desk_person_tone2":{"category":"people","moji":"💁🏼","description":"information desk person tone 2","unicodeVersion":"8.0","digest":"9983412ecd130b7e9cfb078167016c06fd043b6f9f3c26d21733ca3f059fd109"},"information_desk_person_tone3":{"category":"people","moji":"💁🏽","description":"information desk person tone 3","unicodeVersion":"8.0","digest":"d8907bf47af5722127afca8fc0da587eab33044a6c60a94890983deb8d6f7a66"},"information_desk_person_tone4":{"category":"people","moji":"💁🏾","description":"information desk person tone 4","unicodeVersion":"8.0","digest":"3be086d4edfe9ca8e4a364b4e8d09b81b5b594b5eeb9ffdf6370179fb3118658"},"information_desk_person_tone5":{"category":"people","moji":"💁🏿","description":"information desk person tone 5","unicodeVersion":"8.0","digest":"2fde4e98dd11c5c29c89cad7cbb7bd2d5077dfad07913b20e01955b2d0dfad40"},"information_source":{"category":"symbols","moji":"ℹ","description":"information source","unicodeVersion":"3.0","digest":"b6bf3cce86d42c2e3c46470baab4af01e900b8ae337b605c3da07c3eba671269"},"innocent":{"category":"people","moji":"😇","description":"smiling face with halo","unicodeVersion":"6.0","digest":"20f8d856bc3e46f4b1173cea05d4577e1c61f06b2daba46e57db90f4066bb428"},"interrobang":{"category":"symbols","moji":"⁉","description":"exclamation question mark","unicodeVersion":"3.0","digest":"92a2d5b4c0bd6714e402f6f12fe19774cb41d081b5e9c23c415ce794224d8117"},"iphone":{"category":"objects","moji":"📱","description":"mobile phone","unicodeVersion":"6.0","digest":"1ebc54215713cd4bf1c1e50770999f2512bb4fea29e37d0bb3a8aa2460ff875d"},"island":{"category":"travel","moji":"🏝","description":"desert island","unicodeVersion":"7.0","digest":"7f9eb5c0cd865762f7a0f187e09c1be442de7010e7c2e113d56aae998597c90d"},"izakaya_lantern":{"category":"objects","moji":"🏮","description":"izakaya lantern","unicodeVersion":"6.0","digest":"fbdc290e666d43d0776a73b955c26df4518692b35e72742e073705fc4ca2ae88"},"jack_o_lantern":{"category":"nature","moji":"🎃","description":"jack-o-lantern","unicodeVersion":"6.0","digest":"78d666c2e80f64bfb6796f53e5ba4960a83ec36192110e8661031bee2b5e370a"},"japan":{"category":"travel","moji":"🗾","description":"silhouette of japan","unicodeVersion":"6.0","digest":"e7d9d6ebf9047fdd3c52e074ba259659c6d8e51a6abae3cdb8d6cf6dbf9a93fe"},"japanese_castle":{"category":"travel","moji":"🏯","description":"japanese castle","unicodeVersion":"6.0","digest":"938ae132c403330288223b88d28c19a47224d4f254fbc2366ecef73d9633112c"},"japanese_goblin":{"category":"people","moji":"👺","description":"japanese goblin","unicodeVersion":"6.0","digest":"63d4bcf58b9d0c29612994432aad2ae35819fdd2890674e60a2f1d51601b742e"},"japanese_ogre":{"category":"people","moji":"👹","description":"japanese ogre","unicodeVersion":"6.0","digest":"434ceedd102e7dcbc07e086811673dd63659ddf8c3ec4d029a3d759a0abfcbdb"},"jeans":{"category":"people","moji":"👖","description":"jeans","unicodeVersion":"6.0","digest":"f986ad32e419cca81c995f8371f0189d1490172a97ebbeac60054a1af08949c5"},"joy":{"category":"people","moji":"😂","description":"face with tears of joy","unicodeVersion":"6.0","digest":"75d7a05043523d290c46d3b313b19ed3c95271f1110bcf234cf13d4273625b08"},"joy_cat":{"category":"people","moji":"😹","description":"cat face with tears of joy","unicodeVersion":"6.0","digest":"a65c999604147e5e20170fcb14f80a1ff0a633f991492e1f790b2ad4caec7b7e"},"joystick":{"category":"objects","moji":"🕹","description":"joystick","unicodeVersion":"7.0","digest":"671ee588f397a96f27056a67e6a06d6e8d22c2109ec57b2859badb5fec9cf8dd"},"juggling":{"category":"activity","moji":"🤹","description":"juggling","unicodeVersion":"9.0","digest":"1f5dafa78de8b37f3df88fdf3084d2380666bd74ab2f449754d8724f6f8dbfa5"},"juggling_tone1":{"category":"activity","moji":"🤹🏻","description":"juggling tone 1","unicodeVersion":"9.0","digest":"b0b4d020148c896be69c28b08e3c486f6db270d138c7ccf4be362b29eb99878d"},"juggling_tone2":{"category":"activity","moji":"🤹🏼","description":"juggling tone 2","unicodeVersion":"9.0","digest":"cfe0c1649b2fdca03673e0e64f3a7d06d4bd49b8954c769aeb7eb88b70ec99f4"},"juggling_tone3":{"category":"activity","moji":"🤹🏽","description":"juggling tone 3","unicodeVersion":"9.0","digest":"7f87022722008bb265abe245e8157dc7a61944f5da62b3cf86f26ee1b3bdef63"},"juggling_tone4":{"category":"activity","moji":"🤹🏾","description":"juggling tone 4","unicodeVersion":"9.0","digest":"1f00da8c05582c95501cc6c3fe5ce0f9bfbc16789dcee59844a8fe7831198583"},"juggling_tone5":{"category":"activity","moji":"🤹🏿","description":"juggling tone 5","unicodeVersion":"9.0","digest":"a195bf734788eb7961c00dbc05255a49da8b9d5042fada29b26cc20393d3ce52"},"kaaba":{"category":"travel","moji":"🕋","description":"kaaba","unicodeVersion":"8.0","digest":"a4618782f9583f077bd383965f1c91b9985a949bb7b6cec7af22914e7f5e9ab6"},"key":{"category":"objects","moji":"🔑","description":"key","unicodeVersion":"6.0","digest":"66719fa77a50a0827c8d47237e2704c03e38186e6fef80627a765473b2294c2e"},"key2":{"category":"objects","moji":"🗝","description":"old key","unicodeVersion":"7.0","digest":"f57240a014a9da5da3d4d98c17d0a55e0ff2e5f2d22731d2fc867105cff54c6e"},"keyboard":{"category":"objects","moji":"⌨","description":"keyboard","unicodeVersion":"1.1","digest":"34da8ff62ca964142f9281b80123dbba74deaac8d77fa61758c30cfb36c31386"},"kimono":{"category":"people","moji":"👘","description":"kimono","unicodeVersion":"6.0","digest":"637182590e256c8fb74ce4c0565f5180c07f06e3bdebf30138ed3259b209c27f"},"kiss":{"category":"people","moji":"💋","description":"kiss mark","unicodeVersion":"6.0","digest":"62f9b9ffcb01558cd5bb829344a1d1d399511663ff5235405c1f786c9416a94d"},"kiss_mm":{"category":"people","moji":"👨‍❤️‍💋‍👨","description":"kiss (man,man)","unicodeVersion":"6.0","digest":"6b0ae32ecb7ec0f0f43dc7a1350711185cce114c52752395f364ddbfb4f1fff4"},"kiss_ww":{"category":"people","moji":"👩‍❤️‍💋‍👩","description":"kiss (woman,woman)","unicodeVersion":"6.0","digest":"6de420cf752e706b1b7e9522b1b9be62eda069cb028c8fd587caf39f6a142e6a"},"kissing":{"category":"people","moji":"😗","description":"kissing face","unicodeVersion":"6.1","digest":"b4a505f9e3d7fbd0ac60111f0e678cf425a5fd1abc65a3e9db59ae4abcfb8e85"},"kissing_cat":{"category":"people","moji":"😽","description":"kissing cat face with closed eyes","unicodeVersion":"6.0","digest":"a00431bf10601db4998e78433279167e52cbd36aed885399482529d5cdab8636"},"kissing_closed_eyes":{"category":"people","moji":"😚","description":"kissing face with closed eyes","unicodeVersion":"6.0","digest":"ae474db7daf80fe0b82ae1f2a11672cfcd9f9126e100f6e6d4b8a0d135dce39d"},"kissing_heart":{"category":"people","moji":"😘","description":"face throwing a kiss","unicodeVersion":"6.0","digest":"bce372573bd3b347b555c1cd22087e03e650df73c8e0284ab668bf6633251632"},"kissing_smiling_eyes":{"category":"people","moji":"😙","description":"kissing face with smiling eyes","unicodeVersion":"6.1","digest":"f0f8636cb1a02b93cc72ce1b194b890fca823d91e35926b889be3ecfae79207f"},"kiwi":{"category":"food","moji":"🥝","description":"kiwifruit","unicodeVersion":"9.0","digest":"70a3a05f333d9455d2da12eed970bc3baae416286848fed8e5dd31b5be0819be"},"knife":{"category":"objects","moji":"🔪","description":"hocho","unicodeVersion":"6.0","digest":"e6189e4843c6e80875b4952fcddb0c858f7c6039b9214bbec6a261a1358425df"},"koala":{"category":"nature","moji":"🐨","description":"koala","unicodeVersion":"6.0","digest":"c58f7e0abae42c2218a85efed0e04151df67187815bebca7f3db6f435e0dab4d"},"koko":{"category":"symbols","moji":"🈁","description":"squared katakana koko","unicodeVersion":"6.0","digest":"5f45eb49bbf298e1fadedfe6cccc297850fcaaa4535e4cc911d48d979af55807"},"label":{"category":"objects","moji":"🏷","description":"label","unicodeVersion":"7.0","digest":"9550ed50cedbc56eb1bd22a8a0809d837048a33d6e2e6e7d65c50d95fa05a85d"},"large_blue_circle":{"category":"symbols","moji":"🔵","description":"large blue circle","unicodeVersion":"6.0","digest":"0df3fb3b09a6269459a3d9a1fe78db572190a948680844cfe758f53b6a482ff4"},"large_blue_diamond":{"category":"symbols","moji":"🔷","description":"large blue diamond","unicodeVersion":"6.0","digest":"7f646b4e9de2788ed09e45f72cb512c269dda4989029b39bf9a2556659321651"},"large_orange_diamond":{"category":"symbols","moji":"🔶","description":"large orange diamond","unicodeVersion":"6.0","digest":"80ae005ef9d79190c777f00de0993f8b3cb783f7051d76e971640c8c0827c338"},"last_quarter_moon":{"category":"nature","moji":"🌗","description":"last quarter moon symbol","unicodeVersion":"6.0","digest":"3d1f276607c685d50f4b70d00a57750a57ad9ad84256dafd2dc8eef8c72300c3"},"last_quarter_moon_with_face":{"category":"nature","moji":"🌜","description":"last quarter moon with face","unicodeVersion":"6.0","digest":"d516825ba52dc67f5a01433fb9df2aa77742d38efde4225983ebc4882cbdfe5d"},"laughing":{"category":"people","moji":"😆","description":"smiling face with open mouth and tightly-closed ey","unicodeVersion":"6.0","digest":"e9ea994b39650740c4961f070ed492d86b3acf6e6a830a6dadaa3a6872e81b81"},"leaves":{"category":"nature","moji":"🍃","description":"leaf fluttering in wind","unicodeVersion":"6.0","digest":"56a7a0e767a6f214d340d1b5989efd99fec52c6aa306ec5c3328e32234a1631b"},"ledger":{"category":"objects","moji":"📒","description":"ledger","unicodeVersion":"6.0","digest":"e58cb714353e96a2891a5d97910ff79660e637af909b81c49c919d3735db55b4"},"left_facing_fist":{"category":"people","moji":"🤛","description":"left-facing fist","unicodeVersion":"9.0","digest":"7861be485beefae0de341df2f21576666e22f63511a033e785752f30c07291da"},"left_facing_fist_tone1":{"category":"people","moji":"🤛🏻","description":"left facing fist tone 1","unicodeVersion":"9.0","digest":"2e4c4dd96b0e4b46fe0f9ce5666344d266d0f17a8544cbae73d96638d1955296"},"left_facing_fist_tone2":{"category":"people","moji":"🤛🏼","description":"left facing fist tone 2","unicodeVersion":"9.0","digest":"b96a63a801175ce98a75f0edad7b5574251a3fbbd894d8ab3f21aeeda366cc13"},"left_facing_fist_tone3":{"category":"people","moji":"🤛🏽","description":"left facing fist tone 3","unicodeVersion":"9.0","digest":"99df84635513c2ebfef24df1bd3705233e02149eef788c7b82ca0548df6f6ea5"},"left_facing_fist_tone4":{"category":"people","moji":"🤛🏾","description":"left facing fist tone 4","unicodeVersion":"9.0","digest":"68954842ca725aec0aa39bce4aa81aad17ac30f5f298561dfa411feb07414cd3"},"left_facing_fist_tone5":{"category":"people","moji":"🤛🏿","description":"left facing fist tone 5","unicodeVersion":"9.0","digest":"a419b33fae82612dc860ff48950c0547a1642d4f0c94b6547324440837d3bb21"},"left_luggage":{"category":"symbols","moji":"🛅","description":"left luggage","unicodeVersion":"6.0","digest":"6625077767a51163ea20cbc299f3c13fd5ccf1b5ce365ee702ef1fef6be3dadf"},"left_right_arrow":{"category":"symbols","moji":"↔","description":"left right arrow","unicodeVersion":"1.1","digest":"560fcf1b794eb0d5269c73b3f8da57540cbb8a6f1a9af7a9d10b202252247e34"},"leftwards_arrow_with_hook":{"category":"symbols","moji":"↩","description":"leftwards arrow with hook","unicodeVersion":"1.1","digest":"504714c5559b1bd35aa469be83069a923d1a25f364cac08c10df0195749e7b26"},"lemon":{"category":"food","moji":"🍋","description":"lemon","unicodeVersion":"6.0","digest":"ccca25bb6ac47770dba3aaf75144128f9a73299061969b25a35ad1733dcde5fe"},"leo":{"category":"symbols","moji":"♌","description":"leo","unicodeVersion":"1.1","digest":"f2ed930e279699962f189e0cac519cc29d339b3e82debfdc90c5b0935a7543bb"},"leopard":{"category":"nature","moji":"🐆","description":"leopard","unicodeVersion":"6.0","digest":"d4a8964b6f2cdf6ddf074d0f1f2f65783a1a43eb4af426905fad0e60899939c7"},"level_slider":{"category":"objects","moji":"🎚","description":"level slider","unicodeVersion":"7.0","digest":"48842324f54d971ebf548a89a82ac7f29e235702081c91b477b1a92d427290e7"},"levitate":{"category":"activity","moji":"🕴","description":"man in business suit levitating","unicodeVersion":"7.0","digest":"453c24bf2544ed3ef3c710a7fabbd5fdace4dc65cddd377274d30d921523b50b"},"libra":{"category":"symbols","moji":"♎","description":"libra","unicodeVersion":"1.1","digest":"e330ba05bb449db074bc23d1514246ca5e249110f44ddb5804e5510eef6deac1"},"lifter":{"category":"activity","moji":"🏋","description":"weight lifter","unicodeVersion":"7.0","digest":"d6c94a32eb863d14a2a01add8ab95040f42a55d9e3f90641a0fe143d58127558"},"lifter_tone1":{"category":"activity","moji":"🏋🏻","description":"weight lifter tone 1","unicodeVersion":"8.0","digest":"870acf2f554fce360b58d3e98b4c0558d7ec7775587776c0f9d40c6fb1bdacf9"},"lifter_tone2":{"category":"activity","moji":"🏋🏼","description":"weight lifter tone 2","unicodeVersion":"8.0","digest":"1a7ece8512e42241cdd95c85ccc509bc0ff9c7c6ffaff2be343c77f417a27576"},"lifter_tone3":{"category":"activity","moji":"🏋🏽","description":"weight lifter tone 3","unicodeVersion":"8.0","digest":"4bc633ee82a0fb59feba379fb6901a489e4ac849d758f9c8e7a1a0a26eaa380c"},"lifter_tone4":{"category":"activity","moji":"🏋🏾","description":"weight lifter tone 4","unicodeVersion":"8.0","digest":"d086fe5577b5ba80676f2224d886f8ebe4588314f429f12a34c52c971ed71b5c"},"lifter_tone5":{"category":"activity","moji":"🏋🏿","description":"weight lifter tone 5","unicodeVersion":"8.0","digest":"79b0edf6ce1fd024dd7f458e322ad8588af0b789a04cc1cf38380dc8b9c76f55"},"light_rail":{"category":"travel","moji":"🚈","description":"light rail","unicodeVersion":"6.0","digest":"2f30b23a738371690b2f00d96ddb5ceb90a1442b5478754626a3dfa263ed2fc1"},"link":{"category":"objects","moji":"🔗","description":"link symbol","unicodeVersion":"6.0","digest":"7bf567aabd1fc38b3d70422f9db3a13b50950cf6207e70962c9938827c196ccb"},"lion_face":{"category":"nature","moji":"🦁","description":"lion face","unicodeVersion":"8.0","digest":"dd24f2668e973ec973e97dc111f59a2cc14e9b608387401191dd53368d28d4fa"},"lips":{"category":"people","moji":"👄","description":"mouth","unicodeVersion":"6.0","digest":"8740d8086525c7a836d64625a6915cc1c59af69ba143456dbb59e0179276895e"},"lipstick":{"category":"people","moji":"💄","description":"lipstick","unicodeVersion":"6.0","digest":"751dcb22706a796033b13a2ccb94304236ec13207ad4d011e02d230ae33ab5c1"},"lizard":{"category":"nature","moji":"🦎","description":"lizard","unicodeVersion":"9.0","digest":"fb9191f9eab58b8403d4c4626ccbb14ba05c1f6944011751a8edcc4dd03c66e6"},"lock":{"category":"objects","moji":"🔒","description":"lock","unicodeVersion":"6.0","digest":"043b4fc0b8c79d47a07d91308e628e1ac262aea6c1ec05e6b84bf7bcdf89dc83"},"lock_with_ink_pen":{"category":"objects","moji":"🔏","description":"lock with ink pen","unicodeVersion":"6.0","digest":"7b5e959b26cf7296c7b230fc2be9feb9e38391c5001951a019d16b169a71aba9"},"lollipop":{"category":"food","moji":"🍭","description":"lollipop","unicodeVersion":"6.0","digest":"17b6a0df47ec758a2f9c087b46a6902cee344d39407ef4c321e408505cbb72ca"},"loop":{"category":"symbols","moji":"➿","description":"double curly loop","unicodeVersion":"6.0","digest":"9f20ecc34b3c871789ba7d0712aa31e7a74b6c1558ac8bea385bc40590056726"},"loud_sound":{"category":"symbols","moji":"🔊","description":"speaker with three sound waves","unicodeVersion":"6.0","digest":"64b12db9ddd8adf74a9fc2bd83c7979ea865113347f7ce8666e9ccf5019e715f"},"loudspeaker":{"category":"symbols","moji":"📢","description":"public address loudspeaker","unicodeVersion":"6.0","digest":"1e1f35d16dd2898ebaa6f2b2868203df6e09c8a70df069c92d6d1b5cb2ac0976"},"love_hotel":{"category":"travel","moji":"🏩","description":"love hotel","unicodeVersion":"6.0","digest":"ff8966a50fd47a216855488eb09a367d231fea21f49e7e5325191d32fb494473"},"love_letter":{"category":"objects","moji":"💌","description":"love letter","unicodeVersion":"6.0","digest":"037261c8ca4d72f7205e51664591696da2ae7ceb19f1c1c9f6123da5a5979d29"},"low_brightness":{"category":"symbols","moji":"🔅","description":"low brightness symbol","unicodeVersion":"6.0","digest":"a065d00a416e297c168b0a675cafcf492fedf94865cb21801a1be5a3914593d4"},"lying_face":{"category":"people","moji":"🤥","description":"lying face","unicodeVersion":"9.0","digest":"ce836170165e1b70938273f289c02c2106873cd9ab5472dbcd487c2f9f53f13d"},"m":{"category":"symbols","moji":"Ⓜ","description":"circled latin capital letter m","unicodeVersion":"1.1","digest":"54588ac2b7fcd53a96f17124e9de69b617613fcd5af9ad2930a094cb795bb9f4"},"mag":{"category":"objects","moji":"🔍","description":"left-pointing magnifying glass","unicodeVersion":"6.0","digest":"a6e31a2efa7d9427aaa30b45d9f4181ee55c44be08aea2df165a86e0e6d9eaa1"},"mag_right":{"category":"objects","moji":"🔎","description":"right-pointing magnifying glass","unicodeVersion":"6.0","digest":"c7d8ceeb05db261e5eaab31dc4da432d0d5592a2ed71e526c5a542daa230bbaf"},"mahjong":{"category":"symbols","moji":"🀄","description":"mahjong tile red dragon","unicodeVersion":"5.1","digest":"755d69f988434ce1c17531a8b7ac92ead6f5607c2635a22f10e0ad70f09fc3e6"},"mailbox":{"category":"objects","moji":"📫","description":"closed mailbox with raised flag","unicodeVersion":"6.0","digest":"2069091be90a530a43ef29d5ec7688c351bf4d5b08d63a0d20d72b67d639ec62"},"mailbox_closed":{"category":"objects","moji":"📪","description":"closed mailbox with lowered flag","unicodeVersion":"6.0","digest":"d88d65bfebb8216535fd055c69f319564b2cf0b0901820f8312f581864557ed4"},"mailbox_with_mail":{"category":"objects","moji":"📬","description":"open mailbox with raised flag","unicodeVersion":"6.0","digest":"69e966b4659128991a70c6a2dd4d647551bedb91bdf5ce688958686bbec56381"},"mailbox_with_no_mail":{"category":"objects","moji":"📭","description":"open mailbox with lowered flag","unicodeVersion":"6.0","digest":"9e92d8ee88f660ce56da61077c80ec26c5d8f54ebd2306c4cfa16f6c1b981f83"},"man":{"category":"people","moji":"👨","description":"man","unicodeVersion":"6.0","digest":"42b882d2c6aa095f1afcf901203838d95c1908bdc725519779186b9c33c728d7"},"man_dancing":{"category":"people","moji":"🕺","description":"man dancing","unicodeVersion":"9.0","digest":"9f632ee0c886d5f03c61e5f3a27668262c0cc2693b857a91c23c1e5ea3785b9e"},"man_dancing_tone1":{"category":"activity","moji":"🕺🏻","description":"man dancing tone 1","unicodeVersion":"9.0","digest":"6c56a16cb105bcdd97472645b3a351cebdbb1132cbfd18b0118f289db5fbe741"},"man_dancing_tone2":{"category":"activity","moji":"🕺🏼","description":"man dancing tone 2","unicodeVersion":"9.0","digest":"ed7e78c14d205a03fdd5581e5213add69a55e13b4cbaf76a6d5a0d6c80f53327"},"man_dancing_tone3":{"category":"activity","moji":"🕺🏽","description":"man dancing tone 3","unicodeVersion":"9.0","digest":"13b45403e11800163406206eedeb8b579cc83eca2f60246be97e099164387bc8"},"man_dancing_tone4":{"category":"activity","moji":"🕺🏾","description":"man dancing tone 4","unicodeVersion":"9.0","digest":"f6feb1b0b83565fadcdd1a8737d3daa08893e919547d2a06de899160162d9c4a"},"man_dancing_tone5":{"category":"activity","moji":"🕺🏿","description":"man dancing tone 5","unicodeVersion":"9.0","digest":"fe20a9ed9ba991653b4d0683de347ed7c226a5d75610307584a2ddd6fcd1e3f2"},"man_in_tuxedo":{"category":"people","moji":"🤵","description":"man in tuxedo","unicodeVersion":"9.0","digest":"4d451a971dfefedc4830ba78e19b123f250e09ae65baddccdc56c0f8aa3a9b50"},"man_in_tuxedo_tone1":{"category":"people","moji":"🤵🏻","description":"man in tuxedo tone 1","unicodeVersion":"9.0","digest":"2814833334fb211ae2ecb1fb5964e9752282d0fb4d7f3477de5dd2a4f812a793"},"man_in_tuxedo_tone2":{"category":"people","moji":"🤵🏼","description":"man in tuxedo tone 2","unicodeVersion":"9.0","digest":"cd1bab9ee0e2335d3cd99d51216cccdc4fc3c2cf20129b8b7e11a51a77258f68"},"man_in_tuxedo_tone3":{"category":"people","moji":"🤵🏽","description":"man in tuxedo tone 3","unicodeVersion":"9.0","digest":"f387775f925fe60b9f3e7cad63a55d4d196ddd41658029a70440d14c17cb99f9"},"man_in_tuxedo_tone4":{"category":"people","moji":"🤵🏾","description":"man in tuxedo tone 4","unicodeVersion":"9.0","digest":"08debd7a573d1201aee8a2f281ef7cb638d4a2a096222150391f36963f07c622"},"man_in_tuxedo_tone5":{"category":"people","moji":"🤵🏿","description":"man in tuxedo tone 5","unicodeVersion":"9.0","digest":"e3b10e0619f0911cf9b665a265f4ef829b8f6ba6e9c3a021d0539a27e315f8fe"},"man_tone1":{"category":"people","moji":"👨🏻","description":"man tone 1","unicodeVersion":"8.0","digest":"7053e265fa7d2594de54a6c5d06c21795b9a7dfb36a1c5594ca43c4c6cc56504"},"man_tone2":{"category":"people","moji":"👨🏼","description":"man tone 2","unicodeVersion":"8.0","digest":"7ebc64de40d3ac60fb761be5cf94f53fa10b4f03fb66add46c90f5d98eaf71eb"},"man_tone3":{"category":"people","moji":"👨🏽","description":"man tone 3","unicodeVersion":"8.0","digest":"77ceef4d3740ed4751acb83dd45b6b754cf625c522c6757309cd4d61202d7149"},"man_tone4":{"category":"people","moji":"👨🏾","description":"man tone 4","unicodeVersion":"8.0","digest":"41e6037c393f61cca61b9a81b27ed14a95d75fe380e3a00153c33a371a836ffd"},"man_tone5":{"category":"people","moji":"👨🏿","description":"man tone 5","unicodeVersion":"8.0","digest":"a8cebfd39a5b9c79af7cc37f205e1135376056fee287af967c9f55d415572d99"},"man_with_gua_pi_mao":{"category":"people","moji":"👲","description":"man with gua pi mao","unicodeVersion":"6.0","digest":"3dae285e900c69986a48db0fa89d4f371a49f38608059cdae52be098030c5ac4"},"man_with_gua_pi_mao_tone1":{"category":"people","moji":"👲🏻","description":"man with gua pi mao tone 1","unicodeVersion":"8.0","digest":"35404d8e266920c78edd9e7143fb052b42f65242a5698494c4f4365e9183cc67"},"man_with_gua_pi_mao_tone2":{"category":"people","moji":"👲🏼","description":"man with gua pi mao tone 2","unicodeVersion":"8.0","digest":"82d4f968665a93c7543372c8a1eeb0f25d0ea6842d5e518bd91c226c6c3ab8c2"},"man_with_gua_pi_mao_tone3":{"category":"people","moji":"👲🏽","description":"man with gua pi mao tone 3","unicodeVersion":"8.0","digest":"f44159f0c672b9b833449382896180e799abf574f5b3c6cd9541caa992fa18ce"},"man_with_gua_pi_mao_tone4":{"category":"people","moji":"👲🏾","description":"man with gua pi mao tone 4","unicodeVersion":"8.0","digest":"c79060188f9461ca34eaa225b7682d8c410883609509fb731c992db69bfeeb50"},"man_with_gua_pi_mao_tone5":{"category":"people","moji":"👲🏿","description":"man with gua pi mao tone 5","unicodeVersion":"8.0","digest":"de9e4acdb10f7abddeeabc0b48d91139fc8b544a601c530db811f099991b0d38"},"man_with_turban":{"category":"people","moji":"👳","description":"man with turban","unicodeVersion":"6.0","digest":"db72c944e93983f38d00e3e936ebb5b243c6069f1f1236d46f6a9f1beb8d6634"},"man_with_turban_tone1":{"category":"people","moji":"👳🏻","description":"man with turban tone 1","unicodeVersion":"8.0","digest":"b6d7489c4cd151af09fff48b62c54c336303e14866e6ef38f94cd834b085d09e"},"man_with_turban_tone2":{"category":"people","moji":"👳🏼","description":"man with turban tone 2","unicodeVersion":"8.0","digest":"7854ef973c21847f452d7e78e5c460ea300e12b539ce92c69dabe8f1bf3a4382"},"man_with_turban_tone3":{"category":"people","moji":"👳🏽","description":"man with turban tone 3","unicodeVersion":"8.0","digest":"1dbd9bd78f5263cbadee7d0d5754c14cfbc914f7329e25fbd97d9f5b8ce0737e"},"man_with_turban_tone4":{"category":"people","moji":"👳🏾","description":"man with turban tone 4","unicodeVersion":"8.0","digest":"4f4804da4a7c98ad4f9db3ae3eaf674c8977c638e73414e33ef1f65098e413a3"},"man_with_turban_tone5":{"category":"people","moji":"👳🏿","description":"man with turban tone 5","unicodeVersion":"8.0","digest":"240282aa346ef9b1d0d475ea93a02597697f0f56f086305879b532b0b933210a"},"mans_shoe":{"category":"people","moji":"👞","description":"mans shoe","unicodeVersion":"6.0","digest":"f53fe74abd9906cd3e2dd7e7bddbe1feb9f8f7be28b807fabe452f1f60ca1b84"},"map":{"category":"objects","moji":"🗺","description":"world map","unicodeVersion":"7.0","digest":"84f496a062b5c3ae1e8013506175a69036038c8130891bcf780a69ce7fcbe4de"},"maple_leaf":{"category":"nature","moji":"🍁","description":"maple leaf","unicodeVersion":"6.0","digest":"72629a205e33f89337815ad7e51bb5c73947d1a9f98afe5072bdf4846827ae72"},"martial_arts_uniform":{"category":"activity","moji":"🥋","description":"martial arts uniform","unicodeVersion":"9.0","digest":"a1ae797b31081425b388ab31efc635d8eb73a40980fd0fae4708aa5313e2a964"},"mask":{"category":"people","moji":"😷","description":"face with medical mask","unicodeVersion":"6.0","digest":"1b58af9ae599308aabf41bbd38f599fa896bd9fe5df7a40be9f2dc7e0e230600"},"massage":{"category":"people","moji":"💆","description":"face massage","unicodeVersion":"6.0","digest":"6ee48b4d8cec0bf31e11d7803ad9fc1f909457c8c00cb320b5671395af3c170c"},"massage_tone1":{"category":"people","moji":"💆🏻","description":"face massage tone 1","unicodeVersion":"8.0","digest":"9da162c2f39628156b87db986a6ada59372a9e9a6b3f0488d21c9e65ec3309bb"},"massage_tone2":{"category":"people","moji":"💆🏼","description":"face massage tone 2","unicodeVersion":"8.0","digest":"ac259188549b5b429b8c4929e1da2314859e8857ee49720551467aedfcc96567"},"massage_tone3":{"category":"people","moji":"💆🏽","description":"face massage tone 3","unicodeVersion":"8.0","digest":"cfd9c105b6debc10448f172afcb20d4192899f7ae5aa8af54c834153a5466364"},"massage_tone4":{"category":"people","moji":"💆🏾","description":"face massage tone 4","unicodeVersion":"8.0","digest":"38ab715c621c58454f3cb09153a96380118cf082568554b6edc5f83fb62e9297"},"massage_tone5":{"category":"people","moji":"💆🏿","description":"face massage tone 5","unicodeVersion":"8.0","digest":"32480457734121b0c83e9be6d693ae379c95535f43f963c0c2f0f20434ee12c6"},"meat_on_bone":{"category":"food","moji":"🍖","description":"meat on bone","unicodeVersion":"6.0","digest":"d71a8e0b118d5e6ca60690793ce9649afb78e707fcbd7be890a75564c94434fd"},"medal":{"category":"activity","moji":"🏅","description":"sports medal","unicodeVersion":"7.0","digest":"9600cbe57e08da090c60629bcafd2821c87322e738c2454f8e883ceb756e7391"},"mega":{"category":"symbols","moji":"📣","description":"cheering megaphone","unicodeVersion":"6.0","digest":"4b1def6b5b051c5045514063f0ac006222ad81fbfe56d840e14bb950713e331b"},"melon":{"category":"food","moji":"🍈","description":"melon","unicodeVersion":"6.0","digest":"0cdd663e6f2129808856cdf0746e6571b62aac641f224adb553baf3bb63ba3bd"},"menorah":{"category":"symbols","moji":"🕎","description":"menorah with nine branches","unicodeVersion":"8.0","digest":"49fca8c3bc00ea69653ee2f8d4e21e561856ba39716c13e9d107db3e805a2997"},"mens":{"category":"symbols","moji":"🚹","description":"mens symbol","unicodeVersion":"6.0","digest":"7d92292586ee12a5d1a557c37da4d14708dc3ce701cf32d3280dcc83d91e5df8"},"metal":{"category":"people","moji":"🤘","description":"sign of the horns","unicodeVersion":"8.0","digest":"ffb750caf187f5d821c990108e2699ac3e216492bcff6ee543f4a7aa55b9fd29"},"metal_tone1":{"category":"people","moji":"🤘🏻","description":"sign of the horns tone 1","unicodeVersion":"8.0","digest":"5505f0b0340f9ba572db8897e40adf598cfa784686ad5ee360a7351bf44ddc1d"},"metal_tone2":{"category":"people","moji":"🤘🏼","description":"sign of the horns tone 2","unicodeVersion":"8.0","digest":"8f9eee3ad5fc7eeeb30118d16d27467b16fd87297e0ecf02656db77e701f5aeb"},"metal_tone3":{"category":"people","moji":"🤘🏽","description":"sign of the horns tone 3","unicodeVersion":"8.0","digest":"8270a7ecf5eb11431a07ef04cc476c2651ac8aacb0d4768e5cb69355f8a5e84e"},"metal_tone4":{"category":"people","moji":"🤘🏾","description":"sign of the horns tone 4","unicodeVersion":"8.0","digest":"f24f7b137dd6c7899dc0a8794204bbde7ad43ec1e63b419c90dd70a8b77871e8"},"metal_tone5":{"category":"people","moji":"🤘🏿","description":"sign of the horns tone 5","unicodeVersion":"8.0","digest":"07b0726a632653b980df775f460cd3fe1ea8d4a7b0b46fe29e089b66579482d2"},"metro":{"category":"travel","moji":"🚇","description":"metro","unicodeVersion":"6.0","digest":"b380247b61b5e2ca1b9b70fabff65907b2c3a5191a14b169ae094af94659b9b1"},"microphone":{"category":"activity","moji":"🎤","description":"microphone","unicodeVersion":"6.0","digest":"9ef4fc2e40d5391c4bb2d30f34f59662cff7cbb1b04341c9dac210d0e21b44ae"},"microphone2":{"category":"objects","moji":"🎙","description":"studio microphone","unicodeVersion":"7.0","digest":"8a30464d51f7f101335778444c43270ac0679900f49463e6556682d9db1cb4dc"},"microscope":{"category":"objects","moji":"🔬","description":"microscope","unicodeVersion":"6.0","digest":"4ca4322c6ba99b8c15acdb8b605f84f87398769e504b262b134c1f3868b2692f"},"middle_finger":{"category":"people","moji":"🖕","description":"reversed hand with middle finger extended","unicodeVersion":"7.0","digest":"0c3f1cc0ec7323f6d19508ad22fa90050845f7b5cc83f599ab2cacb89cf5dd0e"},"middle_finger_tone1":{"category":"people","moji":"🖕🏻","description":"reversed hand with middle finger extended tone 1","unicodeVersion":"8.0","digest":"4ebecf1058a3059aaa826eaad39c1a791120f115f65dde6d6ae32fc5561f60f7"},"middle_finger_tone2":{"category":"people","moji":"🖕🏼","description":"reversed hand with middle finger extended tone 2","unicodeVersion":"8.0","digest":"85ff506a08c38663c2dfa2e3a90584c02a36aa3dda33af47cdb49834bf9baf83"},"middle_finger_tone3":{"category":"people","moji":"🖕🏽","description":"reversed hand with middle finger extended tone 3","unicodeVersion":"8.0","digest":"cac697ff5207bf8a4e091912f3127f4e73c88ef69b5c6561d1d7b12ed60be8f1"},"middle_finger_tone4":{"category":"people","moji":"🖕🏾","description":"reversed hand with middle finger extended tone 4","unicodeVersion":"8.0","digest":"9324a5a4e3986b798ad8c61f31c18fb507ca7a4abfd6e9ae1408b80b185bf8c7"},"middle_finger_tone5":{"category":"people","moji":"🖕🏿","description":"reversed hand with middle finger extended tone 5","unicodeVersion":"8.0","digest":"078f917cd4d8be08a880724e9400449980d92740ccbee4a57f5046a9cf7f6575"},"military_medal":{"category":"activity","moji":"🎖","description":"military medal","unicodeVersion":"7.0","digest":"5da18351dc14b66cfc070148c83b7c8e67e6b1e3f515ae501133c38ee5c28d3d"},"milk":{"category":"food","moji":"🥛","description":"glass of milk","unicodeVersion":"9.0","digest":"38b28ea40399601fabc95bac5eaaf5a9e4e25548ec80325bd5069395ea884f85"},"milky_way":{"category":"travel","moji":"🌌","description":"milky way","unicodeVersion":"6.0","digest":"17405ff31d94b13a1fb0adcda204b8adb95ca340bc3980d9ad9f42ba1e366e7d"},"minibus":{"category":"travel","moji":"🚐","description":"minibus","unicodeVersion":"6.0","digest":"08ccb4b1bf397b7c9aed901e2b5dcdd6cb8ca5c5487ef26775bb3120f7b92524"},"minidisc":{"category":"objects","moji":"💽","description":"minidisc","unicodeVersion":"6.0","digest":"bebf82c0b91ef66321e7ae7a0abf322e59b2f7d8e6fbf9a94243210c00229c59"},"mobile_phone_off":{"category":"symbols","moji":"📴","description":"mobile phone off","unicodeVersion":"6.0","digest":"6f9d8d6a32fc998f5d8144a5ff7e2ad00de37ad464cd97285e7c72efb09a1feb"},"money_mouth":{"category":"people","moji":"🤑","description":"money-mouth face","unicodeVersion":"8.0","digest":"5a43973dadf48a89201b1816fea9972c5cfe501a26fe457b6f7eee0a6362018e"},"money_with_wings":{"category":"objects","moji":"💸","description":"money with wings","unicodeVersion":"6.0","digest":"15fcf0595021374ba091ca00efdb4167770da4d421eab930964108545f4edab9"},"moneybag":{"category":"objects","moji":"💰","description":"money bag","unicodeVersion":"6.0","digest":"02d708e2f603b0df6f6c169b5c49b3452e1c02e7d72e96f228b73d0b0a20bff4"},"monkey":{"category":"nature","moji":"🐒","description":"monkey","unicodeVersion":"6.0","digest":"3588a544d6d9e9995b45d60327a1a42002fa1faa4d48224b140facd249af1c67"},"monkey_face":{"category":"nature","moji":"🐵","description":"monkey face","unicodeVersion":"6.0","digest":"9e263ef5ca42bb76d1b1d1e3cbf020bcf05023a6e9f91301d30c9eb406363a2a"},"monorail":{"category":"travel","moji":"🚝","description":"monorail","unicodeVersion":"6.0","digest":"2c9f185babcb4001fcef2b8dfc4a32126729843084d0076c3e3ccdc845ab23ad"},"mortar_board":{"category":"people","moji":"🎓","description":"graduation cap","unicodeVersion":"6.0","digest":"d7fbe41d4b340d3564e484aec46a22c9613521414b2ba6eece2180db4d23e410"},"mosque":{"category":"travel","moji":"🕌","description":"mosque","unicodeVersion":"8.0","digest":"5f3d3de7feac953a70a318113531c2857d760a516c3d8d6f42d2a3b3b67ed196"},"motor_scooter":{"category":"travel","moji":"🛵","description":"motor scooter","unicodeVersion":"9.0","digest":"e2dc7c981744a71f46858bd0858ff91af704ac06425ed80377bc3b119e57c872"},"motorboat":{"category":"travel","moji":"🛥","description":"motorboat","unicodeVersion":"7.0","digest":"81c156643528c5a94a12d6d478e52a019f5a4e3eb58ee365cdd9d2361a7fdb01"},"motorcycle":{"category":"travel","moji":"🏍","description":"racing motorcycle","unicodeVersion":"7.0","digest":"354aa8157732184ad50eff9330f7a8915309dc9b7893cc308226adb429311a62"},"motorway":{"category":"travel","moji":"🛣","description":"motorway","unicodeVersion":"7.0","digest":"148c3c13c7c4565453d16e504e0d4b8d007e4f2cad1ab56b1b51fefe39162d17"},"mount_fuji":{"category":"travel","moji":"🗻","description":"mount fuji","unicodeVersion":"6.0","digest":"f8093b9dba62b22c6c88f137be88b2fd3971c560714db15ec053cf697a3820bc"},"mountain":{"category":"travel","moji":"⛰","description":"mountain","unicodeVersion":"5.2","digest":"07423804ad79da68f140948d29df193f5d5343b7b2c23758c086697c4d3a50da"},"mountain_bicyclist":{"category":"activity","moji":"🚵","description":"mountain bicyclist","unicodeVersion":"6.0","digest":"91084b6c887cb7e34f3d7ec30656ecb82c36cc987f53a6c83ccb4c6f7950f96a"},"mountain_bicyclist_tone1":{"category":"activity","moji":"🚵🏻","description":"mountain bicyclist tone 1","unicodeVersion":"8.0","digest":"5d57fcfad61bca26c3e8965eb57602a1993a3117ebdda0f24569af730310ab6e"},"mountain_bicyclist_tone2":{"category":"activity","moji":"🚵🏼","description":"mountain bicyclist tone 2","unicodeVersion":"8.0","digest":"c0da7fb85d99aa01a665f64063cd7e2d994f8a16d3f6fbf52df5d471e771a98a"},"mountain_bicyclist_tone3":{"category":"activity","moji":"🚵🏽","description":"mountain bicyclist tone 3","unicodeVersion":"8.0","digest":"b099e7ee84eae44ebc99023fa06bdf37ffa0d69767c7c0163a89f7ced2a26765"},"mountain_bicyclist_tone4":{"category":"activity","moji":"🚵🏾","description":"mountain bicyclist tone 4","unicodeVersion":"8.0","digest":"9d09f7b3899ea44e736f237a161ef8d5170dccfa162a872c59532ceaf65ee007"},"mountain_bicyclist_tone5":{"category":"activity","moji":"🚵🏿","description":"mountain bicyclist tone 5","unicodeVersion":"8.0","digest":"71e374981d955056748a60c6d1820b45e9688a156b55318b4ea54a3a67ca801c"},"mountain_cableway":{"category":"travel","moji":"🚠","description":"mountain cableway","unicodeVersion":"6.0","digest":"e261c3292758b1c0063c5a0d0c7f5c9803306d2265e08677027e1210506ced94"},"mountain_railway":{"category":"travel","moji":"🚞","description":"mountain railway","unicodeVersion":"6.0","digest":"b0987f8f391b3cbc7a56b9b8945ebfca240e01d12f8fd163877ebebe51d6b277"},"mountain_snow":{"category":"travel","moji":"🏔","description":"snow capped mountain","unicodeVersion":"7.0","digest":"49aac2b851aa6f2bd2ca641efa8060f93e89395357f49d211658d46f5a2b0189"},"mouse":{"category":"nature","moji":"🐭","description":"mouse face","unicodeVersion":"6.0","digest":"007dd108507b45224f7a1fad3c1de6ecc75f38d71fc142744611eb13555f5eff"},"mouse2":{"category":"nature","moji":"🐁","description":"mouse","unicodeVersion":"6.0","digest":"f3ed37b639b7c16aae49502bd423f9fdeabaf15bc6f0f74063954b189e176b5d"},"mouse_three_button":{"category":"objects","moji":"🖱","description":"three button mouse","unicodeVersion":"7.0","digest":"3724341ac5ad0d01027ef1575db64f1db7619f590ca6ada960d1f2c18dc7fc6a"},"movie_camera":{"category":"objects","moji":"🎥","description":"movie camera","unicodeVersion":"6.0","digest":"f7e285eda35b4431c07951e071643ddc34147cd76640e0d516fbfd11208346e9"},"moyai":{"category":"objects","moji":"🗿","description":"moyai","unicodeVersion":"6.0","digest":"2c1d0662c95928936e6b9ab5a40c6110ff1cea5339f2803c7b63aabc76115afb"},"mrs_claus":{"category":"people","moji":"🤶","description":"mother christmas","unicodeVersion":"9.0","digest":"357d769371305a8584f46d6087a962d647b6af22fab363a44702f38ab7814091"},"mrs_claus_tone1":{"category":"people","moji":"🤶🏻","description":"mother christmas tone 1","unicodeVersion":"9.0","digest":"244596919e0fed050203cf9e040899de323d7821235929f175852439927bd129"},"mrs_claus_tone2":{"category":"people","moji":"🤶🏼","description":"mother christmas tone 2","unicodeVersion":"9.0","digest":"8cde96e8521f3a90262a7f5f8a2989a9590d9a02cda2c37e92335dc05975c18d"},"mrs_claus_tone3":{"category":"people","moji":"🤶🏽","description":"mother christmas tone 3","unicodeVersion":"9.0","digest":"c39cd4346d4581799dd0e9a6447c91a954a75747bf2682c8e4d79c3b0fcf7405"},"mrs_claus_tone4":{"category":"people","moji":"🤶🏾","description":"mother christmas tone 4","unicodeVersion":"9.0","digest":"84c85cf54559ea2d78d196fee96149a249af4f959b78e223a0ec4fb72abdbcab"},"mrs_claus_tone5":{"category":"people","moji":"🤶🏿","description":"mother christmas tone 5","unicodeVersion":"9.0","digest":"ce26c0e0645713b17e7497d9f2d0484cc5477564dae99320cabf04d160d3b2ff"},"muscle":{"category":"people","moji":"💪","description":"flexed biceps","unicodeVersion":"6.0","digest":"e4ce52757b2b7982e2516e0e8bf2e2253617cc9f3e6178f1887c61c9039461ba"},"muscle_tone1":{"category":"people","moji":"💪🏻","description":"flexed biceps tone 1","unicodeVersion":"8.0","digest":"4a2fa226a05bb847b62cdd163eb6c2d514d3c2330a727991cf550c0d32b0e818"},"muscle_tone2":{"category":"people","moji":"💪🏼","description":"flexed biceps tone 2","unicodeVersion":"8.0","digest":"a8d5ecce335c782ca5f5e55763c06cfefa1c16c24cd6602237cf125d4ff95e47"},"muscle_tone3":{"category":"people","moji":"💪🏽","description":"flexed biceps tone 3","unicodeVersion":"8.0","digest":"070354b443faec3969663b770545fc4cf5ec75148557b2b9d6fc82ab22b43bd1"},"muscle_tone4":{"category":"people","moji":"💪🏾","description":"flexed biceps tone 4","unicodeVersion":"8.0","digest":"8eafcdb6a607aeafa673c257df0d2a1b20f00fc0868d811babcbe784490a0dd3"},"muscle_tone5":{"category":"people","moji":"💪🏿","description":"flexed biceps tone 5","unicodeVersion":"8.0","digest":"85a1e2b5c89907694240e9c5b9d876a741fa7ba38918c5718273e289cbc40efe"},"mushroom":{"category":"nature","moji":"🍄","description":"mushroom","unicodeVersion":"6.0","digest":"aaca8cf7c5cfa4487b5fef365a231f98be4bbf041197fc022161bcc8ce6f57c8"},"musical_keyboard":{"category":"activity","moji":"🎹","description":"musical keyboard","unicodeVersion":"6.0","digest":"fb0a726728900377d76d94aac9c94dce29107e8e3f1dcb0599d95bce7169b492"},"musical_note":{"category":"symbols","moji":"🎵","description":"musical note","unicodeVersion":"6.0","digest":"41288e79b4070bb980281d0e0d1c14d8b144b4aedb2eaadb9f2bebcb4ef892b4"},"musical_score":{"category":"activity","moji":"🎼","description":"musical score","unicodeVersion":"6.0","digest":"f0f91b9fa4a2bff7a5a1a11afa6f31cfe7e5fa8b0d6f3cce904b781a28ed0277"},"mute":{"category":"symbols","moji":"🔇","description":"speaker with cancellation stroke","unicodeVersion":"6.0","digest":"def277da49d744b55c7cdde269a15aa05315898f615e721ee7e9205d7b8030d6"},"nail_care":{"category":"people","moji":"💅","description":"nail polish","unicodeVersion":"6.0","digest":"48b33b1dbbd25b4f34ab2ca07bb99ddaaaa741990142c5623310f76b78c076f9"},"nail_care_tone1":{"category":"people","moji":"💅🏻","description":"nail polish tone 1","unicodeVersion":"8.0","digest":"a9ac92a34f407e7dd7c71377e6275e66657f7f42e4b911c540d1a66a02d92ac5"},"nail_care_tone2":{"category":"people","moji":"💅🏼","description":"nail polish tone 2","unicodeVersion":"8.0","digest":"f295ec85980aaa75818fad619c3d25042146ecbbf361db9e9bb96e7bc202bc73"},"nail_care_tone3":{"category":"people","moji":"💅🏽","description":"nail polish tone 3","unicodeVersion":"8.0","digest":"02ec373052a250977298bae85262177910126cc10de9480f1afa328ac2f65a95"},"nail_care_tone4":{"category":"people","moji":"💅🏾","description":"nail polish tone 4","unicodeVersion":"8.0","digest":"f3d95390ab59caedfda66122bbd0acf3aabedc142fc48352d68900766a7e6f5c"},"nail_care_tone5":{"category":"people","moji":"💅🏿","description":"nail polish tone 5","unicodeVersion":"8.0","digest":"009423c97f2aafd24fb8c7c485c58b30bbf9ae6797cc14b80d472b207327b518"},"name_badge":{"category":"symbols","moji":"📛","description":"name badge","unicodeVersion":"6.0","digest":"f9f6a4895ff0be8fb2ccc7ad195b94e9650f742f66ead999e90724cfb77af628"},"nauseated_face":{"category":"people","moji":"🤢","description":"nauseated face","unicodeVersion":"9.0","digest":"f8471cf4720948d8246ec9d30e29783e819f90e3cfe8b1ba628671a1aad1a91c"},"necktie":{"category":"people","moji":"👔","description":"necktie","unicodeVersion":"6.0","digest":"01bb18dc8bfe787daa9613b5d09988cd5a065449ef906099ce3cb308c8a7da68"},"negative_squared_cross_mark":{"category":"symbols","moji":"❎","description":"negative squared cross mark","unicodeVersion":"6.0","digest":"1cdaf4abc9adafa089c91c2e33a24e9e647aea0f857e767941a899a16ec53b74"},"nerd":{"category":"people","moji":"🤓","description":"nerd face","unicodeVersion":"8.0","digest":"9e5f3c93db25cf1d0f9d6e6bd2993161afec6c30573ba3fe85e13b8c84483d66"},"neutral_face":{"category":"people","moji":"😐","description":"neutral face","unicodeVersion":"6.0","digest":"7449430a60619956573e9dc80834045296f2b99853737b6c7794c785ff53d64e"},"new":{"category":"symbols","moji":"🆕","description":"squared new","unicodeVersion":"6.0","digest":"e20bc3e9f40726afd0cfb7268d02f1e1a07343364fd08b252d59f38de067bf06"},"new_moon":{"category":"nature","moji":"🌑","description":"new moon symbol","unicodeVersion":"6.0","digest":"dbfc5dcae34b45f15ff767e297cba3a12cb83f3b542db8cfc8dbd9669e0df46c"},"new_moon_with_face":{"category":"nature","moji":"🌚","description":"new moon with face","unicodeVersion":"6.0","digest":"c66d347d2222ac8d77d323a07699aff6b168328648db4f885b1ed0e2831fd59b"},"newspaper":{"category":"objects","moji":"📰","description":"newspaper","unicodeVersion":"6.0","digest":"c05e986d9cdac11afa30c6a21a72572ddf50fc64e87ae0c4e0ad57ffe70acc5c"},"newspaper2":{"category":"objects","moji":"🗞","description":"rolled-up newspaper","unicodeVersion":"7.0","digest":"63db7bcf51effc73e5124392740736383774a4bcfbc1156cf55599504760883d"},"ng":{"category":"symbols","moji":"🆖","description":"squared ng","unicodeVersion":"6.0","digest":"34d5a11c70f48ea719e602908534f446b192622e775d4160f0e1ec52c342a35c"},"night_with_stars":{"category":"travel","moji":"🌃","description":"night with stars","unicodeVersion":"6.0","digest":"39d9c079be80ee6ce1667531be528a2aa7f8bd46c7b6c2a6ee279d9a207c84a4"},"nine":{"category":"symbols","moji":"9️⃣","description":"keycap digit nine","unicodeVersion":"3.0","digest":"8bb40750eda8506ef877c9a3b8e2039d26f20eef345742f635740574a7e8daa6"},"no_bell":{"category":"symbols","moji":"🔕","description":"bell with cancellation stroke","unicodeVersion":"6.0","digest":"6542a9a5656c79c153f8c37f12d48f677c89b02ed0989ae37fa5e51ce6895422"},"no_bicycles":{"category":"symbols","moji":"🚳","description":"no bicycles","unicodeVersion":"6.0","digest":"af71c183545da2ff4c05609f9d572edb64b63ccba7c6a4b208d271558aa92b0a"},"no_entry":{"category":"symbols","moji":"⛔","description":"no entry","unicodeVersion":"5.2","digest":"dc0bac1ed9ab8e9af143f0fce5043fe68f7f46bd80856cdec95d20c3999b637d"},"no_entry_sign":{"category":"symbols","moji":"🚫","description":"no entry sign","unicodeVersion":"6.0","digest":"2c1fceef23b62effca68e0e087b8f020125d25b98d61492b1540055d1914fdc3"},"no_good":{"category":"people","moji":"🙅","description":"face with no good gesture","unicodeVersion":"6.0","digest":"6eb970b104389be5d18657d7c04be5149958c26855c52ea68574af852c5f85c4"},"no_good_tone1":{"category":"people","moji":"🙅🏻","description":"face with no good gesture tone 1","unicodeVersion":"8.0","digest":"c20a24a1e536240b4dcf90ecb530796de621d7ba1fb9e3fa0f849d048c509c03"},"no_good_tone2":{"category":"people","moji":"🙅🏼","description":"face with no good gesture tone 2","unicodeVersion":"8.0","digest":"f31a4628c1f2e6a39288fda8eb19c9ec89983e3726e17a09384d9ecc13ef0b4c"},"no_good_tone3":{"category":"people","moji":"🙅🏽","description":"face with no good gesture tone 3","unicodeVersion":"8.0","digest":"959dec1bfdaf37b20a86ab2bcbdbacd3179c87b163042377d966eab47564c0fb"},"no_good_tone4":{"category":"people","moji":"🙅🏾","description":"face with no good gesture tone 4","unicodeVersion":"8.0","digest":"efd931f0080adf2e04129c83a8b24fda0ae7a9fa7c4b463686c0b99023620db8"},"no_good_tone5":{"category":"people","moji":"🙅🏿","description":"face with no good gesture tone 5","unicodeVersion":"8.0","digest":"f35df2b26af9baef47c1f8cc97a1b28a58aa7fcb2a13fdac7b2d9189f1e40105"},"no_mobile_phones":{"category":"symbols","moji":"📵","description":"no mobile phones","unicodeVersion":"6.0","digest":"a472decd6ac7f9777961c09e00458746b2c04965585e3bee4556be3968e55bcd"},"no_mouth":{"category":"people","moji":"😶","description":"face without mouth","unicodeVersion":"6.0","digest":"72dda8b1e3ad4b05d9b095f9bd05e95d7ba013906c68914976a4554e8edf5866"},"no_pedestrians":{"category":"symbols","moji":"🚷","description":"no pedestrians","unicodeVersion":"6.0","digest":"062b4a71b338fe09775e465bfba8ac04efbb3640330e8cabe88f3af62b0f4225"},"no_smoking":{"category":"symbols","moji":"🚭","description":"no smoking symbol","unicodeVersion":"6.0","digest":"ae2ebb331f79f6074091c0ee9cd69fce16d5e12a131d18973fc05520097e14ee"},"non-potable_water":{"category":"symbols","moji":"🚱","description":"non-potable water symbol","unicodeVersion":"6.0","digest":"32eba0a99b498133c2e4450036f768d3dccaaf5b50adc9ad988757adc777a6a1"},"nose":{"category":"people","moji":"👃","description":"nose","unicodeVersion":"6.0","digest":"9f800e24658ea3cebe1144d5d808cf13a88261f1a7f1f81a10d03b3d9d00e541"},"nose_tone1":{"category":"people","moji":"👃🏻","description":"nose tone 1","unicodeVersion":"8.0","digest":"a2d0af22284b1d264eb780943b8360f463996a5c9c9584b8473edf8d442d9173"},"nose_tone2":{"category":"people","moji":"👃🏼","description":"nose tone 2","unicodeVersion":"8.0","digest":"244dcaa8540024cf521f29f36bd48f933bf82f4833e35e6fa0abf113022038f3"},"nose_tone3":{"category":"people","moji":"👃🏽","description":"nose tone 3","unicodeVersion":"8.0","digest":"c935b64866f0d49da52035aa09f36ff56d238eb7f5b92205386451056e8ea74f"},"nose_tone4":{"category":"people","moji":"👃🏾","description":"nose tone 4","unicodeVersion":"8.0","digest":"a87e95fd9319c49e66b6dea0e57319d0ed9921b8d94df037767bf3d5dc7c94f3"},"nose_tone5":{"category":"people","moji":"👃🏿","description":"nose tone 5","unicodeVersion":"8.0","digest":"1e0f9842e0f8ad5805eabd3f35a6038b7a2e49d566a1f5c17271f9cdf467ca60"},"notebook":{"category":"objects","moji":"📓","description":"notebook","unicodeVersion":"6.0","digest":"fc679d3728f86073d1607a926885dd8b0261132f5c4a0322f1e46ea9f95c8cb8"},"notebook_with_decorative_cover":{"category":"objects","moji":"📔","description":"notebook with decorative cover","unicodeVersion":"6.0","digest":"d822eda4b49cbfa399b36f134c1a0b8dcfdd27ed89f12c50bc18f6f0a9aa56ef"},"notepad_spiral":{"category":"objects","moji":"🗒","description":"spiral note pad","unicodeVersion":"7.0","digest":"c6a8e16aa62474cef13e5659fddb4afc57e3f79635e32e6020edbee2b5b50f18"},"notes":{"category":"symbols","moji":"🎶","description":"multiple musical notes","unicodeVersion":"6.0","digest":"98467e0adc134d45676ef1c6c459e5853a9db50c8a6e91b6aec7d449aa737f48"},"nut_and_bolt":{"category":"objects","moji":"🔩","description":"nut and bolt","unicodeVersion":"6.0","digest":"a77bd72f29a7302195dcec240174b15586de79e3204258e3fb401a6ea90563b3"},"o":{"category":"symbols","moji":"⭕","description":"heavy large circle","unicodeVersion":"5.2","digest":"2387e5fd9ae4c2972d40298d32319b8fa55c50dbfc1c04c5c36088213e6951dd"},"o2":{"category":"symbols","moji":"🅾","description":"negative squared latin capital letter o","unicodeVersion":"6.0","digest":"6a9ccb0bf394e4d05ffda19327cee18f7b9ed80367fc7f41c93da9bb7efab0bf"},"ocean":{"category":"nature","moji":"🌊","description":"water wave","unicodeVersion":"6.0","digest":"1a9ca9848d4fb75852addfc10bf84eccf7caa5339714b90e3de4cb6f2518465e"},"octagonal_sign":{"category":"symbols","moji":"🛑","description":"octagonal sign","unicodeVersion":"9.0","digest":"9f6927048e1f9da57f89d1ae1eb86fa4ab7abdbabca756a738a799e948d0b3f9"},"octopus":{"category":"nature","moji":"🐙","description":"octopus","unicodeVersion":"6.0","digest":"0fcc65c12f4b29ea75a8c4823d20838a7e6db6978fdcb536943072aa1460bc59"},"oden":{"category":"food","moji":"🍢","description":"oden","unicodeVersion":"6.0","digest":"089974cb13a0bef6a245fc73029c5ed5153fd4caae0177b835f779e32200b8aa"},"office":{"category":"travel","moji":"🏢","description":"office building","unicodeVersion":"6.0","digest":"3633a2e91036362e273eef4e0cfbdbbb4cb1208afe2cfa110ebef7b78109a66f"},"oil":{"category":"objects","moji":"🛢","description":"oil drum","unicodeVersion":"7.0","digest":"00b94d33bcc9b9e8a5d4bd6e7f7e2fced9497ce05919edd5e58eafbc011c2caa"},"ok":{"category":"symbols","moji":"🆗","description":"squared ok","unicodeVersion":"6.0","digest":"5f320f9b96e98a2f17ebe240daff9b9fd2ae0727cd6c8e4633b1744356e89365"},"ok_hand":{"category":"people","moji":"👌","description":"ok hand sign","unicodeVersion":"6.0","digest":"d63002dce3cc3655b67b8765b7c28d370edba0e3758b2329b60e0e61c4d8e78d"},"ok_hand_tone1":{"category":"people","moji":"👌🏻","description":"ok hand sign tone 1","unicodeVersion":"8.0","digest":"ef1508efcf483b09807554fe0e451c2948224f9deb85463e8e0dad6875b54012"},"ok_hand_tone2":{"category":"people","moji":"👌🏼","description":"ok hand sign tone 2","unicodeVersion":"8.0","digest":"1215a101a082fd8e04c5d2f7e3c59d0f480cb0bedd79aeab5d36676bfe760088"},"ok_hand_tone3":{"category":"people","moji":"👌🏽","description":"ok hand sign tone 3","unicodeVersion":"8.0","digest":"6fe0ed9fb42e86bb2bed4cb37b2acacacda1471fb1ee845ad55e54fb0897fbf4"},"ok_hand_tone4":{"category":"people","moji":"👌🏾","description":"ok hand sign tone 4","unicodeVersion":"8.0","digest":"bfb9041c49d95e901a667264abaf9b398f6c4aa8b52bf5191c122db20c13c020"},"ok_hand_tone5":{"category":"people","moji":"👌🏿","description":"ok hand sign tone 5","unicodeVersion":"8.0","digest":"1c218dc04d698da2cbdd7bea1ca3f845f9b386e967b7247c52f4b0f6ec8f5320"},"ok_woman":{"category":"people","moji":"🙆","description":"face with ok gesture","unicodeVersion":"6.0","digest":"3f8bd4ce2c4497155d697e5a71ebdc9339f65633d07fa9a7903e1bd76cfa4ba1"},"ok_woman_tone1":{"category":"people","moji":"🙆🏻","description":"face with ok gesture tone1","unicodeVersion":"8.0","digest":"1660cd904ccd2ecdc6f4ba00527f7d4ec8c33f3c6183344616f97badae4c3730"},"ok_woman_tone2":{"category":"people","moji":"🙆🏼","description":"face with ok gesture tone2","unicodeVersion":"8.0","digest":"7ba5fddd1e141424fac6778894dfc5af28e125839c58937c69496f99cd2c4002"},"ok_woman_tone3":{"category":"people","moji":"🙆🏽","description":"face with ok gesture tone3","unicodeVersion":"8.0","digest":"1d972b8377c52f598406f59ab1e5be41aaf8f027e1fefba3deda66312ccd6a9b"},"ok_woman_tone4":{"category":"people","moji":"🙆🏾","description":"face with ok gesture tone4","unicodeVersion":"8.0","digest":"a176328d8f53503aa743448968afd21d72ffd3510555526a3fb38d6b30ee7c15"},"ok_woman_tone5":{"category":"people","moji":"🙆🏿","description":"face with ok gesture tone5","unicodeVersion":"8.0","digest":"13cfc1b589c57e81f768ee07a14b737cafc71407a7eb0956728b2ec4b1df14c4"},"older_man":{"category":"people","moji":"👴","description":"older man","unicodeVersion":"6.0","digest":"4c0462b199bf26181c9e4d2d4cb878a32b0294566941212efc67362d0645f948"},"older_man_tone1":{"category":"people","moji":"👴🏻","description":"older man tone 1","unicodeVersion":"8.0","digest":"99baa083f78cb01166d0a928d0b53682be14be04c29fc17bef14aac1a73a61e6"},"older_man_tone2":{"category":"people","moji":"👴🏼","description":"older man tone 2","unicodeVersion":"8.0","digest":"5b4ce713e8820ba517fe92c25f3b93e6a6bf3704d1f982c461d5f31fc02b9d3d"},"older_man_tone3":{"category":"people","moji":"👴🏽","description":"older man tone 3","unicodeVersion":"8.0","digest":"0eff72b3226c3a703c635798ee84129a695c896fa011fe1adbc105312eecc083"},"older_man_tone4":{"category":"people","moji":"👴🏾","description":"older man tone 4","unicodeVersion":"8.0","digest":"ad9ba82b0c5d3b171b0639ee4265370dbddff5e0eeb70729db122659bb8c8f84"},"older_man_tone5":{"category":"people","moji":"👴🏿","description":"older man tone 5","unicodeVersion":"8.0","digest":"5eb0a7467cc40e75752e11fd5126b275863dc037557a0d0d3b24b681e00c2386"},"older_woman":{"category":"people","moji":"👵","description":"older woman","unicodeVersion":"6.0","digest":"c261fdf3b01e0c7d949e177144531add5895197fbadf1acbba8eb17d18766bf6"},"older_woman_tone1":{"category":"people","moji":"👵🏻","description":"older woman tone 1","unicodeVersion":"8.0","digest":"1f2bb9e42270a58194498254da27ac2b7a50edaa771b90ee194ccd6d24660c62"},"older_woman_tone2":{"category":"people","moji":"👵🏼","description":"older woman tone 2","unicodeVersion":"8.0","digest":"2e28198e9b7ac08c55980677ed66655fd899e157f14184958bebd87fcd714940"},"older_woman_tone3":{"category":"people","moji":"👵🏽","description":"older woman tone 3","unicodeVersion":"8.0","digest":"c968be0170f7e0c65d4f796337034cfb1daba897884da6fad85635ab5b6edf67"},"older_woman_tone4":{"category":"people","moji":"👵🏾","description":"older woman tone 4","unicodeVersion":"8.0","digest":"3596a6fa9a643bf79255afcd29657b03850df8499db9669b92ce013af908af44"},"older_woman_tone5":{"category":"people","moji":"👵🏿","description":"older woman tone 5","unicodeVersion":"8.0","digest":"c8998cb3dbd15e22bd1d6dad613d109ce371d9ffca3657e1a8afe5aeb30c1275"},"om_symbol":{"category":"symbols","moji":"🕉","description":"om symbol","unicodeVersion":"7.0","digest":"5ead73bea546ba9ba6da522f7280cc289c75ff5467742bdba31f92d0e1b3f4e6"},"on":{"category":"symbols","moji":"🔛","description":"on with exclamation mark with left right arrow abo","unicodeVersion":"6.0","digest":"9cc61a6b31a30c32dab594191bf23f91e341c4105384ab22158a6d43e6364631"},"oncoming_automobile":{"category":"travel","moji":"🚘","description":"oncoming automobile","unicodeVersion":"6.0","digest":"557c9cacdc3f95215d4f7a6f097a2baa7c007cb9c519492a6717077af4ca6b56"},"oncoming_bus":{"category":"travel","moji":"🚍","description":"oncoming bus","unicodeVersion":"6.0","digest":"059f28ce6bfb337e107db5982cbd2004844450ef20b4a54b9ca3cb738360ab05"},"oncoming_police_car":{"category":"travel","moji":"🚔","description":"oncoming police car","unicodeVersion":"6.0","digest":"aee79306a0d129cfc1980f58db80391eb46d2d7d5f814bf431414dc7680cab72"},"oncoming_taxi":{"category":"travel","moji":"🚖","description":"oncoming taxi","unicodeVersion":"6.0","digest":"84351489fc86d980b8d3eb9ec4e81120fe700b3ac01346daebe2b7aeb9607a55"},"one":{"category":"symbols","moji":"1️⃣","description":"keycap digit one","unicodeVersion":"3.0","digest":"d5d3fff04e68a114ff6464ee06fc831f3f381713045165f62a88d5e8215c195b"},"open_file_folder":{"category":"objects","moji":"📂","description":"open file folder","unicodeVersion":"6.0","digest":"96cfc322ee4903ae8cec07604811742245fd7d14f00bb70276d39d29c48bed28"},"open_hands":{"category":"people","moji":"👐","description":"open hands sign","unicodeVersion":"6.0","digest":"a6c131da2040b48103cea14f280e728675da50fa448d2b3f3438fcbb5bf5596a"},"open_hands_tone1":{"category":"people","moji":"👐🏻","description":"open hands sign tone 1","unicodeVersion":"8.0","digest":"867128dff2fa9b860c10c6b792f989f0c057928783696062378f834c0ef89d85"},"open_hands_tone2":{"category":"people","moji":"👐🏼","description":"open hands sign tone 2","unicodeVersion":"8.0","digest":"487ff2745b03d49bb3b1d0acd86ba530fd8cc3f467ca3fa504f88f0ef1cbbc01"},"open_hands_tone3":{"category":"people","moji":"👐🏽","description":"open hands sign tone 3","unicodeVersion":"8.0","digest":"cb8cddc8b8661f874ac9478289d16cc41406b947bb87f3363df518a588a53e16"},"open_hands_tone4":{"category":"people","moji":"👐🏾","description":"open hands sign tone 4","unicodeVersion":"8.0","digest":"17dcc2c07230846a769f3c79ce618a757c88b9b58c95c6c5b2d7f968814d447d"},"open_hands_tone5":{"category":"people","moji":"👐🏿","description":"open hands sign tone 5","unicodeVersion":"8.0","digest":"36b2493d67c84cea4f3f85a3088c6abcfd35cf99f7aeaeedfafa420ee878e3d2"},"open_mouth":{"category":"people","moji":"😮","description":"face with open mouth","unicodeVersion":"6.1","digest":"1906c5100ae0c8326ca5c4f9422976958a38dadd8d77724d68538a25d9623035"},"ophiuchus":{"category":"symbols","moji":"⛎","description":"ophiuchus","unicodeVersion":"6.0","digest":"6112e2a1656b1cb8bd9a8b0dfa6cbf66d30cae671710a9ef75c821de344aab2b"},"orange_book":{"category":"objects","moji":"📙","description":"orange book","unicodeVersion":"6.0","digest":"41141b08d2beceded21a94795431603c47fd7d42a3a472a2aa8b2bb25fa87ebf"},"orthodox_cross":{"category":"symbols","moji":"☦","description":"orthodox cross","unicodeVersion":"1.1","digest":"c16372102f0169dd6d32eb2b27a633aaee74e4e0fddcf723c15ad97f9dc6075c"},"outbox_tray":{"category":"objects","moji":"📤","description":"outbox tray","unicodeVersion":"6.0","digest":"e47cb481a0ffcb39996f32fd313e19b362a91d8dda15ffca48ac23a3b5bb5baf"},"owl":{"category":"nature","moji":"🦉","description":"owl","unicodeVersion":"9.0","digest":"f62ec1ad23ad9038966eea8d8b79660ac212f291af2e89bcdb0fdc683caf41e5"},"ox":{"category":"nature","moji":"🐂","description":"ox","unicodeVersion":"6.0","digest":"d13bc60552190bb9936bf32d681bdc742439b702a09cfc62137ea09a98624aed"},"package":{"category":"objects","moji":"📦","description":"package","unicodeVersion":"6.0","digest":"e82bf5accebb65136e897c15607eef635fb79fd7b2d8c8e19a9eb00b6786918c"},"page_facing_up":{"category":"objects","moji":"📄","description":"page facing up","unicodeVersion":"6.0","digest":"3884868bdcb2f29615b09a13a30385cbc5269379094a54b5a7e8a5f4e8ce905a"},"page_with_curl":{"category":"objects","moji":"📃","description":"page with curl","unicodeVersion":"6.0","digest":"3d6257670189f841ad1fa45415c34feb2433b2cb35bb435c4ee122ce89b39669"},"pager":{"category":"objects","moji":"📟","description":"pager","unicodeVersion":"6.0","digest":"e21c756cc1c58ebc1b37ebcd38e22a25b31e2e81306c6f18285d6a7671f9eb12"},"paintbrush":{"category":"objects","moji":"🖌","description":"lower left paintbrush","unicodeVersion":"7.0","digest":"fc0da7a25b726b8be9dd6467953e27293d2313a21eeff21424c2a19be614fff2"},"palm_tree":{"category":"nature","moji":"🌴","description":"palm tree","unicodeVersion":"6.0","digest":"90fedafd62fe0abf51325174d0f293ebb9a4794913b9ba93b12f2d0119056df1"},"pancakes":{"category":"food","moji":"🥞","description":"pancakes","unicodeVersion":"9.0","digest":"5256b4832431e8a88555796b1a9726f12d909a26fb2bdc3a0abff76412c45903"},"panda_face":{"category":"nature","moji":"🐼","description":"panda face","unicodeVersion":"6.0","digest":"56a4b84abe983bd6569be1b81ac5e43071015fd308389a16b92231310ae56a5b"},"paperclip":{"category":"objects","moji":"📎","description":"paperclip","unicodeVersion":"6.0","digest":"d1e2ce94a12b7e8b7a9bba49e47ddc7432ec0288545d3b6817c7a499e806e3f0"},"paperclips":{"category":"objects","moji":"🖇","description":"linked paperclips","unicodeVersion":"7.0","digest":"70cefa0d0777f070e393e9f95c24146fe2dd627f30fa3845baa19310d9291fe2"},"park":{"category":"travel","moji":"🏞","description":"national park","unicodeVersion":"7.0","digest":"444dce8014e0817ddd756c36a38adfbbf7ae4c6aa509e4cae291828f0716d5e7"},"parking":{"category":"symbols","moji":"🅿","description":"negative squared latin capital letter p","unicodeVersion":"5.2","digest":"9f1da460a7dd58b26beab8cf701be2691fb812208fbc941c71daa35be1507c2f"},"part_alternation_mark":{"category":"symbols","moji":"〽","description":"part alternation mark","unicodeVersion":"3.2","digest":"956da19353bb38fd4dfe0ab5360679a9035d566858fb5de62887b85c75fb8eef"},"partly_sunny":{"category":"nature","moji":"⛅","description":"sun behind cloud","unicodeVersion":"5.2","digest":"8fb9a6d2caf9e0cce58447762f0dfd6aa0b581b2e83fea6411348e0cbc8cf3c4"},"passport_control":{"category":"symbols","moji":"🛂","description":"passport control","unicodeVersion":"6.0","digest":"d9be6eed2c90e1c89171c42d70a06485fdf86a4c68833371832cc1f6897fadd0"},"pause_button":{"category":"symbols","moji":"⏸","description":"double vertical bar","unicodeVersion":"7.0","digest":"143221d99e82399ed7824b6c5e185700896492058b65c04e4c668291de78b203"},"peace":{"category":"symbols","moji":"☮","description":"peace symbol","unicodeVersion":"1.1","digest":"65181429e373c1f0507bbd98425c1bec0c042d648fb285a392460cbce60f44d4"},"peach":{"category":"food","moji":"🍑","description":"peach","unicodeVersion":"6.0","digest":"768d1f4f29e1e06aff5abb29043be83087ded16427ce6a2d0f682814e665e311"},"peanuts":{"category":"food","moji":"🥜","description":"peanuts","unicodeVersion":"9.0","digest":"e2384846b6e4a6c3a56e991ebb749cb68b330ac00a9e9d888b2c39105ff7ff5d"},"pear":{"category":"food","moji":"🍐","description":"pear","unicodeVersion":"6.0","digest":"b7c9cf90bb979649b863d2f4132f1b51f6f8107d42e08fb8b4033fea32844948"},"pen_ballpoint":{"category":"objects","moji":"🖊","description":"lower left ballpoint pen","unicodeVersion":"7.0","digest":"aacb20b220f26704e10303deeea33be0eec2d3811dcba7795902ca44b6ae9876"},"pen_fountain":{"category":"objects","moji":"🖋","description":"lower left fountain pen","unicodeVersion":"7.0","digest":"3619913eab2b6291f518b40481bb3eca0820d68b0a1b3c11fb6a69c62b75a626"},"pencil":{"category":"objects","moji":"📝","description":"memo","unicodeVersion":"6.0","digest":"accbc3f1439b7faa4411e502385f78a16c8e71851f71fc13582753291ffb507c"},"pencil2":{"category":"objects","moji":"✏","description":"pencil","unicodeVersion":"1.1","digest":"9ca1b56b5726f472b1f1b23050ed163e213916dac379d22e38e4c8358fe871e0"},"penguin":{"category":"nature","moji":"🐧","description":"penguin","unicodeVersion":"6.0","digest":"a1800ab931d6dc84a9c89bfab2c815198025c276d952509c55b18dd20bd9d316"},"pensive":{"category":"people","moji":"😔","description":"pensive face","unicodeVersion":"6.0","digest":"d237deff9f5ead8a0b281b7e5c6f4b82e98cc30c80c86c22c3fdc6160090b2f2"},"performing_arts":{"category":"activity","moji":"🎭","description":"performing arts","unicodeVersion":"6.0","digest":"d7c7bc9213e308ca26286cbbd8012e656b0f9b00293758faf1bfccc4c5ceabed"},"persevere":{"category":"people","moji":"😣","description":"persevering face","unicodeVersion":"6.0","digest":"c361509c9b8663af19a02a1ffff61b1b0d0b4bd75d693ce3d406b0ca1bde1ca0"},"person_frowning":{"category":"people","moji":"🙍","description":"person frowning","unicodeVersion":"6.0","digest":"b37be8bd95f21a6860ad3f171b8086125ab37331b382d87bcdb4cd684800546b"},"person_frowning_tone1":{"category":"people","moji":"🙍🏻","description":"person frowning tone 1","unicodeVersion":"8.0","digest":"3d5e78a367f9673baed2a86bc11cf04fd44394aadb65291fa51ade8dca318427"},"person_frowning_tone2":{"category":"people","moji":"🙍🏼","description":"person frowning tone 2","unicodeVersion":"8.0","digest":"7456c414c65ad6b6f11855f68a2eedc18113526f86862c4373202397cb1bed2c"},"person_frowning_tone3":{"category":"people","moji":"🙍🏽","description":"person frowning tone 3","unicodeVersion":"8.0","digest":"c86cf2d6951f1e6a7c786a74caaf68a777cf00e88023e23849d4383f864ae437"},"person_frowning_tone4":{"category":"people","moji":"🙍🏾","description":"person frowning tone 4","unicodeVersion":"8.0","digest":"944e96ced645ced8db6bb50120c7e37ed46b6960d595cbfe964c81803efa83aa"},"person_frowning_tone5":{"category":"people","moji":"🙍🏿","description":"person frowning tone 5","unicodeVersion":"8.0","digest":"4bd0ea571be6ef9f0493784ef0d12d5e47bc2d6ac610fb42c450bf3d87fb2948"},"person_with_blond_hair":{"category":"people","moji":"👱","description":"person with blond hair","unicodeVersion":"6.0","digest":"a7f94ede2e43308108c2260d83fc10121dda09a67f94a0a840e6d7bba7fd5616"},"person_with_blond_hair_tone1":{"category":"people","moji":"👱🏻","description":"person with blond hair tone 1","unicodeVersion":"8.0","digest":"00a116357a7878554c83e5bade4bddfa9cfabf76a229efa19cbb58e0d216219c"},"person_with_blond_hair_tone2":{"category":"people","moji":"👱🏼","description":"person with blond hair tone 2","unicodeVersion":"8.0","digest":"df509ebe92ed3138b9d5bd4645eff4b13f77f714cf62bb949c59eff1adc00019"},"person_with_blond_hair_tone3":{"category":"people","moji":"👱🏽","description":"person with blond hair tone 3","unicodeVersion":"8.0","digest":"6f328513f440a0c8cd1dc44596a5028fd8f306bdaf57c1e6f3aa94a3aa262b3c"},"person_with_blond_hair_tone4":{"category":"people","moji":"👱🏾","description":"person with blond hair tone 4","unicodeVersion":"8.0","digest":"32df1a577815b009696643ad80d063cc97b35d54add6d4e5517fc936f6da9ee8"},"person_with_blond_hair_tone5":{"category":"people","moji":"👱🏿","description":"person with blond hair tone 5","unicodeVersion":"8.0","digest":"2e270bb39187d8e36a33f4aa4d6045308189595fafc157cf7993e82d7ce93442"},"person_with_pouting_face":{"category":"people","moji":"🙎","description":"person with pouting face","unicodeVersion":"6.0","digest":"57e9a6e5f82121516dc189173f2a63b218f726cd51014e24a18c2bdfeeec3a0b"},"person_with_pouting_face_tone1":{"category":"people","moji":"🙎🏻","description":"person with pouting face tone1","unicodeVersion":"8.0","digest":"d10dadb1ac03fc2e221eff77b4c47935dc0b4fe897af3de30461e7226c3b4bbc"},"person_with_pouting_face_tone2":{"category":"people","moji":"🙎🏼","description":"person with pouting face tone2","unicodeVersion":"8.0","digest":"efface531537ab934b3b96985210a2dac88de812e82e804d6ec12174e536d1cc"},"person_with_pouting_face_tone3":{"category":"people","moji":"🙎🏽","description":"person with pouting face tone3","unicodeVersion":"8.0","digest":"7ff26ece237216b949bfa96d16bd12cfd248c6fd3e4ed89aa6c735c09eafaeff"},"person_with_pouting_face_tone4":{"category":"people","moji":"🙎🏾","description":"person with pouting face tone4","unicodeVersion":"8.0","digest":"045c04105df41d94ff4942133c7394e42ff35ef76c4ccb711497ab77ae6219f2"},"person_with_pouting_face_tone5":{"category":"people","moji":"🙎🏿","description":"person with pouting face tone5","unicodeVersion":"8.0","digest":"783ee37f146fcf61d38af5009f5823cf6526fe99ed891979f454016bce9dd4ba"},"pick":{"category":"objects","moji":"⛏","description":"pick","unicodeVersion":"5.2","digest":"7f0ec5445b4d5c66cf46e2a7332946cce34bd70e9929ac7a119251a7f57f555d"},"pig":{"category":"nature","moji":"🐷","description":"pig face","unicodeVersion":"6.0","digest":"51362570ab36805c8f67622ee4543e38811f8abb20f732a1af2ffbff2d63d042"},"pig2":{"category":"nature","moji":"🐖","description":"pig","unicodeVersion":"6.0","digest":"67010e255f28061b9d9210bcdab6edc072642ad134122a1d0c7e3a6b1795a45b"},"pig_nose":{"category":"nature","moji":"🐽","description":"pig nose","unicodeVersion":"6.0","digest":"0b21cac238bf4910939fbea9bed35552378c1b605a3867d7b85c1556dbda22a9"},"pill":{"category":"objects","moji":"💊","description":"pill","unicodeVersion":"6.0","digest":"cb00be361aaba6dbcf8da58bd20b76221dd75031362ecae99496b088ed413a7f"},"pineapple":{"category":"food","moji":"🍍","description":"pineapple","unicodeVersion":"6.0","digest":"621d4d4c52b59e566c2e29ed7845c8bd2d1da0946577527342097808d170dd70"},"ping_pong":{"category":"activity","moji":"🏓","description":"table tennis paddle and ball","unicodeVersion":"8.0","digest":"943a858bd054c81a08a08951f8351c27c8009b85a9359729c7362868298b58e1"},"pisces":{"category":"symbols","moji":"♓","description":"pisces","unicodeVersion":"1.1","digest":"453c3915122a4b6b32867056d2447be48675a84469145c88d52f8007fcb0861a"},"pizza":{"category":"food","moji":"🍕","description":"slice of pizza","unicodeVersion":"6.0","digest":"169bc6c1e1d7fdab1b8bf2eab0eeec4f9a7ae08b7b9b38f33b0b0c642e72053a"},"place_of_worship":{"category":"symbols","moji":"🛐","description":"place of worship","unicodeVersion":"8.0","digest":"daf271d36a38ee8c0f8b9de84c128ab8b25a5b7df8f107308d0353c961f2c644"},"play_pause":{"category":"symbols","moji":"⏯","description":"black right-pointing double triangle with double vertical bar","unicodeVersion":"6.0","digest":"af1498f34a3d6e0da8bbd26ebaa447e697e2df08c8eb255437cf7905c93f8c42"},"point_down":{"category":"people","moji":"👇","description":"white down pointing backhand index","unicodeVersion":"6.0","digest":"4ecdb3f31c16dc38113b8854ec1a7884613b688a185ebdf967eab9a81018f76d"},"point_down_tone1":{"category":"people","moji":"👇🏻","description":"white down pointing backhand index tone 1","unicodeVersion":"8.0","digest":"c74a7c94367cddbfa840542dc0924adeb0d108be0c7fde8c25fb95d69115d283"},"point_down_tone2":{"category":"people","moji":"👇🏼","description":"white down pointing backhand index tone 2","unicodeVersion":"8.0","digest":"dc4bda0726d85418b974addb42738f437fbb9cf16e5815cdbab3859c4ada6cae"},"point_down_tone3":{"category":"people","moji":"👇🏽","description":"white down pointing backhand index tone 3","unicodeVersion":"8.0","digest":"e460f81a501376d2f0ed1d45e358c5ed03ba049e8f466e4298afb4f3ca6d24dc"},"point_down_tone4":{"category":"people","moji":"👇🏾","description":"white down pointing backhand index tone 4","unicodeVersion":"8.0","digest":"4bc91cd771f24e0f897a9d8b18f323fec9a82da0fc2429c4a7e4e6a9d885a0a3"},"point_down_tone5":{"category":"people","moji":"👇🏿","description":"white down pointing backhand index tone 5","unicodeVersion":"8.0","digest":"7e47c6bc73250f36dc7ae1c1c09e7b41f30647b9d0ff703a53a75cc046b5057d"},"point_left":{"category":"people","moji":"👈","description":"white left pointing backhand index","unicodeVersion":"6.0","digest":"b5a7e864a0016afbadb3bec41f51ecf8c4af73cc20462e1a08b357f90bca6879"},"point_left_tone1":{"category":"people","moji":"👈🏻","description":"white left pointing backhand index tone 1","unicodeVersion":"8.0","digest":"9f1868272a10a2b738c065be5d30241643324550cfd47baf01c7a09060e66d31"},"point_left_tone2":{"category":"people","moji":"👈🏼","description":"white left pointing backhand index tone 2","unicodeVersion":"8.0","digest":"bf0d58c68178a2c2c01d4a6235a1a66b90073cea170f9f6fe2668b6dd68424f7"},"point_left_tone3":{"category":"people","moji":"👈🏽","description":"white left pointing backhand index tone 3","unicodeVersion":"8.0","digest":"34d28c97bc8f9d111d14e328153c4298fc32cf18e39e20aacaec17846645ed90"},"point_left_tone4":{"category":"people","moji":"👈🏾","description":"white left pointing backhand index tone 4","unicodeVersion":"8.0","digest":"c40c8436316915d516c53bb1c98a469528cefd98baa719be7e748c4608cbbcc9"},"point_left_tone5":{"category":"people","moji":"👈🏿","description":"white left pointing backhand index tone 5","unicodeVersion":"8.0","digest":"c410fe32e4ce0ded74845a54b86090e59e5820d457837b16e175b36cc71ecb46"},"point_right":{"category":"people","moji":"👉","description":"white right pointing backhand index","unicodeVersion":"6.0","digest":"44d9251ab41f2f48c2250c44a47f92b3476a71f13fbbbfb637547db837fd5a49"},"point_right_tone1":{"category":"people","moji":"👉🏻","description":"white right pointing backhand index tone 1","unicodeVersion":"8.0","digest":"9fcce259eb81c0b52ec7796b98a1653194e3a9021a1d338df1dbbab7522fc406"},"point_right_tone2":{"category":"people","moji":"👉🏼","description":"white right pointing backhand index tone 2","unicodeVersion":"8.0","digest":"9d00a0b1cfc435674dc56065b3d28d28839196977504cf20581205351d8708f2"},"point_right_tone3":{"category":"people","moji":"👉🏽","description":"white right pointing backhand index tone 3","unicodeVersion":"8.0","digest":"e3026a70630ba73d76892a055a80cac2f78d509faddce737f802d2abefa074ba"},"point_right_tone4":{"category":"people","moji":"👉🏾","description":"white right pointing backhand index tone 4","unicodeVersion":"8.0","digest":"ea508fde90561460361773b4e1b8e80874667b19ac115926206e7c592587cb76"},"point_right_tone5":{"category":"people","moji":"👉🏿","description":"white right pointing backhand index tone 5","unicodeVersion":"8.0","digest":"d59cdb2864eb2929941ecd233f8b8afcddc30fbd4594e5f9acf6386ae06ac12c"},"point_up":{"category":"people","moji":"☝","description":"white up pointing index","unicodeVersion":"1.1","digest":"b69ff4f650989709f2185822d278c7773672bd9eb4a625da80f3038a2b9ce42b"},"point_up_2":{"category":"people","moji":"👆","description":"white up pointing backhand index","unicodeVersion":"6.0","digest":"e83cd9eff2af5125a25f5a306c3ee3cfea240add683b5c36a86a994a8d8c805c"},"point_up_2_tone1":{"category":"people","moji":"👆🏻","description":"white up pointing backhand index tone 1","unicodeVersion":"8.0","digest":"b02ec3e7e04a83bfb769cffb951cbf32aa78e56fa5a51c097f9326df9e08ed33"},"point_up_2_tone2":{"category":"people","moji":"👆🏼","description":"white up pointing backhand index tone 2","unicodeVersion":"8.0","digest":"32994b85c8b4a1383ca985ebc3382be88866cea1ff1315adfb71fb05e992a232"},"point_up_2_tone3":{"category":"people","moji":"👆🏽","description":"white up pointing backhand index tone 3","unicodeVersion":"8.0","digest":"9e263bcfb82ada34ff85291f36e64e66b86760fb11a4e0c554e801644d417d6d"},"point_up_2_tone4":{"category":"people","moji":"👆🏾","description":"white up pointing backhand index tone 4","unicodeVersion":"8.0","digest":"3edc92130a0851ac7b5236772ce7918d088689221df287098688e1ed5b3ff181"},"point_up_2_tone5":{"category":"people","moji":"👆🏿","description":"white up pointing backhand index tone 5","unicodeVersion":"8.0","digest":"cabb3b7da9290840ef59d0c8b22625bdb2e94842f01b0a575ccbc348f3069d77"},"point_up_tone1":{"category":"people","moji":"☝🏻","description":"white up pointing index tone 1","unicodeVersion":"8.0","digest":"e496fda349072f8b321ceb7a251175f7244c3076661f5ede48ea75ba1acf8339"},"point_up_tone2":{"category":"people","moji":"☝🏼","description":"white up pointing index tone 2","unicodeVersion":"8.0","digest":"5a8081323f3baa67e6431e21e16a36559b339f5175d586644e34947f738dd07a"},"point_up_tone3":{"category":"people","moji":"☝🏽","description":"white up pointing index tone 3","unicodeVersion":"8.0","digest":"07bf0cea812eb226b443334e026e13d1ec23e013478f4af862a3919703107842"},"point_up_tone4":{"category":"people","moji":"☝🏾","description":"white up pointing index tone 4","unicodeVersion":"8.0","digest":"1fbbd71433108143ee157d0fdadd183f7f013bafa96f0dd93b181e1fd5fd4af2"},"point_up_tone5":{"category":"people","moji":"☝🏿","description":"white up pointing index tone 5","unicodeVersion":"8.0","digest":"ad068ef32df32f8297955490a9a90590a0f93ed5702a052cd0d8f6484c6cc679"},"police_car":{"category":"travel","moji":"🚓","description":"police car","unicodeVersion":"6.0","digest":"0909be1bd615ae331a7cce71e16dee3ca663c721d5170072c593cb7c76f9f661"},"poodle":{"category":"nature","moji":"🐩","description":"poodle","unicodeVersion":"6.0","digest":"f1742fdf3fd26a8a5cfeaba57026518dacaad364cbd03344c4000a35af13e47a"},"poop":{"category":"people","moji":"💩","description":"pile of poo","unicodeVersion":"6.0","digest":"857a61c872138d359a7fe8257bb26118afa49d75186eca2addb415d07c92b3ec"},"popcorn":{"category":"food","moji":"🍿","description":"popcorn","unicodeVersion":"8.0","digest":"684f1b7ef34ea7ca933aed41569bc6595a19ef0d546a1b7b9e69f8335540b323"},"post_office":{"category":"travel","moji":"🏣","description":"japanese post office","unicodeVersion":"6.0","digest":"54398ee396c1314a7993b1cb1cba264946b5c9d5a7dbb43fd67286854d1d1a0f"},"postal_horn":{"category":"objects","moji":"📯","description":"postal horn","unicodeVersion":"6.0","digest":"0ea12f44f3bae9a14bde3b37361b48bd738d2f613bb1b53a9204959b70e643f8"},"postbox":{"category":"objects","moji":"📮","description":"postbox","unicodeVersion":"6.0","digest":"bbc424ae8d46de380d7023a43ea064002fd614657d00330d3503275827ac87e2"},"potable_water":{"category":"symbols","moji":"🚰","description":"potable water symbol","unicodeVersion":"6.0","digest":"dbe80d9637837377cc2a290da2e895f81a3108cc18b049e3d87212402c1c2098"},"potato":{"category":"food","moji":"🥔","description":"potato","unicodeVersion":"9.0","digest":"a56a69f36f3a0793f278726d92c0cea2960554f3062ef1a0904526a04511d8e1"},"pouch":{"category":"people","moji":"👝","description":"pouch","unicodeVersion":"6.0","digest":"9f012b90310b4a072b6a8fa2c64def087b5f7ffffaafc36e1856ba943a170351"},"poultry_leg":{"category":"food","moji":"🍗","description":"poultry leg","unicodeVersion":"6.0","digest":"1445ec4f5e68a19e5a84e5537dca8190d62409070c954d112e6097f1a6b7f054"},"pound":{"category":"objects","moji":"💷","description":"banknote with pound sign","unicodeVersion":"6.0","digest":"eb11b83eb52adb0a15e69a3bc15788a2dc7825dedee81ac3af84963c9dd517b5"},"pouting_cat":{"category":"people","moji":"😾","description":"pouting cat face","unicodeVersion":"6.0","digest":"8822abedf3499cf98278d7eeea0764d1100ec25cad71b4b2e877f9346f8c8138"},"pray":{"category":"people","moji":"🙏","description":"person with folded hands","unicodeVersion":"6.0","digest":"735b79dab34ac2cf81fd42fdcd7eb1f13c24655e5e343816d5764896c03edeea"},"pray_tone1":{"category":"people","moji":"🙏🏻","description":"person with folded hands tone 1","unicodeVersion":"8.0","digest":"e8b6103450215e8566797f150978355e297deade4eb47a6371f7a7bc558fed9d"},"pray_tone2":{"category":"people","moji":"🙏🏼","description":"person with folded hands tone 2","unicodeVersion":"8.0","digest":"ee8baacd95d7e8dbad8a1f2d9a12e36c98f3d518db5d3b117d0a18290815e62b"},"pray_tone3":{"category":"people","moji":"🙏🏽","description":"person with folded hands tone 3","unicodeVersion":"8.0","digest":"ae8c0caa9aca0a6c44069e76a7535c961d0284cd701812f76bbd2bd79ce2bd53"},"pray_tone4":{"category":"people","moji":"🙏🏾","description":"person with folded hands tone 4","unicodeVersion":"8.0","digest":"64f7b3178b8cd6f6a877ed583539eefe068fa87a0dd658fdcd58c8bc809f7e17"},"pray_tone5":{"category":"people","moji":"🙏🏿","description":"person with folded hands tone 5","unicodeVersion":"8.0","digest":"5bc8cdce937ac06779c87021423efcec4f602aa4a39dba90b00de81033005332"},"prayer_beads":{"category":"objects","moji":"📿","description":"prayer beads","unicodeVersion":"8.0","digest":"80177091264430cbcf7c994fbe5ee17319d1a58d933636cc752a54dafcf98a05"},"pregnant_woman":{"category":"people","moji":"🤰","description":"pregnant woman","unicodeVersion":"9.0","digest":"49abb86409103338bdb6ae43c13a78ca2dc9cd158a26df35eadd0da3c84a4352"},"pregnant_woman_tone1":{"category":"people","moji":"🤰🏻","description":"pregnant woman tone 1","unicodeVersion":"9.0","digest":"5a9f8ed2b631ecf8af111803a5c11f4c156435a5293cb50329c7b98697c8da25"},"pregnant_woman_tone2":{"category":"people","moji":"🤰🏼","description":"pregnant woman tone 2","unicodeVersion":"9.0","digest":"279a2eafff603b11629c955b05f5bd3d7da9a271d4fb3f02e9ccd457b8d2d815"},"pregnant_woman_tone3":{"category":"people","moji":"🤰🏽","description":"pregnant woman tone 3","unicodeVersion":"9.0","digest":"93bb63ec2312db315e3f0065520b715cc413ac0fd65538ec9b5cd97df2a42b20"},"pregnant_woman_tone4":{"category":"people","moji":"🤰🏾","description":"pregnant woman tone 4","unicodeVersion":"9.0","digest":"b8dc3dcec894bfd832a249459b10850f8786b6778d8887a677d1291865623da2"},"pregnant_woman_tone5":{"category":"people","moji":"🤰🏿","description":"pregnant woman tone 5","unicodeVersion":"9.0","digest":"73ee432752f81980f353a7f9b9f7a5ece62512dca08e15c1876b89227face21c"},"prince":{"category":"people","moji":"🤴","description":"prince","unicodeVersion":"9.0","digest":"34a0e0625f0a9825d3674192d6233b6cae4d8130451293df09f91a6a4165869c"},"prince_tone1":{"category":"people","moji":"🤴🏻","description":"prince tone 1","unicodeVersion":"9.0","digest":"ccecdfeccb2ab1fceceae14f3fba875c8c7099785a4c40131c08a697b5b675fc"},"prince_tone2":{"category":"people","moji":"🤴🏼","description":"prince tone 2","unicodeVersion":"9.0","digest":"c373fd3e0c1798415e3d8d88fab6c98c1bbdedcbe6f52f3a3899f6e2124a768d"},"prince_tone3":{"category":"people","moji":"🤴🏽","description":"prince tone 3","unicodeVersion":"9.0","digest":"71d15695ca954d55aa69d3c753c7d31a8ba5329713a8ddbc90dafc11e524c4ef"},"prince_tone4":{"category":"people","moji":"🤴🏾","description":"prince tone 4","unicodeVersion":"9.0","digest":"08f6cb32424f15cc3aaf83c31a5dac7c01a6be2f37ea8f13aed579ce6fb4db19"},"prince_tone5":{"category":"people","moji":"🤴🏿","description":"prince tone 5","unicodeVersion":"9.0","digest":"77d521148efa33fa4d3409693d050fecfd948411e807327484f174e289834649"},"princess":{"category":"people","moji":"👸","description":"princess","unicodeVersion":"6.0","digest":"efabd28480a843c735f0868734da2f9ce28133933b02ab07b645498f494f3f80"},"princess_tone1":{"category":"people","moji":"👸🏻","description":"princess tone 1","unicodeVersion":"8.0","digest":"52b88b99ba64f82e8f36e2a1827c85145e4fcd6863478c2345fe9fa9e8901cdf"},"princess_tone2":{"category":"people","moji":"👸🏼","description":"princess tone 2","unicodeVersion":"8.0","digest":"7e44289404693668f20e681fcdc2e516512d54a69c627eedae958f69dfe6eea9"},"princess_tone3":{"category":"people","moji":"👸🏽","description":"princess tone 3","unicodeVersion":"8.0","digest":"96c9a9857348d7a1a8be899c50d55b352b9a9fd5c65e4777bfa199fe7929d41c"},"princess_tone4":{"category":"people","moji":"👸🏾","description":"princess tone 4","unicodeVersion":"8.0","digest":"67696f96be60f2a36598072172d2db197d007e6c1ac3acef526a5ce6d59bf3f7"},"princess_tone5":{"category":"people","moji":"👸🏿","description":"princess tone 5","unicodeVersion":"8.0","digest":"007f624e2fad91bb57ce32ecd35213a796d71807f3b12f3f1575bf50e6a50eeb"},"printer":{"category":"objects","moji":"🖨","description":"printer","unicodeVersion":"7.0","digest":"5e5307e3dc7ec4e16c9978fb00934c99c4adefca7d32732a244d1f2de71ce6f8"},"projector":{"category":"objects","moji":"📽","description":"film projector","unicodeVersion":"7.0","digest":"7f8e1fdb89584849a56ee34c62cab808af48b7bd4823467d090af4657a2e0420"},"punch":{"category":"people","moji":"👊","description":"fisted hand sign","unicodeVersion":"6.0","digest":"c7e7edf6d64f755db3f02874354f08337b3971aff329476d19ac946e0b421329"},"punch_tone1":{"category":"people","moji":"👊🏻","description":"fisted hand sign tone 1","unicodeVersion":"8.0","digest":"c9ba508b0c36041047473782acfedab5af40dd7946b33daf4d8d54c726e06a11"},"punch_tone2":{"category":"people","moji":"👊🏼","description":"fisted hand sign tone 2","unicodeVersion":"8.0","digest":"d53011cd2f3334c7b3fffdfe1e2b8cc1c832c74306e1ac6d03f954a1309d7d0b"},"punch_tone3":{"category":"people","moji":"👊🏽","description":"fisted hand sign tone 3","unicodeVersion":"8.0","digest":"f7522347094e0130ed8e304678106574dbd7dd2b6b3aeb4d8a7a0fef880920b2"},"punch_tone4":{"category":"people","moji":"👊🏾","description":"fisted hand sign tone 4","unicodeVersion":"8.0","digest":"3e62bdd426f3e6ff175ce3b8dd6f6d3998d9c1506128defa96b528b455295b47"},"punch_tone5":{"category":"people","moji":"👊🏿","description":"fisted hand sign tone 5","unicodeVersion":"8.0","digest":"7d9bff777dc4ec41ac132b1252fa08cf92a398c8dc146c4a5327b45d568982d8"},"purple_heart":{"category":"symbols","moji":"💜","description":"purple heart","unicodeVersion":"6.0","digest":"a6bf01de806525942be480e45a4b2879f91df8129b78a1b8734d4f917bcab773"},"purse":{"category":"people","moji":"👛","description":"purse","unicodeVersion":"6.0","digest":"2b785f36e01875d66cfda2192c8c53606e7224a7c869a4826b62cb61613d60c8"},"pushpin":{"category":"objects","moji":"📌","description":"pushpin","unicodeVersion":"6.0","digest":"c3f7d7008be6bab8dc02284d4d759abf7aafbb3dbbe3a53f0f5b2ff685af88f8"},"put_litter_in_its_place":{"category":"symbols","moji":"🚮","description":"put litter in its place symbol","unicodeVersion":"6.0","digest":"f52a57d6f1bada7b6e6b9a6458597d70cb701c01e1120d8cb1d7ff65e01d405c"},"question":{"category":"symbols","moji":"❓","description":"black question mark ornament","unicodeVersion":"6.0","digest":"40050a1fd29bed321fd601d13dc33de5d6084121f1d873b29bde9dc3d823a310"},"rabbit":{"category":"nature","moji":"🐰","description":"rabbit face","unicodeVersion":"6.0","digest":"678ad953a7ab8f618c59051449a67c965d1f04f42dd6f6669adaf3fadebd080c"},"rabbit2":{"category":"nature","moji":"🐇","description":"rabbit","unicodeVersion":"6.0","digest":"19b1f5108292472434cc7a49efac4ea9275779735c7aeb0f15c36021d5998ca0"},"race_car":{"category":"travel","moji":"🏎","description":"racing car","unicodeVersion":"7.0","digest":"46f4814259d3d17ff35c04110e73e5327aee99f4711cd459ca1ee951508da3a6"},"racehorse":{"category":"nature","moji":"🐎","description":"horse","unicodeVersion":"6.0","digest":"a57b7aca35347ada8225eeee06b70cfd040484104963b4df56ea8fec690576b0"},"radio":{"category":"objects","moji":"📻","description":"radio","unicodeVersion":"6.0","digest":"9245951dd779cdd141089891b15a90d3999a6358acf1fc296aa505100f812108"},"radio_button":{"category":"symbols","moji":"🔘","description":"radio button","unicodeVersion":"6.0","digest":"565bec59198df2592e96564c6e314d3cde33c47b453db1bec6c5d027b5cb4fd9"},"radioactive":{"category":"symbols","moji":"☢","description":"radioactive sign","unicodeVersion":"1.1","digest":"0ed6634057824e0cfd10b2533753e3632b0624341a7eac8d9835706480335581"},"rage":{"category":"people","moji":"😡","description":"pouting face","unicodeVersion":"6.0","digest":"d97ba6bd08eec46dbc7199f530c945b73a87a878e35397b0a3e4f2b45039e89e"},"railway_car":{"category":"travel","moji":"🚃","description":"railway car","unicodeVersion":"6.0","digest":"2cddc08d555e7fc24e312c3d255ed013fbf9cd2974a6918369c32554049ba2be"},"railway_track":{"category":"travel","moji":"🛤","description":"railway track","unicodeVersion":"7.0","digest":"0da351b6d4e75c6beeaef1225e151d9580d4b5c41dfa1cf192715bf3cec981d7"},"rainbow":{"category":"travel","moji":"🌈","description":"rainbow","unicodeVersion":"6.0","digest":"a93aceb54e965f35e397e8c8716b1831614933308d026012d5464ee42783ed4d"},"raised_back_of_hand":{"category":"people","moji":"🤚","description":"raised back of hand","unicodeVersion":"9.0","digest":"20973a697e826625deba5ee3c4f25eb5e1737f2e860ac6fe4ee4d0e0c84b5e12"},"raised_back_of_hand_tone1":{"category":"people","moji":"🤚🏻","description":"raised back of hand tone 1","unicodeVersion":"9.0","digest":"06af5941255ca69d10d99d0a512bbda6141a296453835dbccf259ce0afe1dd3d"},"raised_back_of_hand_tone2":{"category":"people","moji":"🤚🏼","description":"raised back of hand tone 2","unicodeVersion":"9.0","digest":"429ed19555c9e5197b729b3e7bd8013346551051cb0b3fbc8a4372717c9a027d"},"raised_back_of_hand_tone3":{"category":"people","moji":"🤚🏽","description":"raised back of hand tone 3","unicodeVersion":"9.0","digest":"487a1c3f19e77c99b520ec073de2acc4a9e585b739a84b3989f7de85d2c2045c"},"raised_back_of_hand_tone4":{"category":"people","moji":"🤚🏾","description":"raised back of hand tone 4","unicodeVersion":"9.0","digest":"154254d8500c55ec3de698be4a352f9bcf06e2950cabc4eabaccad0f39a1e1e9"},"raised_back_of_hand_tone5":{"category":"people","moji":"🤚🏿","description":"raised back of hand tone 5","unicodeVersion":"9.0","digest":"6e9c0855ecd5f14adca5e5862427c3d39ffcf86f7ddd3aaa1fefc3cefc7483c8"},"raised_hand":{"category":"people","moji":"✋","description":"raised hand","unicodeVersion":"6.0","digest":"5cf11be683aea985d5ba51fbd44722c2327311bfe26b61c3d441c90f5d5a195a"},"raised_hand_tone1":{"category":"people","moji":"✋🏻","description":"raised hand tone 1","unicodeVersion":"8.0","digest":"865afca29b57577fed8fe8c2be57b74254a008c8cf34194680be2759239b5f5d"},"raised_hand_tone2":{"category":"people","moji":"✋🏼","description":"raised hand tone 2","unicodeVersion":"8.0","digest":"832169a0b626a682a58a3b998f68413657b4962c1fab05f1fdc2668e82727210"},"raised_hand_tone3":{"category":"people","moji":"✋🏽","description":"raised hand tone 3","unicodeVersion":"8.0","digest":"3959a873ad7671de82c615c4ed840b011e67baafb2bab7dd16859608d3e83cb1"},"raised_hand_tone4":{"category":"people","moji":"✋🏾","description":"raised hand tone 4","unicodeVersion":"8.0","digest":"db542f65d076ccf3dbfca27cb7c2f135a8bf7a487a81a04873e70172bdfcd579"},"raised_hand_tone5":{"category":"people","moji":"✋🏿","description":"raised hand tone 5","unicodeVersion":"8.0","digest":"88ca884d14baaae48df21d75c22d82fb15bdc395e42026f5ca34cd65e5ae8674"},"raised_hands":{"category":"people","moji":"🙌","description":"person raising both hands in celebration","unicodeVersion":"6.0","digest":"2ee73466a3f5079e542857fe6f5497e9f87753a81854985ce3356a8d3da1d8b8"},"raised_hands_tone1":{"category":"people","moji":"🙌🏻","description":"person raising both hands in celebration tone 1","unicodeVersion":"8.0","digest":"43e73c60f040a66374b8ec98f3629a90d13ae9f472446ed7676cd5573e824f4b"},"raised_hands_tone2":{"category":"people","moji":"🙌🏼","description":"person raising both hands in celebration tone 2","unicodeVersion":"8.0","digest":"fcc5255bb2b06dc82d6878e74cf34e8ce118c70004a06d39a980683772b98c52"},"raised_hands_tone3":{"category":"people","moji":"🙌🏽","description":"person raising both hands in celebration tone 3","unicodeVersion":"8.0","digest":"3ee3e0aafef486e766a166935e8147fb75a7329cfebc96dec876cc45e83a8754"},"raised_hands_tone4":{"category":"people","moji":"🙌🏾","description":"person raising both hands in celebration tone 4","unicodeVersion":"8.0","digest":"78a8cbf6b2b85be4d6b18f0ff6a77f197963117955725fb7e57e0441effb928f"},"raised_hands_tone5":{"category":"people","moji":"🙌🏿","description":"person raising both hands in celebration tone 5","unicodeVersion":"8.0","digest":"2a5ed7334a17172db0cd820a559e7f75df40ec44de6c25d194c76e1b58c634cb"},"raising_hand":{"category":"people","moji":"🙋","description":"happy person raising one hand","unicodeVersion":"6.0","digest":"512750b00704f1ccefd3c757743540b785ad7670dbbe4a2c4dca8d93e6701920"},"raising_hand_tone1":{"category":"people","moji":"🙋🏻","description":"happy person raising one hand tone1","unicodeVersion":"8.0","digest":"2897722f091c273dd3714cff7423c2475bc3070416c28014ca03322b9ece48bc"},"raising_hand_tone2":{"category":"people","moji":"🙋🏼","description":"happy person raising one hand tone2","unicodeVersion":"8.0","digest":"59199b334b3845911382c1f29bd7c0d5ef9d2486417345e265b166ead7d3e1c1"},"raising_hand_tone3":{"category":"people","moji":"🙋🏽","description":"happy person raising one hand tone3","unicodeVersion":"8.0","digest":"f95b338d5efcf14ef12f415a2c1bba93df48628ddc94f34f70c31e1b3c2e1d28"},"raising_hand_tone4":{"category":"people","moji":"🙋🏾","description":"happy person raising one hand tone4","unicodeVersion":"8.0","digest":"951ddbfdb57d5a60551b59b3d0f7ca00a64912f4a101a73afaebd68445cd6cec"},"raising_hand_tone5":{"category":"people","moji":"🙋🏿","description":"happy person raising one hand tone5","unicodeVersion":"8.0","digest":"9370f93704d8f89ca6dc946715eab5e7dba82bf04dd68c00f5c0abb8bc16371e"},"ram":{"category":"nature","moji":"🐏","description":"ram","unicodeVersion":"6.0","digest":"2875ab28e1018b39062aeb0c5ce488c48a98f13e9f2364470a0a700b126604f2"},"ramen":{"category":"food","moji":"🍜","description":"steaming bowl","unicodeVersion":"6.0","digest":"425662a49c4c13577c0de8d45d004e5ba204aaadbaabae62a5c283ecd7a9a2c5"},"rat":{"category":"nature","moji":"🐀","description":"rat","unicodeVersion":"6.0","digest":"14380d65498c6ce037c02a93bca2b24f25a368d85278d6015b8c9f7cd261f8e2"},"record_button":{"category":"symbols","moji":"⏺","description":"black circle for record","unicodeVersion":"7.0","digest":"92be12161ba206bb2e06a39131711c7b17368d55b4aae0b48f0ac5b6b1cde76b"},"recycle":{"category":"symbols","moji":"♻","description":"black universal recycling symbol","unicodeVersion":"3.2","digest":"c377e8537367b05b5de9be860a0fcabd7aed2bf4ba146eefc423671a21530369"},"red_car":{"category":"travel","moji":"🚗","description":"automobile","unicodeVersion":"6.0","digest":"8a99832a195263c0e922af53d52dea37aa3e07032b3c2a1977f8527b4a144b9c"},"red_circle":{"category":"symbols","moji":"🔴","description":"large red circle","unicodeVersion":"6.0","digest":"9dcf0132f6f2cc81702f0e3b15b37984e8439796705bf98f68ba449b3dfa5307"},"registered":{"category":"symbols","moji":"®","description":"registered sign","unicodeVersion":"1.1","digest":"9661b1df529ecb752d130820c55c403e5de263748eb02f7fea327818bc282d94"},"relaxed":{"category":"people","moji":"☺","description":"white smiling face","unicodeVersion":"1.1","digest":"2d5aed4fb8504c6d6660ef8d3bfe0cc053dcd6099c2f53748c202dc970c639bc"},"relieved":{"category":"people","moji":"😌","description":"relieved face","unicodeVersion":"6.0","digest":"b4ce2ba6c220d887fe5e333c05ed773df9b6df0ac456879fd8f5103ff68604a5"},"reminder_ribbon":{"category":"activity","moji":"🎗","description":"reminder ribbon","unicodeVersion":"7.0","digest":"c3de2a7c9350b77a0b86c0dcce9dcd9953ea8a97aa1e7aed149755924742f54d"},"repeat":{"category":"symbols","moji":"🔁","description":"clockwise rightwards and leftwards open circle arr","unicodeVersion":"6.0","digest":"b9512d508613ed0eb3181eb1030f7f6fd6b994476ecdfa308733c6df975fb99e"},"repeat_one":{"category":"symbols","moji":"🔂","description":"clockwise rightwards and leftwards open circle arr","unicodeVersion":"6.0","digest":"53409cf24dd4bb0d7b50ae359f15d06b87b7f4a292ed5c3a09652fa421a90bf2"},"restroom":{"category":"symbols","moji":"🚻","description":"restroom","unicodeVersion":"6.0","digest":"2e7a1bfc9a9d49b0272230a91db7369e24d54bf1de8e683d36b85f1d8c037f77"},"revolving_hearts":{"category":"symbols","moji":"💞","description":"revolving hearts","unicodeVersion":"6.0","digest":"c43d3197cb4cf06659f643638f6c4e91a2889e0f6531b7d81ea826c2a8b784fc"},"rewind":{"category":"symbols","moji":"⏪","description":"black left-pointing double triangle","unicodeVersion":"6.0","digest":"d20c918c1e528ff0947312738501ca9a6fb6ff4016aad07db7a8125d00fd65cd"},"rhino":{"category":"nature","moji":"🦏","description":"rhinoceros","unicodeVersion":"9.0","digest":"163fa3acd78eead72c431a1f48b8465a6d45272a9169560e456d30b4df93dc6b"},"ribbon":{"category":"objects","moji":"🎀","description":"ribbon","unicodeVersion":"6.0","digest":"74315fe907f9f0203afe139cd4552aa442eecfa2a64fac12db3e1292fc5a8828"},"rice":{"category":"food","moji":"🍚","description":"cooked rice","unicodeVersion":"6.0","digest":"f544f12606de59d28739798003f14ebd8869856add8e24496ec5dda3e131daf4"},"rice_ball":{"category":"food","moji":"🍙","description":"rice ball","unicodeVersion":"6.0","digest":"2cba6f5364cd366859bc8948897b65fc97b225ea7973d9be3b24aba388fed8e8"},"rice_cracker":{"category":"food","moji":"🍘","description":"rice cracker","unicodeVersion":"6.0","digest":"ac0f805d41d4f322154c1968bd3ce3e9aabcd39d908182e52fd7d28458dbef92"},"rice_scene":{"category":"travel","moji":"🎑","description":"moon viewing ceremony","unicodeVersion":"6.0","digest":"b942a06d3da0570aca59bab0af57cd8c16863934f12a38f70339fd0a36f675f5"},"right_facing_fist":{"category":"people","moji":"🤜","description":"right-facing fist","unicodeVersion":"9.0","digest":"f815d1cc0c0345ddcc8886ae9c133582d7dc779732ac9b93dde1ab4fdd3b251d"},"right_facing_fist_tone1":{"category":"people","moji":"🤜🏻","description":"right facing fist tone 1","unicodeVersion":"9.0","digest":"0f9269b70cf68071d97389e059a2bdacffd73f2afd2ce6cfd7447bb1a4e9abbb"},"right_facing_fist_tone2":{"category":"people","moji":"🤜🏼","description":"right facing fist tone 2","unicodeVersion":"9.0","digest":"32a9833db853972e49e65aa227fb0512c57362da190aa1cc40e1d64f238e837e"},"right_facing_fist_tone3":{"category":"people","moji":"🤜🏽","description":"right facing fist tone 3","unicodeVersion":"9.0","digest":"be4706f8bb088411f5cbbf9065a0ae5b773c97456bd975c2b6789765657847b9"},"right_facing_fist_tone4":{"category":"people","moji":"🤜🏾","description":"right facing fist tone 4","unicodeVersion":"9.0","digest":"1680862891a9d85c4b6f76232a80e2ef7428bcec93087c86eae2efaba9c6a3f7"},"right_facing_fist_tone5":{"category":"people","moji":"🤜🏿","description":"right facing fist tone 5","unicodeVersion":"9.0","digest":"388715a4bc2178c52bbb3bc2729f57be50acab5d751784c9f3220e86c6b1fbcc"},"ring":{"category":"people","moji":"💍","description":"ring","unicodeVersion":"6.0","digest":"b5322907222797b5e1786209cda88513e76cd397a40f0a7da24847245c95ef9d"},"robot":{"category":"people","moji":"🤖","description":"robot face","unicodeVersion":"8.0","digest":"4d788e6ec89279588b036fca6b17f5a981291681df8f90306ecf5c039de40848"},"rocket":{"category":"travel","moji":"🚀","description":"rocket","unicodeVersion":"6.0","digest":"b82e68a95aa89a6de344d6e256fef86a848ebc91de560b043b3e1f7fd072d57d"},"rofl":{"category":"people","moji":"🤣","description":"rolling on the floor laughing","unicodeVersion":"9.0","digest":"f4f99ba2ac67b97338f904f9384ff03fb832a2e427bf6e74611bf5fee45f1f48"},"roller_coaster":{"category":"travel","moji":"🎢","description":"roller coaster","unicodeVersion":"6.0","digest":"a65e9ace1d7900499777af1225995f17af90a398bb414764c20b6e09a8c23a2c"},"rolling_eyes":{"category":"people","moji":"🙄","description":"face with rolling eyes","unicodeVersion":"8.0","digest":"23dea8100da488a05721a4e82823eb438393b0ea762211c9ecef011d127aa1b7"},"rooster":{"category":"nature","moji":"🐓","description":"rooster","unicodeVersion":"6.0","digest":"2b90c5cf6fa46da13eb77285443d600afcea0c48bd1d215d60167e7dc510da5d"},"rose":{"category":"nature","moji":"🌹","description":"rose","unicodeVersion":"6.0","digest":"73799e459dba188de4de704605d824242feeb65d587c5bf9109acf528d037146"},"rosette":{"category":"activity","moji":"🏵","description":"rosette","unicodeVersion":"7.0","digest":"2537def4deef422d4e669b28b1a0675259306ab38601019df3ec3482b14e52d5"},"rotating_light":{"category":"travel","moji":"🚨","description":"police cars revolving light","unicodeVersion":"6.0","digest":"91fcdb85a752ae904d335a978c7e7936aed4c75d414b35219b5a74430e51555f"},"round_pushpin":{"category":"objects","moji":"📍","description":"round pushpin","unicodeVersion":"6.0","digest":"8ffca77bbdc6f1f726daf3abd6eff338a5ad1aa9b09dbbd8782c1e7ef5452f30"},"rowboat":{"category":"activity","moji":"🚣","description":"rowboat","unicodeVersion":"6.0","digest":"83715d83a061926d4ad3bb569b21f5d337e3ebd4c9bcdfe493e661c12adc0a16"},"rowboat_tone1":{"category":"activity","moji":"🚣🏻","description":"rowboat tone 1","unicodeVersion":"8.0","digest":"e279ac816442c0876fba1f42c700b80f2fb6de671e1a8a9e9d11b71eed5c58e8"},"rowboat_tone2":{"category":"activity","moji":"🚣🏼","description":"rowboat tone 2","unicodeVersion":"8.0","digest":"6a48eba352ed4971d26498b6c622e5772389c89c5205ed02acde8e995dddcc3b"},"rowboat_tone3":{"category":"activity","moji":"🚣🏽","description":"rowboat tone 3","unicodeVersion":"8.0","digest":"875948f6d8354ebd95ce9a66fde30f06a8366dcd89d5ca3e660845f8801e9305"},"rowboat_tone4":{"category":"activity","moji":"🚣🏾","description":"rowboat tone 4","unicodeVersion":"8.0","digest":"8c7ac7346b0020d0ff5e2f4a1efb1b7785eac637f17556663ec33e2335083f0a"},"rowboat_tone5":{"category":"activity","moji":"🚣🏿","description":"rowboat tone 5","unicodeVersion":"8.0","digest":"a399dbb647892b22323e0bf17bc36a9b5f1708ebedf9ba525233ee7b9d48339a"},"rugby_football":{"category":"activity","moji":"🏉","description":"rugby football","unicodeVersion":"6.0","digest":"cc6f00ade3e0bbb7899e7bfb138b57216dd66de26d7967d5ffa501f382ed09f4"},"runner":{"category":"people","moji":"🏃","description":"runner","unicodeVersion":"6.0","digest":"e9af7b591be60ade2049dbada0f062ba2d3e17f02bec76cbd34ce68854a2a10c"},"runner_tone1":{"category":"people","moji":"🏃🏻","description":"runner tone 1","unicodeVersion":"8.0","digest":"21091cbb09c558712ecf63548bf28b7995df42bdb85235088799a517800e52f5"},"runner_tone2":{"category":"people","moji":"🏃🏼","description":"runner tone 2","unicodeVersion":"8.0","digest":"1fe3d194f675a46fe67799394192e66c407dd81163363692c5e7da32ddb9af2b"},"runner_tone3":{"category":"people","moji":"🏃🏽","description":"runner tone 3","unicodeVersion":"8.0","digest":"8cea1bf4ef3be71f42dc5bae978d5b7a197a3851543225349ef0dda29a370537"},"runner_tone4":{"category":"people","moji":"🏃🏾","description":"runner tone 4","unicodeVersion":"8.0","digest":"c33f0b8b5a71d295fb6ba322e79446964a8eca9e4573efd591e4273808b088a0"},"runner_tone5":{"category":"people","moji":"🏃🏿","description":"runner tone 5","unicodeVersion":"8.0","digest":"9f59e6dd0fdf2f17bceb41f5c355b4e6f3c8bb8cbd8af0992f0b5630ff8892e8"},"running_shirt_with_sash":{"category":"activity","moji":"🎽","description":"running shirt with sash","unicodeVersion":"6.0","digest":"7542307d3595aca45e8ccae66b6e58b6e92870144b738263d5379ec6dc992b76"},"sa":{"category":"symbols","moji":"🈂","description":"squared katakana sa","unicodeVersion":"6.0","digest":"6042bcabd1516ef3847d695aba22851c49421244432d256e24eba04e8a223dab"},"sagittarius":{"category":"symbols","moji":"♐","description":"sagittarius","unicodeVersion":"1.1","digest":"a02593e025023f2e82a01c587a8c0bbb1eff88cbcabf535a1558413eb32ed1d5"},"sailboat":{"category":"travel","moji":"⛵","description":"sailboat","unicodeVersion":"5.2","digest":"c95ef4dc939cbdcb757ef3cd90331310e8c0a426add8cc800bae2540148a3195"},"sake":{"category":"food","moji":"🍶","description":"sake bottle and cup","unicodeVersion":"6.0","digest":"0a786075f3d9da48ae91afccf6ae0d097888da9509d354ee1d3cb99afcc88fe4"},"salad":{"category":"food","moji":"🥗","description":"green salad","unicodeVersion":"9.0","digest":"fe321487ab847abe670e68a83f1d9e096129741c689c769ee7de4a65aeac29f8"},"sandal":{"category":"people","moji":"👡","description":"womans sandal","unicodeVersion":"6.0","digest":"03c3077cb4bd900934f9bdf921165b465e5cc9a6bee53e45a091411bceb8892d"},"santa":{"category":"people","moji":"🎅","description":"father christmas","unicodeVersion":"6.0","digest":"178513e3d815917e59958870f5885b3414b43a16b8056980c863a468dfe00179"},"santa_tone1":{"category":"people","moji":"🎅🏻","description":"father christmas tone 1","unicodeVersion":"8.0","digest":"bf900bbc19bbd329229add9326e28e8197b69d6ddceb69f42162b0200fde5d16"},"santa_tone2":{"category":"people","moji":"🎅🏼","description":"father christmas tone 2","unicodeVersion":"8.0","digest":"7340f2171adab97198e3eecac8b0d84c4c2a41f84606301a0d10e9fe655c93d1"},"santa_tone3":{"category":"people","moji":"🎅🏽","description":"father christmas tone 3","unicodeVersion":"8.0","digest":"7368ab75454ec28d8f7d6baef6ad69b5278445a9f50753f6624731bffde32054"},"santa_tone4":{"category":"people","moji":"🎅🏾","description":"father christmas tone 4","unicodeVersion":"8.0","digest":"0ee60188353e0ee7772079c192bebbc6d49e74e63906f840c66da4eb35f4f245"},"santa_tone5":{"category":"people","moji":"🎅🏿","description":"father christmas tone 5","unicodeVersion":"8.0","digest":"e4378a0cc5d21e9b9fe6e35c32d1ebc6fb8c2e1c09554cd096aeaefd3a6eb511"},"satellite":{"category":"objects","moji":"📡","description":"satellite antenna","unicodeVersion":"6.0","digest":"c9d63118dcb445856917bb080460ab695cc78e715dcbba30ba18dffa9e906b27"},"satellite_orbital":{"category":"travel","moji":"🛰","description":"satellite","unicodeVersion":"7.0","digest":"beb2f50e7f2b010e76bed9daa95d7329a93c783d3ebc4f0b797dd721c5e3d32d"},"saxophone":{"category":"activity","moji":"🎷","description":"saxophone","unicodeVersion":"6.0","digest":"dfd138634f6702a3b89b5a2a50016720eef3f800b0d1d8c9fe097808c9491e96"},"scales":{"category":"objects","moji":"⚖","description":"scales","unicodeVersion":"4.1","digest":"2280c026f16c6b92e0daa00bc14e718770f8d231c571ab439bde84d837cf31cc"},"school":{"category":"travel","moji":"🏫","description":"school","unicodeVersion":"6.0","digest":"af198b068a86ccad3daec4c6873e6b4735086c1ecbb3848182e70bae9aa3ee24"},"school_satchel":{"category":"people","moji":"🎒","description":"school satchel","unicodeVersion":"6.0","digest":"f670ae8aea67eb9d8aaa0bf2748c1cc3e503dcc1dbe999133afcdf21af046b24"},"scissors":{"category":"objects","moji":"✂","description":"black scissors","unicodeVersion":"1.1","digest":"95225be28f05d8b5a6b6e6bf58d973f61f183ad4fef55a558dc1b810796b85c8"},"scooter":{"category":"travel","moji":"🛴","description":"scooter","unicodeVersion":"9.0","digest":"4a7db148880398db75e059711cb53edefb6b8fa9d442009f52856b887ab1dde4"},"scorpion":{"category":"nature","moji":"🦂","description":"scorpion","unicodeVersion":"8.0","digest":"d41119d1ea5daf727c17dbea7dadec1718c72fc9f98ae88252161df5fde0938a"},"scorpius":{"category":"symbols","moji":"♏","description":"scorpius","unicodeVersion":"1.1","digest":"a36404b408814c2ecb8fa8b61f5c5432dfcf54cae8c09cc67b8d0fadf7cbdc03"},"scream":{"category":"people","moji":"😱","description":"face screaming in fear","unicodeVersion":"6.0","digest":"916e4903a4b694da4b00f190f872a4e100e7736b7a2e6171fa1636f46bf646e6"},"scream_cat":{"category":"people","moji":"🙀","description":"weary cat face","unicodeVersion":"6.0","digest":"f1d3a6ff538064e7d5e0321bbc33aba44e8da703dc1894ef1403c0cd6d63d781"},"scroll":{"category":"objects","moji":"📜","description":"scroll","unicodeVersion":"6.0","digest":"9b2cb00860bcc2d20017cafb2ed9681b6232dc07273d489d75d53ce29e4ba3ab"},"seat":{"category":"travel","moji":"💺","description":"seat","unicodeVersion":"6.0","digest":"ae68d86fc2a07cae332451b23bd1ceba3f6526a6c56d8c1089777fa4632850e1"},"second_place":{"category":"activity","moji":"🥈","description":"second place medal","unicodeVersion":"9.0","digest":"9e2336fc16e532829b55380252f94655b58817d47c909fc2570002c5b06b9c40"},"secret":{"category":"symbols","moji":"㊙","description":"circled ideograph secret","unicodeVersion":"1.1","digest":"1d0b9adde2657f41421b135962de20820cf4b4eb0204044f9859522ab9d211b0"},"see_no_evil":{"category":"nature","moji":"🙈","description":"see-no-evil monkey","unicodeVersion":"6.0","digest":"3ff66d2e84b36d071d0a34f8e41cfd620a56b83131474ea50ed7803b635551ed"},"seedling":{"category":"nature","moji":"🌱","description":"seedling","unicodeVersion":"6.0","digest":"c0ec5e6d20e1afdc4e78eeddb1301c8b708ad6278e7287a4e4e825417c858e75"},"selfie":{"category":"people","moji":"🤳","description":"selfie","unicodeVersion":"9.0","digest":"2a1bc9f18ad4d6fb893d91c88ef1b2d9bd063dc2bb1a4b08c248c30f52545d4e"},"selfie_tone1":{"category":"people","moji":"🤳🏻","description":"selfie tone 1","unicodeVersion":"9.0","digest":"26dc212ffed30c276bd6a66a72bc4513e68098a2205fb4ca5b51ccfa1de5b544"},"selfie_tone2":{"category":"people","moji":"🤳🏼","description":"selfie tone 2","unicodeVersion":"9.0","digest":"71eceaefda46e3521f374f76693e7fa8f215067498067900080e2925ca94d7de"},"selfie_tone3":{"category":"people","moji":"🤳🏽","description":"selfie tone 3","unicodeVersion":"9.0","digest":"53eabbd4f6b8ebbd2f7af7bf5cd64309c4039ac1c5b2180290a547deaafcebdf"},"selfie_tone4":{"category":"people","moji":"🤳🏾","description":"selfie tone 4","unicodeVersion":"9.0","digest":"0baad378b09652b99c5d458db2e03b4db14a1557db4ea0969806a0ca1d33d40c"},"selfie_tone5":{"category":"people","moji":"🤳🏿","description":"selfie tone 5","unicodeVersion":"9.0","digest":"9a07608f34ec4dad48764a855f83f3965709d7b2fd2342e6dc9ed61f23f4adfd"},"seven":{"category":"symbols","moji":"7️⃣","description":"keycap digit seven","unicodeVersion":"3.0","digest":"ae85172d2c76c44afb4e3b45d277d400abb2dc895244b9abfbd1dac1cd7c53c2"},"shallow_pan_of_food":{"category":"food","moji":"🥘","description":"shallow pan of food","unicodeVersion":"9.0","digest":"7c7ad9d5d3f7226427d310b5853e8257fad899febe58dcbc5adb4677964f5c6d"},"shamrock":{"category":"nature","moji":"☘","description":"shamrock","unicodeVersion":"4.1","digest":"68ed70c26e04a818439a1742d2da6bc169edd02db86b6e6f8014b651f3235488"},"shark":{"category":"nature","moji":"🦈","description":"shark","unicodeVersion":"9.0","digest":"23a2364b6356e7bbb84c138e9cf58e2c68cd8caabb337a0c4d365ce87bf5d2da"},"shaved_ice":{"category":"food","moji":"🍧","description":"shaved ice","unicodeVersion":"6.0","digest":"54048e77268b7548d03088517bf8558d11324db901ca57f9bec93f1873663a74"},"sheep":{"category":"nature","moji":"🐑","description":"sheep","unicodeVersion":"6.0","digest":"c867c8e6e51768f1f51f4fe5abd3fbd5c1d69b01a3cb48b5fb94b6e2338a271c"},"shell":{"category":"nature","moji":"🐚","description":"spiral shell","unicodeVersion":"6.0","digest":"8983652d33ad6ab91195518cecb5a268a1c0ae603d271f0ddd756ff50058ddb3"},"shield":{"category":"objects","moji":"🛡","description":"shield","unicodeVersion":"7.0","digest":"763d0a56a62c51c730ccb0fbea38ab597cbf41a85ab968198e6ec35630d50aa5"},"shinto_shrine":{"category":"travel","moji":"⛩","description":"shinto shrine","unicodeVersion":"5.2","digest":"38a6d756c5aa9703510afa5076d75192f7814bbb6632394d4b8253d9ceda7f8c"},"ship":{"category":"travel","moji":"🚢","description":"ship","unicodeVersion":"6.0","digest":"79c680845892a3e81ec6af2160ee07c29147155943e5daba6c76d04252014c20"},"shirt":{"category":"people","moji":"👕","description":"t-shirt","unicodeVersion":"6.0","digest":"46c7253e15d7cac03699ddb1550fbb7565bbe487310f7e218c0583aa69f9d3c5"},"shopping_bags":{"category":"objects","moji":"🛍","description":"shopping bags","unicodeVersion":"7.0","digest":"95a3f03c675207bb1354270d02a630c204455c47b3edca23c48523a40cf3ea3b"},"shopping_cart":{"category":"objects","moji":"🛒","description":"shopping trolley","unicodeVersion":"9.0","digest":"4599b63f6861cdb4d8272cac84435c24c1d4d6a73c66d51e04a1cd14a1d333e6"},"shower":{"category":"objects","moji":"🚿","description":"shower","unicodeVersion":"6.0","digest":"6b3c767c0eb472d4861c6c3cc2735a5e2c09681872ef42a11dc89f3c80b9da01"},"shrimp":{"category":"nature","moji":"🦐","description":"shrimp","unicodeVersion":"9.0","digest":"b3651f3be3767125076a013fe903854f5b456a8afae865cb219cf528e0f44caa"},"shrug":{"category":"people","moji":"🤷","description":"shrug","unicodeVersion":"9.0","digest":"6e264243cc3b6e396069dea4357a958bdcd4081cb1af0ed6aa47235bef88cf27"},"shrug_tone1":{"category":"people","moji":"🤷🏻","description":"shrug tone 1","unicodeVersion":"9.0","digest":"0567b9fd95c8a857914003a5465a500ca79c8111811d45b865021b1b1d92d0b1"},"shrug_tone2":{"category":"people","moji":"🤷🏼","description":"shrug tone 2","unicodeVersion":"9.0","digest":"1557c2f5e3d4599c806d74c0b78afcca940678787534b6862bb89a20601bac8a"},"shrug_tone3":{"category":"people","moji":"🤷🏽","description":"shrug tone 3","unicodeVersion":"9.0","digest":"f02754541a7bf74ba7eebe6c27daf1e3e1dac25172c35b8ba45641e278dfda3d"},"shrug_tone4":{"category":"people","moji":"🤷🏾","description":"shrug tone 4","unicodeVersion":"9.0","digest":"2b5121164cb5f4e253d8fb31f6445cf8afaf30dba41732edc511440cdb78d15c"},"shrug_tone5":{"category":"people","moji":"🤷🏿","description":"shrug tone 5","unicodeVersion":"9.0","digest":"62d99a26bbad479f574f66208c41b9960cd41fb9d79d3a13fbdaa44682077115"},"signal_strength":{"category":"symbols","moji":"📶","description":"antenna with bars","unicodeVersion":"6.0","digest":"2c6f04ba4ecd2d2d423e19eb52cfbfd253f4db6e0908d91c1af4ea6192597447"},"six":{"category":"symbols","moji":"6️⃣","description":"keycap digit six","unicodeVersion":"3.0","digest":"cede9324261208d0fd5d00fcdfc0df0331944bd9cff4f40b30a582a641526c1c"},"six_pointed_star":{"category":"symbols","moji":"🔯","description":"six pointed star with middle dot","unicodeVersion":"6.0","digest":"9203e3b4f08af439ae0bfb6a7b29a02dceb027b6c2dc5463b524dfd314cbff4e"},"ski":{"category":"activity","moji":"🎿","description":"ski and ski boot","unicodeVersion":"6.0","digest":"80f0ca8660ba373fef823af9e98e148c4ddb1e217eb6d0a0ea2bae2288b57570"},"skier":{"category":"activity","moji":"⛷","description":"skier","unicodeVersion":"5.2","digest":"4fff0aa155367f551a59aed9657b8afa159173882b25db9cd8434293d1eed76d"},"skull":{"category":"people","moji":"💀","description":"skull","unicodeVersion":"6.0","digest":"cdd2031164281bf2b0083df4479651d96bc16d11e44bac4deaf402a9c0d6f40a"},"skull_crossbones":{"category":"objects","moji":"☠","description":"skull and crossbones","unicodeVersion":"1.1","digest":"ae764ba21a1fcc4409f4cc9e75a261d70b87548f64158dbd3451374ad5724123"},"sleeping":{"category":"people","moji":"😴","description":"sleeping face","unicodeVersion":"6.1","digest":"1050a011509b56735c9f30a6fccc876256e2a4546dc6052e518151c8aca4b526"},"sleeping_accommodation":{"category":"objects","moji":"🛌","description":"sleeping accommodation","unicodeVersion":"7.0","digest":"2ce42c027d1d0947abc403c359fd668a7bc44f5ead2582e97f3db7dd4e22e5d5"},"sleepy":{"category":"people","moji":"😪","description":"sleepy face","unicodeVersion":"6.0","digest":"2ee9bb1f72ef99e0e33095ec2bbf7a58ffea0ff7d40b840f4cdba57be9de74b0"},"slight_frown":{"category":"people","moji":"🙁","description":"slightly frowning face","unicodeVersion":"7.0","digest":"d71d564a6c2d366a8e28a78ef4e07d387a77037fe8c99aa0ea1571299dc490c9"},"slight_smile":{"category":"people","moji":"🙂","description":"slightly smiling face","unicodeVersion":"7.0","digest":"10f4b66a755f5c78762a330f20d1866e4a22f3f1d495161d758d3bab8d2f36fe"},"slot_machine":{"category":"activity","moji":"🎰","description":"slot machine","unicodeVersion":"6.0","digest":"914184788f8cd865cd074dca25c22acee31f5498117bd9a6e78cae67e6601652"},"small_blue_diamond":{"category":"symbols","moji":"🔹","description":"small blue diamond","unicodeVersion":"6.0","digest":"0b56d8e6b5ddf1f49fcc76e45e5fb2ee9f99ae6ffe682c26eaea4d9b7faac36c"},"small_orange_diamond":{"category":"symbols","moji":"🔸","description":"small orange diamond","unicodeVersion":"6.0","digest":"a2235830550e289c1608f2dcf5ede48f5c1a0eff45570699c39708c9677ab950"},"small_red_triangle":{"category":"symbols","moji":"🔺","description":"up-pointing red triangle","unicodeVersion":"6.0","digest":"8c2985c4e9ce42d2f3b35539b879bc36206c5ef749f39fbd1eac51bd2676e1e5"},"small_red_triangle_down":{"category":"symbols","moji":"🔻","description":"down-pointing red triangle","unicodeVersion":"6.0","digest":"46bd328df2fbf5d0597596bbf00d2d5f6e0c65bcb8f3fb325df8ba0c25e445b5"},"smile":{"category":"people","moji":"😄","description":"smiling face with open mouth and smiling eyes","unicodeVersion":"6.0","digest":"14905c372d5bf7719bd727c9efae31a03291acec79801652a23710c6848c5d14"},"smile_cat":{"category":"people","moji":"😸","description":"grinning cat face with smiling eyes","unicodeVersion":"6.0","digest":"c35b76d6df100edb4022d762f47abfeb9f5e70886960c1d25908bd5d57ccb47e"},"smiley":{"category":"people","moji":"😃","description":"smiling face with open mouth","unicodeVersion":"6.0","digest":"a89f31eb9d814636852517a7f4eadec59195e2ac2cc9f8d124f1a1cc0f775b4a"},"smiley_cat":{"category":"people","moji":"😺","description":"smiling cat face with open mouth","unicodeVersion":"6.0","digest":"3e66a113c5e3e73fb94be29084cb27986b6bdb0e78ab44785bf2a35a550e71bf"},"smiling_imp":{"category":"people","moji":"😈","description":"smiling face with horns","unicodeVersion":"6.0","digest":"3e02131d16525938f6facc7e097365dec7e13c8a0049a3be35fc29c80cc291b3"},"smirk":{"category":"people","moji":"😏","description":"smirking face","unicodeVersion":"6.0","digest":"3c180d46f5574d6fca3bb68eb02517da60b7008843cb3e90f2f9620d0c8ee943"},"smirk_cat":{"category":"people","moji":"😼","description":"cat face with wry smile","unicodeVersion":"6.0","digest":"0683c7f73e1f65984e91313607d7cca21d99acd4b2e9932f00e0fffd0ce90742"},"smoking":{"category":"objects","moji":"🚬","description":"smoking symbol","unicodeVersion":"6.0","digest":"baa9cb444bf0fe5c74358f981b19bc9e5c0415ced7f042baf93642282476ea61"},"snail":{"category":"nature","moji":"🐌","description":"snail","unicodeVersion":"6.0","digest":"5733bf3672ae4b2b3e090fa670aeac70dcbcc04ca5b13abc8c8e53b8b3d4ff33"},"snake":{"category":"nature","moji":"🐍","description":"snake","unicodeVersion":"6.0","digest":"18da2d97c771149ef5454dd23470e900903a62ab93f9e2ce301aad5a8181d773"},"sneezing_face":{"category":"people","moji":"🤧","description":"sneezing face","unicodeVersion":"9.0","digest":"c20ef571dc7e35572fe3c18b7845aefc89af083ea925c48a29de3b7387af6e17"},"snowboarder":{"category":"activity","moji":"🏂","description":"snowboarder","unicodeVersion":"6.0","digest":"c6e074139b851aa53b1ba6464d84da14b3da7412fc44c6c196a8469d76915c19"},"snowflake":{"category":"nature","moji":"❄","description":"snowflake","unicodeVersion":"1.1","digest":"6556c918e181df01ba849e76c43972d5310439971e5d8fc2409d112c05bf0028"},"snowman":{"category":"nature","moji":"⛄","description":"snowman without snow","unicodeVersion":"5.2","digest":"6137456b2335e88e09c1859615eb22bb636355ef438f7a3949ad2f3d54478dd3"},"snowman2":{"category":"nature","moji":"☃","description":"snowman","unicodeVersion":"1.1","digest":"33ec75c22a13c81fa3c6b24a77ac1a08dc0dbe70b3716cf17b6702014d8a63fe"},"sob":{"category":"people","moji":"😭","description":"loudly crying face","unicodeVersion":"6.0","digest":"d1ed4b31861f9f9fd4e9c95a9c17530e2320a1b4cad6ececb1545ce25d65e4ce"},"soccer":{"category":"activity","moji":"⚽","description":"soccer ball","unicodeVersion":"5.2","digest":"6a3f2e6a9a0b64c3fbf8705995792091daf386a4112dba75507a1f556f662f84"},"soon":{"category":"symbols","moji":"🔜","description":"soon with rightwards arrow above","unicodeVersion":"6.0","digest":"a49d1bcfbac3e6ccc05b9a9863eff74b0eb8b4d4b22b8b0f7b2787fcba1c73cc"},"sos":{"category":"symbols","moji":"🆘","description":"squared sos","unicodeVersion":"6.0","digest":"2fa7e0274383aeed6019eb9177e778d7aab8b88575b078b0ffeb77cd18df14b3"},"sound":{"category":"symbols","moji":"🔉","description":"speaker with one sound wave","unicodeVersion":"6.0","digest":"faaca7b315b2495cbc381468580d25f1d11362441c35bb43d8a914f2ec8202d2"},"space_invader":{"category":"activity","moji":"👾","description":"alien monster","unicodeVersion":"6.0","digest":"e75379cb5063f9a8861d762ad1886097c1697fbb61f2e4e8f531047955a4a2dd"},"spades":{"category":"symbols","moji":"♠","description":"black spade suit","unicodeVersion":"1.1","digest":"2c4d20f6a4893cfc62498d3f1f8f67577f39ed09f3e6682d8cb9cd8f365d30da"},"spaghetti":{"category":"food","moji":"🍝","description":"spaghetti","unicodeVersion":"6.0","digest":"6d3451dc0faa1913539edb99261448f51735f269b61193c53dfe63466c0191e8"},"sparkle":{"category":"symbols","moji":"❇","description":"sparkle","unicodeVersion":"1.1","digest":"7131163cd6c2f879110c86e9f068c33cf580f7c4b619449c41851fe6083402ee"},"sparkler":{"category":"travel","moji":"🎇","description":"firework sparkler","unicodeVersion":"6.0","digest":"88539ed8a13bd66e0c265c0913bd3ec2ddc4d95484323595713beb102221a1f6"},"sparkles":{"category":"nature","moji":"✨","description":"sparkles","unicodeVersion":"6.0","digest":"cf84d16b1c0a381d5a7ae79031872747c9a6887eab6e92cc4a10a4b8600ef506"},"sparkling_heart":{"category":"symbols","moji":"💖","description":"sparkling heart","unicodeVersion":"6.0","digest":"b80b1ddef83b6528b309a194f6f2faf5acab603daeb9254523efc2b941bcb6d2"},"speak_no_evil":{"category":"nature","moji":"🙊","description":"speak-no-evil monkey","unicodeVersion":"6.0","digest":"d2d7cfb4d471928a496bdc146890adc8422a68500b68115630b24c125d18e81f"},"speaker":{"category":"symbols","moji":"🔈","description":"speaker","unicodeVersion":"6.0","digest":"dbca5f7181728d2ad67ff76fd566ffbdf53e333e7eeed341f54668bd47969413"},"speaking_head":{"category":"people","moji":"🗣","description":"speaking head in silhouette","unicodeVersion":"7.0","digest":"4be1af79b4506c00af4df64663413bcbae195dab0bc63c5011feb8f9663ed544"},"speech_balloon":{"category":"symbols","moji":"💬","description":"speech balloon","unicodeVersion":"6.0","digest":"817100d9979456e7d2f253ac22e13b7a2302dc1590566214915b003e403c53ca"},"speech_left":{"category":"symbols","moji":"🗨","description":"left speech bubble","unicodeVersion":"7.0","digest":"912797107d574f5665411498b6e349dbdec69846f085b6dc356548c4155e90b0"},"speedboat":{"category":"travel","moji":"🚤","description":"speedboat","unicodeVersion":"6.0","digest":"a523b2320f0b24be1e9fdbc1ff828e28d8fd9a64d51e5888ab453ef0bc9f0576"},"spider":{"category":"nature","moji":"🕷","description":"spider","unicodeVersion":"7.0","digest":"8411eac0c1b80926fd93cc1d6423e00b05d04c485b79ee232da8f1714e899a37"},"spider_web":{"category":"nature","moji":"🕸","description":"spider web","unicodeVersion":"7.0","digest":"2434bdfbe56dcc4a43699dd59b638af431486b52fb1d6d685451f3b231b2be23"},"spoon":{"category":"food","moji":"🥄","description":"spoon","unicodeVersion":"9.0","digest":"4fa31d59e5bffd2c45a8e01fcd5652e78a5691cbfa744e69882bc67173ddea05"},"spy":{"category":"people","moji":"🕵","description":"sleuth or spy","unicodeVersion":"7.0","digest":"99fe3cdeff934726ee5855b0e401bf32570084aaad4eb10df837fd410ca742aa"},"spy_tone1":{"category":"people","moji":"🕵🏻","description":"sleuth or spy tone 1","unicodeVersion":"8.0","digest":"1720a99064061c43c7647b6bd517efa2ee2621b355a644adfb347d62849366a2"},"spy_tone2":{"category":"people","moji":"🕵🏼","description":"sleuth or spy tone 2","unicodeVersion":"8.0","digest":"23ff0026723f2b5a46fbfb55e24c4a4a33af2bd96808b3ea3af76aae99965d68"},"spy_tone3":{"category":"people","moji":"🕵🏽","description":"sleuth or spy tone 3","unicodeVersion":"8.0","digest":"1d0cb3d54fb61e4763a4f0642ef32094bdd40832be0d42799ce9ba69773616df"},"spy_tone4":{"category":"people","moji":"🕵🏾","description":"sleuth or spy tone 4","unicodeVersion":"8.0","digest":"e36a4b52df6cb954fab9d9128111f1301c6d46bdeacf51993ffb5bb354cd0ad3"},"spy_tone5":{"category":"people","moji":"🕵🏿","description":"sleuth or spy tone 5","unicodeVersion":"8.0","digest":"ffc6fefd9a537124ebf0a9ddf387414dce1291335026064644f6cf9315591129"},"squid":{"category":"nature","moji":"🦑","description":"squid","unicodeVersion":"9.0","digest":"65a1b318c2c506b9d26cfd8282a5cf9922109595c8d12e92c3f7481ac7c08c49"},"stadium":{"category":"travel","moji":"🏟","description":"stadium","unicodeVersion":"7.0","digest":"73bf955e767ba1518c9c92b2ba59a2aa1ec4b018652dffd97bcd74832a33789f"},"star":{"category":"nature","moji":"⭐","description":"white medium star","unicodeVersion":"5.1","digest":"d78e5c1b78caed103e100150c10b08a9ca3ee30c243943d6fc3cc08f422122e9"},"star2":{"category":"nature","moji":"🌟","description":"glowing star","unicodeVersion":"6.0","digest":"f91ac4afe3f5d4a52847ae8b4a9704b591e00399aebba553d150d7e34ee939fa"},"star_and_crescent":{"category":"symbols","moji":"☪","description":"star and crescent","unicodeVersion":"1.1","digest":"1bf3d29e50034f5e7c0dccff0a3a533b74bfa9b489e357b2739a473311f1332a"},"star_of_david":{"category":"symbols","moji":"✡","description":"star of david","unicodeVersion":"1.1","digest":"28a0bd0eeac9d0835ceb8425d72c2472464e863dd09b76a0ddc1c08cf1986402"},"stars":{"category":"travel","moji":"🌠","description":"shooting star","unicodeVersion":"6.0","digest":"837d9045316b8fb5e533457eac61241534f641eb78d8cb75f688f80fb8e8a7f0"},"station":{"category":"travel","moji":"🚉","description":"station","unicodeVersion":"6.0","digest":"27a163ac0aea4ed247a121cae826eafc475977c68b0d888e9405bea14326ff56"},"statue_of_liberty":{"category":"travel","moji":"🗽","description":"statue of liberty","unicodeVersion":"6.0","digest":"f5a43599ab3f24ed3a78a745e06e2ac3e33107a292386ad81c67935ee5b22493"},"steam_locomotive":{"category":"travel","moji":"🚂","description":"steam locomotive","unicodeVersion":"6.0","digest":"52ad0073f37b978faf3884fb193046f2b0614e1557bbcc9de1b020e42aff2dba"},"stew":{"category":"food","moji":"🍲","description":"pot of food","unicodeVersion":"6.0","digest":"c16f61236db314ad8d9f2dd241ec1e15c8d64e5872cce93ec4d0996490dd39df"},"stop_button":{"category":"symbols","moji":"⏹","description":"black square for stop","unicodeVersion":"7.0","digest":"83f9d0da3ad845fef41b4e8336815d30e9c8f042ab2a8340894ade2f428fc98a"},"stopwatch":{"category":"objects","moji":"⏱","description":"stopwatch","unicodeVersion":"6.0","digest":"9b6b9491a24d8ab4f896eb876da7973f028bd5e7c51a3767ba7e61bb6fbb2be0"},"straight_ruler":{"category":"objects","moji":"📏","description":"straight ruler","unicodeVersion":"6.0","digest":"cee31101767bd3f961363599924dc3790675d05a1285a8396428d2f91771c111"},"strawberry":{"category":"food","moji":"🍓","description":"strawberry","unicodeVersion":"6.0","digest":"5750a15e12f21259286ddbc3a8222a385b3b97a9f368897f42dd000060343174"},"stuck_out_tongue":{"category":"people","moji":"😛","description":"face with stuck-out tongue","unicodeVersion":"6.1","digest":"92dc42980a6dfdd7204fc874a762d6a0bbf0fdbfb5a7c0698fca04782e99fde6"},"stuck_out_tongue_closed_eyes":{"category":"people","moji":"😝","description":"face with stuck-out tongue and tightly-closed eyes","unicodeVersion":"6.0","digest":"434d25ac24cad7ba699eae876a25d9a99b584449cca50b124bf6aa7f20a83d51"},"stuck_out_tongue_winking_eye":{"category":"people","moji":"😜","description":"face with stuck-out tongue and winking eye","unicodeVersion":"6.0","digest":"dbacd6428a2a2933212e6a4dc0c7f302177fb23b963626ccb26f27f91737f03d"},"stuffed_flatbread":{"category":"food","moji":"🥙","description":"stuffed flatbread","unicodeVersion":"9.0","digest":"9f841f2520640d69be4f20a3199023d5811842b28556b5e1152e5ec11f0fda07"},"sun_with_face":{"category":"nature","moji":"🌞","description":"sun with face","unicodeVersion":"6.0","digest":"7256ff5263006c64c03f1eb66e3ddb56d67d785d65dacc37aa886d0cd4be63be"},"sunflower":{"category":"nature","moji":"🌻","description":"sunflower","unicodeVersion":"6.0","digest":"27d1161f50f932a6b26c404cf2e8f7083683ed0f2382d62b7472acccaa6eb695"},"sunglasses":{"category":"people","moji":"😎","description":"smiling face with sunglasses","unicodeVersion":"6.0","digest":"966684382e5c59e98319e4c0ea7c304c61c2638ad5408faa49ce2c83c4416757"},"sunny":{"category":"nature","moji":"☀","description":"black sun with rays","unicodeVersion":"1.1","digest":"460fea4cbbdd1595450c1033a2ee5de7fea2e2f147822efa49f7e204812415aa"},"sunrise":{"category":"travel","moji":"🌅","description":"sunrise","unicodeVersion":"6.0","digest":"7718a49636b0cdd1862ed67c7a9d6e72f471c2591ff0d912485b1be55d1ea115"},"sunrise_over_mountains":{"category":"travel","moji":"🌄","description":"sunrise over mountains","unicodeVersion":"6.0","digest":"743d0701cdbe2a814962363813c3153d3c5e62c3e410349f56d49dbb9581f356"},"surfer":{"category":"activity","moji":"🏄","description":"surfer","unicodeVersion":"6.0","digest":"bb440775e9213430942015c37db8de58b5a561ee971b2a0f3993fc3f1d2554d4"},"surfer_tone1":{"category":"activity","moji":"🏄🏻","description":"surfer tone 1","unicodeVersion":"8.0","digest":"a4937b030aca30b68bb644f37cf63c38aebce3c00b57d1c8a0ffe596b57d2f1e"},"surfer_tone2":{"category":"activity","moji":"🏄🏼","description":"surfer tone 2","unicodeVersion":"8.0","digest":"1c2a954a9c5284dedf0327d6f3c954c9fdd3953b848076d298874775ad8bf0a3"},"surfer_tone3":{"category":"activity","moji":"🏄🏽","description":"surfer tone 3","unicodeVersion":"8.0","digest":"418a3408b9ab026124f067c8597b500217e56bc28d9844a29eea5eee6f604ff8"},"surfer_tone4":{"category":"activity","moji":"🏄🏾","description":"surfer tone 4","unicodeVersion":"8.0","digest":"530870b9ac9f4d45ff750e264feb90b44fb93ca2852f323987b06f5f12fb5a4d"},"surfer_tone5":{"category":"activity","moji":"🏄🏿","description":"surfer tone 5","unicodeVersion":"8.0","digest":"40e11b1ae652cfd085d083377f1da24160065ed1b67403c6fa4655e6e44169ec"},"sushi":{"category":"food","moji":"🍣","description":"sushi","unicodeVersion":"6.0","digest":"b924c621236ca3284b349b0509ae1043f2fc2c7f6d67615716f9717ada78c992"},"suspension_railway":{"category":"travel","moji":"🚟","description":"suspension railway","unicodeVersion":"6.0","digest":"cd3d21da79864f0c018b863e82fb0561fff3c5e3c065303cfcb89c3663d638ba"},"sweat":{"category":"people","moji":"😓","description":"face with cold sweat","unicodeVersion":"6.0","digest":"1aa771479aa1ac5eeea4bafbe93ebd85a0f692f6d869034f31e25b689c2e264d"},"sweat_drops":{"category":"nature","moji":"💦","description":"splashing sweat symbol","unicodeVersion":"6.0","digest":"b575b85415bc9852cf6415d417ebf799167fde03c6819ebcaa24ae1b3dde8dab"},"sweat_smile":{"category":"people","moji":"😅","description":"smiling face with open mouth and cold sweat","unicodeVersion":"6.0","digest":"171b0d0845d46c33bedb6d3b39fb1ff366e22ba90685eedabebd91bb2b0680de"},"sweet_potato":{"category":"food","moji":"🍠","description":"roasted sweet potato","unicodeVersion":"6.0","digest":"4b91920f0b87d42763313bc476f4c821a74e4c12dc1c92165a859dddeaaf8844"},"swimmer":{"category":"activity","moji":"🏊","description":"swimmer","unicodeVersion":"6.0","digest":"2c4ed4a51aad99d9957ae11a219d5164db9748fc3a65002c6085a9f15adfa9e2"},"swimmer_tone1":{"category":"activity","moji":"🏊🏻","description":"swimmer tone 1","unicodeVersion":"8.0","digest":"48588f129ee4af52ca2e0f4594213391978601087cd607896b2f979ca077284b"},"swimmer_tone2":{"category":"activity","moji":"🏊🏼","description":"swimmer tone 2","unicodeVersion":"8.0","digest":"fff209448524bd1ef4d6decabf6c1ead94c8d3d5b1bfb5e54f20cc8e139232fc"},"swimmer_tone3":{"category":"activity","moji":"🏊🏽","description":"swimmer tone 3","unicodeVersion":"8.0","digest":"2003932cb2cf4ae9a10b23338bf375a9293fb18c0ecf91bdfae73be6eebb3800"},"swimmer_tone4":{"category":"activity","moji":"🏊🏾","description":"swimmer tone 4","unicodeVersion":"8.0","digest":"20b4bff9baa1c694ad98067dde834c56092f023b9664bec382c2e512232bd480"},"swimmer_tone5":{"category":"activity","moji":"🏊🏿","description":"swimmer tone 5","unicodeVersion":"8.0","digest":"0ff8eb57c2be8e80a1bc6ba75b8d9ffb9bd8d3be636150c4c03399ec1886f218"},"symbols":{"category":"symbols","moji":"🔣","description":"input symbol for symbols","unicodeVersion":"6.0","digest":"2a2a79816c4d0751a0d73586eec5e63b410653d3c85cc968906bf1fc03d89b94"},"synagogue":{"category":"travel","moji":"🕍","description":"synagogue","unicodeVersion":"8.0","digest":"98569cdd7c61528963b67b7891dfa46025c5e810cbb22ee18ddb3bd85de2da69"},"syringe":{"category":"objects","moji":"💉","description":"syringe","unicodeVersion":"6.0","digest":"e1538e645ccc571227c994b71b3d1be2c4d072d8bd9c944a42ff4a11c91a34a6"},"taco":{"category":"food","moji":"🌮","description":"taco","unicodeVersion":"8.0","digest":"e1e45aefdb7445faeae75c3831df6a3d6f2590fcdd48a20d847593c246df613b"},"tada":{"category":"objects","moji":"🎉","description":"party popper","unicodeVersion":"6.0","digest":"1d2e6cbb2a3244240bc70209715d2213d1efee2e370cccfbcc046c333ae2d650"},"tanabata_tree":{"category":"nature","moji":"🎋","description":"tanabata tree","unicodeVersion":"6.0","digest":"592f2907ffc1b914390e1a106c15120ff3607e99192158b94d237975647c5540"},"tangerine":{"category":"food","moji":"🍊","description":"tangerine","unicodeVersion":"6.0","digest":"40c9ddcde1b0bcfaeb466629a87825eb8c2037835720cbee5e2fda04be3c8d0a"},"taurus":{"category":"symbols","moji":"♉","description":"taurus","unicodeVersion":"1.1","digest":"21cf24cb6410ab6596e2df8b3e242cc07f9dbb247eabc00c590fe184b373d068"},"taxi":{"category":"travel","moji":"🚕","description":"taxi","unicodeVersion":"6.0","digest":"c546cc743831cfbf0c15452767cf2a4faf3775066797e997ae7c1fcbe4eca479"},"tea":{"category":"food","moji":"🍵","description":"teacup without handle","unicodeVersion":"6.0","digest":"00e3f1e389fa58c4fcd8c53ebbf83d25872f4315845ab1984b35410ae65553d9"},"telephone":{"category":"objects","moji":"☎","description":"black telephone","unicodeVersion":"1.1","digest":"3a53851e641f8ad938ce3597b1afca2ea63c9314ff81f62563b99937496a13d7"},"telephone_receiver":{"category":"objects","moji":"📞","description":"telephone receiver","unicodeVersion":"6.0","digest":"1614d67f3d8814b0d75f39d55f9149e4d28ef57b343498625e62fcfff8365046"},"telescope":{"category":"objects","moji":"🔭","description":"telescope","unicodeVersion":"6.0","digest":"4adf40387870276c4f59fb050d441023e8dac784365b6a8c0282fb519780b495"},"ten":{"category":"symbols","moji":"🔟","description":"keycap ten","unicodeVersion":"6.0","digest":"c7c9491021740d2c17edddb856f79579b0b943d8dc85a2f48dbaac84f35b8a40"},"tennis":{"category":"activity","moji":"🎾","description":"tennis racquet and ball","unicodeVersion":"6.0","digest":"dc1600b4d8dce3d26259eb0d1c6ab042566565e3c1f2c96112210f1550a716fd"},"tent":{"category":"travel","moji":"⛺","description":"tent","unicodeVersion":"5.2","digest":"30d9b17ac3219d4970ddf54d7c1a288b0ae50f7f3b82ed232c0b1b19ef585662"},"thermometer":{"category":"objects","moji":"🌡","description":"thermometer","unicodeVersion":"7.0","digest":"66616babbcaef256d7b652796c760e8e893cb950c073348a408fe70904f80f25"},"thermometer_face":{"category":"people","moji":"🤒","description":"face with thermometer","unicodeVersion":"8.0","digest":"ac2b5caddd128563711a9dcc7f690cf210f684d5e8b64b09c0431d6902437126"},"thinking":{"category":"people","moji":"🤔","description":"thinking face","unicodeVersion":"8.0","digest":"4f0b84e5ab8a650cafb166e93688f0e9b31b9ade22a91035261ac90490edb9d3"},"third_place":{"category":"activity","moji":"🥉","description":"third place medal","unicodeVersion":"9.0","digest":"27c9bcba44ad95bee30882cc0722e8b0a798206306655dd648e884447ed26808"},"thought_balloon":{"category":"symbols","moji":"💭","description":"thought balloon","unicodeVersion":"6.0","digest":"bf59624560c333561d636aedf2c8827089e275895cf434974daaabb3d5cea46e"},"three":{"category":"symbols","moji":"3️⃣","description":"keycap digit three","unicodeVersion":"3.0","digest":"d3f85828787799c769655c38a519cad0743ab799ab276c7606e6e6894cc442e6"},"thumbsdown":{"category":"people","moji":"👎","description":"thumbs down sign","unicodeVersion":"6.0","digest":"5954334e2dae5357312b3d629f10a496c728029e02216f8c8b887f9b51561c61"},"thumbsdown_tone1":{"category":"people","moji":"👎🏻","description":"thumbs down sign tone 1","unicodeVersion":"8.0","digest":"3c2853491473fd7ae2d1b5415a425cc390d26a8754446f8736c1360e4cb18ba3"},"thumbsdown_tone2":{"category":"people","moji":"👎🏼","description":"thumbs down sign tone 2","unicodeVersion":"8.0","digest":"4e0f8f86a06b69e423df8d93f41ec393f12800633acc82c4cb6dff64ca0d8507"},"thumbsdown_tone3":{"category":"people","moji":"👎🏽","description":"thumbs down sign tone 3","unicodeVersion":"8.0","digest":"e08fa35575f59978612d4330bbc35313eca9c4dfa04f4212626abc700819effe"},"thumbsdown_tone4":{"category":"people","moji":"👎🏾","description":"thumbs down sign tone 4","unicodeVersion":"8.0","digest":"7c6d118d20d5add8ca003e4a53e42685a1f9436b872ed10d79f67ad418fb2a44"},"thumbsdown_tone5":{"category":"people","moji":"👎🏿","description":"thumbs down sign tone 5","unicodeVersion":"8.0","digest":"8697c4a4ee4d6669dc2d47aa97699c42012ca59b80818ad6845878b37b4a9c58"},"thumbsup":{"category":"people","moji":"👍","description":"thumbs up sign","unicodeVersion":"6.0","digest":"59ec2457ab33e8897261d01a495f6cf5c668d0004807dc541c3b1be5294b1e61"},"thumbsup_tone1":{"category":"people","moji":"👍🏻","description":"thumbs up sign tone 1","unicodeVersion":"8.0","digest":"f57e6c525e8830779ea5026590eec3ca10869dc438a0c779734b617d04f28d21"},"thumbsup_tone2":{"category":"people","moji":"👍🏼","description":"thumbs up sign tone 2","unicodeVersion":"8.0","digest":"980eeeb1d8f5d79dae35c7ff81a576e980aa13a440d07b10e32e98ed34cbf7f1"},"thumbsup_tone3":{"category":"people","moji":"👍🏽","description":"thumbs up sign tone 3","unicodeVersion":"8.0","digest":"b3881060569e56e1dd75ca7960feab0e58ae51f440458781948d65d461116b4e"},"thumbsup_tone4":{"category":"people","moji":"👍🏾","description":"thumbs up sign tone 4","unicodeVersion":"8.0","digest":"86fbe2c95414bce5e38fb5c33da31305d7942fca2c9c79168dcffdbd895e9ad6"},"thumbsup_tone5":{"category":"people","moji":"👍🏿","description":"thumbs up sign tone 5","unicodeVersion":"8.0","digest":"49fa63ff725c746a18649df16c8fab69bad88bbb564884df79d1d15f553b7343"},"thunder_cloud_rain":{"category":"nature","moji":"⛈","description":"thunder cloud and rain","unicodeVersion":"5.2","digest":"dacc20b4f6b68e5834aa1b8391afa5e83b5e6eb28e2d2174d3a68186a770506d"},"ticket":{"category":"activity","moji":"🎫","description":"ticket","unicodeVersion":"6.0","digest":"b4326fe7761940216e6c76ee2928110a6b37bf913da9d694e96557e7c7c10420"},"tickets":{"category":"activity","moji":"🎟","description":"admission tickets","unicodeVersion":"7.0","digest":"fb73358c3697c04fcfde6a1e705b1c3b47635b93b9cadfe31d5657566c7d190a"},"tiger":{"category":"nature","moji":"🐯","description":"tiger face","unicodeVersion":"6.0","digest":"e139531e6c930bc46242dc0ed274661229de026b5419d8ea8f99fdb0f8a719ab"},"tiger2":{"category":"nature","moji":"🐅","description":"tiger","unicodeVersion":"6.0","digest":"f930cc8714198310d9b0edca6baff243ac5a3320f75fadb56fa5acc6fe34ff24"},"timer":{"category":"objects","moji":"⏲","description":"timer clock","unicodeVersion":"6.0","digest":"69b33f219523d89d81cbbc070ad7e528711e4b34e124a50acb12a0280a34d0b0"},"tired_face":{"category":"people","moji":"😫","description":"tired face","unicodeVersion":"6.0","digest":"775739bc9324517e614878ca0960d793df97775feeb62b14dbfb311a42a21802"},"tm":{"category":"symbols","moji":"™","description":"trade mark sign","unicodeVersion":"1.1","digest":"7d9fafdb72d91860478fc185719f289f359eab2c368a132cb936a269e2ab6a24"},"toilet":{"category":"objects","moji":"🚽","description":"toilet","unicodeVersion":"6.0","digest":"0d1b0dd0078f51104e8632a0726e1b3f075561a1ffa8a2546602de15798415d0"},"tokyo_tower":{"category":"travel","moji":"🗼","description":"tokyo tower","unicodeVersion":"6.0","digest":"73eaf6fd59d16396673afef620c6d928857d5cf616e95a40eaf2861686e0956a"},"tomato":{"category":"food","moji":"🍅","description":"tomato","unicodeVersion":"6.0","digest":"d092d8ad381d542e59b6a82b4f1ef0d10fc1ed48460952375c6c5c6258cea111"},"tone1":{"category":"modifier","moji":"🏻","description":"emoji modifier Fitzpatrick type-1-2","unicodeVersion":"8.0","digest":"5c62003a098b774c068be45d658db3c0dd38483c0871f7c8ae293bc1222c4f0c"},"tone2":{"category":"modifier","moji":"🏼","description":"emoji modifier Fitzpatrick type-3","unicodeVersion":"8.0","digest":"3c636ecbc4e58c7a360f2338daaf44e7da598fd07e0ba1514bb5c0f83fc8819f"},"tone3":{"category":"modifier","moji":"🏽","description":"emoji modifier Fitzpatrick type-4","unicodeVersion":"8.0","digest":"398a1e5441b64c9c2d033bbc01d7a8d90b4db30ea9f30e28f0a9120c72a48df8"},"tone4":{"category":"modifier","moji":"🏾","description":"emoji modifier Fitzpatrick type-5","unicodeVersion":"8.0","digest":"ff4a12195aeb7494c785b81266efad8cd60c8022c407a0fc032a02e8b83216b3"},"tone5":{"category":"modifier","moji":"🏿","description":"emoji modifier Fitzpatrick type-6","unicodeVersion":"8.0","digest":"9e9f0125b5d57011b7456c84719e6be6cf71d06c1b198081d0937c0979164a81"},"tongue":{"category":"people","moji":"👅","description":"tongue","unicodeVersion":"6.0","digest":"286e9d2583c371431d6fc979dd4ab48981676da26baada51a846657a3654c19b"},"tools":{"category":"objects","moji":"🛠","description":"hammer and wrench","unicodeVersion":"7.0","digest":"bf08d60dedc06de73d04dab05703bb8ad81989c72b5035d1a07821e51096f158"},"top":{"category":"symbols","moji":"🔝","description":"top with upwards arrow above","unicodeVersion":"6.0","digest":"c9a9f25b17db014e76b6be54aa07ef89bb18f8adb41b3199d180a559ff1d9ea5"},"tophat":{"category":"people","moji":"🎩","description":"top hat","unicodeVersion":"6.0","digest":"43a45dfb5d6b57a63a0491f4e3ec780774c0301b53ed39a303a0bd803d16ed71"},"track_next":{"category":"symbols","moji":"⏭","description":"black right-pointing double triangle with vertical bar","unicodeVersion":"6.0","digest":"88592ef6c720a32aeb752322fb4c794bf5110a72408e21e898630452115c731c"},"track_previous":{"category":"symbols","moji":"⏮","description":"black left-pointing double triangle with vertical bar","unicodeVersion":"6.0","digest":"98c1b3d643768d94857fb762f6d26cfb87282b449a67792242e8b7068643ac87"},"trackball":{"category":"objects","moji":"🖲","description":"trackball","unicodeVersion":"7.0","digest":"32a819a3129429f797ad434d0c40e263dc236808e34878c599ed2304b43702f5"},"tractor":{"category":"travel","moji":"🚜","description":"tractor","unicodeVersion":"6.0","digest":"5e4686290f1a4c9953ae208340b7d276f25b3b2197a43e52469aeb6450e93997"},"traffic_light":{"category":"travel","moji":"🚥","description":"horizontal traffic light","unicodeVersion":"6.0","digest":"d96aacade33d1ad3e0414f8a920513010f36eb7e5889774251c1d91148917ead"},"train":{"category":"travel","moji":"🚋","description":"Tram Car","unicodeVersion":"6.0","digest":"7423d17e131df7aadaa350b5d39dcbce3b28de331ff8b6703a3b2d0093963f4b"},"train2":{"category":"travel","moji":"🚆","description":"train","unicodeVersion":"6.0","digest":"06e65d549e771632f3c64287a38ba67236f9800ccb6a23c3b592bc010e24e122"},"tram":{"category":"travel","moji":"🚊","description":"tram","unicodeVersion":"6.0","digest":"21a7699f1a94f06dcb4d1e896448b98a4205f8efe902a8ac169a5005d11ab100"},"triangular_flag_on_post":{"category":"objects","moji":"🚩","description":"triangular flag on post","unicodeVersion":"6.0","digest":"1f5ce3828a42f5b1717bac1521d0502cf7081ad9f15e8ed292c1a65f0d1386da"},"triangular_ruler":{"category":"objects","moji":"📐","description":"triangular ruler","unicodeVersion":"6.0","digest":"a0367dcf663ec934f1fc7c88bfaccc02b229a896f60930a66bb02241c933e501"},"trident":{"category":"symbols","moji":"🔱","description":"trident emblem","unicodeVersion":"6.0","digest":"ee45920845d3b35c2e45b934cf30ce97bfe2f24c5d72ef1ac6e0842e52b50fc1"},"triumph":{"category":"people","moji":"😤","description":"face with look of triumph","unicodeVersion":"6.0","digest":"4aa44b8e1682c1269624a359f4b0bf613553683b883d947561ab169d7f85da0f"},"trolleybus":{"category":"travel","moji":"🚎","description":"trolleybus","unicodeVersion":"6.0","digest":"f610b4fd1123f06778a8e3bb8f738d5b0079aeb0b0926b6a63268c0dd0ee03ed"},"trophy":{"category":"activity","moji":"🏆","description":"trophy","unicodeVersion":"6.0","digest":"50cfbedac18bf0fa5dec727643e15ec47f64068944b536e97518ee3be4f08006"},"tropical_drink":{"category":"food","moji":"🍹","description":"tropical drink","unicodeVersion":"6.0","digest":"54144fce60d650f426b1edf09e47c70b2762222398c1fe40231881f074603a69"},"tropical_fish":{"category":"nature","moji":"🐠","description":"tropical fish","unicodeVersion":"6.0","digest":"fd92100aaa9328da35e6090388824921b9726b474d1432a926d2cf9c45ad6528"},"truck":{"category":"travel","moji":"🚚","description":"delivery truck","unicodeVersion":"6.0","digest":"0d1571e58e900abc453df0ff683fe7acb5906ecbdd52ab35b7101074359faf18"},"trumpet":{"category":"activity","moji":"🎺","description":"trumpet","unicodeVersion":"6.0","digest":"cea3614c309f5573f328f4603120dbe930016a35f0dfa400b0d968fe9fff2d55"},"tulip":{"category":"nature","moji":"🌷","description":"tulip","unicodeVersion":"6.0","digest":"e744e8dbbdc6b126bd5b15aad56b524191de5a604189f4ab6d96730dfef4d086"},"tumbler_glass":{"category":"food","moji":"🥃","description":"tumbler glass","unicodeVersion":"9.0","digest":"7a38658274b9ff28836725a1dbfad49b8fa3af5ec8385e629db6bfdc7d93907a"},"turkey":{"category":"nature","moji":"🦃","description":"turkey","unicodeVersion":"8.0","digest":"bf5daef15716b66636a5fdb6d059420521443c0603e2d56bd7c99c791a7285f4"},"turtle":{"category":"nature","moji":"🐢","description":"turtle","unicodeVersion":"6.0","digest":"588c35fb42c9502a908e9805517d4cc8c4ba4e74c9beed4035779fea1efe14f8"},"tv":{"category":"objects","moji":"📺","description":"television","unicodeVersion":"6.0","digest":"1279f3f3955a58dbbf74e248fc914b0bdba9c4c6b6a5176e9d12bf2750ecfeb4"},"twisted_rightwards_arrows":{"category":"symbols","moji":"🔀","description":"twisted rightwards arrows","unicodeVersion":"6.0","digest":"fed07eebc2cf0d977ca0826bbd80defafbbcf118508444148f47b58949ebe27c"},"two":{"category":"symbols","moji":"2️⃣","description":"keycap digit two","unicodeVersion":"3.0","digest":"b346f51f6523b02ebcbd753256804e2f9cc1574c96aa634362bf9401dac2c661"},"two_hearts":{"category":"symbols","moji":"💕","description":"two hearts","unicodeVersion":"6.0","digest":"6ded120a59aed790b441ec8fbbdea6f5cbfb4fa48e9e4b224cc29c9fde2d2e4c"},"two_men_holding_hands":{"category":"people","moji":"👬","description":"two men holding hands","unicodeVersion":"6.0","digest":"bfcf9e20a67d00262cdf6e85f1acd545dda91f2e370d68bfd41ce02f232a2987"},"two_women_holding_hands":{"category":"people","moji":"👭","description":"two women holding hands","unicodeVersion":"6.0","digest":"9d9d2b37a7f8e16fde1468dd8b5645003ea81ae4bf8bcf68471e2381845dd0dd"},"u5272":{"category":"symbols","moji":"🈹","description":"squared cjk unified ideograph-5272","unicodeVersion":"6.0","digest":"01e6cb8f74ea3c19fdade59c2d13d158b90dc6b4b293421b2014b7478bf20870"},"u5408":{"category":"symbols","moji":"🈴","description":"squared cjk unified ideograph-5408","unicodeVersion":"6.0","digest":"084cdbd5436670ea4dc22010e269c1ab7b0432897b8675301e69120374bcdd14"},"u55b6":{"category":"symbols","moji":"🈺","description":"squared cjk unified ideograph-55b6","unicodeVersion":"6.0","digest":"c1017023d20d4aae78d59342dd3bfc5282716ea0601d9a8c2476335cbf7a2e12"},"u6307":{"category":"symbols","moji":"🈯","description":"squared cjk unified ideograph-6307","unicodeVersion":"5.2","digest":"f459b092b974f459db1fb9cc13617a448b2e4f2b4dc46cc316d8c46af6e7d8bd"},"u6708":{"category":"symbols","moji":"🈷","description":"squared cjk unified ideograph-6708","unicodeVersion":"6.0","digest":"928815abf5b30f92efe5168de0c7e6cf8c17899a03e358ab42f42667e0a4a04c"},"u6709":{"category":"symbols","moji":"🈶","description":"squared cjk unified ideograph-6709","unicodeVersion":"6.0","digest":"f63a48ee06c892d24acec8b5634c021658d2ebde67a42d8faa86f27804a9f26d"},"u6e80":{"category":"symbols","moji":"🈵","description":"squared cjk unified ideograph-6e80","unicodeVersion":"6.0","digest":"489181d90a5e43068459530673a153e4af04fdad8514ec341ff7afbcfd366c3b"},"u7121":{"category":"symbols","moji":"🈚","description":"squared cjk unified ideograph-7121","unicodeVersion":"5.2","digest":"9c50fd2ba14221affd2dcd3746322c2137dd75458493f4d385b544eb5bd8d6cd"},"u7533":{"category":"symbols","moji":"🈸","description":"squared cjk unified ideograph-7533","unicodeVersion":"6.0","digest":"2b05819b380a2ea47cc5fde8fcce3d53922fd223d6f5bd83d696d44175b69f18"},"u7981":{"category":"symbols","moji":"🈲","description":"squared cjk unified ideograph-7981","unicodeVersion":"6.0","digest":"adbe12601b22972003ddebcb0bd1532b979aa9c78bfdc147511854b5014eabc0"},"u7a7a":{"category":"symbols","moji":"🈳","description":"squared cjk unified ideograph-7a7a","unicodeVersion":"6.0","digest":"b9ee0ec7bb0b86c3eb73d4dbbb91848c427bf356ae30a263b9b44bd9bd784482"},"umbrella":{"category":"nature","moji":"☔","description":"umbrella with rain drops","unicodeVersion":"4.0","digest":"0328a2f48b7df47905e2655460e524c0794ef12d3d7c32a049a10892d5662f77"},"umbrella2":{"category":"nature","moji":"☂","description":"umbrella","unicodeVersion":"1.1","digest":"2f6a58110dc590480a822a3ffa2b5bc86f295e0c994a4a632837d25d4cf9fc58"},"unamused":{"category":"people","moji":"😒","description":"unamused face","unicodeVersion":"6.0","digest":"0d597088e3e7880918d0166e5c69243b18fe64afa31685c39bfdbc71494aa132"},"underage":{"category":"symbols","moji":"🔞","description":"no one under eighteen symbol","unicodeVersion":"6.0","digest":"b6b194614ca714ac2b1c2c17b75fe5922c7fdadb3d1157ba89ab2a5d03494a67"},"unicorn":{"category":"nature","moji":"🦄","description":"unicorn face","unicodeVersion":"8.0","digest":"f71bb485a7c208e999dd45f2b36d7b7d517898c0627947926b05aa28603804ca"},"unlock":{"category":"objects","moji":"🔓","description":"open lock","unicodeVersion":"6.0","digest":"9554ef3a6a315938b873e77970d9b0212e61f13c6cc36e4f17f87acc930a9a53"},"up":{"category":"symbols","moji":"🆙","description":"squared up with exclamation mark","unicodeVersion":"6.0","digest":"ff2554ccf08c7208b38794c5fa3d9a93a46ff191a49401195d8f740846121906"},"upside_down":{"category":"people","moji":"🙃","description":"upside-down face","unicodeVersion":"8.0","digest":"5129121f0a28f5b334268c28565de26a5907559568deca11de6ec620b097dfe1"},"urn":{"category":"objects","moji":"⚱","description":"funeral urn","unicodeVersion":"4.1","digest":"9bebf589eed8dd361f6a03cd1b325078f2cd0e82270ef63a7dd1b6aee08cd1e6"},"v":{"category":"people","moji":"✌","description":"victory hand","unicodeVersion":"1.1","digest":"9825bf440df289a8edf8ede494e8c778dc63c95f967f4d7bbea3245cf4f558ec"},"v_tone1":{"category":"people","moji":"✌🏻","description":"victory hand tone 1","unicodeVersion":"8.0","digest":"76e358250d9ca519b60b8d7b6a32900700d784433dcc609e9442254a410f6e37"},"v_tone2":{"category":"people","moji":"✌🏼","description":"victory hand tone 2","unicodeVersion":"8.0","digest":"4081b674be8416136022523fa9f29ec70a0f7e3aa05ca13152606609f3fd003c"},"v_tone3":{"category":"people","moji":"✌🏽","description":"victory hand tone 3","unicodeVersion":"8.0","digest":"b6afb3a4c78384280610b953592d378241c75597a82aa6d16c86a993f8d8f3b0"},"v_tone4":{"category":"people","moji":"✌🏾","description":"victory hand tone 4","unicodeVersion":"8.0","digest":"7ddc3cdd0138da2c8d7f6d8257ffdb8801496043e8a2395f93b0663447ac7fce"},"v_tone5":{"category":"people","moji":"✌🏿","description":"victory hand tone 5","unicodeVersion":"8.0","digest":"a85dc5c589f0d1cf32f8bfa5c82e5c11c40b35439636914686a2f06f7359f539"},"vertical_traffic_light":{"category":"travel","moji":"🚦","description":"vertical traffic light","unicodeVersion":"6.0","digest":"8cfd49a8f96b15a8313ef855f2e234ea3fa58332e68896dea34760740de9f020"},"vhs":{"category":"objects","moji":"📼","description":"videocassette","unicodeVersion":"6.0","digest":"3fb1acaf25805cf86f8d40ee2c17cf25da587b7ca93b931167ab43fce041eee8"},"vibration_mode":{"category":"symbols","moji":"📳","description":"vibration mode","unicodeVersion":"6.0","digest":"c9a8899222f46fe51dd8cee3e59f77c48268f0b7cfae2bcb34a791213acb1755"},"video_camera":{"category":"objects","moji":"📹","description":"video camera","unicodeVersion":"6.0","digest":"62e56f26c286a7964ef1021f0f23fcb4b38cdcfb5b5af569b472340c412c619a"},"video_game":{"category":"activity","moji":"🎮","description":"video game","unicodeVersion":"6.0","digest":"2787e302aa9e6fd7e9dc382c9bc7f5fbf244ef4940e08a4f9e80d33324f3032e"},"violin":{"category":"activity","moji":"🎻","description":"violin","unicodeVersion":"6.0","digest":"1e69d531ce2b5d5bf1dd9470187dbbe76f479d14428834b6a9e2bf5296dc0ec9"},"virgo":{"category":"symbols","moji":"♍","description":"virgo","unicodeVersion":"1.1","digest":"0f75e9c228bc467fd0cec0f93f0e087c943bc5fb1d945fb0d4de53d07718388e"},"volcano":{"category":"travel","moji":"🌋","description":"volcano","unicodeVersion":"6.0","digest":"41c92ef88ca533df342a0ebe59d2b676873bfa944c3988495b8a96060a9b8e16"},"volleyball":{"category":"activity","moji":"🏐","description":"volleyball","unicodeVersion":"8.0","digest":"774a83357f7aee890b4d4383236f0a90946dbd7c86aaabadc5753dcc9b4c9d69"},"vs":{"category":"symbols","moji":"🆚","description":"squared vs","unicodeVersion":"6.0","digest":"ac943e4c737459c2e1adbac8b71d3fdaebb704dbaf5713012e7a77beb09db1ef"},"vulcan":{"category":"people","moji":"🖖","description":"raised hand with part between middle and ring fingers","unicodeVersion":"7.0","digest":"b4d409a0b019e7b06333cefd15ea46cb54aef5132d86e8ba361c1c3b911fe265"},"vulcan_tone1":{"category":"people","moji":"🖖🏻","description":"raised hand with part between middle and ring fingers tone 1","unicodeVersion":"8.0","digest":"cc6072c85031b5081995f98a57f09ab177168318f69a51f3acc63251760499a4"},"vulcan_tone2":{"category":"people","moji":"🖖🏼","description":"raised hand with part between middle and ring fingers tone 2","unicodeVersion":"8.0","digest":"858bd5a1ac91dc4d7735f57ba4dd69d39138aa6dac1c80cfc05de30a59a5bc33"},"vulcan_tone3":{"category":"people","moji":"🖖🏽","description":"raised hand with part between middle and ring fingers tone 3","unicodeVersion":"8.0","digest":"2f74b6f3eab2a75063591b66f1c7350af0d23153e1427af91de20c48a5f4a54a"},"vulcan_tone4":{"category":"people","moji":"🖖🏾","description":"raised hand with part between middle and ring fingers tone 4","unicodeVersion":"8.0","digest":"87cf8b87d3610f742857a9704b658462df32b4924d8f1ddba26f761e738c4e11"},"vulcan_tone5":{"category":"people","moji":"🖖🏿","description":"raised hand with part between middle and ring fingers tone 5","unicodeVersion":"8.0","digest":"11e9ff62f2385edeb477dbf66c63734536531def5771daf80b66a3425ac71493"},"walking":{"category":"people","moji":"🚶","description":"pedestrian","unicodeVersion":"6.0","digest":"ae77471fe1e8a734d11711cdb589f64347c35d6ee2fc10f6db16ac550c0557fa"},"walking_tone1":{"category":"people","moji":"🚶🏻","description":"pedestrian tone 1","unicodeVersion":"8.0","digest":"3de871c234e1340ccf95338df7babd94d175cfcb17a57b5a74d950e0a31f03b1"},"walking_tone2":{"category":"people","moji":"🚶🏼","description":"pedestrian tone 2","unicodeVersion":"8.0","digest":"620eb7bfb753a331a5822b02bdaf08d8dde7b573efd210287a3d3dfdd84a40b9"},"walking_tone3":{"category":"people","moji":"🚶🏽","description":"pedestrian tone 3","unicodeVersion":"8.0","digest":"ff39545acc2256006128f8c186433c28052b8c9aaec46fe06f25cff02c71f6b8"},"walking_tone4":{"category":"people","moji":"🚶🏾","description":"pedestrian tone 4","unicodeVersion":"8.0","digest":"a9499d142392977a9b9e54fb957952359e9bdffce7ec2f1e8320523d185fb066"},"walking_tone5":{"category":"people","moji":"🚶🏿","description":"pedestrian tone 5","unicodeVersion":"8.0","digest":"b47a4c48ce40298f842f454fc1abccae70f69725d73ee2c80e4018f4c4065d7d"},"waning_crescent_moon":{"category":"nature","moji":"🌘","description":"waning crescent moon symbol","unicodeVersion":"6.0","digest":"2ec7896eefcf821e0ea013556a17af59e997503662c07f080d0a84ab13ef4cf1"},"waning_gibbous_moon":{"category":"nature","moji":"🌖","description":"waning gibbous moon symbol","unicodeVersion":"6.0","digest":"ce2f5aca8fccdacaaf174d10da4e493e853e4608cc4d159aa3081d108a8b58d5"},"warning":{"category":"symbols","moji":"⚠","description":"warning sign","unicodeVersion":"4.0","digest":"745f1d203958f42bf37ecb5909cd0819934e300308ba0ff20964c8c203092f90"},"wastebasket":{"category":"objects","moji":"🗑","description":"wastebasket","unicodeVersion":"7.0","digest":"221a1b6d9975051038d9d97e18a16556cdf4254a6bca4c29bf1c51f306c79f2a"},"watch":{"category":"objects","moji":"⌚","description":"watch","unicodeVersion":"1.1","digest":"acc0c96751404a789b3085f10425cf34f942185215df459515d2439cde3efc6b"},"water_buffalo":{"category":"nature","moji":"🐃","description":"water buffalo","unicodeVersion":"6.0","digest":"ba6a840d4f57f8f9f3e9f29b8a030faf02a3a3d912e3e31b067616b2ac48a3d1"},"water_polo":{"category":"activity","moji":"🤽","description":"water polo","unicodeVersion":"9.0","digest":"fc77e1d2a84a9f4cf0cf19c1ea10cf137cf0940b9103a523121eda87677ad148"},"water_polo_tone1":{"category":"activity","moji":"🤽🏻","description":"water polo tone 1","unicodeVersion":"9.0","digest":"3be28384edd29ada8109f07720d601a9d5866ed63e6234efe9ee1a194ed5d0c5"},"water_polo_tone2":{"category":"activity","moji":"🤽🏼","description":"water polo tone 2","unicodeVersion":"9.0","digest":"afcd3f28c6719f869ca79a6fd1ccade2ea976ade844fbc1081fc72865bcb652f"},"water_polo_tone3":{"category":"activity","moji":"🤽🏽","description":"water polo tone 3","unicodeVersion":"9.0","digest":"d19481c9b82d9413e99c2652e020fd763f2b54408dedaffec8dfe80973ded407"},"water_polo_tone4":{"category":"activity","moji":"🤽🏾","description":"water polo tone 4","unicodeVersion":"9.0","digest":"375972d882b627e8d525e632e58b30346fc3e01858d7d08d62a9d3bf8132bbc7"},"water_polo_tone5":{"category":"activity","moji":"🤽🏿","description":"water polo tone 5","unicodeVersion":"9.0","digest":"a8e1ced1c5382a8147a1d1801a133cada9a0e52e41de6272e56c3c1f426f6048"},"watermelon":{"category":"food","moji":"🍉","description":"watermelon","unicodeVersion":"6.0","digest":"42a3821d2e4dd595c93f5db7a5c70b7af486b8f0ddd3b9d26bc4e743a88e699a"},"wave":{"category":"people","moji":"👋","description":"waving hand sign","unicodeVersion":"6.0","digest":"cddbd764d471604446cbaca91f77f6c4119d1cfc2c856732ca0eaac4593cb736"},"wave_tone1":{"category":"people","moji":"👋🏻","description":"waving hand sign tone 1","unicodeVersion":"8.0","digest":"cf40797437ddf68ec0275f337e6aac4bed81e28da7636d56c9f817ddf8e2b30a"},"wave_tone2":{"category":"people","moji":"👋🏼","description":"waving hand sign tone 2","unicodeVersion":"8.0","digest":"12c8a3e82c03ee35a734c642be482ba2d9d5948dacf91ec1fda243316dd4a0d0"},"wave_tone3":{"category":"people","moji":"👋🏽","description":"waving hand sign tone 3","unicodeVersion":"8.0","digest":"ebcaef43e21b475f76de811d4f4d1a67d9393973b57b03876e02164345a2ba4a"},"wave_tone4":{"category":"people","moji":"👋🏾","description":"waving hand sign tone 4","unicodeVersion":"8.0","digest":"7df7b70cf76766836ba146c3d91b6104930c384450cf2688426e60c1c06a1fc8"},"wave_tone5":{"category":"people","moji":"👋🏿","description":"waving hand sign tone 5","unicodeVersion":"8.0","digest":"8dfdba6aeff5d7dfd807467d431a137547726b34d021f1a5a0b74e155d270ea7"},"wavy_dash":{"category":"symbols","moji":"〰","description":"wavy dash","unicodeVersion":"1.1","digest":"7b1968474f01d12fd09a1f2572282927138d9e9d6a3642de4bf68af80a8c3738"},"waxing_crescent_moon":{"category":"nature","moji":"🌒","description":"waxing crescent moon symbol","unicodeVersion":"6.0","digest":"852d7e55a19074d061fa3aa80d6b1e7e87a9280bdf44d94bbdbbe6d59178b1be"},"waxing_gibbous_moon":{"category":"nature","moji":"🌔","description":"waxing gibbous moon symbol","unicodeVersion":"6.0","digest":"a3a1c7cc72521a3f74929789a90e1c35d81ac86e21225c9f844d718d8940e3b3"},"wc":{"category":"symbols","moji":"🚾","description":"water closet","unicodeVersion":"6.0","digest":"4b95d54e0b53e4b705277917653503b32d6a143c2eaf6c547bc8e01c2dc23659"},"weary":{"category":"people","moji":"😩","description":"weary face","unicodeVersion":"6.0","digest":"3528f85540996cd5b562efe5421c495fc1bb414dc797bc20062783ae1b730847"},"wedding":{"category":"travel","moji":"💒","description":"wedding","unicodeVersion":"6.0","digest":"980f3522cc4c19c3096e668032ea2cd19e7900cdc4b73bbb1c9b4c4d28dc78af"},"whale":{"category":"nature","moji":"🐳","description":"spouting whale","unicodeVersion":"6.0","digest":"6368fe4bc4a7f68aa2bd5386686a5f1b159feacbec16d59515f2b6e5d01adfbd"},"whale2":{"category":"nature","moji":"🐋","description":"whale","unicodeVersion":"6.0","digest":"ccd3edf88167965f2abc18631ffb80e2532f728da35bc0c11144376685da18e8"},"wheel_of_dharma":{"category":"symbols","moji":"☸","description":"wheel of dharma","unicodeVersion":"1.1","digest":"4a0a13fcd507b9621686c8090bf340aa8770c064e0e3eb576fbae1229000d6da"},"wheelchair":{"category":"symbols","moji":"♿","description":"wheelchair symbol","unicodeVersion":"4.1","digest":"f5250f2b4b5b4ffe6a6f77d30865c3f5d7173fc91aee547869589b2a96da91c8"},"white_check_mark":{"category":"symbols","moji":"✅","description":"white heavy check mark","unicodeVersion":"6.0","digest":"45eb17bde6e503f22c8579d6e4d507ad6557a15f9eaad14aa716ec9ba1540876"},"white_circle":{"category":"symbols","moji":"⚪","description":"medium white circle","unicodeVersion":"4.1","digest":"2e7323fa4d1e3929e529d49210a0b82a043eae4f7c95128ec86b98c46fdb0e7c"},"white_flower":{"category":"symbols","moji":"💮","description":"white flower","unicodeVersion":"6.0","digest":"ace093b310eeefdecf4a4bdaf4fbcbb568457b0191ac80778a466ac5f3f4025a"},"white_large_square":{"category":"symbols","moji":"⬜","description":"white large square","unicodeVersion":"5.1","digest":"0db6957ee9ff7325b534b730fc05345a63d4ed9060f0f816807d0dcf004baa3e"},"white_medium_small_square":{"category":"symbols","moji":"◽","description":"white medium small square","unicodeVersion":"3.2","digest":"d79689981a7b38211c60a025a81e44fd39ac6ea4062e227cae3aab8f51572cd4"},"white_medium_square":{"category":"symbols","moji":"◻","description":"white medium square","unicodeVersion":"3.2","digest":"6c4ce26d3f69667219f29ea18b04f3e79373024426275f25936e09a683e9a4fc"},"white_small_square":{"category":"symbols","moji":"▫","description":"white small square","unicodeVersion":"1.1","digest":"ae0d35a6bbba4592b89b2f0f1f2d183efb2f93cf2a2136c0c195aab72f0bb1c8"},"white_square_button":{"category":"symbols","moji":"🔳","description":"white square button","unicodeVersion":"6.0","digest":"797f3d9e44e88e940ffc118e52d0f709eec2ef14b13bdf873ad4b0c96cc0b042"},"white_sun_cloud":{"category":"nature","moji":"🌥","description":"white sun behind cloud","unicodeVersion":"7.0","digest":"0e714038bb0a5b091dd4ad8829c5c72dece493e09da6d56ceadcd0b68e1c0fd5"},"white_sun_rain_cloud":{"category":"nature","moji":"🌦","description":"white sun behind cloud with rain","unicodeVersion":"7.0","digest":"82fb2a91d43c7c511afed216e12f98e32aef4475e7f3c7ccc0f39732d2f7d5e5"},"white_sun_small_cloud":{"category":"nature","moji":"🌤","description":"white sun with small cloud","unicodeVersion":"7.0","digest":"0a6164cdadf2413555b7ef47b95f823f5a010f36d2dacfb1a38335a0f59e9601"},"wilted_rose":{"category":"nature","moji":"🥀","description":"wilted flower","unicodeVersion":"9.0","digest":"2c9e01ab9a61d057c71478b09ba7d82ae08f4a5a1c2212b7ad562b74f616677f"},"wind_blowing_face":{"category":"nature","moji":"🌬","description":"wind blowing face","unicodeVersion":"7.0","digest":"e4f63149cbc8829118571f6a93487b96d26665fc15d17d578cca4e5c752cd54f"},"wind_chime":{"category":"objects","moji":"🎐","description":"wind chime","unicodeVersion":"6.0","digest":"1b1b212fbd74a9edc62aee7ffab9bcf91d3a9f69bffb2be4b7fd527914c14ced"},"wine_glass":{"category":"food","moji":"🍷","description":"wine glass","unicodeVersion":"6.0","digest":"d99107d6809386bc5e219aa58ee4930d27b7c3a6d2b10deb9f523df369f766d1"},"wink":{"category":"people","moji":"😉","description":"winking face","unicodeVersion":"6.0","digest":"56e29994a47335a901d0c98fa141d26faae8f647a860517bd3615fa980921885"},"wolf":{"category":"nature","moji":"🐺","description":"wolf face","unicodeVersion":"6.0","digest":"4a983f5ec8ec0872fcde7890e17605b1229064e5e194b6fca1c4259068d1caed"},"woman":{"category":"people","moji":"👩","description":"woman","unicodeVersion":"6.0","digest":"a06a22a48eeb3aeb885321358fe234e97797ed33be17f52d232ce2830cfbcd97"},"woman_tone1":{"category":"people","moji":"👩🏻","description":"woman tone 1","unicodeVersion":"8.0","digest":"c2e4b135c1dac6a0b002569a6ccd9d098f6cb18481c68b5d9115e11241a0978d"},"woman_tone2":{"category":"people","moji":"👩🏼","description":"woman tone 2","unicodeVersion":"8.0","digest":"4848e650051214a53c4cd9f6d3d94158f77f65ecb34f891789de34ee0a713006"},"woman_tone3":{"category":"people","moji":"👩🏽","description":"woman tone 3","unicodeVersion":"8.0","digest":"b6f751ad47da019cdfb9d6d78f9610adb92120abf204c30df79a9150b57dbdee"},"woman_tone4":{"category":"people","moji":"👩🏾","description":"woman tone 4","unicodeVersion":"8.0","digest":"fd27d3a669dc34313fbfe518df7dc2ded3ade5dde695f8d773afe87bf8a8b0d4"},"woman_tone5":{"category":"people","moji":"👩🏿","description":"woman tone 5","unicodeVersion":"8.0","digest":"9ae9b14dfff40fa60a565d89479727feeba4fd6ffea9acb353a81b14aba751d4"},"womans_clothes":{"category":"people","moji":"👚","description":"womans clothes","unicodeVersion":"6.0","digest":"d12a27810780fe5cd8118ed4587e0c4e70dbe9bcd014c6866fe6a8c9c7c55698"},"womans_hat":{"category":"people","moji":"👒","description":"womans hat","unicodeVersion":"6.0","digest":"52a0255b3483085bd125d39b74516ab6a81003964f44995c2fac821e7ff93086"},"womens":{"category":"symbols","moji":"🚺","description":"womens symbol","unicodeVersion":"6.0","digest":"7e38964006f8b28dfa2b3e9b2b16553bb50c18a63455f556b0bff35ee172137e"},"worried":{"category":"people","moji":"😟","description":"worried face","unicodeVersion":"6.1","digest":"5a073985e1344bc34201ef94a491f7f2b946f5828c9fdbc57eeb2dcd87ac3a6b"},"wrench":{"category":"objects","moji":"🔧","description":"wrench","unicodeVersion":"6.0","digest":"81aae53bc892035b905bf3ec5b442a8ecc95027c5fa9eb51b7c3e7d8fad3f3f4"},"wrestlers":{"category":"activity","moji":"🤼","description":"wrestlers","unicodeVersion":"9.0","digest":"9be983f3f9438f3ab8f6b643a958371d1e710c6d78e728f3465141811f05c2d5"},"wrestlers_tone1":{"category":"activity","moji":"🤼🏻","description":"wrestlers tone 1","unicodeVersion":"9.0","digest":"60461f83bfc93ce59dd027eab4782b7f206a7b142719fa72f301e047dc83a5d9"},"wrestlers_tone2":{"category":"activity","moji":"🤼🏼","description":"wrestlers tone 2","unicodeVersion":"9.0","digest":"67ad93c86e6c58d552c18e7a0105cc81fd9bb0474da51f788eba2e4c14b4a636"},"wrestlers_tone3":{"category":"activity","moji":"🤼🏽","description":"wrestlers tone 3","unicodeVersion":"9.0","digest":"6bfd06c4435cabf2def153912040e05bf8db424fa383148ddda6d0ce8a8a3349"},"wrestlers_tone4":{"category":"activity","moji":"🤼🏾","description":"wrestlers tone 4","unicodeVersion":"9.0","digest":"597312678834c4d288c238482879856d5eba4620deb1eaef495f428e2ba5f2a5"},"wrestlers_tone5":{"category":"activity","moji":"🤼🏿","description":"wrestlers tone 5","unicodeVersion":"9.0","digest":"d6aebdf1e44fd825b9a5b3716aefbc53f4b4dbb73cb2a628c0f2994ebfd34614"},"writing_hand":{"category":"people","moji":"✍","description":"writing hand","unicodeVersion":"1.1","digest":"110517ae4da5587e8b0662881658e27da4120bfacec54734fd6657831d4d782f"},"writing_hand_tone1":{"category":"people","moji":"✍🏻","description":"writing hand tone 1","unicodeVersion":"8.0","digest":"2c7e2108e1990490b681343c1b01b4183d4f18fbdef792f113b2f87595e0dad0"},"writing_hand_tone2":{"category":"people","moji":"✍🏼","description":"writing hand tone 2","unicodeVersion":"8.0","digest":"87ec8d44f472d301adbcbd50d8c852b609e46584057f59cc1527401db363c1bf"},"writing_hand_tone3":{"category":"people","moji":"✍🏽","description":"writing hand tone 3","unicodeVersion":"8.0","digest":"4a48ddef91f7264e8fa9cca223554db22b3a2e3153e94b88d146644ea6dd661e"},"writing_hand_tone4":{"category":"people","moji":"✍🏾","description":"writing hand tone 4","unicodeVersion":"8.0","digest":"e5254564a1f91e42ee59f359d8cd26f52abdc04dca8f3b37cb2f140cb7f71390"},"writing_hand_tone5":{"category":"people","moji":"✍🏿","description":"writing hand tone 5","unicodeVersion":"8.0","digest":"61299bf86d83d323ca3e6052c535ae66c6f7b3d9866a37db0464223b8bc28523"},"x":{"category":"symbols","moji":"❌","description":"cross mark","unicodeVersion":"6.0","digest":"3e5a7918e31ddefdf1ce73972365e2f0bfd2917d6a450c1a278c108349c9425d"},"yellow_heart":{"category":"symbols","moji":"💛","description":"yellow heart","unicodeVersion":"6.0","digest":"a1098f2f04c29754cc9974324508386787d4d803b57cf691d42de414cb2679d6"},"yen":{"category":"objects","moji":"💴","description":"banknote with yen sign","unicodeVersion":"6.0","digest":"944daaeb3f6369c807c0e63b106cee1360040f7800a70c0d942a992f25a55da7"},"yin_yang":{"category":"symbols","moji":"☯","description":"yin yang","unicodeVersion":"1.1","digest":"5ee8d13dacf41306a09237bfcff6abeef110331b40eb7d6e80600628c1327545"},"yum":{"category":"people","moji":"😋","description":"face savouring delicious food","unicodeVersion":"6.0","digest":"31a89088c21bd7a74a3a26d731a907d1bc49436300a9f9c55248703cf7ef44c7"},"zap":{"category":"nature","moji":"⚡","description":"high voltage sign","unicodeVersion":"4.0","digest":"9f8144ae6f866129aea41bbf694b0c858ef9352a139969e57cd8db73385f52c3"},"zero":{"category":"symbols","moji":"0️⃣","description":"keycap digit zero","unicodeVersion":"3.0","digest":"1b27b5c904defadbdd28ace67a6be5c277ff043297db7cd9f672bbf84e37fa1a"},"zipper_mouth":{"category":"people","moji":"🤐","description":"zipper-mouth face","unicodeVersion":"8.0","digest":"81bee5aa1202dfd5a4c7badb71ec0e44b8f75c2cbef94e6fd35c593d8770ae43"},"zzz":{"category":"people","moji":"💤","description":"sleeping symbol","unicodeVersion":"6.0","digest":"b3313d0c44a59fa9d4ce9f7eb4d07ff71dfc8bb01798154250f27cdcf3c693b5"}}

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/diff_with_note.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__syntax_highlight__ = __webpack_require__("./syntax_highlight.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__image_diff_helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__diff_file_header_vue__ = __webpack_require__("./notes/components/diff_file_header.vue");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DiffFileHeader: __WEBPACK_IMPORTED_MODULE_3__diff_file_header_vue__["a" /* default */]
  },
  props: {
    discussion: {
      type: Object,
      required: true
    }
  },
  computed: {
    isImageDiff: function isImageDiff() {
      return !this.diffFile.text;
    },
    diffFileClass: function diffFileClass() {
      var text = this.diffFile.text;

      return text ? 'text-file' : 'js-image-file';
    },
    diffRows: function diffRows() {
      return $(this.discussion.truncatedDiffLines);
    },
    diffFile: function diffFile() {
      return Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__["e" /* convertObjectPropsToCamelCase */])(this.discussion.diffFile);
    },
    imageDiffHtml: function imageDiffHtml() {
      return this.discussion.imageDiffHtml;
    }
  },
  mounted: function mounted() {
    if (this.isImageDiff) {
      var canCreateNote = false;
      var renderCommentBadge = true;
      __WEBPACK_IMPORTED_MODULE_1__image_diff_helpers_index__["a" /* default */].initImageDiff(this.$refs.fileHolder, canCreateNote, renderCommentBadge);
    } else {
      var fileHolder = $(this.$refs.fileHolder);
      this.$nextTick(function () {
        Object(__WEBPACK_IMPORTED_MODULE_0__syntax_highlight__["a" /* default */])(fileHolder);
      });
    }
  },

  methods: {
    rowTag: function rowTag(html) {
      return html.outerHTML ? 'tr' : 'template';
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/note_body.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__note_edited_text_vue__ = __webpack_require__("./notes/components/note_edited_text.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__note_awards_list_vue__ = __webpack_require__("./notes/components/note_awards_list.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__note_attachment_vue__ = __webpack_require__("./notes/components/note_attachment.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__note_form_vue__ = __webpack_require__("./notes/components/note_form.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__task_list__ = __webpack_require__("./task_list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_autosave__ = __webpack_require__("./notes/mixins/autosave.js");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    noteEditedText: __WEBPACK_IMPORTED_MODULE_0__note_edited_text_vue__["a" /* default */],
    noteAwardsList: __WEBPACK_IMPORTED_MODULE_1__note_awards_list_vue__["a" /* default */],
    noteAttachment: __WEBPACK_IMPORTED_MODULE_2__note_attachment_vue__["a" /* default */],
    noteForm: __WEBPACK_IMPORTED_MODULE_3__note_form_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_autosave__["a" /* default */]],
  props: {
    note: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    isEditing: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    noteBody: function noteBody() {
      return this.note.note;
    }
  },
  mounted: function mounted() {
    this.renderGFM();
    this.initTaskList();

    if (this.isEditing) {
      this.initAutoSave(this.note.noteable_type);
    }
  },
  updated: function updated() {
    this.initTaskList();
    this.renderGFM();

    if (this.isEditing) {
      if (!this.autosave) {
        this.initAutoSave(this.note.noteable_type);
      } else {
        this.setAutoSave();
      }
    }
  },

  methods: {
    renderGFM: function renderGFM() {
      $(this.$refs['note-body']).renderGFM();
    },
    initTaskList: function initTaskList() {
      if (this.canEdit) {
        this.taskList = new __WEBPACK_IMPORTED_MODULE_4__task_list__["a" /* default */]({
          dataType: 'note',
          fieldName: 'note',
          selector: '.notes'
        });
      }
    },
    handleFormUpdate: function handleFormUpdate(note, parentElement, callback) {
      this.$emit('handleFormUpdate', note, parentElement, callback);
    },
    formCancelHandler: function formCancelHandler(shouldConfirm, isDirty) {
      this.$emit('cancelFormEdition', shouldConfirm, isDirty);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/noteable_note.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("../../../node_modules/vuex/dist/vuex.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_user_avatar_user_avatar_link_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_link.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__note_header_vue__ = __webpack_require__("./notes/components/note_header.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__note_actions_vue__ = __webpack_require__("./notes/components/note_actions.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__note_body_vue__ = __webpack_require__("./notes/components/note_body.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__event_hub__ = __webpack_require__("./notes/event_hub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_noteable__ = __webpack_require__("./notes/mixins/noteable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_resolvable__ = __webpack_require__("./notes/mixins/resolvable.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    userAvatarLink: __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_user_avatar_user_avatar_link_vue__["a" /* default */],
    noteHeader: __WEBPACK_IMPORTED_MODULE_4__note_header_vue__["a" /* default */],
    noteActions: __WEBPACK_IMPORTED_MODULE_5__note_actions_vue__["a" /* default */],
    noteBody: __WEBPACK_IMPORTED_MODULE_6__note_body_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_noteable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_resolvable__["a" /* default */]],
  props: {
    note: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isEditing: false,
      isDeleting: false,
      isRequesting: false,
      isResolving: false
    };
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['targetNoteHash', 'getUserData']), {
    author: function author() {
      return this.note.author;
    },
    classNameBindings: function classNameBindings() {
      return {
        'is-editing': this.isEditing && !this.isRequesting,
        'is-requesting being-posted': this.isRequesting,
        'disabled-content': this.isDeleting,
        target: this.targetNoteHash === this.noteAnchorId
      };
    },
    canReportAsAbuse: function canReportAsAbuse() {
      return this.note.report_abuse_path && this.author.id !== this.getUserData.id;
    },
    noteAnchorId: function noteAnchorId() {
      return 'note_' + this.note.id;
    }
  }),

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_7__event_hub__["a" /* default */].$on('enterEditMode', function (_ref) {
      var noteId = _ref.noteId;

      if (noteId === _this.note.id) {
        _this.isEditing = true;
        _this.scrollToNoteIfNeeded($(_this.$el));
      }
    });
  },


  methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['deleteNote', 'updateNote', 'toggleResolveNote', 'scrollToNoteIfNeeded']), {
    editHandler: function editHandler() {
      this.isEditing = true;
    },
    deleteHandler: function deleteHandler() {
      var _this2 = this;

      // eslint-disable-next-line no-alert
      if (confirm('Are you sure you want to delete this comment?')) {
        this.isDeleting = true;

        this.deleteNote(this.note).then(function () {
          _this2.isDeleting = false;
        }).catch(function () {
          Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])('Something went wrong while deleting your note. Please try again.');
          _this2.isDeleting = false;
        });
      }
    },
    formUpdateHandler: function formUpdateHandler(noteText, parentElement, callback) {
      var _this3 = this;

      var data = {
        endpoint: this.note.path,
        note: {
          target_type: this.noteableType,
          target_id: this.note.noteable_id,
          note: { note: noteText }
        }
      };
      this.isRequesting = true;
      this.oldContent = this.note.note_html;
      this.note.note_html = Object(__WEBPACK_IMPORTED_MODULE_1_underscore__["escape"])(noteText);

      this.updateNote(data).then(function () {
        _this3.isEditing = false;
        _this3.isRequesting = false;
        _this3.oldContent = null;
        $(_this3.$refs.noteBody.$el).renderGFM();
        _this3.$refs.noteBody.resetAutoSave();
        callback();
      }).catch(function () {
        _this3.isRequesting = false;
        _this3.isEditing = true;
        _this3.$nextTick(function () {
          var msg = 'Something went wrong while editing your comment. Please try again.';
          Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])(msg, 'alert', _this3.$el);
          _this3.recoverNoteContent(noteText);
          callback();
        });
      });
    },
    formCancelHandler: function formCancelHandler(shouldConfirm, isDirty) {
      if (shouldConfirm && isDirty) {
        // eslint-disable-next-line no-alert
        if (!confirm('Are you sure you want to cancel editing this comment?')) return;
      }
      this.$refs.noteBody.resetAutoSave();
      if (this.oldContent) {
        this.note.note_html = this.oldContent;
        this.oldContent = null;
      }
      this.isEditing = false;
    },
    recoverNoteContent: function recoverNoteContent(noteText) {
      // we need to do this to prevent noteForm inconsistent content warning
      // this is something we intentionally do so we need to recover the content
      this.note.note = noteText;
      this.$refs.noteBody.$refs.noteForm.note.note = noteText;
    }
  })
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/notes_app.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("../../../node_modules/vuex/dist/vuex.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores___ = __webpack_require__("./notes/stores/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("./notes/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__noteable_note_vue__ = __webpack_require__("./notes/components/noteable_note.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__noteable_discussion_vue__ = __webpack_require__("./notes/components/noteable_discussion.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vue_shared_components_notes_system_note_vue__ = __webpack_require__("./vue_shared/components/notes/system_note.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__comment_form_vue__ = __webpack_require__("./notes/components/comment_form.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vue_shared_components_notes_placeholder_note_vue__ = __webpack_require__("./vue_shared/components/notes/placeholder_note.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vue_shared_components_notes_placeholder_system_note_vue__ = __webpack_require__("./vue_shared/components/notes/placeholder_system_note.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vue_shared_components_loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vue_shared_components_notes_skeleton_note_vue__ = __webpack_require__("./vue_shared/components/notes/skeleton_note.vue");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotesApp',
  components: {
    noteableNote: __WEBPACK_IMPORTED_MODULE_5__noteable_note_vue__["a" /* default */],
    noteableDiscussion: __WEBPACK_IMPORTED_MODULE_6__noteable_discussion_vue__["a" /* default */],
    systemNote: __WEBPACK_IMPORTED_MODULE_7__vue_shared_components_notes_system_note_vue__["a" /* default */],
    commentForm: __WEBPACK_IMPORTED_MODULE_8__comment_form_vue__["a" /* default */],
    loadingIcon: __WEBPACK_IMPORTED_MODULE_11__vue_shared_components_loading_icon_vue__["a" /* default */],
    placeholderNote: __WEBPACK_IMPORTED_MODULE_9__vue_shared_components_notes_placeholder_note_vue__["a" /* default */],
    placeholderSystemNote: __WEBPACK_IMPORTED_MODULE_10__vue_shared_components_notes_placeholder_system_note_vue__["a" /* default */]
  },
  props: {
    noteableData: {
      type: Object,
      required: true
    },
    notesData: {
      type: Object,
      required: true
    },
    userData: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  store: __WEBPACK_IMPORTED_MODULE_3__stores___["a" /* default */],
  data: function data() {
    return {
      isLoading: true
    };
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['notes', 'getNotesDataByProp', 'discussionCount']), {
    noteableType: function noteableType() {
      // FIXME -- @fatihacet Get this from JSON data.
      var ISSUE_NOTEABLE_TYPE = __WEBPACK_IMPORTED_MODULE_4__constants__["f" /* ISSUE_NOTEABLE_TYPE */],
          MERGE_REQUEST_NOTEABLE_TYPE = __WEBPACK_IMPORTED_MODULE_4__constants__["g" /* MERGE_REQUEST_NOTEABLE_TYPE */];


      return this.noteableData.merge_params ? MERGE_REQUEST_NOTEABLE_TYPE : ISSUE_NOTEABLE_TYPE;
    },
    allNotes: function allNotes() {
      if (this.isLoading) {
        var totalNotes = parseInt(this.notesData.totalNotes, 10) || 0;

        return new Array(totalNotes).fill({
          isSkeletonNote: true
        });
      }
      return this.notes;
    }
  }),
  created: function created() {
    this.setNotesData(this.notesData);
    this.setNoteableData(this.noteableData);
    this.setUserData(this.userData);
  },
  mounted: function mounted() {
    var _this = this;

    this.fetchNotes();

    var parentElement = this.$el.parentElement;

    if (parentElement && parentElement.classList.contains('js-vue-notes-event')) {
      parentElement.addEventListener('toggleAward', function (event) {
        var _event$detail = event.detail,
            awardName = _event$detail.awardName,
            noteId = _event$detail.noteId;

        _this.actionToggleAward({ awardName: awardName, noteId: noteId });
      });
    }
    document.addEventListener('refreshVueNotes', this.fetchNotes);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('refreshVueNotes', this.fetchNotes);
  },

  methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])({
    actionFetchNotes: 'fetchNotes',
    poll: 'poll',
    actionToggleAward: 'toggleAward',
    scrollToNoteIfNeeded: 'scrollToNoteIfNeeded',
    setNotesData: 'setNotesData',
    setNoteableData: 'setNoteableData',
    setUserData: 'setUserData',
    setLastFetchedAt: 'setLastFetchedAt',
    setTargetNoteHash: 'setTargetNoteHash'
  }), {
    getComponentName: function getComponentName(note) {
      if (note.isSkeletonNote) {
        return __WEBPACK_IMPORTED_MODULE_12__vue_shared_components_notes_skeleton_note_vue__["a" /* default */];
      }
      if (note.isPlaceholderNote) {
        if (note.placeholderType === __WEBPACK_IMPORTED_MODULE_4__constants__["l" /* SYSTEM_NOTE */]) {
          return __WEBPACK_IMPORTED_MODULE_10__vue_shared_components_notes_placeholder_system_note_vue__["a" /* default */];
        }
        return __WEBPACK_IMPORTED_MODULE_9__vue_shared_components_notes_placeholder_note_vue__["a" /* default */];
      } else if (note.individual_note) {
        return note.notes[0].system ? __WEBPACK_IMPORTED_MODULE_7__vue_shared_components_notes_system_note_vue__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_5__noteable_note_vue__["a" /* default */];
      }

      return __WEBPACK_IMPORTED_MODULE_6__noteable_discussion_vue__["a" /* default */];
    },
    getComponentData: function getComponentData(note) {
      return note.individual_note ? note.notes[0] : note;
    },
    fetchNotes: function fetchNotes() {
      var _this2 = this;

      return this.actionFetchNotes(this.getNotesDataByProp('discussionsPath')).then(function () {
        return _this2.initPolling();
      }).then(function () {
        _this2.isLoading = false;
      }).then(function () {
        return _this2.$nextTick();
      }).then(function () {
        return _this2.checkLocationHash();
      }).catch(function () {
        _this2.isLoading = false;
        Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])('Something went wrong while fetching comments. Please try again.');
      });
    },
    initPolling: function initPolling() {
      if (this.isPollingInitialized) {
        return;
      }

      this.setLastFetchedAt(this.getNotesDataByProp('lastFetchedAt'));

      this.poll();
      this.isPollingInitialized = true;
    },
    checkLocationHash: function checkLocationHash() {
      var hash = Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_url_utility__["a" /* getLocationHash */])();
      var element = document.getElementById(hash);

      if (hash && element) {
        this.setTargetNoteHash(hash);
        this.scrollToNoteIfNeeded($(element));
      }
    }
  })
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/stage.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_icon_vue__ = __webpack_require__("./vue_shared/components/icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");


/**
 * Renders each stage of the pipeline mini graph.
 *
 * Given the provided endpoint will make a request to
 * fetch the dropdown data when the stage is clicked.
 *
 * Request is made inside this component to make it reusable between:
 * 1. Pipelines main table
 * 2. Pipelines table in commit and Merge request views
 * 3. Merge request widget
 * 4. Commit widget
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    loadingIcon: __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue__["a" /* default */],
    icon: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_icon_vue__["a" /* default */]
  },

  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_3__vue_shared_directives_tooltip__["a" /* default */]
  },

  props: {
    stage: {
      type: Object,
      required: true
    },

    updateDropdown: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function data() {
    return {
      isLoading: false,
      dropdownContent: ''
    };
  },


  computed: {
    dropdownClass: function dropdownClass() {
      return this.dropdownContent.length > 0 ? 'js-builds-dropdown-container' : 'js-builds-dropdown-loading';
    },
    triggerButtonClass: function triggerButtonClass() {
      return 'ci-status-icon-' + this.stage.status.group;
    },
    borderlessIcon: function borderlessIcon() {
      return this.stage.status.icon + '_borderless';
    }
  },

  watch: {
    updateDropdown: function updateDropdown() {
      if (this.updateDropdown && this.isDropdownOpen() && !this.isLoading) {
        this.fetchJobs();
      }
    }
  },

  updated: function updated() {
    if (this.dropdownContent.length > 0) {
      this.stopDropdownClickPropagation();
    }
  },


  methods: {
    onClickStage: function onClickStage() {
      if (!this.isDropdownOpen()) {
        this.isLoading = true;
        this.fetchJobs();
      }
    },
    fetchJobs: function fetchJobs() {
      var _this = this;

      this.$http.get(this.stage.dropdown_path).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this.dropdownContent = data.html;
        _this.isLoading = false;
      }).catch(function () {
        _this.closeDropdown();
        _this.isLoading = false;

        var flash = new __WEBPACK_IMPORTED_MODULE_0__flash__["a" /* default */]('Something went wrong on our end.');
        return flash;
      });
    },


    /**
     * When the user right clicks or cmd/ctrl + click in the job name
     * the dropdown should not be closed and the link should open in another tab,
     * so we stop propagation of the click event inside the dropdown.
     *
     * Since this component is rendered multiple times per page we need to guarantee we only
     * target the click event of this component.
     */
    stopDropdownClickPropagation: function stopDropdownClickPropagation() {
      $(this.$el.querySelectorAll('.js-builds-dropdown-list a.mini-pipeline-graph-dropdown-item')).on('click', function (e) {
        e.stopPropagation();
      });
    },
    closeDropdown: function closeDropdown() {
      if (this.isDropdownOpen()) {
        $(this.$refs.dropdown).dropdown('toggle');
      }
    },
    isDropdownOpen: function isDropdownOpen() {
      return this.$el.classList.contains('open');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/field.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gl_form__ = __webpack_require__("./gl_form.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_vue__ = __webpack_require__("./vue_shared/components/markdown/header.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toolbar_vue__ = __webpack_require__("./vue_shared/components/markdown/toolbar.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icon_vue__ = __webpack_require__("./vue_shared/components/icon.vue");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    markdownHeader: __WEBPACK_IMPORTED_MODULE_2__header_vue__["a" /* default */],
    markdownToolbar: __WEBPACK_IMPORTED_MODULE_3__toolbar_vue__["a" /* default */],
    icon: __WEBPACK_IMPORTED_MODULE_4__icon_vue__["a" /* default */]
  },
  props: {
    markdownPreviewPath: {
      type: String,
      required: false,
      default: ''
    },
    markdownDocsPath: {
      type: String,
      required: true
    },
    addSpacingClasses: {
      type: Boolean,
      required: false,
      default: true
    },
    quickActionsDocsPath: {
      type: String,
      required: false,
      default: ''
    },
    canAttachFile: {
      type: Boolean,
      required: false,
      default: true
    },
    enableAutocomplete: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      markdownPreview: '',
      referencedCommands: '',
      referencedUsers: '',
      markdownPreviewLoading: false,
      previewMarkdown: false
    };
  },

  computed: {
    shouldShowReferencedUsers: function shouldShowReferencedUsers() {
      var referencedUsersThreshold = 10;
      return this.referencedUsers.length >= referencedUsersThreshold;
    }
  },
  mounted: function mounted() {
    /*
      GLForm class handles all the toolbar buttons
    */
    return new __WEBPACK_IMPORTED_MODULE_1__gl_form__["a" /* default */]($(this.$refs['gl-form']), this.enableAutocomplete);
  },
  beforeDestroy: function beforeDestroy() {
    var glForm = $(this.$refs['gl-form']).data('glForm');
    if (glForm) {
      glForm.destroy();
    }
  },

  methods: {
    showPreviewTab: function showPreviewTab() {
      var _this = this;

      if (this.previewMarkdown) return;

      this.previewMarkdown = true;

      /*
        Can't use `$refs` as the component is technically in the parent component
        so we access the VNode & then get the element
      */
      var text = this.$slots.textarea[0].elm.value;

      if (text) {
        this.markdownPreviewLoading = true;
        this.$http.post(this.markdownPreviewPath, { text: text }).then(function (resp) {
          return resp.json();
        }).then(function (data) {
          return _this.renderMarkdown(data);
        }).catch(function () {
          return new __WEBPACK_IMPORTED_MODULE_0__flash__["a" /* default */]('Error loading markdown preview');
        });
      } else {
        this.renderMarkdown();
      }
    },
    showWriteTab: function showWriteTab() {
      this.markdownPreview = '';
      this.previewMarkdown = false;
    },
    renderMarkdown: function renderMarkdown() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.markdownPreviewLoading = false;
      this.markdownPreview = data.body || 'Nothing to preview.';

      if (data.references) {
        this.referencedCommands = data.references.commands;
        this.referencedUsers = data.references.users;
      }

      this.$nextTick(function () {
        $(_this2.$refs['markdown-preview']).renderGFM();
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/header.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toolbar_button_vue__ = __webpack_require__("./vue_shared/components/markdown/toolbar_button.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icon_vue__ = __webpack_require__("./vue_shared/components/icon.vue");





/* harmony default export */ __webpack_exports__["a"] = ({
  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_0__directives_tooltip__["a" /* default */]
  },
  components: {
    toolbarButton: __WEBPACK_IMPORTED_MODULE_1__toolbar_button_vue__["a" /* default */],
    icon: __WEBPACK_IMPORTED_MODULE_2__icon_vue__["a" /* default */]
  },
  props: {
    previewMarkdown: {
      type: Boolean,
      required: true
    }
  },
  mounted: function mounted() {
    $(document).on('markdown-preview:show.vue', this.previewMarkdownTab);
    $(document).on('markdown-preview:hide.vue', this.writeMarkdownTab);
  },
  beforeDestroy: function beforeDestroy() {
    $(document).off('markdown-preview:show.vue', this.previewMarkdownTab);
    $(document).off('markdown-preview:hide.vue', this.writeMarkdownTab);
  },

  methods: {
    isMarkdownForm: function isMarkdownForm(form) {
      return form && !form.find('.js-vue-markdown-field').length;
    },
    previewMarkdownTab: function previewMarkdownTab(event, form) {
      if (event.target.blur) event.target.blur();
      if (this.isMarkdownForm(form)) return;

      this.$emit('preview-markdown');
    },
    writeMarkdownTab: function writeMarkdownTab(event, form) {
      if (event.target.blur) event.target.blur();
      if (this.isMarkdownForm(form)) return;

      this.$emit('write-markdown');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/deckar01-task_list/dist/task_list.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["TaskList"] = factory();
	else
		root["TaskList"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var NodeArray, TaskList, closest, createEvent,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

NodeArray = function(nodeList) {
  return Array.prototype.slice.apply(nodeList);
};

closest = function(el, className) {
  while (el && !el.classList.contains(className)) {
    el = el.parentNode;
  }
  return el;
};

createEvent = function(eventName, detail) {
  var event;
  if (typeof Event === 'function') {
    event = new Event(eventName, {
      bubbles: true,
      cancelable: true
    });
    event.detail = detail;
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, detail);
  }
  return event;
};

TaskList = (function() {
  function TaskList(el1) {
    this.el = el1;
    this.container = closest(this.el, 'js-task-list-container');
    this.field = this.container.querySelector('.js-task-list-field');
    this.container.addEventListener('change', (function(_this) {
      return function(event) {
        if (event.target.classList.contains('task-list-item-checkbox')) {
          return _this.updateTaskList(event.target);
        }
      };
    })(this));
    this.enable();
  }

  TaskList.prototype.enable = function() {
    var event;
    if (this.container.querySelectorAll('.js-task-list-field').length > 0) {
      NodeArray(this.container.querySelectorAll('.task-list-item')).forEach(function(item) {
        return item.classList.add('enabled');
      });
      NodeArray(this.container.querySelectorAll('.task-list-item-checkbox')).forEach(function(checkbox) {
        return checkbox.disabled = false;
      });
      this.container.classList.add('is-task-list-enabled');
      event = createEvent('tasklist:enabled');
      return this.container.dispatchEvent(event);
    }
  };

  TaskList.prototype.disable = function() {
    var event;
    NodeArray(this.container.querySelectorAll('.task-list-item')).forEach(function(item) {
      return item.classList.remove('enabled');
    });
    NodeArray(this.container.querySelectorAll('.task-list-item-checkbox')).forEach(function(checkbox) {
      return checkbox.disabled = true;
    });
    this.container.classList.remove('is-task-list-enabled');
    event = createEvent('tasklist:disabled');
    return this.container.dispatchEvent(event);
  };

  TaskList.prototype.updateTaskList = function(item) {
    var changeEvent, changedEvent, checkboxes, index;
    checkboxes = this.container.querySelectorAll('.task-list-item-checkbox');
    index = 1 + NodeArray(checkboxes).indexOf(item);
    changeEvent = createEvent('tasklist:change', {
      index: index,
      checked: item.checked
    });
    this.field.dispatchEvent(changeEvent);
    if (!changeEvent.defaultPrevented) {
      this.field.value = TaskList.updateSource(this.field.value, index, item.checked);
      changeEvent = createEvent('change');
      this.field.dispatchEvent(changeEvent);
      changedEvent = createEvent('tasklist:changed', {
        index: index,
        checked: item.checked
      });
      return this.field.dispatchEvent(changedEvent);
    }
  };

  TaskList.incomplete = "[ ]";

  TaskList.complete = "[x]";

  TaskList.escapePattern = function(str) {
    return str.replace(/([\[\]])/g, "\\$1").replace(/\s/, "\\s").replace("x", "[xX]");
  };

  TaskList.incompletePattern = RegExp("" + (TaskList.escapePattern(TaskList.incomplete)));

  TaskList.completePattern = RegExp("" + (TaskList.escapePattern(TaskList.complete)));

  TaskList.itemPattern = RegExp("^(?:\\s*(?:>\\s*)*(?:[-+*]|(?:\\d+\\.)))\\s*(" + (TaskList.escapePattern(TaskList.complete)) + "|" + (TaskList.escapePattern(TaskList.incomplete)) + ")\\s+(?!\\(.*?\\))(?=(?:\\[.*?\\]\\s*(?:\\[.*?\\]|\\(.*?\\))\\s*)*(?:[^\\[]|$))");

  TaskList.startFencesPattern = /^`{3}.*$/;

  TaskList.endFencesPattern = /^`{3}$/;

  TaskList.itemsInParasPattern = RegExp("^(" + (TaskList.escapePattern(TaskList.complete)) + "|" + (TaskList.escapePattern(TaskList.incomplete)) + ").+$", "g");

  TaskList.updateSource = function(source, itemIndex, checked) {
    var clean, inCodeBlock, index, line, result;
    clean = source.replace(/\r/g, '').replace(this.itemsInParasPattern, '').split("\n");
    index = 0;
    inCodeBlock = false;
    result = (function() {
      var i, len, ref, results;
      ref = source.split("\n");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        line = ref[i];
        if (inCodeBlock) {
          if (line.match(this.endFencesPattern)) {
            inCodeBlock = false;
          }
        } else if (line.match(this.startFencesPattern)) {
          inCodeBlock = true;
        } else if (indexOf.call(clean, line) >= 0 && line.match(this.itemPattern)) {
          index += 1;
          if (index === itemIndex) {
            line = checked ? line.replace(this.incompletePattern, this.complete) : line.replace(this.completePattern, this.incomplete);
          }
        }
        results.push(line);
      }
      return results;
    }).call(this);
    return result.join("\n");
  };

  return TaskList;

})();

if (typeof jQuery !== 'undefined') {
  jQuery.fn.taskList = function(method) {
    return this.each(function(index, el) {
      var taskList;
      taskList = jQuery(el).data('task-list');
      if (!taskList) {
        taskList = new TaskList(el);
        jQuery(el).data('task-list', taskList);
        if (!method || method === 'enable') {
          return;
        }
      }
      return taskList[method || 'enable']();
    });
  };
}

module.exports = TaskList;


/***/ })
/******/ ]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/dropzone/dist/dropzone.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery, module) {
/*
 *
 * More info at [www.dropzonejs.com](http://www.dropzonejs.com)
 *
 * Copyright (c) 2012, Matias Meno
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

(function() {
  var Dropzone, Emitter, camelize, contentLoaded, detectVerticalSquash, drawImageIOSFix, noop, without,
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  noop = function() {};

  Emitter = (function() {
    function Emitter() {}

    Emitter.prototype.addEventListener = Emitter.prototype.on;

    Emitter.prototype.on = function(event, fn) {
      this._callbacks = this._callbacks || {};
      if (!this._callbacks[event]) {
        this._callbacks[event] = [];
      }
      this._callbacks[event].push(fn);
      return this;
    };

    Emitter.prototype.emit = function() {
      var args, callback, callbacks, event, _i, _len;
      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      this._callbacks = this._callbacks || {};
      callbacks = this._callbacks[event];
      if (callbacks) {
        for (_i = 0, _len = callbacks.length; _i < _len; _i++) {
          callback = callbacks[_i];
          callback.apply(this, args);
        }
      }
      return this;
    };

    Emitter.prototype.removeListener = Emitter.prototype.off;

    Emitter.prototype.removeAllListeners = Emitter.prototype.off;

    Emitter.prototype.removeEventListener = Emitter.prototype.off;

    Emitter.prototype.off = function(event, fn) {
      var callback, callbacks, i, _i, _len;
      if (!this._callbacks || arguments.length === 0) {
        this._callbacks = {};
        return this;
      }
      callbacks = this._callbacks[event];
      if (!callbacks) {
        return this;
      }
      if (arguments.length === 1) {
        delete this._callbacks[event];
        return this;
      }
      for (i = _i = 0, _len = callbacks.length; _i < _len; i = ++_i) {
        callback = callbacks[i];
        if (callback === fn) {
          callbacks.splice(i, 1);
          break;
        }
      }
      return this;
    };

    return Emitter;

  })();

  Dropzone = (function(_super) {
    var extend, resolveOption;

    __extends(Dropzone, _super);

    Dropzone.prototype.Emitter = Emitter;


    /*
    This is a list of all available events you can register on a dropzone object.
    
    You can register an event handler like this:
    
        dropzone.on("dragEnter", function() { });
     */

    Dropzone.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"];

    Dropzone.prototype.defaultOptions = {
      url: null,
      method: "post",
      withCredentials: false,
      parallelUploads: 2,
      uploadMultiple: false,
      maxFilesize: 256,
      paramName: "file",
      createImageThumbnails: true,
      maxThumbnailFilesize: 10,
      thumbnailWidth: 120,
      thumbnailHeight: 120,
      filesizeBase: 1000,
      maxFiles: null,
      params: {},
      clickable: true,
      ignoreHiddenFiles: true,
      acceptedFiles: null,
      acceptedMimeTypes: null,
      autoProcessQueue: true,
      autoQueue: true,
      addRemoveLinks: false,
      previewsContainer: null,
      hiddenInputContainer: "body",
      capture: null,
      dictDefaultMessage: "Drop files here to upload",
      dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
      dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
      dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
      dictInvalidFileType: "You can't upload files of this type.",
      dictResponseError: "Server responded with {{statusCode}} code.",
      dictCancelUpload: "Cancel upload",
      dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
      dictRemoveFile: "Remove file",
      dictRemoveFileConfirmation: null,
      dictMaxFilesExceeded: "You can not upload any more files.",
      accept: function(file, done) {
        return done();
      },
      init: function() {
        return noop;
      },
      forceFallback: false,
      fallback: function() {
        var child, messageElement, span, _i, _len, _ref;
        this.element.className = "" + this.element.className + " dz-browser-not-supported";
        _ref = this.element.getElementsByTagName("div");
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          child = _ref[_i];
          if (/(^| )dz-message($| )/.test(child.className)) {
            messageElement = child;
            child.className = "dz-message";
            continue;
          }
        }
        if (!messageElement) {
          messageElement = Dropzone.createElement("<div class=\"dz-message\"><span></span></div>");
          this.element.appendChild(messageElement);
        }
        span = messageElement.getElementsByTagName("span")[0];
        if (span) {
          if (span.textContent != null) {
            span.textContent = this.options.dictFallbackMessage;
          } else if (span.innerText != null) {
            span.innerText = this.options.dictFallbackMessage;
          }
        }
        return this.element.appendChild(this.getFallbackForm());
      },
      resize: function(file) {
        var info, srcRatio, trgRatio;
        info = {
          srcX: 0,
          srcY: 0,
          srcWidth: file.width,
          srcHeight: file.height
        };
        srcRatio = file.width / file.height;
        info.optWidth = this.options.thumbnailWidth;
        info.optHeight = this.options.thumbnailHeight;
        if ((info.optWidth == null) && (info.optHeight == null)) {
          info.optWidth = info.srcWidth;
          info.optHeight = info.srcHeight;
        } else if (info.optWidth == null) {
          info.optWidth = srcRatio * info.optHeight;
        } else if (info.optHeight == null) {
          info.optHeight = (1 / srcRatio) * info.optWidth;
        }
        trgRatio = info.optWidth / info.optHeight;
        if (file.height < info.optHeight || file.width < info.optWidth) {
          info.trgHeight = info.srcHeight;
          info.trgWidth = info.srcWidth;
        } else {
          if (srcRatio > trgRatio) {
            info.srcHeight = file.height;
            info.srcWidth = info.srcHeight * trgRatio;
          } else {
            info.srcWidth = file.width;
            info.srcHeight = info.srcWidth / trgRatio;
          }
        }
        info.srcX = (file.width - info.srcWidth) / 2;
        info.srcY = (file.height - info.srcHeight) / 2;
        return info;
      },

      /*
      Those functions register themselves to the events on init and handle all
      the user interface specific stuff. Overwriting them won't break the upload
      but can break the way it's displayed.
      You can overwrite them if you don't like the default behavior. If you just
      want to add an additional event handler, register it on the dropzone object
      and don't overwrite those options.
       */
      drop: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragstart: noop,
      dragend: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragenter: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragover: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragleave: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      paste: noop,
      reset: function() {
        return this.element.classList.remove("dz-started");
      },
      addedfile: function(file) {
        var node, removeFileEvent, removeLink, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2, _results;
        if (this.element === this.previewsContainer) {
          this.element.classList.add("dz-started");
        }
        if (this.previewsContainer) {
          file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim());
          file.previewTemplate = file.previewElement;
          this.previewsContainer.appendChild(file.previewElement);
          _ref = file.previewElement.querySelectorAll("[data-dz-name]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            node.textContent = file.name;
          }
          _ref1 = file.previewElement.querySelectorAll("[data-dz-size]");
          for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
            node = _ref1[_j];
            node.innerHTML = this.filesize(file.size);
          }
          if (this.options.addRemoveLinks) {
            file._removeLink = Dropzone.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>" + this.options.dictRemoveFile + "</a>");
            file.previewElement.appendChild(file._removeLink);
          }
          removeFileEvent = (function(_this) {
            return function(e) {
              e.preventDefault();
              e.stopPropagation();
              if (file.status === Dropzone.UPLOADING) {
                return Dropzone.confirm(_this.options.dictCancelUploadConfirmation, function() {
                  return _this.removeFile(file);
                });
              } else {
                if (_this.options.dictRemoveFileConfirmation) {
                  return Dropzone.confirm(_this.options.dictRemoveFileConfirmation, function() {
                    return _this.removeFile(file);
                  });
                } else {
                  return _this.removeFile(file);
                }
              }
            };
          })(this);
          _ref2 = file.previewElement.querySelectorAll("[data-dz-remove]");
          _results = [];
          for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
            removeLink = _ref2[_k];
            _results.push(removeLink.addEventListener("click", removeFileEvent));
          }
          return _results;
        }
      },
      removedfile: function(file) {
        var _ref;
        if (file.previewElement) {
          if ((_ref = file.previewElement) != null) {
            _ref.parentNode.removeChild(file.previewElement);
          }
        }
        return this._updateMaxFilesReachedClass();
      },
      thumbnail: function(file, dataUrl) {
        var thumbnailElement, _i, _len, _ref;
        if (file.previewElement) {
          file.previewElement.classList.remove("dz-file-preview");
          _ref = file.previewElement.querySelectorAll("[data-dz-thumbnail]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            thumbnailElement = _ref[_i];
            thumbnailElement.alt = file.name;
            thumbnailElement.src = dataUrl;
          }
          return setTimeout(((function(_this) {
            return function() {
              return file.previewElement.classList.add("dz-image-preview");
            };
          })(this)), 1);
        }
      },
      error: function(file, message) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          file.previewElement.classList.add("dz-error");
          if (typeof message !== "String" && message.error) {
            message = message.error;
          }
          _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            _results.push(node.textContent = message);
          }
          return _results;
        }
      },
      errormultiple: noop,
      processing: function(file) {
        if (file.previewElement) {
          file.previewElement.classList.add("dz-processing");
          if (file._removeLink) {
            return file._removeLink.textContent = this.options.dictCancelUpload;
          }
        }
      },
      processingmultiple: noop,
      uploadprogress: function(file, progress, bytesSent) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          _ref = file.previewElement.querySelectorAll("[data-dz-uploadprogress]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            if (node.nodeName === 'PROGRESS') {
              _results.push(node.value = progress);
            } else {
              _results.push(node.style.width = "" + progress + "%");
            }
          }
          return _results;
        }
      },
      totaluploadprogress: noop,
      sending: noop,
      sendingmultiple: noop,
      success: function(file) {
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-success");
        }
      },
      successmultiple: noop,
      canceled: function(file) {
        return this.emit("error", file, "Upload canceled.");
      },
      canceledmultiple: noop,
      complete: function(file) {
        if (file._removeLink) {
          file._removeLink.textContent = this.options.dictRemoveFile;
        }
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-complete");
        }
      },
      completemultiple: noop,
      maxfilesexceeded: noop,
      maxfilesreached: noop,
      queuecomplete: noop,
      addedfiles: noop,
      previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size></span></div>\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n  </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>"
    };

    extend = function() {
      var key, object, objects, target, val, _i, _len;
      target = arguments[0], objects = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      for (_i = 0, _len = objects.length; _i < _len; _i++) {
        object = objects[_i];
        for (key in object) {
          val = object[key];
          target[key] = val;
        }
      }
      return target;
    };

    function Dropzone(element, options) {
      var elementOptions, fallback, _ref;
      this.element = element;
      this.version = Dropzone.version;
      this.defaultOptions.previewTemplate = this.defaultOptions.previewTemplate.replace(/\n*/g, "");
      this.clickableElements = [];
      this.listeners = [];
      this.files = [];
      if (typeof this.element === "string") {
        this.element = document.querySelector(this.element);
      }
      if (!(this.element && (this.element.nodeType != null))) {
        throw new Error("Invalid dropzone element.");
      }
      if (this.element.dropzone) {
        throw new Error("Dropzone already attached.");
      }
      Dropzone.instances.push(this);
      this.element.dropzone = this;
      elementOptions = (_ref = Dropzone.optionsForElement(this.element)) != null ? _ref : {};
      this.options = extend({}, this.defaultOptions, elementOptions, options != null ? options : {});
      if (this.options.forceFallback || !Dropzone.isBrowserSupported()) {
        return this.options.fallback.call(this);
      }
      if (this.options.url == null) {
        this.options.url = this.element.getAttribute("action");
      }
      if (!this.options.url) {
        throw new Error("No URL provided.");
      }
      if (this.options.acceptedFiles && this.options.acceptedMimeTypes) {
        throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
      }
      if (this.options.acceptedMimeTypes) {
        this.options.acceptedFiles = this.options.acceptedMimeTypes;
        delete this.options.acceptedMimeTypes;
      }
      this.options.method = this.options.method.toUpperCase();
      if ((fallback = this.getExistingFallback()) && fallback.parentNode) {
        fallback.parentNode.removeChild(fallback);
      }
      if (this.options.previewsContainer !== false) {
        if (this.options.previewsContainer) {
          this.previewsContainer = Dropzone.getElement(this.options.previewsContainer, "previewsContainer");
        } else {
          this.previewsContainer = this.element;
        }
      }
      if (this.options.clickable) {
        if (this.options.clickable === true) {
          this.clickableElements = [this.element];
        } else {
          this.clickableElements = Dropzone.getElements(this.options.clickable, "clickable");
        }
      }
      this.init();
    }

    Dropzone.prototype.getAcceptedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getRejectedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (!file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getFilesWithStatus = function(status) {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === status) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getQueuedFiles = function() {
      return this.getFilesWithStatus(Dropzone.QUEUED);
    };

    Dropzone.prototype.getUploadingFiles = function() {
      return this.getFilesWithStatus(Dropzone.UPLOADING);
    };

    Dropzone.prototype.getAddedFiles = function() {
      return this.getFilesWithStatus(Dropzone.ADDED);
    };

    Dropzone.prototype.getActiveFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === Dropzone.UPLOADING || file.status === Dropzone.QUEUED) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.init = function() {
      var eventName, noPropagation, setupHiddenFileInput, _i, _len, _ref, _ref1;
      if (this.element.tagName === "form") {
        this.element.setAttribute("enctype", "multipart/form-data");
      }
      if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) {
        this.element.appendChild(Dropzone.createElement("<div class=\"dz-default dz-message\"><span>" + this.options.dictDefaultMessage + "</span></div>"));
      }
      if (this.clickableElements.length) {
        setupHiddenFileInput = (function(_this) {
          return function() {
            if (_this.hiddenFileInput) {
              _this.hiddenFileInput.parentNode.removeChild(_this.hiddenFileInput);
            }
            _this.hiddenFileInput = document.createElement("input");
            _this.hiddenFileInput.setAttribute("type", "file");
            if ((_this.options.maxFiles == null) || _this.options.maxFiles > 1) {
              _this.hiddenFileInput.setAttribute("multiple", "multiple");
            }
            _this.hiddenFileInput.className = "dz-hidden-input";
            if (_this.options.acceptedFiles != null) {
              _this.hiddenFileInput.setAttribute("accept", _this.options.acceptedFiles);
            }
            if (_this.options.capture != null) {
              _this.hiddenFileInput.setAttribute("capture", _this.options.capture);
            }
            _this.hiddenFileInput.style.visibility = "hidden";
            _this.hiddenFileInput.style.position = "absolute";
            _this.hiddenFileInput.style.top = "0";
            _this.hiddenFileInput.style.left = "0";
            _this.hiddenFileInput.style.height = "0";
            _this.hiddenFileInput.style.width = "0";
            document.querySelector(_this.options.hiddenInputContainer).appendChild(_this.hiddenFileInput);
            return _this.hiddenFileInput.addEventListener("change", function() {
              var file, files, _i, _len;
              files = _this.hiddenFileInput.files;
              if (files.length) {
                for (_i = 0, _len = files.length; _i < _len; _i++) {
                  file = files[_i];
                  _this.addFile(file);
                }
              }
              _this.emit("addedfiles", files);
              return setupHiddenFileInput();
            });
          };
        })(this);
        setupHiddenFileInput();
      }
      this.URL = (_ref = window.URL) != null ? _ref : window.webkitURL;
      _ref1 = this.events;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        eventName = _ref1[_i];
        this.on(eventName, this.options[eventName]);
      }
      this.on("uploadprogress", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("removedfile", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("canceled", (function(_this) {
        return function(file) {
          return _this.emit("complete", file);
        };
      })(this));
      this.on("complete", (function(_this) {
        return function(file) {
          if (_this.getAddedFiles().length === 0 && _this.getUploadingFiles().length === 0 && _this.getQueuedFiles().length === 0) {
            return setTimeout((function() {
              return _this.emit("queuecomplete");
            }), 0);
          }
        };
      })(this));
      noPropagation = function(e) {
        e.stopPropagation();
        if (e.preventDefault) {
          return e.preventDefault();
        } else {
          return e.returnValue = false;
        }
      };
      this.listeners = [
        {
          element: this.element,
          events: {
            "dragstart": (function(_this) {
              return function(e) {
                return _this.emit("dragstart", e);
              };
            })(this),
            "dragenter": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.emit("dragenter", e);
              };
            })(this),
            "dragover": (function(_this) {
              return function(e) {
                var efct;
                try {
                  efct = e.dataTransfer.effectAllowed;
                } catch (_error) {}
                e.dataTransfer.dropEffect = 'move' === efct || 'linkMove' === efct ? 'move' : 'copy';
                noPropagation(e);
                return _this.emit("dragover", e);
              };
            })(this),
            "dragleave": (function(_this) {
              return function(e) {
                return _this.emit("dragleave", e);
              };
            })(this),
            "drop": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.drop(e);
              };
            })(this),
            "dragend": (function(_this) {
              return function(e) {
                return _this.emit("dragend", e);
              };
            })(this)
          }
        }
      ];
      this.clickableElements.forEach((function(_this) {
        return function(clickableElement) {
          return _this.listeners.push({
            element: clickableElement,
            events: {
              "click": function(evt) {
                if ((clickableElement !== _this.element) || (evt.target === _this.element || Dropzone.elementInside(evt.target, _this.element.querySelector(".dz-message")))) {
                  _this.hiddenFileInput.click();
                }
                return true;
              }
            }
          });
        };
      })(this));
      this.enable();
      return this.options.init.call(this);
    };

    Dropzone.prototype.destroy = function() {
      var _ref;
      this.disable();
      this.removeAllFiles(true);
      if ((_ref = this.hiddenFileInput) != null ? _ref.parentNode : void 0) {
        this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
        this.hiddenFileInput = null;
      }
      delete this.element.dropzone;
      return Dropzone.instances.splice(Dropzone.instances.indexOf(this), 1);
    };

    Dropzone.prototype.updateTotalUploadProgress = function() {
      var activeFiles, file, totalBytes, totalBytesSent, totalUploadProgress, _i, _len, _ref;
      totalBytesSent = 0;
      totalBytes = 0;
      activeFiles = this.getActiveFiles();
      if (activeFiles.length) {
        _ref = this.getActiveFiles();
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          totalBytesSent += file.upload.bytesSent;
          totalBytes += file.upload.total;
        }
        totalUploadProgress = 100 * totalBytesSent / totalBytes;
      } else {
        totalUploadProgress = 100;
      }
      return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    };

    Dropzone.prototype._getParamName = function(n) {
      if (typeof this.options.paramName === "function") {
        return this.options.paramName(n);
      } else {
        return "" + this.options.paramName + (this.options.uploadMultiple ? "[" + n + "]" : "");
      }
    };

    Dropzone.prototype.getFallbackForm = function() {
      var existingFallback, fields, fieldsString, form;
      if (existingFallback = this.getExistingFallback()) {
        return existingFallback;
      }
      fieldsString = "<div class=\"dz-fallback\">";
      if (this.options.dictFallbackText) {
        fieldsString += "<p>" + this.options.dictFallbackText + "</p>";
      }
      fieldsString += "<input type=\"file\" name=\"" + (this._getParamName(0)) + "\" " + (this.options.uploadMultiple ? 'multiple="multiple"' : void 0) + " /><input type=\"submit\" value=\"Upload!\"></div>";
      fields = Dropzone.createElement(fieldsString);
      if (this.element.tagName !== "FORM") {
        form = Dropzone.createElement("<form action=\"" + this.options.url + "\" enctype=\"multipart/form-data\" method=\"" + this.options.method + "\"></form>");
        form.appendChild(fields);
      } else {
        this.element.setAttribute("enctype", "multipart/form-data");
        this.element.setAttribute("method", this.options.method);
      }
      return form != null ? form : fields;
    };

    Dropzone.prototype.getExistingFallback = function() {
      var fallback, getFallback, tagName, _i, _len, _ref;
      getFallback = function(elements) {
        var el, _i, _len;
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )fallback($| )/.test(el.className)) {
            return el;
          }
        }
      };
      _ref = ["div", "form"];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        tagName = _ref[_i];
        if (fallback = getFallback(this.element.getElementsByTagName(tagName))) {
          return fallback;
        }
      }
    };

    Dropzone.prototype.setupEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.addEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.removeEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.removeEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.disable = function() {
      var file, _i, _len, _ref, _results;
      this.clickableElements.forEach(function(element) {
        return element.classList.remove("dz-clickable");
      });
      this.removeEventListeners();
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        _results.push(this.cancelUpload(file));
      }
      return _results;
    };

    Dropzone.prototype.enable = function() {
      this.clickableElements.forEach(function(element) {
        return element.classList.add("dz-clickable");
      });
      return this.setupEventListeners();
    };

    Dropzone.prototype.filesize = function(size) {
      var cutoff, i, selectedSize, selectedUnit, unit, units, _i, _len;
      selectedSize = 0;
      selectedUnit = "b";
      if (size > 0) {
        units = ['TB', 'GB', 'MB', 'KB', 'b'];
        for (i = _i = 0, _len = units.length; _i < _len; i = ++_i) {
          unit = units[i];
          cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
          if (size >= cutoff) {
            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
            selectedUnit = unit;
            break;
          }
        }
        selectedSize = Math.round(10 * selectedSize) / 10;
      }
      return "<strong>" + selectedSize + "</strong> " + selectedUnit;
    };

    Dropzone.prototype._updateMaxFilesReachedClass = function() {
      if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        if (this.getAcceptedFiles().length === this.options.maxFiles) {
          this.emit('maxfilesreached', this.files);
        }
        return this.element.classList.add("dz-max-files-reached");
      } else {
        return this.element.classList.remove("dz-max-files-reached");
      }
    };

    Dropzone.prototype.drop = function(e) {
      var files, items;
      if (!e.dataTransfer) {
        return;
      }
      this.emit("drop", e);
      files = e.dataTransfer.files;
      this.emit("addedfiles", files);
      if (files.length) {
        items = e.dataTransfer.items;
        if (items && items.length && (items[0].webkitGetAsEntry != null)) {
          this._addFilesFromItems(items);
        } else {
          this.handleFiles(files);
        }
      }
    };

    Dropzone.prototype.paste = function(e) {
      var items, _ref;
      if ((e != null ? (_ref = e.clipboardData) != null ? _ref.items : void 0 : void 0) == null) {
        return;
      }
      this.emit("paste", e);
      items = e.clipboardData.items;
      if (items.length) {
        return this._addFilesFromItems(items);
      }
    };

    Dropzone.prototype.handleFiles = function(files) {
      var file, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        _results.push(this.addFile(file));
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromItems = function(items) {
      var entry, item, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = items.length; _i < _len; _i++) {
        item = items[_i];
        if ((item.webkitGetAsEntry != null) && (entry = item.webkitGetAsEntry())) {
          if (entry.isFile) {
            _results.push(this.addFile(item.getAsFile()));
          } else if (entry.isDirectory) {
            _results.push(this._addFilesFromDirectory(entry, entry.name));
          } else {
            _results.push(void 0);
          }
        } else if (item.getAsFile != null) {
          if ((item.kind == null) || item.kind === "file") {
            _results.push(this.addFile(item.getAsFile()));
          } else {
            _results.push(void 0);
          }
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromDirectory = function(directory, path) {
      var dirReader, entriesReader;
      dirReader = directory.createReader();
      entriesReader = (function(_this) {
        return function(entries) {
          var entry, _i, _len;
          for (_i = 0, _len = entries.length; _i < _len; _i++) {
            entry = entries[_i];
            if (entry.isFile) {
              entry.file(function(file) {
                if (_this.options.ignoreHiddenFiles && file.name.substring(0, 1) === '.') {
                  return;
                }
                file.fullPath = "" + path + "/" + file.name;
                return _this.addFile(file);
              });
            } else if (entry.isDirectory) {
              _this._addFilesFromDirectory(entry, "" + path + "/" + entry.name);
            }
          }
        };
      })(this);
      return dirReader.readEntries(entriesReader, function(error) {
        return typeof console !== "undefined" && console !== null ? typeof console.log === "function" ? console.log(error) : void 0 : void 0;
      });
    };

    Dropzone.prototype.accept = function(file, done) {
      if (file.size > this.options.maxFilesize * 1024 * 1024) {
        return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
      } else if (!Dropzone.isValidFile(file, this.options.acceptedFiles)) {
        return done(this.options.dictInvalidFileType);
      } else if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
        return this.emit("maxfilesexceeded", file);
      } else {
        return this.options.accept.call(this, file, done);
      }
    };

    Dropzone.prototype.addFile = function(file) {
      file.upload = {
        progress: 0,
        total: file.size,
        bytesSent: 0
      };
      this.files.push(file);
      file.status = Dropzone.ADDED;
      this.emit("addedfile", file);
      this._enqueueThumbnail(file);
      return this.accept(file, (function(_this) {
        return function(error) {
          if (error) {
            file.accepted = false;
            _this._errorProcessing([file], error);
          } else {
            file.accepted = true;
            if (_this.options.autoQueue) {
              _this.enqueueFile(file);
            }
          }
          return _this._updateMaxFilesReachedClass();
        };
      })(this));
    };

    Dropzone.prototype.enqueueFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        this.enqueueFile(file);
      }
      return null;
    };

    Dropzone.prototype.enqueueFile = function(file) {
      if (file.status === Dropzone.ADDED && file.accepted === true) {
        file.status = Dropzone.QUEUED;
        if (this.options.autoProcessQueue) {
          return setTimeout(((function(_this) {
            return function() {
              return _this.processQueue();
            };
          })(this)), 0);
        }
      } else {
        throw new Error("This file can't be queued because it has already been processed or was rejected.");
      }
    };

    Dropzone.prototype._thumbnailQueue = [];

    Dropzone.prototype._processingThumbnail = false;

    Dropzone.prototype._enqueueThumbnail = function(file) {
      if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1024 * 1024) {
        this._thumbnailQueue.push(file);
        return setTimeout(((function(_this) {
          return function() {
            return _this._processThumbnailQueue();
          };
        })(this)), 0);
      }
    };

    Dropzone.prototype._processThumbnailQueue = function() {
      if (this._processingThumbnail || this._thumbnailQueue.length === 0) {
        return;
      }
      this._processingThumbnail = true;
      return this.createThumbnail(this._thumbnailQueue.shift(), (function(_this) {
        return function() {
          _this._processingThumbnail = false;
          return _this._processThumbnailQueue();
        };
      })(this));
    };

    Dropzone.prototype.removeFile = function(file) {
      if (file.status === Dropzone.UPLOADING) {
        this.cancelUpload(file);
      }
      this.files = without(this.files, file);
      this.emit("removedfile", file);
      if (this.files.length === 0) {
        return this.emit("reset");
      }
    };

    Dropzone.prototype.removeAllFiles = function(cancelIfNecessary) {
      var file, _i, _len, _ref;
      if (cancelIfNecessary == null) {
        cancelIfNecessary = false;
      }
      _ref = this.files.slice();
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status !== Dropzone.UPLOADING || cancelIfNecessary) {
          this.removeFile(file);
        }
      }
      return null;
    };

    Dropzone.prototype.createThumbnail = function(file, callback) {
      var fileReader;
      fileReader = new FileReader;
      fileReader.onload = (function(_this) {
        return function() {
          if (file.type === "image/svg+xml") {
            _this.emit("thumbnail", file, fileReader.result);
            if (callback != null) {
              callback();
            }
            return;
          }
          return _this.createThumbnailFromUrl(file, fileReader.result, callback);
        };
      })(this);
      return fileReader.readAsDataURL(file);
    };

    Dropzone.prototype.createThumbnailFromUrl = function(file, imageUrl, callback, crossOrigin) {
      var img;
      img = document.createElement("img");
      if (crossOrigin) {
        img.crossOrigin = crossOrigin;
      }
      img.onload = (function(_this) {
        return function() {
          var canvas, ctx, resizeInfo, thumbnail, _ref, _ref1, _ref2, _ref3;
          file.width = img.width;
          file.height = img.height;
          resizeInfo = _this.options.resize.call(_this, file);
          if (resizeInfo.trgWidth == null) {
            resizeInfo.trgWidth = resizeInfo.optWidth;
          }
          if (resizeInfo.trgHeight == null) {
            resizeInfo.trgHeight = resizeInfo.optHeight;
          }
          canvas = document.createElement("canvas");
          ctx = canvas.getContext("2d");
          canvas.width = resizeInfo.trgWidth;
          canvas.height = resizeInfo.trgHeight;
          drawImageIOSFix(ctx, img, (_ref = resizeInfo.srcX) != null ? _ref : 0, (_ref1 = resizeInfo.srcY) != null ? _ref1 : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, (_ref2 = resizeInfo.trgX) != null ? _ref2 : 0, (_ref3 = resizeInfo.trgY) != null ? _ref3 : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
          thumbnail = canvas.toDataURL("image/png");
          _this.emit("thumbnail", file, thumbnail);
          if (callback != null) {
            return callback();
          }
        };
      })(this);
      if (callback != null) {
        img.onerror = callback;
      }
      return img.src = imageUrl;
    };

    Dropzone.prototype.processQueue = function() {
      var i, parallelUploads, processingLength, queuedFiles;
      parallelUploads = this.options.parallelUploads;
      processingLength = this.getUploadingFiles().length;
      i = processingLength;
      if (processingLength >= parallelUploads) {
        return;
      }
      queuedFiles = this.getQueuedFiles();
      if (!(queuedFiles.length > 0)) {
        return;
      }
      if (this.options.uploadMultiple) {
        return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
      } else {
        while (i < parallelUploads) {
          if (!queuedFiles.length) {
            return;
          }
          this.processFile(queuedFiles.shift());
          i++;
        }
      }
    };

    Dropzone.prototype.processFile = function(file) {
      return this.processFiles([file]);
    };

    Dropzone.prototype.processFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.processing = true;
        file.status = Dropzone.UPLOADING;
        this.emit("processing", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("processingmultiple", files);
      }
      return this.uploadFiles(files);
    };

    Dropzone.prototype._getFilesWithXhr = function(xhr) {
      var file, files;
      return files = (function() {
        var _i, _len, _ref, _results;
        _ref = this.files;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          if (file.xhr === xhr) {
            _results.push(file);
          }
        }
        return _results;
      }).call(this);
    };

    Dropzone.prototype.cancelUpload = function(file) {
      var groupedFile, groupedFiles, _i, _j, _len, _len1, _ref;
      if (file.status === Dropzone.UPLOADING) {
        groupedFiles = this._getFilesWithXhr(file.xhr);
        for (_i = 0, _len = groupedFiles.length; _i < _len; _i++) {
          groupedFile = groupedFiles[_i];
          groupedFile.status = Dropzone.CANCELED;
        }
        file.xhr.abort();
        for (_j = 0, _len1 = groupedFiles.length; _j < _len1; _j++) {
          groupedFile = groupedFiles[_j];
          this.emit("canceled", groupedFile);
        }
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", groupedFiles);
        }
      } else if ((_ref = file.status) === Dropzone.ADDED || _ref === Dropzone.QUEUED) {
        file.status = Dropzone.CANCELED;
        this.emit("canceled", file);
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", [file]);
        }
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    resolveOption = function() {
      var args, option;
      option = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      if (typeof option === 'function') {
        return option.apply(this, args);
      }
      return option;
    };

    Dropzone.prototype.uploadFile = function(file) {
      return this.uploadFiles([file]);
    };

    Dropzone.prototype.uploadFiles = function(files) {
      var file, formData, handleError, headerName, headerValue, headers, i, input, inputName, inputType, key, method, option, progressObj, response, updateProgress, url, value, xhr, _i, _j, _k, _l, _len, _len1, _len2, _len3, _m, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
      xhr = new XMLHttpRequest();
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.xhr = xhr;
      }
      method = resolveOption(this.options.method, files);
      url = resolveOption(this.options.url, files);
      xhr.open(method, url, true);
      xhr.withCredentials = !!this.options.withCredentials;
      response = null;
      handleError = (function(_this) {
        return function() {
          var _j, _len1, _results;
          _results = [];
          for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
            file = files[_j];
            _results.push(_this._errorProcessing(files, response || _this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr));
          }
          return _results;
        };
      })(this);
      updateProgress = (function(_this) {
        return function(e) {
          var allFilesFinished, progress, _j, _k, _l, _len1, _len2, _len3, _results;
          if (e != null) {
            progress = 100 * e.loaded / e.total;
            for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
              file = files[_j];
              file.upload = {
                progress: progress,
                total: e.total,
                bytesSent: e.loaded
              };
            }
          } else {
            allFilesFinished = true;
            progress = 100;
            for (_k = 0, _len2 = files.length; _k < _len2; _k++) {
              file = files[_k];
              if (!(file.upload.progress === 100 && file.upload.bytesSent === file.upload.total)) {
                allFilesFinished = false;
              }
              file.upload.progress = progress;
              file.upload.bytesSent = file.upload.total;
            }
            if (allFilesFinished) {
              return;
            }
          }
          _results = [];
          for (_l = 0, _len3 = files.length; _l < _len3; _l++) {
            file = files[_l];
            _results.push(_this.emit("uploadprogress", file, progress, file.upload.bytesSent));
          }
          return _results;
        };
      })(this);
      xhr.onload = (function(_this) {
        return function(e) {
          var _ref;
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          if (xhr.readyState !== 4) {
            return;
          }
          response = xhr.responseText;
          if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) {
            try {
              response = JSON.parse(response);
            } catch (_error) {
              e = _error;
              response = "Invalid JSON response from server.";
            }
          }
          updateProgress();
          if (!((200 <= (_ref = xhr.status) && _ref < 300))) {
            return handleError();
          } else {
            return _this._finished(files, response, e);
          }
        };
      })(this);
      xhr.onerror = (function(_this) {
        return function() {
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          return handleError();
        };
      })(this);
      progressObj = (_ref = xhr.upload) != null ? _ref : xhr;
      progressObj.onprogress = updateProgress;
      headers = {
        "Accept": "application/json",
        "Cache-Control": "no-cache",
        "X-Requested-With": "XMLHttpRequest"
      };
      if (this.options.headers) {
        extend(headers, this.options.headers);
      }
      for (headerName in headers) {
        headerValue = headers[headerName];
        if (headerValue) {
          xhr.setRequestHeader(headerName, headerValue);
        }
      }
      formData = new FormData();
      if (this.options.params) {
        _ref1 = this.options.params;
        for (key in _ref1) {
          value = _ref1[key];
          formData.append(key, value);
        }
      }
      for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
        file = files[_j];
        this.emit("sending", file, xhr, formData);
      }
      if (this.options.uploadMultiple) {
        this.emit("sendingmultiple", files, xhr, formData);
      }
      if (this.element.tagName === "FORM") {
        _ref2 = this.element.querySelectorAll("input, textarea, select, button");
        for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
          input = _ref2[_k];
          inputName = input.getAttribute("name");
          inputType = input.getAttribute("type");
          if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
            _ref3 = input.options;
            for (_l = 0, _len3 = _ref3.length; _l < _len3; _l++) {
              option = _ref3[_l];
              if (option.selected) {
                formData.append(inputName, option.value);
              }
            }
          } else if (!inputType || ((_ref4 = inputType.toLowerCase()) !== "checkbox" && _ref4 !== "radio") || input.checked) {
            formData.append(inputName, input.value);
          }
        }
      }
      for (i = _m = 0, _ref5 = files.length - 1; 0 <= _ref5 ? _m <= _ref5 : _m >= _ref5; i = 0 <= _ref5 ? ++_m : --_m) {
        formData.append(this._getParamName(i), files[i], files[i].name);
      }
      return this.submitRequest(xhr, formData, files);
    };

    Dropzone.prototype.submitRequest = function(xhr, formData, files) {
      return xhr.send(formData);
    };

    Dropzone.prototype._finished = function(files, responseText, e) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.SUCCESS;
        this.emit("success", file, responseText, e);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("successmultiple", files, responseText, e);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    Dropzone.prototype._errorProcessing = function(files, message, xhr) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.ERROR;
        this.emit("error", file, message, xhr);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("errormultiple", files, message, xhr);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    return Dropzone;

  })(Emitter);

  Dropzone.version = "4.2.0";

  Dropzone.options = {};

  Dropzone.optionsForElement = function(element) {
    if (element.getAttribute("id")) {
      return Dropzone.options[camelize(element.getAttribute("id"))];
    } else {
      return void 0;
    }
  };

  Dropzone.instances = [];

  Dropzone.forElement = function(element) {
    if (typeof element === "string") {
      element = document.querySelector(element);
    }
    if ((element != null ? element.dropzone : void 0) == null) {
      throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
    }
    return element.dropzone;
  };

  Dropzone.autoDiscover = true;

  Dropzone.discover = function() {
    var checkElements, dropzone, dropzones, _i, _len, _results;
    if (document.querySelectorAll) {
      dropzones = document.querySelectorAll(".dropzone");
    } else {
      dropzones = [];
      checkElements = function(elements) {
        var el, _i, _len, _results;
        _results = [];
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )dropzone($| )/.test(el.className)) {
            _results.push(dropzones.push(el));
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      };
      checkElements(document.getElementsByTagName("div"));
      checkElements(document.getElementsByTagName("form"));
    }
    _results = [];
    for (_i = 0, _len = dropzones.length; _i < _len; _i++) {
      dropzone = dropzones[_i];
      if (Dropzone.optionsForElement(dropzone) !== false) {
        _results.push(new Dropzone(dropzone));
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };

  Dropzone.blacklistedBrowsers = [/opera.*Macintosh.*version\/12/i];

  Dropzone.isBrowserSupported = function() {
    var capableBrowser, regex, _i, _len, _ref;
    capableBrowser = true;
    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
      if (!("classList" in document.createElement("a"))) {
        capableBrowser = false;
      } else {
        _ref = Dropzone.blacklistedBrowsers;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          regex = _ref[_i];
          if (regex.test(navigator.userAgent)) {
            capableBrowser = false;
            continue;
          }
        }
      }
    } else {
      capableBrowser = false;
    }
    return capableBrowser;
  };

  without = function(list, rejectedItem) {
    var item, _i, _len, _results;
    _results = [];
    for (_i = 0, _len = list.length; _i < _len; _i++) {
      item = list[_i];
      if (item !== rejectedItem) {
        _results.push(item);
      }
    }
    return _results;
  };

  camelize = function(str) {
    return str.replace(/[\-_](\w)/g, function(match) {
      return match.charAt(1).toUpperCase();
    });
  };

  Dropzone.createElement = function(string) {
    var div;
    div = document.createElement("div");
    div.innerHTML = string;
    return div.childNodes[0];
  };

  Dropzone.elementInside = function(element, container) {
    if (element === container) {
      return true;
    }
    while (element = element.parentNode) {
      if (element === container) {
        return true;
      }
    }
    return false;
  };

  Dropzone.getElement = function(el, name) {
    var element;
    if (typeof el === "string") {
      element = document.querySelector(el);
    } else if (el.nodeType != null) {
      element = el;
    }
    if (element == null) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector or a plain HTML element.");
    }
    return element;
  };

  Dropzone.getElements = function(els, name) {
    var e, el, elements, _i, _j, _len, _len1, _ref;
    if (els instanceof Array) {
      elements = [];
      try {
        for (_i = 0, _len = els.length; _i < _len; _i++) {
          el = els[_i];
          elements.push(this.getElement(el, name));
        }
      } catch (_error) {
        e = _error;
        elements = null;
      }
    } else if (typeof els === "string") {
      elements = [];
      _ref = document.querySelectorAll(els);
      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
        el = _ref[_j];
        elements.push(el);
      }
    } else if (els.nodeType != null) {
      elements = [els];
    }
    if (!((elements != null) && elements.length)) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
    }
    return elements;
  };

  Dropzone.confirm = function(question, accepted, rejected) {
    if (window.confirm(question)) {
      return accepted();
    } else if (rejected != null) {
      return rejected();
    }
  };

  Dropzone.isValidFile = function(file, acceptedFiles) {
    var baseMimeType, mimeType, validType, _i, _len;
    if (!acceptedFiles) {
      return true;
    }
    acceptedFiles = acceptedFiles.split(",");
    mimeType = file.type;
    baseMimeType = mimeType.replace(/\/.*$/, "");
    for (_i = 0, _len = acceptedFiles.length; _i < _len; _i++) {
      validType = acceptedFiles[_i];
      validType = validType.trim();
      if (validType.charAt(0) === ".") {
        if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
          return true;
        }
      } else if (/\/\*$/.test(validType)) {
        if (baseMimeType === validType.replace(/\/.*$/, "")) {
          return true;
        }
      } else {
        if (mimeType === validType) {
          return true;
        }
      }
    }
    return false;
  };

  if (typeof jQuery !== "undefined" && jQuery !== null) {
    jQuery.fn.dropzone = function(options) {
      return this.each(function() {
        return new Dropzone(this, options);
      });
    };
  }

  if (typeof module !== "undefined" && module !== null) {
    module.exports = Dropzone;
  } else {
    window.Dropzone = Dropzone;
  }

  Dropzone.ADDED = "added";

  Dropzone.QUEUED = "queued";

  Dropzone.ACCEPTED = Dropzone.QUEUED;

  Dropzone.UPLOADING = "uploading";

  Dropzone.PROCESSING = Dropzone.UPLOADING;

  Dropzone.CANCELED = "canceled";

  Dropzone.ERROR = "error";

  Dropzone.SUCCESS = "success";


  /*
  
  Bugfix for iOS 6 and 7
  Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
  based on the work of https://github.com/stomita/ios-imagefile-megapixel
   */

  detectVerticalSquash = function(img) {
    var alpha, canvas, ctx, data, ey, ih, iw, py, ratio, sy;
    iw = img.naturalWidth;
    ih = img.naturalHeight;
    canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = ih;
    ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    data = ctx.getImageData(0, 0, 1, ih).data;
    sy = 0;
    ey = ih;
    py = ih;
    while (py > sy) {
      alpha = data[(py - 1) * 4 + 3];
      if (alpha === 0) {
        ey = py;
      } else {
        sy = py;
      }
      py = (ey + sy) >> 1;
    }
    ratio = py / ih;
    if (ratio === 0) {
      return 1;
    } else {
      return ratio;
    }
  };

  drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
    var vertSquashRatio;
    vertSquashRatio = detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
  };


  /*
   * contentloaded.js
   *
   * Author: Diego Perini (diego.perini at gmail.com)
   * Summary: cross-browser wrapper for DOMContentLoaded
   * Updated: 20101020
   * License: MIT
   * Version: 1.2
   *
   * URL:
   * http://javascript.nwbox.com/ContentLoaded/
   * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
   */

  contentLoaded = function(win, fn) {
    var add, doc, done, init, poll, pre, rem, root, top;
    done = false;
    top = true;
    doc = win.document;
    root = doc.documentElement;
    add = (doc.addEventListener ? "addEventListener" : "attachEvent");
    rem = (doc.addEventListener ? "removeEventListener" : "detachEvent");
    pre = (doc.addEventListener ? "" : "on");
    init = function(e) {
      if (e.type === "readystatechange" && doc.readyState !== "complete") {
        return;
      }
      (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
      if (!done && (done = true)) {
        return fn.call(win, e.type || e);
      }
    };
    poll = function() {
      var e;
      try {
        root.doScroll("left");
      } catch (_error) {
        e = _error;
        setTimeout(poll, 50);
        return;
      }
      return init("poll");
    };
    if (doc.readyState !== "complete") {
      if (doc.createEventObject && root.doScroll) {
        try {
          top = !win.frameElement;
        } catch (_error) {}
        if (top) {
          poll();
        }
      }
      doc[add](pre + "DOMContentLoaded", init, false);
      doc[add](pre + "readystatechange", init, false);
      return win[add](pre + "load", init, false);
    }
  };

  Dropzone._autoDiscoverFunction = function() {
    if (Dropzone.autoDiscover) {
      return Dropzone.discover();
    }
  };

  contentLoaded(window, Dropzone._autoDiscoverFunction);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js"), __webpack_require__("../../../node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "../../../node_modules/mousetrap/plugins/pause/mousetrap-pause.js":
/***/ (function(module, exports) {

/**
 * adds a pause and unpause method to Mousetrap
 * this allows you to enable or disable keyboard shortcuts
 * without having to reset Mousetrap and rebind everything
 */
/* global Mousetrap:true */
Mousetrap = (function(Mousetrap) {
    var self = Mousetrap,
        _originalStopCallback = self.stopCallback,
        enabled = true;

    self.stopCallback = function(e, element, combo) {
        if (!enabled) {
            return true;
        }

        return _originalStopCallback(e, element, combo);
    };

    self.pause = function() {
        enabled = false;
    };

    self.unpause = function() {
        enabled = true;
    };

    return self;
}) (Mousetrap);


/***/ }),

/***/ "../../../node_modules/pikaday/pikaday.js":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Pikaday
 *
 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/dbushell/Pikaday
 */

(function (root, factory)
{
    'use strict';

    var moment;
    if (true) {
        // CommonJS module
        // Load moment.js as an optional dependency
        try { moment = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"moment\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())); } catch (e) {}
        module.exports = factory(moment);
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function (req)
        {
            // Load moment.js as an optional dependency
            var id = 'moment';
            try { moment = req(id); } catch (e) {}
            return factory(moment);
        });
    } else {
        root.Pikaday = factory(root.moment);
    }
}(this, function (moment)
{
    'use strict';

    /**
     * feature detection and helper functions
     */
    var hasMoment = typeof moment === 'function',

    hasEventListeners = !!window.addEventListener,

    document = window.document,

    sto = window.setTimeout,

    addEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.addEventListener(e, callback, !!capture);
        } else {
            el.attachEvent('on' + e, callback);
        }
    },

    removeEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.removeEventListener(e, callback, !!capture);
        } else {
            el.detachEvent('on' + e, callback);
        }
    },

    trim = function(str)
    {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g,'');
    },

    hasClass = function(el, cn)
    {
        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
    },

    addClass = function(el, cn)
    {
        if (!hasClass(el, cn)) {
            el.className = (el.className === '') ? cn : el.className + ' ' + cn;
        }
    },

    removeClass = function(el, cn)
    {
        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
    },

    isArray = function(obj)
    {
        return (/Array/).test(Object.prototype.toString.call(obj));
    },

    isDate = function(obj)
    {
        return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
    },

    isWeekend = function(date)
    {
        var day = date.getDay();
        return day === 0 || day === 6;
    },

    isLeapYear = function(year)
    {
        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    },

    getDaysInMonth = function(year, month)
    {
        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    },

    setToStartOfDay = function(date)
    {
        if (isDate(date)) date.setHours(0,0,0,0);
    },

    compareDates = function(a,b)
    {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
    },

    extend = function(to, from, overwrite)
    {
        var prop, hasProp;
        for (prop in from) {
            hasProp = to[prop] !== undefined;
            if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
                if (isDate(from[prop])) {
                    if (overwrite) {
                        to[prop] = new Date(from[prop].getTime());
                    }
                }
                else if (isArray(from[prop])) {
                    if (overwrite) {
                        to[prop] = from[prop].slice(0);
                    }
                } else {
                    to[prop] = extend({}, from[prop], overwrite);
                }
            } else if (overwrite || !hasProp) {
                to[prop] = from[prop];
            }
        }
        return to;
    },

    fireEvent = function(el, eventName, data)
    {
        var ev;

        if (document.createEvent) {
            ev = document.createEvent('HTMLEvents');
            ev.initEvent(eventName, true, false);
            ev = extend(ev, data);
            el.dispatchEvent(ev);
        } else if (document.createEventObject) {
            ev = document.createEventObject();
            ev = extend(ev, data);
            el.fireEvent('on' + eventName, ev);
        }
    },

    adjustCalendar = function(calendar) {
        if (calendar.month < 0) {
            calendar.year -= Math.ceil(Math.abs(calendar.month)/12);
            calendar.month += 12;
        }
        if (calendar.month > 11) {
            calendar.year += Math.floor(Math.abs(calendar.month)/12);
            calendar.month -= 12;
        }
        return calendar;
    },

    /**
     * defaults and localisation
     */
    defaults = {

        // bind the picker to a form field
        field: null,

        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
        bound: undefined,

        // position of the datepicker, relative to the field (default to bottom & left)
        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
        position: 'bottom left',

        // automatically fit in the viewport even if it means repositioning from the position option
        reposition: true,

        // the default output format for `.toString()` and `field` value
        format: 'YYYY-MM-DD',

        // the toString function which gets passed a current date object and format
        // and returns a string
        toString: null,

        // used to create date object from current input string
        parse: null,

        // the initial date to view when first opened
        defaultDate: null,

        // make the `defaultDate` the initial selected value
        setDefaultDate: false,

        // first day of week (0: Sunday, 1: Monday etc)
        firstDay: 0,

        // the default flag for moment's strict date parsing
        formatStrict: false,

        // the minimum/earliest date that can be selected
        minDate: null,
        // the maximum/latest date that can be selected
        maxDate: null,

        // number of years either side, or array of upper/lower range
        yearRange: 10,

        // show week numbers at head of row
        showWeekNumber: false,

        // Week picker mode
        pickWholeWeek: false,

        // used internally (don't config outside)
        minYear: 0,
        maxYear: 9999,
        minMonth: undefined,
        maxMonth: undefined,

        startRange: null,
        endRange: null,

        isRTL: false,

        // Additional text to append to the year in the calendar title
        yearSuffix: '',

        // Render the month after year in the calendar title
        showMonthAfterYear: false,

        // Render days of the calendar grid that fall in the next or previous month
        showDaysInNextAndPreviousMonths: false,

        // Allows user to select days that fall in the next or previous month
        enableSelectionDaysInNextAndPreviousMonths: false,

        // how many months are visible
        numberOfMonths: 1,

        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
        // only used for the first display or when a selected date is not visible
        mainCalendar: 'left',

        // Specify a DOM element to render the calendar in
        container: undefined,

        // Blur field when date is selected
        blurFieldOnSelect : true,

        // internationalization
        i18n: {
            previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',
            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
        },

        // Theme Classname
        theme: null,

        // events array
        events: [],

        // callback function
        onSelect: null,
        onOpen: null,
        onClose: null,
        onDraw: null
    },


    /**
     * templating functions to abstract HTML rendering
     */
    renderDayName = function(opts, day, abbr)
    {
        day += opts.firstDay;
        while (day >= 7) {
            day -= 7;
        }
        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
    },

    renderDay = function(opts)
    {
        var arr = [];
        var ariaSelected = 'false';
        if (opts.isEmpty) {
            if (opts.showDaysInNextAndPreviousMonths) {
                arr.push('is-outside-current-month');

                if(!opts.enableSelectionDaysInNextAndPreviousMonths) {
                    arr.push('is-selection-disabled');
                }

            } else {
                return '<td class="is-empty"></td>';
            }
        }
        if (opts.isDisabled) {
            arr.push('is-disabled');
        }
        if (opts.isToday) {
            arr.push('is-today');
        }
        if (opts.isSelected) {
            arr.push('is-selected');
            ariaSelected = 'true';
        }
        if (opts.hasEvent) {
            arr.push('has-event');
        }
        if (opts.isInRange) {
            arr.push('is-inrange');
        }
        if (opts.isStartRange) {
            arr.push('is-startrange');
        }
        if (opts.isEndRange) {
            arr.push('is-endrange');
        }
        return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '" aria-selected="' + ariaSelected + '">' +
                 '<button class="pika-button pika-day" type="button" ' +
                    'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' +
                        opts.day +
                 '</button>' +
               '</td>';
    },

    renderWeek = function (d, m, y) {
        // Lifted from http://javascript.about.com/library/blweekyear.htm, lightly modified.
        var onejan = new Date(y, 0, 1),
            weekNum = Math.ceil((((new Date(y, m, d) - onejan) / 86400000) + onejan.getDay()+1)/7);
        return '<td class="pika-week">' + weekNum + '</td>';
    },

    renderRow = function(days, isRTL, pickWholeWeek, isRowSelected)
    {
        return '<tr class="pika-row' + (pickWholeWeek ? ' pick-whole-week' : '') + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
    },

    renderBody = function(rows)
    {
        return '<tbody>' + rows.join('') + '</tbody>';
    },

    renderHead = function(opts)
    {
        var i, arr = [];
        if (opts.showWeekNumber) {
            arr.push('<th></th>');
        }
        for (i = 0; i < 7; i++) {
            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
        }
        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
    },

    renderTitle = function(instance, c, year, month, refYear, randId)
    {
        var i, j, arr,
            opts = instance._o,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="pika-title" role="heading" aria-live="assertive">',
            monthHtml,
            yearHtml,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
                (i === month ? ' selected="selected"': '') +
                ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? 'disabled="disabled"' : '') + '>' +
                opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';

        if (isArray(opts.yearRange)) {
            i = opts.yearRange[0];
            j = opts.yearRange[1] + 1;
        } else {
            i = year - opts.yearRange;
            j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
            if (i >= opts.minYear) {
                arr.push('<option value="' + i + '"' + (i === year ? ' selected="selected"': '') + '>' + (i) + '</option>');
            }
        }
        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';

        if (opts.showMonthAfterYear) {
            html += yearHtml + monthHtml;
        } else {
            html += monthHtml + yearHtml;
        }

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
            prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
            next = false;
        }

        if (c === 0) {
            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
        }
        if (c === (instance._o.numberOfMonths - 1) ) {
            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
        }

        return html += '</div>';
    },

    renderTable = function(opts, data, randId)
    {
        return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + randId + '">' + renderHead(opts) + renderBody(data) + '</table>';
    },


    /**
     * Pikaday constructor
     */
    Pikaday = function(options)
    {
        var self = this,
            opts = self.config(options);

        self._onMouseDown = function(e)
        {
            if (!self._v) {
                return;
            }
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }

            if (!hasClass(target, 'is-disabled')) {
                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty') && !hasClass(target.parentNode, 'is-disabled')) {
                    self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
                    if (opts.bound) {
                        sto(function() {
                            self.hide();
                            if (opts.blurFieldOnSelect && opts.field) {
                                opts.field.blur();
                            }
                        }, 100);
                    }
                }
                else if (hasClass(target, 'pika-prev')) {
                    self.prevMonth();
                }
                else if (hasClass(target, 'pika-next')) {
                    self.nextMonth();
                }
            }
            if (!hasClass(target, 'pika-select')) {
                // if this is touch event prevent mouse events emulation
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                    return false;
                }
            } else {
                self._c = true;
            }
        };

        self._onChange = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }
            if (hasClass(target, 'pika-select-month')) {
                self.gotoMonth(target.value);
            }
            else if (hasClass(target, 'pika-select-year')) {
                self.gotoYear(target.value);
            }
        };

        self._onKeyChange = function(e)
        {
            e = e || window.event;

            if (self.isVisible()) {

                switch(e.keyCode){
                    case 13:
                    case 27:
                        if (opts.field) {
                            opts.field.blur();
                        }
                        break;
                    case 37:
                        e.preventDefault();
                        self.adjustDate('subtract', 1);
                        break;
                    case 38:
                        self.adjustDate('subtract', 7);
                        break;
                    case 39:
                        self.adjustDate('add', 1);
                        break;
                    case 40:
                        self.adjustDate('add', 7);
                        break;
                }
            }
        };

        self._onInputChange = function(e)
        {
            var date;

            if (e.firedBy === self) {
                return;
            }
            if (opts.parse) {
                date = opts.parse(opts.field.value, opts.format);
            } else if (hasMoment) {
                date = moment(opts.field.value, opts.format, opts.formatStrict);
                date = (date && date.isValid()) ? date.toDate() : null;
            }
            else {
                date = new Date(Date.parse(opts.field.value));
            }
            if (isDate(date)) {
              self.setDate(date);
            }
            if (!self._v) {
                self.show();
            }
        };

        self._onInputFocus = function()
        {
            self.show();
        };

        self._onInputClick = function()
        {
            self.show();
        };

        self._onInputBlur = function()
        {
            // IE allows pika div to gain focus; catch blur the input field
            var pEl = document.activeElement;
            do {
                if (hasClass(pEl, 'pika-single')) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));

            if (!self._c) {
                self._b = sto(function() {
                    self.hide();
                }, 50);
            }
            self._c = false;
        };

        self._onClick = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement,
                pEl = target;
            if (!target) {
                return;
            }
            if (!hasEventListeners && hasClass(target, 'pika-select')) {
                if (!target.onchange) {
                    target.setAttribute('onchange', 'return;');
                    addEvent(target, 'change', self._onChange);
                }
            }
            do {
                if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));
            if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
                self.hide();
            }
        };

        self.el = document.createElement('div');
        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');

        addEvent(self.el, 'mousedown', self._onMouseDown, true);
        addEvent(self.el, 'touchend', self._onMouseDown, true);
        addEvent(self.el, 'change', self._onChange);
        addEvent(document, 'keydown', self._onKeyChange);

        if (opts.field) {
            if (opts.container) {
                opts.container.appendChild(self.el);
            } else if (opts.bound) {
                document.body.appendChild(self.el);
            } else {
                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
            }
            addEvent(opts.field, 'change', self._onInputChange);

            if (!opts.defaultDate) {
                if (hasMoment && opts.field.value) {
                    opts.defaultDate = moment(opts.field.value, opts.format).toDate();
                } else {
                    opts.defaultDate = new Date(Date.parse(opts.field.value));
                }
                opts.setDefaultDate = true;
            }
        }

        var defDate = opts.defaultDate;

        if (isDate(defDate)) {
            if (opts.setDefaultDate) {
                self.setDate(defDate, true);
            } else {
                self.gotoDate(defDate);
            }
        } else {
            self.gotoDate(new Date());
        }

        if (opts.bound) {
            this.hide();
            self.el.className += ' is-bound';
            addEvent(opts.trigger, 'click', self._onInputClick);
            addEvent(opts.trigger, 'focus', self._onInputFocus);
            addEvent(opts.trigger, 'blur', self._onInputBlur);
        } else {
            this.show();
        }
    };


    /**
     * public Pikaday API
     */
    Pikaday.prototype = {


        /**
         * configure functionality
         */
        config: function(options)
        {
            if (!this._o) {
                this._o = extend({}, defaults, true);
            }

            var opts = extend(this._o, options, true);

            opts.isRTL = !!opts.isRTL;

            opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;

            opts.theme = (typeof opts.theme) === 'string' && opts.theme ? opts.theme : null;

            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);

            opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;

            opts.disableWeekends = !!opts.disableWeekends;

            opts.disableDayFn = (typeof opts.disableDayFn) === 'function' ? opts.disableDayFn : null;

            var nom = parseInt(opts.numberOfMonths, 10) || 1;
            opts.numberOfMonths = nom > 4 ? 4 : nom;

            if (!isDate(opts.minDate)) {
                opts.minDate = false;
            }
            if (!isDate(opts.maxDate)) {
                opts.maxDate = false;
            }
            if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
                opts.maxDate = opts.minDate = false;
            }
            if (opts.minDate) {
                this.setMinDate(opts.minDate);
            }
            if (opts.maxDate) {
                this.setMaxDate(opts.maxDate);
            }

            if (isArray(opts.yearRange)) {
                var fallback = new Date().getFullYear() - 10;
                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
            } else {
                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
                if (opts.yearRange > 100) {
                    opts.yearRange = 100;
                }
            }

            return opts;
        },

        /**
         * return a formatted string of the current selection (using Moment.js if available)
         */
        toString: function(format)
        {
            format = format || this._o.format;
            if (!isDate(this._d)) {
                return '';
            }
            if (this._o.toString) {
              return this._o.toString(this._d, format);
            }
            if (hasMoment) {
              return moment(this._d).format(format);
            }
            return this._d.toDateString();
        },

        /**
         * return a Moment.js object of the current selection (if available)
         */
        getMoment: function()
        {
            return hasMoment ? moment(this._d) : null;
        },

        /**
         * set the current selection from a Moment.js object (if available)
         */
        setMoment: function(date, preventOnSelect)
        {
            if (hasMoment && moment.isMoment(date)) {
                this.setDate(date.toDate(), preventOnSelect);
            }
        },

        /**
         * return a Date object of the current selection
         */
        getDate: function()
        {
            return isDate(this._d) ? new Date(this._d.getTime()) : null;
        },

        /**
         * set the current selection
         */
        setDate: function(date, preventOnSelect)
        {
            if (!date) {
                this._d = null;

                if (this._o.field) {
                    this._o.field.value = '';
                    fireEvent(this._o.field, 'change', { firedBy: this });
                }

                return this.draw();
            }
            if (typeof date === 'string') {
                date = new Date(Date.parse(date));
            }
            if (!isDate(date)) {
                return;
            }

            var min = this._o.minDate,
                max = this._o.maxDate;

            if (isDate(min) && date < min) {
                date = min;
            } else if (isDate(max) && date > max) {
                date = max;
            }

            this._d = new Date(date.getTime());
            setToStartOfDay(this._d);
            this.gotoDate(this._d);

            if (this._o.field) {
                this._o.field.value = this.toString();
                fireEvent(this._o.field, 'change', { firedBy: this });
            }
            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
                this._o.onSelect.call(this, this.getDate());
            }
        },

        /**
         * change view to a specific date
         */
        gotoDate: function(date)
        {
            var newCalendar = true;

            if (!isDate(date)) {
                return;
            }

            if (this.calendars) {
                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
                    lastVisibleDate = new Date(this.calendars[this.calendars.length-1].year, this.calendars[this.calendars.length-1].month, 1),
                    visibleDate = date.getTime();
                // get the end of the month
                lastVisibleDate.setMonth(lastVisibleDate.getMonth()+1);
                lastVisibleDate.setDate(lastVisibleDate.getDate()-1);
                newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
            }

            if (newCalendar) {
                this.calendars = [{
                    month: date.getMonth(),
                    year: date.getFullYear()
                }];
                if (this._o.mainCalendar === 'right') {
                    this.calendars[0].month += 1 - this._o.numberOfMonths;
                }
            }

            this.adjustCalendars();
        },

        adjustDate: function(sign, days) {

            var day = this.getDate() || new Date();
            var difference = parseInt(days)*24*60*60*1000;

            var newDay;

            if (sign === 'add') {
                newDay = new Date(day.valueOf() + difference);
            } else if (sign === 'subtract') {
                newDay = new Date(day.valueOf() - difference);
            }

            this.setDate(newDay);
        },

        adjustCalendars: function() {
            this.calendars[0] = adjustCalendar(this.calendars[0]);
            for (var c = 1; c < this._o.numberOfMonths; c++) {
                this.calendars[c] = adjustCalendar({
                    month: this.calendars[0].month + c,
                    year: this.calendars[0].year
                });
            }
            this.draw();
        },

        gotoToday: function()
        {
            this.gotoDate(new Date());
        },

        /**
         * change view to a specific month (zero-index, e.g. 0: January)
         */
        gotoMonth: function(month)
        {
            if (!isNaN(month)) {
                this.calendars[0].month = parseInt(month, 10);
                this.adjustCalendars();
            }
        },

        nextMonth: function()
        {
            this.calendars[0].month++;
            this.adjustCalendars();
        },

        prevMonth: function()
        {
            this.calendars[0].month--;
            this.adjustCalendars();
        },

        /**
         * change view to a specific full year (e.g. "2012")
         */
        gotoYear: function(year)
        {
            if (!isNaN(year)) {
                this.calendars[0].year = parseInt(year, 10);
                this.adjustCalendars();
            }
        },

        /**
         * change the minDate
         */
        setMinDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.minDate = value;
                this._o.minYear  = value.getFullYear();
                this._o.minMonth = value.getMonth();
            } else {
                this._o.minDate = defaults.minDate;
                this._o.minYear  = defaults.minYear;
                this._o.minMonth = defaults.minMonth;
                this._o.startRange = defaults.startRange;
            }

            this.draw();
        },

        /**
         * change the maxDate
         */
        setMaxDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.maxDate = value;
                this._o.maxYear = value.getFullYear();
                this._o.maxMonth = value.getMonth();
            } else {
                this._o.maxDate = defaults.maxDate;
                this._o.maxYear = defaults.maxYear;
                this._o.maxMonth = defaults.maxMonth;
                this._o.endRange = defaults.endRange;
            }

            this.draw();
        },

        setStartRange: function(value)
        {
            this._o.startRange = value;
        },

        setEndRange: function(value)
        {
            this._o.endRange = value;
        },

        /**
         * refresh the HTML
         */
        draw: function(force)
        {
            if (!this._v && !force) {
                return;
            }
            var opts = this._o,
                minYear = opts.minYear,
                maxYear = opts.maxYear,
                minMonth = opts.minMonth,
                maxMonth = opts.maxMonth,
                html = '',
                randId;

            if (this._y <= minYear) {
                this._y = minYear;
                if (!isNaN(minMonth) && this._m < minMonth) {
                    this._m = minMonth;
                }
            }
            if (this._y >= maxYear) {
                this._y = maxYear;
                if (!isNaN(maxMonth) && this._m > maxMonth) {
                    this._m = maxMonth;
                }
            }

            randId = 'pika-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);

            for (var c = 0; c < opts.numberOfMonths; c++) {
                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId) + '</div>';
            }

            this.el.innerHTML = html;

            if (opts.bound) {
                if(opts.field.type !== 'hidden') {
                    sto(function() {
                        opts.trigger.focus();
                    }, 1);
                }
            }

            if (typeof this._o.onDraw === 'function') {
                this._o.onDraw(this);
            }

            if (opts.bound) {
                // let the screen reader user know to use arrow keys
                opts.field.setAttribute('aria-label', 'Use the arrow keys to pick a date');
            }
        },

        adjustPosition: function()
        {
            var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect;

            if (this._o.container) return;

            this.el.style.position = 'absolute';

            field = this._o.trigger;
            pEl = field;
            width = this.el.offsetWidth;
            height = this.el.offsetHeight;
            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;

            if (typeof field.getBoundingClientRect === 'function') {
                clientRect = field.getBoundingClientRect();
                left = clientRect.left + window.pageXOffset;
                top = clientRect.bottom + window.pageYOffset;
            } else {
                left = pEl.offsetLeft;
                top  = pEl.offsetTop + pEl.offsetHeight;
                while((pEl = pEl.offsetParent)) {
                    left += pEl.offsetLeft;
                    top  += pEl.offsetTop;
                }
            }

            // default position is bottom & left
            if ((this._o.reposition && left + width > viewportWidth) ||
                (
                    this._o.position.indexOf('right') > -1 &&
                    left - width + field.offsetWidth > 0
                )
            ) {
                left = left - width + field.offsetWidth;
            }
            if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
                (
                    this._o.position.indexOf('top') > -1 &&
                    top - height - field.offsetHeight > 0
                )
            ) {
                top = top - height - field.offsetHeight;
            }

            this.el.style.left = left + 'px';
            this.el.style.top = top + 'px';
        },

        /**
         * render HTML for a particular month
         */
        render: function(year, month, randId)
        {
            var opts   = this._o,
                now    = new Date(),
                days   = getDaysInMonth(year, month),
                before = new Date(year, month, 1).getDay(),
                data   = [],
                row    = [];
            setToStartOfDay(now);
            if (opts.firstDay > 0) {
                before -= opts.firstDay;
                if (before < 0) {
                    before += 7;
                }
            }
            var previousMonth = month === 0 ? 11 : month - 1,
                nextMonth = month === 11 ? 0 : month + 1,
                yearOfPreviousMonth = month === 0 ? year - 1 : year,
                yearOfNextMonth = month === 11 ? year + 1 : year,
                daysInPreviousMonth = getDaysInMonth(yearOfPreviousMonth, previousMonth);
            var cells = days + before,
                after = cells;
            while(after > 7) {
                after -= 7;
            }
            cells += 7 - after;
            var isWeekSelected = false;
            for (var i = 0, r = 0; i < cells; i++)
            {
                var day = new Date(year, month, 1 + (i - before)),
                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
                    isToday = compareDates(day, now),
                    hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false,
                    isEmpty = i < before || i >= (days + before),
                    dayNumber = 1 + (i - before),
                    monthNumber = month,
                    yearNumber = year,
                    isStartRange = opts.startRange && compareDates(opts.startRange, day),
                    isEndRange = opts.endRange && compareDates(opts.endRange, day),
                    isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
                    isDisabled = (opts.minDate && day < opts.minDate) ||
                                 (opts.maxDate && day > opts.maxDate) ||
                                 (opts.disableWeekends && isWeekend(day)) ||
                                 (opts.disableDayFn && opts.disableDayFn(day));

                if (isEmpty) {
                    if (i < before) {
                        dayNumber = daysInPreviousMonth + dayNumber;
                        monthNumber = previousMonth;
                        yearNumber = yearOfPreviousMonth;
                    } else {
                        dayNumber = dayNumber - days;
                        monthNumber = nextMonth;
                        yearNumber = yearOfNextMonth;
                    }
                }

                var dayConfig = {
                        day: dayNumber,
                        month: monthNumber,
                        year: yearNumber,
                        hasEvent: hasEvent,
                        isSelected: isSelected,
                        isToday: isToday,
                        isDisabled: isDisabled,
                        isEmpty: isEmpty,
                        isStartRange: isStartRange,
                        isEndRange: isEndRange,
                        isInRange: isInRange,
                        showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths,
                        enableSelectionDaysInNextAndPreviousMonths: opts.enableSelectionDaysInNextAndPreviousMonths
                    };

                if (opts.pickWholeWeek && isSelected) {
                    isWeekSelected = true;
                }

                row.push(renderDay(dayConfig));

                if (++r === 7) {
                    if (opts.showWeekNumber) {
                        row.unshift(renderWeek(i - before, month, year));
                    }
                    data.push(renderRow(row, opts.isRTL, opts.pickWholeWeek, isWeekSelected));
                    row = [];
                    r = 0;
                    isWeekSelected = false;
                }
            }
            return renderTable(opts, data, randId);
        },

        isVisible: function()
        {
            return this._v;
        },

        show: function()
        {
            if (!this.isVisible()) {
                this._v = true;
                this.draw();
                removeClass(this.el, 'is-hidden');
                if (this._o.bound) {
                    addEvent(document, 'click', this._onClick);
                    this.adjustPosition();
                }
                if (typeof this._o.onOpen === 'function') {
                    this._o.onOpen.call(this);
                }
            }
        },

        hide: function()
        {
            var v = this._v;
            if (v !== false) {
                if (this._o.bound) {
                    removeEvent(document, 'click', this._onClick);
                }
                this.el.style.position = 'static'; // reset
                this.el.style.left = 'auto';
                this.el.style.top = 'auto';
                addClass(this.el, 'is-hidden');
                this._v = false;
                if (v !== undefined && typeof this._o.onClose === 'function') {
                    this._o.onClose.call(this);
                }
            }
        },

        /**
         * GAME OVER
         */
        destroy: function()
        {
            this.hide();
            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
            removeEvent(this.el, 'touchend', this._onMouseDown, true);
            removeEvent(this.el, 'change', this._onChange);
            removeEvent(document, 'keydown', this._onKeyChange);
            if (this._o.field) {
                removeEvent(this._o.field, 'change', this._onInputChange);
                if (this._o.bound) {
                    removeEvent(this._o.trigger, 'click', this._onInputClick);
                    removeEvent(this._o.trigger, 'focus', this._onInputFocus);
                    removeEvent(this._o.trigger, 'blur', this._onInputBlur);
                }
            }
            if (this.el.parentNode) {
                this.el.parentNode.removeChild(this.el);
            }
        }

    };

    return Pikaday;

}));


/***/ }),

/***/ "../../../node_modules/visibilityjs/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../../../node_modules/visibilityjs/lib/visibility.timers.js")


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.core.js":
/***/ (function(module, exports) {

;(function (global) {
    "use strict";

    var lastId = -1;

    // Visibility.js allow you to know, that your web page is in the background
    // tab and thus not visible to the user. This library is wrap under
    // Page Visibility API. It fix problems with different vendor prefixes and
    // add high-level useful functions.
    var self = {

        // Call callback only when page become to visible for user or
        // call it now if page is visible now or Page Visibility API
        // doesn’t supported.
        //
        // Return false if API isn’t supported, true if page is already visible
        // or listener ID (you can use it in `unbind` method) if page isn’t
        // visible now.
        //
        //   Visibility.onVisible(function () {
        //       startIntroAnimation();
        //   });
        onVisible: function (callback) {
            var support = self.isSupported();
            if ( !support || !self.hidden() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( !self.hidden() ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Call callback when visibility will be changed. First argument for
        // callback will be original event object, second will be visibility
        // state name.
        //
        // Return listener ID to unbind listener by `unbind` method.
        //
        // If Page Visibility API doesn’t supported method will be return false
        // and callback never will be called.
        //
        //   Visibility.change(function(e, state) {
        //       Statistics.visibilityChange(state);
        //   });
        //
        // It is just proxy to `visibilitychange` event, but use vendor prefix.
        change: function (callback) {
            if ( !self.isSupported() ) {
                return false;
            }
            lastId += 1;
            var number = lastId;
            self._callbacks[number] = callback;
            self._listen();
            return number;
        },

        // Remove `change` listener by it ID.
        //
        //   var id = Visibility.change(function(e, state) {
        //       firstChangeCallback();
        //       Visibility.unbind(id);
        //   });
        unbind: function (id) {
            delete self._callbacks[id];
        },

        // Call `callback` in any state, expect “prerender”. If current state
        // is “prerender” it will wait until state will be changed.
        // If Page Visibility API doesn’t supported, it will call `callback`
        // immediately.
        //
        // Return false if API isn’t supported, true if page is already after
        // prerendering or listener ID (you can use it in `unbind` method)
        // if page is prerended now.
        //
        //   Visibility.afterPrerendering(function () {
        //       Statistics.countVisitor();
        //   });
        afterPrerendering: function (callback) {
            var support   = self.isSupported();
            var prerender = 'prerender';

            if ( !support || prerender != self.state() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( prerender != state ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Return true if page now isn’t visible to user.
        //
        //   if ( !Visibility.hidden() ) {
        //       VideoPlayer.play();
        //   }
        //
        // It is just proxy to `document.hidden`, but use vendor prefix.
        hidden: function () {
            return !!(self._doc.hidden || self._doc.webkitHidden);
        },

        // Return visibility state: 'visible', 'hidden' or 'prerender'.
        //
        //   if ( 'prerender' == Visibility.state() ) {
        //       Statistics.pageIsPrerendering();
        //   }
        //
        // Don’t use `Visibility.state()` to detect, is page visible, because
        // visibility states can extend in next API versions.
        // Use more simpler and general `Visibility.hidden()` for this cases.
        //
        // It is just proxy to `document.visibilityState`, but use
        // vendor prefix.
        state: function () {
            return self._doc.visibilityState       ||
                   self._doc.webkitVisibilityState ||
                   'visible';
        },

        // Return true if browser support Page Visibility API.
        //
        //   if ( Visibility.isSupported() ) {
        //       Statistics.startTrackingVisibility();
        //       Visibility.change(function(e, state)) {
        //           Statistics.trackVisibility(state);
        //       });
        //   }
        isSupported: function () {
            return !!(self._doc.visibilityState ||
                      self._doc.webkitVisibilityState);
        },

        // Link to document object to change it in tests.
        _doc: document || {},

        // Callbacks from `change` method, that wait visibility changes.
        _callbacks: { },

        // Listener for `visibilitychange` event.
        _change: function(event) {
            var state = self.state();

            for ( var i in self._callbacks ) {
                self._callbacks[i].call(self._doc, event, state);
            }
        },

        // Set listener for `visibilitychange` event.
        _listen: function () {
            if ( self._init ) {
                return;
            }

            var event = 'visibilitychange';
            if ( self._doc.webkitVisibilityState ) {
                event = 'webkit' + event;
            }

            var listener = function () {
                self._change.apply(self, arguments);
            };
            if ( self._doc.addEventListener ) {
                self._doc.addEventListener(event, listener);
            } else {
                self._doc.attachEvent(event, listener);
            }
            self._init = true;
        }

    };

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = self;
    } else {
        global.Visibility = self;
    }

})(this);


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.timers.js":
/***/ (function(module, exports, __webpack_require__) {

;(function (window) {
    "use strict";

    var lastTimer = -1;

    var install = function (Visibility) {

        // Run callback every `interval` milliseconds if page is visible and
        // every `hiddenInterval` milliseconds if page is hidden.
        //
        //   Visibility.every(60 * 1000, 5 * 60 * 1000, function () {
        //       checkNewMails();
        //   });
        //
        // You can skip `hiddenInterval` and callback will be called only if
        // page is visible.
        //
        //   Visibility.every(1000, function () {
        //       updateCountdown();
        //   });
        //
        // It is analog of `setInterval(callback, interval)` but use visibility
        // state.
        //
        // It return timer ID, that you can use in `Visibility.stop(id)` to stop
        // timer (`clearInterval` analog).
        // Warning: timer ID is different from interval ID from `setInterval`,
        // so don’t use it in `clearInterval`.
        //
        // On change state from hidden to visible timers will be execute.
        Visibility.every = function (interval, hiddenInterval, callback) {
            Visibility._time();

            if ( !callback ) {
                callback = hiddenInterval;
                hiddenInterval = null;
            }

            lastTimer += 1;
            var number = lastTimer;

            Visibility._timers[number] = {
                visible:  interval,
                hidden:   hiddenInterval,
                callback: callback
            };
            Visibility._run(number, false);

            if ( Visibility.isSupported() ) {
                Visibility._listen();
            }
            return number;
        };

        // Stop timer from `every` method by it ID (`every` method return it).
        //
        //   slideshow = Visibility.every(5 * 1000, function () {
        //       changeSlide();
        //   });
        //   $('.stopSlideshow').click(function () {
        //       Visibility.stop(slideshow);
        //   });
        Visibility.stop = function(id) {
            if ( !Visibility._timers[id] ) {
                return false;
            }
            Visibility._stop(id);
            delete Visibility._timers[id];
            return true;
        };

        // Callbacks and intervals added by `every` method.
        Visibility._timers = { };

        // Initialize variables on page loading.
        Visibility._time = function () {
            if ( Visibility._timed ) {
                return;
            }
            Visibility._timed     = true;
            Visibility._wasHidden = Visibility.hidden();

            Visibility.change(function () {
                Visibility._stopRun();
                Visibility._wasHidden = Visibility.hidden();
            });
        };

        // Try to run timer from every method by it’s ID. It will be use
        // `interval` or `hiddenInterval` depending on visibility state.
        // If page is hidden and `hiddenInterval` is null,
        // it will not run timer.
        //
        // Argument `runNow` say, that timers must be execute now too.
        Visibility._run = function (id, runNow) {
            var interval,
                timer = Visibility._timers[id];

            if ( Visibility.hidden() ) {
                if ( null === timer.hidden ) {
                    return;
                }
                interval = timer.hidden;
            } else {
                interval = timer.visible;
            }

            var runner = function () {
                timer.last = new Date();
                timer.callback.call(window);
            }

            if ( runNow ) {
                var now  = new Date();
                var last = now - timer.last ;

                if ( interval > last ) {
                    timer.delay = setTimeout(function () {
                        timer.id = setInterval(runner, interval);
                        runner();
                    }, interval - last);
                } else {
                    timer.id = setInterval(runner, interval);
                    runner();
                }

            } else {
              timer.id = setInterval(runner, interval);
            }
        };

        // Stop timer from `every` method by it’s ID.
        Visibility._stop = function (id) {
            var timer = Visibility._timers[id];
            clearInterval(timer.id);
            clearTimeout(timer.delay);
            delete timer.id;
            delete timer.delay;
        };

        // Listener for `visibilitychange` event.
        Visibility._stopRun = function (event) {
            var isHidden  = Visibility.hidden(),
                wasHidden = Visibility._wasHidden;

            if ( (isHidden && !wasHidden) || (!isHidden && wasHidden) ) {
                for ( var i in Visibility._timers ) {
                    Visibility._stop(i);
                    Visibility._run(i, !isHidden);
                }
            }
        };

        return Visibility;
    }

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = install(__webpack_require__("../../../node_modules/visibilityjs/lib/visibility.core.js"));
    } else {
        install(window.Visibility)
    }

})(window);


/***/ }),

/***/ "../../../node_modules/vuex/dist/vuex.esm.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapState; });
/* unused harmony export mapMutations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapActions; });
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v3.0.1
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.0.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/***/ }),

/***/ "../../../node_modules/webpack/buildin/module.js":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "../../views/shared/icons/_ellipsis_v.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1600 1600\"><path d=\"M1088 1248v192q0 40-28 68t-68 28H800q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28H800q-40 0-68-28t-28-68V736q0-40 28-68t68-28h192q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28H800q-40 0-68-28t-28-68V224q0-40 28-68t68-28h192q40 0 68 28t28 68z\"/></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_emoji_slightly_smiling_face.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.29 11.098a4.328 4.328 0 0 1-1.618 2.285c-.79.578-1.68.867-2.672.867-.992 0-1.883-.29-2.672-.867a4.328 4.328 0 0 1-1.617-2.285.721.721 0 0 1 .047-.569.715.715 0 0 1 .445-.369.721.721 0 0 1 .568.047.715.715 0 0 1 .37.445c.195.625.556 1.131 1.084 1.518A2.93 2.93 0 0 0 9 12.75a2.93 2.93 0 0 0 1.775-.58 2.913 2.913 0 0 0 1.084-1.518.711.711 0 0 1 .375-.445.737.737 0 0 1 .575-.047c.195.063.34.186.433.37.094.183.11.372.047.568zM7.5 6c0 .414-.146.768-.44 1.06-.292.294-.646.44-1.06.44-.414 0-.768-.146-1.06-.44A1.445 1.445 0 0 1 4.5 6c0-.414.146-.768.44-1.06.292-.294.646-.44 1.06-.44.414 0 .768.146 1.06.44.294.292.44.646.44 1.06zm6 0c0 .414-.146.768-.44 1.06-.292.294-.646.44-1.06.44-.414 0-.768-.146-1.06-.44A1.445 1.445 0 0 1 10.5 6c0-.414.146-.768.44-1.06.292-.294.646-.44 1.06-.44.414 0 .768.146 1.06.44.294.292.44.646.44 1.06zm3 3a7.29 7.29 0 0 0-.598-2.912 7.574 7.574 0 0 0-1.6-2.39 7.574 7.574 0 0 0-2.39-1.6A7.29 7.29 0 0 0 9 1.5a7.29 7.29 0 0 0-2.912.598 7.574 7.574 0 0 0-2.39 1.6 7.574 7.574 0 0 0-1.6 2.39A7.29 7.29 0 0 0 1.5 9c0 1.016.2 1.986.598 2.912a7.574 7.574 0 0 0 1.6 2.39 7.574 7.574 0 0 0 2.39 1.6A7.29 7.29 0 0 0 9 16.5a7.29 7.29 0 0 0 2.912-.598 7.574 7.574 0 0 0 2.39-1.6 7.574 7.574 0 0 0 1.6-2.39A7.29 7.29 0 0 0 16.5 9zM18 9a8.804 8.804 0 0 1-1.207 4.518 8.96 8.96 0 0 1-3.275 3.275A8.804 8.804 0 0 1 9 18a8.804 8.804 0 0 1-4.518-1.207 8.96 8.96 0 0 1-3.275-3.275A8.804 8.804 0 0 1 0 9c0-1.633.402-3.139 1.207-4.518a8.96 8.96 0 0 1 3.275-3.275A8.804 8.804 0 0 1 9 0c1.633 0 3.139.402 4.518 1.207a8.96 8.96 0 0 1 3.275 3.275A8.804 8.804 0 0 1 18 9z\" fill-rule=\"evenodd\"/></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_emoji_smile.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.29 11.098a4.328 4.328 0 0 1-1.618 2.285c-.79.578-1.68.867-2.672.867-.992 0-1.883-.29-2.672-.867a4.328 4.328 0 0 1-1.617-2.285.721.721 0 0 1 .047-.569.715.715 0 0 1 .445-.369c.195-.062 7.41-.062 7.606 0 .195.063.34.186.433.37.094.183.11.372.047.568zM14 6.37c0 .398-.04.755-.513.755-.473 0-.498-.272-1.237-.272-.74 0-.74.215-1.165.215-.425 0-.585-.3-.585-.698 0-.397.17-.736.513-1.017.341-.281.754-.422 1.237-.422.483 0 .896.14 1.237.422.342.28.513.62.513 1.017zm-6.5 0c0 .398-.04.755-.513.755-.473 0-.498-.272-1.237-.272-.74 0-.74.215-1.165.215-.425 0-.585-.3-.585-.698 0-.397.17-.736.513-1.017.341-.281.754-.422 1.237-.422.483 0 .896.14 1.237.422.342.28.513.62.513 1.017zm9 2.63a7.29 7.29 0 0 0-.598-2.912 7.574 7.574 0 0 0-1.6-2.39 7.574 7.574 0 0 0-2.39-1.6A7.29 7.29 0 0 0 9 1.5a7.29 7.29 0 0 0-2.912.598 7.574 7.574 0 0 0-2.39 1.6 7.574 7.574 0 0 0-1.6 2.39A7.29 7.29 0 0 0 1.5 9c0 1.016.2 1.986.598 2.912a7.574 7.574 0 0 0 1.6 2.39 7.574 7.574 0 0 0 2.39 1.6A7.29 7.29 0 0 0 9 16.5a7.29 7.29 0 0 0 2.912-.598 7.574 7.574 0 0 0 2.39-1.6 7.574 7.574 0 0 0 1.6-2.39A7.29 7.29 0 0 0 16.5 9zM18 9a8.804 8.804 0 0 1-1.207 4.518 8.96 8.96 0 0 1-3.275 3.275A8.804 8.804 0 0 1 9 18a8.804 8.804 0 0 1-4.518-1.207 8.96 8.96 0 0 1-3.275-3.275A8.804 8.804 0 0 1 0 9c0-1.633.402-3.139 1.207-4.518a8.96 8.96 0 0 1 3.275-3.275A8.804 8.804 0 0 1 9 0c1.633 0 3.139.402 4.518 1.207a8.96 8.96 0 0 1 3.275 3.275A8.804 8.804 0 0 1 18 9z\" fill-rule=\"evenodd\"/></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_emoji_smiley.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.29 11.098a4.328 4.328 0 0 1-1.618 2.285c-.79.578-1.68.867-2.672.867-.992 0-1.883-.29-2.672-.867a4.328 4.328 0 0 1-1.617-2.285.721.721 0 0 1 .047-.569.715.715 0 0 1 .445-.369c.195-.062 7.41-.062 7.606 0 .195.063.34.186.433.37.094.183.11.372.047.568h.001zM7.5 6c0 .414-.146.768-.44 1.06A1.44 1.44 0 0 1 6 7.5a1.44 1.44 0 0 1-1.06-.44A1.445 1.445 0 0 1 4.5 6c0-.414.146-.768.44-1.06A1.44 1.44 0 0 1 6 4.5c.414 0 .768.146 1.06.44.294.292.44.646.44 1.06zm6 0c0 .414-.146.768-.44 1.06A1.44 1.44 0 0 1 12 7.5a1.44 1.44 0 0 1-1.06-.44A1.445 1.445 0 0 1 10.5 6c0-.414.146-.768.44-1.06A1.44 1.44 0 0 1 12 4.5c.414 0 .768.146 1.06.44.294.292.44.646.44 1.06zm3 3a7.29 7.29 0 0 0-.598-2.912 7.574 7.574 0 0 0-1.6-2.39 7.574 7.574 0 0 0-2.39-1.6A7.29 7.29 0 0 0 9 1.5a7.29 7.29 0 0 0-2.912.598 7.574 7.574 0 0 0-2.39 1.6 7.574 7.574 0 0 0-1.6 2.39A7.29 7.29 0 0 0 1.5 9c0 1.016.2 1.986.598 2.912a7.574 7.574 0 0 0 1.6 2.39 7.574 7.574 0 0 0 2.39 1.6c.92.397 1.91.6 2.912.598a7.29 7.29 0 0 0 2.912-.598 7.574 7.574 0 0 0 2.39-1.6 7.574 7.574 0 0 0 1.6-2.39c.397-.92.6-1.91.598-2.912zM18 9a8.804 8.804 0 0 1-1.207 4.518 8.96 8.96 0 0 1-3.275 3.275A8.804 8.804 0 0 1 9 18a8.804 8.804 0 0 1-4.518-1.207 8.96 8.96 0 0 1-3.275-3.275A8.804 8.804 0 0 1 0 9c0-1.633.402-3.139 1.207-4.518a8.96 8.96 0 0 1 3.275-3.275A8.804 8.804 0 0 1 9 0c1.633 0 3.139.402 4.518 1.207a8.96 8.96 0 0 1 3.275 3.275A8.804 8.804 0 0 1 18 9z\" fill-rule=\"nonzero\"/></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_commit.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><path d=\"M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3.876-1.008a4.002 4.002 0 0 1-7.752 0A1.01 1.01 0 0 1 4 9H1a1 1 0 1 1 0-2h3c.042 0 .083.003.124.008a4.002 4.002 0 0 1 7.752 0A1.01 1.01 0 0 1 12 7h3a1 1 0 0 1 0 2h-3a1.01 1.01 0 0 1-.124-.008z\"/></svg>\n\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_mr_issue.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><g fill-rule=\"evenodd\"><path d=\"m8.411 1.012c-.136-.008-.273-.012-.411-.012-3.866 0-7 3.134-7 7 0 3.866 3.134 7 7 7 3.866 0 7-3.134 7-7 0-.138-.004-.275-.012-.411-.464.201-.964.334-1.488.386 0 .008 0 .016 0 .025 0 3.038-2.462 5.5-5.5 5.5-3.038 0-5.5-2.462-5.5-5.5 0-3.038 2.462-5.5 5.5-5.5.008 0 .016 0 .025 0 .052-.524.185-1.024.386-1.488\"/><path d=\"m12 2h-1.01c-.54 0-.991.448-.991 1 0 .556.444 1 .991 1h1.01v1.01c0 .54.448.991 1 .991.556 0 1-.444 1-.991v-1.01h1.01c.54 0 .991-.448.991-1 0-.556-.444-1-.991-1h-1.01v-1.01c0-.54-.448-.991-1-.991-.556 0-1 .444-1 .991v1.01m-5 4.01c0-.557.444-1.01 1-1.01.552 0 1 .443 1 1.01v1.981c0 .557-.444 1.01-1 1.01-.552 0-1-.443-1-1.01v-1.981m1 5.991c.552 0 1-.448 1-1 0-.552-.448-1-1-1-.552 0-1 .448-1 1 0 .552.448 1 1 1\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_pencil.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><path d=\"M13.02 1.293l1.414 1.414a1 1 0 0 1 0 1.414L4.119 14.436a1 1 0 0 1-.704.293l-2.407.008L1 12.316a1 1 0 0 1 .293-.71L11.605 1.292a1 1 0 0 1 1.414 0zm-1.416 1.415l-.707.707L12.31 4.83l.707-.707-1.414-1.415zM3.411 13.73l1.123-1.122H3.12v-1.415L2 12.312l.005 1.422 1.406-.005z\"/></svg>\n\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_resolve_discussion.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill-rule=\"evenodd\"/><path d=\"M6.278 7.697L5.045 6.464a.296.296 0 0 0-.42-.002l-.613.614a.298.298 0 0 0 .002.42l1.91 1.909a.5.5 0 0 0 .703.005l.265-.265L9.997 6.04a.291.291 0 0 0-.009-.408l-.614-.614a.29.29 0 0 0-.408-.009L6.278 7.697z\"/></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_success.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M6.278 7.697L5.045 6.464a.296.296 0 0 0-.42-.002l-.613.614a.298.298 0 0 0 .002.42l1.91 1.909a.5.5 0 0 0 .703.005l.265-.265L9.997 6.04a.291.291 0 0 0-.009-.408l-.614-.614a.29.29 0 0 0-.408-.009L6.278 7.697z\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_success_solid.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z M6.278 7.697L5.045 6.464a.296.296 0 0 0-.42-.002l-.613.614a.298.298 0 0 0 .002.42l1.91 1.909a.5.5 0 0 0 .703.005l.265-.265L9.997 6.04a.291.291 0 0 0-.009-.408l-.614-.614a.29.29 0 0 0-.408-.009L6.278 7.697z\" fill-rule=\"evenodd\"/></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_warning.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M6 3.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-4m0 6c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-1\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_stopwatch.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 14\" enable-background=\"new 0 0 12 14\"><path d=\"m11.5 2.4l-1.3-1.1-1 1.1 1.4 1.1.9-1.1\"/><path d=\"m6.8 2v-.5h.5v-1.5h-2.6v1.5h.5v.5c-2.9.4-5.2 2.9-5.2 6 0 3.3 2.7 6 6 6s6-2.7 6-6c0-3-2.3-5.6-5.2-6m-.8 10.5c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5 4.5 2 4.5 4.5-2 4.5-4.5 4.5\"/><path d=\"m6.2 8.9h-.5c-.1 0-.2-.1-.2-.2v-3.5c0-.1.1-.2.2-.2h.5c.1 0 .2.1.2.2v3.5c0 .1-.1.2-.2.2\"/></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_timer.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\"><g fill=\"#8F8F8F\" fill-rule=\"evenodd\"><path d=\"M29.513 10.134A15.922 15.922 0 0 0 23 7.28V6h2.993C26.55 6 27 5.552 27 5V2a1 1 0 0 0-1.007-1H14.007C13.45 1 13 1.448 13 2v3a1 1 0 0 0 1.007 1H17v1.28C9.597 8.686 4 15.19 4 23c0 8.837 7.163 16 16 16s16-7.163 16-16c0-3.461-1.099-6.665-2.967-9.283l1.327-1.58a2.498 2.498 0 0 0-.303-3.53 2.499 2.499 0 0 0-3.528.315l-1.016 1.212zM20 34c6.075 0 11-4.925 11-11s-4.925-11-11-11S9 16.925 9 23s4.925 11 11 11z\"/><path d=\"M19 21h-4.002c-.552 0-.998.452-.998 1.01v1.98c0 .567.447 1.01.998 1.01h7.004c.274 0 .521-.111.701-.291a.979.979 0 0 0 .297-.704v-8.01c0-.54-.452-.995-1.01-.995h-1.98a.997.997 0 0 0-1.01.995V21z\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_mr_widget_empty_state.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"256\" height=\"146\" viewBox=\"0 0 256 146\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>illustration</title><defs><rect id=\"a\" width=\"178.714\" height=\"115.389\" rx=\"10\"/><mask id=\"d\" x=\"0\" y=\"0\" width=\"178.714\" height=\"115.389\" fill=\"#fff\"><use xlink:href=\"#a\"/></mask><path d=\"M8.796 31.515c.395.047.8.072 1.207.072h23.065c5.536 0 10.003-4.475 10.003-9.994v-11.6C43.07 4.476 38.594 0 33.07 0H10.003C4.467 0 0 4.475 0 9.994v11.6c0 1.248.23 2.444.65 3.547H0v7.414c0 4.094 2.394 5.113 5.342 2.28l3.454-3.32z\" id=\"b\"/><mask id=\"e\" x=\"0\" y=\"0\" width=\"43.071\" height=\"36.437\" fill=\"#fff\"><use xlink:href=\"#b\"/></mask><path d=\"M8.796 31.515c.395.047.8.072 1.207.072h23.065c5.536 0 10.003-4.475 10.003-9.994v-11.6C43.07 4.476 38.594 0 33.07 0H10.003C4.467 0 0 4.475 0 9.994v11.6c0 1.248.23 2.444.65 3.547H0v7.414c0 4.094 2.394 5.113 5.342 2.28l3.454-3.32z\" id=\"c\"/><mask id=\"f\" x=\"0\" y=\"0\" width=\"43.071\" height=\"36.437\" fill=\"#fff\"><use xlink:href=\"#c\"/></mask></defs><g fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(0 3.868)\" fill=\"#F9F9F9\"><rect x=\"19.286\" width=\"77.143\" height=\"14.182\" rx=\"7.091\"/><rect y=\"28.364\" width=\"84.857\" height=\"14.182\" rx=\"7.091\"/><rect x=\"133.714\" y=\"42.546\" width=\"122.143\" height=\"14.182\" rx=\"7.091\"/><rect x=\"82.929\" y=\"126.992\" width=\"101.571\" height=\"14.182\" rx=\"7.091\"/><rect x=\"42.429\" y=\"99.273\" width=\"101.571\" height=\"14.182\" rx=\"7.091\"/><rect x=\"19.929\" y=\"70.909\" width=\"225\" height=\"14.182\" rx=\"7.091\"/><path d=\"M98.37 14.182H13.488h13.81a7.098 7.098 0 0 1 7.094 7.09 7.09 7.09 0 0 1-7.094 7.092h-13.81 84.88-23.452a7.098 7.098 0 0 1-7.095-7.09 7.09 7.09 0 0 1 7.096-7.092h23.452zm162 42.545h-75.238 23.452a7.098 7.098 0 0 1 7.095 7.09 7.09 7.09 0 0 1-7.096 7.092h-23.452 75.237-23.453a7.098 7.098 0 0 1-7.095-7.09 7.09 7.09 0 0 1 7.095-7.093h23.452zM103.512 85.09H28.275h23.452a7.098 7.098 0 0 1 7.095 7.092 7.09 7.09 0 0 1-7.095 7.09H28.275h75.237H80.06a7.098 7.098 0 0 1-7.095-7.09 7.09 7.09 0 0 1 7.095-7.09h23.452zm48.215 28.365H76.49 90.3a7.098 7.098 0 0 1 7.093 7.09 7.09 7.09 0 0 1-7.094 7.092H76.49h75.237-33.096a7.098 7.098 0 0 1-7.094-7.09 7.09 7.09 0 0 1 7.095-7.092h33.097z\"/></g><g transform=\"translate(38.57 12.248)\"><use stroke=\"#EEE\" mask=\"url(#d)\" stroke-width=\"8\" fill=\"#FFF\" xlink:href=\"#a\"/><path fill=\"#EEE\" d=\"M2.57 18.694h174.215v2.58H2.57z\"/><g transform=\"translate(21.857 38.678)\"><rect fill=\"#B5A7DD\" y=\".645\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#EEE\" x=\"9.643\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"46.286\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"25.071\" y=\"14.182\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" x=\"34.071\" y=\"7.091\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" opacity=\".5\" x=\"30.857\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"14.182\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"18.643\" y=\"7.091\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" x=\"21.857\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"7.091\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#B5A7DD\" y=\"7.736\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#B5A7DD\" y=\"14.826\" width=\"3.857\" height=\"1.289\" rx=\".645\"/></g><g transform=\"translate(21.857 59.95)\"><rect fill=\"#B5A7DD\" y=\".645\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#FC6D26\" x=\"9.643\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"46.286\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" opacity=\".5\" x=\"25.071\" y=\"14.182\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"34.071\" y=\"7.091\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" x=\"30.857\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" x=\"9.643\" y=\"14.182\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"18.643\" y=\"7.091\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" opacity=\".5\" x=\"21.857\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"7.091\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#B5A7DD\" y=\"7.736\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#B5A7DD\" y=\"14.826\" width=\"3.857\" height=\"1.289\" rx=\".645\"/></g><g transform=\"translate(21.857 81.223)\"><rect fill=\"#B5A7DD\" y=\".645\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#EEE\" x=\"9.643\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"46.286\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"25.071\" y=\"14.182\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"34.071\" y=\"7.091\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" x=\"30.857\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"14.182\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"18.643\" y=\"7.091\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" opacity=\".5\" x=\"21.857\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"7.091\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#B5A7DD\" y=\"7.736\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#B5A7DD\" y=\"14.826\" width=\"3.857\" height=\"1.289\" rx=\".645\"/></g><g transform=\"translate(100.93 38.033)\"><rect fill=\"#FDE5D8\" y=\".645\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#EEE\" x=\"9.643\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"46.286\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" opacity=\".5\" x=\"25.071\" y=\"14.182\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" x=\"34.071\" y=\"7.091\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" opacity=\".5\" x=\"30.857\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" x=\"9.643\" y=\"14.182\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"18.643\" y=\"7.091\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" x=\"21.857\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"7.091\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FDE5D8\" y=\"7.736\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#FDE5D8\" y=\"14.826\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#FDE5D8\" y=\"21.917\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"21.273\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"37.286\" y=\"14.182\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" opacity=\".5\" x=\"25.071\" y=\"35.455\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" x=\"18.643\" y=\"28.364\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" x=\"30.857\" y=\"21.273\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"35.455\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"21.857\" y=\"21.273\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"28.364\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"30.857\" y=\"28.364\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"39.857\" y=\"28.364\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"49.5\" y=\"14.182\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FDE5D8\" y=\"29.008\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#FDE5D8\" y=\"36.099\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#FDE5D8\" y=\"43.19\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#6B4FBB\" x=\"9.643\" y=\"42.546\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"25.071\" y=\"56.727\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" opacity=\".5\" x=\"34.071\" y=\"49.636\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"56.727\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" x=\"18.643\" y=\"49.636\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"21.857\" y=\"42.546\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"46.286\" y=\"49.636\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"49.636\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FDE5D8\" y=\"50.281\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#FDE5D8\" y=\"57.372\" width=\"3.857\" height=\"1.289\" rx=\".645\"/></g></g><g transform=\"translate(196.07)\"><use stroke=\"#FDE5D8\" mask=\"url(#e)\" stroke-width=\"8\" fill=\"#FFF\" xlink:href=\"#b\"/><rect fill=\"#FDB692\" x=\"9\" y=\"9.025\" width=\"18.643\" height=\"1.934\" rx=\".967\"/><rect fill=\"#FDB692\" x=\"9\" y=\"14.826\" width=\"25.071\" height=\"1.934\" rx=\".967\"/><rect fill=\"#FDB692\" x=\"9\" y=\"20.628\" width=\"18.643\" height=\"1.934\" rx=\".967\"/></g><g transform=\"translate(189 41.256)\"><ellipse stroke=\"#FC6D26\" stroke-width=\"3\" fill=\"#FFF7F4\" cx=\"10.286\" cy=\"9.669\" rx=\"9.643\" ry=\"9.669\"/><path d=\"M.023 9.002a8.352 8.352 0 0 0 7.94-4.308M9 .644c0-.21-.008-.416-.023-.62\" stroke=\"#FC6D26\" stroke-width=\"2\"/><path d=\"M5.045 2.008A10.266 10.266 0 0 0 13.5 6.446c2.112 0 4.076-.638 5.71-1.733\" stroke=\"#FC6D26\" stroke-width=\"2\"/><ellipse fill=\"#FC6D26\" cx=\"6.75\" cy=\"11.281\" rx=\".964\" ry=\".967\"/><ellipse fill=\"#FC6D26\" cx=\"13.821\" cy=\"11.281\" rx=\".964\" ry=\".967\"/></g><g transform=\"translate(46.93 96.05)\"><ellipse stroke=\"#6B4FBB\" stroke-width=\"3\" fill=\"#F4F1FA\" cx=\"9.643\" cy=\"10.314\" rx=\"9.643\" ry=\"9.669\"/><path d=\"M12.86 4.51h-.005L11.25 2.58 9.645 4.51H9.64L8.036 2.58 6.43 4.51h-.002L4.82 2.58 3.215 4.512h-1.75A9.646 9.646 0 0 1 9.642 0c3.447 0 6.47 1.8 8.176 4.508h-1.75l-1.605-1.93L12.86 4.51z\" fill=\"#6B4FBB\"/><ellipse fill=\"#6B4FBB\" cx=\"6.107\" cy=\"11.281\" rx=\".964\" ry=\".967\"/><ellipse fill=\"#6B4FBB\" cx=\"13.179\" cy=\"11.281\" rx=\".964\" ry=\".967\"/></g><g transform=\"matrix(-1 0 0 1 56.57 54.794)\"><use stroke=\"#E2DCF2\" mask=\"url(#f)\" stroke-width=\"8\" fill=\"#FFF\" xlink:href=\"#c\"/><rect fill=\"#6B4FBB\" opacity=\".5\" x=\"15.429\" y=\"9.025\" width=\"18.643\" height=\"1.934\" rx=\".967\"/><rect fill=\"#6B4FBB\" opacity=\".5\" x=\"21.857\" y=\"14.826\" width=\"12.214\" height=\"1.934\" rx=\".967\"/><rect fill=\"#6B4FBB\" opacity=\".5\" x=\"21.857\" y=\"20.628\" width=\"12.214\" height=\"1.934\" rx=\".967\"/></g></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_next_discussion.svg":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 20 19\" ><path d=\"M15.21 7.783h-3.317c-.268 0-.472.218-.472.486v.953c0 .28.212.486.473.486h3.318v1.575c0 .36.233.452.52.23l3.06-2.37c.274-.213.286-.582 0-.804l-3.06-2.37c-.275-.213-.52-.12-.52.23v1.583zm.57-3.66c-1.558-1.22-3.783-1.98-6.254-1.98C4.816 2.143 1 4.91 1 8.333c0 1.964 1.256 3.715 3.216 4.846-.447 1.615-1.132 2.195-1.732 2.882-.142.174-.304.32-.256.56v.01c.047.213.218.368.41.368h.046c.37-.048.743-.116 1.085-.213 1.645-.425 3.13-1.22 4.377-2.34.447.048.913.077 1.38.077 2.092 0 4.01-.546 5.492-1.454-.416-.208-.798-.475-1.134-.792-1.227.63-2.743 1.008-4.36 1.008-.41 0-.828-.03-1.237-.078l-.543-.058-.41.368c-.78.696-1.655 1.248-2.616 1.654.248-.445.486-.977.667-1.664l.257-.928-.828-.484c-1.646-.948-2.598-2.32-2.598-3.763 0-2.69 3.35-4.952 7.308-4.952 1.893 0 3.647.518 4.962 1.353.393-.266.827-.473 1.29-.61z\" /></svg>\n"

/***/ }),

/***/ "../images/no_avatar.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAAAAAAdJSU2AAACNElEQVR4AdXYBa7jMBCA4b3/JZahzIkjp2qt+BWUWnG5ln2XxaJJb2b5F2ukL4wvzK/rP7bUcbf92u6oftLSe1ldk8efsfaVeEjusZZeC6e1RllaCk/yG6ag1lZ4WwPX69uyD6tAe/g2ipAlNMRS37awDLaFrpcMWxXQOi0jnWCWjFkSZomYJWDWKmatYNZyEWkJsvQimoZYah5NgdaLxagCtF6GRy0DshZPkeYwS/KIJWGWYjwYUzDLxCwDtJ54OKglimBLqHWahii2g1pmHLLGBmwVoRjcKlmgOdw65H5qKuGWCVi5Qlhs6m1sENZi4q3AWNvca5UYy2RjT/SAsiZey6CsIvc0wVlV5lJ0ibPMyLUGCmlxQq0IM0hLdWyro7CWEc3sXsqaK4O2zLxOsmtpfW5Q1u68ZrVmepaaNXEewawtI9X5Xl3U3n1qND6+rfPzvqoIWz/fklNCSLY153YV53J/XUxGCJnKZ1lajsn3/Ffegf6Y5pV2LUsSNL2UHzxUfh3TlYpZqqTpXZm0KZk9zJcqaEmaWPHDw0pxe05K7bWOLHFLWXVetqpYmrjle4+1y0aBaF4UOQ1NU+lYezJClkjLUnSEjqhH6zjAW4OjtY39Ibq+sawUb6W2RQfoqG0VeKuwrRJvlba17faRdbe2pTtYq6Nty/S7yAbGsQjWIq41wVoT1+IdZNy1djUcVdu5lklQWC0xHkt1X31qNEE1Pr3qKv/9XiSNj6Aaifj3/69+AYujsR/MvkpZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./autosave.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__ = __webpack_require__("./lib/utils/accessor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-param-reassign, prefer-template, no-var, no-void, consistent-return */



var Autosave = function () {
  function Autosave(field, key) {
    var _this = this;

    _classCallCheck(this, Autosave);

    this.field = field;

    this.isLocalStorageAvailable = __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe();
    if (key.join != null) {
      key = key.join('/');
    }
    this.key = 'autosave/' + key;
    this.field.data('autosave', this);
    this.restore();
    this.field.on('input', function () {
      return _this.save();
    });
  }

  _createClass(Autosave, [{
    key: 'restore',
    value: function restore() {
      if (!this.isLocalStorageAvailable) return;
      if (!this.field.length) return;

      var text = window.localStorage.getItem(this.key);

      if ((text != null ? text.length : void 0) > 0) {
        this.field.val(text);
      }

      this.field.trigger('input');
      // v-model does not update with jQuery trigger
      // https://github.com/vuejs/vue/issues/2804#issuecomment-216968137
      var event = new Event('change', { bubbles: true, cancelable: false });
      var field = this.field.get(0);
      field.dispatchEvent(event);
    }
  }, {
    key: 'save',
    value: function save() {
      if (!this.field.length) return;

      var text = this.field.val();

      if (this.isLocalStorageAvailable && (text != null ? text.length : void 0) > 0) {
        return window.localStorage.setItem(this.key, text);
      }

      return this.reset();
    }
  }, {
    key: 'reset',
    value: function reset() {
      if (!this.isLocalStorageAvailable) return;

      return window.localStorage.removeItem(this.key);
    }
  }]);

  return Autosave;
}();

/* harmony default export */ __webpack_exports__["a"] = (Autosave);

/***/ }),

/***/ "./blob/blob_fork_suggestion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaults = {
  // Buttons that will show the `suggestionSections`
  // has `data-fork-path`, and `data-action`
  openButtons: [],
  // Update the href(from `openButton` -> `data-fork-path`)
  // whenever a `openButton` is clicked
  forkButtons: [],
  // Buttons to hide the `suggestionSections`
  cancelButtons: [],
  // Section to show/hide
  suggestionSections: [],
  // Pieces of text that need updating depending on the action, `edit`, `replace`, `delete`
  actionTextPieces: []
};

var BlobForkSuggestion = function () {
  function BlobForkSuggestion(options) {
    _classCallCheck(this, BlobForkSuggestion);

    this.elementMap = Object.assign({}, defaults, options);
    this.onOpenButtonClick = this.onOpenButtonClick.bind(this);
    this.onCancelButtonClick = this.onCancelButtonClick.bind(this);
  }

  _createClass(BlobForkSuggestion, [{
    key: 'init',
    value: function init() {
      this.bindEvents();

      return this;
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      $(this.elementMap.openButtons).on('click', this.onOpenButtonClick);
      $(this.elementMap.cancelButtons).on('click', this.onCancelButtonClick);
    }
  }, {
    key: 'showSuggestionSection',
    value: function showSuggestionSection(forkPath) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'edit';

      $(this.elementMap.suggestionSections).removeClass('hidden');
      $(this.elementMap.forkButtons).attr('href', forkPath);
      $(this.elementMap.actionTextPieces).text(action);
    }
  }, {
    key: 'hideSuggestionSection',
    value: function hideSuggestionSection() {
      $(this.elementMap.suggestionSections).addClass('hidden');
    }
  }, {
    key: 'onOpenButtonClick',
    value: function onOpenButtonClick(e) {
      var forkPath = $(e.currentTarget).attr('data-fork-path');
      var action = $(e.currentTarget).attr('data-action');
      this.showSuggestionSection(forkPath, action);
    }
  }, {
    key: 'onCancelButtonClick',
    value: function onCancelButtonClick() {
      this.hideSuggestionSection();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      $(this.elementMap.openButtons).off('click', this.onOpenButtonClick);
      $(this.elementMap.cancelButtons).off('click', this.onCancelButtonClick);
    }
  }]);

  return BlobForkSuggestion;
}();

/* harmony default export */ __webpack_exports__["a"] = (BlobForkSuggestion);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./commit/image_file.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-use-before-define, prefer-arrow-callback, no-else-return, consistent-return, prefer-template, quotes, one-var, one-var-declaration-per-line, no-unused-vars, no-return-assign, comma-dangle, quote-props, no-unused-expressions, no-sequences, object-shorthand, max-len */

// Width where images must fits in, for 2-up this gets divided by 2
var availWidth = 900;
var viewModes = ['two-up', 'swipe'];

var ImageFile = function () {
  function ImageFile(file) {
    _classCallCheck(this, ImageFile);

    this.views = {
      'two-up': function twoUp() {
        return $('.two-up.view .wrap', this.file).each(function (_this) {
          return function (index, wrap) {
            $('img', wrap).each(function () {
              var currentWidth;
              currentWidth = $(this).width();
              if (currentWidth > availWidth / 2) {
                return $(this).width(availWidth / 2);
              }
            });
            return _this.requestImageInfo($('img', wrap), function (width, height) {
              $('.image-info .meta-width', wrap).text(width + "px");
              $('.image-info .meta-height', wrap).text(height + "px");
              return $('.image-info', wrap).removeClass('hide');
            });
          };
        }(this));
      },
      'swipe': function swipe() {
        var maxHeight, maxWidth;
        maxWidth = 0;
        maxHeight = 0;
        return $('.swipe.view', this.file).each(function (_this) {
          return function (index, view) {
            var $swipeWrap, $swipeBar, $swipeFrame, wrapPadding, ref;
            ref = _this.prepareFrames(view), maxWidth = ref[0], maxHeight = ref[1];
            $swipeFrame = $('.swipe-frame', view);
            $swipeWrap = $('.swipe-wrap', view);
            $swipeBar = $('.swipe-bar', view);

            $swipeFrame.css({
              width: maxWidth + 16,
              height: maxHeight + 28
            });
            $swipeWrap.css({
              width: maxWidth + 1,
              height: maxHeight + 2
            });
            // Set swipeBar left position to match image frame
            $swipeBar.css({
              left: 1
            });

            wrapPadding = parseInt($swipeWrap.css('right').replace('px', ''), 10);

            _this.initDraggable($swipeBar, wrapPadding, function (e, left) {
              if (left > 0 && left < $swipeFrame.width() - wrapPadding * 2) {
                $swipeWrap.width(maxWidth + 1 - left);
                $swipeBar.css('left', left);
              }
            });
          };
        }(this));
      },
      'onion-skin': function onionSkin() {
        var dragTrackWidth, maxHeight, maxWidth;
        maxWidth = 0;
        maxHeight = 0;
        dragTrackWidth = $('.drag-track', this.file).width() - $('.dragger', this.file).width();
        return $('.onion-skin.view', this.file).each(function (_this) {
          return function (index, view) {
            var $frame,
                $track,
                $dragger,
                $frameAdded,
                framePadding,
                ref,
                dragging = false;
            ref = _this.prepareFrames(view), maxWidth = ref[0], maxHeight = ref[1];
            $frame = $('.onion-skin-frame', view);
            $frameAdded = $('.frame.added', view);
            $track = $('.drag-track', view);
            $dragger = $('.dragger', $track);

            $frame.css({
              width: maxWidth + 16,
              height: maxHeight + 28
            });
            $('.swipe-wrap', view).css({
              width: maxWidth + 1,
              height: maxHeight + 2
            });
            $dragger.css({
              left: dragTrackWidth
            });

            $frameAdded.css('opacity', 1);
            framePadding = parseInt($frameAdded.css('right').replace('px', ''), 10);

            _this.initDraggable($dragger, framePadding, function (e, left) {
              var opacity = left / dragTrackWidth;

              if (opacity >= 0 && opacity <= 1) {
                $dragger.css('left', left);
                $frameAdded.css('opacity', opacity);
              }
            });
          };
        }(this));
      }
    };

    this.file = file;
    this.requestImageInfo($('.two-up.view .frame.deleted img', this.file), function (_this) {
      return function (deletedWidth, deletedHeight) {
        return _this.requestImageInfo($('.two-up.view .frame.added img', _this.file), function (width, height) {
          _this.initViewModes();

          // Load two-up view after images are loaded
          // so that we can display the correct width and height information
          var $images = $('.two-up.view img', _this.file);

          $images.waitForImages(function () {
            _this.initView('two-up');
          });
        });
      };
    }(this));
  }

  _createClass(ImageFile, [{
    key: 'initViewModes',
    value: function initViewModes() {
      var viewMode = viewModes[0];
      $('.view-modes', this.file).removeClass('hide');
      $('.view-modes-menu', this.file).on('click', 'li', function (_this) {
        return function (event) {
          if (!$(event.currentTarget).hasClass('active')) {
            return _this.activateViewMode(event.currentTarget.className);
          }
        };
      }(this));
      return this.activateViewMode(viewMode);
    }
  }, {
    key: 'activateViewMode',
    value: function activateViewMode(viewMode) {
      $('.view-modes-menu li', this.file).removeClass('active').filter("." + viewMode).addClass('active');
      return $(".view:visible:not(." + viewMode + ")", this.file).fadeOut(200, function (_this) {
        return function () {
          $(".view." + viewMode, _this.file).fadeIn(200);
          return _this.initView(viewMode);
        };
      }(this));
    }
  }, {
    key: 'initView',
    value: function initView(viewMode) {
      return this.views[viewMode].call(this);
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'initDraggable',
    value: function initDraggable($el, padding, callback) {
      var dragging = false;
      var $body = $('body');
      var $offsetEl = $el.parent();

      $el.off('mousedown').on('mousedown', function () {
        dragging = true;
        $body.css('user-select', 'none');
      });

      $body.off('mouseup').off('mousemove').on('mouseup', function () {
        dragging = false;
        $body.css('user-select', '');
      }).on('mousemove', function (e) {
        var left;
        if (!dragging) return;

        left = e.pageX - ($offsetEl.offset().left + padding);

        callback(e, left);
      });
    }
  }, {
    key: 'prepareFrames',
    value: function prepareFrames(view) {
      var maxHeight, maxWidth;
      maxWidth = 0;
      maxHeight = 0;
      $('.frame', view).each(function (_this) {
        return function (index, frame) {
          var height, width;
          width = $(frame).width();
          height = $(frame).height();
          maxWidth = width > maxWidth ? width : maxWidth;
          return maxHeight = height > maxHeight ? height : maxHeight;
        };
      }(this)).css({
        width: maxWidth,
        height: maxHeight
      });
      return [maxWidth, maxHeight];
    }
    // eslint-disable-next-line

  }, {
    key: 'requestImageInfo',
    value: function requestImageInfo(img, callback) {
      var domImg = img.get(0);
      if (domImg) {
        if (domImg.complete) {
          return callback.call(this, domImg.naturalWidth, domImg.naturalHeight);
        } else {
          return img.on('load', function (_this) {
            return function () {
              return callback.call(_this, domImg.naturalWidth, domImg.naturalHeight);
            };
          }(this));
        }
      }
    }
  }]);

  return ImageFile;
}();

/* harmony default export */ __webpack_exports__["a"] = (ImageFile);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./commit/pipelines/pipelines_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: ./pipelines/services/pipelines_service.js
var pipelines_service = __webpack_require__("./pipelines/services/pipelines_service.js");

// EXTERNAL MODULE: ./pipelines/stores/pipelines_store.js
var pipelines_store = __webpack_require__("./pipelines/stores/pipelines_store.js");

// EXTERNAL MODULE: ./pipelines/mixins/pipelines.js + 27 modules
var pipelines = __webpack_require__("./pipelines/mixins/pipelines.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./commit/pipelines/pipelines_table.vue





/* harmony default export */ var pipelines_table = ({
  mixins: [pipelines["a" /* default */]],
  props: {
    endpoint: {
      type: String,
      required: true
    },
    helpPagePath: {
      type: String,
      required: true
    },
    autoDevopsHelpPath: {
      type: String,
      required: true
    },
    errorStateSvgPath: {
      type: String,
      required: true
    },
    viewType: {
      type: String,
      required: false,
      default: 'child'
    }
  },

  data: function data() {
    var store = new pipelines_store["a" /* default */]();

    return {
      store: store,
      state: store.state
    };
  },


  computed: {
    shouldRenderTable: function shouldRenderTable() {
      return !this.isLoading && this.state.pipelines.length > 0 && !this.hasError;
    },
    shouldRenderErrorState: function shouldRenderErrorState() {
      return this.hasError && !this.isLoading;
    }
  },
  created: function created() {
    this.service = new pipelines_service["a" /* default */](this.endpoint);
  },

  methods: {
    successCallback: function successCallback(resp) {
      var _this = this;

      return resp.json().then(function (response) {
        // depending of the endpoint the response can either bring a `pipelines` key or not.
        var pipelines = response.pipelines || response;
        _this.setCommonData(pipelines);

        var updatePipelinesEvent = new CustomEvent('update-pipelines-count', {
          detail: {
            pipelines: response
          }
        });

        // notifiy to update the count in tabs
        if (_this.$el.parentElement) {
          _this.$el.parentElement.dispatchEvent(updatePipelinesEvent);
        }
      });
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34b04960","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./commit/pipelines/pipelines_table.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-list pipelines"},[(_vm.isLoading)?_c('loading-icon',{staticClass:"prepend-top-20",attrs:{"label":_vm.s__('Pipelines|Loading Pipelines'),"size":"3"}}):(_vm.shouldRenderErrorState)?_c('svg-blank-state',{attrs:{"svg-path":_vm.errorStateSvgPath,"message":_vm.s__("Pipelines|There was an error fetching the pipelines.\n    Try again in a few moments or contact your support team.")}}):(_vm.shouldRenderTable)?_c('div',{staticClass:"table-holder"},[_c('pipelines-table-component',{attrs:{"pipelines":_vm.state.pipelines,"update-graph-dropdown":_vm.updateGraphDropdown,"auto-devops-help-path":_vm.autoDevopsHelpPath,"view-type":_vm.viewType}})],1):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./commit/pipelines/pipelines_table.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  pipelines_table,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pipelines_pipelines_table = (Component.exports);

// CONCATENATED MODULE: ./commit/pipelines/pipelines_bundle.js



/**
 * Used in:
 *  - Commit details View > Pipelines Tab > Pipelines Table.
 *  - Merge Request details View > Pipelines Tab > Pipelines Table.
 *  - New Merge Request View > Pipelines Tab > Pipelines Table.
 */

var CommitPipelinesTable = vue_esm["a" /* default */].extend(pipelines_pipelines_table);

// export for use in merge_request_tabs.js (TODO: remove this hack when we understand how to load
// vue.js in merge_request_tabs.js)
window.gl = window.gl || {};
window.gl.CommitPipelinesTable = CommitPipelinesTable;

/* harmony default export */ var pipelines_bundle = __webpack_exports__["a"] = (function () {
  var pipelineTableViewEl = document.querySelector('#commit-pipeline-table-view');

  if (pipelineTableViewEl) {
    // Update MR and Commits tabs
    pipelineTableViewEl.addEventListener('update-pipelines-count', function (event) {
      if (event.detail.pipelines && event.detail.pipelines.count && event.detail.pipelines.count.all) {
        var badge = document.querySelector('.js-pipelines-mr-count');

        badge.textContent = event.detail.pipelines.count.all;
      }
    });

    if (pipelineTableViewEl.dataset.disableInitialization === undefined) {
      var table = new CommitPipelinesTable({
        propsData: {
          endpoint: pipelineTableViewEl.dataset.endpoint,
          helpPagePath: pipelineTableViewEl.dataset.helpPagePath,
          emptyStateSvgPath: pipelineTableViewEl.dataset.emptyStateSvgPath,
          errorStateSvgPath: pipelineTableViewEl.dataset.errorStateSvgPath,
          autoDevopsHelpPath: pipelineTableViewEl.dataset.helpAutoDevopsPath
        }
      }).$mount();
      pipelineTableViewEl.appendChild(table.$el);
    }
  }
});

/***/ }),

/***/ "./create_label.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_text_utility__ = __webpack_require__("./lib/utils/text_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, prefer-arrow-callback */



var CreateLabelDropdown = function () {
  function CreateLabelDropdown($el, namespacePath, projectPath) {
    _classCallCheck(this, CreateLabelDropdown);

    this.$el = $el;
    this.namespacePath = namespacePath;
    this.projectPath = projectPath;
    this.$dropdownBack = $('.dropdown-menu-back', this.$el.closest('.dropdown'));
    this.$cancelButton = $('.js-cancel-label-btn', this.$el);
    this.$newLabelField = $('#new_label_name', this.$el);
    this.$newColorField = $('#new_label_color', this.$el);
    this.$colorPreview = $('.js-dropdown-label-color-preview', this.$el);
    this.$newLabelError = $('.js-label-error', this.$el);
    this.$newLabelCreateButton = $('.js-new-label-btn', this.$el);
    this.$colorSuggestions = $('.suggest-colors-dropdown a', this.$el);

    this.$newLabelError.hide();
    this.$newLabelCreateButton.disable();

    this.cleanBinding();
    this.addBinding();
  }

  _createClass(CreateLabelDropdown, [{
    key: 'cleanBinding',
    value: function cleanBinding() {
      this.$colorSuggestions.off('click');
      this.$newLabelField.off('keyup change');
      this.$newColorField.off('keyup change');
      this.$dropdownBack.off('click');
      this.$cancelButton.off('click');
      this.$newLabelCreateButton.off('click');
    }
  }, {
    key: 'addBinding',
    value: function addBinding() {
      var self = this;

      this.$colorSuggestions.on('click', function (e) {
        var $this = $(this);
        self.addColorValue(e, $this);
      });

      this.$newLabelField.on('keyup change', this.enableLabelCreateButton.bind(this));
      this.$newColorField.on('keyup change', this.enableLabelCreateButton.bind(this));

      this.$dropdownBack.on('click', this.resetForm.bind(this));

      this.$cancelButton.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        self.resetForm();
        self.$dropdownBack.trigger('click');
      });

      this.$newLabelCreateButton.on('click', this.saveLabel.bind(this));
    }
  }, {
    key: 'addColorValue',
    value: function addColorValue(e, $this) {
      e.preventDefault();
      e.stopPropagation();

      this.$newColorField.val($this.data('color')).trigger('change');
      this.$colorPreview.css('background-color', $this.data('color')).parent().addClass('is-active');
    }
  }, {
    key: 'enableLabelCreateButton',
    value: function enableLabelCreateButton() {
      if (this.$newLabelField.val() !== '' && this.$newColorField.val() !== '') {
        this.$newLabelError.hide();
        this.$newLabelCreateButton.enable();
      } else {
        this.$newLabelCreateButton.disable();
      }
    }
  }, {
    key: 'resetForm',
    value: function resetForm() {
      this.$newLabelField.val('').trigger('change');

      this.$newColorField.val('').trigger('change');

      this.$colorPreview.css('background-color', '').parent().removeClass('is-active');
    }
  }, {
    key: 'saveLabel',
    value: function saveLabel(e) {
      var _this = this;

      e.preventDefault();
      e.stopPropagation();

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].newLabel(this.namespacePath, this.projectPath, {
        title: this.$newLabelField.val(),
        color: this.$newColorField.val()
      }, function (label) {
        _this.$newLabelCreateButton.enable();

        if (label.message) {
          var errors = void 0;

          if (typeof label.message === 'string') {
            errors = label.message;
          } else {
            errors = Object.keys(label.message).map(function (key) {
              return Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_text_utility__["f" /* humanize */])(key) + ' ' + label.message[key].join(', ');
            }).join('<br/>');
          }

          _this.$newLabelError.html(errors).show();
        } else {
          _this.$dropdownBack.trigger('click');

          $(document).trigger('created.label', label);
        }
      });
    }
  }]);

  return CreateLabelDropdown;
}();

/* harmony default export */ __webpack_exports__["a"] = (CreateLabelDropdown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__files_comment_button__ = __webpack_require__("./files_comment_button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__single_file_diff__ = __webpack_require__("./single_file_diff.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__image_diff_helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var UNFOLD_COUNT = 20;
var isBound = false;

var Diff = function () {
  function Diff() {
    _classCallCheck(this, Diff);

    var $diffFile = $('.files .diff-file');

    $diffFile.each(function (index, file) {
      if (!$.data(file, 'singleFileDiff')) {
        $.data(file, 'singleFileDiff', new __WEBPACK_IMPORTED_MODULE_5__single_file_diff__["a" /* default */](file));
      }
    });

    var tab = document.getElementById('diffs');
    if (!tab || tab && tab.dataset && tab.dataset.isLocked !== '') __WEBPACK_IMPORTED_MODULE_4__files_comment_button__["a" /* default */].init($diffFile);

    var firstFile = $('.files').first().get(0);
    var canCreateNote = firstFile && firstFile.hasAttribute('data-can-create-note');
    $diffFile.each(function (index, file) {
      return __WEBPACK_IMPORTED_MODULE_6__image_diff_helpers_index__["a" /* default */].initImageDiff(file, canCreateNote);
    });

    if (!isBound) {
      $(document).on('click', '.js-unfold', this.handleClickUnfold.bind(this)).on('click', '.diff-line-num a', this.handleClickLineNum.bind(this)).on('mousedown', 'td.line_content.parallel', this.handleParallelLineDown.bind(this));
      isBound = true;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_url_utility__["a" /* getLocationHash */])()) {
      this.highlightSelectedLine();
    }

    this.openAnchoredDiff();
  }

  _createClass(Diff, [{
    key: 'handleClickUnfold',
    value: function handleClickUnfold(e) {
      var $target = $(e.target);

      var _lineNumbers = this.lineNumbers($target.parent()),
          _lineNumbers2 = _slicedToArray(_lineNumbers, 2),
          oldLineNumber = _lineNumbers2[0],
          newLineNumber = _lineNumbers2[1];

      var offset = newLineNumber - oldLineNumber;
      var bottom = $target.hasClass('js-unfold-bottom');
      var since = void 0;
      var to = void 0;
      var unfold = true;

      if (bottom) {
        var lineNumber = newLineNumber + 1;
        since = lineNumber;
        to = lineNumber + UNFOLD_COUNT;
      } else {
        var _lineNumber = newLineNumber - 1;
        since = _lineNumber - UNFOLD_COUNT;
        to = _lineNumber;

        // make sure we aren't loading more than we need
        var prevNewLine = this.lineNumbers($target.parent().prev())[1];
        if (since <= prevNewLine + 1) {
          since = prevNewLine + 1;
          unfold = false;
        }
      }

      var file = $target.parents('.diff-file');
      var link = file.data('blobDiffPath');
      var view = file.data('view');

      var params = { since: since, to: to, bottom: bottom, offset: offset, unfold: unfold, view: view };
      __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].get(link, { params: params }).then(function (_ref) {
        var data = _ref.data;
        return $target.parent().replaceWith(data);
      }).catch(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__locale__["a" /* __ */])('An error occurred while loading diff'));
      });
    }
  }, {
    key: 'openAnchoredDiff',
    value: function openAnchoredDiff(cb) {
      var _this = this;

      var locationHash = Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_url_utility__["a" /* getLocationHash */])();
      var anchoredDiff = locationHash && locationHash.split('_')[0];

      if (!anchoredDiff) return;

      var diffTitle = $('#' + anchoredDiff);
      var diffFile = diffTitle.closest('.diff-file');
      var nothingHereBlock = $('.nothing-here-block:visible', diffFile);
      if (nothingHereBlock.length) {
        var clickTarget = $('.js-file-title, .click-to-expand', diffFile);
        diffFile.data('singleFileDiff').toggleDiff(clickTarget, function () {
          _this.highlightSelectedLine();
          if (cb) cb();
        });
      } else if (cb) {
        cb();
      }
    }
  }, {
    key: 'handleClickLineNum',
    value: function handleClickLineNum(e) {
      var hash = $(e.currentTarget).attr('href');
      e.preventDefault();
      if (window.history.pushState) {
        window.history.pushState(null, null, hash);
      } else {
        window.location.hash = hash;
      }
      this.highlightSelectedLine();
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'handleParallelLineDown',
    value: function handleParallelLineDown(e) {
      var line = $(e.currentTarget);
      var table = line.closest('table');

      table.removeClass('left-side-selected right-side-selected');

      var lineClass = ['left-side', 'right-side'].filter(function (name) {
        return line.hasClass(name);
      })[0];
      if (lineClass) {
        table.addClass(lineClass + '-selected');
      }
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'diffViewType',
    value: function diffViewType() {
      return $('.inline-parallel-buttons a.active').data('viewType');
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'lineNumbers',
    value: function lineNumbers(line) {
      var children = line.find('.diff-line-num').toArray();
      if (children.length !== 2) {
        return [0, 0];
      }
      return children.map(function (elm) {
        return parseInt($(elm).data('linenumber'), 10) || 0;
      });
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'highlightSelectedLine',
    value: function highlightSelectedLine() {
      var hash = Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_url_utility__["a" /* getLocationHash */])();
      var $diffFiles = $('.diff-file');
      $diffFiles.find('.hll').removeClass('hll');

      if (hash) {
        $diffFiles.find('tr#' + hash + ':not(.match) td, td#' + hash + ', td[data-line-code="' + hash + '"]').addClass('hll');
      }
    }
  }]);

  return Diff;
}();

/* harmony default export */ __webpack_exports__["a"] = (Diff);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/comment_resolve_btn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable comma-dangle, object-shorthand, func-names, no-else-return, quotes, no-lonely-if, max-len */
/* global CommentsStore */



var CommentAndResolveBtn = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    discussionId: String
  },
  data: function data() {
    return {
      textareaIsEmpty: true,
      discussion: {}
    };
  },

  computed: {
    showButton: function showButton() {
      if (this.discussion) {
        return this.discussion.isResolvable();
      } else {
        return false;
      }
    },
    isDiscussionResolved: function isDiscussionResolved() {
      return this.discussion.isResolved();
    },
    buttonText: function buttonText() {
      if (this.isDiscussionResolved) {
        if (this.textareaIsEmpty) {
          return "未解决讨论";
        } else {
          return "评论 & 未解决讨论";
        }
      } else {
        if (this.textareaIsEmpty) {
          return "解决讨论";
        } else {
          return "评论 & 解决讨论";
        }
      }
    }
  },
  created: function created() {
    if (this.discussionId) {
      this.discussion = CommentsStore.state[this.discussionId];
    }
  },

  mounted: function mounted() {
    var _this = this;

    if (!this.discussionId) return;

    var $textarea = $(".js-discussion-note-form[data-discussion-id=" + this.discussionId + "] .note-textarea");
    this.textareaIsEmpty = $textarea.val() === '';

    $textarea.on('input.comment-and-resolve-btn', function () {
      _this.textareaIsEmpty = $textarea.val() === '';
    });
  },
  destroyed: function destroyed() {
    if (!this.discussionId) return;

    $(".js-discussion-note-form[data-discussion-id=" + this.discussionId + "] .note-textarea").off('input.comment-and-resolve-btn');
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('comment-and-resolve-btn', CommentAndResolveBtn);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/diff_note_avatars.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg__ = __webpack_require__("./diff_notes/icons/collapse_icon.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notes__ = __webpack_require__("./notes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_user_avatar_user_avatar_image_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");
/* global CommentsStore */






var DiffNoteAvatars = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: ['discussionId'],
  data: function data() {
    return {
      isVisible: false,
      lineType: '',
      storeState: CommentsStore.state,
      shownAvatars: 3,
      collapseIcon: __WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg___default.a
    };
  },

  components: {
    userAvatarImage: __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_user_avatar_user_avatar_image_vue__["a" /* default */]
  },
  template: '\n    <div class="diff-comment-avatar-holders"\n      :class="discussionClassName"\n      v-show="notesCount !== 0">\n      <div v-if="!isVisible">\n        <!-- FIXME: Pass an alt attribute here for accessibility -->\n        <user-avatar-image\n          v-for="note in notesSubset"\n          :key="note.id"\n          class="diff-comment-avatar js-diff-comment-avatar"\n          @click.native="clickedAvatar($event)"\n          :img-src="note.authorAvatar"\n          :tooltip-text="getTooltipText(note)"\n          :data-line-type="lineType"\n          :size="19"\n          data-html="true"\n        />\n        <span v-if="notesCount > shownAvatars"\n          class="diff-comments-more-count has-tooltip js-diff-comment-avatar"\n          data-container="body"\n          data-placement="top"\n          ref="extraComments"\n          role="button"\n          :data-line-type="lineType"\n          :title="extraNotesTitle"\n          @click="clickedAvatar($event)">{{ moreText }}</span>\n      </div>\n      <button class="diff-notes-collapse js-diff-comment-avatar"\n        type="button"\n        aria-label="Show comments"\n        :data-line-type="lineType"\n        @click="clickedAvatar($event)"\n        v-if="isVisible"\n        v-html="collapseIcon">\n      </button>\n    </div>\n  ',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.addNoCommentClass();
      _this.setDiscussionVisible();

      _this.lineType = $(_this.$el).closest('.diff-line-num').hasClass('old_line') ? 'old' : 'new';
    });

    $(document).on('toggle.comments', function () {
      _this.$nextTick(function () {
        _this.setDiscussionVisible();
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.addNoCommentClass();
    $(document).off('toggle.comments');
  },

  watch: {
    storeState: {
      handler: function handler() {
        var _this2 = this;

        this.$nextTick(function () {
          $('.has-tooltip', _this2.$el).tooltip('fixTitle');

          // We need to add/remove a class to an element that is outside the Vue instance
          _this2.addNoCommentClass();
        });
      },

      deep: true
    }
  },
  computed: {
    discussionClassName: function discussionClassName() {
      return 'js-diff-avatars-' + this.discussionId;
    },
    notesSubset: function notesSubset() {
      var _this3 = this;

      var notes = [];

      if (this.discussion) {
        notes = Object.keys(this.discussion.notes).slice(0, this.shownAvatars).map(function (noteId) {
          return _this3.discussion.notes[noteId];
        });
      }

      return notes;
    },
    extraNotesTitle: function extraNotesTitle() {
      if (this.discussion) {
        var extra = this.discussion.notesCount() - this.shownAvatars;

        return extra + ' more comment' + (extra > 1 ? 's' : '');
      }

      return '';
    },
    discussion: function discussion() {
      return this.storeState[this.discussionId];
    },
    notesCount: function notesCount() {
      if (this.discussion) {
        return this.discussion.notesCount();
      }

      return 0;
    },
    moreText: function moreText() {
      var plusSign = this.notesCount < 100 ? '+' : '';

      return '' + plusSign + (this.notesCount - this.shownAvatars);
    }
  },
  methods: {
    clickedAvatar: function clickedAvatar(e) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__notes__["a" /* default */].instance.onAddDiffNote(e);

      // Toggle the active state of the toggle all button
      this.toggleDiscussionsToggleState();

      this.$nextTick(function () {
        _this4.setDiscussionVisible();

        $('.has-tooltip', _this4.$el).tooltip('fixTitle');
        $('.has-tooltip', _this4.$el).tooltip('hide');
      });
    },
    addNoCommentClass: function addNoCommentClass() {
      var notesCount = this.notesCount;

      $(this.$el).closest('.js-avatar-container').toggleClass('no-comment-btn', notesCount > 0).nextUntil('.js-avatar-container').toggleClass('no-comment-btn', notesCount > 0);
    },
    toggleDiscussionsToggleState: function toggleDiscussionsToggleState() {
      var $notesHolders = $(this.$el).closest('.code').find('.notes_holder');
      var $visibleNotesHolders = $notesHolders.filter(':visible');
      var $toggleDiffCommentsBtn = $(this.$el).closest('.diff-file').find('.js-toggle-diff-comments');

      $toggleDiffCommentsBtn.toggleClass('active', $notesHolders.length === $visibleNotesHolders.length);
    },
    setDiscussionVisible: function setDiscussionVisible() {
      this.isVisible = $('.diffs .notes[data-discussion-id="' + this.discussion.id + '"]').is(':visible');
    },
    getTooltipText: function getTooltipText(note) {
      return note.authorName + ': ' + note.noteTruncated;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('diff-note-avatars', DiffNoteAvatars);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/jump_to_discussion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion__ = __webpack_require__("./diff_notes/mixins/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__mixins_discussion__);
/* eslint-disable comma-dangle, object-shorthand, func-names, no-else-return, guard-for-in, no-restricted-syntax, one-var, space-before-function-paren, no-lonely-if, no-continue, brace-style, max-len, quotes */
/* global DiscussionMixins */
/* global CommentsStore */





var JumpToDiscussion = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  mixins: [DiscussionMixins],
  props: {
    discussionId: String
  },
  data: function data() {
    return {
      discussions: CommentsStore.state,
      discussion: {}
    };
  },
  computed: {
    buttonText: function buttonText() {
      if (this.discussionId) {
        return 'Jump to next unresolved discussion';
      } else {
        return 'Jump to first unresolved discussion';
      }
    },
    allResolved: function allResolved() {
      return this.unresolvedDiscussionCount === 0;
    },
    showButton: function showButton() {
      if (this.discussionId) {
        if (this.unresolvedDiscussionCount > 1) {
          return true;
        } else {
          return this.discussionId !== this.lastResolvedId;
        }
      } else {
        return this.unresolvedDiscussionCount >= 1;
      }
    },
    lastResolvedId: function lastResolvedId() {
      var lastId = void 0;
      for (var discussionId in this.discussions) {
        var discussion = this.discussions[discussionId];

        if (!discussion.isResolved()) {
          lastId = discussion.id;
        }
      }
      return lastId;
    }
  },
  methods: {
    jumpToNextUnresolvedDiscussion: function jumpToNextUnresolvedDiscussion() {
      var discussionsSelector = void 0;
      var discussionIdsInScope = void 0;
      var firstUnresolvedDiscussionId = void 0;
      var nextUnresolvedDiscussionId = void 0;
      var activeTab = window.mrTabs.currentAction;
      var hasDiscussionsToJumpTo = true;
      var jumpToFirstDiscussion = !this.discussionId;

      var discussionIdsForElements = function discussionIdsForElements(elements) {
        return elements.map(function () {
          return $(this).attr('data-discussion-id');
        }).toArray();
      };

      var discussions = this.discussions;

      if (activeTab === 'diffs') {
        discussionsSelector = '.diffs .notes[data-discussion-id]';
        discussionIdsInScope = discussionIdsForElements($(discussionsSelector));

        var unresolvedDiscussionCount = 0;

        for (var i = 0; i < discussionIdsInScope.length; i += 1) {
          var discussionId = discussionIdsInScope[i];
          var discussion = discussions[discussionId];
          if (discussion && !discussion.isResolved()) {
            unresolvedDiscussionCount += 1;
          }
        }

        if (this.discussionId && !this.discussion.isResolved()) {
          // If this is the last unresolved discussion on the diffs tab,
          // there are no discussions to jump to.
          if (unresolvedDiscussionCount === 1) {
            hasDiscussionsToJumpTo = false;
          }
        } else {
          // If there are no unresolved discussions on the diffs tab at all,
          // there are no discussions to jump to.
          if (unresolvedDiscussionCount === 0) {
            hasDiscussionsToJumpTo = false;
          }
        }
      } else if (activeTab !== 'show') {
        // If we are on the commits or builds tabs,
        // there are no discussions to jump to.
        hasDiscussionsToJumpTo = false;
      }

      if (!hasDiscussionsToJumpTo) {
        // If there are no discussions to jump to on the current page,
        // switch to the notes tab and jump to the first disucssion there.
        window.mrTabs.activateTab('show');
        activeTab = 'show';
        jumpToFirstDiscussion = true;
      }

      if (activeTab === 'show') {
        discussionsSelector = '.discussion[data-discussion-id]';
        discussionIdsInScope = discussionIdsForElements($(discussionsSelector));
      }

      var currentDiscussionFound = false;
      for (var _i = 0; _i < discussionIdsInScope.length; _i += 1) {
        var _discussionId = discussionIdsInScope[_i];
        var _discussion = discussions[_discussionId];

        if (!_discussion) {
          // Discussions for comments on commits in this MR don't have a resolved status.
          continue;
        }

        if (!firstUnresolvedDiscussionId && !_discussion.isResolved()) {
          firstUnresolvedDiscussionId = _discussionId;

          if (jumpToFirstDiscussion) {
            break;
          }
        }

        if (!jumpToFirstDiscussion) {
          if (currentDiscussionFound) {
            if (!_discussion.isResolved()) {
              nextUnresolvedDiscussionId = _discussionId;
              break;
            } else {
              continue;
            }
          }

          if (_discussionId === this.discussionId) {
            currentDiscussionFound = true;
          }
        }
      }

      nextUnresolvedDiscussionId = nextUnresolvedDiscussionId || firstUnresolvedDiscussionId;

      if (!nextUnresolvedDiscussionId) {
        return;
      }

      var $target = $(discussionsSelector + '[data-discussion-id="' + nextUnresolvedDiscussionId + '"]');

      if (activeTab === 'show') {
        $target = $target.closest('.note-discussion');

        // If the next discussion is closed, toggle it open.
        if ($target.find('.js-toggle-content').is(':hidden')) {
          $target.find('.js-toggle-button i').trigger('click');
        }
      } else if (activeTab === 'diffs') {
        // Resolved discussions are hidden in the diffs tab by default.
        // If they are marked unresolved on the notes tab, they will still be hidden on the diffs tab.
        // When jumping between unresolved discussions on the diffs tab, we show them.
        $target.closest(".content").show();

        var $notesHolder = $target.closest("tr.notes_holder");

        // Image diff discussions does not use notes_holder
        // so we should keep original $target value in those cases
        if ($notesHolder.length > 0) {
          $target = $notesHolder;
        }

        $target.show();

        // If we are on the diffs tab, we don't scroll to the discussion itself, but to
        // 4 diff lines above it: the line the discussion was in response to + 3 context
        var prevEl = void 0;
        for (var _i2 = 0; _i2 < 4; _i2 += 1) {
          prevEl = $target.prev();

          // If the discussion doesn't have 4 lines above it, we'll have to do with fewer.
          if (!prevEl.hasClass("line_holder")) {
            break;
          }

          $target = prevEl;
        }
      }

      $.scrollTo($target, {
        offset: -150
      });
    }
  },
  created: function created() {
    this.discussion = this.discussions[this.discussionId];
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('jump-to-discussion', JumpToDiscussion);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/new_issue_for_discussion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* global CommentsStore */



var NewIssueForDiscussion = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    discussionId: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      discussions: CommentsStore.state
    };
  },

  computed: {
    discussion: function discussion() {
      return this.discussions[this.discussionId];
    },
    showButton: function showButton() {
      if (this.discussion) return !this.discussion.isResolved();
      return false;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('new-issue-for-discussion-btn', NewIssueForDiscussion);

/***/ }),

/***/ "./diff_notes/components/resolve_btn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* eslint-disable comma-dangle, object-shorthand, func-names, quote-props, no-else-return, camelcase, max-len */
/* global CommentsStore */
/* global ResolveService */




var ResolveBtn = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    noteId: Number,
    discussionId: String,
    resolved: Boolean,
    canResolve: Boolean,
    resolvedBy: String,
    authorName: String,
    authorAvatar: String,
    noteTruncated: String
  },
  data: function data() {
    return {
      discussions: CommentsStore.state,
      loading: false
    };
  },
  watch: {
    'discussions': {
      handler: 'updateTooltip',
      deep: true
    }
  },
  computed: {
    discussion: function discussion() {
      return this.discussions[this.discussionId];
    },
    note: function note() {
      return this.discussion ? this.discussion.getNote(this.noteId) : {};
    },
    buttonText: function buttonText() {
      if (this.isResolved) {
        return 'Resolved by ' + this.resolvedByName;
      } else if (this.canResolve) {
        return '标记为已解决';
      } else {
        return '无法解决';
      }
    },
    isResolved: function isResolved() {
      if (this.note) {
        return this.note.resolved;
      } else {
        return false;
      }
    },
    resolvedByName: function resolvedByName() {
      return this.note.resolved_by;
    }
  },
  methods: {
    updateTooltip: function updateTooltip() {
      var _this = this;

      this.$nextTick(function () {
        $(_this.$refs.button).tooltip('hide').tooltip('fixTitle');
      });
    },
    resolve: function resolve() {
      var _this2 = this;

      if (!this.canResolve) return;

      var promise = void 0;
      this.loading = true;

      if (this.isResolved) {
        promise = ResolveService.unresolve(this.noteId);
      } else {
        promise = ResolveService.resolve(this.noteId);
      }

      promise.then(function (resp) {
        return resp.json();
      }).then(function (data) {
        _this2.loading = false;

        var resolved_by = data ? data.resolved_by : null;

        CommentsStore.update(_this2.discussionId, _this2.noteId, !_this2.isResolved, resolved_by);
        _this2.discussion.updateHeadline(data);
        gl.mrWidget.checkStatus();
        document.dispatchEvent(new CustomEvent('refreshVueNotes'));

        _this2.updateTooltip();
      }).catch(function () {
        return new __WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */]('An error occurred when trying to resolve a comment. Please try again.');
      });
    }
  },
  mounted: function mounted() {
    $(this.$refs.button).tooltip({
      container: 'body'
    });
  },
  beforeDestroy: function beforeDestroy() {
    CommentsStore.delete(this.discussionId, this.noteId);
  },
  created: function created() {
    CommentsStore.create({
      discussionId: this.discussionId,
      noteId: this.noteId,
      canResolve: this.canResolve,
      resolved: this.resolved,
      resolvedBy: this.resolvedBy,
      authorName: this.authorName,
      authorAvatar: this.authorAvatar,
      noteTruncated: this.noteTruncated
    });
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('resolve-btn', ResolveBtn);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/resolve_count.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion__ = __webpack_require__("./diff_notes/mixins/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__mixins_discussion__);
/* eslint-disable comma-dangle, object-shorthand, func-names, no-param-reassign */
/* global DiscussionMixins */
/* global CommentsStore */





window.ResolveCount = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  mixins: [DiscussionMixins],
  props: {
    loggedOut: Boolean
  },
  data: function data() {
    return {
      discussions: CommentsStore.state
    };
  },
  computed: {
    allResolved: function allResolved() {
      return this.resolvedDiscussionCount === this.discussionCount;
    },
    resolvedCountText: function resolvedCountText() {
      return this.discussionCount === 1 ? '讨论' : '讨论';
    }
  }
});

/***/ }),

/***/ "./diff_notes/components/resolve_discussion_btn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable object-shorthand, func-names, space-before-function-paren, comma-dangle, no-else-return, quotes, max-len */
/* global CommentsStore */
/* global ResolveService */



var ResolveDiscussionBtn = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    discussionId: String,
    mergeRequestId: Number,
    canResolve: Boolean
  },
  data: function data() {
    return {
      discussion: {}
    };
  },
  computed: {
    showButton: function showButton() {
      if (this.discussion) {
        return this.discussion.isResolvable();
      } else {
        return false;
      }
    },
    isDiscussionResolved: function isDiscussionResolved() {
      if (this.discussion) {
        return this.discussion.isResolved();
      } else {
        return false;
      }
    },
    buttonText: function buttonText() {
      if (this.isDiscussionResolved) {
        return "Unresolve discussion";
      } else {
        return "Resolve discussion";
      }
    },
    loading: function loading() {
      if (this.discussion) {
        return this.discussion.loading;
      } else {
        return false;
      }
    }
  },
  methods: {
    resolve: function resolve() {
      ResolveService.toggleResolveForDiscussion(this.mergeRequestId, this.discussionId);
    }
  },
  created: function created() {
    CommentsStore.createDiscussion(this.discussionId, this.canResolve);

    this.discussion = CommentsStore.state[this.discussionId];
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('resolve-discussion-btn', ResolveDiscussionBtn);

/***/ }),

/***/ "./diff_notes/diff_notes_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_discussion__ = __webpack_require__("./diff_notes/models/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_note__ = __webpack_require__("./diff_notes/models/note.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__models_note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_comments__ = __webpack_require__("./diff_notes/stores/comments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_resolve__ = __webpack_require__("./diff_notes/services/resolve.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_discussion__ = __webpack_require__("./diff_notes/mixins/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_discussion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__mixins_discussion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_comment_resolve_btn__ = __webpack_require__("./diff_notes/components/comment_resolve_btn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_jump_to_discussion__ = __webpack_require__("./diff_notes/components/jump_to_discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_resolve_btn__ = __webpack_require__("./diff_notes/components/resolve_btn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_resolve_count__ = __webpack_require__("./diff_notes/components/resolve_count.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_resolve_discussion_btn__ = __webpack_require__("./diff_notes/components/resolve_discussion_btn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_diff_note_avatars__ = __webpack_require__("./diff_notes/components/diff_note_avatars.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_new_issue_for_discussion__ = __webpack_require__("./diff_notes/components/new_issue_for_discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* eslint-disable func-names, comma-dangle, new-cap, no-new, max-len */
/* global ResolveCount */
















/* harmony default export */ __webpack_exports__["a"] = (function () {
  var projectPathHolder = document.querySelector('.merge-request') || document.querySelector('.commit-box');
  var projectPath = projectPathHolder.dataset.projectPath;
  var COMPONENT_SELECTOR = 'resolve-btn, resolve-discussion-btn, jump-to-discussion, comment-and-resolve-btn, new-issue-for-discussion-btn';

  window.gl = window.gl || {};
  window.gl.diffNoteApps = {};

  window.ResolveService = new gl.DiffNotesResolveServiceClass(projectPath);

  gl.diffNotesCompileComponents = function () {
    $('diff-note-avatars').each(function () {
      var tmp = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
        template: $(this).get(0).outerHTML
      });
      var tmpApp = new tmp().$mount();

      $(this).replaceWith(tmpApp.$el);
      $(tmpApp.$el).one('remove.vue', function () {
        tmpApp.$destroy();
        tmpApp.$el.remove();
      });
    });

    var $components = $(COMPONENT_SELECTOR).filter(function () {
      return $(this).closest('resolve-count').length !== 1;
    });

    if ($components) {
      $components.each(function () {
        var $this = $(this);
        var noteId = $this.attr(':note-id');
        var discussionId = $this.attr(':discussion-id');

        if ($this.is('comment-and-resolve-btn') && !discussionId) return;

        var tmp = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
          template: $this.get(0).outerHTML
        });
        var tmpApp = new tmp().$mount();

        if (noteId) {
          gl.diffNoteApps['note_' + noteId] = tmpApp;
        }

        $this.replaceWith(tmpApp.$el);
      });
    }
  };

  gl.diffNotesCompileComponents();

  if (!Object(__WEBPACK_IMPORTED_MODULE_13__lib_utils_common_utils__["n" /* hasVueMRDiscussionsCookie */])()) {
    new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
      el: '#resolve-count-app',
      components: {
        'resolve-count': ResolveCount
      }
    });
  }

  $(window).trigger('resize.nav');
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/icons/collapse_icon.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"11\" height=\"11\" viewBox=\"0 0 9 13\"><path d=\"M2.57568253,6.49866948 C2.50548852,6.57199715 2.44637866,6.59708255 2.39835118,6.57392645 C2.3503237,6.55077034 2.32631032,6.48902165 2.32631032,6.38867852 L2.32631032,-2.13272614 C2.32631032,-2.23306927 2.3503237,-2.29481796 2.39835118,-2.31797406 C2.44637866,-2.34113017 2.50548852,-2.31604477 2.57568253,-2.24271709 L6.51022184,1.86747129 C6.53977721,1.8983461 6.56379059,1.93500939 6.5822627,1.97746225 L6.5822627,2.27849013 C6.56379059,2.31708364 6.53977721,2.35374693 6.51022184,2.38848109 L2.57568253,6.49866948 Z\" transform=\"translate(4.454287, 2.127976) rotate(90.000000) translate(-4.454287, -2.127976) \"></path><path d=\"M3.74312342,2.09553332 C3.74312342,1.99519019 3.77821989,1.9083561 3.8484139,1.83502843 C3.91860791,1.76170075 4.00173115,1.72503747 4.09778611,1.72503747 L4.80711151,1.72503747 C4.90316647,1.72503747 4.98628971,1.76170075 5.05648372,1.83502843 C5.12667773,1.9083561 5.16177421,1.99519019 5.16177421,2.09553332 L5.16177421,10.2464421 C5.16177421,10.3467853 5.12667773,10.4336194 5.05648372,10.506947 C4.98628971,10.5802747 4.90316647,10.616938 4.80711151,10.616938 L4.09778611,10.616938 C4.00173115,10.616938 3.91860791,10.5802747 3.8484139,10.506947 C3.77821989,10.4336194 3.74312342,10.3467853 3.74312342,10.2464421 L3.74312342,2.09553332 Z\" transform=\"translate(4.452449, 6.170988) rotate(-90.000000) translate(-4.452449, -6.170988) \"></path><path d=\"M2.57568253,14.6236695 C2.50548852,14.6969971 2.44637866,14.7220826 2.39835118,14.6989264 C2.3503237,14.6757703 2.32631032,14.6140216 2.32631032,14.5136785 L2.32631032,5.99227386 C2.32631032,5.89193073 2.3503237,5.83018204 2.39835118,5.80702594 C2.44637866,5.78386983 2.50548852,5.80895523 2.57568253,5.88228291 L6.51022184,9.99247129 C6.53977721,10.0233461 6.56379059,10.0600094 6.5822627,10.1024622 L6.5822627,10.4034901 C6.56379059,10.4420836 6.53977721,10.4787469 6.51022184,10.5134811 L2.57568253,14.6236695 Z\" transform=\"translate(4.454287, 10.252976) scale(1, -1) rotate(90.000000) translate(-4.454287, -10.252976) \"></path></svg>\n"

/***/ }),

/***/ "./diff_notes/mixins/discussion.js":
/***/ (function(module, exports) {

/* eslint-disable object-shorthand, func-names, guard-for-in, no-restricted-syntax, comma-dangle, no-param-reassign, max-len */

window.DiscussionMixins = {
  computed: {
    discussionCount: function discussionCount() {
      return Object.keys(this.discussions).length;
    },
    resolvedDiscussionCount: function resolvedDiscussionCount() {
      var resolvedCount = 0;

      for (var discussionId in this.discussions) {
        var discussion = this.discussions[discussionId];

        if (discussion.isResolved()) {
          resolvedCount += 1;
        }
      }

      return resolvedCount;
    },
    unresolvedDiscussionCount: function unresolvedDiscussionCount() {
      var unresolvedCount = 0;

      for (var discussionId in this.discussions) {
        var discussion = this.discussions[discussionId];

        if (!discussion.isResolved()) {
          unresolvedCount += 1;
        }
      }

      return unresolvedCount;
    }
  }
};

/***/ }),

/***/ "./diff_notes/models/discussion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable space-before-function-paren, camelcase, guard-for-in, no-restricted-syntax, no-unused-vars, max-len */
/* global NoteModel */




var DiscussionModel = function () {
  function DiscussionModel(discussionId) {
    _classCallCheck(this, DiscussionModel);

    this.id = discussionId;
    this.notes = {};
    this.loading = false;
    this.canResolve = false;
  }

  _createClass(DiscussionModel, [{
    key: 'createNote',
    value: function createNote(noteObj) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.notes, noteObj.noteId, new NoteModel(this.id, noteObj));
    }
  }, {
    key: 'deleteNote',
    value: function deleteNote(noteId) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].delete(this.notes, noteId);
    }
  }, {
    key: 'getNote',
    value: function getNote(noteId) {
      return this.notes[noteId];
    }
  }, {
    key: 'notesCount',
    value: function notesCount() {
      return Object.keys(this.notes).length;
    }
  }, {
    key: 'isResolved',
    value: function isResolved() {
      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (!note.resolved) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: 'resolveAllNotes',
    value: function resolveAllNotes(resolved_by) {
      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (!note.resolved) {
          note.resolved = true;
          note.resolved_by = resolved_by;
        }
      }
    }
  }, {
    key: 'unResolveAllNotes',
    value: function unResolveAllNotes() {
      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (note.resolved) {
          note.resolved = false;
          note.resolved_by = null;
        }
      }
    }
  }, {
    key: 'updateHeadline',
    value: function updateHeadline(data) {
      var discussionSelector = '.discussion[data-discussion-id="' + this.id + '"]';
      var $discussionHeadline = $(discussionSelector + ' .js-discussion-headline');

      if (data.discussion_headline_html) {
        if ($discussionHeadline.length) {
          $discussionHeadline.replaceWith(data.discussion_headline_html);
        } else {
          $(discussionSelector + ' .discussion-header').append(data.discussion_headline_html);
        }

        Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_datetime_utility__["e" /* localTimeAgo */])($('.js-timeago', '' + discussionSelector));
      } else {
        $discussionHeadline.remove();
      }
    }
  }, {
    key: 'isResolvable',
    value: function isResolvable() {
      if (!this.canResolve) {
        return false;
      }

      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (note.canResolve) {
          return true;
        }
      }

      return false;
    }
  }]);

  return DiscussionModel;
}();

window.DiscussionModel = DiscussionModel;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/models/note.js":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable camelcase, no-unused-vars */

var NoteModel = function NoteModel(discussionId, noteObj) {
  _classCallCheck(this, NoteModel);

  this.discussionId = discussionId;
  this.id = noteObj.noteId;
  this.canResolve = noteObj.canResolve;
  this.resolved = noteObj.resolved;
  this.resolved_by = noteObj.resolvedBy;
  this.authorName = noteObj.authorName;
  this.authorAvatar = noteObj.authorAvatar;
  this.noteTruncated = noteObj.noteTruncated;
};

window.NoteModel = NoteModel;

/***/ }),

/***/ "./diff_notes/services/resolve.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_vue_resource_interceptor__ = __webpack_require__("./vue_shared/vue_resource_interceptor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global CommentsStore */





window.gl = window.gl || {};

var ResolveServiceClass = function () {
  function ResolveServiceClass(root) {
    _classCallCheck(this, ResolveServiceClass);

    this.noteResource = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].resource(root + '/notes{/noteId}/resolve?html=true');
    this.discussionResource = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].resource(root + '/merge_requests{/mergeRequestId}/discussions{/discussionId}/resolve?html=true');
  }

  _createClass(ResolveServiceClass, [{
    key: 'resolve',
    value: function resolve(noteId) {
      return this.noteResource.save({ noteId: noteId }, {});
    }
  }, {
    key: 'unresolve',
    value: function unresolve(noteId) {
      return this.noteResource.delete({ noteId: noteId }, {});
    }
  }, {
    key: 'toggleResolveForDiscussion',
    value: function toggleResolveForDiscussion(mergeRequestId, discussionId) {
      var discussion = CommentsStore.state[discussionId];
      var isResolved = discussion.isResolved();
      var promise = void 0;

      if (isResolved) {
        promise = this.unResolveAll(mergeRequestId, discussionId);
      } else {
        promise = this.resolveAll(mergeRequestId, discussionId);
      }

      promise.then(function (resp) {
        return resp.json();
      }).then(function (data) {
        discussion.loading = false;
        var resolvedBy = data ? data.resolved_by : null;

        if (isResolved) {
          discussion.unResolveAllNotes();
        } else {
          discussion.resolveAllNotes(resolvedBy);
        }

        if (gl.mrWidget) gl.mrWidget.checkStatus();
        discussion.updateHeadline(data);
        document.dispatchEvent(new CustomEvent('refreshVueNotes'));
      }).catch(function () {
        return new __WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */]('An error occurred when trying to resolve a discussion. Please try again.');
      });
    }
  }, {
    key: 'resolveAll',
    value: function resolveAll(mergeRequestId, discussionId) {
      var discussion = CommentsStore.state[discussionId];

      discussion.loading = true;

      return this.discussionResource.save({
        mergeRequestId: mergeRequestId,
        discussionId: discussionId
      }, {});
    }
  }, {
    key: 'unResolveAll',
    value: function unResolveAll(mergeRequestId, discussionId) {
      var discussion = CommentsStore.state[discussionId];

      discussion.loading = true;

      return this.discussionResource.delete({
        mergeRequestId: mergeRequestId,
        discussionId: discussionId
      }, {});
    }
  }]);

  return ResolveServiceClass;
}();

gl.DiffNotesResolveServiceClass = ResolveServiceClass;

/***/ }),

/***/ "./diff_notes/stores/comments.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable object-shorthand, func-names, camelcase, no-restricted-syntax, guard-for-in, comma-dangle, max-len, no-param-reassign */
/* global DiscussionModel */



window.CommentsStore = {
  state: {},
  get: function get(discussionId, noteId) {
    return this.state[discussionId].getNote(noteId);
  },
  createDiscussion: function createDiscussion(discussionId, canResolve) {
    var discussion = this.state[discussionId];
    if (!this.state[discussionId]) {
      discussion = new DiscussionModel(discussionId);
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.state, discussionId, discussion);
    }

    if (canResolve !== undefined) {
      discussion.canResolve = canResolve;
    }

    return discussion;
  },
  create: function create(noteObj) {
    var discussion = this.createDiscussion(noteObj.discussionId);

    discussion.createNote(noteObj);
  },
  update: function update(discussionId, noteId, resolved, resolved_by) {
    var discussion = this.state[discussionId];
    var note = discussion.getNote(noteId);
    note.resolved = resolved;
    note.resolved_by = resolved_by;
  },
  delete: function _delete(discussionId, noteId) {
    var discussion = this.state[discussionId];
    discussion.deleteNote(noteId);

    if (discussion.notesCount() === 0) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].delete(this.state, discussionId);
    }
  },
  unresolvedDiscussionIds: function unresolvedDiscussionIds() {
    var ids = [];

    for (var discussionId in this.state) {
      var discussion = this.state[discussionId];

      if (!discussion.isResolved()) {
        ids.push(discussion.id);
      }
    }

    return ids;
  }
};

/***/ }),

/***/ "./droplab/plugins/input_setter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */

var InputSetter = {
  init: function init(hook) {
    this.hook = hook;
    this.destroyed = false;
    this.config = hook.config.InputSetter || (this.hook.config.InputSetter = {});

    this.eventWrapper = {};

    this.addEvents();
  },
  addEvents: function addEvents() {
    this.eventWrapper.setInputs = this.setInputs.bind(this);
    this.hook.list.list.addEventListener('click.dl', this.eventWrapper.setInputs);
  },
  removeEvents: function removeEvents() {
    this.hook.list.list.removeEventListener('click.dl', this.eventWrapper.setInputs);
  },
  setInputs: function setInputs(e) {
    var _this = this;

    if (this.destroyed) return;

    var selectedItem = e.detail.selected;

    if (!Array.isArray(this.config)) this.config = [this.config];

    this.config.forEach(function (config) {
      return _this.setInput(config, selectedItem);
    });
  },
  setInput: function setInput(config, selectedItem) {
    var input = config.input || this.hook.trigger;
    var newValue = selectedItem.getAttribute(config.valueAttribute);
    var inputAttribute = config.inputAttribute;

    if (input.hasAttribute(inputAttribute)) return input.setAttribute(inputAttribute, newValue);
    if (input.tagName === 'INPUT') return input.value = newValue;
    return input.textContent = newValue;
  },
  destroy: function destroy() {
    this.destroyed = true;

    this.removeEvents();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (InputSetter);

/***/ }),

/***/ "./dropzone_input.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = dropzoneInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dropzone__ = __webpack_require__("../../../node_modules/dropzone/dist/dropzone.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preview_markdown__ = __webpack_require__("./preview_markdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_csrf__ = __webpack_require__("./lib/utils/csrf.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");






__WEBPACK_IMPORTED_MODULE_0_dropzone___default.a.autoDiscover = false;

function dropzoneInput(form) {
  var divHover = '<div class="div-dropzone-hover"></div>';
  var iconPaperclip = '<i class="fa fa-paperclip div-dropzone-icon"></i>';
  var $attachButton = form.find('.button-attach-file');
  var $attachingFileMessage = form.find('.attaching-file-message');
  var $cancelButton = form.find('.button-cancel-uploading-files');
  var $retryLink = form.find('.retry-uploading-link');
  var $uploadProgress = form.find('.uploading-progress');
  var $uploadingErrorContainer = form.find('.uploading-error-container');
  var $uploadingErrorMessage = form.find('.uploading-error-message');
  var $uploadingProgressContainer = form.find('.uploading-progress-container');
  var uploadsPath = window.uploads_path || null;
  var maxFileSize = gon.max_file_size || 10;
  var formTextarea = form.find('.js-gfm-input');
  var handlePaste = void 0;
  var pasteText = void 0;
  var addFileToForm = void 0;
  var updateAttachingMessage = void 0;
  var isImage = void 0;
  var getFilename = void 0;
  var uploadFile = void 0;

  formTextarea.wrap('<div class="div-dropzone"></div>');
  formTextarea.on('paste', function (event) {
    return handlePaste(event);
  });

  // Add dropzone area to the form.
  var $mdArea = formTextarea.closest('.md-area');
  form.setupMarkdownPreview();
  var $formDropzone = form.find('.div-dropzone');
  $formDropzone.parent().addClass('div-dropzone-wrapper');
  $formDropzone.append(divHover);
  $formDropzone.find('.div-dropzone-hover').append(iconPaperclip);

  if (!uploadsPath) {
    $formDropzone.addClass('js-invalid-dropzone');
    return;
  }

  var dropzone = $formDropzone.dropzone({
    url: uploadsPath,
    dictDefaultMessage: '',
    clickable: true,
    paramName: 'file',
    maxFilesize: maxFileSize,
    uploadMultiple: false,
    headers: __WEBPACK_IMPORTED_MODULE_3__lib_utils_csrf__["a" /* default */].headers,
    previewContainer: false,
    processing: function processing() {
      return $('.div-dropzone-alert').alert('close');
    },
    dragover: function dragover() {
      $mdArea.addClass('is-dropzone-hover');
      form.find('.div-dropzone-hover').css('opacity', 0.7);
    },
    dragleave: function dragleave() {
      $mdArea.removeClass('is-dropzone-hover');
      form.find('.div-dropzone-hover').css('opacity', 0);
    },
    drop: function drop() {
      $mdArea.removeClass('is-dropzone-hover');
      form.find('.div-dropzone-hover').css('opacity', 0);
      formTextarea.focus();
    },
    success: function success(header, response) {
      var processingFileCount = this.getQueuedFiles().length + this.getUploadingFiles().length;
      var shouldPad = processingFileCount >= 1;

      pasteText(response.link.markdown, shouldPad);
      // Show 'Attach a file' link only when all files have been uploaded.
      if (!processingFileCount) $attachButton.removeClass('hide');
      addFileToForm(response.link.url);
    },

    error: function error(file) {
      var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Attaching the file failed.';
      var xhr = arguments[2];

      // If 'error' event is fired by dropzone, the second parameter is error message.
      // If the 'errorMessage' parameter is empty, the default error message is set.
      // If the 'error' event is fired by backend (xhr) error response, the third parameter is
      // xhr object (xhr.responseText is error message).
      // On error we hide the 'Attach' and 'Cancel' buttons
      // and show an error.

      // If there's xhr error message, let's show it instead of dropzone's one.
      var message = xhr ? xhr.responseText : errorMessage;

      $uploadingErrorContainer.removeClass('hide');
      $uploadingErrorMessage.html(message);
      $attachButton.addClass('hide');
      $cancelButton.addClass('hide');
    },
    totaluploadprogress: function totaluploadprogress(totalUploadProgress) {
      updateAttachingMessage(this.files, $attachingFileMessage);
      $uploadProgress.text(Math.round(totalUploadProgress) + '%');
    },

    sending: function sending() {
      // DOM elements already exist.
      // Instead of dynamically generating them,
      // we just either hide or show them.
      $attachButton.addClass('hide');
      $uploadingErrorContainer.addClass('hide');
      $uploadingProgressContainer.removeClass('hide');
      $cancelButton.removeClass('hide');
    },
    removedfile: function removedfile() {
      $attachButton.removeClass('hide');
      $cancelButton.addClass('hide');
      $uploadingProgressContainer.addClass('hide');
      $uploadingErrorContainer.addClass('hide');
    },
    queuecomplete: function queuecomplete() {
      $('.dz-preview').remove();
      $('.markdown-area').trigger('input');

      $uploadingProgressContainer.addClass('hide');
      $cancelButton.addClass('hide');
    }
  });

  var child = $(dropzone[0]).children('textarea');

  // removeAllFiles(true) stops uploading files (if any)
  // and remove them from dropzone files queue.
  $cancelButton.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    __WEBPACK_IMPORTED_MODULE_0_dropzone___default.a.forElement($formDropzone.get(0)).removeAllFiles(true);
  });

  // If 'error' event is fired, we store a failed files,
  // clear dropzone files queue, change status of failed files to undefined,
  // and add that files to the dropzone files queue again.
  // addFile() adds file to dropzone files queue and upload it.
  $retryLink.on('click', function (e) {
    var dropzoneInstance = __WEBPACK_IMPORTED_MODULE_0_dropzone___default.a.forElement(e.target.closest('.js-main-target-form').querySelector('.div-dropzone'));
    var failedFiles = dropzoneInstance.files;

    e.preventDefault();

    // 'true' parameter of removeAllFiles() cancels
    // uploading of files that are being uploaded at the moment.
    dropzoneInstance.removeAllFiles(true);

    failedFiles.map(function (failedFile) {
      var file = failedFile;

      if (file.status === __WEBPACK_IMPORTED_MODULE_0_dropzone___default.a.ERROR) {
        file.status = undefined;
        file.accepted = undefined;
      }

      return dropzoneInstance.addFile(file);
    });
  });
  // eslint-disable-next-line consistent-return
  handlePaste = function handlePaste(event) {
    var pasteEvent = event.originalEvent;
    if (pasteEvent.clipboardData && pasteEvent.clipboardData.items) {
      var image = isImage(pasteEvent);
      if (image) {
        event.preventDefault();
        var filename = getFilename(pasteEvent) || 'image.png';
        var text = '{{' + filename + '}}';
        pasteText(text);
        return uploadFile(image.getAsFile(), filename);
      }
    }
  };

  isImage = function isImage(data) {
    var i = 0;
    while (i < data.clipboardData.items.length) {
      var item = data.clipboardData.items[i];
      if (item.type.indexOf('image') !== -1) {
        return item;
      }
      i += 1;
    }
    return false;
  };

  pasteText = function pasteText(text, shouldPad) {
    var formattedText = text;
    if (shouldPad) {
      formattedText += '\n\n';
    }
    var textarea = child.get(0);
    var caretStart = textarea.selectionStart;
    var caretEnd = textarea.selectionEnd;
    var textEnd = $(child).val().length;
    var beforeSelection = $(child).val().substring(0, caretStart);
    var afterSelection = $(child).val().substring(caretEnd, textEnd);
    $(child).val(beforeSelection + formattedText + afterSelection);
    textarea.setSelectionRange(caretStart + formattedText.length, caretEnd + formattedText.length);
    textarea.style.height = textarea.scrollHeight + 'px';
    formTextarea.get(0).dispatchEvent(new Event('input'));
    return formTextarea.trigger('input');
  };

  addFileToForm = function addFileToForm(path) {
    $(form).append('<input type="hidden" name="files[]" value="' + __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.escape(path) + '">');
  };

  getFilename = function getFilename(e) {
    var value = void 0;
    if (window.clipboardData && window.clipboardData.getData) {
      value = window.clipboardData.getData('Text');
    } else if (e.clipboardData && e.clipboardData.getData) {
      value = e.clipboardData.getData('text/plain');
    }
    value = value.split('\r');
    return value[0];
  };

  var showSpinner = function showSpinner() {
    return $uploadingProgressContainer.removeClass('hide');
  };

  var closeSpinner = function closeSpinner() {
    return $uploadingProgressContainer.addClass('hide');
  };

  var showError = function showError(message) {
    $uploadingErrorContainer.removeClass('hide');
    $uploadingErrorMessage.html(message);
  };

  var closeAlertMessage = function closeAlertMessage() {
    return form.find('.div-dropzone-alert').alert('close');
  };

  var insertToTextArea = function insertToTextArea(filename, url) {
    var $child = $(child);
    $child.val(function (index, val) {
      return val.replace('{{' + filename + '}}', url);
    });

    $child.trigger('change');
  };

  uploadFile = function uploadFile(item, filename) {
    var formData = new FormData();
    formData.append('file', item, filename);

    showSpinner();
    closeAlertMessage();

    __WEBPACK_IMPORTED_MODULE_4__lib_utils_axios_utils__["a" /* default */].post(uploadsPath, formData).then(function (_ref) {
      var data = _ref.data;

      var md = data.link.markdown;

      insertToTextArea(filename, md);
      closeSpinner();
    }).catch(function (e) {
      showError(e.response.data.message);
      closeSpinner();
    });
  };

  updateAttachingMessage = function updateAttachingMessage(files, messageContainer) {
    var attachingMessage = void 0;
    var filesCount = files.filter(function (file) {
      return file.status === 'uploading' || file.status === 'queued';
    }).length;

    // Dinamycally change uploading files text depending on files number in
    // dropzone files queue.
    if (filesCount > 1) {
      attachingMessage = 'Attaching ' + filesCount + ' files -';
    } else {
      attachingMessage = 'Attaching a file -';
    }

    messageContainer.text(attachingMessage);
  };

  form.find('.markdown-selector').click(function onMarkdownClick(e) {
    e.preventDefault();
    $(this).closest('.gfm-form').find('.div-dropzone').click();
    formTextarea.focus();
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./due_date_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday__ = __webpack_require__("../../../node_modules/pikaday/pikaday.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pikaday__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__ = __webpack_require__("./lib/utils/datefix.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global dateFormat */





var DueDateSelect = function () {
  function DueDateSelect() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        $dropdown = _ref.$dropdown,
        $loading = _ref.$loading;

    _classCallCheck(this, DueDateSelect);

    var $dropdownParent = $dropdown.closest('.dropdown');
    var $block = $dropdown.closest('.block');
    this.$loading = $loading;
    this.$dropdown = $dropdown;
    this.$dropdownParent = $dropdownParent;
    this.$datePicker = $dropdownParent.find('.js-due-date-calendar');
    this.$block = $block;
    this.$selectbox = $dropdown.closest('.selectbox');
    this.$value = $block.find('.value');
    this.$valueContent = $block.find('.value-content');
    this.$sidebarValue = $('.js-due-date-sidebar-value', $block);
    this.fieldName = $dropdown.data('fieldName');
    this.abilityName = $dropdown.data('abilityName');
    this.issueUpdateURL = $dropdown.data('issueUpdate');

    this.rawSelectedDate = null;
    this.displayedDate = null;
    this.datePayload = null;

    this.initGlDropdown();
    this.initRemoveDueDate();
    this.initDatePicker();
  }

  _createClass(DueDateSelect, [{
    key: 'initGlDropdown',
    value: function initGlDropdown() {
      var _this = this;

      this.$dropdown.glDropdown({
        opened: function opened() {
          var calendar = _this.$datePicker.data('pikaday');
          calendar.show();
        },
        hidden: function hidden() {
          _this.$selectbox.hide();
          _this.$value.css('display', '');
        }
      });
    }
  }, {
    key: 'initDatePicker',
    value: function initDatePicker() {
      var _this2 = this;

      var $dueDateInput = $('input[name=\'' + this.fieldName + '\']');
      var calendar = new __WEBPACK_IMPORTED_MODULE_0_pikaday___default.a({
        field: $dueDateInput.get(0),
        theme: 'gitlab-theme',
        format: 'yyyy-mm-dd',
        parse: function parse(dateString) {
          return Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["a" /* parsePikadayDate */])(dateString);
        },
        toString: function toString(date) {
          return Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["b" /* pikadayToString */])(date);
        },
        onSelect: function onSelect(dateText) {
          $dueDateInput.val(calendar.toString(dateText));

          if (_this2.$dropdown.hasClass('js-issue-boards-due-date')) {
            gl.issueBoards.BoardsStore.detail.issue.dueDate = $dueDateInput.val();
            _this2.updateIssueBoardIssue();
          } else {
            _this2.saveDueDate(true);
          }
        }
      });

      calendar.setDate(Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["a" /* parsePikadayDate */])($dueDateInput.val()));
      this.$datePicker.append(calendar.el);
      this.$datePicker.data('pikaday', calendar);
    }
  }, {
    key: 'initRemoveDueDate',
    value: function initRemoveDueDate() {
      var _this3 = this;

      this.$block.on('click', '.js-remove-due-date', function (e) {
        var calendar = _this3.$datePicker.data('pikaday');
        e.preventDefault();

        calendar.setDate(null);

        if (_this3.$dropdown.hasClass('js-issue-boards-due-date')) {
          gl.issueBoards.BoardsStore.detail.issue.dueDate = '';
          _this3.updateIssueBoardIssue();
        } else {
          $('input[name=\'' + _this3.fieldName + '\']').val('');
          _this3.saveDueDate(false);
        }
      });
    }
  }, {
    key: 'saveDueDate',
    value: function saveDueDate(isDropdown) {
      this.parseSelectedDate();
      this.prepSelectedDate();
      this.submitSelectedDate(isDropdown);
    }
  }, {
    key: 'parseSelectedDate',
    value: function parseSelectedDate() {
      this.rawSelectedDate = $('input[name=\'' + this.fieldName + '\']').val();

      if (this.rawSelectedDate.length) {
        // Construct Date object manually to avoid buggy dateString support within Date constructor
        var dateArray = this.rawSelectedDate.split('-').map(function (v) {
          return parseInt(v, 10);
        });
        var dateObj = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
        this.displayedDate = dateFormat(dateObj, 'mmm d, yyyy');
      } else {
        this.displayedDate = 'No due date';
      }
    }
  }, {
    key: 'prepSelectedDate',
    value: function prepSelectedDate() {
      var datePayload = {};
      datePayload[this.abilityName] = {};
      datePayload[this.abilityName].due_date = this.rawSelectedDate;
      this.datePayload = datePayload;
    }
  }, {
    key: 'updateIssueBoardIssue',
    value: function updateIssueBoardIssue() {
      var _this4 = this;

      this.$loading.fadeIn();
      this.$dropdown.trigger('loading.gl.dropdown');
      this.$selectbox.hide();
      this.$value.css('display', '');
      var fadeOutLoader = function fadeOutLoader() {
        _this4.$loading.fadeOut();
      };

      gl.issueBoards.BoardsStore.detail.issue.update(this.$dropdown.attr('data-issue-update')).then(fadeOutLoader).catch(fadeOutLoader);
    }
  }, {
    key: 'submitSelectedDate',
    value: function submitSelectedDate(isDropdown) {
      var _this5 = this;

      var selectedDateValue = this.datePayload[this.abilityName].due_date;
      var displayedDateStyle = this.displayedDate !== 'No due date' ? 'bold' : 'no-value';

      this.$loading.removeClass('hidden').fadeIn();

      if (isDropdown) {
        this.$dropdown.trigger('loading.gl.dropdown');
        this.$selectbox.hide();
      }

      this.$value.css('display', '');
      this.$valueContent.html('<span class=\'' + displayedDateStyle + '\'>' + this.displayedDate + '</span>');
      this.$sidebarValue.html(this.displayedDate);

      $('.js-remove-due-date-holder').toggleClass('hidden', selectedDateValue.length);

      return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].put(this.issueUpdateURL, this.datePayload).then(function () {
        if (isDropdown) {
          _this5.$dropdown.trigger('loaded.gl.dropdown');
          _this5.$dropdown.dropdown('toggle');
        }
        return _this5.$loading.fadeOut();
      });
    }
  }]);

  return DueDateSelect;
}();

var DueDateSelectors = function () {
  function DueDateSelectors() {
    _classCallCheck(this, DueDateSelectors);

    this.initMilestoneDatePicker();
    this.initIssuableSelect();
  }
  // eslint-disable-next-line class-methods-use-this


  _createClass(DueDateSelectors, [{
    key: 'initMilestoneDatePicker',
    value: function initMilestoneDatePicker() {
      $('.datepicker').each(function initPikadayMilestone() {
        var $datePicker = $(this);
        var calendar = new __WEBPACK_IMPORTED_MODULE_0_pikaday___default.a({
          field: $datePicker.get(0),
          theme: 'gitlab-theme animate-picker',
          format: 'yyyy-mm-dd',
          container: $datePicker.parent().get(0),
          parse: function parse(dateString) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["a" /* parsePikadayDate */])(dateString);
          },
          toString: function toString(date) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["b" /* pikadayToString */])(date);
          },
          onSelect: function onSelect(dateText) {
            $datePicker.val(calendar.toString(dateText));
          }
        });

        calendar.setDate(Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["a" /* parsePikadayDate */])($datePicker.val()));

        $datePicker.data('pikaday', calendar);
      });

      $('.js-clear-due-date,.js-clear-start-date').on('click', function (e) {
        e.preventDefault();
        var calendar = $(e.target).siblings('.datepicker').data('pikaday');
        calendar.setDate(null);
      });
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'initIssuableSelect',
    value: function initIssuableSelect() {
      var $loading = $('.js-issuable-update .due_date').find('.block-loading').hide();

      $('.js-due-date-select').each(function (i, dropdown) {
        var $dropdown = $(dropdown);
        // eslint-disable-next-line no-new
        new DueDateSelect({
          $dropdown: $dropdown,
          $loading: $loading
        });
      });
    }
  }]);

  return DueDateSelectors;
}();

/* harmony default export */ __webpack_exports__["a"] = (DueDateSelectors);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./emoji/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validEmojiNames", function() { return validEmojiNames; });
/* harmony export (immutable) */ __webpack_exports__["normalizeEmojiName"] = normalizeEmojiName;
/* harmony export (immutable) */ __webpack_exports__["isEmojiNameValid"] = isEmojiNameValid;
/* harmony export (immutable) */ __webpack_exports__["filterEmojiNames"] = filterEmojiNames;
/* harmony export (immutable) */ __webpack_exports__["filterEmojiNamesByAlias"] = filterEmojiNamesByAlias;
/* harmony export (immutable) */ __webpack_exports__["getEmojiCategoryMap"] = getEmojiCategoryMap;
/* harmony export (immutable) */ __webpack_exports__["getEmojiInfo"] = getEmojiInfo;
/* harmony export (immutable) */ __webpack_exports__["emojiFallbackImageSrc"] = emojiFallbackImageSrc;
/* harmony export (immutable) */ __webpack_exports__["emojiImageTag"] = emojiImageTag;
/* harmony export (immutable) */ __webpack_exports__["glEmojiTag"] = glEmojiTag;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emojis_digests_json__ = __webpack_require__("../../../fixtures/emojis/digests.json");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emojis_digests_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_emojis_digests_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json__ = __webpack_require__("../../../fixtures/emojis/aliases.json");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var validEmojiNames = [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_1_emojis_digests_json___default.a)), _toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json___default.a)));

function normalizeEmojiName(name) {
  return Object.prototype.hasOwnProperty.call(__WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json___default.a, name) ? __WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json___default.a[name] : name;
}

function isEmojiNameValid(name) {
  return validEmojiNames.indexOf(name) >= 0;
}

function filterEmojiNames(filter) {
  var match = filter.toLowerCase();
  return validEmojiNames.filter(function (name) {
    return name.indexOf(match) >= 0;
  });
}

function filterEmojiNamesByAlias(filter) {
  return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.uniq(filterEmojiNames(filter).map(function (name) {
    return normalizeEmojiName(name);
  }));
}

var emojiCategoryMap = void 0;
function getEmojiCategoryMap() {
  if (!emojiCategoryMap) {
    emojiCategoryMap = {
      activity: [],
      people: [],
      nature: [],
      food: [],
      travel: [],
      objects: [],
      symbols: [],
      flags: []
    };
    Object.keys(__WEBPACK_IMPORTED_MODULE_1_emojis_digests_json___default.a).forEach(function (name) {
      var emoji = __WEBPACK_IMPORTED_MODULE_1_emojis_digests_json___default.a[name];
      if (emojiCategoryMap[emoji.category]) {
        emojiCategoryMap[emoji.category].push(name);
      }
    });
  }
  return emojiCategoryMap;
}

function getEmojiInfo(query) {
  var name = normalizeEmojiName(query);
  var emojiInfo = __WEBPACK_IMPORTED_MODULE_1_emojis_digests_json___default.a[name];

  // Fallback to question mark for unknown emojis
  if (!emojiInfo) {
    name = 'grey_question';
    emojiInfo = __WEBPACK_IMPORTED_MODULE_1_emojis_digests_json___default.a[name];
  }

  return _extends({}, emojiInfo, { name: name });
}

function emojiFallbackImageSrc(inputName) {
  var _getEmojiInfo = getEmojiInfo(inputName),
      name = _getEmojiInfo.name,
      digest = _getEmojiInfo.digest;

  return '' + (gon.asset_host || '') + (gon.relative_url_root || '') + '/assets/emoji/' + name + '-' + digest + '.png';
}

function emojiImageTag(name, src) {
  return '<img class="emoji" title=":' + name + ':" alt=":' + name + ':" src="' + src + '" width="20" height="20" align="absmiddle" />';
}

function glEmojiTag(inputName, options) {
  var opts = _extends({ sprite: false, forceFallback: false }, options);

  var _getEmojiInfo2 = getEmojiInfo(inputName),
      name = _getEmojiInfo2.name,
      emojiInfo = _objectWithoutProperties(_getEmojiInfo2, ['name']);

  var fallbackImageSrc = emojiFallbackImageSrc(name);
  var fallbackSpriteClass = 'emoji-' + name;

  var classList = [];
  if (opts.forceFallback && opts.sprite) {
    classList.push('emoji-icon');
    classList.push(fallbackSpriteClass);
  }
  var classAttribute = classList.length > 0 ? 'class="' + classList.join(' ') + '"' : '';
  var fallbackSpriteAttribute = opts.sprite ? 'data-fallback-sprite-class="' + fallbackSpriteClass + '"' : '';
  var contents = emojiInfo.moji;
  if (opts.forceFallback && !opts.sprite) {
    contents = emojiImageTag(name, fallbackImageSrc);
  }

  return '\n    <gl-emoji\n      ' + classAttribute + '\n      data-name="' + name + '"\n      data-fallback-src="' + fallbackImageSrc + '"\n      ' + fallbackSpriteAttribute + '\n      data-unicode-version="' + emojiInfo.unicodeVersion + '"\n      title="' + emojiInfo.description + '"\n    >\n      ' + contents + '\n    </gl-emoji>\n  ';
}

/***/ }),

/***/ "./files_comment_button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* Developer beware! Do not add logic to showButton or hideButton
 * that will force a reflow. Doing so will create a signficant performance
 * bottleneck for pages with large diffs. For a comprehensive list of what
 * causes reflows, visit https://gist.github.com/paulirish/5d52fb081b3570c81e3a
 */



var LINE_NUMBER_CLASS = 'diff-line-num';
var UNFOLDABLE_LINE_CLASS = 'js-unfold';
var NO_COMMENT_CLASS = 'no-comment-btn';
var EMPTY_CELL_CLASS = 'empty-cell';
var OLD_LINE_CLASS = 'old_line';
var LINE_COLUMN_CLASSES = '.' + LINE_NUMBER_CLASS + ', .line_content';
var DIFF_CONTAINER_SELECTOR = '.files';
var DIFF_EXPANDED_CLASS = 'diff-expanded';

/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init($diffFile) {
    var _this = this;

    /* Caching is used only when the following members are *true*.
     * This is because there are likely to be
     * differently configured versions of diffs in the same session.
     * However if these values are true, they
     * will be true in all cases */

    if (!this.userCanCreateNote) {
      // data-can-create-note is an empty string when true, otherwise undefined
      this.userCanCreateNote = $diffFile.closest(DIFF_CONTAINER_SELECTOR).data('canCreateNote') === '';
    }

    this.isParallelView = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('diff_view') === 'parallel';

    if (this.userCanCreateNote) {
      $diffFile.on('mouseover', LINE_COLUMN_CLASSES, function (e) {
        return _this.showButton(_this.isParallelView, e);
      }).on('mouseleave', LINE_COLUMN_CLASSES, function (e) {
        return _this.hideButton(_this.isParallelView, e);
      });
    }
  },
  showButton: function showButton(isParallelView, e) {
    var buttonParentElement = this.getButtonParent(e.currentTarget, isParallelView);

    if (!this.validateButtonParent(buttonParentElement)) return;

    buttonParentElement.classList.add('is-over');
    buttonParentElement.nextElementSibling.classList.add('is-over');
  },
  hideButton: function hideButton(isParallelView, e) {
    var buttonParentElement = this.getButtonParent(e.currentTarget, isParallelView);

    buttonParentElement.classList.remove('is-over');
    buttonParentElement.nextElementSibling.classList.remove('is-over');
  },
  getButtonParent: function getButtonParent(hoveredElement, isParallelView) {
    if (isParallelView) {
      if (!hoveredElement.classList.contains(LINE_NUMBER_CLASS)) {
        return hoveredElement.previousElementSibling;
      }
    } else if (!hoveredElement.classList.contains(OLD_LINE_CLASS)) {
      return hoveredElement.parentNode.querySelector('.' + OLD_LINE_CLASS);
    }
    return hoveredElement;
  },
  validateButtonParent: function validateButtonParent(buttonParentElement) {
    return !buttonParentElement.classList.contains(EMPTY_CELL_CLASS) && !buttonParentElement.classList.contains(UNFOLDABLE_LINE_CLASS) && !buttonParentElement.classList.contains(NO_COMMENT_CLASS) && !buttonParentElement.parentNode.classList.contains(DIFF_EXPANDED_CLASS);
  }
});

/***/ }),

/***/ "./gl_form.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autosize__ = __webpack_require__("../../../node_modules/autosize/dist/autosize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gfm_auto_complete__ = __webpack_require__("./gfm_auto_complete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dropzone_input__ = __webpack_require__("./dropzone_input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_text_markdown__ = __webpack_require__("./lib/utils/text_markdown.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var GLForm = function () {
  function GLForm(form) {
    var enableGFM = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, GLForm);

    this.form = form;
    this.textarea = this.form.find('textarea.js-gfm-input');
    this.enableGFM = enableGFM;
    // Before we start, we should clean up any previous data for this form
    this.destroy();
    // Setup the form
    this.setupForm();
    this.form.data('glForm', this);
  }

  _createClass(GLForm, [{
    key: 'destroy',
    value: function destroy() {
      // Clean form listeners
      this.clearEventListeners();
      if (this.autoComplete) {
        this.autoComplete.destroy();
      }
      this.form.data('glForm', null);
    }
  }, {
    key: 'setupForm',
    value: function setupForm() {
      var isNewForm = this.form.is(':not(.gfm-form)');
      this.form.removeClass('js-new-note-form');
      if (isNewForm) {
        this.form.find('.div-dropzone').remove();
        this.form.addClass('gfm-form');
        // remove notify commit author checkbox for non-commit notes
        gl.utils.disableButtonIfEmptyField(this.form.find('.js-note-text'), this.form.find('.js-comment-button, .js-note-new-discussion'));
        this.autoComplete = new __WEBPACK_IMPORTED_MODULE_1__gfm_auto_complete__["a" /* default */](gl.GfmAutoComplete && gl.GfmAutoComplete.dataSources);
        this.autoComplete.setup(this.form.find('.js-gfm-input'), {
          emojis: true,
          members: this.enableGFM,
          issues: this.enableGFM,
          milestones: this.enableGFM,
          mergeRequests: this.enableGFM,
          labels: this.enableGFM
        });
        Object(__WEBPACK_IMPORTED_MODULE_2__dropzone_input__["a" /* default */])(this.form);
        __WEBPACK_IMPORTED_MODULE_0_autosize___default()(this.textarea);
      }
      // form and textarea event listeners
      this.addEventListeners();
      __WEBPACK_IMPORTED_MODULE_3__lib_utils_text_markdown__["a" /* default */].init(this.form);
      // hide discard button
      this.form.find('.js-note-discard').hide();
      this.form.show();
      if (this.isAutosizeable) this.setupAutosize();
    }
  }, {
    key: 'setupAutosize',
    value: function setupAutosize() {
      var _this = this;

      this.textarea.off('autosize:resized').on('autosize:resized', this.setHeightData.bind(this));

      this.textarea.off('mouseup.autosize').on('mouseup.autosize', this.destroyAutosize.bind(this));

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_autosize___default()(_this.textarea);
        _this.textarea.css('resize', 'vertical');
      }, 0);
    }
  }, {
    key: 'setHeightData',
    value: function setHeightData() {
      this.textarea.data('height', this.textarea.outerHeight());
    }
  }, {
    key: 'destroyAutosize',
    value: function destroyAutosize() {
      var outerHeight = this.textarea.outerHeight();

      if (this.textarea.data('height') === outerHeight) return;

      __WEBPACK_IMPORTED_MODULE_0_autosize___default.a.destroy(this.textarea);

      this.textarea.data('height', outerHeight);
      this.textarea.outerHeight(outerHeight);
      this.textarea.css('max-height', window.outerHeight);
    }
  }, {
    key: 'clearEventListeners',
    value: function clearEventListeners() {
      this.textarea.off('focus');
      this.textarea.off('blur');
      __WEBPACK_IMPORTED_MODULE_3__lib_utils_text_markdown__["a" /* default */].removeListeners(this.form);
    }
  }, {
    key: 'addEventListeners',
    value: function addEventListeners() {
      this.textarea.on('focus', function focusTextArea() {
        $(this).closest('.md-area').addClass('is-focused');
      });
      this.textarea.on('blur', function blurTextArea() {
        $(this).closest('.md-area').removeClass('is-focused');
      });
    }
  }]);

  return GLForm;
}();

/* harmony default export */ __webpack_exports__["a"] = (GLForm);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./helpers/issuables_helper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./droplab/drop_lab.js + 7 modules
var drop_lab = __webpack_require__("./droplab/drop_lab.js");

// EXTERNAL MODULE: ./droplab/plugins/input_setter.js
var input_setter = __webpack_require__("./droplab/plugins/input_setter.js");

// CONCATENATED MODULE: ./close_reopen_report_toggle.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




// Todo: Remove this when fixing issue in input_setter plugin
var InputSetter = Object.assign({}, input_setter["a" /* default */]);

var close_reopen_report_toggle_CloseReopenReportToggle = function () {
  function CloseReopenReportToggle() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CloseReopenReportToggle);

    this.dropdownTrigger = opts.dropdownTrigger;
    this.dropdownList = opts.dropdownList;
    this.button = opts.button;
  }

  _createClass(CloseReopenReportToggle, [{
    key: 'initDroplab',
    value: function initDroplab() {
      this.reopenItem = this.dropdownList.querySelector('.reopen-item');
      this.closeItem = this.dropdownList.querySelector('.close-item');

      this.droplab = new drop_lab["a" /* default */]();

      var config = this.setConfig();

      this.droplab.init(this.dropdownTrigger, this.dropdownList, [InputSetter], config);
    }
  }, {
    key: 'updateButton',
    value: function updateButton(isClosed) {
      this.toggleButtonType(isClosed);

      this.button.blur();
    }
  }, {
    key: 'toggleButtonType',
    value: function toggleButtonType(isClosed) {
      var _getButtonTypes = this.getButtonTypes(isClosed),
          _getButtonTypes2 = _slicedToArray(_getButtonTypes, 2),
          showItem = _getButtonTypes2[0],
          hideItem = _getButtonTypes2[1];

      showItem.classList.remove('hidden');
      showItem.classList.add('droplab-item-selected');

      hideItem.classList.add('hidden');
      hideItem.classList.remove('droplab-item-selected');

      showItem.click();
    }
  }, {
    key: 'getButtonTypes',
    value: function getButtonTypes(isClosed) {
      return isClosed ? [this.reopenItem, this.closeItem] : [this.closeItem, this.reopenItem];
    }
  }, {
    key: 'setDisable',
    value: function setDisable() {
      var shouldDisable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (shouldDisable) {
        this.button.setAttribute('disabled', 'true');
        this.dropdownTrigger.setAttribute('disabled', 'true');
      } else {
        this.button.removeAttribute('disabled');
        this.dropdownTrigger.removeAttribute('disabled');
      }
    }
  }, {
    key: 'setConfig',
    value: function setConfig() {
      var config = {
        InputSetter: [{
          input: this.button,
          valueAttribute: 'data-text',
          inputAttribute: 'data-value'
        }, {
          input: this.button,
          valueAttribute: 'data-text',
          inputAttribute: 'title'
        }, {
          input: this.button,
          valueAttribute: 'data-button-class',
          inputAttribute: 'class'
        }, {
          input: this.dropdownTrigger,
          valueAttribute: 'data-toggle-class',
          inputAttribute: 'class'
        }, {
          input: this.button,
          valueAttribute: 'data-url',
          inputAttribute: 'href'
        }, {
          input: this.button,
          valueAttribute: 'data-method',
          inputAttribute: 'data-method'
        }]
      };

      return config;
    }
  }]);

  return CloseReopenReportToggle;
}();

/* harmony default export */ var close_reopen_report_toggle = (close_reopen_report_toggle_CloseReopenReportToggle);
// CONCATENATED MODULE: ./helpers/issuables_helper.js


function initCloseReopenReport() {
  var container = document.querySelector('.js-issuable-close-dropdown');

  if (!container) return undefined;

  var dropdownTrigger = container.querySelector('.js-issuable-close-toggle');
  var dropdownList = container.querySelector('.js-issuable-close-menu');
  var button = container.querySelector('.js-issuable-close-button');

  var closeReopenReportToggle = new close_reopen_report_toggle({
    dropdownTrigger: dropdownTrigger,
    dropdownList: dropdownList,
    button: button
  });

  closeReopenReportToggle.initDroplab();

  return closeReopenReportToggle;
}

var IssuablesHelper = {
  initCloseReopenReport: initCloseReopenReport
};

/* harmony default export */ var issuables_helper = __webpack_exports__["a"] = (IssuablesHelper);

/***/ }),

/***/ "./how_to_merge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony default export */ __webpack_exports__["a"] = (function () {
  var modal = $('#modal_merge_info');

  if (modal) {
    modal.modal({
      modal: true,
      show: false
    });

    $('.how_to_merge_link').on('click', modal.show);
    $('.modal-header .close').on('click', modal.hide);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./image_diff/helpers/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./image_diff/helpers/badge_helper.js
function createImageBadge(noteId, _ref) {
  var x = _ref.x,
      y = _ref.y;
  var classNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var buttonEl = document.createElement('button');
  var classList = classNames.concat(['js-image-badge']);
  classList.forEach(function (className) {
    return buttonEl.classList.add(className);
  });
  buttonEl.setAttribute('type', 'button');
  buttonEl.setAttribute('disabled', true);
  buttonEl.dataset.noteId = noteId;
  buttonEl.style.left = x + 'px';
  buttonEl.style.top = y + 'px';

  return buttonEl;
}

function addImageBadge(containerEl, _ref2) {
  var coordinate = _ref2.coordinate,
      badgeText = _ref2.badgeText,
      noteId = _ref2.noteId;

  var buttonEl = createImageBadge(noteId, coordinate, ['badge']);
  buttonEl.innerText = badgeText;

  containerEl.appendChild(buttonEl);
}

function addImageCommentBadge(containerEl, _ref3) {
  var coordinate = _ref3.coordinate,
      noteId = _ref3.noteId;

  var buttonEl = createImageBadge(noteId, coordinate, ['image-comment-badge']);
  buttonEl.innerHTML = gl.utils.spriteIcon('image-comment-dark');

  containerEl.appendChild(buttonEl);
}

function addAvatarBadge(el, event) {
  var _event$detail = event.detail,
      noteId = _event$detail.noteId,
      badgeNumber = _event$detail.badgeNumber;

  // Add badge to new comment

  var avatarBadgeEl = el.querySelector('#' + noteId + ' .badge');
  avatarBadgeEl.innerText = badgeNumber;
  avatarBadgeEl.classList.remove('hidden');
}
// CONCATENATED MODULE: ./image_diff/helpers/comment_indicator_helper.js
function addCommentIndicator(containerEl, _ref) {
  var x = _ref.x,
      y = _ref.y;

  var buttonEl = document.createElement('button');
  buttonEl.classList.add('btn-transparent');
  buttonEl.classList.add('comment-indicator');
  buttonEl.setAttribute('type', 'button');
  buttonEl.style.left = x + 'px';
  buttonEl.style.top = y + 'px';

  buttonEl.innerHTML = gl.utils.spriteIcon('image-comment-dark');

  containerEl.appendChild(buttonEl);
}

function removeCommentIndicator(imageFrameEl) {
  var commentIndicatorEl = imageFrameEl.querySelector('.comment-indicator');
  var imageEl = imageFrameEl.querySelector('img');
  var willRemove = !!commentIndicatorEl;
  var meta = {};

  if (willRemove) {
    meta = {
      x: parseInt(commentIndicatorEl.style.left, 10),
      y: parseInt(commentIndicatorEl.style.top, 10),
      image: {
        width: imageEl.width,
        height: imageEl.height
      }
    };

    commentIndicatorEl.remove();
  }

  return Object.assign({}, meta, {
    removed: willRemove
  });
}

function showCommentIndicator(imageFrameEl, coordinate) {
  var x = coordinate.x,
      y = coordinate.y;

  var commentIndicatorEl = imageFrameEl.querySelector('.comment-indicator');

  if (commentIndicatorEl) {
    commentIndicatorEl.style.left = x + 'px';
    commentIndicatorEl.style.top = y + 'px';
  } else {
    addCommentIndicator(imageFrameEl, coordinate);
  }
}

function commentIndicatorOnClick(event) {
  // Prevent from triggering onAddImageDiffNote in notes.js
  event.stopPropagation();

  var buttonEl = event.currentTarget;
  var diffViewerEl = buttonEl.closest('.diff-viewer');
  var textareaEl = diffViewerEl.querySelector('.note-container .note-textarea');
  textareaEl.focus();
}
// CONCATENATED MODULE: ./image_diff/helpers/dom_helper.js
function setPositionDataAttribute(el, options) {
  // Update position data attribute so that the
  // new comment form can use this data for ajax request
  var x = options.x,
      y = options.y,
      width = options.width,
      height = options.height;

  var position = el.dataset.position;
  var positionObject = Object.assign({}, JSON.parse(position), {
    x: x,
    y: y,
    width: width,
    height: height
  });

  el.setAttribute('data-position', JSON.stringify(positionObject));
}

function updateDiscussionAvatarBadgeNumber(discussionEl, newBadgeNumber) {
  var avatarBadgeEl = discussionEl.querySelector('.image-diff-avatar-link .badge');
  avatarBadgeEl.innerText = newBadgeNumber;
}

function updateDiscussionBadgeNumber(discussionEl, newBadgeNumber) {
  var discussionBadgeEl = discussionEl.querySelector('.badge');
  discussionBadgeEl.innerText = newBadgeNumber;
}

function toggleCollapsed(event) {
  var toggleButtonEl = event.currentTarget;
  var discussionNotesEl = toggleButtonEl.closest('.discussion-notes');
  var formEl = discussionNotesEl.querySelector('.discussion-form');
  var isCollapsed = discussionNotesEl.classList.contains('collapsed');

  if (isCollapsed) {
    discussionNotesEl.classList.remove('collapsed');
  } else {
    discussionNotesEl.classList.add('collapsed');
  }

  // Override the inline display style set in notes.js
  if (formEl && !isCollapsed) {
    formEl.style.display = 'none';
  } else if (formEl && isCollapsed) {
    formEl.style.display = 'block';
  }
}
// EXTERNAL MODULE: ./image_diff/image_badge.js
var image_badge = __webpack_require__("./image_diff/image_badge.js");

// EXTERNAL MODULE: ./image_diff/image_diff.js
var image_diff = __webpack_require__("./image_diff/image_diff.js");

// CONCATENATED MODULE: ./image_diff/view_types.js
var viewTypes = {
  TWO_UP: 'TWO_UP',
  SWIPE: 'SWIPE',
  ONION_SKIN: 'ONION_SKIN'
};

function isValidViewType(validate) {
  return !!Object.getOwnPropertyNames(viewTypes).find(function (viewType) {
    return viewType === validate;
  });
}
// CONCATENATED MODULE: ./image_diff/replaced_image_diff.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var replaced_image_diff_ReplacedImageDiff = function (_ImageDiff) {
  _inherits(ReplacedImageDiff, _ImageDiff);

  function ReplacedImageDiff() {
    _classCallCheck(this, ReplacedImageDiff);

    return _possibleConstructorReturn(this, (ReplacedImageDiff.__proto__ || Object.getPrototypeOf(ReplacedImageDiff)).apply(this, arguments));
  }

  _createClass(ReplacedImageDiff, [{
    key: 'init',
    value: function init() {
      var _imageFrameEls, _viewModesEls;

      var defaultViewType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : viewTypes.TWO_UP;

      this.imageFrameEls = (_imageFrameEls = {}, _defineProperty(_imageFrameEls, viewTypes.TWO_UP, this.el.querySelector('.two-up .js-image-frame')), _defineProperty(_imageFrameEls, viewTypes.SWIPE, this.el.querySelector('.swipe .js-image-frame')), _defineProperty(_imageFrameEls, viewTypes.ONION_SKIN, this.el.querySelector('.onion-skin .js-image-frame')), _imageFrameEls);

      var viewModesEl = this.el.querySelector('.view-modes-menu');
      this.viewModesEls = (_viewModesEls = {}, _defineProperty(_viewModesEls, viewTypes.TWO_UP, viewModesEl.querySelector('.two-up')), _defineProperty(_viewModesEls, viewTypes.SWIPE, viewModesEl.querySelector('.swipe')), _defineProperty(_viewModesEls, viewTypes.ONION_SKIN, viewModesEl.querySelector('.onion-skin')), _viewModesEls);

      this.currentView = defaultViewType;
      this.generateImageEls();
      this.bindEvents();
    }
  }, {
    key: 'generateImageEls',
    value: function generateImageEls() {
      var _this2 = this;

      this.imageEls = {};

      var viewTypeNames = Object.getOwnPropertyNames(viewTypes);
      viewTypeNames.forEach(function (viewType) {
        _this2.imageEls[viewType] = _this2.imageFrameEls[viewType].querySelector('img');
      });
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      _get(ReplacedImageDiff.prototype.__proto__ || Object.getPrototypeOf(ReplacedImageDiff.prototype), 'bindEvents', this).call(this);

      this.changeToViewTwoUp = this.changeView.bind(this, viewTypes.TWO_UP);
      this.changeToViewSwipe = this.changeView.bind(this, viewTypes.SWIPE);
      this.changeToViewOnionSkin = this.changeView.bind(this, viewTypes.ONION_SKIN);

      this.viewModesEls[viewTypes.TWO_UP].addEventListener('click', this.changeToViewTwoUp);
      this.viewModesEls[viewTypes.SWIPE].addEventListener('click', this.changeToViewSwipe);
      this.viewModesEls[viewTypes.ONION_SKIN].addEventListener('click', this.changeToViewOnionSkin);
    }
  }, {
    key: 'changeView',
    value: function changeView(newView) {
      if (!isValidViewType(newView)) {
        return;
      }

      var indicator = helpers.removeCommentIndicator(this.imageFrameEl);

      this.currentView = newView;

      // Clear existing badges on new view
      var existingBadges = this.imageFrameEl.querySelectorAll('.badge');
      [].concat(_toConsumableArray(existingBadges)).map(function (badge) {
        return badge.remove();
      });

      // Remove existing references to old view image badges
      this.imageBadges = [];

      // Image_file.js has a fade animation of 200ms for loading the view
      // Need to wait an additional 250ms for the images to be displayed
      // on window in order to re-normalize their dimensions
      setTimeout(this.renderNewView.bind(this, indicator), 250);
    }
  }, {
    key: 'renderNewView',
    value: function renderNewView(indicator) {
      // Generate badge coordinates on new view
      this.renderBadges();

      // Re-render indicator in new view
      if (indicator.removed) {
        var normalizedIndicator = helpers.resizeCoordinatesToImageElement(this.imageEl, {
          x: indicator.x,
          y: indicator.y,
          width: indicator.image.width,
          height: indicator.image.height
        });
        helpers.showCommentIndicator(this.imageFrameEl, normalizedIndicator);
      }
    }
  }, {
    key: 'imageEl',
    get: function get() {
      return this.imageEls[this.currentView];
    }
  }, {
    key: 'imageFrameEl',
    get: function get() {
      return this.imageFrameEls[this.currentView];
    }
  }]);

  return ReplacedImageDiff;
}(image_diff["a" /* default */]);

/* harmony default export */ var replaced_image_diff = (replaced_image_diff_ReplacedImageDiff);
// EXTERNAL MODULE: ./commit/image_file.js
var image_file = __webpack_require__("./commit/image_file.js");

// CONCATENATED MODULE: ./image_diff/helpers/utils_helper.js





function resizeCoordinatesToImageElement(imageEl, meta) {
  var x = meta.x,
      y = meta.y,
      width = meta.width,
      height = meta.height;


  var imageWidth = imageEl.width;
  var imageHeight = imageEl.height;

  var widthRatio = imageWidth / width;
  var heightRatio = imageHeight / height;

  return {
    x: Math.round(x * widthRatio),
    y: Math.round(y * heightRatio),
    width: imageWidth,
    height: imageHeight
  };
}

function generateBadgeFromDiscussionDOM(imageFrameEl, discussionEl) {
  var position = JSON.parse(discussionEl.dataset.position);
  var firstNoteEl = discussionEl.querySelector('.note');
  var badge = new image_badge["a" /* default */]({
    actual: position,
    imageEl: imageFrameEl.querySelector('img'),
    noteId: firstNoteEl.id,
    discussionId: discussionEl.dataset.discussionId
  });

  return badge;
}

function getTargetSelection(event) {
  var containerEl = event.currentTarget;
  var imageEl = containerEl.querySelector('img');

  var x = event.offsetX;
  var y = event.offsetY;

  var width = imageEl.width;
  var height = imageEl.height;

  var actualWidth = imageEl.naturalWidth;
  var actualHeight = imageEl.naturalHeight;

  var widthRatio = actualWidth / width;
  var heightRatio = actualHeight / height;

  // Browser will include the frame as a clickable target,
  // which would result in potential 1px out of bounds value
  // This bound the coordinates to inside the frame
  var normalizedX = Math.max(0, x) && Math.min(x, width);
  var normalizedY = Math.max(0, y) && Math.min(y, height);

  return {
    browser: {
      x: normalizedX,
      y: normalizedY,
      width: width,
      height: height
    },
    actual: {
      // Round x, y so that we don't need to deal with decimals
      x: Math.round(normalizedX * widthRatio),
      y: Math.round(normalizedY * heightRatio),
      width: actualWidth,
      height: actualHeight
    }
  };
}

function initImageDiff(fileEl, canCreateNote, renderCommentBadge) {
  var options = {
    canCreateNote: canCreateNote,
    renderCommentBadge: renderCommentBadge
  };
  var diff = void 0;

  // ImageFile needs to be invoked before initImageDiff so that badges
  // can mount to the correct location
  new image_file["a" /* default */](fileEl); // eslint-disable-line no-new

  if (fileEl.querySelector('.diff-file .js-single-image')) {
    diff = new image_diff["a" /* default */](fileEl, options);
    diff.init();
  } else if (fileEl.querySelector('.diff-file .js-replaced-image')) {
    diff = new replaced_image_diff(fileEl, options);
    diff.init();
  }

  return diff;
}
// CONCATENATED MODULE: ./image_diff/helpers/index.js





/* harmony default export */ var helpers = __webpack_exports__["a"] = ({
  addCommentIndicator: addCommentIndicator,
  removeCommentIndicator: removeCommentIndicator,
  showCommentIndicator: showCommentIndicator,
  commentIndicatorOnClick: commentIndicatorOnClick,

  addImageBadge: addImageBadge,
  addImageCommentBadge: addImageCommentBadge,
  addAvatarBadge: addAvatarBadge,

  setPositionDataAttribute: setPositionDataAttribute,
  updateDiscussionAvatarBadgeNumber: updateDiscussionAvatarBadgeNumber,
  updateDiscussionBadgeNumber: updateDiscussionBadgeNumber,
  toggleCollapsed: toggleCollapsed,

  resizeCoordinatesToImageElement: resizeCoordinatesToImageElement,
  generateBadgeFromDiscussionDOM: generateBadgeFromDiscussionDOM,
  getTargetSelection: getTargetSelection,
  initImageDiff: initImageDiff
});

/***/ }),

/***/ "./image_diff/image_badge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var defaultMeta = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
};

var ImageBadge = function ImageBadge(options) {
  _classCallCheck(this, ImageBadge);

  var noteId = options.noteId,
      discussionId = options.discussionId;


  this.actual = options.actual || defaultMeta;
  this.browser = options.browser || defaultMeta;
  this.noteId = noteId;
  this.discussionId = discussionId;

  if (options.imageEl && !options.browser) {
    this.browser = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].resizeCoordinatesToImageElement(options.imageEl, this.actual);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ImageBadge);

/***/ }),

/***/ "./image_diff/image_diff.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__image_badge__ = __webpack_require__("./image_diff/image_badge.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_image_utility__ = __webpack_require__("./lib/utils/image_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var ImageDiff = function () {
  function ImageDiff(el, options) {
    _classCallCheck(this, ImageDiff);

    this.el = el;
    this.canCreateNote = !!(options && options.canCreateNote);
    this.renderCommentBadge = !!(options && options.renderCommentBadge);
    this.$noteContainer = $('.note-container', this.el);
    this.imageBadges = [];
  }

  _createClass(ImageDiff, [{
    key: 'init',
    value: function init() {
      this.imageFrameEl = this.el.querySelector('.diff-file .js-image-frame');
      this.imageEl = this.imageFrameEl.querySelector('img');

      this.bindEvents();
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.imageClickedWrapper = this.imageClicked.bind(this);
      this.imageBlurredWrapper = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].removeCommentIndicator.bind(null, this.imageFrameEl);
      this.addBadgeWrapper = this.addBadge.bind(this);
      this.removeBadgeWrapper = this.removeBadge.bind(this);
      this.renderBadgesWrapper = this.renderBadges.bind(this);

      // Render badges
      if (Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_image_utility__["a" /* isImageLoaded */])(this.imageEl)) {
        this.renderBadges();
      } else {
        this.imageEl.addEventListener('load', this.renderBadgesWrapper);
      }

      // jquery makes the event delegation here much simpler
      this.$noteContainer.on('click', '.js-diff-notes-toggle', __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].toggleCollapsed);
      $(this.el).on('click', '.comment-indicator', __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].commentIndicatorOnClick);

      if (this.canCreateNote) {
        this.el.addEventListener('click.imageDiff', this.imageClickedWrapper);
        this.el.addEventListener('blur.imageDiff', this.imageBlurredWrapper);
        this.el.addEventListener('addBadge.imageDiff', this.addBadgeWrapper);
        this.el.addEventListener('removeBadge.imageDiff', this.removeBadgeWrapper);
      }
    }
  }, {
    key: 'imageClicked',
    value: function imageClicked(event) {
      var customEvent = event.detail;
      var selection = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].getTargetSelection(customEvent);
      var el = customEvent.currentTarget;

      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].setPositionDataAttribute(el, selection.actual);
      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].showCommentIndicator(this.imageFrameEl, selection.browser);
    }
  }, {
    key: 'renderBadges',
    value: function renderBadges() {
      var discussionsEls = this.el.querySelectorAll('.note-container .discussion-notes .notes');
      [].concat(_toConsumableArray(discussionsEls)).forEach(this.renderBadge.bind(this));
    }
  }, {
    key: 'renderBadge',
    value: function renderBadge(discussionEl, index) {
      var imageBadge = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].generateBadgeFromDiscussionDOM(this.imageFrameEl, discussionEl);

      this.imageBadges.push(imageBadge);

      var options = {
        coordinate: imageBadge.browser,
        noteId: imageBadge.noteId
      };

      if (this.renderCommentBadge) {
        __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addImageCommentBadge(this.imageFrameEl, options);
      } else {
        var numberBadgeOptions = Object.assign({}, options, {
          badgeText: index + 1
        });

        __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addImageBadge(this.imageFrameEl, numberBadgeOptions);
      }
    }
  }, {
    key: 'addBadge',
    value: function addBadge(event) {
      var _event$detail = event.detail,
          x = _event$detail.x,
          y = _event$detail.y,
          width = _event$detail.width,
          height = _event$detail.height,
          noteId = _event$detail.noteId,
          discussionId = _event$detail.discussionId;

      var badgeText = this.imageBadges.length + 1;
      var imageBadge = new __WEBPACK_IMPORTED_MODULE_1__image_badge__["a" /* default */]({
        actual: {
          x: x,
          y: y,
          width: width,
          height: height
        },
        imageEl: this.imageFrameEl.querySelector('img'),
        noteId: noteId,
        discussionId: discussionId
      });

      this.imageBadges.push(imageBadge);

      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addImageBadge(this.imageFrameEl, {
        coordinate: imageBadge.browser,
        badgeText: badgeText,
        noteId: noteId
      });

      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addAvatarBadge(this.el, {
        detail: {
          noteId: noteId,
          badgeNumber: badgeText
        }
      });

      var discussionEl = this.el.querySelector('#discussion_' + discussionId);
      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].updateDiscussionBadgeNumber(discussionEl, badgeText);
    }
  }, {
    key: 'removeBadge',
    value: function removeBadge(event) {
      var _this = this;

      var badgeNumber = event.detail.badgeNumber;

      var indexToRemove = badgeNumber - 1;
      var imageBadgeEls = this.imageFrameEl.querySelectorAll('.badge');

      if (this.imageBadges.length !== badgeNumber) {
        // Cascade badges count numbers for (avatar badges + image badges)
        this.imageBadges.forEach(function (badge, index) {
          if (index > indexToRemove) {
            var discussionId = badge.discussionId;

            var updatedBadgeNumber = index;
            var discussionEl = _this.el.querySelector('#discussion_' + discussionId);

            imageBadgeEls[index].innerText = updatedBadgeNumber;

            __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].updateDiscussionBadgeNumber(discussionEl, updatedBadgeNumber);
            __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].updateDiscussionAvatarBadgeNumber(discussionEl, updatedBadgeNumber);
          }
        });
      }

      this.imageBadges.splice(indexToRemove, 1);

      var imageBadgeEl = imageBadgeEls[indexToRemove];
      imageBadgeEl.remove();
    }
  }]);

  return ImageDiff;
}();

/* harmony default export */ __webpack_exports__["a"] = (ImageDiff);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./image_diff/init_discussion_tab.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* harmony default export */ __webpack_exports__["a"] = (function () {
  // Always pass can-create-note as false because a user
  // cannot place new badge markers on discussion tab
  var canCreateNote = false;
  var renderCommentBadge = true;

  var diffFileEls = document.querySelectorAll('.timeline-content .diff-file.js-image-file');
  [].concat(_toConsumableArray(diffFileEls)).forEach(function (diffFileEl) {
    return __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].initImageDiff(diffFileEl, canCreateNote, renderCommentBadge);
  });
});

/***/ }),

/***/ "./init_changes_dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_sticky__ = __webpack_require__("./lib/utils/sticky.js");


/* harmony default export */ __webpack_exports__["a"] = (function (stickyTop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_sticky__["a" /* default */])(document.querySelector('.js-diff-files-changed'), stickyTop);

  $('.js-diff-stats-dropdown').glDropdown({
    filterable: true,
    remoteFilter: false
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./init_issuable_sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__milestone_select__ = __webpack_require__("./milestone_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__labels_select__ = __webpack_require__("./labels_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__issuable_context__ = __webpack_require__("./issuable_context.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__right_sidebar__ = __webpack_require__("./right_sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__due_date_select__ = __webpack_require__("./due_date_select.js");
/* eslint-disable no-new */








/* harmony default export */ __webpack_exports__["a"] = (function () {
  var sidebarOptions = JSON.parse(document.querySelector('.js-sidebar-options').innerHTML);

  new __WEBPACK_IMPORTED_MODULE_0__milestone_select__["a" /* default */]({
    full_path: sidebarOptions.fullPath
  });
  new __WEBPACK_IMPORTED_MODULE_1__labels_select__["a" /* default */]();
  new __WEBPACK_IMPORTED_MODULE_2__issuable_context__["a" /* default */](sidebarOptions.currentUser);
  new __WEBPACK_IMPORTED_MODULE_4__due_date_select__["a" /* default */]();
  __WEBPACK_IMPORTED_MODULE_3__right_sidebar__["a" /* default */].initialize();
});

/***/ }),

/***/ "./init_notes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notes__ = __webpack_require__("./notes.js");


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var dataEl = document.querySelector('.js-notes-data');

  var _JSON$parse = JSON.parse(dataEl.innerHTML),
      notesUrl = _JSON$parse.notesUrl,
      notesIds = _JSON$parse.notesIds,
      now = _JSON$parse.now,
      diffView = _JSON$parse.diffView,
      autocomplete = _JSON$parse.autocomplete;

  // Create a singleton so that we don't need to assign
  // into the window object, we can just access the current isntance with Notes.instance


  __WEBPACK_IMPORTED_MODULE_0__notes__["a" /* default */].initialize(notesUrl, notesIds, now, diffView, autocomplete);
});

/***/ }),

/***/ "./issuable_bulk_update_actions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* eslint-disable comma-dangle, quotes, consistent-return, func-names, array-callback-return, space-before-function-paren, prefer-arrow-callback, max-len, no-unused-expressions, no-sequences, no-underscore-dangle, no-unused-vars, no-param-reassign */




/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        container = _ref.container,
        form = _ref.form,
        issues = _ref.issues,
        prefixId = _ref.prefixId;

    this.prefixId = prefixId || 'issue_';
    this.form = form || this.getElement('.bulk-update');
    this.$labelDropdown = this.form.find('.js-label-select');
    this.issues = issues || this.getElement('.issues-list .issue');
    this.willUpdateLabels = false;
    this.bindEvents();
  },
  bindEvents: function bindEvents() {
    return this.form.off('submit').on('submit', this.onFormSubmit.bind(this));
  },
  onFormSubmit: function onFormSubmit(e) {
    e.preventDefault();
    return this.submit();
  },
  submit: function submit() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */][this.form.attr('method')](this.form.attr('action'), this.getFormDataAsObject()).then(function () {
      return window.location.reload();
    }).catch(function () {
      return _this.onFormSubmitFailure();
    });
  },
  onFormSubmitFailure: function onFormSubmitFailure() {
    this.form.find('[type="submit"]').enable();
    return new __WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */]("Issue update failed");
  },
  getSelectedIssues: function getSelectedIssues() {
    return this.issues.has('.selected_issue:checked');
  },
  getLabelsFromSelection: function getLabelsFromSelection() {
    var labels = [];
    this.getSelectedIssues().map(function () {
      var labelsData = $(this).data('labels');
      if (labelsData) {
        return labelsData.map(function (labelId) {
          if (labels.indexOf(labelId) === -1) {
            return labels.push(labelId);
          }
        });
      }
    });
    return labels;
  },


  /**
   * Will return only labels that were marked previously and the user has unmarked
   * @return {Array} Label IDs
   */

  getUnmarkedIndeterminedLabels: function getUnmarkedIndeterminedLabels() {
    var result = [];
    var labelsToKeep = this.$labelDropdown.data('indeterminate');

    this.getLabelsFromSelection().forEach(function (id) {
      if (labelsToKeep.indexOf(id) === -1) {
        result.push(id);
      }
    });

    return result;
  },


  /**
   * Simple form serialization, it will return just what we need
   * Returns key/value pairs from form data
   */

  getFormDataAsObject: function getFormDataAsObject() {
    var formData = {
      update: {
        state_event: this.form.find('input[name="update[state_event]"]').val(),
        // For Merge Requests
        assignee_id: this.form.find('input[name="update[assignee_id]"]').val(),
        // For Issues
        assignee_ids: [this.form.find('input[name="update[assignee_ids][]"]').val()],
        milestone_id: this.form.find('input[name="update[milestone_id]"]').val(),
        issuable_ids: this.form.find('input[name="update[issuable_ids]"]').val(),
        subscription_event: this.form.find('input[name="update[subscription_event]"]').val(),
        add_label_ids: [],
        remove_label_ids: []
      }
    };
    if (this.willUpdateLabels) {
      formData.update.add_label_ids = this.$labelDropdown.data('marked');
      formData.update.remove_label_ids = this.$labelDropdown.data('unmarked');
    }
    return formData;
  },
  setOriginalDropdownData: function setOriginalDropdownData() {
    var $labelSelect = $('.bulk-update .js-label-select');
    $labelSelect.data('common', this.getOriginalCommonIds());
    $labelSelect.data('marked', this.getOriginalMarkedIds());
    $labelSelect.data('indeterminate', this.getOriginalIndeterminateIds());
  },


  // From issuable's initial bulk selection
  getOriginalCommonIds: function getOriginalCommonIds() {
    var _this2 = this;

    var labelIds = [];

    this.getElement('.selected_issue:checked').each(function (i, el) {
      labelIds.push(_this2.getElement('#' + _this2.prefixId + el.dataset.id).data('labels'));
    });
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection.apply(this, labelIds);
  },


  // From issuable's initial bulk selection
  getOriginalMarkedIds: function getOriginalMarkedIds() {
    var _this3 = this;

    var labelIds = [];
    this.getElement('.selected_issue:checked').each(function (i, el) {
      labelIds.push(_this3.getElement('#' + _this3.prefixId + el.dataset.id).data('labels'));
    });
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection.apply(this, labelIds);
  },


  // From issuable's initial bulk selection
  getOriginalIndeterminateIds: function getOriginalIndeterminateIds() {
    var _this4 = this;

    var uniqueIds = [];
    var labelIds = [];
    var issuableLabels = [];

    // Collect unique label IDs for all checked issues
    this.getElement('.selected_issue:checked').each(function (i, el) {
      issuableLabels = _this4.getElement('#' + _this4.prefixId + el.dataset.id).data('labels');
      issuableLabels.forEach(function (labelId) {
        // Store unique IDs
        if (uniqueIds.indexOf(labelId) === -1) {
          uniqueIds.push(labelId);
        }
      });
      // Store array of IDs per issuable
      labelIds.push(issuableLabels);
    });
    // Add uniqueIds to add it as argument for _.intersection
    labelIds.unshift(uniqueIds);
    // Return IDs that are present but not in all selected issueables
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.difference(uniqueIds, __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection.apply(this, labelIds));
  },
  getElement: function getElement(selector) {
    this.scopeEl = this.scopeEl || $('.content');
    return this.scopeEl.find(selector);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./issuable_context.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breakpoints__ = __webpack_require__("./breakpoints.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_select__ = __webpack_require__("./users_select.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var IssuableContext = function IssuableContext(currentUser) {
  _classCallCheck(this, IssuableContext);

  this.userSelect = new __WEBPACK_IMPORTED_MODULE_2__users_select__["a" /* default */](currentUser);

  $('select.select2').select2({
    width: 'resolve',
    dropdownAutoWidth: true
  });

  $('.issuable-sidebar .inline-update').on('change', 'select', function onClickSelect() {
    return $(this).submit();
  });
  $('.issuable-sidebar .inline-update').on('change', '.js-assignee', function onClickAssignee() {
    return $(this).submit();
  });
  $(document).off('click', '.issuable-sidebar .dropdown-content a').on('click', '.issuable-sidebar .dropdown-content a', function (e) {
    return e.preventDefault();
  });

  $(document).off('click', '.edit-link').on('click', '.edit-link', function onClickEdit(e) {
    e.preventDefault();
    var $block = $(this).parents('.block');
    var $selectbox = $block.find('.selectbox');
    if ($selectbox.is(':visible')) {
      $selectbox.hide();
      $block.find('.value').show();
    } else {
      $selectbox.show();
      $block.find('.value').hide();
    }

    if ($selectbox.is(':visible')) {
      setTimeout(function () {
        return $block.find('.dropdown-menu-toggle').trigger('click');
      }, 0);
    }
  });

  window.addEventListener('beforeunload', function () {
    // collapsed_gutter cookie hides the sidebar
    var bpBreakpoint = __WEBPACK_IMPORTED_MODULE_1__breakpoints__["a" /* default */].getBreakpointSize();
    if (bpBreakpoint === 'xs' || bpBreakpoint === 'sm') {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('collapsed_gutter', true);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (IssuableContext);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./labels_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__ = __webpack_require__("./issuable_bulk_update_actions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtered_search_dropdown_utils__ = __webpack_require__("./filtered_search/dropdown_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__create_label__ = __webpack_require__("./create_label.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flash__ = __webpack_require__("./flash.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-useless-return, func-names, space-before-function-paren, wrap-iife, no-var, no-underscore-dangle, prefer-arrow-callback, max-len, one-var, no-unused-vars, one-var-declaration-per-line, prefer-template, no-new, consistent-return, object-shorthand, comma-dangle, no-shadow, no-param-reassign, brace-style, vars-on-top, quotes, no-lonely-if, no-else-return, dot-notation, no-empty, no-return-assign, camelcase, prefer-spread */
/* global Issuable */
/* global ListLabel */








var LabelsSelect = function () {
  function LabelsSelect(els) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, LabelsSelect);

    var _this, $els;
    _this = this;

    $els = $(els);

    if (!els) {
      $els = $('.js-label-select');
    }

    $els.each(function (i, dropdown) {
      var $block, $colorPreview, $dropdown, $form, $loading, $selectbox, $sidebarCollapsedValue, $value, abilityName, defaultLabel, enableLabelCreateButton, issueURLSplit, issueUpdateURL, labelUrl, namespacePath, projectPath, saveLabelData, selectedLabel, showAny, showNo, $sidebarLabelTooltip, initialSelected, $toggleText, fieldName, useId, propertyName, showMenuAbove, $container, $dropdownContainer;
      $dropdown = $(dropdown);
      $dropdownContainer = $dropdown.closest('.labels-filter');
      $toggleText = $dropdown.find('.dropdown-toggle-text');
      namespacePath = $dropdown.data('namespacePath');
      projectPath = $dropdown.data('projectPath');
      labelUrl = $dropdown.data('labels');
      issueUpdateURL = $dropdown.data('issueUpdate');
      selectedLabel = $dropdown.data('selected');
      if (selectedLabel != null && !$dropdown.hasClass('js-multiselect')) {
        selectedLabel = selectedLabel.split(',');
      }
      showNo = $dropdown.data('showNo');
      showAny = $dropdown.data('showAny');
      showMenuAbove = $dropdown.data('showMenuAbove');
      defaultLabel = $dropdown.data('defaultLabel');
      abilityName = $dropdown.data('abilityName');
      $selectbox = $dropdown.closest('.selectbox');
      $block = $selectbox.closest('.block');
      $form = $dropdown.closest('form, .js-issuable-update');
      $sidebarCollapsedValue = $block.find('.sidebar-collapsed-icon span');
      $sidebarLabelTooltip = $block.find('.js-sidebar-labels-tooltip');
      $value = $block.find('.value');
      $loading = $block.find('.block-loading').fadeOut();
      fieldName = $dropdown.data('fieldName');
      useId = $dropdown.is('.js-issuable-form-dropdown, .js-filter-bulk-update, .js-label-sidebar-dropdown');
      propertyName = useId ? 'id' : 'title';
      initialSelected = $selectbox.find('input[name="' + $dropdown.data('fieldName') + '"]').map(function () {
        return this.value;
      }).get();
      var handleClick = options.handleClick;

      $sidebarLabelTooltip.tooltip();

      if ($dropdown.closest('.dropdown').find('.dropdown-new-label').length) {
        new __WEBPACK_IMPORTED_MODULE_5__create_label__["a" /* default */]($dropdown.closest('.dropdown').find('.dropdown-new-label'), namespacePath, projectPath);
      }

      saveLabelData = function saveLabelData() {
        var data, selected;
        selected = $dropdown.closest('.selectbox').find("input[name='" + fieldName + "']").map(function () {
          return this.value;
        }).get();

        if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isEqual(initialSelected, selected)) return;
        initialSelected = selected;

        data = {};
        data[abilityName] = {};
        data[abilityName].label_ids = selected;
        if (!selected.length) {
          data[abilityName].label_ids = [''];
        }
        $loading.removeClass('hidden').fadeIn();
        $dropdown.trigger('loading.gl.dropdown');
        __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].put(issueUpdateURL, data).then(function (_ref) {
          var data = _ref.data;

          var labelCount, template, labelTooltipTitle, labelTitles;
          $loading.fadeOut();
          $dropdown.trigger('loaded.gl.dropdown');
          $selectbox.hide();
          data.issueUpdateURL = issueUpdateURL;
          labelCount = 0;
          if (data.labels.length && issueUpdateURL) {
            template = LabelsSelect.getLabelTemplate({
              labels: data.labels,
              issueUpdateURL: issueUpdateURL
            });
            labelCount = data.labels.length;
          } else {
            template = '<span class="no-value">None</span>';
          }
          $value.removeAttr('style').html(template);
          $sidebarCollapsedValue.text(labelCount);

          if (data.labels.length) {
            labelTitles = data.labels.map(function (label) {
              return label.title;
            });

            if (labelTitles.length > 5) {
              labelTitles = labelTitles.slice(0, 5);
              labelTitles.push('and ' + (data.labels.length - 5) + ' more');
            }

            labelTooltipTitle = labelTitles.join(', ');
          } else {
            labelTooltipTitle = '';
            $sidebarLabelTooltip.tooltip('destroy');
          }

          $sidebarLabelTooltip.attr('title', labelTooltipTitle).tooltip('fixTitle');

          $('.has-tooltip', $value).tooltip({
            container: 'body'
          });
        }).catch(function () {
          return Object(__WEBPACK_IMPORTED_MODULE_6__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('Error saving label update.'));
        });
      };
      $dropdown.glDropdown({
        showMenuAbove: showMenuAbove,
        data: function data(term, callback) {
          __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(labelUrl).then(function (res) {
            var data = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.chain(res.data).groupBy(function (label) {
              return label.title;
            }).map(function (label) {
              var color;
              color = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.map(label, function (dup) {
                return dup.color;
              });
              return {
                id: label[0].id,
                title: label[0].title,
                color: color,
                duplicate: color.length > 1
              };
            }).value();
            if ($dropdown.hasClass('js-extra-options')) {
              var extraData = [];
              if (showNo) {
                extraData.unshift({
                  id: 0,
                  title: '没有标记'
                });
              }
              if (showAny) {
                extraData.unshift({
                  isAny: true,
                  title: '所有标记'
                });
              }
              if (extraData.length) {
                extraData.push('divider');
                data = extraData.concat(data);
              }
            }

            callback(data);
            if (showMenuAbove) {
              $dropdown.data('glDropdown').positionMenuAbove();
            }
          }).catch(function () {
            return Object(__WEBPACK_IMPORTED_MODULE_6__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('Error fetching labels.'));
          });
        },
        renderRow: function renderRow(label, instance) {
          var $a, $li, color, colorEl, indeterminate, removesAll, selectedClass, spacing, i, marked, dropdownName, dropdownValue;
          $li = $('<li>');
          $a = $('<a href="#">');
          selectedClass = [];
          removesAll = label.id <= 0 || label.id == null;
          if ($dropdown.hasClass('js-filter-bulk-update')) {
            indeterminate = $dropdown.data('indeterminate') || [];
            marked = $dropdown.data('marked') || [];

            if (indeterminate.indexOf(label.id) !== -1) {
              selectedClass.push('is-indeterminate');
            }

            if (marked.indexOf(label.id) !== -1) {
              // Remove is-indeterminate class if the item will be marked as active
              i = selectedClass.indexOf('is-indeterminate');
              if (i !== -1) {
                selectedClass.splice(i, 1);
              }
              selectedClass.push('is-active');
            }
          } else {
            if (this.id(label)) {
              dropdownName = $dropdown.data('fieldName');
              dropdownValue = this.id(label).toString().replace(/'/g, '\\\'');

              if ($form.find("input[type='hidden'][name='" + dropdownName + "'][value='" + dropdownValue + "']").length) {
                selectedClass.push('is-active');
              }
            }

            if ($dropdown.hasClass('js-multiselect') && removesAll) {
              selectedClass.push('dropdown-clear-active');
            }
          }
          if (label.duplicate) {
            color = __WEBPACK_IMPORTED_MODULE_4__filtered_search_dropdown_utils__["a" /* default */].duplicateLabelColor(label.color);
          } else {
            if (label.color != null) {
              color = label.color[0];
            }
          }
          if (color) {
            colorEl = "<span class='dropdown-label-box' style='background: " + color + "'></span>";
          } else {
            colorEl = '';
          }
          // We need to identify which items are actually labels
          if (label.id) {
            selectedClass.push('label-item');
            $a.attr('data-label-id', label.id);
          }
          $a.addClass(selectedClass.join(' ')).html(colorEl + ' ' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(label.title));
          // Return generated html
          return $li.html($a).prop('outerHTML');
        },
        search: {
          fields: ['title']
        },
        selectable: true,
        filterable: true,
        selected: $dropdown.data('selected') || [],
        toggleLabel: function toggleLabel(selected, el) {
          var $dropdownParent = $dropdown.parent();
          var $dropdownInputField = $dropdownParent.find('.dropdown-input-field');
          var isSelected = el !== null ? el.hasClass('is-active') : false;
          var title = selected.title;
          var selectedLabels = this.selected;

          if ($dropdownInputField.length && $dropdownInputField.val().length) {
            $dropdownParent.find('.dropdown-input-clear').trigger('click');
          }

          if (selected.id === 0) {
            this.selected = [];
            return '无标记';
          } else if (isSelected) {
            this.selected.push(title);
          } else {
            var index = this.selected.indexOf(title);
            this.selected.splice(index, 1);
          }

          if (selectedLabels.length === 1) {
            return selectedLabels;
          } else if (selectedLabels.length) {
            return selectedLabels[0] + " +" + (selectedLabels.length - 1) + " more";
          } else {
            return defaultLabel;
          }
        },
        fieldName: $dropdown.data('fieldName'),
        id: function id(label) {
          if (label.id <= 0) return label.title;

          if ($dropdown.hasClass('js-issuable-form-dropdown')) {
            return label.id;
          }

          if ($dropdown.hasClass("js-filter-submit") && label.isAny == null) {
            return label.title;
          } else {
            return label.id;
          }
        },
        hidden: function hidden() {
          var isIssueIndex, isMRIndex, page, selectedLabels;
          page = $('body').attr('data-page');
          isIssueIndex = page === 'projects:issues:index';
          isMRIndex = page === 'projects:merge_requests:index';
          $selectbox.hide();
          // display:block overrides the hide-collapse rule
          $value.removeAttr('style');

          if ($dropdown.hasClass('js-issuable-form-dropdown')) {
            return;
          }

          if ($('html').hasClass('issue-boards-page')) {
            return;
          }
          if ($dropdown.hasClass('js-multiselect')) {
            if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
              selectedLabels = $dropdown.closest('form').find("input:hidden[name='" + $dropdown.data('fieldName') + "']");
              Issuable.filterResults($dropdown.closest('form'));
            } else if ($dropdown.hasClass('js-filter-submit')) {
              $dropdown.closest('form').submit();
            } else {
              if (!$dropdown.hasClass('js-filter-bulk-update')) {
                saveLabelData();
              }
            }
          }
        },
        multiSelect: $dropdown.hasClass('js-multiselect'),
        vue: $dropdown.hasClass('js-issue-board-sidebar'),
        clicked: function clicked(clickEvent) {
          var $el = clickEvent.$el,
              e = clickEvent.e,
              isMarking = clickEvent.isMarking;

          var label = clickEvent.selectedObj;

          var isIssueIndex, isMRIndex, page, boardsModel;
          var fadeOutLoader = function fadeOutLoader() {
            $loading.fadeOut();
          };

          page = $('body').attr('data-page');
          isIssueIndex = page === 'projects:issues:index';
          isMRIndex = page === 'projects:merge_requests:index';

          if ($dropdown.parent().find('.is-active:not(.dropdown-clear-active)').length) {
            $dropdown.parent().find('.dropdown-clear-active').removeClass('is-active');
          }

          if ($dropdown.hasClass('js-issuable-form-dropdown')) {
            return;
          }

          if ($dropdown.hasClass('js-filter-bulk-update')) {
            _this.enableBulkLabelDropdown();
            _this.setDropdownData($dropdown, isMarking, label.id);
            return;
          }

          if ($dropdown.closest('.add-issues-modal').length) {
            boardsModel = gl.issueBoards.ModalStore.store.filter;
          }

          if (boardsModel) {
            if (label.isAny) {
              boardsModel['label_name'] = [];
            } else if ($el.hasClass('is-active')) {
              boardsModel['label_name'].push(label.title);
            }

            e.preventDefault();
            return;
          } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
            if (!$dropdown.hasClass('js-multiselect')) {
              selectedLabel = label.title;
              return Issuable.filterResults($dropdown.closest('form'));
            }
          } else if ($dropdown.hasClass('js-filter-submit')) {
            return $dropdown.closest('form').submit();
          } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
            if ($el.hasClass('is-active')) {
              gl.issueBoards.BoardsStore.detail.issue.labels.push(new ListLabel({
                id: label.id,
                title: label.title,
                color: label.color[0],
                textColor: '#fff'
              }));
            } else {
              var labels = gl.issueBoards.BoardsStore.detail.issue.labels;
              labels = labels.filter(function (selectedLabel) {
                return selectedLabel.id !== label.id;
              });
              gl.issueBoards.BoardsStore.detail.issue.labels = labels;
            }

            $loading.fadeIn();

            gl.issueBoards.BoardsStore.detail.issue.update($dropdown.attr('data-issue-update')).then(fadeOutLoader).catch(fadeOutLoader);
          } else if (handleClick) {
            e.preventDefault();
            handleClick(label);
          } else {
            if ($dropdown.hasClass('js-multiselect')) {} else {
              return saveLabelData();
            }
          }
        }
      });

      // Set dropdown data
      _this.setOriginalDropdownData($dropdownContainer, $dropdown);
    });
    this.bindEvents();
  }

  _createClass(LabelsSelect, [{
    key: 'bindEvents',
    value: function bindEvents() {
      return $('body').on('change', '.selected_issue', this.onSelectCheckboxIssue);
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'onSelectCheckboxIssue',
    value: function onSelectCheckboxIssue() {
      if ($('.selected_issue:checked').length) {
        return;
      }
      return $('.issues-bulk-update .labels-filter .dropdown-toggle-text').text('Label');
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'enableBulkLabelDropdown',
    value: function enableBulkLabelDropdown() {
      __WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__["a" /* default */].willUpdateLabels = true;
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'setDropdownData',
    value: function setDropdownData($dropdown, isMarking, value) {
      var i, markedIds, unmarkedIds, indeterminateIds;

      markedIds = $dropdown.data('marked') || [];
      unmarkedIds = $dropdown.data('unmarked') || [];
      indeterminateIds = $dropdown.data('indeterminate') || [];

      if (isMarking) {
        markedIds.push(value);

        i = indeterminateIds.indexOf(value);
        if (i > -1) {
          indeterminateIds.splice(i, 1);
        }

        i = unmarkedIds.indexOf(value);
        if (i > -1) {
          unmarkedIds.splice(i, 1);
        }
      } else {
        // If marked item (not common) is unmarked
        i = markedIds.indexOf(value);
        if (i > -1) {
          markedIds.splice(i, 1);
        }

        // If an indeterminate item is being unmarked
        if (__WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__["a" /* default */].getOriginalIndeterminateIds().indexOf(value) > -1) {
          unmarkedIds.push(value);
        }

        // If a marked item is being unmarked
        // (a marked item could also be a label that is present in all selection)
        if (__WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__["a" /* default */].getOriginalCommonIds().indexOf(value) > -1) {
          unmarkedIds.push(value);
        }
      }

      $dropdown.data('marked', markedIds);
      $dropdown.data('unmarked', unmarkedIds);
      $dropdown.data('indeterminate', indeterminateIds);
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'setOriginalDropdownData',
    value: function setOriginalDropdownData($container, $dropdown) {
      var labels = [];
      $container.find('[name="label_name[]"]').map(function () {
        return labels.push(this.value);
      });
      $dropdown.data('marked', labels);
    }
  }], [{
    key: 'getLabelTemplate',
    value: function getLabelTemplate(tplData) {
      // We could use ES6 template string here
      // and properly indent markup for readability
      // but that also introduces unintended white-space
      // so best approach is to use traditional way of
      // concatenation
      // see: http://2ality.com/2016/05/template-literal-whitespace.html#joining-arrays
      var tpl = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template(['<% _.each(labels, function(label){ %>', '<a href="<%- issueUpdateURL.slice(0, issueUpdateURL.lastIndexOf("/")) %>?label_name[]=<%- encodeURIComponent(label.title) %>">', '<span class="label has-tooltip color-label" title="<%- label.description %>" style="background-color: <%- label.color %>; color: <%- label.text_color %>;">', '<%- label.title %>', '</span>', '</a>', '<% }); %>'].join(''));

      return tpl(tplData);
    }
  }]);

  return LabelsSelect;
}();

/* harmony default export */ __webpack_exports__["a"] = (LabelsSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./lib/utils/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BYTES_IN_KIB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIDDEN_CLASS; });
var BYTES_IN_KIB = 1024;
var HIDDEN_CLASS = 'hidden';

/***/ }),

/***/ "./lib/utils/datefix.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pad */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parsePikadayDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pikadayToString; });

var pad = function pad(val) {
  var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return ('0' + val).slice(-len);
};

/**
 * Formats dates in Pickaday
 * @param {String} dateString Date in yyyy-mm-dd format
 * @return {Date} UTC format
 */
var parsePikadayDate = function parsePikadayDate(dateString) {
  var parts = dateString.split('-');
  var year = parseInt(parts[0], 10);
  var month = parseInt(parts[1] - 1, 10);
  var day = parseInt(parts[2], 10);

  return new Date(year, month, day);
};

/**
 * Used `onSelect` method in pickaday
 * @param {Date} date UTC format
 * @return {String} Date formated in yyyy-mm-dd
 */
var pikadayToString = function pikadayToString(date) {
  var day = pad(date.getDate());
  var month = pad(date.getMonth() + 1);
  var year = date.getFullYear();

  return year + '-' + month + '-' + day;
};

/***/ }),

/***/ "./lib/utils/http_status.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * exports HTTP status codes
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  ABORTED: 0,
  NO_CONTENT: 204,
  OK: 200,
  MULTIPLE_CHOICES: 300,
  BAD_REQUEST: 400
});

/***/ }),

/***/ "./lib/utils/image_utility.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isImageLoaded;
/* eslint-disable import/prefer-default-export */

function isImageLoaded(element) {
  return element.complete && element.naturalHeight !== 0;
}

/***/ }),

/***/ "./lib/utils/number_utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = formatRelevantDigits;
/* unused harmony export bytesToKiB */
/* harmony export (immutable) */ __webpack_exports__["a"] = bytesToMiB;
/* unused harmony export bytesToGiB */
/* harmony export (immutable) */ __webpack_exports__["c"] = numberToHumanSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./lib/utils/constants.js");


/**
 * Function that allows a number with an X amount of decimals
 * to be formatted in the following fashion:
 * * For 1 digit to the left of the decimal point and X digits to the right of it
 * * * Show 3 digits to the right
 * * For 2 digits to the left of the decimal point and X digits to the right of it
 * * * Show 2 digits to the right
*/
function formatRelevantDigits(number) {
  var digitsLeft = '';
  var relevantDigits = 0;
  var formattedNumber = '';
  if (!isNaN(Number(number))) {
    digitsLeft = number.toString().split('.')[0];
    switch (digitsLeft.length) {
      case 1:
        relevantDigits = 3;
        break;
      case 2:
        relevantDigits = 2;
        break;
      case 3:
        relevantDigits = 1;
        break;
      default:
        relevantDigits = 4;
        break;
    }
    formattedNumber = Number(number).toFixed(relevantDigits);
  }
  return formattedNumber;
}

/**
 * Utility function that calculates KiB of the given bytes.
 *
 * @param  {Number} number bytes
 * @return {Number}        KiB
 */
function bytesToKiB(number) {
  return number / __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */];
}

/**
 * Utility function that calculates MiB of the given bytes.
 *
 * @param  {Number} number bytes
 * @return {Number}        MiB
 */
function bytesToMiB(number) {
  return number / (__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]);
}

/**
 * Utility function that calculates GiB of the given bytes.
 * @param {Number} number
 * @returns {Number}
 */
function bytesToGiB(number) {
  return number / (__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]);
}

/**
 * Port of rails number_to_human_size
 * Formats the bytes in number into a more understandable
 * representation (e.g., giving it 1500 yields 1.5 KB).
 *
 * @param {Number} size
 * @returns {String}
 */
function numberToHumanSize(size) {
  if (size < __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]) {
    return size + ' bytes';
  } else if (size < __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]) {
    return bytesToKiB(size).toFixed(2) + ' KiB';
  } else if (size < __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]) {
    return bytesToMiB(size).toFixed(2) + ' MiB';
  }
  return bytesToGiB(size).toFixed(2) + ' GiB';
}

/***/ }),

/***/ "./lib/utils/poll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_status__ = __webpack_require__("./lib/utils/http_status.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




/**
 * Polling utility for handling realtime updates.
 * Requirements: Promise based HTTP client
 *
 * Service for promise based http client and method need to be provided as props
 *
 * @example
 * new Poll({
 *   resource: resource,
 *   method: 'name',
 *   data: {page: 1, scope: 'all'}, // optional
 *   successCallback: () => {},
 *   errorCallback: () => {},
 *   notificationCallback: () => {}, // optional
 * }).makeRequest();
 *
 * Usage in pipelines table with visibility lib:
 *
 * const poll = new Poll({
 *  resource: this.service,
 *  method: 'getPipelines',
 *  data: { page: pageNumber, scope },
 *  successCallback: this.successCallback,
 *  errorCallback: this.errorCallback,
 *  notificationCallback: this.updateLoading,
 * });
 *
 * if (!Visibility.hidden()) {
 *  poll.makeRequest();
 *  }
 *
 * Visibility.change(() => {
 *  if (!Visibility.hidden()) {
 *   poll.restart();
 *  } else {
 *   poll.stop();
 *  }
* });
 *
 * 1. Checks for response and headers before start polling
 * 2. Interval is provided by `Poll-Interval` header.
 * 3. If `Poll-Interval` is -1, we stop polling
 * 4. If HTTP response is 200, we poll.
 * 5. If HTTP response is different from 200, we stop polling.
 *
 */

var Poll = function () {
  function Poll() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Poll);

    this.options = options;
    this.options.data = options.data || {};
    this.options.notificationCallback = options.notificationCallback || function notificationCallback() {};

    this.intervalHeader = 'POLL-INTERVAL';
    this.timeoutID = null;
    this.canPoll = true;
  }

  _createClass(Poll, [{
    key: 'checkConditions',
    value: function checkConditions(response) {
      var _this = this;

      var headers = Object(__WEBPACK_IMPORTED_MODULE_1__common_utils__["x" /* normalizeHeaders */])(response.headers);
      var pollInterval = parseInt(headers[this.intervalHeader], 10);
      if (pollInterval > 0 && response.status === __WEBPACK_IMPORTED_MODULE_0__http_status__["a" /* default */].OK && this.canPoll) {
        this.timeoutID = setTimeout(function () {
          _this.makeRequest();
        }, pollInterval);
      }
      this.options.successCallback(response);
    }
  }, {
    key: 'makeRequest',
    value: function makeRequest() {
      var _this2 = this;

      var _options = this.options,
          resource = _options.resource,
          method = _options.method,
          data = _options.data,
          errorCallback = _options.errorCallback,
          notificationCallback = _options.notificationCallback;

      // It's called everytime a new request is made. Useful to update the status.

      notificationCallback(true);

      return resource[method](data).then(function (response) {
        _this2.checkConditions(response);
        notificationCallback(false);
      }).catch(function (error) {
        notificationCallback(false);
        if (error.status === __WEBPACK_IMPORTED_MODULE_0__http_status__["a" /* default */].ABORTED) {
          return;
        }
        errorCallback(error);
      });
    }

    /**
     * Stops the polling recursive chain
     * and guarantees if the timeout is already running it won't make another request by
     * cancelling the previously established timeout.
     */

  }, {
    key: 'stop',
    value: function stop() {
      this.canPoll = false;
      clearTimeout(this.timeoutID);
    }

    /**
     * Restarts polling after it has been stoped
     */

  }, {
    key: 'restart',
    value: function restart(options) {
      // update data
      if (options && options.data) {
        this.options.data = options.data;
      }

      this.canPoll = true;
      this.makeRequest();
    }
  }]);

  return Poll;
}();

/* harmony default export */ __webpack_exports__["a"] = (Poll);

/***/ }),

/***/ "./lib/utils/sticky.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createPlaceholder */
/* unused harmony export isSticky */
var createPlaceholder = function createPlaceholder() {
  var placeholder = document.createElement('div');
  placeholder.classList.add('sticky-placeholder');

  return placeholder;
};

var isSticky = function isSticky(el, scrollY, stickyTop, insertPlaceholder) {
  var top = Math.floor(el.offsetTop - scrollY);

  if (top <= stickyTop && !el.classList.contains('is-stuck')) {
    var placeholder = insertPlaceholder ? createPlaceholder() : null;
    var heightBefore = el.offsetHeight;

    el.classList.add('is-stuck');

    if (insertPlaceholder) {
      el.parentNode.insertBefore(placeholder, el.nextElementSibling);

      placeholder.style.height = heightBefore - el.offsetHeight + 'px';
    }
  } else if (top > stickyTop && el.classList.contains('is-stuck')) {
    el.classList.remove('is-stuck');

    if (insertPlaceholder && el.nextElementSibling && el.nextElementSibling.classList.contains('sticky-placeholder')) {
      el.nextElementSibling.remove();
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function (el, stickyTop) {
  var insertPlaceholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!el) return;

  if (typeof CSS === 'undefined' || !CSS.supports('(position: -webkit-sticky) or (position: sticky)')) return;

  document.addEventListener('scroll', function () {
    return isSticky(el, window.scrollY, stickyTop, insertPlaceholder);
  }, {
    passive: true
  });
});

/***/ }),

/***/ "./lib/utils/text_markdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable import/prefer-default-export, func-names, space-before-function-paren, wrap-iife, no-var, no-param-reassign, no-cond-assign, quotes, one-var, one-var-declaration-per-line, operator-assignment, no-else-return, prefer-template, prefer-arrow-callback, no-empty, max-len, consistent-return, no-unused-vars, no-return-assign, max-len, vars-on-top */

var textUtils = {};

textUtils.selectedText = function (text, textarea) {
  return text.substring(textarea.selectionStart, textarea.selectionEnd);
};

textUtils.lineBefore = function (text, textarea) {
  var split;
  split = text.substring(0, textarea.selectionStart).trim().split('\n');
  return split[split.length - 1];
};

textUtils.lineAfter = function (text, textarea) {
  return text.substring(textarea.selectionEnd).trim().split('\n')[0];
};

textUtils.blockTagText = function (text, textArea, blockTag, selected) {
  var lineAfter, lineBefore;
  lineBefore = this.lineBefore(text, textArea);
  lineAfter = this.lineAfter(text, textArea);
  if (lineBefore === blockTag && lineAfter === blockTag) {
    // To remove the block tag we have to select the line before & after
    if (blockTag != null) {
      textArea.selectionStart = textArea.selectionStart - (blockTag.length + 1);
      textArea.selectionEnd = textArea.selectionEnd + (blockTag.length + 1);
    }
    return selected;
  } else {
    return blockTag + "\n" + selected + "\n" + blockTag;
  }
};

textUtils.insertText = function (textArea, text, tag, blockTag, selected, wrap) {
  var insertText, inserted, selectedSplit, startChar, removedLastNewLine, removedFirstNewLine, currentLineEmpty, lastNewLine;
  removedLastNewLine = false;
  removedFirstNewLine = false;
  currentLineEmpty = false;

  // Remove the first newline
  if (selected.indexOf('\n') === 0) {
    removedFirstNewLine = true;
    selected = selected.replace(/\n+/, '');
  }

  // Remove the last newline
  if (textArea.selectionEnd - textArea.selectionStart > selected.replace(/\n$/, '').length) {
    removedLastNewLine = true;
    selected = selected.replace(/\n$/, '');
  }

  selectedSplit = selected.split('\n');

  if (!wrap) {
    lastNewLine = textArea.value.substr(0, textArea.selectionStart).lastIndexOf('\n');

    // Check whether the current line is empty or consists only of spaces(=handle as empty)
    if (/^\s*$/.test(textArea.value.substring(lastNewLine, textArea.selectionStart))) {
      currentLineEmpty = true;
    }
  }

  startChar = !wrap && !currentLineEmpty && textArea.selectionStart > 0 ? '\n' : '';

  if (selectedSplit.length > 1 && (!wrap || blockTag != null && blockTag !== '')) {
    if (blockTag != null && blockTag !== '') {
      insertText = this.blockTagText(text, textArea, blockTag, selected);
    } else {
      insertText = selectedSplit.map(function (val) {
        if (val.indexOf(tag) === 0) {
          return "" + val.replace(tag, '');
        } else {
          return "" + tag + val;
        }
      }).join('\n');
    }
  } else {
    insertText = "" + startChar + tag + selected + (wrap ? tag : ' ');
  }

  if (removedFirstNewLine) {
    insertText = '\n' + insertText;
  }

  if (removedLastNewLine) {
    insertText += '\n';
  }

  if (document.queryCommandSupported('insertText')) {
    inserted = document.execCommand('insertText', false, insertText);
  }
  if (!inserted) {
    try {
      document.execCommand("ms-beginUndoUnit");
    } catch (error) {}
    textArea.value = this.replaceRange(text, textArea.selectionStart, textArea.selectionEnd, insertText);
    try {
      document.execCommand("ms-endUndoUnit");
    } catch (error) {}
  }
  return this.moveCursor(textArea, tag, wrap, removedLastNewLine);
};

textUtils.moveCursor = function (textArea, tag, wrapped, removedLastNewLine) {
  var pos;
  if (!textArea.setSelectionRange) {
    return;
  }
  if (textArea.selectionStart === textArea.selectionEnd) {
    if (wrapped) {
      pos = textArea.selectionStart - tag.length;
    } else {
      pos = textArea.selectionStart;
    }

    if (removedLastNewLine) {
      pos -= 1;
    }

    return textArea.setSelectionRange(pos, pos);
  }
};

textUtils.updateText = function (textArea, tag, blockTag, wrap) {
  var $textArea, selected, text;
  $textArea = $(textArea);
  textArea = $textArea.get(0);
  text = $textArea.val();
  selected = this.selectedText(text, textArea);
  $textArea.focus();
  return this.insertText(textArea, text, tag, blockTag, selected, wrap);
};

textUtils.init = function (form) {
  var self;
  self = this;
  return $('.js-md', form).off('click').on('click', function () {
    var $this;
    $this = $(this);
    return self.updateText($this.closest('.md-area').find('textarea'), $this.data('mdTag'), $this.data('mdBlock'), !$this.data('mdPrepend'));
  });
};

textUtils.removeListeners = function (form) {
  return $('.js-md', form).off('click');
};

textUtils.replaceRange = function (s, start, end, substitute) {
  return s.substring(0, start) + substitute + s.substring(end);
};

/* harmony default export */ __webpack_exports__["a"] = (textUtils);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./merge_request.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task_list__ = __webpack_require__("./task_list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__merge_request_tabs__ = __webpack_require__("./merge_request_tabs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_issuables_helper__ = __webpack_require__("./helpers/issuables_helper.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_text_utility__ = __webpack_require__("./lib/utils/text_utility.js");
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, quotes, no-underscore-dangle, one-var, one-var-declaration-per-line, consistent-return, dot-notation, quote-props, comma-dangle, object-shorthand, max-len, prefer-arrow-callback */






function MergeRequest(opts) {
  // Initialize MergeRequest behavior
  //
  // Options:
  //   action - String, current controller action
  //
  this.opts = opts != null ? opts : {};
  this.submitNoteForm = this.submitNoteForm.bind(this);
  this.$el = $('.merge-request');
  this.$('.show-all-commits').on('click', function (_this) {
    return function () {
      return _this.showAllCommits();
    };
  }(this));

  this.initTabs();
  this.initMRBtnListeners();
  this.initCommitMessageListeners();
  this.closeReopenReportToggle = __WEBPACK_IMPORTED_MODULE_3__helpers_issuables_helper__["a" /* default */].initCloseReopenReport();

  if ($("a.btn-close").length) {
    this.taskList = new __WEBPACK_IMPORTED_MODULE_1__task_list__["a" /* default */]({
      dataType: 'merge_request',
      fieldName: 'description',
      selector: '.detail-page-description',
      onSuccess: function onSuccess(result) {
        document.querySelector('#task_status').innerText = result.task_status;
        document.querySelector('#task_status_short').innerText = result.task_status_short;
      }
    });
  }
}

// Local jQuery finder
MergeRequest.prototype.$ = function (selector) {
  return this.$el.find(selector);
};

MergeRequest.prototype.initTabs = function () {
  if (window.mrTabs) {
    window.mrTabs.unbindEvents();
  }
  window.mrTabs = new __WEBPACK_IMPORTED_MODULE_2__merge_request_tabs__["a" /* default */](this.opts);
};

MergeRequest.prototype.showAllCommits = function () {
  this.$('.first-commits').remove();
  return this.$('.all-commits').removeClass('hide');
};

MergeRequest.prototype.initMRBtnListeners = function () {
  var _this;
  _this = this;
  return $('a.btn-close, a.btn-reopen').on('click', function (e) {
    var $this, shouldSubmit;
    $this = $(this);
    shouldSubmit = $this.hasClass('btn-comment');
    if (shouldSubmit && $this.data('submitted')) {
      return;
    }

    if (this.closeReopenReportToggle) this.closeReopenReportToggle.setDisable();

    if (shouldSubmit) {
      if ($this.hasClass('btn-comment-and-close') || $this.hasClass('btn-comment-and-reopen')) {
        e.preventDefault();
        e.stopImmediatePropagation();

        _this.submitNoteForm($this.closest('form'), $this);
      }
    }
  });
};

MergeRequest.prototype.submitNoteForm = function (form, $button) {
  var noteText;
  noteText = form.find("textarea.js-note-text").val();
  if (noteText.trim().length > 0) {
    form.submit();
    $button.data('submitted', true);
    return $button.trigger('click');
  }
};

MergeRequest.prototype.initCommitMessageListeners = function () {
  $(document).on('click', 'a.js-with-description-link', function (e) {
    var textarea = $('textarea.js-commit-message');
    e.preventDefault();

    textarea.val(textarea.data('messageWithDescription'));
    $('.js-with-description-hint').hide();
    $('.js-without-description-hint').show();
  });

  $(document).on('click', 'a.js-without-description-link', function (e) {
    var textarea = $('textarea.js-commit-message');
    e.preventDefault();

    textarea.val(textarea.data('messageWithoutDescription'));
    $('.js-with-description-hint').show();
    $('.js-without-description-hint').hide();
  });
};

MergeRequest.setStatusBoxToMerged = function () {
  $('.detail-page-header .status-box').removeClass('status-box-open').addClass('status-box-mr-merged').find('span').text(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* __ */])('Merged'));
};

MergeRequest.decreaseCounter = function () {
  var by = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  var $el = $('.js-merge-counter');
  var count = Math.max(parseInt($el.text().replace(/[^\d]/, ''), 10) - by, 0);

  $el.text(Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils_text_utility__["a" /* addDelimiter */])(count));
};

MergeRequest.hideCloseButton = function () {
  var el = document.querySelector('.merge-request .js-issuable-actions');
  var closeDropdownItem = el.querySelector('li.close-item');
  if (closeDropdownItem) {
    closeDropdownItem.classList.add('hidden');
    // Selects the next dropdown item
    el.querySelector('li.report-item').click();
  } else {
    // No dropdown just hide the Close button
    el.querySelector('.btn-close').classList.add('hidden');
  }
  // Dropdown for mobile screen
  el.querySelector('li.js-close-item').classList.add('hidden');
};

/* harmony default export */ __webpack_exports__["a"] = (MergeRequest);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./merge_request_tabs.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blob_blob_fork_suggestion__ = __webpack_require__("./blob/blob_fork_suggestion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__init_changes_dropdown__ = __webpack_require__("./init_changes_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__breakpoints__ = __webpack_require__("./breakpoints.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__image_diff_init_discussion_tab__ = __webpack_require__("./image_diff/init_discussion_tab.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__diff__ = __webpack_require__("./diff.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__syntax_highlight__ = __webpack_require__("./syntax_highlight.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__notes__ = __webpack_require__("./notes.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-new, class-methods-use-this */















/* eslint-disable max-len */
// MergeRequestTabs
//
// Handles persisting and restoring the current tab selection and lazily-loading
// content on the MergeRequests#show page.
//
// ### Example Markup
//
//   <ul class="nav-links merge-request-tabs">
//     <li class="notes-tab active">
//       <a data-action="notes" data-target="#notes" data-toggle="tab" href="/foo/bar/merge_requests/1">
//         Discussion
//       </a>
//     </li>
//     <li class="commits-tab">
//       <a data-action="commits" data-target="#commits" data-toggle="tab" href="/foo/bar/merge_requests/1/commits">
//         Commits
//       </a>
//     </li>
//     <li class="diffs-tab">
//       <a data-action="diffs" data-target="#diffs" data-toggle="tab" href="/foo/bar/merge_requests/1/diffs">
//         Diffs
//       </a>
//     </li>
//   </ul>
//
//   <div class="tab-content">
//     <div class="notes tab-pane active" id="notes">
//       Notes Content
//     </div>
//     <div class="commits tab-pane" id="commits">
//       Commits Content
//     </div>
//     <div class="diffs tab-pane" id="diffs">
//       Diffs Content
//     </div>
//   </div>
//
//   <div class="mr-loading-status">
//     <div class="loading">
//       Loading Animation
//     </div>
//   </div>
//
/* eslint-enable max-len */

// Store the `location` object, allowing for easier stubbing in tests
var location = window.location;

var MergeRequestTabs = function () {
  function MergeRequestTabs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        action = _ref.action,
        setUrl = _ref.setUrl,
        stubLocation = _ref.stubLocation;

    _classCallCheck(this, MergeRequestTabs);

    var mergeRequestTabs = document.querySelector('.js-tabs-affix');
    var navbar = document.querySelector('.navbar-gitlab');
    var paddingTop = 16;

    this.diffsLoaded = false;
    this.pipelinesLoaded = false;
    this.commitsLoaded = false;
    this.fixedLayoutPref = null;

    this.setUrl = setUrl !== undefined ? setUrl : true;
    this.setCurrentAction = this.setCurrentAction.bind(this);
    this.tabShown = this.tabShown.bind(this);
    this.showTab = this.showTab.bind(this);
    this.stickyTop = navbar ? navbar.offsetHeight - paddingTop : 0;

    if (mergeRequestTabs) {
      this.stickyTop += mergeRequestTabs.offsetHeight;
    }

    if (stubLocation) {
      location = stubLocation;
    }

    this.bindEvents();
    this.activateTab(action);
    this.initAffix();
  }

  _createClass(MergeRequestTabs, [{
    key: 'bindEvents',
    value: function bindEvents() {
      $(document).on('shown.bs.tab', '.merge-request-tabs a[data-toggle="tab"]', this.tabShown).on('click', '.js-show-tab', this.showTab);

      $('.merge-request-tabs a[data-toggle="tab"]').on('click', this.clickTab);
    }

    // Used in tests

  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      $(document).off('shown.bs.tab', '.merge-request-tabs a[data-toggle="tab"]', this.tabShown).off('click', '.js-show-tab', this.showTab);

      $('.merge-request-tabs a[data-toggle="tab"]').off('click', this.clickTab);
    }
  }, {
    key: 'destroyPipelinesView',
    value: function destroyPipelinesView() {
      if (this.commitPipelinesTable) {
        this.commitPipelinesTable.$destroy();
        this.commitPipelinesTable = null;

        document.querySelector('#commit-pipeline-table-view').innerHTML = '';
      }
    }
  }, {
    key: 'showTab',
    value: function showTab(e) {
      e.preventDefault();
      this.activateTab($(e.target).data('action'));
    }
  }, {
    key: 'clickTab',
    value: function clickTab(e) {
      if (e.currentTarget && Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils_common_utils__["u" /* isMetaClick */])(e)) {
        var targetLink = e.currentTarget.getAttribute('href');
        e.stopImmediatePropagation();
        e.preventDefault();
        window.open(targetLink, '_blank');
      }
    }
  }, {
    key: 'tabShown',
    value: function tabShown(e) {
      var $target = $(e.target);
      var action = $target.data('action');

      if (action === 'commits') {
        this.loadCommits($target.attr('href'));
        this.expandView();
        this.resetViewContainer();
        this.destroyPipelinesView();
      } else if (this.isDiffAction(action)) {
        this.loadDiff($target.attr('href'));
        if (__WEBPACK_IMPORTED_MODULE_5__breakpoints__["a" /* default */].getBreakpointSize() !== 'lg') {
          this.shrinkView();
        }
        if (this.diffViewType() === 'parallel') {
          this.expandViewContainer();
        }
        this.destroyPipelinesView();
      } else if (action === 'pipelines') {
        this.resetViewContainer();
        this.mountPipelinesView();
      } else {
        if (__WEBPACK_IMPORTED_MODULE_5__breakpoints__["a" /* default */].getBreakpointSize() !== 'xs') {
          this.expandView();
        }
        this.resetViewContainer();
        this.destroyPipelinesView();

        Object(__WEBPACK_IMPORTED_MODULE_8__image_diff_init_discussion_tab__["a" /* default */])();
      }
      if (this.setUrl) {
        this.setCurrentAction(action);
      }
    }
  }, {
    key: 'scrollToElement',
    value: function scrollToElement(container) {
      if (location.hash) {
        var offset = 0 - ($('.navbar-gitlab').outerHeight() + $('.js-tabs-affix').outerHeight());
        var $el = $(container + ' ' + location.hash + ':not(.match)');
        if ($el.length) {
          $.scrollTo($el[0], { offset: offset });
        }
      }
    }

    // Activate a tab based on the current action

  }, {
    key: 'activateTab',
    value: function activateTab(action) {
      // important note: the .tab('show') method triggers 'shown.bs.tab' event itself
      $('.merge-request-tabs a[data-action=\'' + action + '\']').tab('show');
    }

    // Replaces the current Merge Request-specific action in the URL with a new one
    //
    // If the action is "notes", the URL is reset to the standard
    // `MergeRequests#show` route.
    //
    // Examples:
    //
    //   location.pathname # => "/namespace/project/merge_requests/1"
    //   setCurrentAction('diffs')
    //   location.pathname # => "/namespace/project/merge_requests/1/diffs"
    //
    //   location.pathname # => "/namespace/project/merge_requests/1/diffs"
    //   setCurrentAction('show')
    //   location.pathname # => "/namespace/project/merge_requests/1"
    //
    //   location.pathname # => "/namespace/project/merge_requests/1/diffs"
    //   setCurrentAction('commits')
    //   location.pathname # => "/namespace/project/merge_requests/1/commits"
    //
    // Returns the new URL String

  }, {
    key: 'setCurrentAction',
    value: function setCurrentAction(action) {
      this.currentAction = action;

      // Remove a trailing '/commits' '/diffs' '/pipelines'
      var newState = location.pathname.replace(/\/(commits|diffs|pipelines)(\.html)?\/?$/, '');

      // Append the new action if we're on a tab other than 'notes'
      if (this.currentAction !== 'show' && this.currentAction !== 'new') {
        newState += '/' + this.currentAction;
      }

      // Ensure parameters and hash come along for the ride
      newState += location.search + location.hash;

      // TODO: Consider refactoring in light of turbolinks removal.

      // Replace the current history state with the new one without breaking
      // Turbolinks' history.
      //
      // See https://github.com/rails/turbolinks/issues/363
      window.history.replaceState({
        url: newState
      }, document.title, newState);

      return newState;
    }
  }, {
    key: 'getCurrentAction',
    value: function getCurrentAction() {
      return this.currentAction;
    }
  }, {
    key: 'loadCommits',
    value: function loadCommits(source) {
      var _this = this;

      if (this.commitsLoaded) {
        return;
      }

      this.toggleLoading(true);

      __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(source + '.json').then(function (_ref2) {
        var data = _ref2.data;

        document.querySelector('div#commits').innerHTML = data.html;
        Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils_datetime_utility__["e" /* localTimeAgo */])($('.js-timeago', 'div#commits'));
        _this.commitsLoaded = true;
        _this.scrollToElement('#commits');

        _this.toggleLoading(false);
      }).catch(function () {
        _this.toggleLoading(false);
        Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])('An error occurred while fetching this tab.');
      });
    }
  }, {
    key: 'mountPipelinesView',
    value: function mountPipelinesView() {
      var pipelineTableViewEl = document.querySelector('#commit-pipeline-table-view');
      var CommitPipelinesTable = gl.CommitPipelinesTable;
      this.commitPipelinesTable = new CommitPipelinesTable({
        propsData: {
          endpoint: pipelineTableViewEl.dataset.endpoint,
          helpPagePath: pipelineTableViewEl.dataset.helpPagePath,
          emptyStateSvgPath: pipelineTableViewEl.dataset.emptyStateSvgPath,
          errorStateSvgPath: pipelineTableViewEl.dataset.errorStateSvgPath,
          autoDevopsHelpPath: pipelineTableViewEl.dataset.helpAutoDevopsPath
        }
      }).$mount();

      // $mount(el) replaces the el with the new rendered component. We need it in order to mount
      // it everytime this tab is clicked - https://vuejs.org/v2/api/#vm-mount
      pipelineTableViewEl.appendChild(this.commitPipelinesTable.$el);
    }
  }, {
    key: 'loadDiff',
    value: function loadDiff(source) {
      var _this2 = this;

      if (this.diffsLoaded) {
        document.dispatchEvent(new CustomEvent('scroll'));
        return;
      }

      // We extract pathname for the current Changes tab anchor href
      // some pages like MergeRequestsController#new has query parameters on that anchor
      var urlPathname = Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils_common_utils__["B" /* parseUrlPathname */])(source);

      this.toggleLoading(true);

      __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(urlPathname + '.json' + location.search).then(function (_ref3) {
        var data = _ref3.data;

        var $container = $('#diffs');
        $container.html(data.html);

        Object(__WEBPACK_IMPORTED_MODULE_4__init_changes_dropdown__["a" /* default */])(_this2.stickyTop);

        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }

        Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils_datetime_utility__["e" /* localTimeAgo */])($('.js-timeago', 'div#diffs'));
        Object(__WEBPACK_IMPORTED_MODULE_11__syntax_highlight__["a" /* default */])($('#diffs .js-syntax-highlight'));

        if (_this2.diffViewType() === 'parallel' && _this2.isDiffAction(_this2.currentAction)) {
          _this2.expandViewContainer();
        }
        _this2.diffsLoaded = true;

        new __WEBPACK_IMPORTED_MODULE_9__diff__["a" /* default */]();
        _this2.scrollToElement('#diffs');

        $('.diff-file').each(function (i, el) {
          new __WEBPACK_IMPORTED_MODULE_3__blob_blob_fork_suggestion__["a" /* default */]({
            openButtons: $(el).find('.js-edit-blob-link-fork-toggler'),
            forkButtons: $(el).find('.js-fork-suggestion-button'),
            cancelButtons: $(el).find('.js-cancel-fork-suggestion-button'),
            suggestionSections: $(el).find('.js-file-fork-suggestion-section'),
            actionTextPieces: $(el).find('.js-file-fork-suggestion-section-action')
          }).init();
        });

        // Scroll any linked note into view
        // Similar to `toggler_behavior` in the discussion tab
        var hash = Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils_url_utility__["a" /* getLocationHash */])();
        var anchor = hash && $container.find('.note[id="' + hash + '"]');
        if (anchor && anchor.length > 0) {
          var notesContent = anchor.closest('.notes_content');
          var lineType = notesContent.hasClass('new') ? 'new' : 'old';
          __WEBPACK_IMPORTED_MODULE_12__notes__["a" /* default */].instance.toggleDiffNote({
            target: anchor,
            lineType: lineType,
            forceShow: true
          });
          anchor[0].scrollIntoView();
          Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils_common_utils__["m" /* handleLocationHash */])();
          // We have multiple elements on the page with `#note_xxx`
          // (discussion and diff tabs) and `:target` only applies to the first
          anchor.addClass('target');
        }

        _this2.toggleLoading(false);
      }).catch(function () {
        _this2.toggleLoading(false);
        Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])('An error occurred while fetching this tab.');
      });
    }

    // Show or hide the loading spinner
    //
    // status - Boolean, true to show, false to hide

  }, {
    key: 'toggleLoading',
    value: function toggleLoading(status) {
      $('.mr-loading-status .loading').toggle(status);
    }
  }, {
    key: 'diffViewType',
    value: function diffViewType() {
      return $('.inline-parallel-buttons a.active').data('viewType');
    }
  }, {
    key: 'isDiffAction',
    value: function isDiffAction(action) {
      return action === 'diffs' || action === 'new/diffs';
    }
  }, {
    key: 'expandViewContainer',
    value: function expandViewContainer() {
      var $wrapper = $('.content-wrapper .container-fluid').not('.breadcrumbs');
      if (this.fixedLayoutPref === null) {
        this.fixedLayoutPref = $wrapper.hasClass('container-limited');
      }
      $wrapper.removeClass('container-limited');
    }
  }, {
    key: 'resetViewContainer',
    value: function resetViewContainer() {
      if (this.fixedLayoutPref !== null) {
        $('.content-wrapper .container-fluid').toggleClass('container-limited', this.fixedLayoutPref);
      }
    }
  }, {
    key: 'shrinkView',
    value: function shrinkView() {
      var $gutterIcon = $('.js-sidebar-toggle i:visible');

      // Wait until listeners are set
      setTimeout(function () {
        // Only when sidebar is expanded
        if ($gutterIcon.is('.fa-angle-double-right')) {
          $gutterIcon.closest('a').trigger('click', [true]);
        }
      }, 0);
    }

    // Expand the issuable sidebar unless the user explicitly collapsed it

  }, {
    key: 'expandView',
    value: function expandView() {
      if (__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('collapsed_gutter') === 'true') {
        return;
      }
      var $gutterIcon = $('.js-sidebar-toggle i:visible');

      // Wait until listeners are set
      setTimeout(function () {
        // Only when sidebar is collapsed
        if ($gutterIcon.is('.fa-angle-double-left')) {
          $gutterIcon.closest('a').trigger('click', [true]);
        }
      }, 0);
    }
  }, {
    key: 'initAffix',
    value: function initAffix() {
      var $tabs = $('.js-tabs-affix');
      var $fixedNav = $('.navbar-gitlab');

      // Screen space on small screens is usually very sparse
      // So we dont affix the tabs on these
      if (__WEBPACK_IMPORTED_MODULE_5__breakpoints__["a" /* default */].getBreakpointSize() === 'xs' || !$tabs.length) return;

      /**
        If the browser does not support position sticky, it returns the position as static.
        If the browser does support sticky, then we allow the browser to handle it, if not
        then we default back to Bootstraps affix
      **/
      if ($tabs.css('position') !== 'static') return;

      var $diffTabs = $('#diff-notes-app');

      $tabs.off('affix.bs.affix affix-top.bs.affix').affix({
        offset: {
          top: function top() {
            return $diffTabs.offset().top - $tabs.height() - $fixedNav.height();
          }
        }
      }).on('affix.bs.affix', function () {
        return $diffTabs.css({ marginTop: $tabs.height() });
      }).on('affix-top.bs.affix', function () {
        return $diffTabs.css({ marginTop: '' });
      });

      // Fix bug when reloading the page already scrolling
      if ($tabs.hasClass('affix')) {
        $tabs.trigger('affix.bs.affix');
      }
    }
  }]);

  return MergeRequestTabs;
}();

/* harmony default export */ __webpack_exports__["a"] = (MergeRequestTabs);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./notes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__("../../../node_modules/autosize/dist/autosize.js");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/vendor/assets/javascripts/jquery.caret.js
var jquery_caret = __webpack_require__("../../../vendor/assets/javascripts/jquery.caret.js");
var jquery_caret_default = /*#__PURE__*/__webpack_require__.n(jquery_caret);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/vendor/assets/javascripts/jquery.atwho.js
var jquery_atwho = __webpack_require__("../../../vendor/assets/javascripts/jquery.atwho.js");
var jquery_atwho_default = /*#__PURE__*/__webpack_require__.n(jquery_atwho);

// EXTERNAL MODULE: ./lib/utils/ajax_cache.js
var ajax_cache = __webpack_require__("./lib/utils/ajax_cache.js");

// EXTERNAL MODULE: ./lib/utils/axios_utils.js
var axios_utils = __webpack_require__("./lib/utils/axios_utils.js");

// EXTERNAL MODULE: ./lib/utils/url_utility.js
var url_utility = __webpack_require__("./lib/utils/url_utility.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./droplab/drop_lab.js + 7 modules
var drop_lab = __webpack_require__("./droplab/drop_lab.js");

// EXTERNAL MODULE: ./droplab/plugins/input_setter.js
var input_setter = __webpack_require__("./droplab/plugins/input_setter.js");

// CONCATENATED MODULE: ./comment_type_toggle.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




// Todo: Remove this when fixing issue in input_setter plugin
var InputSetter = Object.assign({}, input_setter["a" /* default */]);

var comment_type_toggle_CommentTypeToggle = function () {
  function CommentTypeToggle() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CommentTypeToggle);

    this.dropdownTrigger = opts.dropdownTrigger;
    this.dropdownList = opts.dropdownList;
    this.noteTypeInput = opts.noteTypeInput;
    this.submitButton = opts.submitButton;
    this.closeButton = opts.closeButton;
    this.reopenButton = opts.reopenButton;
  }

  _createClass(CommentTypeToggle, [{
    key: 'initDroplab',
    value: function initDroplab() {
      this.droplab = new drop_lab["a" /* default */]();

      var config = this.setConfig();

      this.droplab.init(this.dropdownTrigger, this.dropdownList, [InputSetter], config);
    }
  }, {
    key: 'setConfig',
    value: function setConfig() {
      var config = {
        InputSetter: [{
          input: this.noteTypeInput,
          valueAttribute: 'data-value'
        }, {
          input: this.submitButton,
          valueAttribute: 'data-submit-text'
        }]
      };

      if (this.closeButton) {
        config.InputSetter.push({
          input: this.closeButton,
          valueAttribute: 'data-close-text'
        }, {
          input: this.closeButton,
          valueAttribute: 'data-close-text',
          inputAttribute: 'data-alternative-text'
        });
      }

      if (this.reopenButton) {
        config.InputSetter.push({
          input: this.reopenButton,
          valueAttribute: 'data-reopen-text'
        }, {
          input: this.reopenButton,
          valueAttribute: 'data-reopen-text',
          inputAttribute: 'data-alternative-text'
        });
      }

      return config;
    }
  }]);

  return CommentTypeToggle;
}();

/* harmony default export */ var comment_type_toggle = (comment_type_toggle_CommentTypeToggle);
// EXTERNAL MODULE: ./gl_form.js
var gl_form = __webpack_require__("./gl_form.js");

// EXTERNAL MODULE: ./awards_handler.js
var awards_handler = __webpack_require__("./awards_handler.js");

// EXTERNAL MODULE: ./autosave.js
var autosave = __webpack_require__("./autosave.js");

// EXTERNAL MODULE: ./task_list.js
var task_list = __webpack_require__("./task_list.js");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// EXTERNAL MODULE: ./image_diff/helpers/index.js + 6 modules
var helpers = __webpack_require__("./image_diff/helpers/index.js");

// EXTERNAL MODULE: ./lib/utils/datetime_utility.js
var datetime_utility = __webpack_require__("./lib/utils/datetime_utility.js");

// CONCATENATED MODULE: ./notes.js
var notes__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function notes__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-restricted-properties, func-names, space-before-function-paren,
no-var, prefer-rest-params, wrap-iife, no-use-before-define, camelcase,
no-unused-expressions, quotes, max-len, one-var, one-var-declaration-per-line,
default-case, prefer-template, consistent-return, no-alert, no-return-assign,
no-param-reassign, prefer-arrow-callback, no-else-return, comma-dangle, no-new,
brace-style, no-lonely-if, vars-on-top, no-unused-vars, no-sequences, no-shadow,
newline-per-chained-call, no-useless-escape, class-methods-use-this */

/* global ResolveService */
/* global mrRefreshWidgetUrl */





 // required by jquery.atwho














window.autosize = autosize_default.a;

function normalizeNewlines(str) {
  return str.replace(/\r\n/g, '\n');
}

var MAX_VISIBLE_COMMIT_LIST_COUNT = 3;
var REGEX_QUICK_ACTIONS = /^\/\w+.*$/gm;

var notes_Notes = function () {
  notes__createClass(Notes, null, [{
    key: 'initialize',
    value: function initialize(notes_url, note_ids, last_fetched_at, view) {
      var enableGFM = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

      if (!this.instance) {
        this.instance = new Notes(notes_url, note_ids, last_fetched_at, view, enableGFM);
      }
    }
  }, {
    key: 'getInstance',
    value: function getInstance() {
      return this.instance;
    }
  }]);

  function Notes(notes_url, note_ids, last_fetched_at, view) {
    var enableGFM = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    notes__classCallCheck(this, Notes);

    this.updateTargetButtons = this.updateTargetButtons.bind(this);
    this.updateComment = this.updateComment.bind(this);
    this.visibilityChange = this.visibilityChange.bind(this);
    this.cancelDiscussionForm = this.cancelDiscussionForm.bind(this);
    this.onAddDiffNote = this.onAddDiffNote.bind(this);
    this.onAddImageDiffNote = this.onAddImageDiffNote.bind(this);
    this.setupDiscussionNoteForm = this.setupDiscussionNoteForm.bind(this);
    this.onReplyToDiscussionNote = this.onReplyToDiscussionNote.bind(this);
    this.removeNote = this.removeNote.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.updateNote = this.updateNote.bind(this);
    this.addDiscussionNote = this.addDiscussionNote.bind(this);
    this.addNoteError = this.addNoteError.bind(this);
    this.addNote = this.addNote.bind(this);
    this.resetMainTargetForm = this.resetMainTargetForm.bind(this);
    this.refresh = this.refresh.bind(this);
    this.keydownNoteText = this.keydownNoteText.bind(this);
    this.toggleCommitList = this.toggleCommitList.bind(this);
    this.postComment = this.postComment.bind(this);
    this.clearFlashWrapper = this.clearFlash.bind(this);
    this.onHashChange = this.onHashChange.bind(this);

    this.notes_url = notes_url;
    this.note_ids = note_ids;
    this.enableGFM = enableGFM;
    // Used to keep track of updated notes while people are editing things
    this.updatedNotesTrackingMap = {};
    this.last_fetched_at = last_fetched_at;
    this.noteable_url = document.URL;
    this.notesCountBadge || (this.notesCountBadge = jquery_default()('.issuable-details').find('.notes-tab .badge'));
    this.basePollingInterval = 15000;
    this.maxPollingSteps = 4;

    this.$wrapperEl = Object(common_utils["n" /* hasVueMRDiscussionsCookie */])() ? jquery_default()(document).find('.diffs') : jquery_default()(document);
    this.cleanBinding();
    this.addBinding();
    this.setPollingInterval();
    this.setupMainTargetNoteForm();
    this.taskList = new task_list["a" /* default */]({
      dataType: 'note',
      fieldName: 'note',
      selector: '.notes'
    });
    this.collapseLongCommitList();
    this.setViewType(view);

    // We are in the Merge Requests page so we need another edit form for Changes tab
    if (Object(common_utils["h" /* getPagePath */])(1) === 'merge_requests') {
      jquery_default()('.note-edit-form').clone().addClass('mr-note-edit-form').insertAfter('.note-edit-form');
    }
  }

  notes__createClass(Notes, [{
    key: 'setViewType',
    value: function setViewType(view) {
      this.view = js_cookie_default.a.get('diff_view') || view;
    }
  }, {
    key: 'addBinding',
    value: function addBinding() {
      // Edit note link
      this.$wrapperEl.on('click', '.js-note-edit', this.showEditForm.bind(this));
      this.$wrapperEl.on('click', '.note-edit-cancel', this.cancelEdit);
      // Reopen and close actions for Issue/MR combined with note form submit
      this.$wrapperEl.on('click', '.js-comment-submit-button', this.postComment);
      this.$wrapperEl.on('click', '.js-comment-save-button', this.updateComment);
      this.$wrapperEl.on('keyup input', '.js-note-text', this.updateTargetButtons);
      // resolve a discussion
      this.$wrapperEl.on('click', '.js-comment-resolve-button', this.postComment);
      // remove a note (in general)
      this.$wrapperEl.on('click', '.js-note-delete', this.removeNote);
      // delete note attachment
      this.$wrapperEl.on('click', '.js-note-attachment-delete', this.removeAttachment);
      // reset main target form when clicking discard
      this.$wrapperEl.on('click', '.js-note-discard', this.resetMainTargetForm);
      // update the file name when an attachment is selected
      this.$wrapperEl.on('change', '.js-note-attachment-input', this.updateFormAttachment);
      // reply to diff/discussion notes
      this.$wrapperEl.on('click', '.js-discussion-reply-button', this.onReplyToDiscussionNote);
      // add diff note
      this.$wrapperEl.on('click', '.js-add-diff-note-button', this.onAddDiffNote);
      // add diff note for images
      this.$wrapperEl.on('click', '.js-add-image-diff-note-button', this.onAddImageDiffNote);
      // hide diff note form
      this.$wrapperEl.on('click', '.js-close-discussion-note-form', this.cancelDiscussionForm);
      // toggle commit list
      this.$wrapperEl.on('click', '.system-note-commit-list-toggler', this.toggleCommitList);
      // fetch notes when tab becomes visible
      this.$wrapperEl.on('visibilitychange', this.visibilityChange);
      // when issue status changes, we need to refresh data
      this.$wrapperEl.on('issuable:change', this.refresh);
      // ajax:events that happen on Form when actions like Reopen, Close are performed on Issues and MRs.
      this.$wrapperEl.on('ajax:success', '.js-main-target-form', this.addNote);
      this.$wrapperEl.on('ajax:success', '.js-discussion-note-form', this.addDiscussionNote);
      this.$wrapperEl.on('ajax:success', '.js-main-target-form', this.resetMainTargetForm);
      this.$wrapperEl.on('ajax:complete', '.js-main-target-form', this.reenableTargetFormSubmitButton);
      // when a key is clicked on the notes
      this.$wrapperEl.on('keydown', '.js-note-text', this.keydownNoteText);
      // When the URL fragment/hash has changed, `#note_xxx`
      jquery_default()(window).on('hashchange', this.onHashChange);
      this.boundGetContent = this.getContent.bind(this);
      document.addEventListener('refreshLegacyNotes', this.boundGetContent);
    }
  }, {
    key: 'cleanBinding',
    value: function cleanBinding() {
      this.$wrapperEl.off('click', '.js-note-edit');
      this.$wrapperEl.off('click', '.note-edit-cancel');
      this.$wrapperEl.off('click', '.js-note-delete');
      this.$wrapperEl.off('click', '.js-note-attachment-delete');
      this.$wrapperEl.off('click', '.js-discussion-reply-button');
      this.$wrapperEl.off('click', '.js-add-diff-note-button');
      this.$wrapperEl.off('click', '.js-add-image-diff-note-button');
      this.$wrapperEl.off('visibilitychange');
      this.$wrapperEl.off('keyup input', '.js-note-text');
      this.$wrapperEl.off('click', '.js-note-target-reopen');
      this.$wrapperEl.off('click', '.js-note-target-close');
      this.$wrapperEl.off('click', '.js-note-discard');
      this.$wrapperEl.off('keydown', '.js-note-text');
      this.$wrapperEl.off('click', '.js-comment-resolve-button');
      this.$wrapperEl.off('click', '.system-note-commit-list-toggler');
      this.$wrapperEl.off('ajax:success', '.js-main-target-form');
      this.$wrapperEl.off('ajax:success', '.js-discussion-note-form');
      this.$wrapperEl.off('ajax:complete', '.js-main-target-form');
      document.removeEventListener('refreshLegacyNotes', this.boundGetContent);
      jquery_default()(window).off('hashchange', this.onHashChange);
    }
  }, {
    key: 'keydownNoteText',
    value: function keydownNoteText(e) {
      var $textarea, discussionNoteForm, editNote, myLastNote, myLastNoteEditBtn, newText, originalText;
      if (Object(common_utils["v" /* isMetaKey */])(e)) {
        return;
      }

      $textarea = jquery_default()(e.target);
      // Edit previous note when UP arrow is hit
      switch (e.which) {
        case 38:
          if ($textarea.val() !== '') {
            return;
          }
          myLastNote = jquery_default()('li.note[data-author-id=\'' + gon.current_user_id + '\'][data-editable]:last', $textarea.closest('.note, .notes_holder, #notes'));
          if (myLastNote.length) {
            myLastNoteEditBtn = myLastNote.find('.js-note-edit');
            return myLastNoteEditBtn.trigger('click', [true, myLastNote]);
          }
          break;
        // Cancel creating diff note or editing any note when ESCAPE is hit
        case 27:
          discussionNoteForm = $textarea.closest('.js-discussion-note-form');
          if (discussionNoteForm.length) {
            if ($textarea.val() !== '') {
              if (!confirm('您确定要取消发表评论？')) {
                return;
              }
            }
            this.removeDiscussionNoteForm(discussionNoteForm);
            return;
          }
          editNote = $textarea.closest('.note');
          if (editNote.length) {
            originalText = $textarea.closest('form').data('originalNote');
            newText = $textarea.val();
            if (originalText !== newText) {
              if (!confirm('您确定要取消编辑评论？')) {
                return;
              }
            }
            return this.removeNoteEditForm(editNote);
          }
      }
    }
  }, {
    key: 'initRefresh',
    value: function initRefresh() {
      if (Notes.interval) {
        clearInterval(Notes.interval);
      }
      return Notes.interval = setInterval(function (_this) {
        return function () {
          return _this.refresh();
        };
      }(this), this.pollingInterval);
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      if (!document.hidden) {
        return this.getContent();
      }
    }
  }, {
    key: 'getContent',
    value: function getContent() {
      var _this2 = this;

      if (this.refreshing) {
        return;
      }

      this.refreshing = true;

      axios_utils["a" /* default */].get(this.notes_url + '?html=true', {
        headers: {
          'X-Last-Fetched-At': this.last_fetched_at
        }
      }).then(function (_ref) {
        var data = _ref.data;

        var notes = data.notes;
        _this2.last_fetched_at = data.last_fetched_at;
        _this2.setPollingInterval(data.notes.length);
        jquery_default.a.each(notes, function (i, note) {
          return _this2.renderNote(note);
        });

        _this2.refreshing = false;
      }).catch(function () {
        _this2.refreshing = false;
      });
    }

    /**
     * Increase @pollingInterval up to 120 seconds on every function call,
     * if `shouldReset` has a truthy value, 'null' or 'undefined' the variable
     * will reset to @basePollingInterval.
     *
     * Note: this function is used to gradually increase the polling interval
     * if there aren't new notes coming from the server
     */

  }, {
    key: 'setPollingInterval',
    value: function setPollingInterval(shouldReset) {
      var nthInterval;
      if (shouldReset == null) {
        shouldReset = true;
      }
      nthInterval = this.basePollingInterval * Math.pow(2, this.maxPollingSteps - 1);
      if (shouldReset) {
        this.pollingInterval = this.basePollingInterval;
      } else if (this.pollingInterval < nthInterval) {
        this.pollingInterval *= 2;
      }
      return this.initRefresh();
    }
  }, {
    key: 'handleQuickActions',
    value: function handleQuickActions(noteEntity) {
      var votesBlock;
      if (noteEntity.commands_changes) {
        if ('merge' in noteEntity.commands_changes) {
          Notes.checkMergeRequestStatus();
        }

        if ('emoji_award' in noteEntity.commands_changes) {
          votesBlock = jquery_default()('.js-awards-block').eq(0);

          Object(awards_handler["a" /* default */])().then(function (awardsHandler) {
            awardsHandler.addAwardToEmojiBar(votesBlock, noteEntity.commands_changes.emoji_award);
            awardsHandler.scrollToAwards();
          }).catch(function () {
            // ignore
          });
        }
      }
    }
  }, {
    key: 'setupNewNote',
    value: function setupNewNote($note) {
      // Update datetime format on the recent note
      Object(datetime_utility["e" /* localTimeAgo */])($note.find('.js-timeago'), false);

      this.collapseLongCommitList();
      this.taskList.init();

      // This stops the note highlight, #note_xxx`, from being removed after real time update
      // The `:target` selector does not re-evaluate after we replace element in the DOM
      Notes.updateNoteTargetSelector($note);
      this.$noteToCleanHighlight = $note;
    }
  }, {
    key: 'onHashChange',
    value: function onHashChange() {
      if (this.$noteToCleanHighlight) {
        Notes.updateNoteTargetSelector(this.$noteToCleanHighlight);
      }

      this.$noteToCleanHighlight = null;
    }
  }, {
    key: 'renderNote',


    /**
     * Render note in main comments area.
     *
     * Note: for rendering inline notes use renderDiscussionNote
     */
    value: function renderNote(noteEntity, $form) {
      var $notesList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : jquery_default()('.main-notes-list');

      if (noteEntity.discussion_html) {
        return this.renderDiscussionNote(noteEntity, $form);
      }

      if (!noteEntity.valid) {
        if (noteEntity.errors && noteEntity.errors.commands_only) {
          if (noteEntity.commands_changes && Object.keys(noteEntity.commands_changes).length > 0) {
            $notesList.find('.system-note.being-posted').remove();
          }
          this.addFlash(noteEntity.errors.commands_only, 'notice', this.parentTimeline.get(0));
          this.refresh();
        }
        return;
      }

      var $note = $notesList.find('#note_' + noteEntity.id);
      if (Notes.isNewNote(noteEntity, this.note_ids)) {
        if (Object(common_utils["n" /* hasVueMRDiscussionsCookie */])()) {
          return;
        }

        this.note_ids.push(noteEntity.id);

        if ($notesList.length) {
          $notesList.find('.system-note.being-posted').remove();
        }
        var $newNote = Notes.animateAppendNote(noteEntity.html, $notesList);

        this.setupNewNote($newNote);
        this.refresh();
        return this.updateNotesCount(1);
      }
      // The server can send the same update multiple times so we need to make sure to only update once per actual update.
      else if (Notes.isUpdatedNote(noteEntity, $note)) {
          var isEditing = $note.hasClass('is-editing');
          var initialContent = normalizeNewlines($note.find('.original-note-content').text().trim());
          var $textarea = $note.find('.js-note-text');
          var currentContent = $textarea.val();
          // There can be CRLF vs LF mismatches if we don't sanitize and compare the same way
          var sanitizedNoteNote = normalizeNewlines(noteEntity.note);
          var isTextareaUntouched = currentContent === initialContent || currentContent === sanitizedNoteNote;

          if (isEditing && isTextareaUntouched) {
            $textarea.val(noteEntity.note);
            this.updatedNotesTrackingMap[noteEntity.id] = noteEntity;
          } else if (isEditing && !isTextareaUntouched) {
            this.putConflictEditWarningInPlace(noteEntity, $note);
            this.updatedNotesTrackingMap[noteEntity.id] = noteEntity;
          } else {
            var $updatedNote = Notes.animateUpdateNote(noteEntity.html, $note);
            this.setupNewNote($updatedNote);
          }
        }

      Notes.refreshVueNotes();
    }
  }, {
    key: 'isParallelView',
    value: function isParallelView() {
      return js_cookie_default.a.get('diff_view') === 'parallel';
    }

    /**
     * Render note in discussion area. To render inline notes use renderDiscussionNote.
     */

  }, {
    key: 'renderDiscussionNote',
    value: function renderDiscussionNote(noteEntity, $form) {
      var discussionContainer, form, row, lineType, diffAvatarContainer;

      if (!Notes.isNewNote(noteEntity, this.note_ids)) {
        return;
      }
      this.note_ids.push(noteEntity.id);

      form = $form || jquery_default()('.js-discussion-note-form[data-discussion-id="' + noteEntity.discussion_id + '"]');
      row = form.length || !noteEntity.discussion_line_code ? form.closest('tr') : jquery_default()('#' + noteEntity.discussion_line_code);

      if (noteEntity.on_image) {
        row = form;
      }

      lineType = this.isParallelView() ? form.find('#line_type').val() : 'old';
      diffAvatarContainer = row.prevAll('.line_holder').first().find('.js-avatar-container.' + lineType + '_line');
      // is this the first note of discussion?
      discussionContainer = jquery_default()('.notes[data-discussion-id="' + noteEntity.discussion_id + '"]');
      if (!discussionContainer.length) {
        discussionContainer = form.closest('.discussion').find('.notes');
      }
      if (discussionContainer.length === 0) {
        if (noteEntity.diff_discussion_html) {
          var $discussion = jquery_default()(noteEntity.diff_discussion_html).renderGFM();

          if (!this.isParallelView() || row.hasClass('js-temp-notes-holder') || noteEntity.on_image) {
            // insert the note and the reply button after the temp row
            row.after($discussion);
          } else {
            // Merge new discussion HTML in
            var $notes = $discussion.find('.notes[data-discussion-id="' + noteEntity.discussion_id + '"]');
            var contentContainerClass = '.' + $notes.closest('.notes_content').attr('class').split(' ').join('.');

            row.find(contentContainerClass + ' .content').append($notes.closest('.content').children());
          }
        }
        // Init discussion on 'Discussion' page if it is merge request page
        var page = jquery_default()('body').attr('data-page');
        if (page && page.indexOf('projects:merge_request') !== -1 || !noteEntity.diff_discussion_html) {
          if (!Object(common_utils["n" /* hasVueMRDiscussionsCookie */])()) {
            Notes.animateAppendNote(noteEntity.discussion_html, jquery_default()('.main-notes-list'));
          }
        }
      } else {
        // append new note to all matching discussions
        Notes.animateAppendNote(noteEntity.html, discussionContainer);
      }

      if (typeof gl.diffNotesCompileComponents !== 'undefined' && noteEntity.discussion_resolvable) {
        gl.diffNotesCompileComponents();

        this.renderDiscussionAvatar(diffAvatarContainer, noteEntity);
      }

      Object(datetime_utility["e" /* localTimeAgo */])(jquery_default()('.js-timeago'), false);
      Notes.checkMergeRequestStatus();
      return this.updateNotesCount(1);
    }
  }, {
    key: 'getLineHolder',
    value: function getLineHolder(changesDiscussionContainer) {
      return jquery_default()(changesDiscussionContainer).closest('.notes_holder').prevAll('.line_holder').first().get(0);
    }
  }, {
    key: 'renderDiscussionAvatar',
    value: function renderDiscussionAvatar(diffAvatarContainer, noteEntity) {
      var avatarHolder = diffAvatarContainer.find('.diff-comment-avatar-holders');

      if (!avatarHolder.length) {
        avatarHolder = document.createElement('diff-note-avatars');
        avatarHolder.setAttribute('discussion-id', noteEntity.discussion_id);

        diffAvatarContainer.append(avatarHolder);

        gl.diffNotesCompileComponents();
      }
    }

    /**
     * Called in response the main target form has been successfully submitted.
     *
     * Removes any errors.
     * Resets text and preview.
     * Resets buttons.
     */

  }, {
    key: 'resetMainTargetForm',
    value: function resetMainTargetForm(e) {
      var form;
      form = jquery_default()('.js-main-target-form');
      // remove validation errors
      form.find('.js-errors').remove();
      // reset text and preview
      form.find('.js-md-write-button').click();
      form.find('.js-note-text').val('').trigger('input');
      form.find('.js-note-text').data('autosave').reset();

      var event = document.createEvent('Event');
      event.initEvent('autosize:update', true, false);
      form.find('.js-autosize')[0].dispatchEvent(event);

      this.updateTargetButtons(e);
    }
  }, {
    key: 'reenableTargetFormSubmitButton',
    value: function reenableTargetFormSubmitButton() {
      var form;
      form = jquery_default()('.js-main-target-form');
      return form.find('.js-note-text').trigger('input');
    }

    /**
     * Shows the main form and does some setup on it.
     *
     * Sets some hidden fields in the form.
     */

  }, {
    key: 'setupMainTargetNoteForm',
    value: function setupMainTargetNoteForm() {
      var form;
      // find the form
      form = jquery_default()('.js-new-note-form');
      // Set a global clone of the form for later cloning
      this.formClone = form.clone();
      // show the form
      this.setupNoteForm(form);
      // fix classes
      form.removeClass('js-new-note-form');
      form.addClass('js-main-target-form');
      form.find('#note_line_code').remove();
      form.find('#note_position').remove();
      form.find('#note_type').val('');
      form.find('#note_project_id').remove();
      form.find('#in_reply_to_discussion_id').remove();
      form.find('.js-comment-resolve-button').closest('comment-and-resolve-btn').remove();
      this.parentTimeline = form.parents('.timeline');

      if (form.length) {
        Notes.initCommentTypeToggle(form.get(0));
      }
    }

    /**
     * General note form setup.
     *
     * deactivates the submit button when text is empty
     * hides the preview button when text is empty
     * setup GFM auto complete
     * show the form
     */

  }, {
    key: 'setupNoteForm',
    value: function setupNoteForm(form) {
      var textarea, key;
      this.glForm = new gl_form["a" /* default */](form, this.enableGFM);
      textarea = form.find('.js-note-text');
      key = ['Note', form.find('#note_noteable_type').val(), form.find('#note_noteable_id').val(), form.find('#note_commit_id').val(), form.find('#note_type').val(), form.find('#note_project_id').val(), form.find('#in_reply_to_discussion_id').val(),

      // LegacyDiffNote
      form.find('#note_line_code').val(),

      // DiffNote
      form.find('#note_position').val()];
      return new autosave["a" /* default */](textarea, key);
    }

    /**
     * Called in response to the new note form being submitted
     *
     * Adds new note to list.
     */

  }, {
    key: 'addNote',
    value: function addNote($form, note) {
      return this.renderNote(note);
    }
  }, {
    key: 'addNoteError',
    value: function addNoteError($form) {
      var formParentTimeline = void 0;
      if ($form.hasClass('js-main-target-form')) {
        formParentTimeline = $form.parents('.timeline');
      } else if ($form.hasClass('js-discussion-note-form')) {
        formParentTimeline = $form.closest('.discussion-notes').find('.notes');
      }
      return this.addFlash('Your comment could not be submitted! Please check your network connection and try again.', 'alert', formParentTimeline.get(0));
    }
  }, {
    key: 'updateNoteError',
    value: function updateNoteError($parentTimeline) {
      new flash["a" /* default */]('Your comment could not be updated! Please check your network connection and try again.');
    }

    /**
     * Called in response to the new note form being submitted
     *
     * Adds new note to list.
     */

  }, {
    key: 'addDiscussionNote',
    value: function addDiscussionNote($form, note, isNewDiffComment) {
      if ($form.attr('data-resolve-all') != null) {
        var projectPath = $form.data('projectPath');
        var discussionId = $form.data('discussionId');
        var mergeRequestId = $form.data('noteableIid');

        if (ResolveService != null) {
          ResolveService.toggleResolveForDiscussion(mergeRequestId, discussionId);
        }
      }

      this.renderNote(note, $form);
      // cleanup after successfully creating a diff/discussion note
      if (isNewDiffComment) {
        this.removeDiscussionNoteForm($form);
      }
    }

    /**
     * Called in response to the edit note form being submitted
     *
     * Updates the current note field.
     */

  }, {
    key: 'updateNote',
    value: function updateNote(noteEntity, $targetNote) {
      var $noteEntityEl, $note_li;
      // Convert returned HTML to a jQuery object so we can modify it further
      $noteEntityEl = jquery_default()(noteEntity.html);
      this.revertNoteEditForm($targetNote);
      $noteEntityEl.renderGFM();
      // Find the note's `li` element by ID and replace it with the updated HTML
      $note_li = jquery_default()('.note-row-' + noteEntity.id);

      $note_li.replaceWith($noteEntityEl);
      this.setupNewNote($noteEntityEl);

      if (typeof gl.diffNotesCompileComponents !== 'undefined') {
        gl.diffNotesCompileComponents();
      }
    }
  }, {
    key: 'checkContentToAllowEditing',
    value: function checkContentToAllowEditing($el) {
      var initialContent = $el.find('.original-note-content').text().trim();
      var currentContent = $el.find('.js-note-text').val();
      var isAllowed = true;

      if (currentContent === initialContent) {
        this.removeNoteEditForm($el);
      } else {
        var $buttons = $el.find('.note-form-actions');
        var isWidgetVisible = Object(common_utils["t" /* isInViewport */])($el.get(0));

        if (!isWidgetVisible) {
          Object(common_utils["D" /* scrollToElement */])($el);
        }

        $el.find('.js-finish-edit-warning').show();
        isAllowed = false;
      }

      return isAllowed;
    }

    /**
     * Called in response to clicking the edit note link
     *
     * Replaces the note text with the note edit form
     * Adds a data attribute to the form with the original content of the note for cancellations
     */

  }, {
    key: 'showEditForm',
    value: function showEditForm(e, scrollTo, myLastNote) {
      e.preventDefault();

      var $target = jquery_default()(e.target);
      var $editForm = jquery_default()(this.getEditFormSelector($target));
      var $note = $target.closest('.note');
      var $currentlyEditing = jquery_default()('.note.is-editing:visible');

      if ($currentlyEditing.length) {
        var isEditAllowed = this.checkContentToAllowEditing($currentlyEditing);

        if (!isEditAllowed) {
          return;
        }
      }

      $note.find('.js-note-attachment-delete').show();
      $editForm.addClass('current-note-edit-form');
      $note.addClass('is-editing');
      this.putEditFormInPlace($target);
    }

    /**
     * Called in response to clicking the edit note link
     *
     * Hides edit form and restores the original note text to the editor textarea.
     */

  }, {
    key: 'cancelEdit',
    value: function cancelEdit(e) {
      e.preventDefault();
      var $target = jquery_default()(e.target);
      var $note = $target.closest('.note');
      var noteId = $note.attr('data-note-id');

      this.revertNoteEditForm($target);

      if (this.updatedNotesTrackingMap[noteId]) {
        var $newNote = jquery_default()(this.updatedNotesTrackingMap[noteId].html);
        $note.replaceWith($newNote);
        this.setupNewNote($newNote);
        // Now that we have taken care of the update, clear it out
        delete this.updatedNotesTrackingMap[noteId];
      } else {
        $note.find('.js-finish-edit-warning').hide();
        this.removeNoteEditForm($note);
      }
    }
  }, {
    key: 'revertNoteEditForm',
    value: function revertNoteEditForm($target) {
      $target = $target || jquery_default()('.note.is-editing:visible');
      var selector = this.getEditFormSelector($target);
      var $editForm = jquery_default()(selector);

      $editForm.insertBefore('.diffs');
      $editForm.find('.js-comment-save-button').enable();
      $editForm.find('.js-finish-edit-warning').hide();
    }
  }, {
    key: 'getEditFormSelector',
    value: function getEditFormSelector($el) {
      var selector = '.note-edit-form:not(.mr-note-edit-form)';

      if ($el.parents('#diffs').length) {
        selector = '.note-edit-form.mr-note-edit-form';
      }

      return selector;
    }
  }, {
    key: 'removeNoteEditForm',
    value: function removeNoteEditForm($note) {
      var form = $note.find('.diffs .current-note-edit-form');

      $note.removeClass('is-editing');
      form.removeClass('current-note-edit-form');
      form.find('.js-finish-edit-warning').hide();
      // Replace markdown textarea text with original note text.
      return form.find('.js-note-text').val(form.find('form.edit-note').data('originalNote'));
    }

    /**
     * Called in response to deleting a note of any kind.
     *
     * Removes the actual note from view.
     * Removes the whole discussion if the last note is being removed.
     */

  }, {
    key: 'removeNote',
    value: function removeNote(e) {
      var noteElId, noteId, dataNoteId, $note, lineHolder;
      $note = jquery_default()(e.currentTarget).closest('.note');
      noteElId = $note.attr('id');
      noteId = $note.attr('data-note-id');
      lineHolder = jquery_default()(e.currentTarget).closest('.notes[data-discussion-id]').closest('.notes_holder').prev('.line_holder');
      jquery_default()('.note[id="' + noteElId + '"]').each(function (_this) {
        // A same note appears in the "Discussion" and in the "Changes" tab, we have
        // to remove all. Using $('.note[id='noteId']') ensure we get all the notes,
        // where $('#noteId') would return only one.
        return function (i, el) {
          var $note, $notes;
          $note = jquery_default()(el);
          $notes = $note.closest('.discussion-notes');
          var discussionId = jquery_default()('.notes', $notes).data('discussionId');

          if (typeof gl.diffNotesCompileComponents !== 'undefined') {
            if (gl.diffNoteApps[noteElId]) {
              gl.diffNoteApps[noteElId].$destroy();
            }
          }

          $note.remove();

          // check if this is the last note for this line
          if ($notes.find('.note').length === 0) {
            var notesTr = $notes.closest('tr');

            // "Discussions" tab
            $notes.closest('.timeline-entry').remove();

            jquery_default()('.js-diff-avatars-' + discussionId).trigger('remove.vue');

            // The notes tr can contain multiple lists of notes, like on the parallel diff
            // notesTr does not exist for image diffs
            if (notesTr.find('.discussion-notes').length > 1 || notesTr.length === 0) {
              var $diffFile = $notes.closest('.diff-file');
              if ($diffFile.length > 0) {
                var removeBadgeEvent = new CustomEvent('removeBadge.imageDiff', {
                  detail: {
                    // badgeNumber's start with 1 and index starts with 0
                    badgeNumber: $notes.index() + 1
                  }
                });

                $diffFile[0].dispatchEvent(removeBadgeEvent);
              }

              $notes.remove();
            } else if (notesTr.length > 0) {
              notesTr.remove();
            }
          }
        };
      }(this));

      Notes.refreshVueNotes();
      Notes.checkMergeRequestStatus();
      return this.updateNotesCount(-1);
    }

    /**
     * Called in response to clicking the delete attachment link
     *
     * Removes the attachment wrapper view, including image tag if it exists
     * Resets the note editing form
     */

  }, {
    key: 'removeAttachment',
    value: function removeAttachment() {
      var $note = jquery_default()(this).closest('.note');
      $note.find('.note-attachment').remove();
      $note.find('.note-body > .note-text').show();
      $note.find('.note-header').show();
      return $note.find('.current-note-edit-form').remove();
    }

    /**
     * Called when clicking on the "reply" button for a diff line.
     *
     * Shows the note form below the notes.
     */

  }, {
    key: 'onReplyToDiscussionNote',
    value: function onReplyToDiscussionNote(e) {
      this.replyToDiscussionNote(e.target);
    }
  }, {
    key: 'replyToDiscussionNote',
    value: function replyToDiscussionNote(target) {
      var form, replyLink;
      form = this.cleanForm(this.formClone.clone());
      replyLink = jquery_default()(target).closest('.js-discussion-reply-button');
      // insert the form after the button
      replyLink.closest('.discussion-reply-holder').hide().after(form);
      // show the form
      return this.setupDiscussionNoteForm(replyLink, form);
    }

    /**
     * Shows the diff or discussion form and does some setup on it.
     *
     * Sets some hidden fields in the form.
     *
     * Note: dataHolder must have the "discussionId" and "lineCode" data attributes set.
     */

  }, {
    key: 'setupDiscussionNoteForm',
    value: function setupDiscussionNoteForm(dataHolder, form) {
      // setup note target
      var diffFileData = dataHolder.closest('.text-file');

      if (diffFileData.length === 0) {
        diffFileData = dataHolder.closest('.image');
      }

      var discussionID = dataHolder.data('discussionId');

      if (discussionID) {
        form.attr('data-discussion-id', discussionID);
        form.find('#in_reply_to_discussion_id').val(discussionID);
      }

      form.find('#note_project_id').val(dataHolder.data('discussionProjectId'));

      form.attr('data-line-code', dataHolder.data('lineCode'));
      form.find('#line_type').val(dataHolder.data('lineType'));

      form.find('#note_noteable_type').val(diffFileData.data('noteableType'));
      form.find('#note_noteable_id').val(diffFileData.data('noteableId'));
      form.find('#note_commit_id').val(diffFileData.data('commitId'));

      form.find('#note_type').val(dataHolder.data('noteType'));

      // LegacyDiffNote
      form.find('#note_line_code').val(dataHolder.data('lineCode'));

      // DiffNote
      form.find('#note_position').val(dataHolder.attr('data-position'));

      form.find('.js-note-discard').show().removeClass('js-note-discard').addClass('js-close-discussion-note-form').text(form.find('.js-close-discussion-note-form').data('cancelText'));
      form.find('.js-note-target-close').remove();
      form.find('.js-note-new-discussion').remove();
      this.setupNoteForm(form);

      form.removeClass('js-main-target-form').addClass('discussion-form js-discussion-note-form');

      if (typeof gl.diffNotesCompileComponents !== 'undefined') {
        var $commentBtn = form.find('comment-and-resolve-btn');
        $commentBtn.attr(':discussion-id', '\'' + discussionID + '\'');

        gl.diffNotesCompileComponents();
      }

      form.find('.js-note-text').focus();
      form.find('.js-comment-resolve-button').attr('data-discussion-id', discussionID);
    }

    /**
     * Called when clicking on the "add a comment" button on the side of a diff line.
     *
     * Inserts a temporary row for the form below the line.
     * Sets up the form and shows it.
     */

  }, {
    key: 'onAddDiffNote',
    value: function onAddDiffNote(e) {
      e.preventDefault();
      var link = e.currentTarget || e.target;
      var $link = jquery_default()(link);
      var showReplyInput = !$link.hasClass('js-diff-comment-avatar');
      this.toggleDiffNote({
        target: $link,
        lineType: link.dataset.lineType,
        showReplyInput: showReplyInput
      });
    }
  }, {
    key: 'onAddImageDiffNote',
    value: function onAddImageDiffNote(e) {
      var $link = jquery_default()(e.currentTarget || e.target);
      var $diffFile = $link.closest('.diff-file');

      var clickEvent = new CustomEvent('click.imageDiff', {
        detail: e
      });

      $diffFile[0].dispatchEvent(clickEvent);

      // Setup comment form
      var newForm = void 0;
      var $noteContainer = $link.closest('.diff-viewer').find('.note-container');
      var $form = $noteContainer.find('> .discussion-form');

      if ($form.length === 0) {
        newForm = this.cleanForm(this.formClone.clone());
        newForm.appendTo($noteContainer);
      } else {
        newForm = $form;
      }

      this.setupDiscussionNoteForm($link, newForm);
    }
  }, {
    key: 'toggleDiffNote',
    value: function toggleDiffNote(_ref2) {
      var target = _ref2.target,
          lineType = _ref2.lineType,
          forceShow = _ref2.forceShow,
          _ref2$showReplyInput = _ref2.showReplyInput,
          showReplyInput = _ref2$showReplyInput === undefined ? false : _ref2$showReplyInput;

      var $link, addForm, hasNotes, newForm, noteForm, replyButton, row, rowCssToAdd, targetContent, isDiffCommentAvatar;
      $link = jquery_default()(target);
      row = $link.closest('tr');
      var nextRow = row.next();
      var targetRow = row;
      if (nextRow.is('.notes_holder')) {
        targetRow = nextRow;
      }

      hasNotes = nextRow.is('.notes_holder');
      addForm = false;
      var lineTypeSelector = '';
      rowCssToAdd = '<tr class="notes_holder js-temp-notes-holder"><td class="notes_line" colspan="2"></td><td class="notes_content"><div class="content"></div></td></tr>';
      // In parallel view, look inside the correct left/right pane
      if (this.isParallelView()) {
        lineTypeSelector = '.' + lineType;
        rowCssToAdd = '<tr class="notes_holder js-temp-notes-holder"><td class="notes_line old"></td><td class="notes_content parallel old"><div class="content"></div></td><td class="notes_line new"></td><td class="notes_content parallel new"><div class="content"></div></td></tr>';
      }
      var notesContentSelector = '.notes_content' + lineTypeSelector + ' .content';
      var notesContent = targetRow.find(notesContentSelector);

      if (hasNotes && showReplyInput) {
        targetRow.show();
        notesContent = targetRow.find(notesContentSelector);
        if (notesContent.length) {
          notesContent.show();
          replyButton = notesContent.find('.js-discussion-reply-button:visible');
          if (replyButton.length) {
            this.replyToDiscussionNote(replyButton[0]);
          } else {
            // In parallel view, the form may not be present in one of the panes
            noteForm = notesContent.find('.js-discussion-note-form');
            if (noteForm.length === 0) {
              addForm = true;
            }
          }
        }
      } else if (showReplyInput) {
        // add a notes row and insert the form
        row.after(rowCssToAdd);
        targetRow = row.next();
        notesContent = targetRow.find(notesContentSelector);
        addForm = true;
      } else {
        var isCurrentlyShown = targetRow.find('.content:not(:empty)').is(':visible');
        var isForced = forceShow === true || forceShow === false;
        var showNow = forceShow === true || !isCurrentlyShown && !isForced;

        targetRow.toggle(showNow);
        notesContent.toggle(showNow);
      }

      if (addForm) {
        newForm = this.cleanForm(this.formClone.clone());
        newForm.appendTo(notesContent);
        // show the form
        return this.setupDiscussionNoteForm($link, newForm);
      }
    }

    /**
     * Called in response to "cancel" on a diff note form.
     *
     * Shows the reply button again.
     * Removes the form and if necessary it's temporary row.
     */

  }, {
    key: 'removeDiscussionNoteForm',
    value: function removeDiscussionNoteForm(form) {
      var glForm, row;
      row = form.closest('tr');
      glForm = form.data('glForm');
      glForm.destroy();
      form.find('.js-note-text').data('autosave').reset();
      // show the reply button (will only work for replies)
      form.prev('.discussion-reply-holder').show();
      if (row.is('.js-temp-notes-holder')) {
        // remove temporary row for diff lines
        return row.remove();
      } else {
        // only remove the form
        return form.remove();
      }
    }
  }, {
    key: 'cancelDiscussionForm',
    value: function cancelDiscussionForm(e) {
      e.preventDefault();
      var $form = jquery_default()(e.target).closest('.js-discussion-note-form');
      var $discussionNote = jquery_default()(e.target).closest('.discussion-notes');

      if ($discussionNote.length === 0) {
        // Only send blur event when the discussion form
        // is not part of a discussion note
        var $diffFile = $form.closest('.diff-file');

        if ($diffFile.length > 0) {
          var blurEvent = new CustomEvent('blur.imageDiff', {
            detail: e
          });

          $diffFile[0].dispatchEvent(blurEvent);
        }
      }

      return this.removeDiscussionNoteForm($form);
    }

    /**
     * Called after an attachment file has been selected.
     *
     * Updates the file name for the selected attachment.
     */

  }, {
    key: 'updateFormAttachment',
    value: function updateFormAttachment() {
      var filename, form;
      form = jquery_default()(this).closest('form');
      // get only the basename
      filename = jquery_default()(this).val().replace(/^.*[\\\/]/, '');
      return form.find('.js-attachment-filename').text(filename);
    }

    /**
     * Called when the tab visibility changes
     */

  }, {
    key: 'visibilityChange',
    value: function visibilityChange() {
      return this.refresh();
    }
  }, {
    key: 'updateTargetButtons',
    value: function updateTargetButtons(e) {
      var closebtn, closetext, discardbtn, form, reopenbtn, reopentext, textarea;
      textarea = jquery_default()(e.target);
      form = textarea.parents('form');
      reopenbtn = form.find('.js-note-target-reopen');
      closebtn = form.find('.js-note-target-close');
      discardbtn = form.find('.js-note-discard');

      if (textarea.val().trim().length > 0) {
        reopentext = reopenbtn.attr('data-alternative-text');
        closetext = closebtn.attr('data-alternative-text');
        if (reopenbtn.text() !== reopentext) {
          reopenbtn.text(reopentext);
        }
        if (closebtn.text() !== closetext) {
          closebtn.text(closetext);
        }
        if (reopenbtn.is(':not(.btn-comment-and-reopen)')) {
          reopenbtn.addClass('btn-comment-and-reopen');
        }
        if (closebtn.is(':not(.btn-comment-and-close)')) {
          closebtn.addClass('btn-comment-and-close');
        }
        if (discardbtn.is(':hidden')) {
          return discardbtn.show();
        }
      } else {
        reopentext = reopenbtn.data('originalText');
        closetext = closebtn.data('originalText');
        if (reopenbtn.text() !== reopentext) {
          reopenbtn.text(reopentext);
        }
        if (closebtn.text() !== closetext) {
          closebtn.text(closetext);
        }
        if (reopenbtn.is('.btn-comment-and-reopen')) {
          reopenbtn.removeClass('btn-comment-and-reopen');
        }
        if (closebtn.is('.btn-comment-and-close')) {
          closebtn.removeClass('btn-comment-and-close');
        }
        if (discardbtn.is(':visible')) {
          return discardbtn.hide();
        }
      }
    }
  }, {
    key: 'putEditFormInPlace',
    value: function putEditFormInPlace($el) {
      var $editForm = jquery_default()(this.getEditFormSelector($el));
      var $note = $el.closest('.note');

      $editForm.insertAfter($note.find('.note-text'));

      var $originalContentEl = $note.find('.original-note-content');
      var originalContent = $originalContentEl.text().trim();
      var postUrl = $originalContentEl.data('postUrl');
      var targetId = $originalContentEl.data('targetId');
      var targetType = $originalContentEl.data('targetType');

      this.glForm = new gl_form["a" /* default */]($editForm.find('form'), this.enableGFM);

      $editForm.find('form').attr('action', postUrl + '?html=true').attr('data-remote', 'true');
      $editForm.find('.js-form-target-id').val(targetId);
      $editForm.find('.js-form-target-type').val(targetType);
      $editForm.find('.js-note-text').focus().val(originalContent);
      $editForm.find('.js-md-write-button').trigger('click');
      $editForm.find('.referenced-users').hide();
    }
  }, {
    key: 'putConflictEditWarningInPlace',
    value: function putConflictEditWarningInPlace(noteEntity, $note) {
      if ($note.find('.js-conflict-edit-warning').length === 0) {
        var $alert = jquery_default()('<div class="js-conflict-edit-warning alert alert-danger">\n        This comment has changed since you started editing, please review the\n        <a href="#note_' + noteEntity.id + '" target="_blank" rel="noopener noreferrer">\n          updated comment\n        </a>\n        to ensure information is not lost\n      </div>');
        $alert.insertAfter($note.find('.note-text'));
      }
    }
  }, {
    key: 'updateNotesCount',
    value: function updateNotesCount(updateCount) {
      return this.notesCountBadge.text(parseInt(this.notesCountBadge.text(), 10) + updateCount);
    }
  }, {
    key: 'toggleCommitList',
    value: function toggleCommitList(e) {
      var $element = jquery_default()(e.currentTarget);
      var $closestSystemCommitList = $element.siblings('.system-note-commit-list');

      $element.find('.fa').toggleClass('fa-angle-down').toggleClass('fa-angle-up');
      $closestSystemCommitList.toggleClass('hide-shade');
    }

    /**
     * Scans system notes with `ul` elements in system note body
     * then collapse long commit list pushed by user to make it less
     * intrusive.
     */

  }, {
    key: 'collapseLongCommitList',
    value: function collapseLongCommitList() {
      var systemNotes = jquery_default()('#notes-list').find('li.system-note').has('ul');

      jquery_default.a.each(systemNotes, function (index, systemNote) {
        var $systemNote = jquery_default()(systemNote);
        var headerMessage = $systemNote.find('.note-text').find('p:first').text().replace(':', '');

        $systemNote.find('.note-header .system-note-message').html(headerMessage);

        if ($systemNote.find('li').length > MAX_VISIBLE_COMMIT_LIST_COUNT) {
          $systemNote.find('.note-text').addClass('system-note-commit-list');
          $systemNote.find('.system-note-commit-list-toggler').show();
        } else {
          $systemNote.find('.note-text').addClass('system-note-commit-list hide-shade');
        }
      });
    }
  }, {
    key: 'addFlash',
    value: function addFlash() {
      for (var _len = arguments.length, flashParams = Array(_len), _key = 0; _key < _len; _key++) {
        flashParams[_key] = arguments[_key];
      }

      this.flashContainer = new (Function.prototype.bind.apply(flash["a" /* default */], [null].concat(flashParams)))();
    }
  }, {
    key: 'clearFlash',
    value: function clearFlash() {
      if (this.flashContainer) {
        this.flashContainer.style.display = 'none';
        this.flashContainer = null;
      }
    }
  }, {
    key: 'cleanForm',
    value: function cleanForm($form) {
      // Remove JS classes that are not needed here
      $form.find('.js-comment-type-dropdown').removeClass('btn-group');

      // Remove dropdown
      $form.find('.dropdown-menu').remove();

      return $form;
    }

    /**
     * Check if note does not exists on page
     */

  }, {
    key: 'getFormData',


    /**
     * Get data from Form attributes to use for saving/submitting comment.
     */
    value: function getFormData($form) {
      var content = $form.find('.js-note-text').val();
      return {
        formData: $form.serialize(),
        formContent: underscore_default.a.escape(content),
        formAction: $form.attr('action'),
        formContentOriginal: content
      };
    }

    /**
     * Identify if comment has any quick actions
     */

  }, {
    key: 'hasQuickActions',
    value: function hasQuickActions(formContent) {
      return REGEX_QUICK_ACTIONS.test(formContent);
    }

    /**
     * Remove quick actions and leave comment with pure message
     */

  }, {
    key: 'stripQuickActions',
    value: function stripQuickActions(formContent) {
      return formContent.replace(REGEX_QUICK_ACTIONS, '').trim();
    }

    /**
     * Gets appropriate description from quick actions found in provided `formContent`
     */

  }, {
    key: 'getQuickActionDescription',
    value: function getQuickActionDescription(formContent) {
      var availableQuickActions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var tempFormContent = void 0;

      // Identify executed quick actions from `formContent`
      var executedCommands = availableQuickActions.filter(function (command, index) {
        var commandRegex = new RegExp('/' + command.name);
        return commandRegex.test(formContent);
      });

      if (executedCommands && executedCommands.length) {
        if (executedCommands.length > 1) {
          tempFormContent = 'Applying multiple commands';
        } else {
          var commandDescription = executedCommands[0].description.toLowerCase();
          tempFormContent = 'Applying command to ' + commandDescription;
        }
      } else {
        tempFormContent = 'Applying command';
      }

      return tempFormContent;
    }

    /**
     * Create placeholder note DOM element populated with comment body
     * that we will show while comment is being posted.
     * Once comment is _actually_ posted on server, we will have final element
     * in response that we will show in place of this temporary element.
     */

  }, {
    key: 'createPlaceholderNote',
    value: function createPlaceholderNote(_ref3) {
      var formContent = _ref3.formContent,
          uniqueId = _ref3.uniqueId,
          isDiscussionNote = _ref3.isDiscussionNote,
          currentUsername = _ref3.currentUsername,
          currentUserFullname = _ref3.currentUserFullname,
          currentUserAvatar = _ref3.currentUserAvatar;

      var discussionClass = isDiscussionNote ? 'discussion' : '';
      var $tempNote = jquery_default()('<li id="' + uniqueId + '" class="note being-posted fade-in-half timeline-entry">\n         <div class="timeline-entry-inner">\n            <div class="timeline-icon">\n               <a href="/' + underscore_default.a.escape(currentUsername) + '">\n                 <img class="avatar s40" src="' + currentUserAvatar + '" />\n               </a>\n            </div>\n            <div class="timeline-content ' + discussionClass + '">\n               <div class="note-header">\n                  <div class="note-header-info">\n                     <a href="/' + underscore_default.a.escape(currentUsername) + '">\n                       <span class="hidden-xs">' + underscore_default.a.escape(currentUsername) + '</span>\n                       <span class="note-headline-light">' + underscore_default.a.escape(currentUsername) + '</span>\n                     </a>\n                  </div>\n               </div>\n               <div class="note-body">\n                 <div class="note-text">\n                   <p>' + formContent + '</p>\n                 </div>\n               </div>\n            </div>\n         </div>\n      </li>');

      $tempNote.find('.hidden-xs').text(underscore_default.a.escape(currentUserFullname));
      $tempNote.find('.note-headline-light').text('@' + underscore_default.a.escape(currentUsername));

      return $tempNote;
    }

    /**
     * Create Placeholder System Note DOM element populated with quick action description
     */

  }, {
    key: 'createPlaceholderSystemNote',
    value: function createPlaceholderSystemNote(_ref4) {
      var formContent = _ref4.formContent,
          uniqueId = _ref4.uniqueId;

      var $tempNote = jquery_default()('<li id="' + uniqueId + '" class="note system-note timeline-entry being-posted fade-in-half">\n         <div class="timeline-entry-inner">\n           <div class="timeline-content">\n             <i>' + formContent + '</i>\n           </div>\n         </div>\n       </li>');

      return $tempNote;
    }

    /**
     * This method does following tasks step-by-step whenever a new comment
     * is submitted by user (both main thread comments as well as discussion comments).
     *
     * 1) Get Form metadata
     * 2) Identify comment type; a) Main thread b) Discussion thread c) Discussion resolve
     * 3) Build temporary placeholder element (using `createPlaceholderNote`)
     * 4) Show placeholder note on UI
     * 5) Perform network request to submit the note using `axios.post`
     *    a) If request is successfully completed
     *        1. Remove placeholder element
     *        2. Show submitted Note element
     *        3. Perform post-submit errands
     *           a. Mark discussion as resolved if comment submission was for resolve.
     *           b. Reset comment form to original state.
     *    b) If request failed
     *        1. Remove placeholder element
     *        2. Show error Flash message about failure
     */

  }, {
    key: 'postComment',
    value: function postComment(e) {
      var _this3 = this;

      e.preventDefault();

      // Get Form metadata
      var $submitBtn = jquery_default()(e.target);
      var $form = $submitBtn.parents('form');
      var $closeBtn = $form.find('.js-note-target-close');
      var isDiscussionNote = $submitBtn.parent().find('li.droplab-item-selected').attr('id') === 'discussion';
      var isMainForm = $form.hasClass('js-main-target-form');
      var isDiscussionForm = $form.hasClass('js-discussion-note-form');
      var isDiscussionResolve = $submitBtn.hasClass('js-comment-resolve-button');

      var _getFormData = this.getFormData($form),
          formData = _getFormData.formData,
          formContent = _getFormData.formContent,
          formAction = _getFormData.formAction,
          formContentOriginal = _getFormData.formContentOriginal;

      var noteUniqueId = void 0;
      var systemNoteUniqueId = void 0;
      var hasQuickActions = false;
      var $notesContainer = void 0;
      var tempFormContent = void 0;

      // Get reference to notes container based on type of comment
      if (isDiscussionForm) {
        $notesContainer = $form.parent('.discussion-notes').find('.notes');
      } else if (isMainForm) {
        $notesContainer = jquery_default()('ul.main-notes-list');
      }

      // If comment is to resolve discussion, disable submit buttons while
      // comment posting is finished.
      if (isDiscussionResolve) {
        $submitBtn.disable();
        $form.find('.js-comment-submit-button').disable();
      }

      tempFormContent = formContent;
      if (this.hasQuickActions(formContent)) {
        tempFormContent = this.stripQuickActions(formContent);
        hasQuickActions = true;
      }

      // Show placeholder note
      if (tempFormContent) {
        noteUniqueId = underscore_default.a.uniqueId('tempNote_');
        $notesContainer.append(this.createPlaceholderNote({
          formContent: tempFormContent,
          uniqueId: noteUniqueId,
          isDiscussionNote: isDiscussionNote,
          currentUsername: gon.current_username,
          currentUserFullname: gon.current_user_fullname,
          currentUserAvatar: gon.current_user_avatar_url
        }));
      }

      // Show placeholder system note
      if (hasQuickActions) {
        systemNoteUniqueId = underscore_default.a.uniqueId('tempSystemNote_');
        $notesContainer.append(this.createPlaceholderSystemNote({
          formContent: this.getQuickActionDescription(formContent, ajax_cache["a" /* default */].get(gl.GfmAutoComplete.dataSources.commands)),
          uniqueId: systemNoteUniqueId
        }));
      }

      // Clear the form textarea
      if ($notesContainer.length) {
        if (isMainForm) {
          this.resetMainTargetForm(e);
        } else if (isDiscussionForm) {
          this.removeDiscussionNoteForm($form);
        }
      }

      /* eslint-disable promise/catch-or-return */
      // Make request to submit comment on server
      axios_utils["a" /* default */].post(formAction + '?html=true', formData).then(function (res) {
        var note = res.data;

        // Submission successful! remove placeholder
        $notesContainer.find('#' + noteUniqueId).remove();

        var $diffFile = $form.closest('.diff-file');
        if ($diffFile.length > 0) {
          var blurEvent = new CustomEvent('blur.imageDiff', {
            detail: e
          });

          $diffFile[0].dispatchEvent(blurEvent);
        }

        // Reset cached commands list when command is applied
        if (hasQuickActions) {
          $form.find('textarea.js-note-text').trigger('clear-commands-cache.atwho');
        }

        // Clear previous form errors
        _this3.clearFlashWrapper();

        // Check if this was discussion comment
        if (isDiscussionForm) {
          // Remove flash-container
          $notesContainer.find('.flash-container').remove();

          // If comment intends to resolve discussion, do the same.
          if (isDiscussionResolve) {
            $form.attr('data-discussion-id', $submitBtn.data('discussionId')).attr('data-resolve-all', 'true').attr('data-project-path', $submitBtn.data('projectPath'));
          }

          // Show final note element on UI
          var isNewDiffComment = $notesContainer.length === 0;
          _this3.addDiscussionNote($form, note, isNewDiffComment);

          if (isNewDiffComment) {
            // Add image badge, avatar badge and toggle discussion badge for new image diffs
            var notePosition = $form.find('#note_position').val();
            if ($diffFile.length > 0 && notePosition.length > 0) {
              var _JSON$parse = JSON.parse(notePosition),
                  x = _JSON$parse.x,
                  y = _JSON$parse.y,
                  width = _JSON$parse.width,
                  height = _JSON$parse.height;

              var addBadgeEvent = new CustomEvent('addBadge.imageDiff', {
                detail: {
                  x: x,
                  y: y,
                  width: width,
                  height: height,
                  noteId: 'note_' + note.id,
                  discussionId: note.discussion_id
                }
              });

              $diffFile[0].dispatchEvent(addBadgeEvent);
            }
          }

          // append flash-container to the Notes list
          if ($notesContainer.length) {
            $notesContainer.append('<div class="flash-container" style="display: none;"></div>');
          }

          Notes.refreshVueNotes();
        } else if (isMainForm) {
          // Check if this was main thread comment
          // Show final note element on UI and perform form and action buttons cleanup
          _this3.addNote($form, note);
          _this3.reenableTargetFormSubmitButton(e);
        }

        if (note.commands_changes) {
          _this3.handleQuickActions(note);
        }

        $form.trigger('ajax:success', [note]);
      }).catch(function () {
        // Submission failed, remove placeholder note and show Flash error message
        $notesContainer.find('#' + noteUniqueId).remove();

        var blurEvent = new CustomEvent('blur.imageDiff', {
          detail: e
        });

        var closestDiffFile = $form.closest('.diff-file');

        if (closestDiffFile.length) {
          closestDiffFile[0].dispatchEvent(blurEvent);
        }

        if (hasQuickActions) {
          $notesContainer.find('#' + systemNoteUniqueId).remove();
        }

        // Show form again on UI on failure
        if (isDiscussionForm && $notesContainer.length) {
          var replyButton = $notesContainer.parent().find('.js-discussion-reply-button');
          _this3.replyToDiscussionNote(replyButton[0]);
          $form = $notesContainer.parent().find('form');
        }

        $form.find('.js-note-text').val(formContentOriginal);
        _this3.reenableTargetFormSubmitButton(e);
        _this3.addNoteError($form);
      });

      return $closeBtn.text($closeBtn.data('originalText'));
    }

    /**
     * This method does following tasks step-by-step whenever an existing comment
     * is updated by user (both main thread comments as well as discussion comments).
     *
     * 1) Get Form metadata
     * 2) Update note element with new content
     * 3) Perform network request to submit the updated note using `axios.post`
     *    a) If request is successfully completed
     *        1. Show submitted Note element
     *    b) If request failed
     *        1. Revert Note element to original content
     *        2. Show error Flash message about failure
     */

  }, {
    key: 'updateComment',
    value: function updateComment(e) {
      var _this4 = this;

      e.preventDefault();

      // Get Form metadata
      var $submitBtn = jquery_default()(e.target);
      var $form = $submitBtn.parents('form');
      var $closeBtn = $form.find('.js-note-target-close');
      var $editingNote = $form.parents('.note.is-editing');
      var $noteBody = $editingNote.find('.js-task-list-container');
      var $noteBodyText = $noteBody.find('.note-text');

      var _getFormData2 = this.getFormData($form),
          formData = _getFormData2.formData,
          formContent = _getFormData2.formContent,
          formAction = _getFormData2.formAction;

      var $diffFile = $form.closest('.diff-file');
      var $notesContainer = $form.closest('.notes');

      // Cache original comment content
      var cachedNoteBodyText = $noteBodyText.html();

      // Show updated comment content temporarily
      $noteBodyText.html(formContent);
      $editingNote.removeClass('is-editing fade-in-full').addClass('being-posted fade-in-half');
      $editingNote.find('.note-headline-meta a').html('<i class="fa fa-spinner fa-spin" aria-label="评论已经更新" aria-hidden="true"></i>');

      /* eslint-disable promise/catch-or-return */
      // Make request to update comment on server
      axios_utils["a" /* default */].post(formAction + '?html=true', formData).then(function (_ref5) {
        var data = _ref5.data;

        // Submission successful! render final note element
        _this4.updateNote(data, $editingNote);
      }).catch(function () {
        // Submission failed, revert back to original note
        $noteBodyText.html(underscore_default.a.escape(cachedNoteBodyText));
        $editingNote.removeClass('being-posted fade-in');
        $editingNote.find('.fa.fa-spinner').remove();

        // Show Flash message about failure
        _this4.updateNoteError();
      });

      return $closeBtn.text($closeBtn.data('originalText'));
    }
  }], [{
    key: 'initCommentTypeToggle',
    value: function initCommentTypeToggle(form) {
      var dropdownTrigger = form.querySelector('.js-comment-type-dropdown .dropdown-toggle');
      var dropdownList = form.querySelector('.js-comment-type-dropdown .dropdown-menu');
      var noteTypeInput = form.querySelector('#note_type');
      var submitButton = form.querySelector('.js-comment-type-dropdown .js-comment-submit-button');
      var closeButton = form.querySelector('.js-note-target-close');
      var reopenButton = form.querySelector('.js-note-target-reopen');

      var commentTypeToggle = new comment_type_toggle({
        dropdownTrigger: dropdownTrigger,
        dropdownList: dropdownList,
        noteTypeInput: noteTypeInput,
        submitButton: submitButton,
        closeButton: closeButton,
        reopenButton: reopenButton
      });

      commentTypeToggle.initDroplab();
    }
  }, {
    key: 'updateNoteTargetSelector',
    value: function updateNoteTargetSelector($note) {
      var hash = Object(url_utility["a" /* getLocationHash */])();
      // Needs to be an explicit true/false for the jQuery `toggleClass(force)`
      var addTargetClass = Boolean(hash && $note.filter('#' + hash).length > 0);
      $note.toggleClass('target', addTargetClass);
    }
  }, {
    key: 'isNewNote',
    value: function isNewNote(noteEntity, noteIds) {
      return jquery_default.a.inArray(noteEntity.id, noteIds) === -1;
    }

    /**
     * Check if $note already contains the `noteEntity` content
     */

  }, {
    key: 'isUpdatedNote',
    value: function isUpdatedNote(noteEntity, $note) {
      // There can be CRLF vs LF mismatches if we don't sanitize and compare the same way
      var sanitizedNoteEntityText = normalizeNewlines(noteEntity.note.trim());
      var currentNoteText = normalizeNewlines($note.find('.original-note-content').first().text().trim());
      return sanitizedNoteEntityText !== currentNoteText;
    }
  }, {
    key: 'checkMergeRequestStatus',
    value: function checkMergeRequestStatus() {
      if (Object(common_utils["h" /* getPagePath */])(1) === 'merge_requests' && gl.mrWidget) {
        gl.mrWidget.checkStatus();
      }
    }
  }, {
    key: 'animateAppendNote',
    value: function animateAppendNote(noteHtml, $notesList) {
      var $note = jquery_default()(noteHtml);

      $note.addClass('fade-in-full').renderGFM();
      $notesList.append($note);
      return $note;
    }
  }, {
    key: 'animateUpdateNote',
    value: function animateUpdateNote(noteHtml, $note) {
      var $updatedNote = jquery_default()(noteHtml);

      $updatedNote.addClass('fade-in').renderGFM();
      $note.replaceWith($updatedNote);
      return $updatedNote;
    }
  }, {
    key: 'refreshVueNotes',
    value: function refreshVueNotes() {
      document.dispatchEvent(new CustomEvent('refreshVueNotes'));
    }
  }]);

  return Notes;
}();

/* harmony default export */ var notes_0 = __webpack_exports__["a"] = (notes_Notes);


window.Notes = notes_Notes;

/***/ }),

/***/ "./notes/components/comment_form.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("../../../node_modules/vuex/dist/vuex.esm.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__("../../../node_modules/autosize/dist/autosize.js");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./autosave.js
var autosave = __webpack_require__("./autosave.js");

// EXTERNAL MODULE: ./task_list.js
var task_list = __webpack_require__("./task_list.js");

// EXTERNAL MODULE: ./lib/utils/text_utility.js
var text_utility = __webpack_require__("./lib/utils/text_utility.js");

// EXTERNAL MODULE: ./notes/constants.js
var constants = __webpack_require__("./notes/constants.js");

// EXTERNAL MODULE: ./notes/event_hub.js
var event_hub = __webpack_require__("./notes/event_hub.js");

// EXTERNAL MODULE: ./vue_shared/components/issue/issue_warning.vue + 2 modules
var issue_warning = __webpack_require__("./vue_shared/components/issue/issue_warning.vue");

// EXTERNAL MODULE: ./vue_shared/components/markdown/field.vue + 1 modules
var field = __webpack_require__("./vue_shared/components/markdown/field.vue");

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_link.vue + 2 modules
var user_avatar_link = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_link.vue");

// EXTERNAL MODULE: ./vue_shared/components/loading_button.vue + 2 modules
var loading_button = __webpack_require__("./vue_shared/components/loading_button.vue");

// EXTERNAL MODULE: ./notes/components/note_signed_out_widget.vue + 2 modules
var note_signed_out_widget = __webpack_require__("./notes/components/note_signed_out_widget.vue");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// EXTERNAL MODULE: ./vue_shared/mixins/issuable.js
var issuable = __webpack_require__("./vue_shared/mixins/issuable.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/discussion_locked_widget.vue




/* harmony default export */ var discussion_locked_widget = ({
  components: {
    Icon: icon["a" /* default */]
  },
  mixins: [issuable["a" /* default */]]
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8790406c","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/discussion_locked_widget.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disabled-comment text-center"},[_c('span',{staticClass:"issuable-note-warning inline"},[_c('icon',{staticClass:"icon",attrs:{"name":"lock","size":16}}),_vm._v(" "),_c('span',[_vm._v("\n      This "+_vm._s(_vm.issuableDisplayName)+" is locked. Only "),_c('b',[_vm._v("project members")]),_vm._v(" can comment.\n    ")])],1)])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./notes/components/discussion_locked_widget.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  discussion_locked_widget,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_discussion_locked_widget = (Component.exports);

// EXTERNAL MODULE: ./notes/mixins/issuable_state.js
var issuable_state = __webpack_require__("./notes/mixins/issuable_state.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/comment_form.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




















/* harmony default export */ var comment_form = ({
  name: 'CommentForm',
  components: {
    issueWarning: issue_warning["a" /* default */],
    noteSignedOutWidget: note_signed_out_widget["a" /* default */],
    discussionLockedWidget: components_discussion_locked_widget,
    markdownField: field["a" /* default */],
    userAvatarLink: user_avatar_link["a" /* default */],
    loadingButton: loading_button["a" /* default */]
  },
  mixins: [issuable_state["a" /* default */]],
  props: {
    noteableType: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      note: '',
      noteType: constants["b" /* COMMENT */],
      isSubmitting: false,
      isSubmitButtonDisabled: true
    };
  },

  computed: _extends({}, Object(vuex_esm["c" /* mapGetters */])(['getCurrentUserLastNote', 'getUserData', 'getNoteableData', 'getNotesData', 'openState']), Object(vuex_esm["d" /* mapState */])(['isToggleStateButtonLoading']), {
    noteableDisplayName: function noteableDisplayName() {
      return this.noteableType.replace(/_/g, ' ');
    },
    isLoggedIn: function isLoggedIn() {
      return this.getUserData.id;
    },
    commentButtonTitle: function commentButtonTitle() {
      return this.noteType === constants["b" /* COMMENT */] ? 'Comment' : 'Start discussion';
    },
    isOpen: function isOpen() {
      return this.openState === constants["i" /* OPENED */] || this.openState === constants["j" /* REOPENED */];
    },
    canCreateNote: function canCreateNote() {
      return this.getNoteableData.current_user.can_create_note;
    },
    issueActionButtonTitle: function issueActionButtonTitle() {
      var openOrClose = this.isOpen ? 'close' : 'reopen';

      if (this.note.length) {
        return Object(locale["f" /* sprintf */])(Object(locale["a" /* __ */])('%{actionText} & %{openOrClose} %{noteable}'), {
          actionText: this.commentButtonTitle,
          openOrClose: openOrClose,
          noteable: this.noteableDisplayName
        });
      }

      return Object(locale["f" /* sprintf */])(Object(locale["a" /* __ */])('%{openOrClose} %{noteable}'), {
        openOrClose: Object(text_utility["b" /* capitalizeFirstCharacter */])(openOrClose),
        noteable: this.noteableDisplayName
      });
    },
    actionButtonClassNames: function actionButtonClassNames() {
      return {
        'btn-reopen': !this.isOpen,
        'btn-close': this.isOpen,
        'js-note-target-close': this.isOpen,
        'js-note-target-reopen': !this.isOpen
      };
    },
    markdownDocsPath: function markdownDocsPath() {
      return this.getNotesData.markdownDocsPath;
    },
    quickActionsDocsPath: function quickActionsDocsPath() {
      return this.getNotesData.quickActionsDocsPath;
    },
    markdownPreviewPath: function markdownPreviewPath() {
      return this.getNoteableData.preview_note_path;
    },
    author: function author() {
      return this.getUserData;
    },
    canUpdateIssue: function canUpdateIssue() {
      return this.getNoteableData.current_user.can_update;
    },
    endpoint: function endpoint() {
      return this.getNoteableData.create_note_path;
    }
  }),
  watch: {
    note: function note(newNote) {
      this.setIsSubmitButtonDisabled(newNote, this.isSubmitting);
    },
    isSubmitting: function isSubmitting(newValue) {
      this.setIsSubmitButtonDisabled(this.note, newValue);
    }
  },
  mounted: function mounted() {
    var _this = this;

    // jQuery is needed here because it is a custom event being dispatched with jQuery.
    jquery_default()(document).on('issuable:change', function (e, isClosed) {
      _this.toggleIssueLocalState(isClosed ? constants["a" /* CLOSED */] : constants["j" /* REOPENED */]);
    });

    this.initAutoSave();
    this.initTaskList();
  },

  methods: _extends({}, Object(vuex_esm["b" /* mapActions */])(['saveNote', 'stopPolling', 'restartPolling', 'removePlaceholderNotes', 'closeIssue', 'reopenIssue', 'toggleIssueLocalState', 'toggleStateButtonLoading']), {
    setIsSubmitButtonDisabled: function setIsSubmitButtonDisabled(note, isSubmitting) {
      if (!underscore_default.a.isEmpty(note) && !isSubmitting) {
        this.isSubmitButtonDisabled = false;
      } else {
        this.isSubmitButtonDisabled = true;
      }
    },
    handleSave: function handleSave(withIssueAction) {
      var _this2 = this;

      this.isSubmitting = true;

      if (this.note.length) {
        var noteData = {
          endpoint: this.endpoint,
          flashContainer: this.$el,
          data: {
            note: {
              noteable_type: this.noteableType,
              noteable_id: this.getNoteableData.id,
              note: this.note
            }
          }
        };

        if (this.noteType === constants["d" /* DISCUSSION */]) {
          noteData.data.note.type = constants["e" /* DISCUSSION_NOTE */];
        }

        this.note = ''; // Empty textarea while being requested. Repopulate in catch
        this.resizeTextarea();
        this.stopPolling();

        this.saveNote(noteData).then(function (res) {
          _this2.enableButton();
          _this2.restartPolling();

          if (res.errors) {
            if (res.errors.commands_only) {
              _this2.discard();
            } else {
              Object(flash["a" /* default */])('Something went wrong while adding your comment. Please try again.', 'alert', _this2.$refs.commentForm);
            }
          } else {
            _this2.discard();
          }

          if (withIssueAction) {
            _this2.toggleIssueState();
          }
        }).catch(function () {
          _this2.enableButton();
          _this2.discard(false);
          var msg = 'Your comment could not be submitted!\nPlease check your network connection and try again.';
          Object(flash["a" /* default */])(msg, 'alert', _this2.$el);
          _this2.note = noteData.data.note.note; // Restore textarea content.
          _this2.removePlaceholderNotes();
        });
      } else {
        this.toggleIssueState();
      }
    },
    enableButton: function enableButton() {
      this.isSubmitting = false;
    },
    toggleIssueState: function toggleIssueState() {
      var _this3 = this;

      if (this.isOpen) {
        this.closeIssue().then(function () {
          return _this3.enableButton();
        }).catch(function () {
          _this3.enableButton();
          _this3.toggleStateButtonLoading(false);
          Object(flash["a" /* default */])(Object(locale["f" /* sprintf */])(Object(locale["a" /* __ */])('Something went wrong while closing the %{issuable}. Please try again later'), { issuable: _this3.noteableDisplayName }));
        });
      } else {
        this.reopenIssue().then(function () {
          return _this3.enableButton();
        }).catch(function () {
          _this3.enableButton();
          _this3.toggleStateButtonLoading(false);
          Object(flash["a" /* default */])(Object(locale["f" /* sprintf */])(Object(locale["a" /* __ */])('Something went wrong while reopening the %{issuable}. Please try again later'), { issuable: _this3.noteableDisplayName }));
        });
      }
    },
    discard: function discard() {
      var shouldClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      // `blur` is needed to clear slash commands autocomplete cache if event fired.
      // `focus` is needed to remain cursor in the textarea.
      this.$refs.textarea.blur();
      this.$refs.textarea.focus();

      if (shouldClear) {
        this.note = '';
        this.resizeTextarea();
        this.$refs.markdownField.previewMarkdown = false;
      }

      this.autosave.reset();
    },
    setNoteType: function setNoteType(type) {
      this.noteType = type;
    },
    editCurrentUserLastNote: function editCurrentUserLastNote() {
      if (this.note === '') {
        var lastNote = this.getCurrentUserLastNote;

        if (lastNote) {
          event_hub["a" /* default */].$emit('enterEditMode', {
            noteId: lastNote.id
          });
        }
      }
    },
    initAutoSave: function initAutoSave() {
      if (this.isLoggedIn) {
        var noteableType = Object(text_utility["b" /* capitalizeFirstCharacter */])(Object(text_utility["c" /* convertToCamelCase */])(this.noteableType));

        this.autosave = new autosave["a" /* default */](jquery_default()(this.$refs.textarea), ['Note', noteableType, this.getNoteableData.id]);
      }
    },
    initTaskList: function initTaskList() {
      return new task_list["a" /* default */]({
        dataType: 'note',
        fieldName: 'note',
        selector: '.notes'
      });
    },
    resizeTextarea: function resizeTextarea() {
      var _this4 = this;

      this.$nextTick(function () {
        autosize_default.a.update(_this4.$refs.textarea);
      });
    }
  })
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f18fbf4","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/comment_form.vue
var comment_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoggedIn)?_c('note-signed-out-widget'):(!_vm.canCreateNote)?_c('discussion-locked-widget',{attrs:{"issuable-type":"issue"}}):_c('ul',{staticClass:"notes notes-form timeline"},[_c('li',{staticClass:"timeline-entry"},[_c('div',{staticClass:"timeline-entry-inner"},[_c('div',{staticClass:"flash-container error-alert timeline-content"}),_vm._v(" "),_c('div',{staticClass:"timeline-icon hidden-xs hidden-sm"},[(_vm.author)?_c('user-avatar-link',{attrs:{"link-href":_vm.author.path,"img-src":_vm.author.avatar_url,"img-alt":_vm.author.name,"img-size":40}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"timeline-content timeline-content-form"},[_c('form',{ref:"commentForm",staticClass:"new-note common-note-form gfm-form js-main-target-form"},[_c('div',{staticClass:"error-alert"}),_vm._v(" "),(_vm.hasWarning(_vm.getNoteableData))?_c('issue-warning',{attrs:{"is-locked":_vm.isLocked(_vm.getNoteableData),"is-confidential":_vm.isConfidential(_vm.getNoteableData)}}):_vm._e(),_vm._v(" "),_c('markdown-field',{ref:"markdownField",attrs:{"markdown-preview-path":_vm.markdownPreviewPath,"markdown-docs-path":_vm.markdownDocsPath,"quick-actions-docs-path":_vm.quickActionsDocsPath,"add-spacing-classes":false}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.note),expression:"note"}],ref:"textarea",staticClass:"note-textarea js-vue-comment-form\njs-gfm-input js-autosize markdown-area js-vue-textarea",attrs:{"slot":"textarea","id":"note-body","name":"note[note]","data-supports-quick-actions":"true","aria-label":"Description","disabled":_vm.isSubmitting,"placeholder":"Write a comment or drag your files here..."},domProps:{"value":(_vm.note)},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }_vm.editCurrentUserLastNote()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }if(!$event.metaKey){ return null; }_vm.handleSave()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }if(!$event.ctrlKey){ return null; }_vm.handleSave()}],"input":function($event){if($event.target.composing){ return; }_vm.note=$event.target.value}},slot:"textarea"})]),_vm._v(" "),_c('div',{staticClass:"note-form-actions"},[_c('div',{staticClass:"pull-left btn-group\nappend-right-10 comment-type-dropdown js-comment-type-dropdown droplab-dropdown"},[_c('button',{staticClass:"btn btn-create comment-btn js-comment-button js-comment-submit-button",attrs:{"disabled":_vm.isSubmitButtonDisabled,"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.handleSave()}}},[_vm._v("\n                    "+_vm._s(_vm.__(_vm.commentButtonTitle))+"\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn comment-btn note-type-toggle js-note-new-discussion dropdown-toggle",attrs:{"disabled":_vm.isSubmitButtonDisabled,"name":"button","type":"button","data-toggle":"dropdown","aria-label":"Open comment type dropdown"}},[_c('i',{staticClass:"fa fa-caret-down toggle-icon",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('ul',{staticClass:"note-type-dropdown dropdown-open-top dropdown-menu"},[_c('li',{class:{ 'droplab-item-selected': _vm.noteType === 'comment' }},[_c('button',{staticClass:"btn btn-transparent",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.setNoteType('comment')}}},[_c('i',{staticClass:"fa fa-check icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"description"},[_c('strong',[_vm._v("Comment")]),_vm._v(" "),_c('p',[_vm._v("\n                            Add a general comment to this "+_vm._s(_vm.noteableDisplayName)+".\n                          ")])])])]),_vm._v(" "),_c('li',{staticClass:"divider droplab-item-ignore"}),_vm._v(" "),_c('li',{class:{ 'droplab-item-selected': _vm.noteType === 'discussion' }},[_c('button',{staticClass:"btn btn-transparent",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.setNoteType('discussion')}}},[_c('i',{staticClass:"fa fa-check icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{staticClass:"description"},[_c('strong',[_vm._v("Start discussion")]),_vm._v(" "),_c('p',[_vm._v("\n                            Discuss a specific suggestion or question.\n                          ")])])])])])]),_vm._v(" "),(_vm.canUpdateIssue)?_c('loading-button',{attrs:{"loading":_vm.isToggleStateButtonLoading,"container-class":[
                    _vm.actionButtonClassNames,
                    'btn btn-comment btn-comment-and-close js-action-button'
                  ],"disabled":_vm.isToggleStateButtonLoading || _vm.isSubmitting,"label":_vm.issueActionButtonTitle},on:{"click":function($event){_vm.handleSave(true)}}}):_vm._e(),_vm._v(" "),(_vm.note.length)?_c('button',{staticClass:"btn btn-cancel js-note-discard",attrs:{"type":"button"},on:{"click":_vm.discard}},[_vm._v("\n                  Discard draft\n                ")]):_vm._e()],1)],1)])])])])],1)}
var comment_form_staticRenderFns = []

// CONCATENATED MODULE: ./notes/components/comment_form.vue
/* script */


/* template */

/* template functional */
var comment_form___vue_template_functional__ = false
/* styles */
var comment_form___vue_styles__ = null
/* scopeId */
var comment_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var comment_form___vue_module_identifier__ = null

var comment_form_Component = Object(component_normalizer["a" /* default */])(
  comment_form,
  comment_form_render,
  comment_form_staticRenderFns,
  comment_form___vue_template_functional__,
  comment_form___vue_styles__,
  comment_form___vue_scopeId__,
  comment_form___vue_module_identifier__
)

/* harmony default export */ var components_comment_form = __webpack_exports__["a"] = (comment_form_Component.exports);


/***/ }),

/***/ "./notes/components/diff_file_header.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/clipboard_button.vue + 2 modules
var clipboard_button = __webpack_require__("./vue_shared/components/clipboard_button.vue");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/diff_file_header.vue




/* harmony default export */ var diff_file_header = ({
  components: {
    ClipboardButton: clipboard_button["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    diffFile: {
      type: Object,
      required: true
    }
  },
  computed: {
    titleTag: function titleTag() {
      return this.diffFile.discussionPath ? 'a' : 'span';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02c11602","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/diff_file_header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-header-content"},[(_vm.diffFile.submodule)?_c('div',[_c('span',[_c('icon',{attrs:{"name":"archive"}}),_vm._v(" "),_c('strong',{staticClass:"file-title-name",domProps:{"innerHTML":_vm._s(_vm.diffFile.submoduleLink)}}),_vm._v(" "),_c('clipboard-button',{attrs:{"title":"Copy file path to clipboard","text":_vm.diffFile.submoduleLink,"css-class":"btn-default btn-transparent btn-clipboard"}})],1)]):[_c(_vm.titleTag,{ref:"titleWrapper",tag:"component",attrs:{"href":_vm.diffFile.discussionPath}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.diffFile.blobIcon)}}),_vm._v(" "),(_vm.diffFile.renamedFile)?_c('span',[_c('strong',{staticClass:"file-title-name has-tooltip",attrs:{"title":_vm.diffFile.oldPath,"data-container":"body"}},[_vm._v("\n          "+_vm._s(_vm.diffFile.oldPath)+"\n        ")]),_vm._v("\n        →\n        "),_c('strong',{staticClass:"file-title-name has-tooltip",attrs:{"title":_vm.diffFile.newPath,"data-container":"body"}},[_vm._v("\n          "+_vm._s(_vm.diffFile.newPath)+"\n        ")])]):_c('strong',{staticClass:"file-title-name has-tooltip",attrs:{"title":_vm.diffFile.oldPath,"data-container":"body"}},[_vm._v("\n        "+_vm._s(_vm.diffFile.filePath)+"\n        "),(_vm.diffFile.deletedFile)?_c('span',[_vm._v("\n          deleted\n        ")]):_vm._e()])]),_vm._v(" "),_c('clipboard-button',{attrs:{"title":"Copy file path to clipboard","text":_vm.diffFile.filePath,"css-class":"btn-default btn-transparent btn-clipboard"}}),_vm._v(" "),(_vm.diffFile.modeChanged)?_c('small',{ref:"fileMode"},[_vm._v("\n      "+_vm._s(_vm.diffFile.aMode)+" → "+_vm._s(_vm.diffFile.bMode)+"\n    ")]):_vm._e()]],2)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./notes/components/diff_file_header.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  diff_file_header,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_diff_file_header = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./notes/components/note_actions.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("../../../node_modules/vuex/dist/vuex.esm.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_emoji_slightly_smiling_face.svg
var _emoji_slightly_smiling_face = __webpack_require__("../../views/shared/icons/_emoji_slightly_smiling_face.svg");
var _emoji_slightly_smiling_face_default = /*#__PURE__*/__webpack_require__.n(_emoji_slightly_smiling_face);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_emoji_smile.svg
var _emoji_smile = __webpack_require__("../../views/shared/icons/_emoji_smile.svg");
var _emoji_smile_default = /*#__PURE__*/__webpack_require__.n(_emoji_smile);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_emoji_smiley.svg
var _emoji_smiley = __webpack_require__("../../views/shared/icons/_emoji_smiley.svg");
var _emoji_smiley_default = /*#__PURE__*/__webpack_require__.n(_emoji_smiley);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_pencil.svg
var _icon_pencil = __webpack_require__("../../views/shared/icons/_icon_pencil.svg");
var _icon_pencil_default = /*#__PURE__*/__webpack_require__.n(_icon_pencil);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_resolve_discussion.svg
var _icon_resolve_discussion = __webpack_require__("../../views/shared/icons/_icon_resolve_discussion.svg");
var _icon_resolve_discussion_default = /*#__PURE__*/__webpack_require__.n(_icon_resolve_discussion);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_status_success_solid.svg
var _icon_status_success_solid = __webpack_require__("../../views/shared/icons/_icon_status_success_solid.svg");
var _icon_status_success_solid_default = /*#__PURE__*/__webpack_require__.n(_icon_status_success_solid);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_ellipsis_v.svg
var _ellipsis_v = __webpack_require__("../../views/shared/icons/_ellipsis_v.svg");
var _ellipsis_v_default = /*#__PURE__*/__webpack_require__.n(_ellipsis_v);

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/note_actions.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












/* harmony default export */ var note_actions = ({
  name: 'NoteActions',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    loadingIcon: loading_icon["a" /* default */]
  },
  props: {
    authorId: {
      type: Number,
      required: true
    },
    noteId: {
      type: Number,
      required: true
    },
    accessLevel: {
      type: String,
      required: false,
      default: ''
    },
    reportAbusePath: {
      type: String,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    canDelete: {
      type: Boolean,
      required: true
    },
    resolvable: {
      type: Boolean,
      required: false,
      default: false
    },
    isResolved: {
      type: Boolean,
      required: false,
      default: false
    },
    isResolving: {
      type: Boolean,
      required: false,
      default: false
    },
    resolvedBy: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    canReportAsAbuse: {
      type: Boolean,
      required: true
    }
  },
  computed: _extends({}, Object(vuex_esm["c" /* mapGetters */])(['getUserDataByProp']), {
    shouldShowActionsDropdown: function shouldShowActionsDropdown() {
      return this.currentUserId && (this.canEdit || this.canReportAsAbuse);
    },
    canAddAwardEmoji: function canAddAwardEmoji() {
      return this.currentUserId;
    },
    isAuthoredByCurrentUser: function isAuthoredByCurrentUser() {
      return this.authorId === this.currentUserId;
    },
    currentUserId: function currentUserId() {
      return this.getUserDataByProp('id');
    },
    resolveButtonTitle: function resolveButtonTitle() {
      var title = 'Mark as resolved';

      if (this.resolvedBy) {
        title = 'Resolved by ' + this.resolvedBy.name;
      }

      return title;
    }
  }),
  created: function created() {
    this.emojiSmiling = _emoji_slightly_smiling_face_default.a;
    this.emojiSmile = _emoji_smile_default.a;
    this.emojiSmiley = _emoji_smiley_default.a;
    this.editSvg = _icon_pencil_default.a;
    this.ellipsisSvg = _ellipsis_v_default.a;
    this.resolveDiscussionSvg = _icon_resolve_discussion_default.a;
    this.resolvedDiscussionSvg = _icon_status_success_solid_default.a;
  },

  methods: {
    onEdit: function onEdit() {
      this.$emit('handleEdit');
    },
    onDelete: function onDelete() {
      this.$emit('handleDelete');
    },
    onResolve: function onResolve() {
      this.$emit('handleResolve');
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-668ad3c0","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/note_actions.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"note-actions"},[(_vm.accessLevel)?_c('span',{staticClass:"note-role user-access-role"},[_vm._v("\n    "+_vm._s(_vm.accessLevel)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.resolvable)?_c('div',{staticClass:"note-actions-item"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"line-resolve-btn note-action-button",class:{ 'is-disabled': !_vm.resolvable, 'is-active': _vm.isResolved },attrs:{"title":_vm.resolveButtonTitle,"aria-label":_vm.resolveButtonTitle,"type":"button"},on:{"click":_vm.onResolve}},[(!_vm.isResolving)?[(_vm.isResolved)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.resolvedDiscussionSvg)}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.resolveDiscussionSvg)}})]:_c('loading-icon',{attrs:{"inline":true}})],2)]):_vm._e(),_vm._v(" "),(_vm.canAddAwardEmoji)?_c('div',{staticClass:"note-actions-item"},[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"note-action-button note-emoji-button js-add-award js-note-emoji",class:{ 'js-user-authored': _vm.isAuthoredByCurrentUser },attrs:{"data-position":"right","data-placement":"bottom","data-container":"body","href":"#","title":"Add reaction"}},[_c('loading-icon',{attrs:{"inline":true}}),_vm._v(" "),_c('span',{staticClass:"link-highlight award-control-icon-neutral",domProps:{"innerHTML":_vm._s(_vm.emojiSmiling)}}),_vm._v(" "),_c('span',{staticClass:"link-highlight award-control-icon-positive",domProps:{"innerHTML":_vm._s(_vm.emojiSmiley)}}),_vm._v(" "),_c('span',{staticClass:"link-highlight award-control-icon-super-positive",domProps:{"innerHTML":_vm._s(_vm.emojiSmile)}})],1)]):_vm._e(),_vm._v(" "),(_vm.canEdit)?_c('div',{staticClass:"note-actions-item"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"note-action-button js-note-edit btn btn-transparent",attrs:{"type":"button","title":"Edit comment","data-container":"body","data-placement":"bottom"},on:{"click":_vm.onEdit}},[_c('span',{staticClass:"link-highlight",domProps:{"innerHTML":_vm._s(_vm.editSvg)}})])]):_vm._e(),_vm._v(" "),(_vm.shouldShowActionsDropdown)?_c('div',{staticClass:"dropdown more-actions note-actions-item"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"note-action-button more-actions-toggle btn btn-transparent",attrs:{"type":"button","title":"More actions","data-toggle":"dropdown","data-container":"body","data-placement":"bottom"}},[_c('span',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.ellipsisSvg)}})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu more-actions-dropdown dropdown-open-left"},[(_vm.canReportAsAbuse)?_c('li',[_c('a',{attrs:{"href":_vm.reportAbusePath}},[_vm._v("\n          Report as abuse\n        ")])]):_vm._e(),_vm._v(" "),(_vm.canEdit)?_c('li',[_c('button',{staticClass:"btn btn-transparent js-note-delete js-note-delete",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.onDelete($event)}}},[_c('span',{staticClass:"text-danger"},[_vm._v("\n            Delete comment\n          ")])])]):_vm._e()])]):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./notes/components/note_actions.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  note_actions,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_note_actions = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./notes/components/note_attachment.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/note_attachment.vue

/* harmony default export */ var note_attachment = ({
  name: 'NoteAttachment',
  props: {
    attachment: {
      type: Object,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44dc6ea7","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/note_attachment.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"note-attachment"},[(_vm.attachment.image)?_c('a',{attrs:{"href":_vm.attachment.url,"target":"_blank","rel":"noopener noreferrer"}},[_c('img',{staticClass:"note-image-attach",attrs:{"src":_vm.attachment.url}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"attachment"},[(_vm.attachment.url)?_c('a',{attrs:{"href":_vm.attachment.url,"target":"_blank","rel":"noopener noreferrer"}},[_c('i',{staticClass:"fa fa-paperclip",attrs:{"aria-hidden":"true"}}),_vm._v("\n      "+_vm._s(_vm.attachment.filename)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./notes/components/note_attachment.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  note_attachment,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_note_attachment = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./notes/components/note_awards_list.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("../../../node_modules/vuex/dist/vuex.esm.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_emoji_slightly_smiling_face.svg
var _emoji_slightly_smiling_face = __webpack_require__("../../views/shared/icons/_emoji_slightly_smiling_face.svg");
var _emoji_slightly_smiling_face_default = /*#__PURE__*/__webpack_require__.n(_emoji_slightly_smiling_face);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_emoji_smile.svg
var _emoji_smile = __webpack_require__("../../views/shared/icons/_emoji_smile.svg");
var _emoji_smile_default = /*#__PURE__*/__webpack_require__.n(_emoji_smile);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_emoji_smiley.svg
var _emoji_smiley = __webpack_require__("../../views/shared/icons/_emoji_smiley.svg");
var _emoji_smiley_default = /*#__PURE__*/__webpack_require__.n(_emoji_smiley);

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./emoji/index.js
var emoji = __webpack_require__("./emoji/index.js");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/note_awards_list.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









/* harmony default export */ var note_awards_list = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    awards: {
      type: Array,
      required: true
    },
    toggleAwardPath: {
      type: String,
      required: true
    },
    noteAuthorId: {
      type: Number,
      required: true
    },
    noteId: {
      type: Number,
      required: true
    }
  },
  computed: _extends({}, Object(vuex_esm["c" /* mapGetters */])(['getUserData']), {
    // `this.awards` is an array with emojis but they are not grouped by emoji name. See below.
    // [ { name: foo, user: user1 }, { name: bar, user: user1 }, { name: foo, user: user2 } ]
    // This method will group emojis by their name as an Object. See below.
    // {
    //   foo: [ { name: foo, user: user1 }, { name: foo, user: user2 } ],
    //   bar: [ { name: bar, user: user1 } ]
    // }
    // We need to do this otherwise we will render the same emoji over and over again.
    groupedAwards: function groupedAwards() {
      var awards = this.awards.reduce(function (acc, award) {
        if (Object.prototype.hasOwnProperty.call(acc, award.name)) {
          acc[award.name].push(award);
        } else {
          Object.assign(acc, _defineProperty({}, award.name, [award]));
        }

        return acc;
      }, {});

      var orderedAwards = {};
      var thumbsdown = awards.thumbsdown,
          thumbsup = awards.thumbsup;
      // Always show thumbsup and thumbsdown first

      if (thumbsup) {
        orderedAwards.thumbsup = thumbsup;
        delete awards.thumbsup;
      }
      if (thumbsdown) {
        orderedAwards.thumbsdown = thumbsdown;
        delete awards.thumbsdown;
      }

      return Object.assign({}, orderedAwards, awards);
    },
    isAuthoredByMe: function isAuthoredByMe() {
      return this.noteAuthorId === this.getUserData.id;
    },
    isLoggedIn: function isLoggedIn() {
      return this.getUserData.id;
    }
  }),
  created: function created() {
    this.emojiSmiling = _emoji_slightly_smiling_face_default.a;
    this.emojiSmile = _emoji_smile_default.a;
    this.emojiSmiley = _emoji_smiley_default.a;
  },

  methods: _extends({}, Object(vuex_esm["b" /* mapActions */])(['toggleAwardRequest']), {
    getAwardHTML: function getAwardHTML(name) {
      return Object(emoji["glEmojiTag"])(name);
    },
    getAwardClassBindings: function getAwardClassBindings(awardList, awardName) {
      return {
        active: this.hasReactionByCurrentUser(awardList),
        disabled: !this.canInteractWithEmoji(awardList, awardName)
      };
    },
    canInteractWithEmoji: function canInteractWithEmoji(awardList, awardName) {
      var isAllowed = true;
      var restrictedEmojis = ['thumbsup', 'thumbsdown'];

      // Users can not add :+1: and :-1: to their own notes
      if (this.getUserData.id === this.noteAuthorId && restrictedEmojis.indexOf(awardName) > -1) {
        isAllowed = false;
      }

      return this.getUserData.id && isAllowed;
    },
    hasReactionByCurrentUser: function hasReactionByCurrentUser(awardList) {
      var _this = this;

      return awardList.filter(function (award) {
        return award.user.id === _this.getUserData.id;
      }).length;
    },
    awardTitle: function awardTitle(awardsList) {
      var _this2 = this;

      var hasReactionByCurrentUser = this.hasReactionByCurrentUser(awardsList);
      var TOOLTIP_NAME_COUNT = hasReactionByCurrentUser ? 9 : 10;
      var awardList = awardsList;

      // Filter myself from list if I am awarded.
      if (hasReactionByCurrentUser) {
        awardList = awardList.filter(function (award) {
          return award.user.id !== _this2.getUserData.id;
        });
      }

      // Get only 9-10 usernames to show in tooltip text.
      var namesToShow = awardList.slice(0, TOOLTIP_NAME_COUNT).map(function (award) {
        return award.user.name;
      });

      // Get the remaining list to use in `and x more` text.
      var remainingAwardList = awardList.slice(TOOLTIP_NAME_COUNT, awardList.length);

      // Add myself to the begining of the list so title will start with You.
      if (hasReactionByCurrentUser) {
        namesToShow.unshift('You');
      }

      var title = '';

      // We have 10+ awarded user, join them with comma and add `and x more`.
      if (remainingAwardList.length) {
        title = namesToShow.join(', ') + ', and ' + remainingAwardList.length + ' more.';
      } else if (namesToShow.length > 1) {
        // Join all names with comma but not the last one, it will be added with and text.
        title = namesToShow.slice(0, namesToShow.length - 1).join(', ');
        // If we have more than 2 users we need an extra comma before and text.
        title += namesToShow.length > 2 ? ',' : '';
        title += ' and ' + namesToShow.slice(-1); // Append and text
      } else {
        // We have only 2 users so join them with and.
        title = namesToShow.join(' and ');
      }

      return title;
    },
    handleAward: function handleAward(awardName) {
      if (!this.isLoggedIn) {
        return;
      }

      var parsedName = void 0;

      // 100 and 1234 emoji are a number. Callback for v-for click sends it as a string
      switch (awardName) {
        case '100':
          parsedName = 100;
          break;
        case '1234':
          parsedName = 1234;
          break;
        default:
          parsedName = awardName;
          break;
      }

      var data = {
        endpoint: this.toggleAwardPath,
        noteId: this.noteId,
        awardName: parsedName
      };

      this.toggleAwardRequest(data).catch(function () {
        return Object(flash["a" /* default */])('Something went wrong on our end.');
      });
    }
  })
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fd04fdf","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/note_awards_list.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"note-awards"},[_c('div',{staticClass:"awards js-awards-block"},[_vm._l((_vm.groupedAwards),function(awardList,awardName,index){return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],key:index,staticClass:"btn award-control",class:_vm.getAwardClassBindings(awardList, awardName),attrs:{"title":_vm.awardTitle(awardList),"data-placement":"bottom","type":"button"},on:{"click":function($event){_vm.handleAward(awardName)}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getAwardHTML(awardName))}}),_vm._v(" "),_c('span',{staticClass:"award-control-text js-counter"},[_vm._v("\n        "+_vm._s(awardList.length)+"\n      ")])])}),_vm._v(" "),(_vm.isLoggedIn)?_c('div',{staticClass:"award-menu-holder"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"award-control btn js-add-award",class:{ 'js-user-authored': _vm.isAuthoredByMe },attrs:{"title":"Add reaction","aria-label":"Add reaction","data-placement":"bottom","type":"button"}},[_c('span',{staticClass:"award-control-icon award-control-icon-neutral",domProps:{"innerHTML":_vm._s(_vm.emojiSmiling)}}),_vm._v(" "),_c('span',{staticClass:"award-control-icon award-control-icon-positive",domProps:{"innerHTML":_vm._s(_vm.emojiSmiley)}}),_vm._v(" "),_c('span',{staticClass:"award-control-icon award-control-icon-super-positive",domProps:{"innerHTML":_vm._s(_vm.emojiSmile)}}),_vm._v(" "),_c('i',{staticClass:"fa fa-spinner fa-spin award-control-icon award-control-icon-loading",attrs:{"aria-hidden":"true"}})])]):_vm._e()],2)])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./notes/components/note_awards_list.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  note_awards_list,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_note_awards_list = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./notes/components/note_body.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/note_body.vue
var note_body = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/note_body.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66ba06da","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/note_body.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"note-body",staticClass:"note-body",class:{ 'js-task-list-container': _vm.canEdit }},[_c('div',{staticClass:"note-text md",domProps:{"innerHTML":_vm._s(_vm.note.note_html)}}),_vm._v(" "),(_vm.isEditing)?_c('note-form',{ref:"noteForm",attrs:{"is-editing":_vm.isEditing,"note-body":_vm.noteBody,"note-id":_vm.note.id},on:{"handleFormUpdate":_vm.handleFormUpdate,"cancelFormEdition":_vm.formCancelHandler}}):_vm._e(),_vm._v(" "),(_vm.canEdit)?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.note.note),expression:"note.note"}],staticClass:"hidden js-task-list-field",attrs:{"data-update-url":_vm.note.path},domProps:{"value":(_vm.note.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.note, "note", $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.note.last_edited_at)?_c('note-edited-text',{attrs:{"edited-at":_vm.note.last_edited_at,"edited-by":_vm.note.last_edited_by,"action-text":"Edited"}}):_vm._e(),_vm._v(" "),(_vm.note.award_emoji.length)?_c('note-awards-list',{attrs:{"note-id":_vm.note.id,"note-author-id":_vm.note.author.id,"awards":_vm.note.award_emoji,"toggle-award-path":_vm.note.toggle_award_path}}):_vm._e(),_vm._v(" "),(_vm.note.attachment)?_c('note-attachment',{attrs:{"attachment":_vm.note.attachment}}):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./notes/components/note_body.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  note_body["a" /* default */],
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_note_body = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./notes/components/note_edited_text.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/time_ago_tooltip.vue + 2 modules
var time_ago_tooltip = __webpack_require__("./vue_shared/components/time_ago_tooltip.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/note_edited_text.vue



/* harmony default export */ var note_edited_text = ({
  name: 'EditedNoteText',
  components: {
    timeAgoTooltip: time_ago_tooltip["a" /* default */]
  },
  props: {
    actionText: {
      type: String,
      required: true
    },
    editedAt: {
      type: String,
      required: true
    },
    editedBy: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    className: {
      type: String,
      required: false,
      default: 'edited-text'
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-459f52f6","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/note_edited_text.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className},[_vm._v("\n  "+_vm._s(_vm.actionText)+"\n  "),_c('time-ago-tooltip',{attrs:{"time":_vm.editedAt,"tooltip-placement":"bottom"}}),_vm._v(" "),(_vm.editedBy)?[_vm._v("\n    by\n    "),_c('a',{staticClass:"js-vue-author author_link",attrs:{"href":_vm.editedBy.path}},[_vm._v("\n      "+_vm._s(_vm.editedBy.name)+"\n    ")])]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./notes/components/note_edited_text.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  note_edited_text,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_note_edited_text = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./notes/components/note_form.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("../../../node_modules/vuex/dist/vuex.esm.js");

// EXTERNAL MODULE: ./notes/event_hub.js
var event_hub = __webpack_require__("./notes/event_hub.js");

// EXTERNAL MODULE: ./vue_shared/components/issue/issue_warning.vue + 2 modules
var issue_warning = __webpack_require__("./vue_shared/components/issue/issue_warning.vue");

// EXTERNAL MODULE: ./vue_shared/components/markdown/field.vue + 1 modules
var field = __webpack_require__("./vue_shared/components/markdown/field.vue");

// EXTERNAL MODULE: ./notes/mixins/issuable_state.js
var issuable_state = __webpack_require__("./notes/mixins/issuable_state.js");

// EXTERNAL MODULE: ./notes/mixins/resolvable.js
var resolvable = __webpack_require__("./notes/mixins/resolvable.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/note_form.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/* harmony default export */ var note_form = ({
  name: 'IssueNoteForm',
  components: {
    issueWarning: issue_warning["a" /* default */],
    markdownField: field["a" /* default */]
  },
  mixins: [issuable_state["a" /* default */], resolvable["a" /* default */]],
  props: {
    noteBody: {
      type: String,
      required: false,
      default: ''
    },
    noteId: {
      type: Number,
      required: false,
      default: 0
    },
    saveButtonTitle: {
      type: String,
      required: false,
      default: 'Save comment'
    },
    note: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    isEditing: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      updatedNoteBody: this.noteBody,
      conflictWhileEditing: false,
      isSubmitting: false,
      isResolving: false,
      resolveAsThread: true
    };
  },

  computed: _extends({}, Object(vuex_esm["c" /* mapGetters */])(['getDiscussionLastNote', 'getNoteableData', 'getNoteableDataByProp', 'getNotesDataByProp', 'getUserDataByProp']), {
    noteHash: function noteHash() {
      return '#note_' + this.noteId;
    },
    markdownPreviewPath: function markdownPreviewPath() {
      return this.getNoteableDataByProp('preview_note_path');
    },
    markdownDocsPath: function markdownDocsPath() {
      return this.getNotesDataByProp('markdownDocsPath');
    },
    quickActionsDocsPath: function quickActionsDocsPath() {
      return !this.isEditing ? this.getNotesDataByProp('quickActionsDocsPath') : undefined;
    },
    currentUserId: function currentUserId() {
      return this.getUserDataByProp('id');
    },
    isDisabled: function isDisabled() {
      return !this.updatedNoteBody.length || this.isSubmitting;
    }
  }),
  watch: {
    noteBody: function noteBody() {
      if (this.updatedNoteBody === this.noteBody) {
        this.updatedNoteBody = this.noteBody;
      } else {
        this.conflictWhileEditing = true;
      }
    }
  },
  mounted: function mounted() {
    this.$refs.textarea.focus();
  },

  methods: _extends({}, Object(vuex_esm["b" /* mapActions */])(['toggleResolveNote']), {
    handleUpdate: function handleUpdate(shouldResolve) {
      var _this = this;

      var beforeSubmitDiscussionState = this.discussionResolved;
      this.isSubmitting = true;

      this.$emit('handleFormUpdate', this.updatedNoteBody, this.$refs.editNoteForm, function () {
        _this.isSubmitting = false;

        if (shouldResolve) {
          _this.resolveHandler(beforeSubmitDiscussionState);
        }
      });
    },
    editMyLastNote: function editMyLastNote() {
      if (this.updatedNoteBody === '') {
        var lastNoteInDiscussion = this.getDiscussionLastNote(this.updatedNoteBody);

        if (lastNoteInDiscussion) {
          event_hub["a" /* default */].$emit('enterEditMode', {
            noteId: lastNoteInDiscussion.id
          });
        }
      }
    },
    cancelHandler: function cancelHandler() {
      var shouldConfirm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      // Sends information about confirm message and if the textarea has changed
      this.$emit('cancelFormEdition', shouldConfirm, this.noteBody !== this.updatedNoteBody);
    }
  })
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57025676","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/note_form.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"editNoteForm",staticClass:"note-edit-form current-note-edit-form"},[(_vm.conflictWhileEditing)?_c('div',{staticClass:"js-conflict-edit-warning alert alert-danger"},[_vm._v("\n      This comment has changed since you started editing, please review the\n      "),_c('a',{attrs:{"href":_vm.noteHash,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n        updated comment\n      ")]),_vm._v("\n      to ensure information is not lost.\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flash-container timeline-content"}),_vm._v(" "),_c('form',{staticClass:"edit-note common-note-form js-quick-submit gfm-form"},[(_vm.hasWarning(_vm.getNoteableData))?_c('issue-warning',{attrs:{"is-locked":_vm.isLocked(_vm.getNoteableData),"is-confidential":_vm.isConfidential(_vm.getNoteableData)}}):_vm._e(),_vm._v(" "),_c('markdown-field',{attrs:{"markdown-preview-path":_vm.markdownPreviewPath,"markdown-docs-path":_vm.markdownDocsPath,"quick-actions-docs-path":_vm.quickActionsDocsPath,"add-spacing-classes":false}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.updatedNoteBody),expression:"updatedNoteBody"}],ref:"textarea",staticClass:"note-textarea js-gfm-input\njs-autosize markdown-area js-vue-issue-note-form js-vue-textarea",attrs:{"slot":"textarea","id":"note_note","name":"note[note]","data-supports-quick-actions":!_vm.isEditing,"aria-label":"Description","placeholder":"Write a comment or drag your files here..."},domProps:{"value":(_vm.updatedNoteBody)},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }if(!$event.metaKey){ return null; }_vm.handleUpdate()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }if(!$event.ctrlKey){ return null; }_vm.handleUpdate()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }_vm.editMyLastNote()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.cancelHandler(true)}],"input":function($event){if($event.target.composing){ return; }_vm.updatedNoteBody=$event.target.value}},slot:"textarea"})]),_vm._v(" "),_c('div',{staticClass:"note-form-actions clearfix"},[_c('button',{staticClass:"js-vue-issue-save btn btn-save",attrs:{"type":"button","disabled":_vm.isDisabled},on:{"click":function($event){_vm.handleUpdate()}}},[_vm._v("\n          "+_vm._s(_vm.saveButtonTitle)+"\n        ")]),_vm._v(" "),(_vm.note.resolvable)?_c('button',{staticClass:"btn btn-nr btn-default append-right-10 js-comment-resolve-button",on:{"click":function($event){$event.preventDefault();_vm.handleUpdate(true)}}},[_vm._v("\n          "+_vm._s(_vm.resolveButtonTitle)+"\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-cancel note-edit-cancel",attrs:{"type":"button"},on:{"click":function($event){_vm.cancelHandler()}}},[_vm._v("\n          Cancel\n        ")])])],1)])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./notes/components/note_form.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  note_form,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_note_form = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./notes/components/note_header.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("../../../node_modules/vuex/dist/vuex.esm.js");

// EXTERNAL MODULE: ./vue_shared/components/time_ago_tooltip.vue + 2 modules
var time_ago_tooltip = __webpack_require__("./vue_shared/components/time_ago_tooltip.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/note_header.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ var note_header = ({
  components: {
    timeAgoTooltip: time_ago_tooltip["a" /* default */]
  },
  props: {
    author: {
      type: Object,
      required: true
    },
    createdAt: {
      type: String,
      required: true
    },
    actionText: {
      type: String,
      required: false,
      default: ''
    },
    actionTextHtml: {
      type: String,
      required: false,
      default: ''
    },
    noteId: {
      type: Number,
      required: true
    },
    includeToggle: {
      type: Boolean,
      required: false,
      default: false
    },
    expanded: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    toggleChevronClass: function toggleChevronClass() {
      return this.expanded ? 'fa-chevron-up' : 'fa-chevron-down';
    },
    noteTimestampLink: function noteTimestampLink() {
      return '#note_' + this.noteId;
    }
  },
  methods: _extends({}, Object(vuex_esm["b" /* mapActions */])(['setTargetNoteHash']), {
    handleToggle: function handleToggle() {
      this.$emit('toggleHandler');
    },
    updateTargetNoteHash: function updateTargetNoteHash() {
      this.setTargetNoteHash(this.noteTimestampLink);
    }
  })
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d9f27a4","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/note_header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"note-header-info"},[_c('a',{attrs:{"href":_vm.author.path}},[_c('span',{staticClass:"note-header-author-name"},[_vm._v(_vm._s(_vm.author.name))]),_vm._v(" "),_c('span',{staticClass:"note-headline-light"},[_vm._v("\n      @"+_vm._s(_vm.author.username)+"\n    ")])]),_vm._v(" "),_c('span',{staticClass:"note-headline-light"},[_c('span',{staticClass:"note-headline-meta"},[(_vm.actionText)?[_vm._v("\n        "+_vm._s(_vm.actionText)+"\n      ")]:_vm._e(),_vm._v(" "),(_vm.actionTextHtml)?_c('span',{staticClass:"system-note-message",domProps:{"innerHTML":_vm._s(_vm.actionTextHtml)}}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"note-timestamp",attrs:{"href":_vm.noteTimestampLink},on:{"click":_vm.updateTargetNoteHash}},[_c('time-ago-tooltip',{attrs:{"time":_vm.createdAt,"tooltip-placement":"bottom"}})],1),_vm._v(" "),_c('i',{staticClass:"fa fa-spinner fa-spin editing-spinner",attrs:{"aria-label":"Comment is being updated","aria-hidden":"true"}})],2)]),_vm._v(" "),(_vm.includeToggle)?_c('div',{staticClass:"discussion-actions"},[_c('button',{staticClass:"note-action-button discussion-toggle-button js-vue-toggle-button",attrs:{"type":"button"},on:{"click":_vm.handleToggle}},[_c('i',{staticClass:"fa",class:_vm.toggleChevronClass,attrs:{"aria-hidden":"true"}}),_vm._v("\n      Toggle discussion\n    ")])]):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./notes/components/note_header.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  note_header,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_note_header = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./notes/components/note_signed_out_widget.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("../../../node_modules/vuex/dist/vuex.esm.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/note_signed_out_widget.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ var note_signed_out_widget = ({
  computed: _extends({}, Object(vuex_esm["c" /* mapGetters */])(['getNotesDataByProp']), {
    registerLink: function registerLink() {
      return this.getNotesDataByProp('registerPath');
    },
    signInLink: function signInLink() {
      return this.getNotesDataByProp('newSessionPath');
    }
  })
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f23423e","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/note_signed_out_widget.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disabled-comment text-center"},[_vm._v("\n  Please\n  "),_c('a',{attrs:{"href":_vm.registerLink}},[_vm._v("register")]),_vm._v("\n  or\n  "),_c('a',{attrs:{"href":_vm.signInLink}},[_vm._v("sign in")]),_vm._v("\n  to reply\n")])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./notes/components/note_signed_out_widget.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  note_signed_out_widget,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_note_signed_out_widget = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./notes/components/noteable_discussion.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("../../../node_modules/vuex/dist/vuex.esm.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_mr_issue.svg
var _icon_mr_issue = __webpack_require__("../../views/shared/icons/_icon_mr_issue.svg");
var _icon_mr_issue_default = /*#__PURE__*/__webpack_require__.n(_icon_mr_issue);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_next_discussion.svg
var _next_discussion = __webpack_require__("../../views/shared/icons/_next_discussion.svg");
var _next_discussion_default = /*#__PURE__*/__webpack_require__.n(_next_discussion);

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./notes/constants.js
var constants = __webpack_require__("./notes/constants.js");

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_link.vue + 2 modules
var user_avatar_link = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_link.vue");

// EXTERNAL MODULE: ./notes/components/noteable_note.vue + 1 modules
var noteable_note = __webpack_require__("./notes/components/noteable_note.vue");

// EXTERNAL MODULE: ./notes/components/note_header.vue + 2 modules
var note_header = __webpack_require__("./notes/components/note_header.vue");

// EXTERNAL MODULE: ./notes/components/note_signed_out_widget.vue + 2 modules
var note_signed_out_widget = __webpack_require__("./notes/components/note_signed_out_widget.vue");

// EXTERNAL MODULE: ./notes/components/note_edited_text.vue + 2 modules
var note_edited_text = __webpack_require__("./notes/components/note_edited_text.vue");

// EXTERNAL MODULE: ./notes/components/note_form.vue + 2 modules
var note_form = __webpack_require__("./notes/components/note_form.vue");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/diff_with_note.vue
var diff_with_note = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/diff_with_note.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04f0499f","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/diff_with_note.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"fileHolder",staticClass:"diff-file file-holder",class:_vm.diffFileClass},[_c('div',{staticClass:"js-file-title file-title file-title-flex-parent"},[_c('diff-file-header',{attrs:{"diff-file":_vm.diffFile}})],1),_vm._v(" "),(_vm.diffFile.text)?_c('div',{staticClass:"diff-content code js-syntax-highlight"},[_c('table',[_vm._l((_vm.diffRows),function(html,index){return _c(_vm.rowTag(html),{key:index,tag:"component",class:html.className,domProps:{"innerHTML":_vm._s(html.outerHTML)}})}),_vm._v(" "),_c('tr',{staticClass:"notes_holder"},[_c('td',{staticClass:"notes_line",attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticClass:"notes_content"},[_vm._t("default")],2)])],2)]):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.imageDiffHtml)}}),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./notes/components/diff_with_note.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  diff_with_note["a" /* default */],
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_diff_with_note = (Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/notes/placeholder_note.vue + 2 modules
var placeholder_note = __webpack_require__("./vue_shared/components/notes/placeholder_note.vue");

// EXTERNAL MODULE: ./vue_shared/components/notes/placeholder_system_note.vue + 2 modules
var placeholder_system_note = __webpack_require__("./vue_shared/components/notes/placeholder_system_note.vue");

// EXTERNAL MODULE: ./notes/mixins/autosave.js
var autosave = __webpack_require__("./notes/mixins/autosave.js");

// EXTERNAL MODULE: ./notes/mixins/noteable.js
var noteable = __webpack_require__("./notes/mixins/noteable.js");

// EXTERNAL MODULE: ./notes/mixins/resolvable.js
var resolvable = __webpack_require__("./notes/mixins/resolvable.js");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/noteable_discussion.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





















/* harmony default export */ var noteable_discussion = ({
  components: {
    noteableNote: noteable_note["a" /* default */],
    diffWithNote: components_diff_with_note,
    userAvatarLink: user_avatar_link["a" /* default */],
    noteHeader: note_header["a" /* default */],
    noteSignedOutWidget: note_signed_out_widget["a" /* default */],
    noteEditedText: note_edited_text["a" /* default */],
    noteForm: note_form["a" /* default */],
    placeholderNote: placeholder_note["a" /* default */],
    placeholderSystemNote: placeholder_system_note["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  mixins: [autosave["a" /* default */], noteable["a" /* default */], resolvable["a" /* default */]],
  props: {
    note: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isReplying: false,
      isResolving: false,
      resolveAsThread: true
    };
  },

  computed: _extends({}, Object(vuex_esm["c" /* mapGetters */])(['getNoteableData', 'discussionCount', 'resolvedDiscussionCount', 'unresolvedDiscussions']), {
    discussion: function discussion() {
      return _extends({}, this.note.notes[0], {
        truncatedDiffLines: this.note.truncated_diff_lines,
        diffFile: this.note.diff_file,
        diffDiscussion: this.note.diff_discussion,
        imageDiffHtml: this.note.image_diff_html
      });
    },
    author: function author() {
      return this.discussion.author;
    },
    canReply: function canReply() {
      return this.getNoteableData.current_user.can_create_note;
    },
    newNotePath: function newNotePath() {
      return this.getNoteableData.create_note_path;
    },
    lastUpdatedBy: function lastUpdatedBy() {
      var notes = this.note.notes;


      if (notes.length > 1) {
        return notes[notes.length - 1].author;
      }

      return null;
    },
    lastUpdatedAt: function lastUpdatedAt() {
      var notes = this.note.notes;


      if (notes.length > 1) {
        return notes[notes.length - 1].created_at;
      }

      return null;
    },
    hasUnresolvedDiscussion: function hasUnresolvedDiscussion() {
      return this.unresolvedDiscussions.length > 0;
    },
    wrapperComponent: function wrapperComponent() {
      return this.discussion.diffDiscussion && this.discussion.diffFile ? components_diff_with_note : 'div';
    },
    wrapperClass: function wrapperClass() {
      return this.isDiffDiscussion ? '' : 'panel panel-default';
    }
  }),
  mounted: function mounted() {
    if (this.isReplying) {
      this.initAutoSave(this.discussion.noteable_type);
    }
  },
  updated: function updated() {
    if (this.isReplying) {
      if (!this.autosave) {
        this.initAutoSave(this.discussion.noteable_type);
      } else {
        this.setAutoSave();
      }
    }
  },
  created: function created() {
    this.resolveDiscussionsSvg = _icon_mr_issue_default.a;
    this.nextDiscussionsSvg = _next_discussion_default.a;
  },

  methods: _extends({}, Object(vuex_esm["b" /* mapActions */])(['saveNote', 'toggleDiscussion', 'removePlaceholderNotes', 'toggleResolveNote']), {
    componentName: function componentName(note) {
      if (note.isPlaceholderNote) {
        if (note.placeholderType === constants["l" /* SYSTEM_NOTE */]) {
          return placeholder_system_note["a" /* default */];
        }
        return placeholder_note["a" /* default */];
      }

      return noteable_note["a" /* default */];
    },
    componentData: function componentData(note) {
      return note.isPlaceholderNote ? this.note.notes[0] : note;
    },
    toggleDiscussionHandler: function toggleDiscussionHandler() {
      this.toggleDiscussion({ discussionId: this.note.id });
    },
    showReplyForm: function showReplyForm() {
      this.isReplying = true;
    },
    cancelReplyForm: function cancelReplyForm(shouldConfirm) {
      if (shouldConfirm && this.$refs.noteForm.isDirty) {
        // eslint-disable-next-line no-alert
        if (!confirm('Are you sure you want to cancel creating this comment?')) {
          return;
        }
      }

      this.resetAutoSave();
      this.isReplying = false;
    },
    saveReply: function saveReply(noteText, form, callback) {
      var _this = this;

      var replyData = {
        endpoint: this.newNotePath,
        flashContainer: this.$el,
        data: {
          in_reply_to_discussion_id: this.note.reply_id,
          target_type: this.noteableType,
          target_id: this.discussion.noteable_id,
          note: { note: noteText }
        }
      };
      this.isReplying = false;

      this.saveNote(replyData).then(function () {
        _this.resetAutoSave();
        callback();
      }).catch(function (err) {
        _this.removePlaceholderNotes();
        _this.isReplying = true;
        _this.$nextTick(function () {
          var msg = 'Your comment could not be submitted!\nPlease check your network connection and try again.';
          Object(flash["a" /* default */])(msg, 'alert', _this.$el);
          _this.$refs.noteForm.note = noteText;
          callback(err);
        });
      });
    },
    jumpToDiscussion: function jumpToDiscussion() {
      var unresolvedIds = this.unresolvedDiscussions.map(function (d) {
        return d.id;
      });
      var index = unresolvedIds.indexOf(this.note.id);

      if (index >= 0 && index !== unresolvedIds.length) {
        var nextId = unresolvedIds[index + 1];
        var el = document.querySelector('[data-discussion-id="' + nextId + '"]');

        if (el) {
          Object(common_utils["D" /* scrollToElement */])(el);
        }
      }
    }
  })
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d5454be","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/noteable_discussion.vue
var noteable_discussion_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"note note-discussion timeline-entry",attrs:{"data-discussion-id":_vm.note.id}},[_c('div',{staticClass:"timeline-entry-inner"},[_c('div',{staticClass:"timeline-icon"},[_c('user-avatar-link',{attrs:{"link-href":_vm.author.path,"img-src":_vm.author.avatar_url,"img-alt":_vm.author.name,"img-size":40}})],1),_vm._v(" "),_c('div',{staticClass:"timeline-content"},[_c('div',{staticClass:"discussion"},[_c('div',{staticClass:"discussion-header"},[_c('note-header',{staticClass:"discussion",attrs:{"author":_vm.author,"created-at":_vm.discussion.created_at,"note-id":_vm.discussion.id,"include-toggle":true,"expanded":_vm.note.expanded,"action-text":"started a discussion"},on:{"toggleHandler":_vm.toggleDiscussionHandler}}),_vm._v(" "),(_vm.lastUpdatedAt)?_c('note-edited-text',{attrs:{"edited-at":_vm.lastUpdatedAt,"edited-by":_vm.lastUpdatedBy,"action-text":"Last updated","class-name":"discussion-headline-light js-discussion-headline"}}):_vm._e()],1),_vm._v(" "),(_vm.note.expanded)?_c('div',{staticClass:"discussion-body"},[_c(_vm.wrapperComponent,{tag:"component",class:_vm.wrapperClass,attrs:{"discussion":_vm.discussion}},[_c('div',{staticClass:"discussion-notes"},[_c('ul',{staticClass:"notes"},_vm._l((_vm.note.notes),function(note){return _c(_vm.componentName(note),{key:note.id,tag:"component",attrs:{"note":_vm.componentData(note)}})})),_vm._v(" "),_c('div',{staticClass:"discussion-reply-holder",class:{ 'is-replying': _vm.isReplying }},[(!_vm.isReplying && _vm.canReply)?[_c('div',{staticClass:"btn-group-justified discussion-with-resolve-btn",attrs:{"role":"group"}},[_c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('button',{staticClass:"js-vue-discussion-reply btn btn-text-field",attrs:{"type":"button","title":"Add a reply"},on:{"click":_vm.showReplyForm}},[_vm._v("Reply...")])]),_vm._v(" "),(_vm.note.resolvable)?_c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.resolveHandler()}}},[(_vm.isResolving)?_c('i',{staticClass:"fa fa-spinner fa-spin",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v("\n                        "+_vm._s(_vm.resolveButtonTitle)+"\n                      ")])]):_vm._e(),_vm._v(" "),(_vm.note.resolvable)?_c('div',{staticClass:"btn-group discussion-actions",attrs:{"role":"group"}},[(!_vm.discussionResolved)?_c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"new-issue-for-discussion btn\n                            btn-default discussion-create-issue-btn",attrs:{"href":_vm.note.resolve_with_issue_path,"title":"Resolve this discussion in a new issue","data-container":"body"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.resolveDiscussionsSvg)}})])]):_vm._e(),_vm._v(" "),(_vm.hasUnresolvedDiscussion)?_c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"btn btn-default discussion-next-btn",attrs:{"title":"Jump to next unresolved discussion","data-container":"body"},on:{"click":_vm.jumpToDiscussion}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.nextDiscussionsSvg)}})])]):_vm._e()]):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.isReplying)?_c('note-form',{ref:"noteForm",attrs:{"save-button-title":"Comment","note":_vm.note,"is-editing":false},on:{"handleFormUpdate":_vm.saveReply,"cancelFormEdition":_vm.cancelReplyForm}}):_vm._e(),_vm._v(" "),(!_vm.canReply)?_c('note-signed-out-widget'):_vm._e()],2)])])],1):_vm._e()])])])])}
var noteable_discussion_staticRenderFns = []

// CONCATENATED MODULE: ./notes/components/noteable_discussion.vue
/* script */


/* template */

/* template functional */
var noteable_discussion___vue_template_functional__ = false
/* styles */
var noteable_discussion___vue_styles__ = null
/* scopeId */
var noteable_discussion___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var noteable_discussion___vue_module_identifier__ = null

var noteable_discussion_Component = Object(component_normalizer["a" /* default */])(
  noteable_discussion,
  noteable_discussion_render,
  noteable_discussion_staticRenderFns,
  noteable_discussion___vue_template_functional__,
  noteable_discussion___vue_styles__,
  noteable_discussion___vue_scopeId__,
  noteable_discussion___vue_module_identifier__
)

/* harmony default export */ var components_noteable_discussion = __webpack_exports__["a"] = (noteable_discussion_Component.exports);


/***/ }),

/***/ "./notes/components/noteable_note.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/noteable_note.vue
var noteable_note = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/noteable_note.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c0cf4e9","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/noteable_note.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"note timeline-entry",class:_vm.classNameBindings,attrs:{"id":_vm.noteAnchorId,"data-award-url":_vm.note.toggle_award_path}},[_c('div',{staticClass:"timeline-entry-inner"},[_c('div',{staticClass:"timeline-icon"},[_c('user-avatar-link',{attrs:{"link-href":_vm.author.path,"img-src":_vm.author.avatar_url,"img-alt":_vm.author.name,"img-size":40}})],1),_vm._v(" "),_c('div',{staticClass:"timeline-content"},[_c('div',{staticClass:"note-header"},[_c('note-header',{attrs:{"author":_vm.author,"created-at":_vm.note.created_at,"note-id":_vm.note.id,"action-text":"commented"}}),_vm._v(" "),_c('note-actions',{attrs:{"author-id":_vm.author.id,"note-id":_vm.note.id,"access-level":_vm.note.human_access,"can-edit":_vm.note.current_user.can_edit,"can-delete":_vm.note.current_user.can_edit,"can-report-as-abuse":_vm.canReportAsAbuse,"report-abuse-path":_vm.note.report_abuse_path,"resolvable":_vm.note.resolvable,"is-resolved":_vm.note.resolved,"is-resolving":_vm.isResolving,"resolved-by":_vm.note.resolved_by},on:{"handleEdit":_vm.editHandler,"handleDelete":_vm.deleteHandler,"handleResolve":_vm.resolveHandler}})],1),_vm._v(" "),_c('note-body',{ref:"noteBody",attrs:{"note":_vm.note,"can-edit":_vm.note.current_user.can_edit,"is-editing":_vm.isEditing},on:{"handleFormUpdate":_vm.formUpdateHandler,"cancelFormEdition":_vm.formCancelHandler}})],1)])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./notes/components/noteable_note.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  noteable_note["a" /* default */],
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_noteable_note = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./notes/components/notes_app.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/notes_app.vue
var notes_app = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/notes_app.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecc149a6","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/notes_app.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"notes"}},[_c('ul',{staticClass:"notes main-notes-list timeline",attrs:{"id":"notes-list"}},_vm._l((_vm.allNotes),function(note){return _c(_vm.getComponentName(note),{key:note.id,tag:"component",attrs:{"note":_vm.getComponentData(note)}})})),_vm._v(" "),_c('comment-form',{attrs:{"noteable-type":_vm.noteableType}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./notes/components/notes_app.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  notes_app["a" /* default */],
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_notes_app = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./notes/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DISCUSSION_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DIFF_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DISCUSSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SYSTEM_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return OPENED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REOPENED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSED; });
/* unused harmony export EMOJI_THUMBSUP */
/* unused harmony export EMOJI_THUMBSDOWN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ISSUE_NOTEABLE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MERGE_REQUEST_NOTEABLE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UNRESOLVE_NOTE_METHOD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RESOLVE_NOTE_METHOD_NAME; });
var DISCUSSION_NOTE = 'DiscussionNote';
var DIFF_NOTE = 'DiffNote';
var DISCUSSION = 'discussion';
var NOTE = 'note';
var SYSTEM_NOTE = 'systemNote';
var COMMENT = 'comment';
var OPENED = 'opened';
var REOPENED = 'reopened';
var CLOSED = 'closed';
var EMOJI_THUMBSUP = 'thumbsup';
var EMOJI_THUMBSDOWN = 'thumbsdown';
var ISSUE_NOTEABLE_TYPE = 'issue';
var MERGE_REQUEST_NOTEABLE_TYPE = 'merge_request';
var UNRESOLVE_NOTE_METHOD_NAME = 'delete';
var RESOLVE_NOTE_METHOD_NAME = 'post';

/***/ }),

/***/ "./notes/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ "./notes/mixins/autosave.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__autosave__ = __webpack_require__("./autosave.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_text_utility__ = __webpack_require__("./lib/utils/text_utility.js");



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    initAutoSave: function initAutoSave(noteableType) {
      this.autosave = new __WEBPACK_IMPORTED_MODULE_0__autosave__["a" /* default */]($(this.$refs.noteForm.$refs.textarea), ['Note', Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_text_utility__["b" /* capitalizeFirstCharacter */])(noteableType), this.note.id]);
    },
    resetAutoSave: function resetAutoSave() {
      this.autosave.reset();
    },
    setAutoSave: function setAutoSave() {
      this.autosave.save();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./notes/mixins/issuable_state.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    isConfidential: function isConfidential(issue) {
      return !!issue.confidential;
    },
    isLocked: function isLocked(issue) {
      return !!issue.discussion_locked;
    },
    hasWarning: function hasWarning(issue) {
      return this.isConfidential(issue) || this.isLocked(issue);
    }
  }
});

/***/ }),

/***/ "./notes/mixins/noteable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./notes/constants.js");


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    note: {
      type: Object,
      required: true
    }
  },
  computed: {
    noteableType: function noteableType() {
      switch (this.note.noteable_type) {
        case 'MergeRequest':
          return __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* MERGE_REQUEST_NOTEABLE_TYPE */];
        case 'Issue':
          return __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* ISSUE_NOTEABLE_TYPE */];
        default:
          return '';
      }
    }
  }
});

/***/ }),

/***/ "./notes/mixins/resolvable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__("./locale/index.js");



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    note: {
      type: Object,
      required: true
    }
  },
  computed: {
    discussionResolved: function discussionResolved() {
      var _note = this.note,
          notes = _note.notes,
          resolved = _note.resolved;


      if (notes) {
        // Decide resolved state using store. Only valid for discussions.
        return notes.every(function (note) {
          return note.resolved && !note.system;
        });
      }

      return resolved;
    },
    resolveButtonTitle: function resolveButtonTitle() {
      if (this.updatedNoteBody) {
        if (this.discussionResolved) {
          return Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('Comment and unresolve discussion');
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('Comment and resolve discussion');
      }
      return this.discussionResolved ? Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('Unresolve discussion') : Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('Resolve discussion');
    }
  },
  methods: {
    resolveHandler: function resolveHandler() {
      var _this = this;

      var resolvedState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.isResolving = true;
      var endpoint = this.note.resolve_path || this.note.path + '/resolve';
      var isResolved = this.discussionResolved || resolvedState;
      var discussion = this.resolveAsThread;

      this.toggleResolveNote({ endpoint: endpoint, isResolved: isResolved, discussion: discussion }).then(function () {
        _this.isResolving = false;
      }).catch(function () {
        _this.isResolving = false;
        var msg = Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('Something went wrong while resolving this discussion. Please try again.');
        Object(__WEBPACK_IMPORTED_MODULE_0__flash__["a" /* default */])(msg, 'alert', _this.$el);
      });
    }
  }
});

/***/ }),

/***/ "./notes/services/notes_service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("../../../node_modules/vue-resource/dist/vue-resource.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("./notes/constants.js");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchNotes: function fetchNotes(endpoint) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(endpoint);
  },
  deleteNote: function deleteNote(endpoint) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.delete(endpoint);
  },
  replyToDiscussion: function replyToDiscussion(endpoint, data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(endpoint, data, { emulateJSON: true });
  },
  updateNote: function updateNote(endpoint, data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(endpoint, data, { emulateJSON: true });
  },
  createNewNote: function createNewNote(endpoint, data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(endpoint, data, { emulateJSON: true });
  },
  toggleResolveNote: function toggleResolveNote(endpoint, isResolved) {
    var RESOLVE_NOTE_METHOD_NAME = __WEBPACK_IMPORTED_MODULE_2__constants__["k" /* RESOLVE_NOTE_METHOD_NAME */],
        UNRESOLVE_NOTE_METHOD_NAME = __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* UNRESOLVE_NOTE_METHOD_NAME */];

    var method = isResolved ? UNRESOLVE_NOTE_METHOD_NAME : RESOLVE_NOTE_METHOD_NAME;

    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http[method](endpoint);
  },
  poll: function poll() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var endpoint = data.notesData.notesPath;
    var lastFetchedAt = data.lastFetchedAt;
    var options = {
      headers: {
        'X-Last-Fetched-At': lastFetchedAt ? '' + lastFetchedAt : undefined
      }
    };

    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(endpoint, options);
  },
  toggleAward: function toggleAward(endpoint, data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(endpoint, data, { emulateJSON: true });
  },
  toggleIssueState: function toggleIssueState(endpoint, data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.put(endpoint, data);
  }
});

/***/ }),

/***/ "./notes/stores/actions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNotesData", function() { return setNotesData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNoteableData", function() { return setNoteableData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUserData", function() { return setUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLastFetchedAt", function() { return setLastFetchedAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInitialNotes", function() { return setInitialNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTargetNoteHash", function() { return setTargetNoteHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleDiscussion", function() { return toggleDiscussion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchNotes", function() { return fetchNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteNote", function() { return deleteNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateNote", function() { return updateNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replyToDiscussion", function() { return replyToDiscussion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createNewNote", function() { return createNewNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removePlaceholderNotes", function() { return removePlaceholderNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleResolveNote", function() { return toggleResolveNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeIssue", function() { return closeIssue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reopenIssue", function() { return reopenIssue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleStateButtonLoading", function() { return toggleStateButtonLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emitStateChangedEvent", function() { return emitStateChangedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleIssueLocalState", function() { return toggleIssueLocalState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveNote", function() { return saveNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "poll", function() { return poll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopPolling", function() { return stopPolling; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restartPolling", function() { return restartPolling; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchData", function() { return fetchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleAward", function() { return toggleAward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleAwardRequest", function() { return toggleAwardRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scrollToNoteIfNeeded", function() { return scrollToNoteIfNeeded; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_visibilityjs__ = __webpack_require__("../../../node_modules/visibilityjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_visibilityjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_visibilityjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_poll__ = __webpack_require__("./lib/utils/poll.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__("./notes/stores/mutation_types.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("./notes/stores/utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("./notes/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_notes_service__ = __webpack_require__("./notes/services/notes_service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__awards_handler__ = __webpack_require__("./awards_handler.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sidebar_event_hub__ = __webpack_require__("./sidebar/event_hub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");











var eTagPoll = void 0;

var setNotesData = function setNotesData(_ref, data) {
  var commit = _ref.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["j" /* SET_NOTES_DATA */], data);
};
var setNoteableData = function setNoteableData(_ref2, data) {
  var commit = _ref2.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["i" /* SET_NOTEABLE_DATA */], data);
};
var setUserData = function setUserData(_ref3, data) {
  var commit = _ref3.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["l" /* SET_USER_DATA */], data);
};
var setLastFetchedAt = function setLastFetchedAt(_ref4, data) {
  var commit = _ref4.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* SET_LAST_FETCHED_AT */], data);
};
var setInitialNotes = function setInitialNotes(_ref5, data) {
  var commit = _ref5.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* SET_INITIAL_NOTES */], data);
};
var setTargetNoteHash = function setTargetNoteHash(_ref6, data) {
  var commit = _ref6.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["k" /* SET_TARGET_NOTE_HASH */], data);
};
var toggleDiscussion = function toggleDiscussion(_ref7, data) {
  var commit = _ref7.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["o" /* TOGGLE_DISCUSSION */], data);
};

var fetchNotes = function fetchNotes(_ref8, path) {
  var commit = _ref8.commit;
  return __WEBPACK_IMPORTED_MODULE_6__services_notes_service__["a" /* default */].fetchNotes(path).then(function (res) {
    return res.json();
  }).then(function (res) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["g" /* SET_INITIAL_NOTES */], res);
  });
};

var deleteNote = function deleteNote(_ref9, note) {
  var commit = _ref9.commit;
  return __WEBPACK_IMPORTED_MODULE_6__services_notes_service__["a" /* default */].deleteNote(note.path).then(function () {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* DELETE_NOTE */], note);
  });
};

var updateNote = function updateNote(_ref10, _ref11) {
  var commit = _ref10.commit;
  var endpoint = _ref11.endpoint,
      note = _ref11.note;
  return __WEBPACK_IMPORTED_MODULE_6__services_notes_service__["a" /* default */].updateNote(endpoint, note).then(function (res) {
    return res.json();
  }).then(function (res) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["r" /* UPDATE_NOTE */], res);
  });
};

var replyToDiscussion = function replyToDiscussion(_ref12, _ref13) {
  var commit = _ref12.commit;
  var endpoint = _ref13.endpoint,
      data = _ref13.data;
  return __WEBPACK_IMPORTED_MODULE_6__services_notes_service__["a" /* default */].replyToDiscussion(endpoint, data).then(function (res) {
    return res.json();
  }).then(function (res) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* ADD_NEW_REPLY_TO_DISCUSSION */], res);

    return res;
  });
};

var createNewNote = function createNewNote(_ref14, _ref15) {
  var commit = _ref14.commit;
  var endpoint = _ref15.endpoint,
      data = _ref15.data;
  return __WEBPACK_IMPORTED_MODULE_6__services_notes_service__["a" /* default */].createNewNote(endpoint, data).then(function (res) {
    return res.json();
  }).then(function (res) {
    if (!res.errors) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* ADD_NEW_NOTE */], res);
    }
    return res;
  });
};

var removePlaceholderNotes = function removePlaceholderNotes(_ref16) {
  var commit = _ref16.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* REMOVE_PLACEHOLDER_NOTES */]);
};

var toggleResolveNote = function toggleResolveNote(_ref17, _ref18) {
  var commit = _ref17.commit;
  var endpoint = _ref18.endpoint,
      isResolved = _ref18.isResolved,
      discussion = _ref18.discussion;
  return __WEBPACK_IMPORTED_MODULE_6__services_notes_service__["a" /* default */].toggleResolveNote(endpoint, isResolved).then(function (res) {
    return res.json();
  }).then(function (res) {
    var mutationType = discussion ? __WEBPACK_IMPORTED_MODULE_3__mutation_types__["q" /* UPDATE_DISCUSSION */] : __WEBPACK_IMPORTED_MODULE_3__mutation_types__["r" /* UPDATE_NOTE */];

    commit(mutationType, res);
  });
};

var closeIssue = function closeIssue(_ref19) {
  var commit = _ref19.commit,
      dispatch = _ref19.dispatch,
      state = _ref19.state;

  dispatch('toggleStateButtonLoading', true);
  return __WEBPACK_IMPORTED_MODULE_6__services_notes_service__["a" /* default */].toggleIssueState(state.notesData.closePath).then(function (res) {
    return res.json();
  }).then(function (data) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* CLOSE_ISSUE */]);
    dispatch('emitStateChangedEvent', data);
    dispatch('toggleStateButtonLoading', false);
  });
};

var reopenIssue = function reopenIssue(_ref20) {
  var commit = _ref20.commit,
      dispatch = _ref20.dispatch,
      state = _ref20.state;

  dispatch('toggleStateButtonLoading', true);
  return __WEBPACK_IMPORTED_MODULE_6__services_notes_service__["a" /* default */].toggleIssueState(state.notesData.reopenPath).then(function (res) {
    return res.json();
  }).then(function (data) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* REOPEN_ISSUE */]);
    dispatch('emitStateChangedEvent', data);
    dispatch('toggleStateButtonLoading', false);
  });
};

var toggleStateButtonLoading = function toggleStateButtonLoading(_ref21, value) {
  var commit = _ref21.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["p" /* TOGGLE_STATE_BUTTON_LOADING */], value);
};

var emitStateChangedEvent = function emitStateChangedEvent(_ref22, data) {
  var commit = _ref22.commit,
      getters = _ref22.getters;

  var event = new CustomEvent('issuable_vue_app:change', { detail: {
      data: data,
      isClosed: getters.openState === __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* CLOSED */]
    } });

  document.dispatchEvent(event);
};

var toggleIssueLocalState = function toggleIssueLocalState(_ref23, newState) {
  var commit = _ref23.commit;

  if (newState === __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* CLOSED */]) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* CLOSE_ISSUE */]);
  } else if (newState === __WEBPACK_IMPORTED_MODULE_5__constants__["j" /* REOPENED */]) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* REOPEN_ISSUE */]);
  }
};

var saveNote = function saveNote(_ref24, noteData) {
  var commit = _ref24.commit,
      dispatch = _ref24.dispatch;
  var note = noteData.data.note.note;

  var placeholderText = note;
  var hasQuickActions = __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* hasQuickActions */](placeholderText);
  var replyId = noteData.data.in_reply_to_discussion_id;
  var methodToDispatch = replyId ? 'replyToDiscussion' : 'createNewNote';

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* REMOVE_PLACEHOLDER_NOTES */]); // remove previous placeholders
  $('.notes-form .flash-container').hide(); // hide previous flash notification

  if (hasQuickActions) {
    placeholderText = __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* stripQuickActions */](placeholderText);
  }

  if (placeholderText.length) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* SHOW_PLACEHOLDER_NOTE */], {
      noteBody: placeholderText,
      replyId: replyId
    });
  }

  if (hasQuickActions) {
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* SHOW_PLACEHOLDER_NOTE */], {
      isSystemNote: true,
      noteBody: __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* getQuickActionText */](note),
      replyId: replyId
    });
  }

  return dispatch(methodToDispatch, noteData).then(function (res) {
    var errors = res.errors;

    var commandsChanges = res.commands_changes;

    if (hasQuickActions && errors && Object.keys(errors).length) {
      eTagPoll.makeRequest();

      $('.js-gfm-input').trigger('clear-commands-cache.atwho');
      Object(__WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */])('Commands applied', 'notice', noteData.flashContainer);
    }

    if (commandsChanges) {
      if (commandsChanges.emoji_award) {
        var votesBlock = $('.js-awards-block').eq(0);

        Object(__WEBPACK_IMPORTED_MODULE_7__awards_handler__["a" /* default */])().then(function (awardsHandler) {
          awardsHandler.addAwardToEmojiBar(votesBlock, commandsChanges.emoji_award);
          awardsHandler.scrollToAwards();
        }).catch(function () {
          Object(__WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */])('Something went wrong while adding your award. Please try again.', 'alert', noteData.flashContainer);
        });
      }

      if (commandsChanges.spend_time != null || commandsChanges.time_estimate != null) {
        __WEBPACK_IMPORTED_MODULE_8__sidebar_event_hub__["a" /* default */].$emit('timeTrackingUpdated', res);
      }
    }

    if (errors && errors.commands_only) {
      Object(__WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */])(errors.commands_only, 'notice', noteData.flashContainer);
    }
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["e" /* REMOVE_PLACEHOLDER_NOTES */]);

    return res;
  });
};

var pollSuccessCallBack = function pollSuccessCallBack(resp, commit, state, getters) {
  if (resp.notes && resp.notes.length) {
    var notesById = getters.notesById;


    resp.notes.forEach(function (note) {
      if (notesById[note.id]) {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["r" /* UPDATE_NOTE */], note);
      } else if (note.type === __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* DISCUSSION_NOTE */] || note.type === __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* DIFF_NOTE */]) {
        var discussion = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* findNoteObjectById */](state.notes, note.discussion_id);

        if (discussion) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* ADD_NEW_REPLY_TO_DISCUSSION */], note);
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* ADD_NEW_NOTE */], note);
        }
      } else {
        commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* ADD_NEW_NOTE */], note);
      }
    });
  }

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["h" /* SET_LAST_FETCHED_AT */], resp.last_fetched_at);

  return resp;
};

var poll = function poll(_ref25) {
  var commit = _ref25.commit,
      state = _ref25.state,
      getters = _ref25.getters;

  eTagPoll = new __WEBPACK_IMPORTED_MODULE_2__lib_utils_poll__["a" /* default */]({
    resource: __WEBPACK_IMPORTED_MODULE_6__services_notes_service__["a" /* default */],
    method: 'poll',
    data: state,
    successCallback: function successCallback(resp) {
      return resp.json().then(function (data) {
        return pollSuccessCallBack(data, commit, state, getters);
      });
    },
    errorCallback: function errorCallback() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */])('Something went wrong while fetching latest comments.');
    }
  });

  if (!__WEBPACK_IMPORTED_MODULE_0_visibilityjs___default.a.hidden()) {
    eTagPoll.makeRequest();
  } else {
    __WEBPACK_IMPORTED_MODULE_6__services_notes_service__["a" /* default */].poll(state);
  }

  __WEBPACK_IMPORTED_MODULE_0_visibilityjs___default.a.change(function () {
    if (!__WEBPACK_IMPORTED_MODULE_0_visibilityjs___default.a.hidden()) {
      eTagPoll.restart();
    } else {
      eTagPoll.stop();
    }
  });
};

var stopPolling = function stopPolling() {
  eTagPoll.stop();
};

var restartPolling = function restartPolling() {
  eTagPoll.restart();
};

var fetchData = function fetchData(_ref26) {
  var commit = _ref26.commit,
      state = _ref26.state,
      getters = _ref26.getters;

  var requestData = { endpoint: state.notesData.notesPath, lastFetchedAt: state.lastFetchedAt };

  __WEBPACK_IMPORTED_MODULE_6__services_notes_service__["a" /* default */].poll(requestData).then(function (resp) {
    return resp.json;
  }).then(function (data) {
    return pollSuccessCallBack(data, commit, state, getters);
  }).catch(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */])('Something went wrong while fetching latest comments.');
  });
};

var toggleAward = function toggleAward(_ref27, _ref28) {
  var commit = _ref27.commit,
      state = _ref27.state,
      getters = _ref27.getters,
      dispatch = _ref27.dispatch;
  var awardName = _ref28.awardName,
      noteId = _ref28.noteId;

  commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["n" /* TOGGLE_AWARD */], { awardName: awardName, note: getters.notesById[noteId] });
};

var toggleAwardRequest = function toggleAwardRequest(_ref29, data) {
  var commit = _ref29.commit,
      getters = _ref29.getters,
      dispatch = _ref29.dispatch;
  var endpoint = data.endpoint,
      awardName = data.awardName;


  return __WEBPACK_IMPORTED_MODULE_6__services_notes_service__["a" /* default */].toggleAward(endpoint, { name: awardName }).then(function (res) {
    return res.json();
  }).then(function () {
    dispatch('toggleAward', data);
  });
};

var scrollToNoteIfNeeded = function scrollToNoteIfNeeded(context, el) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils_common_utils__["t" /* isInViewport */])(el[0])) {
    Object(__WEBPACK_IMPORTED_MODULE_9__lib_utils_common_utils__["D" /* scrollToElement */])(el);
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./notes/stores/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getters_namespaceObject = {};
__webpack_require__.d(getters_namespaceObject, "notes", function() { return getters_notes; });
__webpack_require__.d(getters_namespaceObject, "targetNoteHash", function() { return targetNoteHash; });
__webpack_require__.d(getters_namespaceObject, "getNotesData", function() { return getNotesData; });
__webpack_require__.d(getters_namespaceObject, "getNotesDataByProp", function() { return getNotesDataByProp; });
__webpack_require__.d(getters_namespaceObject, "getNoteableData", function() { return getNoteableData; });
__webpack_require__.d(getters_namespaceObject, "getNoteableDataByProp", function() { return getNoteableDataByProp; });
__webpack_require__.d(getters_namespaceObject, "openState", function() { return openState; });
__webpack_require__.d(getters_namespaceObject, "getUserData", function() { return getUserData; });
__webpack_require__.d(getters_namespaceObject, "getUserDataByProp", function() { return getUserDataByProp; });
__webpack_require__.d(getters_namespaceObject, "notesById", function() { return notesById; });
__webpack_require__.d(getters_namespaceObject, "getCurrentUserLastNote", function() { return getters_getCurrentUserLastNote; });
__webpack_require__.d(getters_namespaceObject, "getDiscussionLastNote", function() { return getDiscussionLastNote; });
__webpack_require__.d(getters_namespaceObject, "discussionCount", function() { return discussionCount; });
__webpack_require__.d(getters_namespaceObject, "unresolvedDiscussions", function() { return unresolvedDiscussions; });
__webpack_require__.d(getters_namespaceObject, "resolvedDiscussionsById", function() { return resolvedDiscussionsById; });
__webpack_require__.d(getters_namespaceObject, "resolvedDiscussionCount", function() { return resolvedDiscussionCount; });

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("../../../node_modules/vuex/dist/vuex.esm.js");

// EXTERNAL MODULE: ./notes/stores/actions.js
var actions = __webpack_require__("./notes/stores/actions.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// CONCATENATED MODULE: ./notes/stores/getters.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var getters_notes = function notes(state) {
  return state.notes;
};
var targetNoteHash = function targetNoteHash(state) {
  return state.targetNoteHash;
};

var getNotesData = function getNotesData(state) {
  return state.notesData;
};
var getNotesDataByProp = function getNotesDataByProp(state) {
  return function (prop) {
    return state.notesData[prop];
  };
};

var getNoteableData = function getNoteableData(state) {
  return state.noteableData;
};
var getNoteableDataByProp = function getNoteableDataByProp(state) {
  return function (prop) {
    return state.noteableData[prop];
  };
};
var openState = function openState(state) {
  return state.noteableData.state;
};

var getUserData = function getUserData(state) {
  return state.userData || {};
};
var getUserDataByProp = function getUserDataByProp(state) {
  return function (prop) {
    return state.userData && state.userData[prop];
  };
};

var notesById = function notesById(state) {
  return state.notes.reduce(function (acc, note) {
    note.notes.every(function (n) {
      return Object.assign(acc, _defineProperty({}, n.id, n));
    });
    return acc;
  }, {});
};

var reverseNotes = function reverseNotes(array) {
  return array.slice(0).reverse();
};
var isLastNote = function isLastNote(note, state) {
  return !note.system && state.userData && note.author && note.author.id === state.userData.id;
};

var getters_getCurrentUserLastNote = function getCurrentUserLastNote(state) {
  return underscore_default.a.flatten(reverseNotes(state.notes).map(function (note) {
    return reverseNotes(note.notes);
  })).find(function (el) {
    return isLastNote(el, state);
  });
};

var getDiscussionLastNote = function getDiscussionLastNote(state) {
  return function (discussion) {
    return reverseNotes(discussion.notes).find(function (el) {
      return isLastNote(el, state);
    });
  };
};

var discussionCount = function discussionCount(state) {
  var discussions = state.notes.filter(function (n) {
    return !n.individual_note;
  });

  return discussions.length;
};

var unresolvedDiscussions = function unresolvedDiscussions(state, getters) {
  var resolvedMap = getters.resolvedDiscussionsById;

  return state.notes.filter(function (n) {
    return !n.individual_note && !resolvedMap[n.id];
  });
};

var resolvedDiscussionsById = function resolvedDiscussionsById(state) {
  var map = {};

  state.notes.forEach(function (n) {
    if (n.notes) {
      var resolved = n.notes.every(function (note) {
        return note.resolved && !note.system;
      });

      if (resolved) {
        map[n.id] = n;
      }
    }
  });

  return map;
};

var resolvedDiscussionCount = function resolvedDiscussionCount(state, getters) {
  var resolvedMap = getters.resolvedDiscussionsById;

  return Object.keys(resolvedMap).length;
};
// EXTERNAL MODULE: ./notes/stores/utils.js
var utils = __webpack_require__("./notes/stores/utils.js");

// EXTERNAL MODULE: ./notes/stores/mutation_types.js
var mutation_types = __webpack_require__("./notes/stores/mutation_types.js");

// EXTERNAL MODULE: ./notes/constants.js
var constants = __webpack_require__("./notes/constants.js");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// CONCATENATED MODULE: ./notes/stores/mutations.js
var _types$ADD_NEW_NOTE$t;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function mutations__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






/* harmony default export */ var mutations = (_types$ADD_NEW_NOTE$t = {}, mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["a" /* ADD_NEW_NOTE */], function (state, note) {
  var discussion_id = note.discussion_id,
      type = note.type;

  var _state$notes$filter = state.notes.filter(function (n) {
    return n.id === note.discussion_id;
  }),
      _state$notes$filter2 = _slicedToArray(_state$notes$filter, 1),
      exists = _state$notes$filter2[0];

  var isDiscussion = type === constants["e" /* DISCUSSION_NOTE */];

  if (!exists) {
    var noteData = {
      expanded: true,
      id: discussion_id,
      individual_note: !isDiscussion,
      notes: [note],
      reply_id: discussion_id
    };

    if (isDiscussion && Object(common_utils["r" /* isInMRPage */])()) {
      noteData.resolvable = note.resolvable;
      noteData.resolved = false;
      noteData.resolve_path = note.resolve_path;
      noteData.resolve_with_issue_path = note.resolve_with_issue_path;
    }

    state.notes.push(noteData);
    document.dispatchEvent(new CustomEvent('refreshLegacyNotes'));
  }
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["b" /* ADD_NEW_REPLY_TO_DISCUSSION */], function (state, note) {
  var noteObj = utils["a" /* findNoteObjectById */](state.notes, note.discussion_id);

  if (noteObj) {
    noteObj.notes.push(note);
    document.dispatchEvent(new CustomEvent('refreshLegacyNotes'));
  }
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["d" /* DELETE_NOTE */], function (state, note) {
  var noteObj = utils["a" /* findNoteObjectById */](state.notes, note.discussion_id);

  if (noteObj.individual_note) {
    state.notes.splice(state.notes.indexOf(noteObj), 1);
  } else {
    var comment = utils["a" /* findNoteObjectById */](noteObj.notes, note.id);
    noteObj.notes.splice(noteObj.notes.indexOf(comment), 1);

    if (!noteObj.notes.length) {
      state.notes.splice(state.notes.indexOf(noteObj), 1);
    }
  }

  document.dispatchEvent(new CustomEvent('refreshLegacyNotes'));
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["e" /* REMOVE_PLACEHOLDER_NOTES */], function (state) {
  var notes = state.notes;


  for (var i = notes.length - 1; i >= 0; i -= 1) {
    var note = notes[i];
    var children = note.notes;

    if (children.length && !note.individual_note) {
      // remove placeholder from discussions
      for (var j = children.length - 1; j >= 0; j -= 1) {
        if (children[j].isPlaceholderNote) {
          children.splice(j, 1);
        }
      }
    } else if (note.isPlaceholderNote) {
      // remove placeholders from state root
      notes.splice(i, 1);
    }
  }
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["j" /* SET_NOTES_DATA */], function (state, data) {
  Object.assign(state, { notesData: data });
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["i" /* SET_NOTEABLE_DATA */], function (state, data) {
  Object.assign(state, { noteableData: data });
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["l" /* SET_USER_DATA */], function (state, data) {
  Object.assign(state, { userData: data });
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["g" /* SET_INITIAL_NOTES */], function (state, notesData) {
  var notes = [];

  notesData.forEach(function (note) {
    // To support legacy notes, should be very rare case.
    if (note.individual_note && note.notes.length > 1) {
      note.notes.forEach(function (n) {
        notes.push(_extends({}, note, {
          notes: [n] // override notes array to only have one item to mimick individual_note
        }));
      });
    } else {
      var oldNote = utils["a" /* findNoteObjectById */](state.notes, note.id);

      notes.push(_extends({}, note, {
        expanded: oldNote ? oldNote.expanded : note.expanded
      }));
    }
  });

  Object.assign(state, { notes: notes });
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["h" /* SET_LAST_FETCHED_AT */], function (state, fetchedAt) {
  Object.assign(state, { lastFetchedAt: fetchedAt });
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["k" /* SET_TARGET_NOTE_HASH */], function (state, hash) {
  Object.assign(state, { targetNoteHash: hash });
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["m" /* SHOW_PLACEHOLDER_NOTE */], function (state, data) {
  var notesArr = state.notes;
  if (data.replyId) {
    notesArr = utils["a" /* findNoteObjectById */](notesArr, data.replyId).notes;
  }

  notesArr.push({
    individual_note: true,
    isPlaceholderNote: true,
    placeholderType: data.isSystemNote ? constants["l" /* SYSTEM_NOTE */] : constants["h" /* NOTE */],
    notes: [{
      body: data.noteBody
    }]
  });
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["n" /* TOGGLE_AWARD */], function (state, data) {
  var awardName = data.awardName,
      note = data.note;
  var _state$userData = state.userData,
      id = _state$userData.id,
      name = _state$userData.name,
      username = _state$userData.username;


  var hasEmojiAwardedByCurrentUser = note.award_emoji.filter(function (emoji) {
    return emoji.name === data.awardName && emoji.user.id === id;
  });

  if (hasEmojiAwardedByCurrentUser.length) {
    // If current user has awarded this emoji, remove it.
    note.award_emoji.splice(note.award_emoji.indexOf(hasEmojiAwardedByCurrentUser[0]), 1);
  } else {
    note.award_emoji.push({
      name: awardName,
      user: { id: id, name: name, username: username }
    });
  }

  document.dispatchEvent(new CustomEvent('refreshLegacyNotes'));
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["o" /* TOGGLE_DISCUSSION */], function (state, _ref) {
  var discussionId = _ref.discussionId;

  var discussion = utils["a" /* findNoteObjectById */](state.notes, discussionId);

  discussion.expanded = !discussion.expanded;
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["r" /* UPDATE_NOTE */], function (state, note) {
  var noteObj = utils["a" /* findNoteObjectById */](state.notes, note.discussion_id);

  if (noteObj.individual_note) {
    noteObj.notes.splice(0, 1, note);
  } else {
    var comment = utils["a" /* findNoteObjectById */](noteObj.notes, note.id);
    noteObj.notes.splice(noteObj.notes.indexOf(comment), 1, note);
  }

  // document.dispatchEvent(new CustomEvent('refreshLegacyNotes'));
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["q" /* UPDATE_DISCUSSION */], function (state, noteData) {
  var note = noteData;
  var index = 0;

  state.notes.forEach(function (n, i) {
    if (n.id === note.id) {
      index = i;
    }
  });

  note.expanded = true; // override expand flag to prevent collapse
  state.notes.splice(index, 1, note);

  document.dispatchEvent(new CustomEvent('refreshLegacyNotes'));
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["c" /* CLOSE_ISSUE */], function (state) {
  Object.assign(state.noteableData, { state: constants["a" /* CLOSED */] });
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["f" /* REOPEN_ISSUE */], function (state) {
  Object.assign(state.noteableData, { state: constants["j" /* REOPENED */] });
}), mutations__defineProperty(_types$ADD_NEW_NOTE$t, mutation_types["p" /* TOGGLE_STATE_BUTTON_LOADING */], function (state, value) {
  Object.assign(state, { isToggleStateButtonLoading: value });
}), _types$ADD_NEW_NOTE$t);
// CONCATENATED MODULE: ./notes/stores/index.js






vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var stores = __webpack_exports__["a"] = (new vuex_esm["a" /* default */].Store({
  state: {
    notes: [],
    targetNoteHash: null,
    lastFetchedAt: null,

    // View layer
    isToggleStateButtonLoading: false,

    // holds endpoints and permissions provided through haml
    notesData: {},
    userData: {},
    noteableData: {}
  },
  actions: actions,
  getters: getters_namespaceObject,
  mutations: mutations
}));

/***/ }),

/***/ "./notes/stores/mutation_types.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_NEW_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_NEW_REPLY_TO_DISCUSSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REMOVE_PLACEHOLDER_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_NOTES_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_NOTEABLE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_USER_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_INITIAL_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_LAST_FETCHED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_TARGET_NOTE_HASH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SHOW_PLACEHOLDER_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TOGGLE_AWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TOGGLE_DISCUSSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return UPDATE_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return UPDATE_DISCUSSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLOSE_ISSUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REOPEN_ISSUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TOGGLE_STATE_BUTTON_LOADING; });
var ADD_NEW_NOTE = 'ADD_NEW_NOTE';
var ADD_NEW_REPLY_TO_DISCUSSION = 'ADD_NEW_REPLY_TO_DISCUSSION';
var DELETE_NOTE = 'DELETE_NOTE';
var REMOVE_PLACEHOLDER_NOTES = 'REMOVE_PLACEHOLDER_NOTES';
var SET_NOTES_DATA = 'SET_NOTES_DATA';
var SET_NOTEABLE_DATA = 'SET_NOTEABLE_DATA';
var SET_USER_DATA = 'SET_USER_DATA';
var SET_INITIAL_NOTES = 'SET_INITIAL_NOTES';
var SET_LAST_FETCHED_AT = 'SET_LAST_FETCHED_AT';
var SET_TARGET_NOTE_HASH = 'SET_TARGET_NOTE_HASH';
var SHOW_PLACEHOLDER_NOTE = 'SHOW_PLACEHOLDER_NOTE';
var TOGGLE_AWARD = 'TOGGLE_AWARD';
var TOGGLE_DISCUSSION = 'TOGGLE_DISCUSSION';
var UPDATE_NOTE = 'UPDATE_NOTE';
var UPDATE_DISCUSSION = 'UPDATE_DISCUSSION';

// Issue
var CLOSE_ISSUE = 'CLOSE_ISSUE';
var REOPEN_ISSUE = 'REOPEN_ISSUE';
var TOGGLE_STATE_BUTTON_LOADING = 'TOGGLE_STATE_BUTTON_LOADING';

/***/ }),

/***/ "./notes/stores/utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findNoteObjectById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getQuickActionText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasQuickActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return stripQuickActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_ajax_cache__ = __webpack_require__("./lib/utils/ajax_cache.js");


var REGEX_QUICK_ACTIONS = /^\/\w+.*$/gm;

var findNoteObjectById = function findNoteObjectById(notes, id) {
  return notes.filter(function (n) {
    return n.id === id;
  })[0];
};

var getQuickActionText = function getQuickActionText(note) {
  var text = 'Applying command';
  var quickActions = __WEBPACK_IMPORTED_MODULE_0__lib_utils_ajax_cache__["a" /* default */].get(gl.GfmAutoComplete.dataSources.commands) || [];

  var executedCommands = quickActions.filter(function (command) {
    var commandRegex = new RegExp('/' + command.name);
    return commandRegex.test(note);
  });

  if (executedCommands && executedCommands.length) {
    if (executedCommands.length > 1) {
      text = 'Applying multiple commands';
    } else {
      var commandDescription = executedCommands[0].description.toLowerCase();
      text = 'Applying command to ' + commandDescription;
    }
  }

  return text;
};

var hasQuickActions = function hasQuickActions(note) {
  return REGEX_QUICK_ACTIONS.test(note);
};

var stripQuickActions = function stripQuickActions(note) {
  return note.replace(REGEX_QUICK_ACTIONS, '').trim();
};

/***/ }),

/***/ "./pages/projects/merge_requests/show/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: ./notes/components/notes_app.vue + 1 modules
var notes_app = __webpack_require__("./notes/components/notes_app.vue");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("../../../node_modules/vuex/dist/vuex.esm.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_resolve_discussion.svg
var _icon_resolve_discussion = __webpack_require__("../../views/shared/icons/_icon_resolve_discussion.svg");
var _icon_resolve_discussion_default = /*#__PURE__*/__webpack_require__.n(_icon_resolve_discussion);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_status_success_solid.svg
var _icon_status_success_solid = __webpack_require__("../../views/shared/icons/_icon_status_success_solid.svg");
var _icon_status_success_solid_default = /*#__PURE__*/__webpack_require__.n(_icon_status_success_solid);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_mr_issue.svg
var _icon_mr_issue = __webpack_require__("../../views/shared/icons/_icon_mr_issue.svg");
var _icon_mr_issue_default = /*#__PURE__*/__webpack_require__.n(_icon_mr_issue);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_next_discussion.svg
var _next_discussion = __webpack_require__("../../views/shared/icons/_next_discussion.svg");
var _next_discussion_default = /*#__PURE__*/__webpack_require__.n(_next_discussion);

// EXTERNAL MODULE: ./lib/utils/text_utility.js
var text_utility = __webpack_require__("./lib/utils/text_utility.js");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./notes/components/discussion_counter.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










/* harmony default export */ var discussion_counter = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  computed: _extends({}, Object(vuex_esm["c" /* mapGetters */])(['getUserData', 'getNoteableData', 'discussionCount', 'unresolvedDiscussions', 'resolvedDiscussionCount']), {
    isLoggedIn: function isLoggedIn() {
      return this.getUserData.id;
    },
    hasNextButton: function hasNextButton() {
      return this.isLoggedIn && !this.allResolved;
    },
    countText: function countText() {
      return Object(text_utility["g" /* pluralize */])('discussion', this.discussionCount);
    },
    allResolved: function allResolved() {
      return this.resolvedDiscussionCount === this.discussionCount;
    },
    resolveAllDiscussionsIssuePath: function resolveAllDiscussionsIssuePath() {
      return this.getNoteableData.create_issue_to_resolve_discussions_path;
    },
    firstUnresolvedDiscussionId: function firstUnresolvedDiscussionId() {
      var item = this.unresolvedDiscussions[0] || {};

      return item.id;
    }
  }),
  created: function created() {
    this.resolveSvg = _icon_resolve_discussion_default.a;
    this.resolvedSvg = _icon_status_success_solid_default.a;
    this.mrIssueSvg = _icon_mr_issue_default.a;
    this.nextDiscussionSvg = _next_discussion_default.a;
  },

  methods: {
    jumpToFirstDiscussion: function jumpToFirstDiscussion() {
      var el = document.querySelector('[data-discussion-id="' + this.firstUnresolvedDiscussionId + '"]');
      var activeTab = window.mrTabs.currentAction;

      if (activeTab === 'commits' || activeTab === 'pipelines') {
        window.mrTabs.activateTab('show');
      }

      if (el) {
        Object(common_utils["D" /* scrollToElement */])(el);
      }
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76ea793e","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./notes/components/discussion_counter.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-resolve-all-container prepend-top-10"},[_c('div',[(_vm.discussionCount > 0)?_c('div',{staticClass:"line-resolve-all",class:{ 'has-next-btn': _vm.hasNextButton }},[_c('span',{staticClass:"line-resolve-btn is-disabled",class:{ 'is-active': _vm.allResolved },attrs:{"type":"button"}},[(_vm.allResolved)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.resolvedSvg)}}):_c('span',{domProps:{"innerHTML":_vm._s(_vm.resolveSvg)}})]),_vm._v(" "),_c('span',{staticClass:".line-resolve-text"},[_vm._v("\n        "+_vm._s(_vm.resolvedDiscussionCount)+"/"+_vm._s(_vm.discussionCount)+" "+_vm._s(_vm.countText)+" resolved\n      ")])]):_vm._e(),_vm._v(" "),(_vm.resolveAllDiscussionsIssuePath && !_vm.allResolved)?_c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"new-issue-for-discussion btn btn-default discussion-create-issue-btn",attrs:{"href":_vm.resolveAllDiscussionsIssuePath,"title":"Resolve all discussions in new issue","data-container":"body"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.mrIssueSvg)}})])]):_vm._e(),_vm._v(" "),(_vm.isLoggedIn && !_vm.allResolved)?_c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"btn btn-default discussion-next-btn",attrs:{"title":"Jump to first unresolved discussion","data-container":"body"},on:{"click":_vm.jumpToFirstDiscussion}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.nextDiscussionSvg)}})])]):_vm._e()])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./notes/components/discussion_counter.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  discussion_counter,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_discussion_counter = (Component.exports);

// EXTERNAL MODULE: ./notes/stores/index.js + 2 modules
var stores = __webpack_require__("./notes/stores/index.js");

// CONCATENATED MODULE: ./mr_notes/index.js





function initMrNotes() {
  new vue_esm["a" /* default */]({ // eslint-disable-line
    el: '#js-vue-mr-discussions',
    components: {
      notesApp: notes_app["a" /* default */]
    },
    data: function data() {
      var notesDataset = document.getElementById('js-vue-mr-discussions').dataset;
      return {
        noteableData: JSON.parse(notesDataset.noteableData),
        currentUserData: JSON.parse(notesDataset.currentUserData),
        notesData: JSON.parse(notesDataset.notesData)
      };
    },
    render: function render(createElement) {
      return createElement('notes-app', {
        props: {
          noteableData: this.noteableData,
          notesData: this.notesData,
          userData: this.currentUserData
        }
      });
    }
  });

  new vue_esm["a" /* default */]({ // eslint-disable-line
    el: '#js-vue-discussion-counter',
    components: {
      discussionCounter: components_discussion_counter
    },
    store: stores["a" /* default */],
    render: function render(createElement) {
      return createElement('discussion-counter');
    }
  });
}
// EXTERNAL MODULE: ./sidebar/sidebar_bundle.js
var sidebar_bundle = __webpack_require__("./sidebar/sidebar_bundle.js");

// EXTERNAL MODULE: ./merge_request.js
var merge_request = __webpack_require__("./merge_request.js");

// EXTERNAL MODULE: ./zen_mode.js
var zen_mode = __webpack_require__("./zen_mode.js");

// EXTERNAL MODULE: ./init_notes.js
var init_notes = __webpack_require__("./init_notes.js");

// EXTERNAL MODULE: ./init_issuable_sidebar.js
var init_issuable_sidebar = __webpack_require__("./init_issuable_sidebar.js");

// EXTERNAL MODULE: ./diff_notes/diff_notes_bundle.js
var diff_notes_bundle = __webpack_require__("./diff_notes/diff_notes_bundle.js");

// EXTERNAL MODULE: ./shortcuts_issuable.js
var shortcuts_issuable = __webpack_require__("./shortcuts_issuable.js");

// EXTERNAL MODULE: ./diff.js
var diff = __webpack_require__("./diff.js");

// EXTERNAL MODULE: ./how_to_merge.js
var how_to_merge = __webpack_require__("./how_to_merge.js");

// EXTERNAL MODULE: ./commit/pipelines/pipelines_bundle.js + 3 modules
var pipelines_bundle = __webpack_require__("./commit/pipelines/pipelines_bundle.js");

// EXTERNAL MODULE: ./smart_interval.js
var smart_interval = __webpack_require__("./smart_interval.js");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/clipboard_button.vue + 2 modules
var clipboard_button = __webpack_require__("./vue_shared/components/clipboard_button.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_header.vue






/* harmony default export */ var mr_widget_header = ({
  name: 'MRWidgetHeader',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    icon: icon["a" /* default */],
    clipboardButton: clipboard_button["a" /* default */]
  },
  props: {
    mr: {
      type: Object,
      required: true
    }
  },
  computed: {
    shouldShowCommitsBehindText: function shouldShowCommitsBehindText() {
      return this.mr.divergedCommitsCount > 0;
    },
    commitsText: function commitsText() {
      return Object(locale["d" /* n__ */])('%d commit behind', '%d commits behind', this.mr.divergedCommitsCount);
    },
    branchNameClipboardData: function branchNameClipboardData() {
      // This supports code in app/assets/javascripts/copy_to_clipboard.js that
      // works around ClipboardJS limitations to allow the context-specific
      // copy/pasting of plain text or GFM.
      return JSON.stringify({
        text: this.mr.sourceBranch,
        gfm: '`' + this.mr.sourceBranch + '`'
      });
    },
    isSourceBranchLong: function isSourceBranchLong() {
      return this.isBranchTitleLong(this.mr.sourceBranch);
    },
    isTargetBranchLong: function isTargetBranchLong() {
      return this.isBranchTitleLong(this.mr.targetBranch);
    }
  },
  methods: {
    isBranchTitleLong: function isBranchTitleLong(branchTitle) {
      return branchTitle.length > 32;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf80d446","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_header.vue
var mr_widget_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-source-target"},[_c('div',{staticClass:"normal"},[_c('strong',[_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|Request to merge"))+"\n      "),_c('span',{staticClass:"label-branch js-source-branch",class:{ 'label-truncated': _vm.isSourceBranchLong },attrs:{"title":_vm.isSourceBranchLong ? _vm.mr.sourceBranch : '',"data-placement":"bottom","v-tooltip":_vm.isSourceBranchLong},domProps:{"innerHTML":_vm._s(_vm.mr.sourceBranchLink)}}),_vm._v(" "),_c('clipboard-button',{attrs:{"text":_vm.branchNameClipboardData,"title":_vm.__('Copy branch name to clipboard'),"css-class":"btn-default btn-transparent btn-clipboard"}}),_vm._v("\n\n      "+_vm._s(_vm.s__("mrWidget|into"))+"\n\n      "),_c('span',{staticClass:"label-branch",class:{ 'label-truncatedtooltip': _vm.isTargetBranchLong },attrs:{"v-tooltip":_vm.isTargetBranchLong,"title":_vm.isTargetBranchLong ? _vm.mr.targetBranch : '',"data-placement":"bottom"}},[_c('a',{staticClass:"js-target-branch",attrs:{"href":_vm.mr.targetBranchTreePath}},[_vm._v("\n          "+_vm._s(_vm.mr.targetBranch)+"\n        ")])])],1),_vm._v(" "),(_vm.shouldShowCommitsBehindText)?_c('span',{staticClass:"diverged-commits-count"},[_vm._v("\n      ("),_c('a',{attrs:{"href":_vm.mr.targetBranchPath}},[_vm._v(_vm._s(_vm.commitsText))]),_vm._v(")\n    ")]):_vm._e()]),_vm._v(" "),(_vm.mr.isOpen)?_c('div',[_c('button',{staticClass:"btn btn-sm btn-default inline js-check-out-branch",attrs:{"data-target":"#modal_merge_info","data-toggle":"modal","disabled":_vm.mr.sourceBranchRemoved,"type":"button"}},[_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|Check out branch"))+"\n    ")]),_vm._v(" "),_c('span',{staticClass:"dropdown prepend-left-10"},[_c('button',{staticClass:"btn btn-sm inline dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown","aria-label":"Download as","aria-haspopup":"true","aria-expanded":"false"}},[_c('icon',{attrs:{"name":"download"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}})],1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-align-right"},[_c('li',[_c('a',{staticClass:"js-download-email-patches",attrs:{"href":_vm.mr.emailPatchesPath,"download":""}},[_vm._v("\n            "+_vm._s(_vm.s__("mrWidget|Email patches"))+"\n          ")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"js-download-plain-diff",attrs:{"href":_vm.mr.plainDiffPath,"download":""}},[_vm._v("\n            "+_vm._s(_vm.s__("mrWidget|Plain diff"))+"\n          ")])])])])]):_vm._e()])}
var mr_widget_header_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_header.vue
/* script */


/* template */

/* template functional */
var mr_widget_header___vue_template_functional__ = false
/* styles */
var mr_widget_header___vue_styles__ = null
/* scopeId */
var mr_widget_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_header___vue_module_identifier__ = null

var mr_widget_header_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_header,
  mr_widget_header_render,
  mr_widget_header_staticRenderFns,
  mr_widget_header___vue_template_functional__,
  mr_widget_header___vue_styles__,
  mr_widget_header___vue_scopeId__,
  mr_widget_header___vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_header = (mr_widget_header_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_merge_help.vue



/* harmony default export */ var mr_widget_merge_help = ({
  name: 'MRWidgetMergeHelp',
  props: {
    missingBranch: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    missingBranchInfo: function missingBranchInfo() {
      return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('mrWidget|If the %{branch} branch exists in your local repository, you can merge this merge request manually using the'), { branch: this.missingBranch });
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12cfd29e","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_merge_help.vue
var mr_widget_merge_help_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mr-widget-help"},[(_vm.missingBranch)?[_vm._v("\n    "+_vm._s(_vm.missingBranchInfo)+"\n  ")]:[_vm._v("\n    "+_vm._s(_vm.s__("mrWidget|You can merge this merge request manually using the"))+"\n  ")],_vm._v(" "),_c('button',{staticClass:"btn-link btn-blank js-open-modal-help",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal_merge_info"}},[_vm._v("\n    "+_vm._s(_vm.s__("mrWidget|command line"))+"\n  ")])],2)}
var mr_widget_merge_help_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_merge_help.vue
/* script */


/* template */

/* template functional */
var mr_widget_merge_help___vue_template_functional__ = false
/* styles */
var mr_widget_merge_help___vue_styles__ = null
/* scopeId */
var mr_widget_merge_help___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_merge_help___vue_module_identifier__ = null

var mr_widget_merge_help_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_merge_help,
  mr_widget_merge_help_render,
  mr_widget_merge_help_staticRenderFns,
  mr_widget_merge_help___vue_template_functional__,
  mr_widget_merge_help___vue_styles__,
  mr_widget_merge_help___vue_scopeId__,
  mr_widget_merge_help___vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_merge_help = (mr_widget_merge_help_Component.exports);

// EXTERNAL MODULE: ./pipelines/components/stage.vue + 1 modules
var stage = __webpack_require__("./pipelines/components/stage.vue");

// EXTERNAL MODULE: ./vue_shared/components/ci_icon.vue + 2 modules
var ci_icon = __webpack_require__("./vue_shared/components/ci_icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_pipeline.vue

/* eslint-disable vue/require-default-prop */




/* harmony default export */ var mr_widget_pipeline = ({
  name: 'MRWidgetPipeline',
  components: {
    pipelineStage: stage["a" /* default */],
    ciIcon: ci_icon["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    pipeline: {
      type: Object,
      required: true
    },
    // This prop needs to be camelCase, html attributes are case insensive
    // https://vuejs.org/v2/guide/components.html#camelCase-vs-kebab-case
    hasCi: {
      type: Boolean,
      required: false
    },
    ciStatus: {
      type: String,
      required: false
    }
  },
  computed: {
    hasPipeline: function hasPipeline() {
      return this.pipeline && Object.keys(this.pipeline).length > 0;
    },
    hasCIError: function hasCIError() {
      return this.hasCi && !this.ciStatus;
    },
    status: function status() {
      return this.pipeline.details && this.pipeline.details.status ? this.pipeline.details.status : {};
    },
    hasStages: function hasStages() {
      return this.pipeline.details && this.pipeline.details.stages && this.pipeline.details.stages.length;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26e369e9","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_pipeline.vue
var mr_widget_pipeline_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPipeline || _vm.hasCIError)?_c('div',{staticClass:"mr-widget-heading"},[_c('div',{staticClass:"ci-widget media"},[(_vm.hasCIError)?[_c('div',{staticClass:"ci-status-icon ci-status-icon-failed ci-error js-ci-error append-right-10"},[_c('icon',{attrs:{"name":"status_failed"}})],1),_vm._v(" "),_c('div',{staticClass:"media-body"},[_vm._v("\n        Could not connect to the CI server. Please check your settings and try again\n      ")])]:(_vm.hasPipeline)?[_c('a',{staticClass:"append-right-10",attrs:{"href":_vm.status.details_path}},[_c('ci-icon',{attrs:{"status":_vm.status}})],1),_vm._v(" "),_c('div',{staticClass:"media-body"},[_vm._v("\n        Pipeline\n        "),_c('a',{staticClass:"pipeline-id",attrs:{"href":_vm.pipeline.path}},[_vm._v("\n          #"+_vm._s(_vm.pipeline.id)+"\n        ")]),_vm._v("\n\n        "+_vm._s(_vm.pipeline.details.status.label)+" for\n\n        "),_c('a',{staticClass:"commit-sha js-commit-link",attrs:{"href":_vm.pipeline.commit.commit_path}},[_vm._v("\n        "+_vm._s(_vm.pipeline.commit.short_id))]),_vm._v(".\n\n        "),_c('span',{staticClass:"mr-widget-pipeline-graph"},[(_vm.hasStages)?_c('span',{staticClass:"stage-cell"},_vm._l((_vm.pipeline.details.stages),function(stage,i){return _c('div',{key:i,staticClass:"stage-container dropdown js-mini-pipeline-graph"},[_c('pipeline-stage',{attrs:{"stage":stage}})],1)})):_vm._e()]),_vm._v(" "),(_vm.pipeline.coverage)?[_vm._v("\n          Coverage "+_vm._s(_vm.pipeline.coverage)+"%\n        ")]:_vm._e()],2)]:_vm._e()],2)]):_vm._e()}
var mr_widget_pipeline_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_pipeline.vue
/* script */


/* template */

/* template functional */
var mr_widget_pipeline___vue_template_functional__ = false
/* styles */
var mr_widget_pipeline___vue_styles__ = null
/* scopeId */
var mr_widget_pipeline___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_pipeline___vue_module_identifier__ = null

var mr_widget_pipeline_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_pipeline,
  mr_widget_pipeline_render,
  mr_widget_pipeline_staticRenderFns,
  mr_widget_pipeline___vue_template_functional__,
  mr_widget_pipeline___vue_styles__,
  mr_widget_pipeline___vue_scopeId__,
  mr_widget_pipeline___vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_pipeline = (mr_widget_pipeline_Component.exports);

// EXTERNAL MODULE: ./lib/utils/datetime_utility.js
var datetime_utility = __webpack_require__("./lib/utils/datetime_utility.js");

// EXTERNAL MODULE: ./lib/utils/url_utility.js
var url_utility = __webpack_require__("./lib/utils/url_utility.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./lib/utils/http_status.js
var http_status = __webpack_require__("./lib/utils/http_status.js");

// EXTERNAL MODULE: ./lib/utils/number_utils.js
var number_utils = __webpack_require__("./lib/utils/number_utils.js");

// CONCATENATED MODULE: ./vue_shared/components/memory_graph.js


/* harmony default export */ var memory_graph = ({
  name: 'MemoryGraph',
  props: {
    metrics: { type: Array, required: true },
    deploymentTime: { type: Number, required: true },
    width: { type: String, required: true },
    height: { type: String, required: true }
  },
  data: function data() {
    return {
      pathD: '',
      pathViewBox: '',
      dotX: '',
      dotY: ''
    };
  },

  computed: {
    getFormattedMedian: function getFormattedMedian() {
      var deployedSince = Object(datetime_utility["d" /* getTimeago */])().format(this.deploymentTime * 1000);
      return 'Deployed ' + deployedSince;
    }
  },
  methods: {
    /**
     * Returns metric value index in metrics array
     * with timestamp closest to matching median
     */
    getMedianMetricIndex: function getMedianMetricIndex(median, metrics) {
      var matchIndex = 0;
      var timestampDiff = 0;
      var smallestDiff = 0;

      var metricTimestamps = metrics.map(function (v) {
        return v[0];
      });

      // Find metric timestamp which is closest to deploymentTime
      timestampDiff = Math.abs(metricTimestamps[0] - median);
      metricTimestamps.forEach(function (timestamp, index) {
        if (index === 0) {
          // Skip first element
          return;
        }

        smallestDiff = Math.abs(timestamp - median);
        if (smallestDiff < timestampDiff) {
          matchIndex = index;
          timestampDiff = smallestDiff;
        }
      });

      return matchIndex;
    },


    /**
     * Get Graph Plotting values to render Line and Dot
     */
    getGraphPlotValues: function getGraphPlotValues(median, metrics) {
      var renderData = metrics.map(function (v) {
        return v[1];
      });
      var medianMetricIndex = this.getMedianMetricIndex(median, metrics);
      var cx = 0;
      var cy = 0;

      // Find Maximum and Minimum values from `renderData` array
      var maxMemory = Math.max.apply(null, renderData);
      var minMemory = Math.min.apply(null, renderData);

      // Find difference between extreme ends
      var diff = maxMemory - minMemory;
      var lineWidth = renderData.length;

      // Iterate over metrics values and perform following
      // 1. Find x & y co-ords for deploymentTime's memory value
      // 2. Return line path against maxMemory
      var linePath = renderData.map(function (y, x) {
        if (medianMetricIndex === x) {
          cx = x;
          cy = maxMemory - y;
        }
        return x + ' ' + (maxMemory - y);
      });

      return {
        pathD: linePath,
        pathViewBox: {
          lineWidth: lineWidth,
          diff: diff
        },
        dotX: cx,
        dotY: cy
      };
    },


    /**
     * Render Graph based on provided median and metrics values
     */
    renderGraph: function renderGraph(median, metrics) {
      var _getGraphPlotValues = this.getGraphPlotValues(median, metrics),
          pathD = _getGraphPlotValues.pathD,
          pathViewBox = _getGraphPlotValues.pathViewBox,
          dotX = _getGraphPlotValues.dotX,
          dotY = _getGraphPlotValues.dotY;

      // Set props and update graph on UI.


      this.pathD = 'M ' + pathD;
      this.pathViewBox = '0 0 ' + pathViewBox.lineWidth + ' ' + pathViewBox.diff;
      this.dotX = dotX;
      this.dotY = dotY;
    }
  },
  mounted: function mounted() {
    this.renderGraph(this.deploymentTime, this.metrics);
  },

  template: '\n    <div class="memory-graph-container">\n      <svg class="has-tooltip" :title="getFormattedMedian" :width="width" :height="height" xmlns="http://www.w3.org/2000/svg">\n        <path :d="pathD" :viewBox="pathViewBox" />\n        <circle r="1.5" :cx="dotX" :cy="dotY" tranform="translate(0 -1)" />\n      </svg>\n    </div>\n  '
});
// EXTERNAL MODULE: ./lib/utils/axios_utils.js
var axios_utils = __webpack_require__("./lib/utils/axios_utils.js");

// CONCATENATED MODULE: ./vue_merge_request_widget/services/mr_widget_service.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var mr_widget_service_MRWidgetService = function () {
  function MRWidgetService(endpoints) {
    _classCallCheck(this, MRWidgetService);

    this.endpoints = endpoints;
  }

  _createClass(MRWidgetService, [{
    key: 'merge',
    value: function merge(data) {
      return axios_utils["a" /* default */].post(this.endpoints.mergePath, data);
    }
  }, {
    key: 'cancelAutomaticMerge',
    value: function cancelAutomaticMerge() {
      return axios_utils["a" /* default */].post(this.endpoints.cancelAutoMergePath);
    }
  }, {
    key: 'removeWIP',
    value: function removeWIP() {
      return axios_utils["a" /* default */].post(this.endpoints.removeWIPPath);
    }
  }, {
    key: 'removeSourceBranch',
    value: function removeSourceBranch() {
      return axios_utils["a" /* default */].delete(this.endpoints.sourceBranchPath);
    }
  }, {
    key: 'fetchDeployments',
    value: function fetchDeployments() {
      return axios_utils["a" /* default */].get(this.endpoints.ciEnvironmentsStatusPath);
    }
  }, {
    key: 'poll',
    value: function poll() {
      return axios_utils["a" /* default */].get(this.endpoints.statusPath + '?serializer=basic');
    }
  }, {
    key: 'checkStatus',
    value: function checkStatus() {
      return axios_utils["a" /* default */].get(this.endpoints.statusPath + '?serializer=widget');
    }
  }, {
    key: 'fetchMergeActionsContent',
    value: function fetchMergeActionsContent() {
      return axios_utils["a" /* default */].get(this.endpoints.mergeActionsContentPath);
    }
  }, {
    key: 'rebase',
    value: function rebase() {
      return axios_utils["a" /* default */].post(this.endpoints.rebasePath);
    }
  }], [{
    key: 'stopEnvironment',
    value: function stopEnvironment(url) {
      return axios_utils["a" /* default */].post(url);
    }
  }, {
    key: 'fetchMetrics',
    value: function fetchMetrics(metricsUrl) {
      return axios_utils["a" /* default */].get(metricsUrl + '.json');
    }
  }]);

  return MRWidgetService;
}();

/* harmony default export */ var mr_widget_service = (mr_widget_service_MRWidgetService);
// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_memory_usage.js






/* harmony default export */ var mr_widget_memory_usage = ({
  name: 'MemoryUsage',
  props: {
    metricsUrl: {
      type: String,
      required: true
    },
    metricsMonitoringUrl: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      memoryFrom: 0,
      memoryTo: 0,
      memoryMetrics: [],
      deploymentTime: 0,
      hasMetrics: false,
      loadFailed: false,
      loadingMetrics: true,
      backOffRequestCounter: 0
    };
  },

  components: {
    'mr-memory-graph': memory_graph
  },
  computed: {
    shouldShowLoading: function shouldShowLoading() {
      return this.loadingMetrics && !this.hasMetrics && !this.loadFailed;
    },
    shouldShowMemoryGraph: function shouldShowMemoryGraph() {
      return !this.loadingMetrics && this.hasMetrics && !this.loadFailed;
    },
    shouldShowLoadFailure: function shouldShowLoadFailure() {
      return !this.loadingMetrics && !this.hasMetrics && this.loadFailed;
    },
    shouldShowMetricsUnavailable: function shouldShowMetricsUnavailable() {
      return !this.loadingMetrics && !this.hasMetrics && !this.loadFailed;
    },
    memoryChangeType: function memoryChangeType() {
      var memoryTo = Number(this.memoryTo);
      var memoryFrom = Number(this.memoryFrom);

      if (memoryTo > memoryFrom) {
        return 'increased';
      } else if (memoryTo < memoryFrom) {
        return 'decreased';
      }

      return 'unchanged';
    }
  },
  methods: {
    getMegabytes: function getMegabytes(bytesString) {
      var valueInBytes = Number(bytesString).toFixed(2);
      return Object(number_utils["a" /* bytesToMiB */])(valueInBytes).toFixed(2);
    },
    computeGraphData: function computeGraphData(metrics, deploymentTime) {
      this.loadingMetrics = false;
      var memory_before = metrics.memory_before,
          memory_after = metrics.memory_after,
          memory_values = metrics.memory_values;

      // Both `memory_before` and `memory_after` objects
      // have peculiar structure where accessing only a specific
      // index yeilds correct value that we can use to show memory delta.

      if (memory_before.length > 0) {
        this.memoryFrom = this.getMegabytes(memory_before[0].value[1]);
      }

      if (memory_after.length > 0) {
        this.memoryTo = this.getMegabytes(memory_after[0].value[1]);
      }

      if (memory_values.length > 0) {
        this.hasMetrics = true;
        this.memoryMetrics = memory_values[0].values;
        this.deploymentTime = deploymentTime;
      }
    },
    loadMetrics: function loadMetrics() {
      var _this = this;

      Object(common_utils["c" /* backOff */])(function (next, stop) {
        mr_widget_service.fetchMetrics(_this.metricsUrl).then(function (res) {
          if (res.status === http_status["a" /* default */].NO_CONTENT) {
            _this.backOffRequestCounter = _this.backOffRequestCounter += 1;
            /* eslint-disable no-unused-expressions */
            _this.backOffRequestCounter < 3 ? next() : stop(res);
          } else {
            stop(res);
          }
        }).catch(stop);
      }).then(function (res) {
        if (res.status === http_status["a" /* default */].NO_CONTENT) {
          return res;
        }

        return res.data;
      }).then(function (data) {
        _this.computeGraphData(data.metrics, data.deployment_time);
        return data;
      }).catch(function () {
        _this.loadFailed = true;
        _this.loadingMetrics = false;
      });
    }
  },
  mounted: function mounted() {
    this.loadingMetrics = true;
    this.loadMetrics();
  },

  template: '\n    <div class="mr-info-list clearfix mr-memory-usage js-mr-memory-usage">\n      <p\n        v-if="shouldShowLoading"\n        class="usage-info js-usage-info usage-info-loading">\n        <i\n          class="fa fa-spinner fa-spin usage-info-load-spinner"\n          aria-hidden="true" />\u6B63\u5728\u8F7D\u5165\u90E8\u7F72\u7EDF\u8BA1\u4FE1\u606F\u3002\n      </p>\n      <p\n        v-if="shouldShowMemoryGraph"\n        class="usage-info js-usage-info">\n        <a :href="metricsMonitoringUrl">\u5185\u5B58</a> \u4F7F\u7528\u7387 <b>{{memoryChangeType}}</b> \u4ECE {{memoryFrom}}MB \u5230 {{memoryTo}}MB\n      </p>\n      <p\n        v-if="shouldShowLoadFailure"\n        class="usage-info js-usage-info usage-info-failed">\n        \u8F7D\u5165\u90E8\u7F72\u7EDF\u8BA1\u4FE1\u606F\u5931\u8D25\u3002\n      </p>\n      <p\n        v-if="shouldShowMetricsUnavailable"\n        class="usage-info js-usage-info usage-info-unavailable">\n        \u90E8\u7F72\u7EDF\u8BA1\u4FE1\u606F\u76EE\u524D\u8FD8\u4E0D\u53EF\u7528\u3002\n      </p>\n      <mr-memory-graph\n        v-if="shouldShowMemoryGraph"\n        :metrics="memoryMetrics"\n        :deploymentTime="deploymentTime"\n        height="25"\n        width="100" />\n    </div>\n  '
});
// EXTERNAL MODULE: ./vue_merge_request_widget/components/mr_widget_status_icon.vue + 2 modules
var mr_widget_status_icon = __webpack_require__("./vue_merge_request_widget/components/mr_widget_status_icon.vue");

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_deployment.js







/* harmony default export */ var mr_widget_deployment = ({
  name: 'MRWidgetDeployment',
  props: {
    mr: { type: Object, required: true },
    service: { type: Object, required: true }
  },
  components: {
    'mr-widget-memory-usage': mr_widget_memory_usage,
    'status-icon': mr_widget_status_icon["a" /* default */]
  },
  methods: {
    formatDate: function formatDate(date) {
      return Object(datetime_utility["d" /* getTimeago */])().format(date);
    },
    hasExternalUrls: function hasExternalUrls() {
      var deployment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return deployment.external_url && deployment.external_url_formatted;
    },
    hasDeploymentTime: function hasDeploymentTime() {
      var deployment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return deployment.deployed_at && deployment.deployed_at_formatted;
    },
    hasDeploymentMeta: function hasDeploymentMeta() {
      var deployment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return deployment.url && deployment.name;
    },
    stopEnvironment: function stopEnvironment(deployment) {
      var msg = '您确定要停用该运行环境？';
      var isConfirmed = confirm(msg); // eslint-disable-line

      if (isConfirmed) {
        mr_widget_service.stopEnvironment(deployment.stop_url).then(function (res) {
          return res.data;
        }).then(function (data) {
          if (data.redirect_url) {
            Object(url_utility["g" /* visitUrl */])(data.redirect_url);
          }
        }).catch(function () {
          new flash["a" /* default */]('停用运行环境时出现错误，请稍后重试。'); // eslint-disable-line
        });
      }
    }
  },
  template: '\n    <div class="mr-widget-heading deploy-heading">\n      <div v-for="deployment in mr.deployments">\n        <div class="ci-widget media">\n          <div class="ci-status-icon ci-status-icon-success">\n            <span class="js-icon-link icon-link">\n              <status-icon status="success" />\n            </span>\n          </div>\n          <div class="media-body space-children">\n            <span>\n              <span\n                v-if="hasDeploymentMeta(deployment)">\n                \u5DF2\u90E8\u7F72\u5230\n              </span>\n              <a\n                v-if="hasDeploymentMeta(deployment)"\n                :href="deployment.url"\n                target="_blank"\n                rel="noopener noreferrer nofollow"\n                class="js-deploy-meta inline">\n                {{deployment.name}}\n              </a>\n              <span\n                v-if="hasExternalUrls(deployment)">\n                \u4E8E\n              </span>\n              <a\n                v-if="hasExternalUrls(deployment)"\n                :href="deployment.external_url"\n                target="_blank"\n                rel="noopener noreferrer nofollow"\n                class="js-deploy-url inline">\n                <i\n                  class="fa fa-external-link"\n                  aria-hidden="true" />\n                {{deployment.external_url_formatted}}\n              </a>\n              <span\n                v-if="hasDeploymentTime(deployment)"\n                :data-title="deployment.deployed_at_formatted"\n                class="js-deploy-time"\n                data-toggle="tooltip"\n                data-placement="top">\n                {{formatDate(deployment.deployed_at)}}\n              </span>\n            </span>\n            <button\n              type="button"\n              v-if="deployment.stop_url"\n              @click="stopEnvironment(deployment)"\n              class="btn btn-default btn-xs">\n              \u505C\u7528\u8FD0\u884C\u73AF\u5883\n            </button>\n            <mr-widget-memory-usage\n              v-if="deployment.metrics_url"\n              :metrics-url="deployment.metrics_url"\n              :metrics-monitoring-url="deployment.metrics_monitoring_url"\n            />\n          </div>\n        </div>\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_maintainer_edit.vue

/* harmony default export */ var mr_widget_maintainer_edit = ({
  name: 'MRWidgetMaintainerEdit',
  props: {
    maintainerEditAllowed: {
      type: Boolean,
      default: false,
      required: false
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c99de5","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_maintainer_edit.vue
var mr_widget_maintainer_edit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mr-info-list mr-links"},[(_vm.maintainerEditAllowed)?_c('p',[_vm._v("\n    "+_vm._s(_vm.s__("mrWidget|Allows edits from maintainers"))+"\n  ")]):_vm._e()])}
var mr_widget_maintainer_edit_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_maintainer_edit.vue
/* script */


/* template */

/* template functional */
var mr_widget_maintainer_edit___vue_template_functional__ = false
/* styles */
var mr_widget_maintainer_edit___vue_styles__ = null
/* scopeId */
var mr_widget_maintainer_edit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_maintainer_edit___vue_module_identifier__ = null

var mr_widget_maintainer_edit_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_maintainer_edit,
  mr_widget_maintainer_edit_render,
  mr_widget_maintainer_edit_staticRenderFns,
  mr_widget_maintainer_edit___vue_template_functional__,
  mr_widget_maintainer_edit___vue_styles__,
  mr_widget_maintainer_edit___vue_scopeId__,
  mr_widget_maintainer_edit___vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_maintainer_edit = (mr_widget_maintainer_edit_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_related_links.vue



/* harmony default export */ var mr_widget_related_links = ({
  name: 'MRWidgetRelatedLinks',
  props: {
    relatedLinks: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    state: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    closesText: function closesText() {
      if (this.state === 'merged') {
        return Object(locale["e" /* s__ */])('mrWidget|Closed');
      }
      if (this.state === 'closed') {
        return Object(locale["e" /* s__ */])('mrWidget|Did not close');
      }
      return Object(locale["e" /* s__ */])('mrWidget|Closes');
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf14ab0","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_related_links.vue
var mr_widget_related_links_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mr-info-list mr-links"},[(_vm.relatedLinks.closing)?_c('p',[_vm._v("\n    "+_vm._s(_vm.closesText)+" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.relatedLinks.closing)}})]):_vm._e(),_vm._v(" "),(_vm.relatedLinks.mentioned)?_c('p',[_vm._v("\n    "+_vm._s(_vm.s__("mrWidget|Mentions"))+" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.relatedLinks.mentioned)}})]):_vm._e(),_vm._v(" "),(_vm.relatedLinks.assignToMe)?_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.relatedLinks.assignToMe)}})]):_vm._e()])}
var mr_widget_related_links_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_related_links.vue
/* script */


/* template */

/* template functional */
var mr_widget_related_links___vue_template_functional__ = false
/* styles */
var mr_widget_related_links___vue_styles__ = null
/* scopeId */
var mr_widget_related_links___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_related_links___vue_module_identifier__ = null

var mr_widget_related_links_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_related_links,
  mr_widget_related_links_render,
  mr_widget_related_links_staticRenderFns,
  mr_widget_related_links___vue_template_functional__,
  mr_widget_related_links___vue_styles__,
  mr_widget_related_links___vue_scopeId__,
  mr_widget_related_links___vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_related_links = (mr_widget_related_links_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_author.vue



/* harmony default export */ var mr_widget_author = ({
  name: 'MRWidgetAuthor',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    author: {
      type: Object,
      required: true
    },
    showAuthorName: {
      type: Boolean,
      required: false,
      default: true
    },
    showAuthorTooltip: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    authorUrl: function authorUrl() {
      return this.author.webUrl || this.author.web_url;
    },
    avatarUrl: function avatarUrl() {
      return this.author.avatarUrl || this.author.avatar_url;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fe1caf0","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_author.vue
var mr_widget_author_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"author-link inline",attrs:{"href":_vm.authorUrl,"v-tooltip":_vm.showAuthorTooltip,"title":_vm.author.name}},[_c('img',{staticClass:"avatar avatar-inline s16",attrs:{"src":_vm.avatarUrl}}),_vm._v(" "),(_vm.showAuthorName)?_c('span',{staticClass:"author"},[_vm._v("\n    "+_vm._s(_vm.author.name)+"\n  ")]):_vm._e()])}
var mr_widget_author_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_author.vue
/* script */


/* template */

/* template functional */
var mr_widget_author___vue_template_functional__ = false
/* styles */
var mr_widget_author___vue_styles__ = null
/* scopeId */
var mr_widget_author___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_author___vue_module_identifier__ = null

var mr_widget_author_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_author,
  mr_widget_author_render,
  mr_widget_author_staticRenderFns,
  mr_widget_author___vue_template_functional__,
  mr_widget_author___vue_styles__,
  mr_widget_author___vue_scopeId__,
  mr_widget_author___vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_author = (mr_widget_author_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_author_time.vue



/* harmony default export */ var mr_widget_author_time = ({
  name: 'MRWidgetAuthorTime',
  components: {
    mrWidgetAuthor: components_mr_widget_author
  },
  props: {
    actionText: {
      type: String,
      required: true
    },
    author: {
      type: Object,
      required: true
    },
    dateTitle: {
      type: String,
      required: true
    },
    dateReadable: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-658e77d0","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_author_time.vue
var mr_widget_author_time_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"js-mr-widget-author"},[_vm._v("\n  "+_vm._s(_vm.actionText)+"\n  "),_c('mr-widget-author',{attrs:{"author":_vm.author}}),_vm._v(" "),_c('time',{attrs:{"title":_vm.dateTitle,"data-toggle":"tooltip","data-placement":"top","data-container":"body"}},[_vm._v("\n    "+_vm._s(_vm.dateReadable)+"\n  ")])],1)}
var mr_widget_author_time_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_author_time.vue
/* script */


/* template */

/* template functional */
var mr_widget_author_time___vue_template_functional__ = false
/* styles */
var mr_widget_author_time___vue_styles__ = null
/* scopeId */
var mr_widget_author_time___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_author_time___vue_module_identifier__ = null

var mr_widget_author_time_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_author_time,
  mr_widget_author_time_render,
  mr_widget_author_time_staticRenderFns,
  mr_widget_author_time___vue_template_functional__,
  mr_widget_author_time___vue_styles__,
  mr_widget_author_time___vue_scopeId__,
  mr_widget_author_time___vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_author_time = (mr_widget_author_time_Component.exports);

// EXTERNAL MODULE: ./vue_merge_request_widget/event_hub.js
var event_hub = __webpack_require__("./vue_merge_request_widget/event_hub.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_merged.vue









/* harmony default export */ var mr_widget_merged = ({
  name: 'MRWidgetMerged',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    mrWidgetAuthorTime: components_mr_widget_author_time,
    loadingIcon: loading_icon["a" /* default */],
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  props: {
    mr: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    service: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isMakingRequest: false
    };
  },

  computed: {
    shouldShowRemoveSourceBranch: function shouldShowRemoveSourceBranch() {
      var _mr = this.mr,
          sourceBranchRemoved = _mr.sourceBranchRemoved,
          isRemovingSourceBranch = _mr.isRemovingSourceBranch,
          canRemoveSourceBranch = _mr.canRemoveSourceBranch;


      return !sourceBranchRemoved && canRemoveSourceBranch && !this.isMakingRequest && !isRemovingSourceBranch;
    },
    shouldShowSourceBranchRemoving: function shouldShowSourceBranchRemoving() {
      var _mr2 = this.mr,
          sourceBranchRemoved = _mr2.sourceBranchRemoved,
          isRemovingSourceBranch = _mr2.isRemovingSourceBranch;

      return !sourceBranchRemoved && (isRemovingSourceBranch || this.isMakingRequest);
    },
    shouldShowMergedButtons: function shouldShowMergedButtons() {
      var _mr3 = this.mr,
          canRevertInCurrentMR = _mr3.canRevertInCurrentMR,
          canCherryPickInCurrentMR = _mr3.canCherryPickInCurrentMR,
          revertInForkPath = _mr3.revertInForkPath,
          cherryPickInForkPath = _mr3.cherryPickInForkPath;


      return canRevertInCurrentMR || canCherryPickInCurrentMR || revertInForkPath || cherryPickInForkPath;
    },
    revertTitle: function revertTitle() {
      return Object(locale["e" /* s__ */])('mrWidget|Revert this merge request in a new merge request');
    },
    cherryPickTitle: function cherryPickTitle() {
      return Object(locale["e" /* s__ */])('mrWidget|Cherry-pick this merge request in a new merge request');
    },
    revertLabel: function revertLabel() {
      return Object(locale["e" /* s__ */])('mrWidget|Revert');
    },
    cherryPickLabel: function cherryPickLabel() {
      return Object(locale["e" /* s__ */])('mrWidget|Cherry-pick');
    }
  },
  methods: {
    removeSourceBranch: function removeSourceBranch() {
      var _this = this;

      this.isMakingRequest = true;

      this.service.removeSourceBranch().then(function (res) {
        return res.data;
      }).then(function (data) {
        if (data.message === 'Branch was removed') {
          event_hub["a" /* default */].$emit('MRWidgetUpdateRequested', function () {
            _this.isMakingRequest = false;
          });
        }
      }).catch(function () {
        _this.isMakingRequest = false;
        Object(flash["a" /* default */])(Object(locale["a" /* __ */])('Something went wrong. Please try again.'));
      });
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-747e4197","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_merged.vue
var mr_widget_merged_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"success"}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('div',{staticClass:"space-children"},[_c('mr-widget-author-time',{attrs:{"action-text":_vm.s__('mrWidget|Merged by'),"author":_vm.mr.metrics.mergedBy,"date-title":_vm.mr.metrics.mergedAt,"date-readable":_vm.mr.metrics.readableMergedAt}}),_vm._v(" "),(_vm.mr.canRevertInCurrentMR)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"btn btn-close btn-xs",attrs:{"href":"#modal-revert-commit","data-toggle":"modal","data-container":"body","title":_vm.revertTitle}},[_vm._v("\n        "+_vm._s(_vm.revertLabel)+"\n      ")]):(_vm.mr.revertInForkPath)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"btn btn-close btn-xs",attrs:{"data-method":"post","href":_vm.mr.revertInForkPath,"title":_vm.revertTitle}},[_vm._v("\n        "+_vm._s(_vm.revertLabel)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.mr.canCherryPickInCurrentMR)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"btn btn-default btn-xs",attrs:{"href":"#modal-cherry-pick-commit","data-toggle":"modal","data-container":"body","title":_vm.cherryPickTitle}},[_vm._v("\n        "+_vm._s(_vm.cherryPickLabel)+"\n      ")]):(_vm.mr.cherryPickInForkPath)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"btn btn-default btn-xs",attrs:{"data-method":"post","href":_vm.mr.cherryPickInForkPath,"title":_vm.cherryPickTitle}},[_vm._v("\n        "+_vm._s(_vm.cherryPickLabel)+"\n      ")]):_vm._e()],1),_vm._v(" "),_c('section',{staticClass:"mr-info-list"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|The changes were merged into"))+"\n        "),_c('span',{staticClass:"label-branch"},[_c('a',{attrs:{"href":_vm.mr.targetBranchPath}},[_vm._v(_vm._s(_vm.mr.targetBranch))])])]),_vm._v(" "),(_vm.mr.sourceBranchRemoved)?_c('p',[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|The source branch has been removed"))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.shouldShowRemoveSourceBranch)?_c('p',{staticClass:"space-children"},[_c('span',[_vm._v(_vm._s(_vm.s__("mrWidget|You can remove source branch now")))]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-default js-remove-branch-button",attrs:{"disabled":_vm.isMakingRequest,"type":"button"},on:{"click":_vm.removeSourceBranch}},[_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|Remove Source Branch"))+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.shouldShowSourceBranchRemoving)?_c('p',[_c('loading-icon',{attrs:{"inline":true}}),_vm._v(" "),_c('span',[_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|The source branch is being removed"))+"\n        ")])],1):_vm._e()])])],1)}
var mr_widget_merged_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_merged.vue
/* script */


/* template */

/* template functional */
var mr_widget_merged___vue_template_functional__ = false
/* styles */
var mr_widget_merged___vue_styles__ = null
/* scopeId */
var mr_widget_merged___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_merged___vue_module_identifier__ = null

var mr_widget_merged_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_merged,
  mr_widget_merged_render,
  mr_widget_merged_staticRenderFns,
  mr_widget_merged___vue_template_functional__,
  mr_widget_merged___vue_styles__,
  mr_widget_merged___vue_scopeId__,
  mr_widget_merged___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_merged = (mr_widget_merged_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_failed_to_merge.vue





/* harmony default export */ var mr_widget_failed_to_merge = ({
  name: 'MRWidgetFailedToMerge',

  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  },

  props: {
    mr: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      timer: 10,
      isRefreshing: false
    };
  },


  computed: {
    timerText: function timerText() {
      return Object(locale["d" /* n__ */])('Refreshing in a second to show the updated status...', 'Refreshing in %d seconds to show the updated status...', this.timer);
    }
  },

  mounted: function mounted() {
    var _this = this;

    setInterval(function () {
      _this.updateTimer();
    }, 1000);
  },
  created: function created() {
    event_hub["a" /* default */].$emit('DisablePolling');
  },


  methods: {
    refresh: function refresh() {
      this.isRefreshing = true;
      event_hub["a" /* default */].$emit('MRWidgetUpdateRequested');
      event_hub["a" /* default */].$emit('EnablePolling');
    },
    updateTimer: function updateTimer() {
      this.timer = this.timer - 1;

      if (this.timer === 0) {
        this.refresh();
      }
    }
  }

});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4338048a","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_failed_to_merge.vue
var mr_widget_failed_to_merge_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[(_vm.isRefreshing)?[_c('status-icon',{attrs:{"status":"loading"}}),_vm._v(" "),_c('span',{staticClass:"media-body bold js-refresh-label"},[_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|Refreshing now"))+"\n    ")])]:[_c('status-icon',{attrs:{"status":"warning","show-disabled-button":true}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('span',{staticClass:"bold"},[(_vm.mr.mergeError)?_c('span',{staticClass:"has-error-message"},[_vm._v("\n          "+_vm._s(_vm.mr.mergeError)+".\n        ")]):_c('span',[_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|Merge failed."))+"\n        ")]),_vm._v(" "),_c('span',{class:{ 'has-custom-error': _vm.mr.mergeError }},[_vm._v("\n          "+_vm._s(_vm.timerText)+"\n        ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-xs js-refresh-button",attrs:{"type":"button"},on:{"click":_vm.refresh}},[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|Refresh now"))+"\n      ")])])]],2)}
var mr_widget_failed_to_merge_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_failed_to_merge.vue
/* script */


/* template */

/* template functional */
var mr_widget_failed_to_merge___vue_template_functional__ = false
/* styles */
var mr_widget_failed_to_merge___vue_styles__ = null
/* scopeId */
var mr_widget_failed_to_merge___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_failed_to_merge___vue_module_identifier__ = null

var mr_widget_failed_to_merge_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_failed_to_merge,
  mr_widget_failed_to_merge_render,
  mr_widget_failed_to_merge_staticRenderFns,
  mr_widget_failed_to_merge___vue_template_functional__,
  mr_widget_failed_to_merge___vue_styles__,
  mr_widget_failed_to_merge___vue_scopeId__,
  mr_widget_failed_to_merge___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_failed_to_merge = (mr_widget_failed_to_merge_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_closed.vue




/* harmony default export */ var mr_widget_closed = ({
  name: 'MRWidgetClosed',
  components: {
    mrWidgetAuthorTime: components_mr_widget_author_time,
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  props: {
    /* TODO: This is providing all store and service down when it
    only needs metrics and targetBranch */
    mr: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-712ee8d3","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_closed.vue
var mr_widget_closed_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"warning"}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('mr-widget-author-time',{attrs:{"action-text":_vm.s__('mrWidget|Closed by'),"author":_vm.mr.metrics.closedBy,"date-title":_vm.mr.metrics.closedAt,"date-readable":_vm.mr.metrics.readableClosedAt}}),_vm._v(" "),_c('section',{staticClass:"mr-info-list"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|The changes were not merged into"))+"\n        "),_c('a',{staticClass:"label-branch",attrs:{"href":_vm.mr.targetBranchPath}},[_vm._v("\n          "+_vm._s(_vm.mr.targetBranch)+"\n        ")])])])],1)],1)}
var mr_widget_closed_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_closed.vue
/* script */


/* template */

/* template functional */
var mr_widget_closed___vue_template_functional__ = false
/* styles */
var mr_widget_closed___vue_styles__ = null
/* scopeId */
var mr_widget_closed___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_closed___vue_module_identifier__ = null

var mr_widget_closed_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_closed,
  mr_widget_closed_render,
  mr_widget_closed_staticRenderFns,
  mr_widget_closed___vue_template_functional__,
  mr_widget_closed___vue_styles__,
  mr_widget_closed___vue_scopeId__,
  mr_widget_closed___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_closed = (mr_widget_closed_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_merging.vue



/* harmony default export */ var mr_widget_merging = ({
  name: 'MRWidgetMerging',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  props: {
    mr: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef7b084","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_merging.vue
var mr_widget_merging_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body mr-state-locked media"},[_c('status-icon',{attrs:{"status":"loading"}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h4',[_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|This merge request is in the process of being merged"))+"\n    ")]),_vm._v(" "),_c('section',{staticClass:"mr-info-list"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|The changes will be merged into"))+"\n        "),_c('span',{staticClass:"label-branch"},[_c('a',{attrs:{"href":_vm.mr.targetBranchPath}},[_vm._v(_vm._s(_vm.mr.targetBranch))])])])])])],1)}
var mr_widget_merging_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_merging.vue
/* script */


/* template */

/* template functional */
var mr_widget_merging___vue_template_functional__ = false
/* styles */
var mr_widget_merging___vue_styles__ = null
/* scopeId */
var mr_widget_merging___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_merging___vue_module_identifier__ = null

var mr_widget_merging_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_merging,
  mr_widget_merging_render,
  mr_widget_merging_staticRenderFns,
  mr_widget_merging___vue_template_functional__,
  mr_widget_merging___vue_styles__,
  mr_widget_merging___vue_scopeId__,
  mr_widget_merging___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_merging = (mr_widget_merging_Component.exports);

// EXTERNAL MODULE: ./vue_merge_request_widget/components/states/mr_widget_wip.js
var mr_widget_wip = __webpack_require__("./vue_merge_request_widget/components/states/mr_widget_wip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_archived.vue



/* harmony default export */ var mr_widget_archived = ({
  name: 'MRWidgetArchived',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f098ac0c","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_archived.vue
var mr_widget_archived_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('div',{staticClass:"space-children"},[_c('status-icon',{attrs:{"status":"warning"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"button","disabled":"true"}},[_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|Merge"))+"\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('span',{staticClass:"bold"},[_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|This project is archived, write access has been disabled"))+"\n    ")])])])}
var mr_widget_archived_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_archived.vue
/* script */


/* template */

/* template functional */
var mr_widget_archived___vue_template_functional__ = false
/* styles */
var mr_widget_archived___vue_styles__ = null
/* scopeId */
var mr_widget_archived___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_archived___vue_module_identifier__ = null

var mr_widget_archived_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_archived,
  mr_widget_archived_render,
  mr_widget_archived_staticRenderFns,
  mr_widget_archived___vue_template_functional__,
  mr_widget_archived___vue_styles__,
  mr_widget_archived___vue_scopeId__,
  mr_widget_archived___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_archived = (mr_widget_archived_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_conflicts.vue



/* harmony default export */ var mr_widget_conflicts = ({
  name: 'MRWidgetConflicts',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  props: {
    /* TODO: This is providing all store and service down when it
    only needs a few props */
    mr: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b353dce6","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_conflicts.vue
var mr_widget_conflicts_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"warning","show-disabled-button":true}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[(_vm.mr.shouldBeRebased)?_c('span',{staticClass:"bold"},[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|Fast-forward merge is not possible.\nTo merge this request, first rebase locally."))+"\n      ")]):[_c('span',{staticClass:"bold"},[_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|There are merge conflicts"))),(!_vm.mr.canMerge)?_c('span',[_vm._v(".")]):_vm._e(),_vm._v(" "),(!_vm.mr.canMerge)?_c('span',[_vm._v("\n            "+_vm._s(_vm.s__("mrWidget|Resolve these conflicts or ask someone\n            with write access to this repository to merge it locally"))+"\n          ")]):_vm._e()]),_vm._v(" "),(_vm.mr.canMerge && _vm.mr.conflictResolutionPath)?_c('a',{staticClass:"js-resolve-conflicts-button btn btn-default btn-xs",attrs:{"href":_vm.mr.conflictResolutionPath}},[_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|Resolve conflicts"))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.mr.canMerge)?_c('button',{staticClass:"js-merge-locally-button btn btn-default btn-xs",attrs:{"data-toggle":"modal","data-target":"#modal_merge_info"}},[_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|Merge locally"))+"\n        ")]):_vm._e()]],2)],1)}
var mr_widget_conflicts_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_conflicts.vue
/* script */


/* template */

/* template functional */
var mr_widget_conflicts___vue_template_functional__ = false
/* styles */
var mr_widget_conflicts___vue_styles__ = null
/* scopeId */
var mr_widget_conflicts___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_conflicts___vue_module_identifier__ = null

var mr_widget_conflicts_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_conflicts,
  mr_widget_conflicts_render,
  mr_widget_conflicts_staticRenderFns,
  mr_widget_conflicts___vue_template_functional__,
  mr_widget_conflicts___vue_styles__,
  mr_widget_conflicts___vue_scopeId__,
  mr_widget_conflicts___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_conflicts = (mr_widget_conflicts_Component.exports);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_mr_widget_empty_state.svg
var _mr_widget_empty_state = __webpack_require__("../../views/shared/icons/_mr_widget_empty_state.svg");
var _mr_widget_empty_state_default = /*#__PURE__*/__webpack_require__.n(_mr_widget_empty_state);

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_nothing_to_merge.js


/* harmony default export */ var mr_widget_nothing_to_merge = ({
  name: 'MRWidgetNothingToMerge',
  props: {
    mr: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return { emptyStateSVG: _mr_widget_empty_state_default.a };
  },

  template: '\n    <div class="mr-widget-body mr-widget-empty-state">\n      <div class="row">\n        <div class="artwork col-sm-5 col-sm-push-7 col-xs-12 text-center">\n          <span v-html="emptyStateSVG"></span>\n        </div>\n        <div class="text col-sm-7 col-sm-pull-5 col-xs-12">\n          <span>\n            \u5408\u5E76\u8BF7\u6C42\u662F\u4E00\u4E2A\u53EF\u4EE5\u8BA9\u60A8\u63D0\u51FA\u5BF9\u9879\u76EE\u6240\u505A\u7684\u53D8\u66F4\uFF0C\n            \u5E76\u4E0E\u5176\u4ED6\u4EBA\u8BA8\u8BBA\u8FD9\u4E9B\u53D8\u66F4\u7684\u5730\u65B9\u3002\n          </span>\n          <p>\n            \u6709\u5174\u8DA3\u8005\u751A\u81F3\u53EF\u4EE5\u901A\u8FC7\u63A8\u9001\u63D0\u4EA4\u505A\u51FA\u8D21\u732E\u3002\n          </p>\n          <p>\n            \u6CA1\u6709\u4EC0\u4E48\u9700\u8981\u4ECE\u6E90\u5206\u652F\u5408\u5E76\u5230\u76EE\u6807\u5206\u652F\u3002\n            \u8BF7\u63A8\u9001\u65B0\u7684\u63D0\u4EA4\u6216\u8005\u9009\u62E9\u53E6\u4E00\u4E2A\u6E90\u5206\u652F\u3002\n          </p>\n          <div>\n            <a\n              v-if="mr.newBlobPath"\n              :href="mr.newBlobPath"\n              class="btn btn-inverted btn-save">\n              \u521B\u5EFA\u6587\u4EF6\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_missing_branch.vue






/* harmony default export */ var mr_widget_missing_branch = ({
  name: 'MRWidgetMissingBranch',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    mrWidgetMergeHelp: components_mr_widget_merge_help,
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  props: {
    mr: {
      type: Object,
      required: true
    }
  },
  computed: {
    missingBranchName: function missingBranchName() {
      return this.mr.sourceBranchRemoved ? 'source' : 'target';
    },
    missingBranchNameMessage: function missingBranchNameMessage() {
      return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('mrWidget| Please restore it or use a different %{missingBranchName} branch'), {
        missingBranchName: this.missingBranchName
      });
    },
    message: function message() {
      return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('mrWidget|If the %{missingBranchName} branch exists in your local repository, you can merge this merge request manually using the command line'), {
        missingBranchName: this.missingBranchName
      });
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b14d3ffe","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_missing_branch.vue
var mr_widget_missing_branch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"warning","show-disabled-button":true}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('span',{staticClass:"bold js-branch-text"},[_c('span',{staticClass:"capitalize"},[_vm._v("\n        "+_vm._s(_vm.missingBranchName)+"\n      ")]),_vm._v(" "+_vm._s(_vm.s__("mrWidget|branch does not exist."))+"\n      "+_vm._s(_vm.missingBranchNameMessage)+"\n      "),_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"fa fa-question-circle",attrs:{"title":_vm.message,"aria-label":_vm.message}})])])],1)}
var mr_widget_missing_branch_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_missing_branch.vue
/* script */


/* template */

/* template functional */
var mr_widget_missing_branch___vue_template_functional__ = false
/* styles */
var mr_widget_missing_branch___vue_styles__ = null
/* scopeId */
var mr_widget_missing_branch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_missing_branch___vue_module_identifier__ = null

var mr_widget_missing_branch_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_missing_branch,
  mr_widget_missing_branch_render,
  mr_widget_missing_branch_staticRenderFns,
  mr_widget_missing_branch___vue_template_functional__,
  mr_widget_missing_branch___vue_styles__,
  mr_widget_missing_branch___vue_scopeId__,
  mr_widget_missing_branch___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_missing_branch = (mr_widget_missing_branch_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_not_allowed.vue



/* harmony default export */ var mr_widget_not_allowed = ({
  name: 'MRWidgetNotAllowed',
  components: {
    StatusIcon: mr_widget_status_icon["a" /* default */]
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e831fe","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_not_allowed.vue
var mr_widget_not_allowed_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"success","show-disabled-button":true}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('span',{staticClass:"bold"},[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|Ready to be merged automatically.\nAsk someone with write access to this repository to merge this request"))+"\n      ")])])],1)}
var mr_widget_not_allowed_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_not_allowed.vue
/* script */


/* template */

/* template functional */
var mr_widget_not_allowed___vue_template_functional__ = false
/* styles */
var mr_widget_not_allowed___vue_styles__ = null
/* scopeId */
var mr_widget_not_allowed___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_not_allowed___vue_module_identifier__ = null

var mr_widget_not_allowed_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_not_allowed,
  mr_widget_not_allowed_render,
  mr_widget_not_allowed_staticRenderFns,
  mr_widget_not_allowed___vue_template_functional__,
  mr_widget_not_allowed___vue_styles__,
  mr_widget_not_allowed___vue_scopeId__,
  mr_widget_not_allowed___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_not_allowed = (mr_widget_not_allowed_Component.exports);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_status_success.svg
var _icon_status_success = __webpack_require__("../../views/shared/icons/_icon_status_success.svg");
var _icon_status_success_default = /*#__PURE__*/__webpack_require__.n(_icon_status_success);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_status_warning.svg
var _icon_status_warning = __webpack_require__("../../views/shared/icons/_icon_status_warning.svg");
var _icon_status_warning_default = /*#__PURE__*/__webpack_require__.n(_icon_status_warning);

// CONCATENATED MODULE: ./lib/utils/simple_poll.js
/* harmony default export */ var simple_poll = (function (fn) {
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60000;

  var startTime = Date.now();

  return new Promise(function (resolve, reject) {
    var stop = function stop(arg) {
      return arg instanceof Error ? reject(arg) : resolve(arg);
    };
    var next = function next() {
      if (Date.now() - startTime < timeout) {
        setTimeout(fn.bind(null, next, stop), interval);
      } else {
        reject(new Error('SIMPLE_POLL_TIMEOUT'));
      }
    };
    fn(next, stop);
  });
});
// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_ready_to_merge.js








/* harmony default export */ var mr_widget_ready_to_merge = ({
  name: 'MRWidgetReadyToMerge',
  props: {
    mr: { type: Object, required: true },
    service: { type: Object, required: true }
  },
  data: function data() {
    return {
      removeSourceBranch: this.mr.shouldRemoveSourceBranch,
      mergeWhenBuildSucceeds: false,
      useCommitMessageWithDescription: false,
      setToMergeWhenPipelineSucceeds: false,
      showCommitMessageEditor: false,
      isMakingRequest: false,
      isMergingImmediately: false,
      commitMessage: this.mr.commitMessage,
      successSvg: _icon_status_success_default.a,
      warningSvg: _icon_status_warning_default.a
    };
  },

  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  computed: {
    shouldShowMergeWhenPipelineSucceedsText: function shouldShowMergeWhenPipelineSucceedsText() {
      return this.mr.isPipelineActive;
    },
    commitMessageLinkTitle: function commitMessageLinkTitle() {
      var withDesc = 'Include description in commit message';
      var withoutDesc = "Don't include description in commit message";

      return this.useCommitMessageWithDescription ? withoutDesc : withDesc;
    },
    status: function status() {
      var _mr = this.mr,
          pipeline = _mr.pipeline,
          isPipelineActive = _mr.isPipelineActive,
          isPipelineFailed = _mr.isPipelineFailed,
          hasCI = _mr.hasCI,
          ciStatus = _mr.ciStatus;


      if (hasCI && !ciStatus) {
        return 'failed';
      } else if (!pipeline) {
        return 'success';
      } else if (isPipelineActive) {
        return 'pending';
      } else if (isPipelineFailed) {
        return 'failed';
      }

      return 'success';
    },
    mergeButtonClass: function mergeButtonClass() {
      var defaultClass = 'btn btn-sm btn-success accept-merge-request';
      var failedClass = defaultClass + ' btn-danger';
      var inActionClass = defaultClass + ' btn-info';

      if (this.status === 'failed') {
        return failedClass;
      } else if (this.status === 'pending') {
        return inActionClass;
      }

      return defaultClass;
    },
    iconClass: function iconClass() {
      if (this.status === 'failed' || !this.commitMessage.length || !this.mr.isMergeAllowed || this.mr.preventMerge) {
        return 'warning';
      }
      return 'success';
    },
    mergeButtonText: function mergeButtonText() {
      if (this.isMergingImmediately) {
        return '合并进行中';
      } else if (this.shouldShowMergeWhenPipelineSucceedsText) {
        return '当流水线成功后合并';
      }

      return '合并';
    },
    shouldShowMergeOptionsDropdown: function shouldShowMergeOptionsDropdown() {
      return this.mr.isPipelineActive && !this.mr.onlyAllowMergeIfPipelineSucceeds;
    },
    isMergeButtonDisabled: function isMergeButtonDisabled() {
      var commitMessage = this.commitMessage;

      return Boolean(!commitMessage.length || !this.shouldShowMergeControls() || this.isMakingRequest || this.mr.preventMerge);
    },
    isRemoveSourceBranchButtonDisabled: function isRemoveSourceBranchButtonDisabled() {
      return this.isMergeButtonDisabled || !this.mr.canRemoveSourceBranch;
    },
    shouldShowSquashBeforeMerge: function shouldShowSquashBeforeMerge() {
      var _mr2 = this.mr,
          commitsCount = _mr2.commitsCount,
          enableSquashBeforeMerge = _mr2.enableSquashBeforeMerge;

      return enableSquashBeforeMerge && commitsCount > 1;
    }
  },
  methods: {
    shouldShowMergeControls: function shouldShowMergeControls() {
      return this.mr.isMergeAllowed || this.shouldShowMergeWhenPipelineSucceedsText;
    },
    updateCommitMessage: function updateCommitMessage() {
      var cmwd = this.mr.commitMessageWithDescription;
      this.useCommitMessageWithDescription = !this.useCommitMessageWithDescription;
      this.commitMessage = this.useCommitMessageWithDescription ? cmwd : this.mr.commitMessage;
    },
    toggleCommitMessageEditor: function toggleCommitMessageEditor() {
      this.showCommitMessageEditor = !this.showCommitMessageEditor;
    },
    handleMergeButtonClick: function handleMergeButtonClick(mergeWhenBuildSucceeds, mergeImmediately) {
      var _this = this;

      // TODO: Remove no-param-reassign
      if (mergeWhenBuildSucceeds === undefined) {
        mergeWhenBuildSucceeds = this.mr.isPipelineActive; // eslint-disable-line no-param-reassign
      } else if (mergeImmediately) {
        this.isMergingImmediately = true;
      }

      this.setToMergeWhenPipelineSucceeds = mergeWhenBuildSucceeds === true;

      var options = {
        sha: this.mr.sha,
        commit_message: this.commitMessage,
        merge_when_pipeline_succeeds: this.setToMergeWhenPipelineSucceeds,
        should_remove_source_branch: this.removeSourceBranch === true
      };

      // Only truthy in EE extension of this component
      if (this.setAdditionalParams) {
        this.setAdditionalParams(options);
      }

      this.isMakingRequest = true;
      this.service.merge(options).then(function (res) {
        return res.data;
      }).then(function (data) {
        var hasError = data.status === 'failed' || data.status === 'hook_validation_error';

        if (data.status === 'merge_when_pipeline_succeeds') {
          event_hub["a" /* default */].$emit('MRWidgetUpdateRequested');
        } else if (data.status === 'success') {
          _this.initiateMergePolling();
        } else if (hasError) {
          event_hub["a" /* default */].$emit('FailedToMerge', data.merge_error);
        }
      }).catch(function () {
        _this.isMakingRequest = false;
        new flash["a" /* default */]('出现了错误。请重试。'); // eslint-disable-line
      });
    },
    initiateMergePolling: function initiateMergePolling() {
      var _this2 = this;

      simple_poll(function (continuePolling, stopPolling) {
        _this2.handleMergePolling(continuePolling, stopPolling);
      });
    },
    handleMergePolling: function handleMergePolling(continuePolling, stopPolling) {
      var _this3 = this;

      this.service.poll().then(function (res) {
        return res.data;
      }).then(function (data) {
        if (data.state === 'merged') {
          // If state is merged we should update the widget and stop the polling
          event_hub["a" /* default */].$emit('MRWidgetUpdateRequested');
          event_hub["a" /* default */].$emit('FetchActionsContent');
          merge_request["a" /* default */].setStatusBoxToMerged();
          merge_request["a" /* default */].hideCloseButton();
          merge_request["a" /* default */].decreaseCounter();
          stopPolling();

          // If user checked remove source branch and we didn't remove the branch yet
          // we should start another polling for source branch remove process
          if (_this3.removeSourceBranch && data.source_branch_exists) {
            _this3.initiateRemoveSourceBranchPolling();
          }
        } else if (data.merge_error) {
          event_hub["a" /* default */].$emit('FailedToMerge', data.merge_error);
          stopPolling();
        } else {
          // MR is not merged yet, continue polling until the state becomes 'merged'
          continuePolling();
        }
      }).catch(function () {
        new flash["a" /* default */]('合并出现了错误。请重试。'); // eslint-disable-line
      });
    },
    initiateRemoveSourceBranchPolling: function initiateRemoveSourceBranchPolling() {
      var _this4 = this;

      // We need to show source branch is being removed spinner in another component
      event_hub["a" /* default */].$emit('SetBranchRemoveFlag', [true]);

      simple_poll(function (continuePolling, stopPolling) {
        _this4.handleRemoveBranchPolling(continuePolling, stopPolling);
      });
    },
    handleRemoveBranchPolling: function handleRemoveBranchPolling(continuePolling, stopPolling) {
      this.service.poll().then(function (res) {
        return res.data;
      }).then(function (data) {
        // If source branch exists then we should continue polling
        // because removing a source branch is a background task and takes time
        if (data.source_branch_exists) {
          continuePolling();
        } else {
          // Branch is removed. Update widget, stop polling and hide the spinner
          event_hub["a" /* default */].$emit('MRWidgetUpdateRequested', function () {
            event_hub["a" /* default */].$emit('SetBranchRemoveFlag', [false]);
          });
          stopPolling();
        }
      }).catch(function () {
        new flash["a" /* default */]('删除源分支出现了错误，请重试。'); // eslint-disable-line
      });
    }
  },
  template: '\n    <div class="mr-widget-body media">\n      <status-icon :status="iconClass" />\n      <div class="media-body">\n        <div class="mr-widget-body-controls media space-children">\n          <span class="btn-group append-bottom-5">\n            <button\n              @click="handleMergeButtonClick()"\n              :disabled="isMergeButtonDisabled"\n              :class="mergeButtonClass"\n              type="button"\n              class="qa-merge-button">\n              <i\n                v-if="isMakingRequest"\n                class="fa fa-spinner fa-spin"\n                aria-hidden="true" />\n              {{mergeButtonText}}\n            </button>\n            <button\n              v-if="shouldShowMergeOptionsDropdown"\n              :disabled="isMergeButtonDisabled"\n              type="button"\n              class="btn btn-sm btn-info dropdown-toggle js-merge-moment"\n              data-toggle="dropdown"\n              aria-label="\u9009\u62E9\u5408\u5E76\u65F6\u523B">\n              <i\n                class="fa fa-chevron-down"\n                aria-hidden="true" />\n            </button>\n            <ul\n              v-if="shouldShowMergeOptionsDropdown"\n              class="dropdown-menu dropdown-menu-right"\n              role="menu">\n              <li>\n                <a\n                  @click.prevent="handleMergeButtonClick(true)"\n                  class="merge_when_pipeline_succeeds"\n                  href="#">\n                  <span class="media">\n                    <span\n                      v-html="successSvg"\n                      class="merge-opt-icon"\n                      aria-hidden="true"></span>\n                    <span class="media-body merge-opt-title">\u5F53\u6D41\u6C34\u7EBF\u6210\u529F\u65F6\u5408\u5E76</span>\n                  </span>\n                </a>\n              </li>\n              <li>\n                <a\n                  @click.prevent="handleMergeButtonClick(false, true)"\n                  class="accept-merge-request"\n                  href="#">\n                  <span class="media">\n                    <span\n                      v-html="warningSvg"\n                      class="merge-opt-icon"\n                      aria-hidden="true"></span>\n                    <span class="media-body merge-opt-title">\u7ACB\u523B\u5408\u5E76</span>\n                  </span>\n                </a>\n              </li>\n            </ul>\n          </span>\n          <div class="media-body-wrap space-children">\n            <template v-if="shouldShowMergeControls()">\n              <label>\n                <input\n                  id="remove-source-branch-input"\n                  v-model="removeSourceBranch"\n                  class="js-remove-source-branch-checkbox"\n                  :disabled="isRemoveSourceBranchButtonDisabled"\n                  type="checkbox"/> \u5220\u9664\u6E90\u5206\u652F\n              </label>\n\n              <!-- Placeholder for EE extension of this component -->\n              <squash-before-merge\n                v-if="shouldShowSquashBeforeMerge"\n                :mr="mr"\n                :is-merge-button-disabled="isMergeButtonDisabled" />\n\n              <span\n                v-if="mr.ffOnlyEnabled"\n                class="js-fast-forward-message">\n                \u65E0\u5408\u5E76\u63D0\u4EA4\u7684\u5FEB\u8FDB\u5F0F\u5408\u5E76\n              </span>\n              <button\n                v-else\n                @click="toggleCommitMessageEditor"\n                :disabled="isMergeButtonDisabled"\n                class="js-modify-commit-message-button btn btn-default btn-xs"\n                type="button">\n                \u4FEE\u6539\u63D0\u4EA4\u4FE1\u606F\n              </button>\n            </template>\n            <template v-else>\n              <span class="bold js-resolve-mr-widget-items-message">\n                \u60A8\u53EA\u80FD\u5728\u4EE5\u4E0A\u51B2\u7A81\u90FD\u89E3\u51B3\u540E\u624D\u80FD\u5408\u5E76\n              </span>\n            </template>\n          </div>\n        </div>\n        <div\n          v-if="showCommitMessageEditor"\n          class="prepend-top-default commit-message-editor">\n          <div class="form-group clearfix">\n            <label\n              class="control-label"\n              for="commit-message">\n              \u63D0\u4EA4\u4FE1\u606F\n            </label>\n            <div class="col-sm-10">\n              <div class="commit-message-container">\n                <div class="max-width-marker"></div>\n                <textarea\n                  v-model="commitMessage"\n                  class="form-control js-commit-message"\n                  required="required"\n                  rows="14"\n                  name="\u63D0\u4EA4\u4FE1\u606F"></textarea>\n              </div>\n              <p class="hint">\u5C1D\u8BD5\u4FDD\u6301\u7B2C\u4E00\u884C\u4E0D\u8D85\u8FC752\u4E2A\u5B57\u7B26\uFF0C\u5176\u5B83\u884C\u4E0D\u8D85\u8FC772\u4E2A\u5B57\u7B26\u3002</p>\n              <div class="hint">\n                <a\n                  @click.prevent="updateCommitMessage"\n                  href="#">{{commitMessageLinkTitle}}</a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_sha_mismatch.js


/* harmony default export */ var mr_widget_sha_mismatch = ({
  name: 'MRWidgetSHAMismatch',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  template: '\n    <div class="mr-widget-body media">\n      <status-icon status="warning" :show-disabled-button="true" />\n      <div class="media-body space-children">\n        <span class="bold">\n          \u6E90\u5206\u652F\u7684 HEAD \u5728\u6700\u8FD1\u53D1\u751F\u4E86\u53D8\u66F4\u3002 \u8BF7\u91CD\u65B0\u52A0\u8F7D\u9875\u9762\uFF0C\u5E76\u5728\u5408\u5E76\u4E4B\u524D\u67E5\u770B\u66F4\u6539\u3002\n        </span>\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_unresolved_discussions.js


/* harmony default export */ var mr_widget_unresolved_discussions = ({
  name: 'MRWidgetUnresolvedDiscussions',
  props: {
    mr: { type: Object, required: true }
  },
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  template: '\n    <div class="mr-widget-body media">\n      <status-icon status="warning" :show-disabled-button="true" />\n      <div class="media-body space-children">\n        <span class="bold">\n          \u8FD8\u6709\u672A\u89E3\u51B3\u7684\u8BA8\u8BBA\u3002\u8BF7\u89E3\u51B3\u8FD9\u4E9B\u8BA8\u8BBA\n        </span>\n        <a\n          v-if="mr.createIssueToResolveDiscussionsPath"\n          :href="mr.createIssueToResolveDiscussionsPath"\n          class="btn btn-default btn-xs js-create-issue">\n          \u521B\u5EFA\u4E00\u4E2A\u95EE\u9898\uFF0C\u4EE5\u4FBF\u4EE5\u540E\u89E3\u51B3\n        </a>\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_pipeline_blocked.vue



/* harmony default export */ var mr_widget_pipeline_blocked = ({
  name: 'MRWidgetPipelineBlocked',
  components: {
    StatusIcon: mr_widget_status_icon["a" /* default */]
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-859ea36c","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_pipeline_blocked.vue
var mr_widget_pipeline_blocked_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"warning","show-disabled-button":true}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('span',{staticClass:"bold"},[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|Pipeline blocked.\nThe pipeline for this merge request requires a manual action to proceed"))+"\n      ")])])],1)}
var mr_widget_pipeline_blocked_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_pipeline_blocked.vue
/* script */


/* template */

/* template functional */
var mr_widget_pipeline_blocked___vue_template_functional__ = false
/* styles */
var mr_widget_pipeline_blocked___vue_styles__ = null
/* scopeId */
var mr_widget_pipeline_blocked___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_pipeline_blocked___vue_module_identifier__ = null

var mr_widget_pipeline_blocked_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_pipeline_blocked,
  mr_widget_pipeline_blocked_render,
  mr_widget_pipeline_blocked_staticRenderFns,
  mr_widget_pipeline_blocked___vue_template_functional__,
  mr_widget_pipeline_blocked___vue_styles__,
  mr_widget_pipeline_blocked___vue_scopeId__,
  mr_widget_pipeline_blocked___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_pipeline_blocked = (mr_widget_pipeline_blocked_Component.exports);

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_pipeline_failed.js


/* harmony default export */ var mr_widget_pipeline_failed = ({
  name: 'MRWidgetPipelineBlocked',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  template: '\n    <div class="mr-widget-body media">\n      <status-icon status="warning" :show-disabled-button="true" />\n      <div class="media-body space-children">\n        <span class="bold">\n          \u6B64\u5408\u5E76\u8BF7\u6C42\u7684\u6D41\u6C34\u7EBF\u5DF2\u5931\u8D25\u3002 \u8BF7\u91CD\u8BD5\u8BE5\u4F5C\u4E1A\u6216\u63A8\u9001\u4E00\u4E2A\u65B0\u7684\u63D0\u4EA4\u6765\u4FEE\u590D\u5931\u8D25\u3002\n        </span>\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_merge_when_pipeline_succeeds.vue






/* harmony default export */ var mr_widget_merge_when_pipeline_succeeds = ({
  name: 'MRWidgetMergeWhenPipelineSucceeds',
  components: {
    mrWidgetAuthor: components_mr_widget_author,
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  props: {
    mr: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    service: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isCancellingAutoMerge: false,
      isRemovingSourceBranch: false
    };
  },

  computed: {
    canRemoveSourceBranch: function canRemoveSourceBranch() {
      var _mr = this.mr,
          shouldRemoveSourceBranch = _mr.shouldRemoveSourceBranch,
          canRemoveSourceBranch = _mr.canRemoveSourceBranch,
          mergeUserId = _mr.mergeUserId,
          currentUserId = _mr.currentUserId;


      return !shouldRemoveSourceBranch && canRemoveSourceBranch && mergeUserId === currentUserId;
    }
  },
  methods: {
    cancelAutomaticMerge: function cancelAutomaticMerge() {
      var _this = this;

      this.isCancellingAutoMerge = true;
      this.service.cancelAutomaticMerge().then(function (res) {
        return res.data;
      }).then(function (data) {
        event_hub["a" /* default */].$emit('UpdateWidgetData', data);
      }).catch(function () {
        _this.isCancellingAutoMerge = false;
        Object(flash["a" /* default */])('Something went wrong. Please try again.');
      });
    },
    removeSourceBranch: function removeSourceBranch() {
      var _this2 = this;

      var options = {
        sha: this.mr.sha,
        merge_when_pipeline_succeeds: true,
        should_remove_source_branch: true
      };

      this.isRemovingSourceBranch = true;
      this.service.merge(options).then(function (res) {
        return res.data;
      }).then(function (data) {
        if (data.status === 'merge_when_pipeline_succeeds') {
          event_hub["a" /* default */].$emit('MRWidgetUpdateRequested');
        }
      }).catch(function () {
        _this2.isRemovingSourceBranch = false;
        Object(flash["a" /* default */])('Something went wrong. Please try again.');
      });
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-944d95f8","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_merge_when_pipeline_succeeds.vue
var mr_widget_merge_when_pipeline_succeeds_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"success"}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h4',{staticClass:"flex-container-block"},[_c('span',{staticClass:"append-right-10"},[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|Set by"))+"\n        "),_c('mr-widget-author',{attrs:{"author":_vm.mr.setToMWPSBy}}),_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|to be merged automatically when the pipeline succeeds"))+"\n      ")],1),_vm._v(" "),(_vm.mr.canCancelAutomaticMerge)?_c('a',{staticClass:"btn btn-xs btn-default js-cancel-auto-merge",attrs:{"disabled":_vm.isCancellingAutoMerge,"role":"button","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.cancelAutomaticMerge($event)}}},[(_vm.isCancellingAutoMerge)?_c('i',{staticClass:"fa fa-spinner fa-spin",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|Cancel automatic merge"))+"\n      ")]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"mr-info-list"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|The changes will be merged into"))+"\n        "),_c('a',{staticClass:"label-branch",attrs:{"href":_vm.mr.targetBranchPath}},[_vm._v("\n          "+_vm._s(_vm.mr.targetBranch)+"\n        ")])]),_vm._v(" "),(_vm.mr.shouldRemoveSourceBranch)?_c('p',[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|The source branch will be removed"))+"\n      ")]):_c('p',{staticClass:"flex-container-block"},[_c('span',{staticClass:"append-right-10"},[_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|The source branch will not be removed"))+"\n        ")]),_vm._v(" "),(_vm.canRemoveSourceBranch)?_c('a',{staticClass:"btn btn-xs btn-default js-remove-source-branch",attrs:{"disabled":_vm.isRemovingSourceBranch,"role":"button","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeSourceBranch($event)}}},[(_vm.isRemovingSourceBranch)?_c('i',{staticClass:"fa fa-spinner fa-spin",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|Remove source branch"))+"\n        ")]):_vm._e()])])])],1)}
var mr_widget_merge_when_pipeline_succeeds_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_merge_when_pipeline_succeeds.vue
/* script */


/* template */

/* template functional */
var mr_widget_merge_when_pipeline_succeeds___vue_template_functional__ = false
/* styles */
var mr_widget_merge_when_pipeline_succeeds___vue_styles__ = null
/* scopeId */
var mr_widget_merge_when_pipeline_succeeds___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_merge_when_pipeline_succeeds___vue_module_identifier__ = null

var mr_widget_merge_when_pipeline_succeeds_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_merge_when_pipeline_succeeds,
  mr_widget_merge_when_pipeline_succeeds_render,
  mr_widget_merge_when_pipeline_succeeds_staticRenderFns,
  mr_widget_merge_when_pipeline_succeeds___vue_template_functional__,
  mr_widget_merge_when_pipeline_succeeds___vue_styles__,
  mr_widget_merge_when_pipeline_succeeds___vue_scopeId__,
  mr_widget_merge_when_pipeline_succeeds___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_merge_when_pipeline_succeeds = (mr_widget_merge_when_pipeline_succeeds_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_rebase.vue







/* harmony default export */ var mr_widget_rebase = ({
  name: 'MRWidgetRebase',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */],
    loadingIcon: loading_icon["a" /* default */]
  },
  props: {
    mr: {
      type: Object,
      required: true
    },
    service: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isMakingRequest: false,
      rebasingError: null
    };
  },

  computed: {
    status: function status() {
      if (this.mr.rebaseInProgress || this.isMakingRequest) {
        return 'loading';
      }
      if (!this.mr.canPushToSourceBranch && !this.mr.rebaseInProgress) {
        return 'warning';
      }
      return 'success';
    },
    showDisabledButton: function showDisabledButton() {
      return ['failed', 'loading'].includes(this.status);
    }
  },
  methods: {
    rebase: function rebase() {
      var _this = this;

      this.isMakingRequest = true;
      this.rebasingError = null;

      this.service.rebase().then(function () {
        simple_poll(_this.checkRebaseStatus);
      }).catch(function (error) {
        _this.rebasingError = error.merge_error;
        _this.isMakingRequest = false;
        Object(flash["a" /* default */])('Something went wrong. Please try again.');
      });
    },
    checkRebaseStatus: function checkRebaseStatus(continuePolling, stopPolling) {
      var _this2 = this;

      this.service.poll().then(function (res) {
        return res.data;
      }).then(function (res) {
        if (res.rebase_in_progress) {
          continuePolling();
        } else {
          _this2.isMakingRequest = false;

          if (res.merge_error && res.merge_error.length) {
            _this2.rebasingError = res.merge_error;
            Object(flash["a" /* default */])('Something went wrong. Please try again.');
          }

          event_hub["a" /* default */].$emit('MRWidgetUpdateRequested');
          stopPolling();
        }
      }).catch(function () {
        _this2.isMakingRequest = false;
        Object(flash["a" /* default */])('Something went wrong. Please try again.');
        stopPolling();
      });
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e3e33a","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_rebase.vue
var mr_widget_rebase_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":_vm.status,"show-disabled-button":_vm.showDisabledButton}}),_vm._v(" "),_c('div',{staticClass:"rebase-state-find-class-convention media media-body space-children"},[(_vm.mr.rebaseInProgress || _vm.isMakingRequest)?[_c('span',{staticClass:"bold"},[_vm._v("\n          Rebase in progress\n        ")])]:_vm._e(),_vm._v(" "),(!_vm.mr.rebaseInProgress && !_vm.mr.canPushToSourceBranch)?[_c('span',{staticClass:"bold"},[_vm._v("\n          Fast-forward merge is not possible.\n          Rebase the source branch onto\n          "),_c('span',{staticClass:"label-branch"},[_vm._v(_vm._s(_vm.mr.targetBranch))]),_vm._v("\n          to allow this merge request to be merged.\n        ")])]:_vm._e(),_vm._v(" "),(!_vm.mr.rebaseInProgress && _vm.mr.canPushToSourceBranch && !_vm.isMakingRequest)?[_c('div',{staticClass:"accept-merge-holder clearfix\njs-toggle-container accept-action media space-children"},[_c('button',{staticClass:"btn btn-sm btn-reopen btn-success qa-mr-rebase-button",attrs:{"type":"button","disabled":_vm.isMakingRequest},on:{"click":_vm.rebase}},[(_vm.isMakingRequest)?_c('loading-icon'):_vm._e(),_vm._v("\n            Rebase\n          ")],1),_vm._v(" "),(!_vm.rebasingError)?_c('span',{staticClass:"bold"},[_vm._v("\n            Fast-forward merge is not possible.\n            Rebase the source branch onto the target branch or merge target\n            branch into source branch to allow this merge request to be merged.\n          ")]):_c('span',{staticClass:"bold danger"},[_vm._v("\n            "+_vm._s(_vm.rebasingError)+"\n          ")])])]:_vm._e()],2)],1)}
var mr_widget_rebase_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_rebase.vue
/* script */


/* template */

/* template functional */
var mr_widget_rebase___vue_template_functional__ = false
/* styles */
var mr_widget_rebase___vue_styles__ = null
/* scopeId */
var mr_widget_rebase___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_rebase___vue_module_identifier__ = null

var mr_widget_rebase_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_rebase,
  mr_widget_rebase_render,
  mr_widget_rebase_staticRenderFns,
  mr_widget_rebase___vue_template_functional__,
  mr_widget_rebase___vue_styles__,
  mr_widget_rebase___vue_scopeId__,
  mr_widget_rebase___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_rebase = (mr_widget_rebase_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_auto_merge_failed.vue





/* harmony default export */ var mr_widget_auto_merge_failed = ({
  name: 'MRWidgetAutoMergeFailed',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */],
    loadingIcon: loading_icon["a" /* default */]
  },
  props: {
    mr: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isRefreshing: false
    };
  },

  methods: {
    refreshWidget: function refreshWidget() {
      var _this = this;

      this.isRefreshing = true;
      event_hub["a" /* default */].$emit('MRWidgetUpdateRequested', function () {
        _this.isRefreshing = false;
      });
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-122e13b6","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_auto_merge_failed.vue
var mr_widget_auto_merge_failed_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"warning"}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('span',{staticClass:"bold"},[(_vm.mr.mergeError)?[_vm._v(_vm._s(_vm.mr.mergeError)+".")]:_vm._e(),_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|This merge request failed to be merged automatically"))+"\n    ")],2),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-default",attrs:{"disabled":_vm.isRefreshing,"type":"button"},on:{"click":_vm.refreshWidget}},[(_vm.isRefreshing)?_c('loading-icon',{attrs:{"inline":true}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|Refresh"))+"\n    ")],1)])],1)}
var mr_widget_auto_merge_failed_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_auto_merge_failed.vue
/* script */


/* template */

/* template functional */
var mr_widget_auto_merge_failed___vue_template_functional__ = false
/* styles */
var mr_widget_auto_merge_failed___vue_styles__ = null
/* scopeId */
var mr_widget_auto_merge_failed___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_auto_merge_failed___vue_module_identifier__ = null

var mr_widget_auto_merge_failed_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_auto_merge_failed,
  mr_widget_auto_merge_failed_render,
  mr_widget_auto_merge_failed_staticRenderFns,
  mr_widget_auto_merge_failed___vue_template_functional__,
  mr_widget_auto_merge_failed___vue_styles__,
  mr_widget_auto_merge_failed___vue_scopeId__,
  mr_widget_auto_merge_failed___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_auto_merge_failed = (mr_widget_auto_merge_failed_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_checking.vue



/* harmony default export */ var mr_widget_checking = ({
  name: 'MRWidgetChecking',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56dde2de","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_checking.vue
var mr_widget_checking_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"loading","show-disabled-button":true}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('span',{staticClass:"bold"},[_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|Checking ability to merge automatically"))+"\n    ")])])],1)}
var mr_widget_checking_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_checking.vue
/* script */


/* template */

/* template functional */
var mr_widget_checking___vue_template_functional__ = false
/* styles */
var mr_widget_checking___vue_styles__ = null
/* scopeId */
var mr_widget_checking___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_checking___vue_module_identifier__ = null

var mr_widget_checking_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_checking,
  mr_widget_checking_render,
  mr_widget_checking_staticRenderFns,
  mr_widget_checking___vue_template_functional__,
  mr_widget_checking___vue_styles__,
  mr_widget_checking___vue_scopeId__,
  mr_widget_checking___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_checking = (mr_widget_checking_Component.exports);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/timeago.js/dist/timeago.min.js
var timeago_min = __webpack_require__("../../../node_modules/timeago.js/dist/timeago.min.js");
var timeago_min_default = /*#__PURE__*/__webpack_require__.n(timeago_min);

// CONCATENATED MODULE: ./vue_merge_request_widget/stores/state_maps.js
var stateToComponentMap = {
  merged: 'mr-widget-merged',
  closed: 'mr-widget-closed',
  merging: 'mr-widget-merging',
  conflicts: 'mr-widget-conflicts',
  missingBranch: 'mr-widget-missing-branch',
  workInProgress: 'mr-widget-wip',
  readyToMerge: 'mr-widget-ready-to-merge',
  nothingToMerge: 'mr-widget-nothing-to-merge',
  notAllowedToMerge: 'mr-widget-not-allowed',
  archived: 'mr-widget-archived',
  checking: 'mr-widget-checking',
  unresolvedDiscussions: 'mr-widget-unresolved-discussions',
  pipelineBlocked: 'mr-widget-pipeline-blocked',
  pipelineFailed: 'mr-widget-pipeline-failed',
  mergeWhenPipelineSucceeds: 'mr-widget-merge-when-pipeline-succeeds',
  failedToMerge: 'mr-widget-failed-to-merge',
  autoMergeFailed: 'mr-widget-auto-merge-failed',
  shaMismatch: 'mr-widget-sha-mismatch',
  rebase: 'mr-widget-rebase'
};

var statesToShowHelpWidget = ['merging', 'conflicts', 'workInProgress', 'readyToMerge', 'checking', 'unresolvedDiscussions', 'pipelineFailed', 'pipelineBlocked', 'autoMergeFailed', 'rebase'];

var stateKey = {
  archived: 'archived',
  missingBranch: 'missingBranch',
  nothingToMerge: 'nothingToMerge',
  checking: 'checking',
  conflicts: 'conflicts',
  workInProgress: 'workInProgress',
  pipelineFailed: 'pipelineFailed',
  unresolvedDiscussions: 'unresolvedDiscussions',
  pipelineBlocked: 'pipelineBlocked',
  shaMismatch: 'shaMismatch',
  autoMergeFailed: 'autoMergeFailed',
  mergeWhenPipelineSucceeds: 'mergeWhenPipelineSucceeds',
  notAllowedToMerge: 'notAllowedToMerge',
  readyToMerge: 'readyToMerge',
  rebase: 'rebase'
};

/* harmony default export */ var state_maps = ({
  stateToComponentMap: stateToComponentMap,
  statesToShowHelpWidget: statesToShowHelpWidget
});
// CONCATENATED MODULE: ./vue_merge_request_widget/stores/mr_widget_store.js
var mr_widget_store__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function mr_widget_store__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var mr_widget_store_MergeRequestStore = function () {
  function MergeRequestStore(data) {
    mr_widget_store__classCallCheck(this, MergeRequestStore);

    this.sha = data.diff_head_sha;
    this.gitlabLogo = data.gitlabLogo;

    this.setData(data);
  }

  mr_widget_store__createClass(MergeRequestStore, [{
    key: 'setData',
    value: function setData(data) {
      var currentUser = data.current_user;
      var pipelineStatus = data.pipeline ? data.pipeline.details.status : null;

      this.title = data.title;
      this.targetBranch = data.target_branch;
      this.sourceBranch = data.source_branch;
      this.mergeStatus = data.merge_status;
      this.commitMessage = data.merge_commit_message;
      this.commitMessageWithDescription = data.merge_commit_message_with_description;
      this.commitsCount = data.commits_count;
      this.divergedCommitsCount = data.diverged_commits_count;
      this.pipeline = data.pipeline || {};
      this.deployments = this.deployments || data.deployments || [];
      this.initRebase(data);

      if (data.issues_links) {
        var links = data.issues_links;
        var closing = links.closing;

        var mentioned = links.mentioned_but_not_closing;
        var assignToMe = links.assign_to_closing;

        if (closing || mentioned || assignToMe) {
          this.relatedLinks = { closing: closing, mentioned: mentioned, assignToMe: assignToMe };
        }
      }

      this.updatedAt = data.updated_at;
      this.metrics = MergeRequestStore.buildMetrics(data.metrics);
      this.setToMWPSBy = MergeRequestStore.formatUserObject(data.merge_user || {});
      this.mergeUserId = data.merge_user_id;
      this.currentUserId = gon.current_user_id;
      this.sourceBranchPath = data.source_branch_path;
      this.sourceBranchLink = data.source_branch_with_namespace_link;
      this.mergeError = data.merge_error;
      this.targetBranchPath = data.target_branch_commits_path;
      this.targetBranchTreePath = data.target_branch_tree_path;
      this.conflictResolutionPath = data.conflict_resolution_path;
      this.cancelAutoMergePath = data.cancel_merge_when_pipeline_succeeds_path;
      this.removeWIPPath = data.remove_wip_path;
      this.sourceBranchRemoved = !data.source_branch_exists;
      this.shouldRemoveSourceBranch = data.remove_source_branch || false;
      this.onlyAllowMergeIfPipelineSucceeds = data.only_allow_merge_if_pipeline_succeeds || false;
      this.mergeWhenPipelineSucceeds = data.merge_when_pipeline_succeeds || false;
      this.mergePath = data.merge_path;
      this.ffOnlyEnabled = data.ff_only_enabled;
      this.shouldBeRebased = !!data.should_be_rebased;
      this.statusPath = data.status_path;
      this.emailPatchesPath = data.email_patches_path;
      this.plainDiffPath = data.plain_diff_path;
      this.newBlobPath = data.new_blob_path;
      this.createIssueToResolveDiscussionsPath = data.create_issue_to_resolve_discussions_path;
      this.mergeCheckPath = data.merge_check_path;
      this.mergeActionsContentPath = data.commit_change_content_path;
      this.isRemovingSourceBranch = this.isRemovingSourceBranch || false;
      this.isOpen = data.state === 'opened';
      this.hasMergeableDiscussionsState = data.mergeable_discussions_state === false;
      this.canRemoveSourceBranch = currentUser.can_remove_source_branch || false;
      this.canMerge = !!data.merge_path;
      this.canCreateIssue = currentUser.can_create_issue || false;
      this.canCancelAutomaticMerge = !!data.cancel_merge_when_pipeline_succeeds_path;
      this.hasSHAChanged = this.sha !== data.diff_head_sha;
      this.canBeMerged = data.can_be_merged || false;
      this.isMergeAllowed = data.mergeable || false;
      this.mergeOngoing = data.merge_ongoing;
      this.maintainerEditAllowed = data.allow_maintainer_to_push;

      // Cherry-pick and Revert actions related
      this.canCherryPickInCurrentMR = currentUser.can_cherry_pick_on_current_merge_request || false;
      this.canRevertInCurrentMR = currentUser.can_revert_on_current_merge_request || false;
      this.cherryPickInForkPath = currentUser.cherry_pick_in_fork_path;
      this.revertInForkPath = currentUser.revert_in_fork_path;

      // CI related
      this.ciEnvironmentsStatusPath = data.ci_environments_status_path;
      this.hasCI = data.has_ci;
      this.ciStatus = data.ci_status;
      this.isPipelineFailed = this.ciStatus === 'failed' || this.ciStatus === 'canceled';
      this.isPipelinePassing = this.ciStatus === 'success' || this.ciStatus === 'success_with_warnings';
      this.isPipelineSkipped = this.ciStatus === 'skipped';
      this.pipelineDetailedStatus = pipelineStatus;
      this.isPipelineActive = data.pipeline ? data.pipeline.active : false;
      this.isPipelineBlocked = pipelineStatus ? pipelineStatus.group === 'manual' : false;
      this.ciStatusFaviconPath = pipelineStatus ? pipelineStatus.favicon : null;

      this.setState(data);
    }
  }, {
    key: 'setState',
    value: function setState(data) {
      if (this.mergeOngoing) {
        this.state = 'merging';
        return;
      }

      if (this.isOpen) {
        this.state = deviseState.call(this, data);
      } else {
        switch (data.state) {
          case 'merged':
            this.state = 'merged';
            break;
          case 'closed':
            this.state = 'closed';
            break;
          default:
            this.state = null;
        }
      }
    }
  }, {
    key: 'initRebase',
    value: function initRebase(data) {
      this.canPushToSourceBranch = data.can_push_to_source_branch;
      this.rebaseInProgress = data.rebase_in_progress;
      this.approvalsLeft = !data.approved;
      this.rebasePath = data.rebase_path;
    }
  }, {
    key: 'isNothingToMergeState',
    get: function get() {
      return this.state === stateKey.nothingToMerge;
    }
  }], [{
    key: 'buildMetrics',
    value: function buildMetrics(metrics) {
      if (!metrics) {
        return {};
      }

      return {
        mergedBy: MergeRequestStore.formatUserObject(metrics.merged_by),
        closedBy: MergeRequestStore.formatUserObject(metrics.closed_by),
        mergedAt: Object(datetime_utility["a" /* formatDate */])(metrics.merged_at),
        closedAt: Object(datetime_utility["a" /* formatDate */])(metrics.closed_at),
        readableMergedAt: MergeRequestStore.getReadableDate(metrics.merged_at),
        readableClosedAt: MergeRequestStore.getReadableDate(metrics.closed_at)
      };
    }
  }, {
    key: 'formatUserObject',
    value: function formatUserObject(user) {
      if (!user) {
        return {};
      }

      return {
        name: user.name || '',
        username: user.username || '',
        webUrl: user.web_url || '',
        avatarUrl: user.avatar_url || ''
      };
    }
  }, {
    key: 'getReadableDate',
    value: function getReadableDate(date) {
      if (!date) {
        return '';
      }

      var timeagoInstance = new timeago_min_default.a();

      return timeagoInstance.format(date);
    }
  }]);

  return MergeRequestStore;
}();

/* harmony default export */ var mr_widget_store = (mr_widget_store_MergeRequestStore);
// CONCATENATED MODULE: ./vue_merge_request_widget/stores/get_state_key.js


function deviseState(data) {
  if (data.project_archived) {
    return stateKey.archived;
  } else if (data.branch_missing) {
    return stateKey.missingBranch;
  } else if (!data.commits_count) {
    return stateKey.nothingToMerge;
  } else if (this.mergeStatus === 'unchecked') {
    return stateKey.checking;
  } else if (data.has_conflicts) {
    return stateKey.conflicts;
  } else if (data.work_in_progress) {
    return stateKey.workInProgress;
  } else if (this.onlyAllowMergeIfPipelineSucceeds && this.isPipelineFailed) {
    return stateKey.pipelineFailed;
  } else if (this.hasMergeableDiscussionsState) {
    return stateKey.unresolvedDiscussions;
  } else if (this.isPipelineBlocked) {
    return stateKey.pipelineBlocked;
  } else if (this.hasSHAChanged) {
    return stateKey.shaMismatch;
  } else if (this.mergeWhenPipelineSucceeds) {
    return this.mergeError ? stateKey.autoMergeFailed : stateKey.mergeWhenPipelineSucceeds;
  } else if (!this.canMerge) {
    return stateKey.notAllowedToMerge;
  } else if (this.shouldBeRebased) {
    return stateKey.rebase;
  } else if (this.canBeMerged) {
    return stateKey.readyToMerge;
  }
  return null;
}
// EXTERNAL MODULE: ./pages/projects/project.js
var project = __webpack_require__("./pages/projects/project.js");

// CONCATENATED MODULE: ./vue_merge_request_widget/mr_widget_options.js






/* harmony default export */ var mr_widget_options = ({
  el: '#js-vue-mr-widget',
  name: 'MRWidget',
  props: {
    mrData: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    var store = new mr_widget_store(this.mrData || window.gl.mrWidgetData);
    var service = this.createService(store);
    return {
      mr: store,
      service: service
    };
  },

  computed: {
    componentName: function componentName() {
      return state_maps.stateToComponentMap[this.mr.state];
    },
    shouldRenderMergeHelp: function shouldRenderMergeHelp() {
      return state_maps.statesToShowHelpWidget.indexOf(this.mr.state) > -1;
    },
    shouldRenderPipelines: function shouldRenderPipelines() {
      return this.mr.hasCI;
    },
    shouldRenderRelatedLinks: function shouldRenderRelatedLinks() {
      return !!this.mr.relatedLinks && !this.mr.isNothingToMergeState;
    },
    shouldRenderDeployments: function shouldRenderDeployments() {
      return this.mr.deployments.length;
    }
  },
  methods: {
    createService: function createService(store) {
      var endpoints = {
        mergePath: store.mergePath,
        mergeCheckPath: store.mergeCheckPath,
        cancelAutoMergePath: store.cancelAutoMergePath,
        removeWIPPath: store.removeWIPPath,
        sourceBranchPath: store.sourceBranchPath,
        ciEnvironmentsStatusPath: store.ciEnvironmentsStatusPath,
        statusPath: store.statusPath,
        mergeActionsContentPath: store.mergeActionsContentPath,
        rebasePath: store.rebasePath
      };
      return new mr_widget_service(endpoints);
    },
    checkStatus: function checkStatus(cb) {
      var _this = this;

      return this.service.checkStatus().then(function (res) {
        return res.data;
      }).then(function (data) {
        _this.handleNotification(data);
        _this.mr.setData(data);
        _this.setFaviconHelper();

        if (cb) {
          cb.call(null, data);
        }
      }).catch(function () {
        return new flash["a" /* default */]('Something went wrong. Please try again.');
      });
    },
    initPolling: function initPolling() {
      this.pollingInterval = new smart_interval["a" /* default */]({
        callback: this.checkStatus,
        startingInterval: 10000,
        maxInterval: 30000,
        hiddenInterval: 120000,
        incrementByFactorOf: 5000
      });
    },
    initDeploymentsPolling: function initDeploymentsPolling() {
      this.deploymentsInterval = new smart_interval["a" /* default */]({
        callback: this.fetchDeployments,
        startingInterval: 30000,
        maxInterval: 120000,
        hiddenInterval: 240000,
        incrementByFactorOf: 15000,
        immediateExecution: true
      });
    },
    setFaviconHelper: function setFaviconHelper() {
      if (this.mr.ciStatusFaviconPath) {
        Object(common_utils["F" /* setFavicon */])(this.mr.ciStatusFaviconPath);
      }
    },
    fetchDeployments: function fetchDeployments() {
      var _this2 = this;

      return this.service.fetchDeployments().then(function (res) {
        return res.data;
      }).then(function (data) {
        if (data.length) {
          _this2.mr.deployments = data;
        }
      }).catch(function () {
        new flash["a" /* default */]('获取这个合并请求的运行环境出现了错误，请重试。'); // eslint-disable-line
      });
    },
    fetchActionsContent: function fetchActionsContent() {
      this.service.fetchMergeActionsContent().then(function (res) {
        if (res.data) {
          var el = document.createElement('div');
          el.innerHTML = res.data;
          document.body.appendChild(el);
          project["a" /* default */].initRefSwitcher();
        }
      }).catch(function () {
        return new flash["a" /* default */]('出现了错误，请重试。');
      });
    },
    handleNotification: function handleNotification(data) {
      if (data.ci_status === this.mr.ciStatus) return;
      if (!data.pipeline) return;

      var label = data.pipeline.details.status.label;
      var title = 'Pipeline ' + label;
      var message = 'Pipeline ' + label + ' for "' + data.title + '"';

      utils_notify.notifyMe(title, message, this.mr.gitlabLogo);
    },
    resumePolling: function resumePolling() {
      this.pollingInterval.resume();
    },
    stopPolling: function stopPolling() {
      this.pollingInterval.stopTimer();
    },
    bindEventHubListeners: function bindEventHubListeners() {
      var _this3 = this;

      event_hub["a" /* default */].$on('MRWidgetUpdateRequested', function (cb) {
        _this3.checkStatus(cb);
      });

      // `params` should be an Array contains a Boolean, like `[true]`
      // Passing parameter as Boolean didn't work.
      event_hub["a" /* default */].$on('SetBranchRemoveFlag', function (params) {
        _this3.mr.isRemovingSourceBranch = params[0];
      });

      event_hub["a" /* default */].$on('FailedToMerge', function (mergeError) {
        _this3.mr.state = 'failedToMerge';
        _this3.mr.mergeError = mergeError;
      });

      event_hub["a" /* default */].$on('UpdateWidgetData', function (data) {
        _this3.mr.setData(data);
      });

      event_hub["a" /* default */].$on('FetchActionsContent', function () {
        _this3.fetchActionsContent();
      });

      event_hub["a" /* default */].$on('EnablePolling', function () {
        _this3.resumePolling();
      });

      event_hub["a" /* default */].$on('DisablePolling', function () {
        _this3.stopPolling();
      });
    },
    handleMounted: function handleMounted() {
      this.setFaviconHelper();
      this.initDeploymentsPolling();
    }
  },
  created: function created() {
    this.initPolling();
    this.bindEventHubListeners();
  },
  mounted: function mounted() {
    this.handleMounted();
  },

  components: {
    'mr-widget-header': components_mr_widget_header,
    'mr-widget-merge-help': components_mr_widget_merge_help,
    'mr-widget-pipeline': components_mr_widget_pipeline,
    'mr-widget-deployment': mr_widget_deployment,
    'mr-widget-maintainer-edit': components_mr_widget_maintainer_edit,
    'mr-widget-related-links': components_mr_widget_related_links,
    'mr-widget-merged': states_mr_widget_merged,
    'mr-widget-closed': states_mr_widget_closed,
    'mr-widget-merging': states_mr_widget_merging,
    'mr-widget-failed-to-merge': states_mr_widget_failed_to_merge,
    'mr-widget-wip': mr_widget_wip["a" /* default */],
    'mr-widget-archived': states_mr_widget_archived,
    'mr-widget-conflicts': states_mr_widget_conflicts,
    'mr-widget-nothing-to-merge': mr_widget_nothing_to_merge,
    'mr-widget-not-allowed': states_mr_widget_not_allowed,
    'mr-widget-missing-branch': states_mr_widget_missing_branch,
    'mr-widget-ready-to-merge': mr_widget_ready_to_merge,
    'mr-widget-sha-mismatch': mr_widget_sha_mismatch,
    'mr-widget-squash-before-merge': mr_widget_squash_before_merge,
    'mr-widget-checking': states_mr_widget_checking,
    'mr-widget-unresolved-discussions': mr_widget_unresolved_discussions,
    'mr-widget-pipeline-blocked': states_mr_widget_pipeline_blocked,
    'mr-widget-pipeline-failed': mr_widget_pipeline_failed,
    'mr-widget-merge-when-pipeline-succeeds': states_mr_widget_merge_when_pipeline_succeeds,
    'mr-widget-auto-merge-failed': states_mr_widget_auto_merge_failed,
    'mr-widget-rebase': states_mr_widget_rebase
  },
  template: '\n    <div class="mr-state-widget prepend-top-default">\n      <mr-widget-header :mr="mr" />\n      <mr-widget-pipeline\n        v-if="shouldRenderPipelines"\n        :pipeline="mr.pipeline"\n        :ci-status="mr.ciStatus"\n        :has-ci="mr.hasCI"\n        />\n      <mr-widget-deployment\n        v-if="shouldRenderDeployments"\n        :mr="mr"\n        :service="service" />\n      <div class="mr-widget-section">\n        <component\n          :is="componentName"\n          :mr="mr"\n          :service="service" />\n        <mr-widget-maintainer-edit\n          :maintainerEditAllowed="mr.maintainerEditAllowed" />\n        <mr-widget-related-links\n          v-if="shouldRenderRelatedLinks"\n          :state="mr.state"\n          :related-links="mr.relatedLinks" />\n      </div>\n      <div\n        class="mr-widget-footer"\n        v-if="shouldRenderMergeHelp">\n        <mr-widget-merge-help />\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_squash_before_merge.js
/*
The squash-before-merge button is EE only, but it's located right in the middle
of the readyToMerge state component template.

If we didn't declare this component in CE, we'd need to maintain a separate copy
of the readyToMergeState template in EE, which is pretty big and likely to change.

Instead, in CE, we declare the component, but it's hidden and is configured to do nothing.
In EE, the configuration extends this object to add a functioning squash-before-merge
button.
*/

/* harmony default export */ var mr_widget_squash_before_merge = ({
  template: ''
});
// CONCATENATED MODULE: ./lib/utils/notify.js
/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, one-var, one-var-declaration-per-line, consistent-return, prefer-arrow-callback, no-return-assign, object-shorthand, comma-dangle, no-param-reassign, max-len */

function notificationGranted(message, opts, onclick) {
  var notification;
  notification = new Notification(message, opts);
  setTimeout(function () {
    // Hide the notification after X amount of seconds
    return notification.close();
  }, 8000);

  return notification.onclick = onclick || notification.close;
}

function notifyPermissions() {
  if ('Notification' in window) {
    return Notification.requestPermission();
  }
}

function notifyMe(message, body, icon, onclick) {
  var opts;
  opts = {
    body: body,
    icon: icon
  };
  // Let's check if the browser supports notifications
  if (!('Notification' in window)) {
    // do nothing
  } else if (Notification.permission === 'granted') {
    // If it's okay let's create a notification
    return notificationGranted(message, opts, onclick);
  } else if (Notification.permission !== 'denied') {
    return Notification.requestPermission(function (permission) {
      // If the user accepts, let's create a notification
      if (permission === 'granted') {
        return notificationGranted(message, opts, onclick);
      }
    });
  }
}

var notify = {
  notificationGranted: notificationGranted,
  notifyPermissions: notifyPermissions,
  notifyMe: notifyMe
};

/* harmony default export */ var utils_notify = (notify);
// CONCATENATED MODULE: ./vue_merge_request_widget/dependencies.js
/**
 * This file is the centerpiece of an attempt to reduce potential conflicts
 * between the CE and EE versions of the MR widget. EE additions to the MR widget should
 * be contained in the ee/vue_merge_request_widget directory, and should **extend**
 * rather than mutate CE MR Widget code.
 *
 * This file should be the only source of conflicts between EE and CE. EE-only components should
 * imported directly where they are needed, and import paths for EE extensions of CE components
 * should overwrite import paths **without** changing the order of dependencies listed here.
 */




































// EXTERNAL MODULE: ./vue_shared/translate.js
var translate = __webpack_require__("./vue_shared/translate.js");

// CONCATENATED MODULE: ./vue_merge_request_widget/index.js



vue_esm["a" /* default */].use(translate["a" /* default */]);

/* harmony default export */ var vue_merge_request_widget = (function () {
  gl.mrWidgetData.gitlabLogo = gon.gitlab_logo;

  var vm = new vue_esm["a" /* default */](mr_widget_options);

  window.gl.mrWidget = {
    checkStatus: vm.checkStatus
  };
});
// CONCATENATED MODULE: ./pages/projects/merge_requests/init_merge_request_show.js












/* harmony default export */ var init_merge_request_show = (function () {
  new diff["a" /* default */](); // eslint-disable-line no-new
  new zen_mode["a" /* default */](); // eslint-disable-line no-new

  Object(init_issuable_sidebar["a" /* default */])();
  Object(init_notes["a" /* default */])();
  Object(diff_notes_bundle["a" /* default */])();
  Object(pipelines_bundle["a" /* default */])();

  var mrShowNode = document.querySelector('.merge-request');

  window.mergeRequest = new merge_request["a" /* default */]({
    action: mrShowNode.dataset.mrAction
  });

  new shortcuts_issuable["a" /* default */](true); // eslint-disable-line no-new
  Object(common_utils["m" /* handleLocationHash */])();
  Object(how_to_merge["a" /* default */])();
  vue_merge_request_widget();
});
// CONCATENATED MODULE: ./pages/projects/merge_requests/show/index.js





document.addEventListener('DOMContentLoaded', function () {
  init_merge_request_show();
  Object(sidebar_bundle["a" /* default */])();

  if (Object(common_utils["n" /* hasVueMRDiscussionsCookie */])()) {
    initMrNotes();
  }
});

/***/ }),

/***/ "./pages/projects/project.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__project_select__ = __webpack_require__("./project_select.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, no-var, consistent-return, no-new, prefer-arrow-callback, no-return-assign, one-var, one-var-declaration-per-line, object-shorthand, no-else-return, newline-per-chained-call, no-shadow, vars-on-top, prefer-template, max-len */








var Project = function () {
  function Project() {
    _classCallCheck(this, Project);

    var $cloneOptions = $('ul.clone-options-dropdown');
    var $projectCloneField = $('#project_clone');
    var $cloneBtnText = $('a.clone-dropdown-btn span');

    var selectedCloneOption = $cloneBtnText.text().trim();
    if (selectedCloneOption.length > 0) {
      $('a:contains(\'' + selectedCloneOption + '\')', $cloneOptions).addClass('is-active');
    }

    $('a', $cloneOptions).on('click', function (e) {
      var $this = $(e.currentTarget);
      var url = $this.attr('href');
      var activeText = $this.find('.dropdown-menu-inner-title').text();

      e.preventDefault();

      $('.is-active', $cloneOptions).not($this).removeClass('is-active');
      $this.toggleClass('is-active');
      $projectCloneField.val(url);
      $cloneBtnText.text(activeText);

      return $('.clone').text(url);
    });
    // Ref switcher
    Project.initRefSwitcher();
    $('.project-refs-select').on('change', function () {
      return $(this).parents('form').submit();
    });
    $('.hide-no-ssh-message').on('click', function (e) {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('hide_no_ssh_message', 'false');
      $(this).parents('.no-ssh-key-message').remove();
      return e.preventDefault();
    });
    $('.hide-no-password-message').on('click', function (e) {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('hide_no_password_message', 'false');
      $(this).parents('.no-password-message').remove();
      return e.preventDefault();
    });
    Project.projectSelectDropdown();
  }

  _createClass(Project, null, [{
    key: 'projectSelectDropdown',
    value: function projectSelectDropdown() {
      Object(__WEBPACK_IMPORTED_MODULE_5__project_select__["a" /* default */])();
      $('.project-item-select').on('click', function (e) {
        return Project.changeProject($(e.currentTarget).val());
      });
    }
  }, {
    key: 'changeProject',
    value: function changeProject(url) {
      return window.location = url;
    }
  }, {
    key: 'initRefSwitcher',
    value: function initRefSwitcher() {
      var refListItem = document.createElement('li');
      var refLink = document.createElement('a');

      refLink.href = '#';

      return $('.js-project-refs-dropdown').each(function () {
        var $dropdown, selected;
        $dropdown = $(this);
        selected = $dropdown.data('selected');
        return $dropdown.glDropdown({
          data: function data(term, callback) {
            __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__["a" /* default */].get($dropdown.data('refsUrl'), {
              params: {
                ref: $dropdown.data('ref'),
                search: term
              }
            }).then(function (_ref) {
              var data = _ref.data;
              return callback(data);
            }).catch(function () {
              return Object(__WEBPACK_IMPORTED_MODULE_4__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('An error occurred while getting projects'));
            });
          },

          selectable: true,
          filterable: true,
          filterRemote: true,
          filterByText: true,
          inputFieldName: $dropdown.data('inputFieldName'),
          fieldName: $dropdown.data('fieldName'),
          renderRow: function renderRow(ref) {
            var li = refListItem.cloneNode(false);

            if (ref.header != null) {
              li.className = 'dropdown-header';
              li.textContent = ref.header;
            } else {
              var link = refLink.cloneNode(false);

              if (ref === selected) {
                link.className = 'is-active';
              }

              link.textContent = ref;
              link.dataset.ref = ref;

              li.appendChild(link);
            }

            return li;
          },
          id: function id(obj, $el) {
            return $el.attr('data-ref');
          },
          toggleLabel: function toggleLabel(obj, $el) {
            return $el.text().trim();
          },
          clicked: function clicked(options) {
            var e = options.e;

            e.preventDefault();
            if ($('input[name="ref"]').length) {
              var $form = $dropdown.closest('form');

              var $visit = $dropdown.data('visit');
              var shouldVisit = $visit ? true : $visit;
              var action = $form.attr('action');
              var divider = action.indexOf('?') === -1 ? '?' : '&';
              if (shouldVisit) {
                Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_url_utility__["g" /* visitUrl */])('' + action + divider + $form.serialize());
              }
            }
          }
        });
      });
    }
  }]);

  return Project;
}();

/* harmony default export */ __webpack_exports__["a"] = (Project);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pipelines/components/stage.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/stage.vue
var stage = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/stage.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65860e01","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/stage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"mini-pipeline-graph-dropdown-toggle js-builds-dropdown-button",class:_vm.triggerButtonClass,attrs:{"title":_vm.stage.title,"data-placement":"top","data-toggle":"dropdown","type":"button","id":"stageDropdown","aria-haspopup":"true","aria-expanded":"false"},on:{"click":_vm.onClickStage}},[_c('span',{attrs:{"aria-hidden":"true","aria-label":_vm.stage.title}},[_c('icon',{attrs:{"name":_vm.borderlessIcon}})],1),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu mini-pipeline-graph-dropdown-menu js-builds-dropdown-container",attrs:{"aria-labelledby":"stageDropdown"}},[_c('li',{staticClass:"js-builds-dropdown-list scrollable-menu",class:_vm.dropdownClass},[(_vm.isLoading)?_c('loading-icon'):_c('ul',{domProps:{"innerHTML":_vm._s(_vm.dropdownContent)}})],1)])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./pipelines/components/stage.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  stage["a" /* default */],
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_stage = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./pipelines/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ "./pipelines/mixins/pipelines.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/visibilityjs/index.js
var visibilityjs = __webpack_require__("../../../node_modules/visibilityjs/index.js");
var visibilityjs_default = /*#__PURE__*/__webpack_require__.n(visibilityjs);

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./lib/utils/poll.js
var poll = __webpack_require__("./lib/utils/poll.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/empty_state.vue

/* harmony default export */ var empty_state = ({
  name: 'PipelinesEmptyState',
  props: {
    helpPagePath: {
      type: String,
      required: true
    },
    emptyStateSvgPath: {
      type: String,
      required: true
    },
    canSetCi: {
      type: Boolean,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a3569de","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/empty_state.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row empty-state js-empty-state"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"svg-content svg-250"},[_c('img',{attrs:{"src":_vm.emptyStateSvgPath}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"text-content"},[(_vm.canSetCi)?[_c('h4',{staticClass:"text-center"},[_vm._v("\n          "+_vm._s(_vm.s__('Pipelines|Build with confidence'))+"\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          "+_vm._s(_vm.s__("Pipelines|Continous Integration can help\n              catch bugs by running your tests automatically,\n              while Continuous Deployment can help you deliver\n              code to your product environment."))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('a',{staticClass:"btn btn-primary js-get-started-pipelines",attrs:{"href":_vm.helpPagePath}},[_vm._v("\n            "+_vm._s(_vm.s__('Pipelines|Get started with Pipelines'))+"\n          ")])])]:_c('p',{staticClass:"text-center"},[_vm._v("\n        "+_vm._s(_vm.s__('Pipelines|This project is not currently set up to run pipelines.'))+"\n      ")])],2)])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./pipelines/components/empty_state.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  empty_state,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_empty_state = (Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/blank_state.vue

/* harmony default export */ var blank_state = ({
  name: 'PipelinesSvgState',
  props: {
    svgPath: {
      type: String,
      required: true
    },

    message: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-190f43c7","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/blank_state.vue
var blank_state_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row empty-state"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"svg-content"},[_c('img',{attrs:{"src":_vm.svgPath}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 text-center"},[_c('div',{staticClass:"text-content"},[_c('h4',[_vm._v(_vm._s(_vm.message))])])])])}
var blank_state_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/blank_state.vue
/* script */


/* template */

/* template functional */
var blank_state___vue_template_functional__ = false
/* styles */
var blank_state___vue_styles__ = null
/* scopeId */
var blank_state___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var blank_state___vue_module_identifier__ = null

var blank_state_Component = Object(component_normalizer["a" /* default */])(
  blank_state,
  blank_state_render,
  blank_state_staticRenderFns,
  blank_state___vue_template_functional__,
  blank_state___vue_styles__,
  blank_state___vue_scopeId__,
  blank_state___vue_module_identifier__
)

/* harmony default export */ var components_blank_state = (blank_state_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/modal.vue + 2 modules
var modal = __webpack_require__("./vue_shared/components/modal.vue");

// EXTERNAL MODULE: ./pipelines/event_hub.js
var event_hub = __webpack_require__("./pipelines/event_hub.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/async_button.vue

/* eslint-disable no-alert */






/* harmony default export */ var async_button = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    loadingIcon: loading_icon["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    endpoint: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    cssClass: {
      type: String,
      required: true
    },
    pipelineId: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: false
    };
  },

  computed: {
    buttonClass: function buttonClass() {
      return 'btn ' + this.cssClass;
    }
  },
  created: function created() {
    // We're using eventHub to listen to the modal here instead of
    // using props because it would would make the parent components
    // much more complex to keep track of the loading state of each button
    event_hub["a" /* default */].$on('postAction', this.setLoading);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('postAction', this.setLoading);
  },

  methods: {
    onClick: function onClick() {
      event_hub["a" /* default */].$emit('openConfirmationModal', {
        pipelineId: this.pipelineId,
        endpoint: this.endpoint,
        type: this.type
      });
    },
    setLoading: function setLoading(endpoint) {
      if (endpoint === this.endpoint) {
        this.isLoading = true;
      }
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08a875a2","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/async_button.vue
var async_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.buttonClass,attrs:{"type":"button","title":_vm.title,"aria-label":_vm.title,"data-container":"body","data-placement":"top","disabled":_vm.isLoading},on:{"click":_vm.onClick}},[_c('icon',{attrs:{"name":_vm.icon}}),_vm._v(" "),(_vm.isLoading)?_c('loading-icon'):_vm._e()],1)}
var async_button_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/async_button.vue
/* script */


/* template */

/* template functional */
var async_button___vue_template_functional__ = false
/* styles */
var async_button___vue_styles__ = null
/* scopeId */
var async_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var async_button___vue_module_identifier__ = null

var async_button_Component = Object(component_normalizer["a" /* default */])(
  async_button,
  async_button_render,
  async_button_staticRenderFns,
  async_button___vue_template_functional__,
  async_button___vue_styles__,
  async_button___vue_scopeId__,
  async_button___vue_module_identifier__
)

/* harmony default export */ var components_async_button = (async_button_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_actions.vue






/* harmony default export */ var pipelines_actions = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    loadingIcon: loading_icon["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    actions: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: false
    };
  },

  methods: {
    onClickAction: function onClickAction(endpoint) {
      this.isLoading = true;

      event_hub["a" /* default */].$emit('postAction', endpoint);
    },
    isActionDisabled: function isActionDisabled(action) {
      if (action.playable === undefined) {
        return false;
      }

      return !action.playable;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4131da4d","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_actions.vue
var pipelines_actions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"dropdown-new btn btn-default js-pipeline-dropdown-manual-actions",attrs:{"type":"button","title":"Manual job","data-toggle":"dropdown","data-placement":"top","aria-label":"Manual job","disabled":_vm.isLoading}},[_c('icon',{staticClass:"icon-play",attrs:{"name":"play"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.isLoading)?_c('loading-icon'):_vm._e()],1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-align-right"},_vm._l((_vm.actions),function(action,i){return _c('li',{key:i},[_c('button',{staticClass:"js-pipeline-action-link no-btn btn",class:{ disabled: _vm.isActionDisabled(action) },attrs:{"type":"button","disabled":_vm.isActionDisabled(action)},on:{"click":function($event){_vm.onClickAction(action.path)}}},[_vm._v("\n        "+_vm._s(action.name)+"\n      ")])])}))])}
var pipelines_actions_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/pipelines_actions.vue
/* script */


/* template */

/* template functional */
var pipelines_actions___vue_template_functional__ = false
/* styles */
var pipelines_actions___vue_styles__ = null
/* scopeId */
var pipelines_actions___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_actions___vue_module_identifier__ = null

var pipelines_actions_Component = Object(component_normalizer["a" /* default */])(
  pipelines_actions,
  pipelines_actions_render,
  pipelines_actions_staticRenderFns,
  pipelines_actions___vue_template_functional__,
  pipelines_actions___vue_styles__,
  pipelines_actions___vue_scopeId__,
  pipelines_actions___vue_module_identifier__
)

/* harmony default export */ var components_pipelines_actions = (pipelines_actions_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_artifacts.vue




/* harmony default export */ var pipelines_artifacts = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    icon: icon["a" /* default */]
  },
  props: {
    artifacts: {
      type: Array,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8577a5a6","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_artifacts.vue
var pipelines_artifacts_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"dropdown-toggle btn btn-default build-artifacts js-pipeline-dropdown-download",attrs:{"title":"Artifacts","data-placement":"top","data-toggle":"dropdown","aria-label":"Artifacts"}},[_c('icon',{attrs:{"name":"download"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}})],1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-align-right"},_vm._l((_vm.artifacts),function(artifact,i){return _c('li',{key:i},[_c('a',{attrs:{"rel":"nofollow","download":"","href":artifact.path}},[_vm._v("\n        Download "+_vm._s(artifact.name)+" artifacts\n      ")])])}))])}
var pipelines_artifacts_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/pipelines_artifacts.vue
/* script */


/* template */

/* template functional */
var pipelines_artifacts___vue_template_functional__ = false
/* styles */
var pipelines_artifacts___vue_styles__ = null
/* scopeId */
var pipelines_artifacts___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_artifacts___vue_module_identifier__ = null

var pipelines_artifacts_Component = Object(component_normalizer["a" /* default */])(
  pipelines_artifacts,
  pipelines_artifacts_render,
  pipelines_artifacts_staticRenderFns,
  pipelines_artifacts___vue_template_functional__,
  pipelines_artifacts___vue_styles__,
  pipelines_artifacts___vue_scopeId__,
  pipelines_artifacts___vue_module_identifier__
)

/* harmony default export */ var components_pipelines_artifacts = (pipelines_artifacts_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/ci_badge_link.vue + 2 modules
var ci_badge_link = __webpack_require__("./vue_shared/components/ci_badge_link.vue");

// EXTERNAL MODULE: ./pipelines/components/stage.vue + 1 modules
var stage = __webpack_require__("./pipelines/components/stage.vue");

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_link.vue + 2 modules
var user_avatar_link = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_link.vue");

// EXTERNAL MODULE: ./vue_shared/directives/popover.js
var popover = __webpack_require__("./vue_shared/directives/popover.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipeline_url.vue





/* harmony default export */ var pipeline_url = ({
  components: {
    userAvatarLink: user_avatar_link["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */],
    popover: popover["a" /* default */]
  },
  props: {
    pipeline: {
      type: Object,
      required: true
    },
    autoDevopsHelpPath: {
      type: String,
      required: true
    }
  },
  computed: {
    user: function user() {
      return this.pipeline.user;
    },
    popoverOptions: function popoverOptions() {
      return {
        html: true,
        trigger: 'focus',
        placement: 'top',
        title: '<div class="autodevops-title">\n          This pipeline makes use of a predefined CI/CD configuration enabled by <b>Auto DevOps.</b>\n        </div>',
        content: '<a\n          class="autodevops-link"\n          href="' + this.autoDevopsHelpPath + '"\n          target="_blank"\n          rel="noopener noreferrer nofollow">\n          Learn more about Auto DevOps\n        </a>'
      };
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cea8c848","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipeline_url.vue
var pipeline_url_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-section section-15 hidden-xs hidden-sm pipeline-tags"},[_c('a',{staticClass:"js-pipeline-url-link",attrs:{"href":_vm.pipeline.path}},[_c('span',{staticClass:"pipeline-id"},[_vm._v("#"+_vm._s(_vm.pipeline.id))])]),_vm._v(" "),_c('span',[_vm._v("by")]),_vm._v(" "),(_vm.user)?_c('user-avatar-link',{staticClass:"js-pipeline-url-user",attrs:{"link-href":_vm.pipeline.user.path,"img-src":_vm.pipeline.user.avatar_url,"tooltip-text":_vm.pipeline.user.name}}):_vm._e(),_vm._v(" "),(!_vm.user)?_c('span',{staticClass:"js-pipeline-url-api api"},[_vm._v("\n    API\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"label-container"},[(_vm.pipeline.flags.latest)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-pipeline-url-latest label label-success",attrs:{"title":"Latest pipeline for this branch"}},[_vm._v("\n      latest\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.yaml_errors)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-pipeline-url-yaml label label-danger",attrs:{"title":_vm.pipeline.yaml_errors}},[_vm._v("\n      yaml invalid\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.failure_reason)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-pipeline-url-failure label label-danger",attrs:{"title":_vm.pipeline.failure_reason}},[_vm._v("\n      error\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.auto_devops)?_c('a',{directives:[{name:"popover",rawName:"v-popover",value:(_vm.popoverOptions),expression:"popoverOptions"}],staticClass:"js-pipeline-url-autodevops label label-info autodevops-badge",attrs:{"tabindex":"0","role":"button"}},[_vm._v("\n      Auto DevOps\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.stuck)?_c('span',{staticClass:"js-pipeline-url-stuck label label-warning"},[_vm._v("\n      stuck\n    ")]):_vm._e()])],1)}
var pipeline_url_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/pipeline_url.vue
/* script */


/* template */

/* template functional */
var pipeline_url___vue_template_functional__ = false
/* styles */
var pipeline_url___vue_styles__ = null
/* scopeId */
var pipeline_url___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipeline_url___vue_module_identifier__ = null

var pipeline_url_Component = Object(component_normalizer["a" /* default */])(
  pipeline_url,
  pipeline_url_render,
  pipeline_url_staticRenderFns,
  pipeline_url___vue_template_functional__,
  pipeline_url___vue_styles__,
  pipeline_url___vue_scopeId__,
  pipeline_url___vue_module_identifier__
)

/* harmony default export */ var components_pipeline_url = (pipeline_url_Component.exports);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_timer.svg
var _icon_timer = __webpack_require__("../../views/shared/icons/_icon_timer.svg");
var _icon_timer_default = /*#__PURE__*/__webpack_require__.n(_icon_timer);

// EXTERNAL MODULE: ./lib/utils/datetime_utility.js
var datetime_utility = __webpack_require__("./lib/utils/datetime_utility.js");

// EXTERNAL MODULE: ./vue_shared/mixins/timeago.js
var timeago = __webpack_require__("./vue_shared/mixins/timeago.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/time_ago.vue






/* harmony default export */ var time_ago = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  mixins: [timeago["a" /* default */]],
  props: {
    finishedTime: {
      type: String,
      required: true
    },
    duration: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      iconTimerSvg: _icon_timer_default.a
    };
  },

  computed: {
    hasDuration: function hasDuration() {
      return this.duration > 0;
    },
    hasFinishedTime: function hasFinishedTime() {
      return this.finishedTime !== '';
    },
    durationFormated: function durationFormated() {
      var date = new Date(this.duration * 1000);

      var hh = date.getUTCHours();
      var mm = date.getUTCMinutes();
      var ss = date.getSeconds();

      // left pad
      if (hh < 10) {
        hh = '0' + hh;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      if (ss < 10) {
        ss = '0' + ss;
      }

      return hh + ':' + mm + ':' + ss;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-369bf334","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/time_ago.vue
var time_ago_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-section section-15 pipelines-time-ago"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n    持续时间\n  ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[(_vm.hasDuration)?_c('p',{staticClass:"duration"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.iconTimerSvg)}}),_vm._v("\n      "+_vm._s(_vm.durationFormated)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.hasFinishedTime)?_c('p',{staticClass:"finished-at hidden-xs hidden-sm"},[_c('i',{staticClass:"fa fa-calendar",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('time',{directives:[{name:"tooltip",rawName:"v-tooltip"}],attrs:{"data-placement":"top","data-container":"body","title":_vm.tooltipTitle(_vm.finishedTime)}},[_vm._v("\n        "+_vm._s(_vm.timeFormated(_vm.finishedTime))+"\n      ")])]):_vm._e()])])}
var time_ago_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/time_ago.vue
/* script */


/* template */

/* template functional */
var time_ago___vue_template_functional__ = false
/* styles */
var time_ago___vue_styles__ = null
/* scopeId */
var time_ago___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var time_ago___vue_module_identifier__ = null

var time_ago_Component = Object(component_normalizer["a" /* default */])(
  time_ago,
  time_ago_render,
  time_ago_staticRenderFns,
  time_ago___vue_template_functional__,
  time_ago___vue_styles__,
  time_ago___vue_scopeId__,
  time_ago___vue_module_identifier__
)

/* harmony default export */ var components_time_ago = (time_ago_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/commit.vue + 2 modules
var commit = __webpack_require__("./vue_shared/components/commit.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_table_row.vue

/* eslint-disable no-param-reassign */









/**
 * Pipeline table row.
 *
 * Given the received object renders a table row in the pipelines' table.
 */
/* harmony default export */ var pipelines_table_row = ({
  components: {
    asyncButtonComponent: components_async_button,
    pipelinesActionsComponent: components_pipelines_actions,
    pipelinesArtifactsComponent: components_pipelines_artifacts,
    commitComponent: commit["a" /* default */],
    pipelineStage: stage["a" /* default */],
    pipelineUrl: components_pipeline_url,
    ciBadge: ci_badge_link["a" /* default */],
    pipelinesTimeago: components_time_ago
  },
  props: {
    pipeline: {
      type: Object,
      required: true
    },
    updateGraphDropdown: {
      type: Boolean,
      required: false,
      default: false
    },
    autoDevopsHelpPath: {
      type: String,
      required: true
    },
    viewType: {
      type: String,
      required: true
    }
  },
  computed: {
    /**
     * If provided, returns the commit tag.
     * Needed to render the commit component column.
     *
     * This field needs a lot of verification, because of different possible cases:
     *
     * 1. person who is an author of a commit might be a GitLab user
     * 2. if person who is an author of a commit is a GitLab user he/she can have a GitLab avatar
     * 3. If GitLab user does not have avatar he/she might have a Gravatar
     * 4. If committer is not a GitLab User he/she can have a Gravatar
     * 5. We do not have consistent API object in this case
     * 6. We should improve API and the code
     *
     * @returns {Object|Undefined}
     */
    commitAuthor: function commitAuthor() {
      var commitAuthorInformation = void 0;

      if (!this.pipeline || !this.pipeline.commit) {
        return null;
      }

      // 1. person who is an author of a commit might be a GitLab user
      if (this.pipeline.commit.author) {
        // 2. if person who is an author of a commit is a GitLab user
        // he/she can have a GitLab avatar
        if (this.pipeline.commit.author.avatar_url) {
          commitAuthorInformation = this.pipeline.commit.author;

          // 3. If GitLab user does not have avatar he/she might have a Gravatar
        } else if (this.pipeline.commit.author_gravatar_url) {
          commitAuthorInformation = Object.assign({}, this.pipeline.commit.author, {
            avatar_url: this.pipeline.commit.author_gravatar_url
          });
        }
        // 4. If committer is not a GitLab User he/she can have a Gravatar
      } else {
        commitAuthorInformation = {
          avatar_url: this.pipeline.commit.author_gravatar_url,
          path: 'mailto:' + this.pipeline.commit.author_email,
          username: this.pipeline.commit.author_name
        };
      }

      return commitAuthorInformation;
    },


    /**
     * If provided, returns the commit tag.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitTag: function commitTag() {
      if (this.pipeline.ref && this.pipeline.ref.tag) {
        return this.pipeline.ref.tag;
      }
      return undefined;
    },


    /**
     * If provided, returns the commit ref.
     * Needed to render the commit component column.
     *
     * Matches `path` prop sent in the API to `ref_url` prop needed
     * in the commit component.
     *
     * @returns {Object|Undefined}
     */
    commitRef: function commitRef() {
      var _this = this;

      if (this.pipeline.ref) {
        return Object.keys(this.pipeline.ref).reduce(function (accumulator, prop) {
          if (prop === 'path') {
            accumulator.ref_url = _this.pipeline.ref[prop];
          } else {
            accumulator[prop] = _this.pipeline.ref[prop];
          }
          return accumulator;
        }, {});
      }

      return undefined;
    },


    /**
     * If provided, returns the commit url.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitUrl: function commitUrl() {
      if (this.pipeline.commit && this.pipeline.commit.commit_path) {
        return this.pipeline.commit.commit_path;
      }
      return undefined;
    },


    /**
     * If provided, returns the commit short sha.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitShortSha: function commitShortSha() {
      if (this.pipeline.commit && this.pipeline.commit.short_id) {
        return this.pipeline.commit.short_id;
      }
      return undefined;
    },


    /**
     * If provided, returns the commit title.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitTitle: function commitTitle() {
      if (this.pipeline.commit && this.pipeline.commit.title) {
        return this.pipeline.commit.title;
      }
      return undefined;
    },


    /**
     * Timeago components expects a number
     *
     * @return {type}  description
     */
    pipelineDuration: function pipelineDuration() {
      if (this.pipeline.details && this.pipeline.details.duration) {
        return this.pipeline.details.duration;
      }

      return 0;
    },


    /**
     * Timeago component expects a String.
     *
     * @return {String}
     */
    pipelineFinishedAt: function pipelineFinishedAt() {
      if (this.pipeline.details && this.pipeline.details.finished_at) {
        return this.pipeline.details.finished_at;
      }

      return '';
    },
    pipelineStatus: function pipelineStatus() {
      if (this.pipeline.details && this.pipeline.details.status) {
        return this.pipeline.details.status;
      }
      return {};
    },
    displayPipelineActions: function displayPipelineActions() {
      return this.pipeline.flags.retryable || this.pipeline.flags.cancelable || this.pipeline.details.manual_actions.length || this.pipeline.details.artifacts.length;
    },
    isChildView: function isChildView() {
      return this.viewType === 'child';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c853a7e","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table_row.vue
var pipelines_table_row_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commit gl-responsive-table-row"},[_c('div',{staticClass:"table-section section-10 commit-link"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n      Status\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[_c('ci-badge',{attrs:{"status":_vm.pipelineStatus,"show-text":!_vm.isChildView}})],1)]),_vm._v(" "),_c('pipeline-url',{attrs:{"pipeline":_vm.pipeline,"auto-devops-help-path":_vm.autoDevopsHelpPath}}),_vm._v(" "),_c('div',{staticClass:"table-section section-20"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n      Commit\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[_c('commit-component',{attrs:{"tag":_vm.commitTag,"commit-ref":_vm.commitRef,"commit-url":_vm.commitUrl,"short-sha":_vm.commitShortSha,"title":_vm.commitTitle,"author":_vm.commitAuthor,"show-branch":!_vm.isChildView}})],1)]),_vm._v(" "),_c('div',{staticClass:"table-section section-wrap section-20 stage-cell"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n      Stages\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[(_vm.pipeline.details.stages.length > 0)?_vm._l((_vm.pipeline.details.stages),function(stage,index){return _c('div',{key:index,staticClass:"stage-container dropdown js-mini-pipeline-graph"},[_c('pipeline-stage',{attrs:{"stage":stage,"update-dropdown":_vm.updateGraphDropdown}})],1)}):_vm._e()],2)]),_vm._v(" "),_c('pipelines-timeago',{attrs:{"duration":_vm.pipelineDuration,"finished-time":_vm.pipelineFinishedAt}}),_vm._v(" "),(_vm.displayPipelineActions)?_c('div',{staticClass:"table-section section-20 table-button-footer pipeline-actions"},[_c('div',{staticClass:"btn-group table-action-buttons"},[(_vm.pipeline.details.manual_actions.length)?_c('pipelines-actions-component',{attrs:{"actions":_vm.pipeline.details.manual_actions}}):_vm._e(),_vm._v(" "),(_vm.pipeline.details.artifacts.length)?_c('pipelines-artifacts-component',{staticClass:"hidden-xs hidden-sm",attrs:{"artifacts":_vm.pipeline.details.artifacts}}):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.retryable)?_c('async-button-component',{attrs:{"endpoint":_vm.pipeline.retry_path,"css-class":"js-pipelines-retry-button btn-default btn-retry","title":"Retry","icon":"repeat","pipeline-id":_vm.pipeline.id,"data-toggle":"modal","data-target":"#confirmation-modal","type":"retry"}}):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.cancelable)?_c('async-button-component',{attrs:{"endpoint":_vm.pipeline.cancel_path,"css-class":"js-pipelines-cancel-button btn-remove","title":"Stop","icon":"close","pipeline-id":_vm.pipeline.id,"data-toggle":"modal","data-target":"#confirmation-modal","type":"stop"}}):_vm._e()],1)]):_vm._e()],1)}
var pipelines_table_row_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/pipelines_table_row.vue
/* script */


/* template */

/* template functional */
var pipelines_table_row___vue_template_functional__ = false
/* styles */
var pipelines_table_row___vue_styles__ = null
/* scopeId */
var pipelines_table_row___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_table_row___vue_module_identifier__ = null

var pipelines_table_row_Component = Object(component_normalizer["a" /* default */])(
  pipelines_table_row,
  pipelines_table_row_render,
  pipelines_table_row_staticRenderFns,
  pipelines_table_row___vue_template_functional__,
  pipelines_table_row___vue_styles__,
  pipelines_table_row___vue_scopeId__,
  pipelines_table_row___vue_module_identifier__
)

/* harmony default export */ var components_pipelines_table_row = (pipelines_table_row_Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_table.vue






/**
 * Pipelines Table Component.
 *
 * Given an array of objects, renders a table.
 */
/* harmony default export */ var pipelines_table = ({
  components: {
    pipelinesTableRowComponent: components_pipelines_table_row,
    modal: modal["a" /* default */]
  },
  props: {
    pipelines: {
      type: Array,
      required: true
    },
    updateGraphDropdown: {
      type: Boolean,
      required: false,
      default: false
    },
    autoDevopsHelpPath: {
      type: String,
      required: true
    },
    viewType: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      pipelineId: '',
      endpoint: '',
      type: ''
    };
  },

  computed: {
    modalTitle: function modalTitle() {
      return this.type === 'stop' ? Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Pipeline|Stop pipeline #%{pipelineId}?'), {
        pipelineId: '\'' + this.pipelineId + '\''
      }, false) : Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Pipeline|Retry pipeline #%{pipelineId}?'), {
        pipelineId: '\'' + this.pipelineId + '\''
      }, false);
    },
    modalText: function modalText() {
      return this.type === 'stop' ? Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Pipeline|You’re about to stop pipeline %{pipelineId}.'), {
        pipelineId: '<strong>#' + this.pipelineId + '</strong>'
      }, false) : Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Pipeline|You’re about to retry pipeline %{pipelineId}.'), {
        pipelineId: '<strong>#' + this.pipelineId + '</strong>'
      }, false);
    },
    primaryButtonLabel: function primaryButtonLabel() {
      return this.type === 'stop' ? Object(locale["e" /* s__ */])('Pipeline|Stop pipeline') : Object(locale["e" /* s__ */])('Pipeline|Retry pipeline');
    }
  },
  created: function created() {
    event_hub["a" /* default */].$on('openConfirmationModal', this.setModalData);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('openConfirmationModal', this.setModalData);
  },

  methods: {
    setModalData: function setModalData(data) {
      this.pipelineId = data.pipelineId;
      this.endpoint = data.endpoint;
      this.type = data.type;
    },
    onSubmit: function onSubmit() {
      event_hub["a" /* default */].$emit('postAction', this.endpoint);
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b82e002","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table.vue
var pipelines_table_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ci-table"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.pipelines),function(model){return _c('pipelines-table-row-component',{key:model.id,attrs:{"pipeline":model,"update-graph-dropdown":_vm.updateGraphDropdown,"auto-devops-help-path":_vm.autoDevopsHelpPath,"view-type":_vm.viewType}})}),_vm._v(" "),_c('modal',{attrs:{"id":"confirmation-modal","title":_vm.modalTitle,"text":_vm.modalText,"kind":"danger","primary-button-label":_vm.primaryButtonLabel},on:{"submit":_vm.onSubmit},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_c('p',{domProps:{"innerHTML":_vm._s(props.text)}})]}}])})],2)}
var pipelines_table_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gl-responsive-table-row table-row-header",attrs:{"role":"row"}},[_c('div',{staticClass:"table-section section-10 js-pipeline-status pipeline-status",attrs:{"role":"rowheader"}},[_vm._v("\n      状态\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-section section-15 js-pipeline-info pipeline-info",attrs:{"role":"rowheader"}},[_vm._v("\n      流水线\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-section section-20 js-pipeline-commit pipeline-commit",attrs:{"role":"rowheader"}},[_vm._v("\n      提交\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-section section-20 js-pipeline-stages pipeline-stages",attrs:{"role":"rowheader"}},[_vm._v("\n      步骤\n    ")])])}]

// CONCATENATED MODULE: ./pipelines/components/pipelines_table.vue
/* script */


/* template */

/* template functional */
var pipelines_table___vue_template_functional__ = false
/* styles */
var pipelines_table___vue_styles__ = null
/* scopeId */
var pipelines_table___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_table___vue_module_identifier__ = null

var pipelines_table_Component = Object(component_normalizer["a" /* default */])(
  pipelines_table,
  pipelines_table_render,
  pipelines_table_staticRenderFns,
  pipelines_table___vue_template_functional__,
  pipelines_table___vue_styles__,
  pipelines_table___vue_scopeId__,
  pipelines_table___vue_module_identifier__
)

/* harmony default export */ var components_pipelines_table = (pipelines_table_Component.exports);

// CONCATENATED MODULE: ./pipelines/mixins/pipelines.js










/* harmony default export */ var pipelines = __webpack_exports__["a"] = ({
  components: {
    PipelinesTableComponent: components_pipelines_table,
    SvgBlankState: components_blank_state,
    EmptyState: components_empty_state,
    LoadingIcon: loading_icon["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: false,
      hasError: false,
      isMakingRequest: false,
      updateGraphDropdown: false,
      hasMadeRequest: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.poll = new poll["a" /* default */]({
      resource: this.service,
      method: 'getPipelines',
      data: this.requestData ? this.requestData : undefined,
      successCallback: this.successCallback,
      errorCallback: this.errorCallback,
      notificationCallback: this.setIsMakingRequest
    });

    if (!visibilityjs_default.a.hidden()) {
      this.isLoading = true;
      this.poll.makeRequest();
    } else {
      // If tab is not visible we need to make the first request so we don't show the empty
      // state without knowing if there are any pipelines
      this.fetchPipelines();
    }

    visibilityjs_default.a.change(function () {
      if (!visibilityjs_default.a.hidden()) {
        _this.poll.restart();
      } else {
        _this.poll.stop();
      }
    });

    event_hub["a" /* default */].$on('refreshPipelines', this.fetchPipelines);
    event_hub["a" /* default */].$on('postAction', this.postAction);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('refreshPipelines');
    event_hub["a" /* default */].$on('postAction', this.postAction);
  },
  destroyed: function destroyed() {
    this.poll.stop();
  },

  methods: {
    fetchPipelines: function fetchPipelines() {
      var _this2 = this;

      if (!this.isMakingRequest) {
        this.isLoading = true;

        this.service.getPipelines(this.requestData).then(function (response) {
          return _this2.successCallback(response);
        }).catch(function () {
          return _this2.errorCallback();
        });
      }
    },
    setCommonData: function setCommonData(pipelines) {
      this.store.storePipelines(pipelines);
      this.isLoading = false;
      this.updateGraphDropdown = true;
      this.hasMadeRequest = true;
    },
    errorCallback: function errorCallback() {
      this.hasError = true;
      this.isLoading = false;
      this.updateGraphDropdown = false;
      this.hasMadeRequest = true;
    },
    setIsMakingRequest: function setIsMakingRequest(isMakingRequest) {
      this.isMakingRequest = isMakingRequest;

      if (isMakingRequest) {
        this.updateGraphDropdown = false;
      }
    },
    postAction: function postAction(endpoint) {
      this.service.postAction(endpoint).then(function () {
        return event_hub["a" /* default */].$emit('refreshPipelines');
      }).catch(function () {
        return Object(flash["a" /* default */])(Object(locale["a" /* __ */])('An error occurred while making the request.'));
      });
    }
  }
});

/***/ }),

/***/ "./pipelines/services/pipelines_service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("../../../node_modules/vue-resource/dist/vue-resource.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_vue_resource_interceptor__ = __webpack_require__("./vue_shared/vue_resource_interceptor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

var PipelinesService = function () {

  /**
  * Commits and merge request endpoints need to be requested with `.json`.
  *
  * The url provided to request the pipelines in the new merge request
  * page already has `.json`.
  *
  * @param  {String} root
  */
  function PipelinesService(root) {
    _classCallCheck(this, PipelinesService);

    var endpoint = void 0;

    if (root.indexOf('.json') === -1) {
      endpoint = root + '.json';
    } else {
      endpoint = root;
    }

    this.pipelines = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].resource(endpoint);
  }

  _createClass(PipelinesService, [{
    key: 'getPipelines',
    value: function getPipelines() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var scope = data.scope,
          page = data.page;

      return this.pipelines.get({ scope: scope, page: page });
    }

    /**
     * Post request for all pipelines actions.
     *
     * @param  {String} endpoint
     * @return {Promise}
     */

  }, {
    key: 'postAction',
    value: function postAction(endpoint) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(endpoint + '.json');
    }
  }]);

  return PipelinesService;
}();

/* harmony default export */ __webpack_exports__["a"] = (PipelinesService);

/***/ }),

/***/ "./pipelines/stores/pipelines_store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PipelinesStore = function () {
  function PipelinesStore() {
    _classCallCheck(this, PipelinesStore);

    this.state = {};

    this.state.pipelines = [];
    this.state.count = {};
    this.state.pageInfo = {};
  }

  _createClass(PipelinesStore, [{
    key: 'storePipelines',
    value: function storePipelines() {
      var pipelines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.state.pipelines = pipelines;
    }
  }, {
    key: 'storeCount',
    value: function storeCount() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.state.count = count;
    }
  }, {
    key: 'storePagination',
    value: function storePagination() {
      var pagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var paginationInfo = void 0;

      if (Object.keys(pagination).length) {
        var normalizedHeaders = Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["x" /* normalizeHeaders */])(pagination);
        paginationInfo = Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["z" /* parseIntPagination */])(normalizedHeaders);
      } else {
        paginationInfo = pagination;
      }

      this.state.pageInfo = paginationInfo;
    }
  }]);

  return PipelinesStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (PipelinesStore);

/***/ }),

/***/ "./project_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = projectSelect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__project_select_combo_button__ = __webpack_require__("./project_select_combo_button.js");
/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-var, comma-dangle, object-shorthand, one-var, one-var-declaration-per-line, no-else-return, quotes, max-len */



function projectSelect() {
  $('.ajax-project-select').each(function (i, select) {
    var placeholder;
    var simpleFilter = $(select).data('simpleFilter') || false;
    this.groupId = $(select).data('groupId');
    this.includeGroups = $(select).data('includeGroups');
    this.allProjects = $(select).data('allProjects') || false;
    this.orderBy = $(select).data('orderBy') || 'id';
    this.withIssuesEnabled = $(select).data('withIssuesEnabled');
    this.withMergeRequestsEnabled = $(select).data('withMergeRequestsEnabled');

    placeholder = "搜索项目";
    if (this.includeGroups) {
      placeholder += "或群组";
    }

    $(select).select2({
      placeholder: placeholder,
      minimumInputLength: 0,
      query: function (_this) {
        return function (query) {
          var finalCallback, projectsCallback;
          finalCallback = function finalCallback(projects) {
            var data;
            data = {
              results: projects
            };
            return query.callback(data);
          };
          if (_this.includeGroups) {
            projectsCallback = function projectsCallback(projects) {
              var groupsCallback;
              groupsCallback = function groupsCallback(groups) {
                var data;
                data = groups.concat(projects);
                return finalCallback(data);
              };
              return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].groups(query.term, {}, groupsCallback);
            };
          } else {
            projectsCallback = finalCallback;
          }
          if (_this.groupId) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].groupProjects(_this.groupId, query.term, projectsCallback);
          } else {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].projects(query.term, {
              order_by: _this.orderBy,
              with_issues_enabled: _this.withIssuesEnabled,
              with_merge_requests_enabled: _this.withMergeRequestsEnabled,
              membership: !_this.allProjects
            }, projectsCallback);
          }
        };
      }(this),
      id: function id(project) {
        if (simpleFilter) return project.id;
        return JSON.stringify({
          name: project.name,
          url: project.web_url
        });
      },
      text: function text(project) {
        return project.name_with_namespace || project.name;
      },
      dropdownCssClass: "ajax-project-dropdown"
    });
    if (simpleFilter) return select;
    return new __WEBPACK_IMPORTED_MODULE_1__project_select_combo_button__["a" /* default */](select);
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./project_select_combo_button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__ = __webpack_require__("./lib/utils/accessor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ProjectSelectComboButton = function () {
  function ProjectSelectComboButton(select) {
    _classCallCheck(this, ProjectSelectComboButton);

    this.projectSelectInput = $(select);
    this.newItemBtn = $('.new-project-item-link');
    this.resourceType = this.newItemBtn.data('type');
    this.resourceLabel = this.newItemBtn.data('label');
    this.formattedText = this.deriveTextVariants();
    this.groupId = this.projectSelectInput.data('groupId');
    this.bindEvents();
    this.initLocalStorage();
  }

  _createClass(ProjectSelectComboButton, [{
    key: 'bindEvents',
    value: function bindEvents() {
      var _this = this;

      this.projectSelectInput.siblings('.new-project-item-select-button').on('click', function (e) {
        return _this.openDropdown(e);
      });

      this.newItemBtn.on('click', function (e) {
        if (!_this.getProjectFromLocalStorage()) {
          e.preventDefault();
          _this.openDropdown(e);
        }
      });

      this.projectSelectInput.on('change', function () {
        return _this.selectProject();
      });
    }
  }, {
    key: 'initLocalStorage',
    value: function initLocalStorage() {
      var localStorageIsSafe = __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe();

      if (localStorageIsSafe) {
        this.localStorageKey = ['group', this.groupId, this.formattedText.localStorageItemType, 'recent-project'].join('-');
        this.setBtnTextFromLocalStorage();
      }
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'openDropdown',
    value: function openDropdown(event) {
      $(event.currentTarget).siblings('.project-item-select').select2('open');
    }
  }, {
    key: 'selectProject',
    value: function selectProject() {
      var selectedProjectData = JSON.parse(this.projectSelectInput.val());
      var projectUrl = selectedProjectData.url + '/' + this.projectSelectInput.data('relativePath');
      var projectName = selectedProjectData.name;

      var projectMeta = {
        url: projectUrl,
        name: projectName
      };

      this.setNewItemBtnAttributes(projectMeta);
      this.setProjectInLocalStorage(projectMeta);
    }
  }, {
    key: 'setBtnTextFromLocalStorage',
    value: function setBtnTextFromLocalStorage() {
      var cachedProjectData = this.getProjectFromLocalStorage();

      this.setNewItemBtnAttributes(cachedProjectData);
    }
  }, {
    key: 'setNewItemBtnAttributes',
    value: function setNewItemBtnAttributes(project) {
      if (project) {
        this.newItemBtn.attr('href', project.url);
        this.newItemBtn.text(this.formattedText.defaultTextPrefix + ' in ' + project.name);
      } else {
        this.newItemBtn.text('\u9009\u62E9\u4E00\u4E2A\u9879\u76EE\u6765\u521B\u5EFA ' + this.formattedText.presetTextSuffix);
      }
    }
  }, {
    key: 'getProjectFromLocalStorage',
    value: function getProjectFromLocalStorage() {
      var projectString = localStorage.getItem(this.localStorageKey);

      return JSON.parse(projectString);
    }
  }, {
    key: 'setProjectInLocalStorage',
    value: function setProjectInLocalStorage(projectMeta) {
      var projectString = JSON.stringify(projectMeta);

      localStorage.setItem(this.localStorageKey, projectString);
    }
  }, {
    key: 'deriveTextVariants',
    value: function deriveTextVariants() {
      var defaultTextPrefix = this.resourceLabel;

      // the trailing slice call depluralizes each of these strings (e.g. new-issues -> new-issue)
      var localStorageItemType = 'new-' + this.resourceType.split('_').join('-').slice(0, -1);
      var presetTextSuffix = this.resourceType.split('_').join(' ').slice(0, -1);

      return {
        localStorageItemType: localStorageItemType, // new-issue / new-merge-request
        defaultTextPrefix: defaultTextPrefix, // New issue / New merge request
        presetTextSuffix: presetTextSuffix // issue / merge request
      };
    }
  }]);

  return ProjectSelectComboButton;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProjectSelectComboButton);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./right_sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-unused-vars, consistent-return, one-var, one-var-declaration-per-line, quotes, prefer-template, object-shorthand, comma-dangle, no-else-return, no-param-reassign, max-len */






function Sidebar(currentUser) {
  this.toggleTodo = this.toggleTodo.bind(this);
  this.sidebar = $('aside');

  this.removeListeners();
  this.addEventListeners();
}

Sidebar.initialize = function (currentUser) {
  if (!this.instance) {
    this.instance = new Sidebar(currentUser);
  }
};

Sidebar.prototype.removeListeners = function () {
  this.sidebar.off('click', '.sidebar-collapsed-icon');
  this.sidebar.off('hidden.gl.dropdown');
  $('.dropdown').off('loading.gl.dropdown');
  $('.dropdown').off('loaded.gl.dropdown');
  $(document).off('click', '.js-sidebar-toggle');
};

Sidebar.prototype.addEventListeners = function () {
  var $document = $(document);

  this.sidebar.on('click', '.sidebar-collapsed-icon', this, this.sidebarCollapseClicked);
  this.sidebar.on('hidden.gl.dropdown', this, this.onSidebarDropdownHidden);
  $('.dropdown').on('loading.gl.dropdown', this.sidebarDropdownLoading);
  $('.dropdown').on('loaded.gl.dropdown', this.sidebarDropdownLoaded);

  $document.on('click', '.js-sidebar-toggle', this.sidebarToggleClicked);
  return $(document).off('click', '.js-issuable-todo').on('click', '.js-issuable-todo', this.toggleTodo);
};

Sidebar.prototype.sidebarToggleClicked = function (e, triggered) {
  var $allGutterToggleIcons, $this, $thisIcon;
  e.preventDefault();
  $this = $(this);
  $thisIcon = $this.find('i');
  $allGutterToggleIcons = $('.js-sidebar-toggle i');
  if ($thisIcon.hasClass('fa-angle-double-right')) {
    $allGutterToggleIcons.removeClass('fa-angle-double-right').addClass('fa-angle-double-left');
    $('aside.right-sidebar').removeClass('right-sidebar-expanded').addClass('right-sidebar-collapsed');
    $('.layout-page').removeClass('right-sidebar-expanded').addClass('right-sidebar-collapsed');
  } else {
    $allGutterToggleIcons.removeClass('fa-angle-double-left').addClass('fa-angle-double-right');
    $('aside.right-sidebar').removeClass('right-sidebar-collapsed').addClass('right-sidebar-expanded');
    $('.layout-page').removeClass('right-sidebar-collapsed').addClass('right-sidebar-expanded');

    if (gl.lazyLoader) gl.lazyLoader.loadCheck();
  }
  if (!triggered) {
    __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set("collapsed_gutter", $('.right-sidebar').hasClass('right-sidebar-collapsed'));
  }
};

Sidebar.prototype.toggleTodo = function (e) {
  var _this = this;

  var $btnText, $this, $todoLoading, ajaxType, url;
  $this = $(e.currentTarget);
  ajaxType = $this.attr('data-delete-path') ? 'delete' : 'post';
  if ($this.attr('data-delete-path')) {
    url = "" + $this.attr('data-delete-path');
  } else {
    url = "" + $this.data('url');
  }

  $this.tooltip('hide');

  $('.js-issuable-todo').disable().addClass('is-loading');

  __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__["a" /* default */][ajaxType](url, {
    issuable_id: $this.data('issuableId'),
    issuable_type: $this.data('issuableType')
  }).then(function (_ref) {
    var data = _ref.data;

    _this.todoUpdateDone(data);
  }).catch(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])('There was an error ' + (ajaxType === 'post' ? 'adding a' : 'deleting the') + ' todo.');
  });
};

Sidebar.prototype.todoUpdateDone = function (data) {
  var deletePath = data.delete_path ? data.delete_path : null;
  var attrPrefix = deletePath ? 'mark' : 'todo';
  var $todoBtns = $('.js-issuable-todo');

  $(document).trigger('todo:toggle', data.count);

  $todoBtns.each(function (i, el) {
    var $el = $(el);
    var $elText = $el.find('.js-issuable-todo-inner');

    $el.removeClass('is-loading').enable().attr('aria-label', $el.data(attrPrefix + 'Text')).attr('data-delete-path', deletePath).attr('title', $el.data(attrPrefix + 'Text'));

    if ($el.hasClass('has-tooltip')) {
      $el.tooltip('fixTitle');
    }

    if ($el.data(attrPrefix + 'Icon')) {
      $elText.html($el.data(attrPrefix + 'Icon'));
    } else {
      $elText.text($el.data(attrPrefix + 'Text'));
    }
  });
};

Sidebar.prototype.sidebarDropdownLoading = function (e) {
  var $loading, $sidebarCollapsedIcon, i, img;
  $sidebarCollapsedIcon = $(this).closest('.block').find('.sidebar-collapsed-icon');
  img = $sidebarCollapsedIcon.find('img');
  i = $sidebarCollapsedIcon.find('i');
  $loading = $('<i class="fa fa-spinner fa-spin"></i>');
  if (img.length) {
    img.before($loading);
    return img.hide();
  } else if (i.length) {
    i.before($loading);
    return i.hide();
  }
};

Sidebar.prototype.sidebarDropdownLoaded = function (e) {
  var $sidebarCollapsedIcon, i, img;
  $sidebarCollapsedIcon = $(this).closest('.block').find('.sidebar-collapsed-icon');
  img = $sidebarCollapsedIcon.find('img');
  $sidebarCollapsedIcon.find('i.fa-spin').remove();
  i = $sidebarCollapsedIcon.find('i');
  if (img.length) {
    return img.show();
  } else {
    return i.show();
  }
};

Sidebar.prototype.sidebarCollapseClicked = function (e) {
  var $block, sidebar;
  if ($(e.currentTarget).hasClass('dont-change-state')) {
    return;
  }
  sidebar = e.data;
  e.preventDefault();
  $block = $(this).closest('.block');
  return sidebar.openDropdown($block);
};

Sidebar.prototype.openDropdown = function (blockOrName) {
  var $block;
  $block = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isString(blockOrName) ? this.getBlock(blockOrName) : blockOrName;
  if (!this.isOpen()) {
    this.setCollapseAfterUpdate($block);
    this.toggleSidebar('open');
  }

  // Wait for the sidebar to trigger('click') open
  // so it doesn't cause our dropdown to close preemptively
  setTimeout(function () {
    $block.find('.js-sidebar-dropdown-toggle').trigger('click');
  });
};

Sidebar.prototype.setCollapseAfterUpdate = function ($block) {
  $block.addClass('collapse-after-update');
  return $('.layout-page').addClass('with-overlay');
};

Sidebar.prototype.onSidebarDropdownHidden = function (e) {
  var $block, sidebar;
  sidebar = e.data;
  e.preventDefault();
  $block = $(e.target).closest('.block');
  return sidebar.sidebarDropdownHidden($block);
};

Sidebar.prototype.sidebarDropdownHidden = function ($block) {
  if ($block.hasClass('collapse-after-update')) {
    $block.removeClass('collapse-after-update');
    $('.layout-page').removeClass('with-overlay');
    return this.toggleSidebar('hide');
  }
};

Sidebar.prototype.triggerOpenSidebar = function () {
  return this.sidebar.find('.js-sidebar-toggle').trigger('click');
};

Sidebar.prototype.toggleSidebar = function (action) {
  if (action == null) {
    action = 'toggle';
  }
  if (action === 'toggle') {
    this.triggerOpenSidebar();
  }
  if (action === 'open') {
    if (!this.isOpen()) {
      this.triggerOpenSidebar();
    }
  }
  if (action === 'hide') {
    if (this.isOpen()) {
      return this.triggerOpenSidebar();
    }
  }
};

Sidebar.prototype.isOpen = function () {
  return this.sidebar.is('.right-sidebar-expanded');
};

Sidebar.prototype.getBlock = function (name) {
  return this.sidebar.find(".block." + name);
};

/* harmony default export */ __webpack_exports__["a"] = (Sidebar);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./shortcuts_issuable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__right_sidebar__ = __webpack_require__("./right_sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shortcuts__ = __webpack_require__("./shortcuts.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__behaviors_copy_as_gfm__ = __webpack_require__("./behaviors/copy_as_gfm.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ShortcutsIssuable = function (_Shortcuts) {
  _inherits(ShortcutsIssuable, _Shortcuts);

  function ShortcutsIssuable(isMergeRequest) {
    _classCallCheck(this, ShortcutsIssuable);

    var _this = _possibleConstructorReturn(this, (ShortcutsIssuable.__proto__ || Object.getPrototypeOf(ShortcutsIssuable)).call(this));

    _this.$replyField = isMergeRequest ? $('.js-main-target-form #note_note') : $('.js-main-target-form .js-vue-comment-form');

    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('a', function () {
      return ShortcutsIssuable.openSidebarDropdown('assignee');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('m', function () {
      return ShortcutsIssuable.openSidebarDropdown('milestone');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('l', function () {
      return ShortcutsIssuable.openSidebarDropdown('labels');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('r', _this.replyWithSelectedText.bind(_this));
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('e', ShortcutsIssuable.editIssue);

    if (isMergeRequest) {
      _this.enabledHelp.push('.hidden-shortcut.merge_requests');
    } else {
      _this.enabledHelp.push('.hidden-shortcut.issues');
    }
    return _this;
  }

  _createClass(ShortcutsIssuable, [{
    key: 'replyWithSelectedText',
    value: function replyWithSelectedText() {
      var documentFragment = window.gl.utils.getSelectedFragment();

      if (!documentFragment) {
        this.$replyField.focus();
        return false;
      }

      var el = __WEBPACK_IMPORTED_MODULE_4__behaviors_copy_as_gfm__["a" /* CopyAsGFM */].transformGFMSelection(documentFragment.cloneNode(true));
      var selected = __WEBPACK_IMPORTED_MODULE_4__behaviors_copy_as_gfm__["a" /* CopyAsGFM */].nodeToGFM(el);

      if (selected.trim() === '') {
        return false;
      }

      var quote = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.map(selected.split('\n'), function (val) {
        return ('> ' + val).trim() + '\n';
      });

      // If replyField already has some content, add a newline before our quote
      var separator = this.$replyField.val().trim() !== '' && '\n\n' || '';
      this.$replyField.val(function (a, current) {
        return '' + current + separator + quote.join('') + '\n';
      }).trigger('input').trigger('change');

      // Trigger autosize
      var event = document.createEvent('Event');
      event.initEvent('autosize:update', true, false);
      this.$replyField.get(0).dispatchEvent(event);

      // Focus the input field
      this.$replyField.focus();

      return false;
    }
  }], [{
    key: 'editIssue',
    value: function editIssue() {
      // Need to click the element as on issues, editing is inline
      // on merge request, editing is on a different page
      document.querySelector('.js-issuable-edit').click();

      return false;
    }
  }, {
    key: 'openSidebarDropdown',
    value: function openSidebarDropdown(name) {
      __WEBPACK_IMPORTED_MODULE_2__right_sidebar__["a" /* default */].instance.openDropdown(name);
      return false;
    }
  }]);

  return ShortcutsIssuable;
}(__WEBPACK_IMPORTED_MODULE_3__shortcuts__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ShortcutsIssuable);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./sidebar/components/assignees/assignee_title.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AssigneeTitle',
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    numberOfAssignees: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    },
    showToggle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    assigneeTitle: function assigneeTitle() {
      var assignees = this.numberOfAssignees;
      return assignees > 1 ? assignees + ' \u4E2A\u6307\u6D3E' : '个指派';
    }
  },
  template: '\n    <div class="title hide-collapsed">\n      {{assigneeTitle}}\n      <i\n        v-if="loading"\n        aria-hidden="true"\n        class="fa fa-spinner fa-spin block-loading"\n      />\n      <a\n        v-if="editable"\n        class="js-sidebar-dropdown-toggle edit-link pull-right"\n        href="#"\n      >\n        {{ __(\'Edit\') }}\n      </a>\n      <a\n        v-if="showToggle"\n        aria-label="Toggle sidebar"\n        class="gutter-toggle pull-right js-sidebar-toggle"\n        href="#"\n        role="button"\n      >\n        <i\n          aria-hidden="true"\n          data-hidden="true"\n          class="fa fa-angle-double-right"\n        />\n      </a>\n    </div>\n  '
});

/***/ }),

/***/ "./sidebar/components/assignees/assignees.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/assignees/assignees.vue

/* harmony default export */ var assignees = ({
  name: 'Assignees',
  props: {
    rootPath: {
      type: String,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      defaultRenderCount: 5,
      defaultMaxCounter: 99,
      showLess: true
    };
  },

  computed: {
    firstUser: function firstUser() {
      return this.users[0];
    },
    hasMoreThanTwoAssignees: function hasMoreThanTwoAssignees() {
      return this.users.length > 2;
    },
    hasMoreThanOneAssignee: function hasMoreThanOneAssignee() {
      return this.users.length > 1;
    },
    hasAssignees: function hasAssignees() {
      return this.users.length > 0;
    },
    hasNoUsers: function hasNoUsers() {
      return !this.users.length;
    },
    hasOneUser: function hasOneUser() {
      return this.users.length === 1;
    },
    renderShowMoreSection: function renderShowMoreSection() {
      return this.users.length > this.defaultRenderCount;
    },
    numberOfHiddenAssignees: function numberOfHiddenAssignees() {
      return this.users.length - this.defaultRenderCount;
    },
    isHiddenAssignees: function isHiddenAssignees() {
      return this.numberOfHiddenAssignees > 0;
    },
    hiddenAssigneesLabel: function hiddenAssigneesLabel() {
      return '+ ' + this.numberOfHiddenAssignees + ' more';
    },
    collapsedTooltipTitle: function collapsedTooltipTitle() {
      var maxRender = Math.min(this.defaultRenderCount, this.users.length);
      var renderUsers = this.users.slice(0, maxRender);
      var names = renderUsers.map(function (u) {
        return u.name;
      });

      if (this.users.length > maxRender) {
        names.push('+ ' + (this.users.length - maxRender) + ' more');
      }

      return names.join(', ');
    },
    sidebarAvatarCounter: function sidebarAvatarCounter() {
      var counter = '+' + (this.users.length - 1);

      if (this.users.length > this.defaultMaxCounter) {
        counter = this.defaultMaxCounter + '+';
      }

      return counter;
    }
  },
  methods: {
    assignSelf: function assignSelf() {
      this.$emit('assign-self');
    },
    toggleShowLess: function toggleShowLess() {
      this.showLess = !this.showLess;
    },
    renderAssignee: function renderAssignee(index) {
      return !this.showLess || index < this.defaultRenderCount && this.showLess;
    },
    avatarUrl: function avatarUrl(user) {
      return user.avatar || user.avatar_url || gon.default_avatar_url;
    },
    assigneeUrl: function assigneeUrl(user) {
      return '' + this.rootPath + user.username;
    },
    assigneeAlt: function assigneeAlt(user) {
      return user.name + '\'s avatar';
    },
    assigneeUsername: function assigneeUsername(user) {
      return '@' + user.username;
    },
    shouldRenderCollapsedAssignee: function shouldRenderCollapsedAssignee(index) {
      var firstTwo = this.users.length <= 2 && index <= 2;

      return index === 0 || firstTwo;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ce02b48","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/assignees/assignees.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar-collapsed-icon sidebar-collapsed-user",class:{ 'multiple-users': _vm.hasMoreThanOneAssignee, 'has-tooltip': _vm.hasAssignees },attrs:{"data-container":"body","data-placement":"left","title":_vm.collapsedTooltipTitle}},[(_vm.hasNoUsers)?_c('i',{staticClass:"fa fa-user",attrs:{"aria-label":"No Assignee"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.users),function(user,index){return (_vm.shouldRenderCollapsedAssignee(index))?_c('button',{key:user.id,staticClass:"btn-link",attrs:{"type":"button"}},[_c('img',{staticClass:"avatar avatar-inline s24",attrs:{"width":"24","alt":_vm.assigneeAlt(user),"src":_vm.avatarUrl(user)}}),_vm._v(" "),_c('span',{staticClass:"author"},[_vm._v("\n        "+_vm._s(user.name)+"\n      ")])]):_vm._e()}),_vm._v(" "),(_vm.hasMoreThanTwoAssignees)?_c('button',{staticClass:"btn-link",attrs:{"type":"button"}},[_c('span',{staticClass:"avatar-counter sidebar-avatar-counter"},[_vm._v("\n        "+_vm._s(_vm.sidebarAvatarCounter)+"\n      ")])]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"value hide-collapsed"},[(_vm.hasNoUsers)?[_c('span',{staticClass:"assign-yourself no-value"},[_vm._v("\n        No assignee\n        "),(_vm.editable)?[_vm._v("\n          -\n          "),_c('button',{staticClass:"btn-link",attrs:{"type":"button"},on:{"click":_vm.assignSelf}},[_vm._v("\n            assign yourself\n          ")])]:_vm._e()],2)]:(_vm.hasOneUser)?[_c('a',{staticClass:"author_link bold",attrs:{"href":_vm.assigneeUrl(_vm.firstUser)}},[_c('img',{staticClass:"avatar avatar-inline s32",attrs:{"width":"32","alt":_vm.assigneeAlt(_vm.firstUser),"src":_vm.avatarUrl(_vm.firstUser)}}),_vm._v(" "),_c('span',{staticClass:"author"},[_vm._v("\n          "+_vm._s(_vm.firstUser.name)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"username"},[_vm._v("\n          "+_vm._s(_vm.assigneeUsername(_vm.firstUser))+"\n        ")])])]:[_c('div',{staticClass:"user-list"},_vm._l((_vm.users),function(user,index){return (_vm.renderAssignee(index))?_c('div',{key:user.id,staticClass:"user-item"},[_c('a',{staticClass:"user-link has-tooltip",attrs:{"data-container":"body","data-placement":"bottom","href":_vm.assigneeUrl(user),"data-title":user.name}},[_c('img',{staticClass:"avatar avatar-inline s32",attrs:{"width":"32","alt":_vm.assigneeAlt(user),"src":_vm.avatarUrl(user)}})])]):_vm._e()})),_vm._v(" "),(_vm.renderShowMoreSection)?_c('div',{staticClass:"user-list-more"},[_c('button',{staticClass:"btn-link",attrs:{"type":"button"},on:{"click":_vm.toggleShowLess}},[(_vm.showLess)?[_vm._v("\n            "+_vm._s(_vm.hiddenAssigneesLabel)+"\n          ")]:[_vm._v("\n            - show less\n          ")]],2)]):_vm._e()]],2)])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/assignees/assignees.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  assignees,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var assignees_assignees = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./sidebar/components/assignees/sidebar_assignees.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./sidebar/components/assignees/assignee_title.js
var assignee_title = __webpack_require__("./sidebar/components/assignees/assignee_title.js");

// EXTERNAL MODULE: ./sidebar/components/assignees/assignees.vue + 2 modules
var assignees = __webpack_require__("./sidebar/components/assignees/assignees.vue");

// EXTERNAL MODULE: ./sidebar/stores/sidebar_store.js
var sidebar_store = __webpack_require__("./sidebar/stores/sidebar_store.js");

// EXTERNAL MODULE: ./sidebar/event_hub.js
var event_hub = __webpack_require__("./sidebar/event_hub.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/assignees/sidebar_assignees.vue







/* harmony default export */ var sidebar_assignees = ({
  name: 'SidebarAssignees',
  components: {
    AssigneeTitle: assignee_title["a" /* default */],
    Assignees: assignees["a" /* default */]
  },
  props: {
    mediator: {
      type: Object,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    signedIn: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      store: new sidebar_store["a" /* default */](),
      loading: false
    };
  },
  created: function created() {
    this.removeAssignee = this.store.removeAssignee.bind(this.store);
    this.addAssignee = this.store.addAssignee.bind(this.store);
    this.removeAllAssignees = this.store.removeAllAssignees.bind(this.store);

    // Get events from glDropdown
    event_hub["a" /* default */].$on('sidebar.removeAssignee', this.removeAssignee);
    event_hub["a" /* default */].$on('sidebar.addAssignee', this.addAssignee);
    event_hub["a" /* default */].$on('sidebar.removeAllAssignees', this.removeAllAssignees);
    event_hub["a" /* default */].$on('sidebar.saveAssignees', this.saveAssignees);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('sidebar.removeAssignee', this.removeAssignee);
    event_hub["a" /* default */].$off('sidebar.addAssignee', this.addAssignee);
    event_hub["a" /* default */].$off('sidebar.removeAllAssignees', this.removeAllAssignees);
    event_hub["a" /* default */].$off('sidebar.saveAssignees', this.saveAssignees);
  },

  methods: {
    assignSelf: function assignSelf() {
      // Notify gl dropdown that we are now assigning to current user
      this.$el.parentElement.dispatchEvent(new Event('assignYourself'));

      this.mediator.assignYourself();
      this.saveAssignees();
    },
    saveAssignees: function saveAssignees() {
      this.loading = true;

      function setLoadingFalse() {
        this.loading = false;
      }

      this.mediator.saveAssignees(this.field).then(setLoadingFalse.bind(this)).catch(function () {
        setLoadingFalse();
        return new flash["a" /* default */]('Error occurred when saving assignees');
      });
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1589a2dd","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/assignees/sidebar_assignees.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('assignee-title',{attrs:{"number-of-assignees":_vm.store.assignees.length,"loading":_vm.loading || _vm.store.isFetching.assignees,"editable":_vm.store.editable,"show-toggle":!_vm.signedIn}}),_vm._v(" "),(!_vm.store.isFetching.assignees)?_c('assignees',{staticClass:"value",attrs:{"root-path":_vm.store.rootPath,"users":_vm.store.assignees,"editable":_vm.store.editable},on:{"assign-self":_vm.assignSelf}}):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/assignees/sidebar_assignees.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sidebar_assignees,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var assignees_sidebar_assignees = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./sidebar/components/confidential/confidential_issue_sidebar.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/confidential/edit_form_buttons.vue

/* harmony default export */ var edit_form_buttons = ({
  props: {
    isConfidential: {
      required: true,
      type: Boolean
    },
    toggleForm: {
      required: true,
      type: Function
    },
    updateConfidentialAttribute: {
      required: true,
      type: Function
    }
  },
  computed: {
    toggleButtonText: function toggleButtonText() {
      return this.isConfidential ? '禁用' : '启用';
    },
    updateConfidentialBool: function updateConfidentialBool() {
      return !this.isConfidential;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9f34c0a","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/confidential/edit_form_buttons.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-item-warning-message-actions"},[_c('button',{staticClass:"btn btn-default append-right-10",attrs:{"type":"button"},on:{"click":_vm.toggleForm}},[_vm._v("\n    "+_vm._s(_vm.__('Cancel'))+"\n  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-close",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.updateConfidentialAttribute(_vm.updateConfidentialBool)}}},[_vm._v("\n    "+_vm._s(_vm.toggleButtonText)+"\n  ")])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/confidential/edit_form_buttons.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  edit_form_buttons,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var confidential_edit_form_buttons = (Component.exports);

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/confidential/edit_form.vue




/* harmony default export */ var edit_form = ({
  components: {
    editFormButtons: confidential_edit_form_buttons
  },
  props: {
    isConfidential: {
      required: true,
      type: Boolean
    },
    toggleForm: {
      required: true,
      type: Function
    },
    updateConfidentialAttribute: {
      required: true,
      type: Function
    }
  },
  computed: {
    confidentialityOnWarning: function confidentialityOnWarning() {
      return Object(locale["e" /* s__ */])('confidentiality|You are going to turn on the confidentiality. This means that only team members with <strong>at least Reporter access</strong> are able to see and leave comments on the issue.');
    },
    confidentialityOffWarning: function confidentialityOffWarning() {
      return Object(locale["e" /* s__ */])('confidentiality|You are going to turn off the confidentiality. This means <strong>everyone</strong> will be able to see and leave a comment on this issue.');
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-562b52c5","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/confidential/edit_form.vue
var edit_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown open"},[_c('div',{staticClass:"dropdown-menu sidebar-item-warning-message"},[_c('div',[(!_vm.isConfidential)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.confidentialityOnWarning)}}):_c('p',{domProps:{"innerHTML":_vm._s(_vm.confidentialityOffWarning)}}),_vm._v(" "),_c('edit-form-buttons',{attrs:{"is-confidential":_vm.isConfidential,"toggle-form":_vm.toggleForm,"update-confidential-attribute":_vm.updateConfidentialAttribute}})],1)])])}
var edit_form_staticRenderFns = []

// CONCATENATED MODULE: ./sidebar/components/confidential/edit_form.vue
/* script */


/* template */

/* template functional */
var edit_form___vue_template_functional__ = false
/* styles */
var edit_form___vue_styles__ = null
/* scopeId */
var edit_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var edit_form___vue_module_identifier__ = null

var edit_form_Component = Object(component_normalizer["a" /* default */])(
  edit_form,
  edit_form_render,
  edit_form_staticRenderFns,
  edit_form___vue_template_functional__,
  edit_form___vue_styles__,
  edit_form___vue_scopeId__,
  edit_form___vue_module_identifier__
)

/* harmony default export */ var confidential_edit_form = (edit_form_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/confidential/confidential_issue_sidebar.vue






/* harmony default export */ var confidential_issue_sidebar = ({
  components: {
    editForm: confidential_edit_form,
    Icon: icon["a" /* default */]
  },
  props: {
    isConfidential: {
      required: true,
      type: Boolean
    },
    isEditable: {
      required: true,
      type: Boolean
    },
    service: {
      required: true,
      type: Object
    }
  },
  data: function data() {
    return {
      edit: false
    };
  },

  computed: {
    confidentialityIcon: function confidentialityIcon() {
      return this.isConfidential ? 'eye-slash' : 'eye';
    }
  },
  methods: {
    toggleForm: function toggleForm() {
      this.edit = !this.edit;
    },
    updateConfidentialAttribute: function updateConfidentialAttribute(confidential) {
      this.service.update('issue', { confidential: confidential }).then(function () {
        return location.reload();
      }).catch(function () {
        Object(flash["a" /* default */])(Object(locale["a" /* __ */])('Something went wrong trying to change the confidentiality of this issue'));
      });
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5945913e","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/confidential/confidential_issue_sidebar.vue
var confidential_issue_sidebar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block issuable-sidebar-item confidentiality"},[_c('div',{staticClass:"sidebar-collapsed-icon"},[_c('icon',{attrs:{"name":_vm.confidentialityIcon,"size":16,"aria-hidden":"true"}})],1),_vm._v(" "),_c('div',{staticClass:"title hide-collapsed"},[_vm._v("\n    "+_vm._s(_vm.__('Confidentiality'))+"\n    "),(_vm.isEditable)?_c('a',{staticClass:"pull-right confidential-edit",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleForm($event)}}},[_vm._v("\n      "+_vm._s(_vm.__('Edit'))+"\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"value sidebar-item-value hide-collapsed"},[(_vm.edit)?_c('editForm',{attrs:{"toggle-form":_vm.toggleForm,"is-confidential":_vm.isConfidential,"update-confidential-attribute":_vm.updateConfidentialAttribute}}):_vm._e(),_vm._v(" "),(!_vm.isConfidential)?_c('div',{staticClass:"no-value sidebar-item-value"},[_c('icon',{staticClass:"sidebar-item-icon inline",attrs:{"name":"eye","size":16,"aria-hidden":"true"}}),_vm._v("\n      "+_vm._s(_vm.__('Not confidential'))+"\n    ")],1):_c('div',{staticClass:"value sidebar-item-value hide-collapsed"},[_c('icon',{staticClass:"sidebar-item-icon inline is-active",attrs:{"name":"eye-slash","size":16,"aria-hidden":"true"}}),_vm._v("\n      "+_vm._s(_vm.__('This issue is confidential'))+"\n    ")],1)],1)])}
var confidential_issue_sidebar_staticRenderFns = []

// CONCATENATED MODULE: ./sidebar/components/confidential/confidential_issue_sidebar.vue
/* script */


/* template */

/* template functional */
var confidential_issue_sidebar___vue_template_functional__ = false
/* styles */
var confidential_issue_sidebar___vue_styles__ = null
/* scopeId */
var confidential_issue_sidebar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var confidential_issue_sidebar___vue_module_identifier__ = null

var confidential_issue_sidebar_Component = Object(component_normalizer["a" /* default */])(
  confidential_issue_sidebar,
  confidential_issue_sidebar_render,
  confidential_issue_sidebar_staticRenderFns,
  confidential_issue_sidebar___vue_template_functional__,
  confidential_issue_sidebar___vue_styles__,
  confidential_issue_sidebar___vue_scopeId__,
  confidential_issue_sidebar___vue_module_identifier__
)

/* harmony default export */ var confidential_confidential_issue_sidebar = __webpack_exports__["a"] = (confidential_issue_sidebar_Component.exports);


/***/ }),

/***/ "./sidebar/components/lock/lock_issue_sidebar.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/lock/edit_form_buttons.vue

/* harmony default export */ var edit_form_buttons = ({
  props: {
    isLocked: {
      required: true,
      type: Boolean
    },

    toggleForm: {
      required: true,
      type: Function
    },

    updateLockedAttribute: {
      required: true,
      type: Function
    }
  },

  computed: {
    buttonText: function buttonText() {
      return this.isLocked ? this.__('Unlock') : this.__('Lock');
    },
    toggleLock: function toggleLock() {
      return !this.isLocked;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-393c72f5","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/lock/edit_form_buttons.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-item-warning-message-actions"},[_c('button',{staticClass:"btn btn-default append-right-10",attrs:{"type":"button"},on:{"click":_vm.toggleForm}},[_vm._v("\n    "+_vm._s(_vm.__('Cancel'))+"\n  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-close",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.updateLockedAttribute(_vm.toggleLock)}}},[_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n  ")])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/lock/edit_form_buttons.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  edit_form_buttons,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var lock_edit_form_buttons = (Component.exports);

// EXTERNAL MODULE: ./vue_shared/mixins/issuable.js
var issuable = __webpack_require__("./vue_shared/mixins/issuable.js");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/lock/edit_form.vue





/* harmony default export */ var edit_form = ({
  components: {
    editFormButtons: lock_edit_form_buttons
  },
  mixins: [issuable["a" /* default */]],
  props: {
    isLocked: {
      required: true,
      type: Boolean
    },

    toggleForm: {
      required: true,
      type: Function
    },

    updateLockedAttribute: {
      required: true,
      type: Function
    }
  },
  computed: {
    lockWarning: function lockWarning() {
      return Object(locale["f" /* sprintf */])(Object(locale["a" /* __ */])('Lock this %{issuableDisplayName}? Only <strong>project members</strong> will be able to comment.'), { issuableDisplayName: this.issuableDisplayName });
    },
    unlockWarning: function unlockWarning() {
      return Object(locale["f" /* sprintf */])(Object(locale["a" /* __ */])('Unlock this %{issuableDisplayName}? <strong>Everyone</strong> will be able to comment.'), { issuableDisplayName: this.issuableDisplayName });
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3432d361","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/lock/edit_form.vue
var edit_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown open"},[_c('div',{staticClass:"dropdown-menu sidebar-item-warning-message"},[(_vm.isLocked)?_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.unlockWarning)}}):_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.lockWarning)}}),_vm._v(" "),_c('edit-form-buttons',{attrs:{"is-locked":_vm.isLocked,"toggle-form":_vm.toggleForm,"update-locked-attribute":_vm.updateLockedAttribute}})],1)])}
var edit_form_staticRenderFns = []

// CONCATENATED MODULE: ./sidebar/components/lock/edit_form.vue
/* script */


/* template */

/* template functional */
var edit_form___vue_template_functional__ = false
/* styles */
var edit_form___vue_styles__ = null
/* scopeId */
var edit_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var edit_form___vue_module_identifier__ = null

var edit_form_Component = Object(component_normalizer["a" /* default */])(
  edit_form,
  edit_form_render,
  edit_form_staticRenderFns,
  edit_form___vue_template_functional__,
  edit_form___vue_styles__,
  edit_form___vue_scopeId__,
  edit_form___vue_module_identifier__
)

/* harmony default export */ var lock_edit_form = (edit_form_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/lock/lock_issue_sidebar.vue






/* harmony default export */ var lock_issue_sidebar = ({
  components: {
    editForm: lock_edit_form,
    Icon: icon["a" /* default */]
  },
  mixins: [issuable["a" /* default */]],

  props: {
    isLocked: {
      required: true,
      type: Boolean
    },

    isEditable: {
      required: true,
      type: Boolean
    },

    mediator: {
      required: true,
      type: Object,
      validator: function validator(mediatorObject) {
        return mediatorObject.service && mediatorObject.service.update && mediatorObject.store;
      }
    }
  },

  computed: {
    lockIcon: function lockIcon() {
      return this.isLocked ? 'lock' : 'lock-open';
    },
    isLockDialogOpen: function isLockDialogOpen() {
      return this.mediator.store.isLockDialogOpen;
    }
  },

  methods: {
    toggleForm: function toggleForm() {
      this.mediator.store.isLockDialogOpen = !this.mediator.store.isLockDialogOpen;
    },
    updateLockedAttribute: function updateLockedAttribute(locked) {
      var _this = this;

      this.mediator.service.update(this.issuableType, {
        discussion_locked: locked
      }).then(function () {
        return location.reload();
      }).catch(function () {
        return Object(flash["a" /* default */])(_this.__('Something went wrong trying to change the locked state of this ' + _this.issuableDisplayName));
      });
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46351bb8","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/lock/lock_issue_sidebar.vue
var lock_issue_sidebar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block issuable-sidebar-item lock"},[_c('div',{staticClass:"sidebar-collapsed-icon"},[_c('icon',{staticClass:"sidebar-item-icon is-active",attrs:{"name":_vm.lockIcon,"size":16,"aria-hidden":"true"}})],1),_vm._v(" "),_c('div',{staticClass:"title hide-collapsed"},[_vm._v("\n    "+_vm._s(_vm.sprintf(_vm.__('Lock %{issuableDisplayName}'), { issuableDisplayName: _vm.issuableDisplayName }))+"\n    "),(_vm.isEditable)?_c('button',{staticClass:"pull-right lock-edit",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.toggleForm($event)}}},[_vm._v("\n      "+_vm._s(_vm.__('Edit'))+"\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"value sidebar-item-value hide-collapsed"},[(_vm.isLockDialogOpen)?_c('edit-form',{attrs:{"toggle-form":_vm.toggleForm,"is-locked":_vm.isLocked,"update-locked-attribute":_vm.updateLockedAttribute,"issuable-type":_vm.issuableType}}):_vm._e(),_vm._v(" "),(_vm.isLocked)?_c('div',{staticClass:"value sidebar-item-value"},[_c('icon',{staticClass:"sidebar-item-icon inline is-active",attrs:{"name":"lock","size":16,"aria-hidden":"true"}}),_vm._v("\n      "+_vm._s(_vm.__('Locked'))+"\n    ")],1):_c('div',{staticClass:"no-value sidebar-item-value hide-collapsed"},[_c('icon',{staticClass:"sidebar-item-icon inline",attrs:{"name":"lock-open","size":16,"aria-hidden":"true"}}),_vm._v("\n      "+_vm._s(_vm.__('Unlocked'))+"\n    ")],1)],1)])}
var lock_issue_sidebar_staticRenderFns = []

// CONCATENATED MODULE: ./sidebar/components/lock/lock_issue_sidebar.vue
/* script */


/* template */

/* template functional */
var lock_issue_sidebar___vue_template_functional__ = false
/* styles */
var lock_issue_sidebar___vue_styles__ = null
/* scopeId */
var lock_issue_sidebar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var lock_issue_sidebar___vue_module_identifier__ = null

var lock_issue_sidebar_Component = Object(component_normalizer["a" /* default */])(
  lock_issue_sidebar,
  lock_issue_sidebar_render,
  lock_issue_sidebar_staticRenderFns,
  lock_issue_sidebar___vue_template_functional__,
  lock_issue_sidebar___vue_styles__,
  lock_issue_sidebar___vue_scopeId__,
  lock_issue_sidebar___vue_module_identifier__
)

/* harmony default export */ var lock_lock_issue_sidebar = __webpack_exports__["a"] = (lock_issue_sidebar_Component.exports);


/***/ }),

/***/ "./sidebar/components/participants/sidebar_participants.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./sidebar/stores/sidebar_store.js
var sidebar_store = __webpack_require__("./sidebar/stores/sidebar_store.js");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue + 2 modules
var user_avatar_image = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/participants/participants.vue





/* harmony default export */ var participants = ({
  components: {
    loadingIcon: loading_icon["a" /* default */],
    userAvatarImage: user_avatar_image["a" /* default */]
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    participants: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    numberOfLessParticipants: {
      type: Number,
      required: false,
      default: 7
    }
  },
  data: function data() {
    return {
      isShowingMoreParticipants: false
    };
  },

  computed: {
    lessParticipants: function lessParticipants() {
      return this.participants.slice(0, this.numberOfLessParticipants);
    },
    visibleParticipants: function visibleParticipants() {
      return this.isShowingMoreParticipants ? this.participants : this.lessParticipants;
    },
    hasMoreParticipants: function hasMoreParticipants() {
      return this.participants.length > this.numberOfLessParticipants;
    },
    toggleLabel: function toggleLabel() {
      var label = '';
      if (this.isShowingMoreParticipants) {
        label = Object(locale["a" /* __ */])('- show less');
      } else {
        label = Object(locale["f" /* sprintf */])(Object(locale["a" /* __ */])('+ %{moreCount} more'), {
          moreCount: this.participants.length - this.numberOfLessParticipants
        });
      }

      return label;
    },
    participantLabel: function participantLabel() {
      return Object(locale["f" /* sprintf */])(Object(locale["d" /* n__ */])('%{count} participant', '%{count} participants', this.participants.length), { count: this.loading ? '' : this.participantCount });
    },
    participantCount: function participantCount() {
      return this.participants.length;
    }
  },
  methods: {
    toggleMoreParticipants: function toggleMoreParticipants() {
      this.isShowingMoreParticipants = !this.isShowingMoreParticipants;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e3b61e6","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/participants/participants.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar-collapsed-icon"},[_c('i',{staticClass:"fa fa-users",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.loading)?_c('loading-icon',{staticClass:"js-participants-collapsed-loading-icon"}):_c('span',{staticClass:"js-participants-collapsed-count"},[_vm._v("\n      "+_vm._s(_vm.participantCount)+"\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"title hide-collapsed"},[(_vm.loading)?_c('loading-icon',{staticClass:"js-participants-expanded-loading-icon",attrs:{"inline":true}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.participantLabel)+"\n  ")],1),_vm._v(" "),_c('div',{staticClass:"participants-list hide-collapsed"},_vm._l((_vm.visibleParticipants),function(participant){return _c('div',{key:participant.id,staticClass:"participants-author js-participants-author"},[_c('a',{staticClass:"author_link",attrs:{"href":participant.web_url}},[_c('user-avatar-image',{attrs:{"lazy":true,"img-src":participant.avatar_url,"css-classes":"avatar-inline","size":24,"tooltip-text":participant.name,"tooltip-placement":"bottom"}})],1)])})),_vm._v(" "),(_vm.hasMoreParticipants)?_c('div',{staticClass:"participants-more hide-collapsed"},[_c('button',{staticClass:"btn-transparent btn-blank js-toggle-participants-button",attrs:{"type":"button"},on:{"click":_vm.toggleMoreParticipants}},[_vm._v("\n      "+_vm._s(_vm.toggleLabel)+"\n    ")])]):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/participants/participants.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  participants,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var participants_participants = (Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/participants/sidebar_participants.vue




/* harmony default export */ var sidebar_participants = ({
  components: {
    participants: participants_participants
  },
  props: {
    mediator: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      store: new sidebar_store["a" /* default */]()
    };
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ce48697","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/participants/sidebar_participants.vue
var sidebar_participants_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block participants"},[_c('participants',{attrs:{"loading":_vm.store.isFetching.participants,"participants":_vm.store.participants,"number-of-less-participants":7}})],1)}
var sidebar_participants_staticRenderFns = []

// CONCATENATED MODULE: ./sidebar/components/participants/sidebar_participants.vue
/* script */


/* template */

/* template functional */
var sidebar_participants___vue_template_functional__ = false
/* styles */
var sidebar_participants___vue_styles__ = null
/* scopeId */
var sidebar_participants___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sidebar_participants___vue_module_identifier__ = null

var sidebar_participants_Component = Object(component_normalizer["a" /* default */])(
  sidebar_participants,
  sidebar_participants_render,
  sidebar_participants_staticRenderFns,
  sidebar_participants___vue_template_functional__,
  sidebar_participants___vue_styles__,
  sidebar_participants___vue_scopeId__,
  sidebar_participants___vue_module_identifier__
)

/* harmony default export */ var participants_sidebar_participants = __webpack_exports__["a"] = (sidebar_participants_Component.exports);


/***/ }),

/***/ "./sidebar/components/subscriptions/sidebar_subscriptions.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./sidebar/stores/sidebar_store.js
var sidebar_store = __webpack_require__("./sidebar/stores/sidebar_store.js");

// EXTERNAL MODULE: ./sidebar/event_hub.js
var event_hub = __webpack_require__("./sidebar/event_hub.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./sidebar/components/subscriptions/subscriptions.vue + 2 modules
var subscriptions = __webpack_require__("./sidebar/components/subscriptions/subscriptions.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/subscriptions/sidebar_subscriptions.vue







/* harmony default export */ var sidebar_subscriptions = ({
  components: {
    subscriptions: subscriptions["a" /* default */]
  },
  props: {
    mediator: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      store: new sidebar_store["a" /* default */]()
    };
  },
  created: function created() {
    event_hub["a" /* default */].$on('toggleSubscription', this.onToggleSubscription);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('toggleSubscription', this.onToggleSubscription);
  },

  methods: {
    onToggleSubscription: function onToggleSubscription() {
      this.mediator.toggleSubscription().catch(function () {
        Object(flash["a" /* default */])(Object(locale["a" /* __ */])('Error occurred when toggling the notification subscription'));
      });
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a64caa4","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/subscriptions/sidebar_subscriptions.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block subscriptions"},[_c('subscriptions',{attrs:{"loading":_vm.store.isFetching.subscriptions,"subscribed":_vm.store.subscribed}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/subscriptions/sidebar_subscriptions.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sidebar_subscriptions,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var subscriptions_sidebar_subscriptions = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./sidebar/components/subscriptions/subscriptions.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/toggle_button.vue + 2 modules
var toggle_button = __webpack_require__("./vue_shared/components/toggle_button.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./sidebar/event_hub.js
var event_hub = __webpack_require__("./sidebar/event_hub.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/subscriptions/subscriptions.vue







var ICON_ON = 'notifications';
var ICON_OFF = 'notifications-off';
var LABEL_ON = Object(locale["a" /* __ */])('Notifications on');
var LABEL_OFF = Object(locale["a" /* __ */])('Notifications off');

/* harmony default export */ var subscriptions = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    icon: icon["a" /* default */],
    toggleButton: toggle_button["a" /* default */]
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    subscribed: {
      type: Boolean,
      required: false,
      default: null
    },
    id: {
      type: Number,
      required: false,
      default: null
    }
  },
  computed: {
    showLoadingState: function showLoadingState() {
      return this.subscribed === null;
    },
    notificationIcon: function notificationIcon() {
      return this.subscribed ? ICON_ON : ICON_OFF;
    },
    notificationTooltip: function notificationTooltip() {
      return this.subscribed ? LABEL_ON : LABEL_OFF;
    }
  },
  methods: {
    toggleSubscription: function toggleSubscription() {
      event_hub["a" /* default */].$emit('toggleSubscription', this.id);
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-999c2692","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/subscriptions/subscriptions.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar-collapsed-icon"},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],attrs:{"title":_vm.notificationTooltip,"data-container":"body","data-placement":"left"}},[_c('icon',{staticClass:"sidebar-item-icon is-active",attrs:{"name":_vm.notificationIcon,"size":16,"aria-hidden":"true"}})],1)]),_vm._v(" "),_c('span',{staticClass:"issuable-header-text hide-collapsed pull-left"},[_vm._v("\n    "+_vm._s(_vm.__('Notifications'))+"\n  ")]),_vm._v(" "),_c('toggle-button',{ref:"toggleButton",staticClass:"pull-right hide-collapsed js-issuable-subscribe-button",attrs:{"is-loading":_vm.showLoadingState,"value":_vm.subscribed},on:{"change":_vm.toggleSubscription}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/subscriptions/subscriptions.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  subscriptions,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var subscriptions_subscriptions = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./sidebar/components/time_tracking/sidebar_time_tracking.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__smart_interval__ = __webpack_require__("./smart_interval.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__time_tracker_vue__ = __webpack_require__("./sidebar/components/time_tracking/time_tracker.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_sidebar_store__ = __webpack_require__("./sidebar/stores/sidebar_store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sidebar_mediator__ = __webpack_require__("./sidebar/sidebar_mediator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_hub__ = __webpack_require__("./sidebar/event_hub.js");










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      mediator: new __WEBPACK_IMPORTED_MODULE_4__sidebar_mediator__["a" /* default */](),
      store: new __WEBPACK_IMPORTED_MODULE_3__stores_sidebar_store__["a" /* default */]()
    };
  },

  components: {
    IssuableTimeTracker: __WEBPACK_IMPORTED_MODULE_2__time_tracker_vue__["a" /* default */]
  },
  methods: {
    listenForQuickActions: function listenForQuickActions() {
      var _this = this;

      $(document).on('ajax:success', '.gfm-form', this.quickActionListened);
      __WEBPACK_IMPORTED_MODULE_5__event_hub__["a" /* default */].$on('timeTrackingUpdated', function (data) {
        _this.quickActionListened(null, data);
      });
    },
    quickActionListened: function quickActionListened(e, data) {
      var subscribedCommands = ['spend_time', 'time_estimate'];
      var changedCommands = void 0;
      if (data !== undefined) {
        changedCommands = data.commands_changes ? Object.keys(data.commands_changes) : [];
      } else {
        changedCommands = [];
      }
      if (changedCommands && __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection(subscribedCommands, changedCommands).length) {
        this.mediator.fetch();
      }
    }
  },
  mounted: function mounted() {
    this.listenForQuickActions();
  },

  template: '\n    <div class="block">\n      <issuable-time-tracker\n        :time_estimate="store.timeEstimate"\n        :time_spent="store.totalTimeSpent"\n        :human_time_estimate="store.humanTimeEstimate"\n        :human_time_spent="store.humanTotalTimeSpent"\n        :rootPath="store.rootPath"\n      />\n    </div>\n  '
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./sidebar/components/time_tracking/time_tracker.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// CONCATENATED MODULE: ./sidebar/components/time_tracking/help_state.js


/* harmony default export */ var help_state = ({
  name: 'time-tracking-help-state',
  props: {
    rootPath: {
      type: String,
      required: true
    }
  },
  computed: {
    href: function href() {
      return this.rootPath + 'help/workflow/time_tracking.md';
    },
    estimateText: function estimateText() {
      return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('estimateCommand|%{slash_command} will update the estimated time with the latest command.'), {
        slash_command: '<code>/estimate</code>'
      }, false);
    },
    spendText: function spendText() {
      return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('spendCommand|%{slash_command} will update the sum of the time spent.'), {
        slash_command: '<code>/spend</code>'
      }, false);
    }
  },
  template: '\n    <div class="time-tracking-help-state">\n      <div class="time-tracking-info">\n        <h4>\n          {{ __(\'Track time with quick actions\') }}\n        </h4>\n        <p>\n          {{ __(\'Quick actions can be used in the issues description and comment boxes.\') }}\n        </p>\n        <p v-html="estimateText">\n        </p>\n        <p v-html="spendText">\n        </p>\n        <a\n          class="btn btn-default learn-more-button"\n          :href="href"\n        >\n          {{ __(\'Learn more\') }}\n        </a>\n      </div>\n    </div>\n  '
});
// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_stopwatch.svg
var _icon_stopwatch = __webpack_require__("../../views/shared/icons/_icon_stopwatch.svg");
var _icon_stopwatch_default = /*#__PURE__*/__webpack_require__.n(_icon_stopwatch);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// CONCATENATED MODULE: ./lib/utils/pretty_time.js


/*
 * TODO: Make these methods more configurable (e.g. stringifyTime condensed or
 * non-condensed, abbreviateTimelengths)
 * */

/*
 * Accepts seconds and returns a timeObject { weeks: #, days: #, hours: #, minutes: # }
 * Seconds can be negative or positive, zero or non-zero. Can be configured for any day
 * or week length.
*/

function parseSeconds(seconds) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$daysPerWeek = _ref.daysPerWeek,
      daysPerWeek = _ref$daysPerWeek === undefined ? 5 : _ref$daysPerWeek,
      _ref$hoursPerDay = _ref.hoursPerDay,
      hoursPerDay = _ref$hoursPerDay === undefined ? 8 : _ref$hoursPerDay;

  var DAYS_PER_WEEK = daysPerWeek;
  var HOURS_PER_DAY = hoursPerDay;
  var MINUTES_PER_HOUR = 60;
  var MINUTES_PER_WEEK = DAYS_PER_WEEK * HOURS_PER_DAY * MINUTES_PER_HOUR;
  var MINUTES_PER_DAY = HOURS_PER_DAY * MINUTES_PER_HOUR;

  var timePeriodConstraints = {
    weeks: MINUTES_PER_WEEK,
    days: MINUTES_PER_DAY,
    hours: MINUTES_PER_HOUR,
    minutes: 1
  };

  var unorderedMinutes = Math.abs(seconds / MINUTES_PER_HOUR);

  return underscore_default.a.mapObject(timePeriodConstraints, function (minutesPerPeriod) {
    var periodCount = Math.floor(unorderedMinutes / minutesPerPeriod);

    unorderedMinutes -= periodCount * minutesPerPeriod;

    return periodCount;
  });
}

/*
* Accepts a timeObject (see parseSeconds) and returns a condensed string representation of it
* (e.g. '1w 2d 3h 1m' or '1h 30m'). Zero value units are not included.
*/

function stringifyTime(timeObject) {
  var reducedTime = underscore_default.a.reduce(timeObject, function (memo, unitValue, unitName) {
    var isNonZero = !!unitValue;
    return isNonZero ? memo + ' ' + unitValue + unitName.charAt(0) : memo;
  }, '').trim();
  return reducedTime.length ? reducedTime : '0m';
}

/*
* Accepts a time string of any size (e.g. '1w 2d 3h 5m' or '1w 2d') and returns
*  the first non-zero unit/value pair.
*/

function pretty_time_abbreviateTime(timeStr) {
  return timeStr.split(' ').filter(function (unitStr) {
    return unitStr.charAt(0) !== '0';
  })[0];
}
// CONCATENATED MODULE: ./sidebar/components/time_tracking/collapsed_state.js



/* harmony default export */ var collapsed_state = ({
  name: 'time-tracking-collapsed-state',
  props: {
    showComparisonState: {
      type: Boolean,
      required: true
    },
    showSpentOnlyState: {
      type: Boolean,
      required: true
    },
    showEstimateOnlyState: {
      type: Boolean,
      required: true
    },
    showNoTimeTrackingState: {
      type: Boolean,
      required: true
    },
    timeSpentHumanReadable: {
      type: String,
      required: false,
      default: ''
    },
    timeEstimateHumanReadable: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    timeSpent: function timeSpent() {
      return this.abbreviateTime(this.timeSpentHumanReadable);
    },
    timeEstimate: function timeEstimate() {
      return this.abbreviateTime(this.timeEstimateHumanReadable);
    },
    divClass: function divClass() {
      if (this.showComparisonState) {
        return 'compare';
      } else if (this.showEstimateOnlyState) {
        return 'estimate-only';
      } else if (this.showSpentOnlyState) {
        return 'spend-only';
      } else if (this.showNoTimeTrackingState) {
        return 'no-tracking';
      }

      return '';
    },
    spanClass: function spanClass() {
      if (this.showComparisonState) {
        return '';
      } else if (this.showEstimateOnlyState || this.showSpentOnlyState) {
        return 'bold';
      } else if (this.showNoTimeTrackingState) {
        return 'no-value';
      }

      return '';
    },
    text: function text() {
      if (this.showComparisonState) {
        return this.timeSpent + ' / ' + this.timeEstimate;
      } else if (this.showEstimateOnlyState) {
        return '-- / ' + this.timeEstimate;
      } else if (this.showSpentOnlyState) {
        return this.timeSpent + ' / --';
      } else if (this.showNoTimeTrackingState) {
        return 'None';
      }

      return '';
    }
  },
  methods: {
    abbreviateTime: function abbreviateTime(timeStr) {
      return pretty_time_abbreviateTime(timeStr);
    }
  },
  template: '\n    <div class="sidebar-collapsed-icon">\n      ' + _icon_stopwatch_default.a + '\n      <div class="time-tracking-collapsed-summary">\n        <div :class="divClass">\n          <span :class="spanClass">\n            {{ text }}\n          </span>\n        </div>\n      </div>\n    </div>\n    '
});
// CONCATENATED MODULE: ./sidebar/components/time_tracking/spent_only_pane.js
/* harmony default export */ var spent_only_pane = ({
  name: 'time-tracking-spent-only-pane',
  props: {
    timeSpentHumanReadable: {
      type: String,
      required: true
    }
  },
  template: '\n    <div class="time-tracking-spend-only-pane">\n      <span class="bold">Spent:</span>\n      {{ timeSpentHumanReadable }}\n    </div>\n  '
});
// CONCATENATED MODULE: ./sidebar/components/time_tracking/no_tracking_pane.js
/* harmony default export */ var no_tracking_pane = ({
  name: 'time-tracking-no-tracking-pane',
  template: '\n    <div class="time-tracking-no-tracking-pane">\n      <span class="no-value">\n        {{ __(\'No estimate or time spent\') }}\n      </span>\n    </div>\n  '
});
// CONCATENATED MODULE: ./sidebar/components/time_tracking/estimate_only_pane.js
/* harmony default export */ var estimate_only_pane = ({
  name: 'time-tracking-estimate-only-pane',
  props: {
    timeEstimateHumanReadable: {
      type: String,
      required: true
    }
  },
  template: '\n    <div class="time-tracking-estimate-only-pane">\n      <span class="bold">\n        {{ s__(\'TimeTracking|Estimated:\') }}\n      </span>\n      {{ timeEstimateHumanReadable }}\n    </div>\n  '
});
// CONCATENATED MODULE: ./sidebar/components/time_tracking/comparison_pane.js


/* harmony default export */ var comparison_pane = ({
  name: 'time-tracking-comparison-pane',
  props: {
    timeSpent: {
      type: Number,
      required: true
    },
    timeEstimate: {
      type: Number,
      required: true
    },
    timeSpentHumanReadable: {
      type: String,
      required: true
    },
    timeEstimateHumanReadable: {
      type: String,
      required: true
    }
  },
  computed: {
    parsedTimeRemaining: function parsedTimeRemaining() {
      var diffSeconds = this.timeEstimate - this.timeSpent;
      return parseSeconds(diffSeconds);
    },
    timeRemainingHumanReadable: function timeRemainingHumanReadable() {
      return stringifyTime(this.parsedTimeRemaining);
    },
    timeRemainingTooltip: function timeRemainingTooltip() {
      var prefix = this.timeRemainingMinutes < 0 ? 'Over by' : 'Time remaining:';
      return prefix + ' ' + this.timeRemainingHumanReadable;
    },

    /* Diff values for comparison meter */
    timeRemainingMinutes: function timeRemainingMinutes() {
      return this.timeEstimate - this.timeSpent;
    },
    timeRemainingPercent: function timeRemainingPercent() {
      return Math.floor(this.timeSpent / this.timeEstimate * 100) + '%';
    },
    timeRemainingStatusClass: function timeRemainingStatusClass() {
      return this.timeEstimate >= this.timeSpent ? 'within_estimate' : 'over_estimate';
    }
  },
  template: '\n    <div class="time-tracking-comparison-pane">\n      <div\n        class="compare-meter"\n        data-toggle="tooltip"\n        data-placement="top"\n        role="timeRemainingDisplay"\n        :aria-valuenow="timeRemainingTooltip"\n        :title="timeRemainingTooltip"\n        :data-original-title="timeRemainingTooltip"\n        :class="timeRemainingStatusClass"\n      >\n        <div\n          class="meter-container"\n          role="timeSpentPercent"\n          :aria-valuenow="timeRemainingPercent"\n        >\n          <div\n            :style="{ width: timeRemainingPercent }"\n            class="meter-fill"\n          />\n        </div>\n        <div class="compare-display-container">\n          <div class="compare-display pull-left">\n            <span class="compare-label">\n            {{ s__(\'TimeTracking|Spent\') }}\n            </span>\n            <span class="compare-value spent">\n              {{ timeSpentHumanReadable }}\n            </span>\n          </div>\n          <div class="compare-display estimated pull-right">\n            <span class="compare-label">\n              {{ s__(\'TimeTrackingEstimated|Est\') }}\n            </span>\n            <span class="compare-value">\n              {{ timeEstimateHumanReadable }}\n            </span>\n          </div>\n        </div>\n      </div>\n    </div>\n  '
});
// EXTERNAL MODULE: ./sidebar/event_hub.js
var event_hub = __webpack_require__("./sidebar/event_hub.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/time_tracking/time_tracker.vue










/* harmony default export */ var time_tracker = ({
  name: 'IssuableTimeTracker',
  components: {
    'time-tracking-collapsed-state': collapsed_state,
    'time-tracking-estimate-only-pane': estimate_only_pane,
    'time-tracking-spent-only-pane': spent_only_pane,
    'time-tracking-no-tracking-pane': no_tracking_pane,
    'time-tracking-comparison-pane': comparison_pane,
    'time-tracking-help-state': help_state
  },
  props: {
    time_estimate: {
      type: Number,
      required: true
    },
    time_spent: {
      type: Number,
      required: true
    },
    human_time_estimate: {
      type: String,
      required: false,
      default: ''
    },
    human_time_spent: {
      type: String,
      required: false,
      default: ''
    },
    rootPath: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      showHelp: false
    };
  },

  computed: {
    timeSpent: function timeSpent() {
      return this.time_spent;
    },
    timeEstimate: function timeEstimate() {
      return this.time_estimate;
    },
    timeEstimateHumanReadable: function timeEstimateHumanReadable() {
      return this.human_time_estimate;
    },
    timeSpentHumanReadable: function timeSpentHumanReadable() {
      return this.human_time_spent;
    },
    hasTimeSpent: function hasTimeSpent() {
      return !!this.timeSpent;
    },
    hasTimeEstimate: function hasTimeEstimate() {
      return !!this.timeEstimate;
    },
    showComparisonState: function showComparisonState() {
      return this.hasTimeEstimate && this.hasTimeSpent;
    },
    showEstimateOnlyState: function showEstimateOnlyState() {
      return this.hasTimeEstimate && !this.hasTimeSpent;
    },
    showSpentOnlyState: function showSpentOnlyState() {
      return this.hasTimeSpent && !this.hasTimeEstimate;
    },
    showNoTimeTrackingState: function showNoTimeTrackingState() {
      return !this.hasTimeEstimate && !this.hasTimeSpent;
    },
    showHelpState: function showHelpState() {
      return !!this.showHelp;
    }
  },
  created: function created() {
    event_hub["a" /* default */].$on('timeTracker:updateData', this.update);
  },

  methods: {
    toggleHelpState: function toggleHelpState(show) {
      this.showHelp = show;
    },
    update: function update(data) {
      this.time_estimate = data.time_estimate;
      this.time_spent = data.time_spent;
      this.human_time_estimate = data.human_time_estimate;
      this.human_time_spent = data.human_time_spent;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc25cbb2","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/time_tracking/time_tracker.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time_tracker time-tracking-component-wrap"},[_c('time-tracking-collapsed-state',{attrs:{"show-comparison-state":_vm.showComparisonState,"show-no-time-tracking-state":_vm.showNoTimeTrackingState,"show-help-state":_vm.showHelpState,"show-spent-only-state":_vm.showSpentOnlyState,"show-estimate-only-state":_vm.showEstimateOnlyState,"time-spent-human-readable":_vm.timeSpentHumanReadable,"time-estimate-human-readable":_vm.timeEstimateHumanReadable}}),_vm._v(" "),_c('div',{staticClass:"title hide-collapsed"},[_vm._v("\n    "+_vm._s(_vm.__('Time tracking'))+"\n    "),(!_vm.showHelpState)?_c('div',{staticClass:"help-button pull-right",on:{"click":function($event){_vm.toggleHelpState(true)}}},[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.showHelpState)?_c('div',{staticClass:"close-help-button pull-right",on:{"click":function($event){_vm.toggleHelpState(false)}}},[_c('i',{staticClass:"fa fa-close",attrs:{"aria-hidden":"true"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"time-tracking-content hide-collapsed"},[(_vm.showEstimateOnlyState)?_c('time-tracking-estimate-only-pane',{attrs:{"time-estimate-human-readable":_vm.timeEstimateHumanReadable}}):_vm._e(),_vm._v(" "),(_vm.showSpentOnlyState)?_c('time-tracking-spent-only-pane',{attrs:{"time-spent-human-readable":_vm.timeSpentHumanReadable}}):_vm._e(),_vm._v(" "),(_vm.showNoTimeTrackingState)?_c('time-tracking-no-tracking-pane'):_vm._e(),_vm._v(" "),(_vm.showComparisonState)?_c('time-tracking-comparison-pane',{attrs:{"time-estimate":_vm.timeEstimate,"time-spent":_vm.timeSpent,"time-spent-human-readable":_vm.timeSpentHumanReadable,"time-estimate-human-readable":_vm.timeEstimateHumanReadable}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"help-state-toggle"}},[(_vm.showHelpState)?_c('time-tracking-help-state',{attrs:{"root-path":_vm.rootPath}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/time_tracking/time_tracker.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  time_tracker,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var time_tracking_time_tracker = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./sidebar/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


var eventHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

// TODO: remove eventHub hack after code splitting refactor
window.emitSidebarEvent = function () {
  return eventHub.$emit.apply(eventHub, arguments);
};

/* harmony default export */ __webpack_exports__["a"] = (eventHub);

/***/ }),

/***/ "./sidebar/lib/sidebar_move_issue.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function isValidProjectId(id) {
  return id > 0;
}

var SidebarMoveIssue = function () {
  function SidebarMoveIssue(mediator, dropdownToggle, confirmButton) {
    _classCallCheck(this, SidebarMoveIssue);

    this.mediator = mediator;

    this.$dropdownToggle = $(dropdownToggle);
    this.$confirmButton = $(confirmButton);

    this.onConfirmClickedWrapper = this.onConfirmClicked.bind(this);
  }

  _createClass(SidebarMoveIssue, [{
    key: 'init',
    value: function init() {
      this.initDropdown();
      this.addEventListeners();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.removeEventListeners();
    }
  }, {
    key: 'initDropdown',
    value: function initDropdown() {
      var _this = this;

      this.$dropdownToggle.glDropdown({
        search: {
          fields: ['name_with_namespace']
        },
        showMenuAbove: true,
        selectable: true,
        filterable: true,
        filterRemote: true,
        multiSelect: false,
        // Keep the dropdown open after selecting an option
        shouldPropagate: false,
        data: function data(searchTerm, callback) {
          _this.mediator.fetchAutocompleteProjects(searchTerm).then(callback).catch(function () {
            return new window.Flash('An error occurred while fetching projects autocomplete.');
          });
        },
        renderRow: function renderRow(project) {
          return '\n        <li>\n          <a href="#" class="js-move-issue-dropdown-item">\n            ' + project.name_with_namespace + '\n          </a>\n        </li>\n      ';
        },
        clicked: function clicked(options) {
          var project = options.selectedObj;
          var selectedProjectId = options.isMarking ? project.id : 0;
          _this.mediator.setMoveToProjectId(selectedProjectId);

          _this.$confirmButton.prop('disabled', !isValidProjectId(selectedProjectId));
        }
      });
    }
  }, {
    key: 'addEventListeners',
    value: function addEventListeners() {
      this.$confirmButton.on('click', this.onConfirmClickedWrapper);
    }
  }, {
    key: 'removeEventListeners',
    value: function removeEventListeners() {
      this.$confirmButton.off('click', this.onConfirmClickedWrapper);
    }
  }, {
    key: 'onConfirmClicked',
    value: function onConfirmClicked() {
      var _this2 = this;

      if (isValidProjectId(this.mediator.store.moveToProjectId)) {
        this.$confirmButton.disable().addClass('is-loading');

        this.mediator.moveIssue().catch(function () {
          window.Flash('An error occurred while moving the issue.');
          _this2.$confirmButton.enable().removeClass('is-loading');
        });
      }
    }
  }]);

  return SidebarMoveIssue;
}();

/* harmony default export */ __webpack_exports__["a"] = (SidebarMoveIssue);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./sidebar/mount_sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["b"] = mountSidebar;
/* harmony export (immutable) */ __webpack_exports__["a"] = getSidebarOptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_time_tracking_sidebar_time_tracking__ = __webpack_require__("./sidebar/components/time_tracking/sidebar_time_tracking.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_assignees_sidebar_assignees_vue__ = __webpack_require__("./sidebar/components/assignees/sidebar_assignees.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_confidential_confidential_issue_sidebar_vue__ = __webpack_require__("./sidebar/components/confidential/confidential_issue_sidebar.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_sidebar_move_issue__ = __webpack_require__("./sidebar/lib/sidebar_move_issue.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_lock_lock_issue_sidebar_vue__ = __webpack_require__("./sidebar/components/lock/lock_issue_sidebar.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_participants_sidebar_participants_vue__ = __webpack_require__("./sidebar/components/participants/sidebar_participants.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_subscriptions_sidebar_subscriptions_vue__ = __webpack_require__("./sidebar/components/subscriptions/sidebar_subscriptions.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_shared_translate__ = __webpack_require__("./vue_shared/translate.js");










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__vue_shared_translate__["a" /* default */]);

function mountAssigneesComponent(mediator) {
  var el = document.getElementById('js-vue-sidebar-assignees');

  if (!el) return;

  // eslint-disable-next-line no-new
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: el,
    components: {
      SidebarAssignees: __WEBPACK_IMPORTED_MODULE_2__components_assignees_sidebar_assignees_vue__["a" /* default */]
    },
    render: function render(createElement) {
      return createElement('sidebar-assignees', {
        props: {
          mediator: mediator,
          field: el.dataset.field,
          signedIn: el.hasAttribute('data-signed-in')
        }
      });
    }
  });
}

function mountConfidentialComponent(mediator) {
  var el = document.getElementById('js-confidential-entry-point');

  if (!el) return;

  var dataNode = document.getElementById('js-confidential-issue-data');
  var initialData = JSON.parse(dataNode.innerHTML);

  var ConfidentialComp = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_3__components_confidential_confidential_issue_sidebar_vue__["a" /* default */]);

  new ConfidentialComp({
    propsData: {
      isConfidential: initialData.is_confidential,
      isEditable: initialData.is_editable,
      service: mediator.service
    }
  }).$mount(el);
}

function mountLockComponent(mediator) {
  var el = document.getElementById('js-lock-entry-point');

  if (!el) return;

  var dataNode = document.getElementById('js-lock-issue-data');
  var initialData = JSON.parse(dataNode.innerHTML);

  var LockComp = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_5__components_lock_lock_issue_sidebar_vue__["a" /* default */]);

  new LockComp({
    propsData: {
      isLocked: initialData.is_locked,
      isEditable: initialData.is_editable,
      mediator: mediator,
      issuableType: gl.utils.isInIssuePage() ? 'issue' : 'merge_request'
    }
  }).$mount(el);
}

function mountParticipantsComponent(mediator) {
  var el = document.querySelector('.js-sidebar-participants-entry-point');

  // eslint-disable-next-line no-new
  if (!el) return;

  // eslint-disable-next-line no-new
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: el,
    components: {
      sidebarParticipants: __WEBPACK_IMPORTED_MODULE_6__components_participants_sidebar_participants_vue__["a" /* default */]
    },
    render: function render(createElement) {
      return createElement('sidebar-participants', {
        props: {
          mediator: mediator
        }
      });
    }
  });
}

function mountSubscriptionsComponent(mediator) {
  var el = document.querySelector('.js-sidebar-subscriptions-entry-point');

  if (!el) return;

  // eslint-disable-next-line no-new
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: el,
    components: {
      sidebarSubscriptions: __WEBPACK_IMPORTED_MODULE_7__components_subscriptions_sidebar_subscriptions_vue__["a" /* default */]
    },
    render: function render(createElement) {
      return createElement('sidebar-subscriptions', {
        props: {
          mediator: mediator
        }
      });
    }
  });
}

function mountTimeTrackingComponent() {
  var el = document.getElementById('issuable-time-tracker');

  if (!el) return;

  // eslint-disable-next-line no-new
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: el,
    components: {
      SidebarTimeTracking: __WEBPACK_IMPORTED_MODULE_1__components_time_tracking_sidebar_time_tracking__["a" /* default */]
    },
    render: function render(createElement) {
      return createElement('sidebar-time-tracking', {});
    }
  });
}

function mountSidebar(mediator) {
  mountAssigneesComponent(mediator);
  mountConfidentialComponent(mediator);
  mountLockComponent(mediator);
  mountParticipantsComponent(mediator);
  mountSubscriptionsComponent(mediator);

  new __WEBPACK_IMPORTED_MODULE_4__lib_sidebar_move_issue__["a" /* default */](mediator, $('.js-move-issue'), $('.js-move-issue-confirmation-button')).init();

  mountTimeTrackingComponent();
}

function getSidebarOptions() {
  return JSON.parse(document.querySelector('.js-sidebar-options').innerHTML);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./sidebar/sidebar_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidebar_mediator__ = __webpack_require__("./sidebar/sidebar_mediator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mount_sidebar__ = __webpack_require__("./sidebar/mount_sidebar.js");



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var mediator = new __WEBPACK_IMPORTED_MODULE_0__sidebar_mediator__["a" /* default */](Object(__WEBPACK_IMPORTED_MODULE_1__mount_sidebar__["a" /* getSidebarOptions */])());
  mediator.fetch();

  Object(__WEBPACK_IMPORTED_MODULE_1__mount_sidebar__["b" /* mountSidebar */])(mediator);
});

/***/ }),

/***/ "./sidebar/sidebar_mediator.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./lib/utils/url_utility.js
var url_utility = __webpack_require__("./lib/utils/url_utility.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-resource/dist/vue-resource.esm.js
var vue_resource_esm = __webpack_require__("../../../node_modules/vue-resource/dist/vue-resource.esm.js");

// CONCATENATED MODULE: ./sidebar/services/sidebar_service.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




vue_esm["a" /* default */].use(vue_resource_esm["a" /* default */]);

var sidebar_service_SidebarService = function () {
  function SidebarService(endpointMap) {
    _classCallCheck(this, SidebarService);

    if (!SidebarService.singleton) {
      this.endpoint = endpointMap.endpoint;
      this.toggleSubscriptionEndpoint = endpointMap.toggleSubscriptionEndpoint;
      this.moveIssueEndpoint = endpointMap.moveIssueEndpoint;
      this.projectsAutocompleteEndpoint = endpointMap.projectsAutocompleteEndpoint;

      SidebarService.singleton = this;
    }

    return SidebarService.singleton;
  }

  _createClass(SidebarService, [{
    key: 'get',
    value: function get() {
      return vue_esm["a" /* default */].http.get(this.endpoint);
    }
  }, {
    key: 'update',
    value: function update(key, data) {
      return vue_esm["a" /* default */].http.put(this.endpoint, _defineProperty({}, key, data), {
        emulateJSON: true
      });
    }
  }, {
    key: 'getProjectsAutocomplete',
    value: function getProjectsAutocomplete(searchTerm) {
      return vue_esm["a" /* default */].http.get(this.projectsAutocompleteEndpoint, {
        params: {
          search: searchTerm
        }
      });
    }
  }, {
    key: 'toggleSubscription',
    value: function toggleSubscription() {
      return vue_esm["a" /* default */].http.post(this.toggleSubscriptionEndpoint);
    }
  }, {
    key: 'moveIssue',
    value: function moveIssue(moveToProjectId) {
      return vue_esm["a" /* default */].http.post(this.moveIssueEndpoint, {
        move_to_project_id: moveToProjectId
      });
    }
  }]);

  return SidebarService;
}();

/* harmony default export */ var sidebar_service = (sidebar_service_SidebarService);
// EXTERNAL MODULE: ./sidebar/stores/sidebar_store.js
var sidebar_store = __webpack_require__("./sidebar/stores/sidebar_store.js");

// CONCATENATED MODULE: ./sidebar/sidebar_mediator.js
var sidebar_mediator__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function sidebar_mediator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var sidebar_mediator_SidebarMediator = function () {
  function SidebarMediator(options) {
    sidebar_mediator__classCallCheck(this, SidebarMediator);

    if (!SidebarMediator.singleton) {
      this.initSingleton(options);
    }
    return SidebarMediator.singleton;
  }

  sidebar_mediator__createClass(SidebarMediator, [{
    key: 'initSingleton',
    value: function initSingleton(options) {
      this.store = new sidebar_store["a" /* default */](options);
      this.service = new sidebar_service({
        endpoint: options.endpoint,
        toggleSubscriptionEndpoint: options.toggleSubscriptionEndpoint,
        moveIssueEndpoint: options.moveIssueEndpoint,
        projectsAutocompleteEndpoint: options.projectsAutocompleteEndpoint
      });
      SidebarMediator.singleton = this;
    }
  }, {
    key: 'assignYourself',
    value: function assignYourself() {
      this.store.addAssignee(this.store.currentUser);
    }
  }, {
    key: 'saveAssignees',
    value: function saveAssignees(field) {
      var selected = this.store.assignees.map(function (u) {
        return u.id;
      });

      // If there are no ids, that means we have to unassign (which is id = 0)
      // And it only accepts an array, hence [0]
      return this.service.update(field, selected.length === 0 ? [0] : selected);
    }
  }, {
    key: 'setMoveToProjectId',
    value: function setMoveToProjectId(projectId) {
      this.store.setMoveToProjectId(projectId);
    }
  }, {
    key: 'fetch',
    value: function fetch() {
      var _this = this;

      return this.service.get().then(function (response) {
        return response.json();
      }).then(function (data) {
        _this.processFetchedData(data);
      }).catch(function () {
        return new flash["a" /* default */]('Error occurred when fetching sidebar data');
      });
    }
  }, {
    key: 'processFetchedData',
    value: function processFetchedData(data) {
      this.store.setAssigneeData(data);
      this.store.setTimeTrackingData(data);
      this.store.setParticipantsData(data);
      this.store.setSubscriptionsData(data);
    }
  }, {
    key: 'toggleSubscription',
    value: function toggleSubscription() {
      var _this2 = this;

      this.store.setFetchingState('subscriptions', true);
      return this.service.toggleSubscription().then(function () {
        _this2.store.setSubscribedState(!_this2.store.subscribed);
        _this2.store.setFetchingState('subscriptions', false);
      }).catch(function (err) {
        _this2.store.setFetchingState('subscriptions', false);
        throw err;
      });
    }
  }, {
    key: 'fetchAutocompleteProjects',
    value: function fetchAutocompleteProjects(searchTerm) {
      var _this3 = this;

      return this.service.getProjectsAutocomplete(searchTerm).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this3.store.setAutocompleteProjects(data);
        return _this3.store.autocompleteProjects;
      });
    }
  }, {
    key: 'moveIssue',
    value: function moveIssue() {
      return this.service.moveIssue(this.store.moveToProjectId).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (location.pathname !== data.web_url) {
          Object(url_utility["g" /* visitUrl */])(data.web_url);
        }
      });
    }
  }]);

  return SidebarMediator;
}();

/* harmony default export */ var sidebar_mediator = __webpack_exports__["a"] = (sidebar_mediator_SidebarMediator);

/***/ }),

/***/ "./sidebar/stores/sidebar_store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SidebarStore = function () {
  function SidebarStore(options) {
    _classCallCheck(this, SidebarStore);

    if (!SidebarStore.singleton) {
      this.initSingleton(options);
    }

    return SidebarStore.singleton;
  }

  _createClass(SidebarStore, [{
    key: 'initSingleton',
    value: function initSingleton(options) {
      var currentUser = options.currentUser,
          rootPath = options.rootPath,
          editable = options.editable;

      this.currentUser = currentUser;
      this.rootPath = rootPath;
      this.editable = editable;
      this.timeEstimate = 0;
      this.totalTimeSpent = 0;
      this.humanTimeEstimate = '';
      this.humanTimeSpent = '';
      this.assignees = [];
      this.isFetching = {
        assignees: true,
        participants: true,
        subscriptions: true
      };
      this.isLoading = {};
      this.autocompleteProjects = [];
      this.moveToProjectId = 0;
      this.isLockDialogOpen = false;
      this.participants = [];
      this.subscribed = null;

      SidebarStore.singleton = this;
    }
  }, {
    key: 'setAssigneeData',
    value: function setAssigneeData(data) {
      this.isFetching.assignees = false;
      if (data.assignees) {
        this.assignees = data.assignees;
      }
    }
  }, {
    key: 'setTimeTrackingData',
    value: function setTimeTrackingData(data) {
      this.timeEstimate = data.time_estimate;
      this.totalTimeSpent = data.total_time_spent;
      this.humanTimeEstimate = data.human_time_estimate;
      this.humanTotalTimeSpent = data.human_total_time_spent;
    }
  }, {
    key: 'setParticipantsData',
    value: function setParticipantsData(data) {
      this.isFetching.participants = false;
      this.participants = data.participants || [];
    }
  }, {
    key: 'setSubscriptionsData',
    value: function setSubscriptionsData(data) {
      this.isFetching.subscriptions = false;
      this.subscribed = data.subscribed || false;
    }
  }, {
    key: 'setFetchingState',
    value: function setFetchingState(key, value) {
      this.isFetching[key] = value;
    }
  }, {
    key: 'setLoadingState',
    value: function setLoadingState(key, value) {
      this.isLoading[key] = value;
    }
  }, {
    key: 'addAssignee',
    value: function addAssignee(assignee) {
      if (!this.findAssignee(assignee)) {
        this.assignees.push(assignee);
      }
    }
  }, {
    key: 'findAssignee',
    value: function findAssignee(_findAssignee) {
      return this.assignees.filter(function (assignee) {
        return assignee.id === _findAssignee.id;
      })[0];
    }
  }, {
    key: 'removeAssignee',
    value: function removeAssignee(_removeAssignee) {
      if (_removeAssignee) {
        this.assignees = this.assignees.filter(function (assignee) {
          return assignee.id !== _removeAssignee.id;
        });
      }
    }
  }, {
    key: 'removeAllAssignees',
    value: function removeAllAssignees() {
      this.assignees = [];
    }
  }, {
    key: 'setAutocompleteProjects',
    value: function setAutocompleteProjects(projects) {
      this.autocompleteProjects = projects;
    }
  }, {
    key: 'setSubscribedState',
    value: function setSubscribedState(subscribed) {
      this.subscribed = subscribed;
    }
  }, {
    key: 'setMoveToProjectId',
    value: function setMoveToProjectId(moveToProjectId) {
      this.moveToProjectId = moveToProjectId;
    }
  }]);

  return SidebarStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (SidebarStore);

/***/ }),

/***/ "./single_file_diff.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__files_comment_button__ = __webpack_require__("./files_comment_button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__image_diff_helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__syntax_highlight__ = __webpack_require__("./syntax_highlight.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, prefer-arrow-callback, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, one-var, one-var-declaration-per-line, consistent-return, no-param-reassign, max-len */








var WRAPPER = '<div class="diff-content"></div>';
var LOADING_HTML = '<i class="fa fa-spinner fa-spin"></i>';
var ERROR_HTML = '<div class="nothing-here-block"><i class="fa fa-warning"></i> Could not load diff</div>';
var COLLAPSED_HTML = '<div class="nothing-here-block diff-collapsed">This diff is collapsed. <a class="click-to-expand">Click to expand it.</a></div>';

var SingleFileDiff = function () {
  function SingleFileDiff(file) {
    _classCallCheck(this, SingleFileDiff);

    this.file = file;
    this.toggleDiff = this.toggleDiff.bind(this);
    this.content = $('.diff-content', this.file);
    this.$toggleIcon = $('.diff-toggle-caret', this.file);
    this.diffForPath = this.content.find('[data-diff-for-path]').data('diffForPath');
    this.isOpen = !this.diffForPath;
    if (this.diffForPath) {
      this.collapsedContent = this.content;
      this.loadingContent = $(WRAPPER).addClass('loading').html(LOADING_HTML).hide();
      this.content = null;
      this.collapsedContent.after(this.loadingContent);
      this.$toggleIcon.addClass('fa-caret-right');
    } else {
      this.collapsedContent = $(WRAPPER).html(COLLAPSED_HTML).hide();
      this.content.after(this.collapsedContent);
      this.$toggleIcon.addClass('fa-caret-down');
    }

    $('.js-file-title, .click-to-expand', this.file).on('click', function (e) {
      this.toggleDiff($(e.target));
    }.bind(this));
  }

  _createClass(SingleFileDiff, [{
    key: 'toggleDiff',
    value: function toggleDiff($target, cb) {
      if (!$target.hasClass('js-file-title') && !$target.hasClass('click-to-expand') && !$target.hasClass('diff-toggle-caret')) return;
      this.isOpen = !this.isOpen;
      if (!this.isOpen && !this.hasError) {
        this.content.hide();
        this.$toggleIcon.addClass('fa-caret-right').removeClass('fa-caret-down');
        this.collapsedContent.show();
        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }
      } else if (this.content) {
        this.collapsedContent.hide();
        this.content.show();
        this.$toggleIcon.addClass('fa-caret-down').removeClass('fa-caret-right');
        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }
      } else {
        this.$toggleIcon.addClass('fa-caret-down').removeClass('fa-caret-right');
        return this.getContentHTML(cb);
      }
    }
  }, {
    key: 'getContentHTML',
    value: function getContentHTML(cb) {
      var _this = this;

      this.collapsedContent.hide();
      this.loadingContent.show();

      __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(this.diffForPath).then(function (_ref) {
        var data = _ref.data;

        _this.loadingContent.hide();
        if (data.html) {
          _this.content = $(data.html);
          Object(__WEBPACK_IMPORTED_MODULE_5__syntax_highlight__["a" /* default */])(_this.content);
        } else {
          _this.hasError = true;
          _this.content = $(ERROR_HTML);
        }
        _this.collapsedContent.after(_this.content);

        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }

        var $file = $(_this.file);
        __WEBPACK_IMPORTED_MODULE_3__files_comment_button__["a" /* default */].init($file);

        var canCreateNote = $file.closest('.files').is('[data-can-create-note]');
        __WEBPACK_IMPORTED_MODULE_4__image_diff_helpers_index__["a" /* default */].initImageDiff($file[0], canCreateNote);

        if (cb) cb();
      }).catch(function () {
        Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* __ */])('An error occurred while retrieving diff'));
      });
    }
  }]);

  return SingleFileDiff;
}();

/* harmony default export */ __webpack_exports__["a"] = (SingleFileDiff);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./smart_interval.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Instances of SmartInterval extend the functionality of `setInterval`, make it configurable
 * and controllable by a public API.
 */

var SmartInterval = function () {
  /**
   * @param { function } opts.callback Function that returns a promise, called on each iteration
   *                     unless still in progress (required)
   * @param { milliseconds } opts.startingInterval `currentInterval` is set to this initially
   * @param { milliseconds } opts.maxInterval `currentInterval` will be incremented to this
   * @param { milliseconds } opts.hiddenInterval `currentInterval` is set to this
   *                         when the page is hidden
   * @param { integer } opts.incrementByFactorOf `currentInterval` is incremented by this factor
   * @param { boolean } opts.lazyStart Configure if timer is initialized on
   *                    instantiation or lazily
   * @param { boolean } opts.immediateExecution Configure if callback should
   *                    be executed before the first interval.
   */
  function SmartInterval() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SmartInterval);

    this.cfg = {
      callback: opts.callback,
      startingInterval: opts.startingInterval,
      maxInterval: opts.maxInterval,
      hiddenInterval: opts.hiddenInterval,
      incrementByFactorOf: opts.incrementByFactorOf,
      lazyStart: opts.lazyStart,
      immediateExecution: opts.immediateExecution
    };

    this.state = {
      intervalId: null,
      currentInterval: this.cfg.startingInterval,
      pageVisibility: 'visible'
    };

    this.initInterval();
  }

  /* public */

  _createClass(SmartInterval, [{
    key: 'start',
    value: function start() {
      var _this = this;

      var cfg = this.cfg;
      var state = this.state;

      if (cfg.immediateExecution && !this.isLoading) {
        cfg.immediateExecution = false;
        this.triggerCallback();
      }

      state.intervalId = window.setInterval(function () {
        if (_this.isLoading) {
          return;
        }
        _this.triggerCallback();

        if (_this.getCurrentInterval() === cfg.maxInterval) {
          return;
        }

        _this.incrementInterval();
        _this.resume();
      }, this.getCurrentInterval());
    }

    // cancel the existing timer, setting the currentInterval back to startingInterval

  }, {
    key: 'cancel',
    value: function cancel() {
      this.setCurrentInterval(this.cfg.startingInterval);
      this.stopTimer();
    }
  }, {
    key: 'onVisibilityHidden',
    value: function onVisibilityHidden() {
      if (this.cfg.hiddenInterval) {
        this.setCurrentInterval(this.cfg.hiddenInterval);
        this.resume();
      } else {
        this.cancel();
      }
    }

    // start a timer, using the existing interval

  }, {
    key: 'resume',
    value: function resume() {
      this.stopTimer(); // stop existing timer, in case timer was not previously stopped
      this.start();
    }
  }, {
    key: 'onVisibilityVisible',
    value: function onVisibilityVisible() {
      this.cancel();
      this.start();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.cancel();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      $(document).off('visibilitychange').off('beforeunload');
    }

    /* private */

  }, {
    key: 'initInterval',
    value: function initInterval() {
      var cfg = this.cfg;

      if (!cfg.lazyStart) {
        this.start();
      }

      this.initVisibilityChangeHandling();
      this.initPageUnloadHandling();
    }
  }, {
    key: 'triggerCallback',
    value: function triggerCallback() {
      var _this2 = this;

      this.isLoading = true;
      this.cfg.callback().then(function () {
        _this2.isLoading = false;
      }).catch(function (err) {
        _this2.isLoading = false;
        throw err;
      });
    }
  }, {
    key: 'initVisibilityChangeHandling',
    value: function initVisibilityChangeHandling() {
      // cancel interval when tab no longer shown (prevents cached pages from polling)
      document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
    }
  }, {
    key: 'initPageUnloadHandling',
    value: function initPageUnloadHandling() {
      var _this3 = this;

      // TODO: Consider refactoring in light of turbolinks removal.
      // prevent interval continuing after page change, when kept in cache by Turbolinks
      $(document).on('beforeunload', function () {
        return _this3.cancel();
      });
    }
  }, {
    key: 'handleVisibilityChange',
    value: function handleVisibilityChange(e) {
      this.state.pageVisibility = e.target.visibilityState;
      var intervalAction = this.isPageVisible() ? this.onVisibilityVisible : this.onVisibilityHidden;

      intervalAction.apply(this);
    }
  }, {
    key: 'getCurrentInterval',
    value: function getCurrentInterval() {
      return this.state.currentInterval;
    }
  }, {
    key: 'setCurrentInterval',
    value: function setCurrentInterval(newInterval) {
      this.state.currentInterval = newInterval;
    }
  }, {
    key: 'incrementInterval',
    value: function incrementInterval() {
      var cfg = this.cfg;
      var currentInterval = this.getCurrentInterval();
      if (cfg.hiddenInterval && !this.isPageVisible()) return;
      var nextInterval = currentInterval * cfg.incrementByFactorOf;

      if (nextInterval > cfg.maxInterval) {
        nextInterval = cfg.maxInterval;
      }

      this.setCurrentInterval(nextInterval);
    }
  }, {
    key: 'isPageVisible',
    value: function isPageVisible() {
      return this.state.pageVisibility === 'visible';
    }
  }, {
    key: 'stopTimer',
    value: function stopTimer() {
      var state = this.state;

      state.intervalId = window.clearInterval(state.intervalId);
    }
  }]);

  return SmartInterval;
}();

/* harmony default export */ __webpack_exports__["a"] = (SmartInterval);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./task_list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deckar01_task_list__ = __webpack_require__("../../../node_modules/deckar01-task_list/dist/task_list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deckar01_task_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_deckar01_task_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var TaskList = function () {
  function TaskList() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, TaskList);

    this.selector = options.selector;
    this.dataType = options.dataType;
    this.fieldName = options.fieldName;
    this.onSuccess = options.onSuccess || function () {};
    this.onError = function showFlash(e) {
      var errorMessages = '';

      if (e.response.data && _typeof(e.response.data) === 'object') {
        errorMessages = e.response.data.errors.join(' ');
      }

      return new __WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */](errorMessages || 'Update failed', 'alert');
    };

    this.init();
  }

  _createClass(TaskList, [{
    key: 'init',
    value: function init() {
      // Prevent duplicate event bindings
      this.disable();
      $(this.selector + ' .js-task-list-container').taskList('enable');
      $(document).on('tasklist:changed', this.selector + ' .js-task-list-container', this.update.bind(this));
    }
  }, {
    key: 'disable',
    value: function disable() {
      $(this.selector + ' .js-task-list-container').taskList('disable');
      $(document).off('tasklist:changed', this.selector + ' .js-task-list-container');
    }
  }, {
    key: 'update',
    value: function update(e) {
      var _this = this;

      var $target = $(e.target);
      var patchData = {};
      patchData[this.dataType] = _defineProperty({}, this.fieldName, $target.val());

      return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].patch($target.data('updateUrl') || $('form.js-issuable-update').attr('action'), patchData).then(function (_ref) {
        var data = _ref.data;
        return _this.onSuccess(data);
      }).catch(function (err) {
        return _this.onError(err);
      });
    }
  }]);

  return TaskList;
}();

/* harmony default export */ __webpack_exports__["a"] = (TaskList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./users_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable func-names, space-before-function-paren, one-var, no-var, prefer-rest-params, wrap-iife, quotes, max-len, one-var-declaration-per-line, vars-on-top, prefer-arrow-callback, consistent-return, comma-dangle, object-shorthand, no-shadow, no-unused-vars, no-else-return, no-self-compare, prefer-template, no-unused-expressions, no-lonely-if, yoda, prefer-spread, no-void, camelcase, no-param-reassign */
/* global Issuable */
/* global emitSidebarEvent */



// TODO: remove eventHub hack after code splitting refactor
window.emitSidebarEvent = window.emitSidebarEvent || $.noop;

function UsersSelect(currentUser, els) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var $els;
  this.users = this.users.bind(this);
  this.user = this.user.bind(this);
  this.usersPath = "/autocomplete/users.json";
  this.userPath = "/autocomplete/users/:id.json";
  if (currentUser != null) {
    if ((typeof currentUser === 'undefined' ? 'undefined' : _typeof(currentUser)) === 'object') {
      this.currentUser = currentUser;
    } else {
      this.currentUser = JSON.parse(currentUser);
    }
  }

  var handleClick = options.handleClick;


  $els = $(els);

  if (!els) {
    $els = $('.js-user-search');
  }

  $els.each(function (_this) {
    return function (i, dropdown) {
      var options = {};
      var $block, $collapsedSidebar, $dropdown, $loading, $selectbox, $value, abilityName, assignTo, assigneeTemplate, collapsedAssigneeTemplate, defaultLabel, defaultNullUser, firstUser, issueURL, selectedId, selectedIdDefault, showAnyUser, showNullUser, showMenuAbove;
      $dropdown = $(dropdown);
      options.projectId = $dropdown.data('projectId');
      options.groupId = $dropdown.data('groupId');
      options.showCurrentUser = $dropdown.data('currentUser');
      options.todoFilter = $dropdown.data('todoFilter');
      options.todoStateFilter = $dropdown.data('todoStateFilter');
      showNullUser = $dropdown.data('nullUser');
      defaultNullUser = $dropdown.data('nullUserDefault');
      showMenuAbove = $dropdown.data('showMenuAbove');
      showAnyUser = $dropdown.data('anyUser');
      firstUser = $dropdown.data('firstUser');
      options.authorId = $dropdown.data('authorId');
      defaultLabel = $dropdown.data('defaultLabel');
      issueURL = $dropdown.data('issueUpdate');
      $selectbox = $dropdown.closest('.selectbox');
      $block = $selectbox.closest('.block');
      abilityName = $dropdown.data('abilityName');
      $value = $block.find('.value');
      $collapsedSidebar = $block.find('.sidebar-collapsed-user');
      $loading = $block.find('.block-loading').fadeOut();
      selectedIdDefault = defaultNullUser && showNullUser ? 0 : null;
      selectedId = $dropdown.data('selected');

      if (selectedId === undefined) {
        selectedId = selectedIdDefault;
      }

      var assignYourself = function assignYourself() {
        var unassignedSelected = $dropdown.closest('.selectbox').find('input[name=\'' + $dropdown.data('fieldName') + '\'][value=0]');

        if (unassignedSelected) {
          unassignedSelected.remove();
        }

        // Save current selected user to the DOM
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = $dropdown.data('fieldName');

        var currentUserInfo = $dropdown.data('currentUserInfo');

        if (currentUserInfo) {
          input.value = currentUserInfo.id;
          input.dataset.meta = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(currentUserInfo.name);
        } else if (_this.currentUser) {
          input.value = _this.currentUser.id;
        }

        if ($selectbox) {
          $dropdown.parent().before(input);
        } else {
          $dropdown.after(input);
        }
      };

      if ($block[0]) {
        $block[0].addEventListener('assignYourself', assignYourself);
      }

      var getSelectedUserInputs = function getSelectedUserInputs() {
        return $selectbox.find('input[name="' + $dropdown.data('fieldName') + '"]');
      };

      var getSelected = function getSelected() {
        return getSelectedUserInputs().map(function (index, input) {
          return parseInt(input.value, 10);
        }).get();
      };

      var checkMaxSelect = function checkMaxSelect() {
        var maxSelect = $dropdown.data('maxSelect');
        if (maxSelect) {
          var selected = getSelected();

          if (selected.length > maxSelect) {
            var firstSelectedId = selected[0];
            var firstSelected = $dropdown.closest('.selectbox').find('input[name=\'' + $dropdown.data('fieldName') + '\'][value=' + firstSelectedId + ']');

            firstSelected.remove();
            emitSidebarEvent('sidebar.removeAssignee', {
              id: firstSelectedId
            });
          }
        }
      };

      var getMultiSelectDropdownTitle = function getMultiSelectDropdownTitle(selectedUser, isSelected) {
        var selectedUsers = getSelected().filter(function (u) {
          return u !== 0;
        });

        var firstUser = getSelectedUserInputs().map(function (index, input) {
          return {
            name: input.dataset.meta,
            value: parseInt(input.value, 10)
          };
        }).filter(function (u) {
          return u.id !== 0;
        }).get(0);

        if (selectedUsers.length === 0) {
          return '未指派';
        } else if (selectedUsers.length === 1) {
          return firstUser.name;
        } else if (isSelected) {
          var otherSelected = selectedUsers.filter(function (s) {
            return s !== selectedUser.id;
          });
          return selectedUser.name + ' + ' + otherSelected.length + ' more';
        } else {
          return firstUser.name + ' + ' + (selectedUsers.length - 1) + ' more';
        }
      };

      $('.assign-to-me-link').on('click', function (e) {
        e.preventDefault();
        $(e.currentTarget).hide();

        if ($dropdown.data('multiSelect')) {
          assignYourself();
          checkMaxSelect();

          var currentUserInfo = $dropdown.data('currentUserInfo');
          $dropdown.find('.dropdown-toggle-text').text(getMultiSelectDropdownTitle(currentUserInfo)).removeClass('is-default');
        } else {
          var $input = $('input[name="' + $dropdown.data('fieldName') + '"]');
          $input.val(gon.current_user_id);
          selectedId = $input.val();
          $dropdown.find('.dropdown-toggle-text').text(gon.current_user_fullname).removeClass('is-default');
        }
      });

      $block.on('click', '.js-assign-yourself', function (e) {
        e.preventDefault();
        return assignTo(_this.currentUser.id);
      });

      assignTo = function assignTo(selected) {
        var data;
        data = {};
        data[abilityName] = {};
        data[abilityName].assignee_id = selected != null ? selected : null;
        $loading.removeClass('hidden').fadeIn();
        $dropdown.trigger('loading.gl.dropdown');

        return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].put(issueURL, data).then(function (_ref) {
          var data = _ref.data;

          var user;
          $dropdown.trigger('loaded.gl.dropdown');
          $loading.fadeOut();
          if (data.assignee) {
            user = {
              name: data.assignee.name,
              username: data.assignee.username,
              avatar: data.assignee.avatar_url
            };
          } else {
            user = {
              name: '未指派',
              username: '',
              avatar: ''
            };
          }
          $value.html(assigneeTemplate(user));
          $collapsedSidebar.attr('title', __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name)).tooltip('fixTitle');
          return $collapsedSidebar.html(collapsedAssigneeTemplate(user));
        });
      };
      collapsedAssigneeTemplate = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template('<% if( avatar ) { %> <a class="author_link" href="/<%- username %>"> <img width="24" class="avatar avatar-inline s24" alt="" src="<%- avatar %>"> </a> <% } else { %> <i class="fa fa-user"></i> <% } %>');
      assigneeTemplate = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template('<% if (username) { %> <a class="author_link bold" href="/<%- username %>"> <% if( avatar ) { %> <img width="32" class="avatar avatar-inline s32" alt="" src="<%- avatar %>"> <% } %> <span class="author"><%- name %></span> <span class="username"> @<%- username %> </span> </a> <% } else { %> <span class="no-value assign-yourself"> No assignee - <a href="#" class="js-assign-yourself"> assign yourself </a> </span> <% } %>');
      return $dropdown.glDropdown({
        showMenuAbove: showMenuAbove,
        data: function data(term, callback) {
          return _this.users(term, options, function (users) {
            // GitLabDropdownFilter returns this.instance
            // GitLabDropdownRemote returns this.options.instance
            var glDropdown = this.instance || this.options.instance;
            glDropdown.options.processData(term, users, callback);
          }.bind(this));
        },
        processData: function processData(term, data, callback) {
          var users = data;

          // Only show assigned user list when there is no search term
          if ($dropdown.hasClass('js-multiselect') && term.length === 0) {
            var selectedInputs = getSelectedUserInputs();

            // Potential duplicate entries when dealing with issue board
            // because issue board is also managed by vue
            var selectedUsers = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.uniq(selectedInputs, false, function (a) {
              return a.value;
            }).filter(function (input) {
              var userId = parseInt(input.value, 10);
              var inUsersArray = users.find(function (u) {
                return u.id === userId;
              });

              return !inUsersArray && userId !== 0;
            }).map(function (input) {
              var userId = parseInt(input.value, 10);
              var _input$dataset = input.dataset,
                  avatarUrl = _input$dataset.avatarUrl,
                  avatar_url = _input$dataset.avatar_url,
                  name = _input$dataset.name,
                  username = _input$dataset.username;

              return {
                avatar_url: avatarUrl || avatar_url,
                id: userId,
                name: name,
                username: username
              };
            });

            users = data.concat(selectedUsers);
          }

          var anyUser = void 0;
          var index = void 0;
          var j = void 0;
          var len = void 0;
          var name = void 0;
          var obj = void 0;
          var showDivider = void 0;
          if (term.length === 0) {
            showDivider = 0;
            if (firstUser) {
              // Move current user to the front of the list
              for (index = j = 0, len = users.length; j < len; index = j += 1) {
                obj = users[index];
                if (obj.username === firstUser) {
                  users.splice(index, 1);
                  users.unshift(obj);
                  break;
                }
              }
            }
            if (showNullUser) {
              showDivider += 1;
              users.unshift({
                beforeDivider: true,
                name: '未指派',
                id: 0
              });
            }
            if (showAnyUser) {
              showDivider += 1;
              name = showAnyUser;
              if (name === true) {
                name = 'Any User';
              }
              anyUser = {
                beforeDivider: true,
                name: name,
                id: null
              };
              users.unshift(anyUser);
            }

            if (showDivider) {
              users.splice(showDivider, 0, 'divider');
            }

            if ($dropdown.hasClass('js-multiselect')) {
              var selected = getSelected().filter(function (i) {
                return i !== 0;
              });

              if (selected.length > 0) {
                if ($dropdown.data('dropdownHeader')) {
                  showDivider += 1;
                  users.splice(showDivider, 0, {
                    header: $dropdown.data('dropdownHeader')
                  });
                }

                var _selectedUsers = users.filter(function (u) {
                  return selected.indexOf(u.id) !== -1;
                }).sort(function (a, b) {
                  return a.name > b.name;
                });

                users = users.filter(function (u) {
                  return selected.indexOf(u.id) === -1;
                });

                _selectedUsers.forEach(function (selectedUser) {
                  showDivider += 1;
                  users.splice(showDivider, 0, selectedUser);
                });

                users.splice(showDivider + 1, 0, 'divider');
              }
            }
          }

          callback(users);
          if (showMenuAbove) {
            $dropdown.data('glDropdown').positionMenuAbove();
          }
        },
        filterable: true,
        filterRemote: true,
        search: {
          fields: ['name', 'username']
        },
        selectable: true,
        fieldName: $dropdown.data('fieldName'),
        toggleLabel: function toggleLabel(selected, el, glDropdown) {
          var inputValue = glDropdown.filterInput.val();

          if (this.multiSelect && inputValue === '') {
            // Remove non-users from the fullData array
            var users = glDropdown.filteredFullData();
            var callback = glDropdown.parseData.bind(glDropdown);

            // Update the data model
            this.processData(inputValue, users, callback);
          }

          if (this.multiSelect) {
            return getMultiSelectDropdownTitle(selected, $(el).hasClass('is-active'));
          }

          if (selected && 'id' in selected && $(el).hasClass('is-active')) {
            $dropdown.find('.dropdown-toggle-text').removeClass('is-default');
            if (selected.text) {
              return selected.text;
            } else {
              return selected.name;
            }
          } else {
            $dropdown.find('.dropdown-toggle-text').addClass('is-default');
            return defaultLabel;
          }
        },
        defaultLabel: defaultLabel,
        hidden: function hidden(e) {
          if ($dropdown.hasClass('js-multiselect')) {
            emitSidebarEvent('sidebar.saveAssignees');
          }

          if (!$dropdown.data('alwaysShowSelectbox')) {
            $selectbox.hide();

            // Recalculate where .value is because vue might have changed it
            $block = $selectbox.closest('.block');
            $value = $block.find('.value');
            // display:block overrides the hide-collapse rule
            $value.css('display', '');
          }
        },
        multiSelect: $dropdown.hasClass('js-multiselect'),
        inputMeta: $dropdown.data('inputMeta'),
        clicked: function clicked(options) {
          var $el = options.$el,
              e = options.e,
              isMarking = options.isMarking;

          var user = options.selectedObj;

          if ($dropdown.hasClass('js-multiselect')) {
            var isActive = $el.hasClass('is-active');
            var previouslySelected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('fieldName') + "'][value!=0]");

            // Enables support for limiting the number of users selected
            // Automatically removes the first on the list if more users are selected
            checkMaxSelect();

            if (user.beforeDivider && user.name.toLowerCase() === '未指派') {
              // Unassigned selected
              previouslySelected.each(function (index, element) {
                var id = parseInt(element.value, 10);
                element.remove();
              });
              emitSidebarEvent('sidebar.removeAllAssignees');
            } else if (isActive) {
              // user selected
              emitSidebarEvent('sidebar.addAssignee', user);

              // Remove unassigned selection (if it was previously selected)
              var unassignedSelected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('fieldName') + "'][value=0]");

              if (unassignedSelected) {
                unassignedSelected.remove();
              }
            } else {
              if (previouslySelected.length === 0) {
                // Select unassigned because there is no more selected users
                this.addInput($dropdown.data('fieldName'), 0, {});
              }

              // User unselected
              emitSidebarEvent('sidebar.removeAssignee', user);
            }

            if (getSelected().find(function (u) {
              return u === gon.current_user_id;
            })) {
              $('.assign-to-me-link').hide();
            } else {
              $('.assign-to-me-link').show();
            }
          }

          var isIssueIndex, isMRIndex, page, selected;
          page = $('body').attr('data-page');
          isIssueIndex = page === 'projects:issues:index';
          isMRIndex = page === page && page === 'projects:merge_requests:index';
          if ($dropdown.hasClass('js-filter-bulk-update') || $dropdown.hasClass('js-issuable-form-dropdown')) {
            e.preventDefault();

            var isSelecting = user.id !== selectedId;
            selectedId = isSelecting ? user.id : selectedIdDefault;

            if (selectedId === gon.current_user_id) {
              $('.assign-to-me-link').hide();
            } else {
              $('.assign-to-me-link').show();
            }
            return;
          }
          if ($el.closest('.add-issues-modal').length) {
            gl.issueBoards.ModalStore.store.filter[$dropdown.data('fieldName')] = user.id;
          } else if (handleClick) {
            e.preventDefault();
            handleClick(user, isMarking);
          } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
            return Issuable.filterResults($dropdown.closest('form'));
          } else if ($dropdown.hasClass('js-filter-submit')) {
            return $dropdown.closest('form').submit();
          } else if (!$dropdown.hasClass('js-multiselect')) {
            selected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('fieldName') + "']").val();
            return assignTo(selected);
          }

          // Automatically close dropdown after assignee is selected
          // since CE has no multiple assignees
          // EE does not have a max-select
          if ($dropdown.data('maxSelect') && getSelected().length === $dropdown.data('maxSelect')) {
            // Close the dropdown
            $dropdown.dropdown('toggle');
          }
        },
        id: function id(user) {
          return user.id;
        },
        opened: function opened(e) {
          var $el = $(e.currentTarget);
          var selected = getSelected();
          if ($dropdown.hasClass('js-issue-board-sidebar') && selected.length === 0) {
            this.addInput($dropdown.data('fieldName'), 0, {});
          }
          $el.find('.is-active').removeClass('is-active');

          function highlightSelected(id) {
            $el.find('li[data-user-id="' + id + '"] .dropdown-menu-user-link').addClass('is-active');
          }

          if (selected.length > 0) {
            getSelected().forEach(function (selectedId) {
              return highlightSelected(selectedId);
            });
          } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
            highlightSelected(0);
          } else {
            highlightSelected(selectedId);
          }
        },
        updateLabel: $dropdown.data('dropdownTitle'),
        renderRow: function renderRow(user) {
          var avatar, img, listClosingTags, listWithName, listWithUserName, username;
          username = user.username ? "@" + user.username : "";
          avatar = user.avatar_url ? user.avatar_url : gon.default_avatar_url;

          var selected = false;

          if (this.multiSelect) {
            selected = getSelected().find(function (u) {
              return user.id === u;
            });

            var fieldName = this.fieldName;
            var field = $dropdown.closest('.selectbox').find("input[name='" + fieldName + "'][value='" + user.id + "']");

            if (field.length) {
              selected = true;
            }
          } else {
            selected = user.id === selectedId;
          }

          img = "";
          if (user.beforeDivider != null) {
            '<li><a href=\'#\' class=\'' + (selected === true ? 'is-active' : '') + '\'>' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name) + '</a></li>';
          } else {
            img = "<img src='" + avatar + "' class='avatar avatar-inline' width='32' />";
          }

          return '\n            <li data-user-id=' + user.id + '>\n              <a href=\'#\' class=\'dropdown-menu-user-link ' + (selected === true ? 'is-active' : '') + '\'>\n                ' + img + '\n                <strong class=\'dropdown-menu-user-full-name\'>\n                  ' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name) + '\n                </strong>\n                ' + (username ? '<span class=\'dropdown-menu-user-username\'>' + username + '</span>' : '') + '\n              </a>\n            </li>\n          ';
        }
      });
    };
  }(this));
  $('.ajax-users-select').each(function (_this) {
    return function (i, select) {
      var firstUser, showAnyUser, showEmailUser, showNullUser;
      var options = {};
      options.skipLdap = $(select).hasClass('skip_ldap');
      options.projectId = $(select).data('projectId');
      options.groupId = $(select).data('groupId');
      options.showCurrentUser = $(select).data('currentUser');
      options.authorId = $(select).data('authorId');
      options.skipUsers = $(select).data('skipUsers');
      showNullUser = $(select).data('nullUser');
      showAnyUser = $(select).data('anyUser');
      showEmailUser = $(select).data('emailUser');
      firstUser = $(select).data('firstUser');
      return $(select).select2({
        placeholder: "Search for a user",
        multiple: $(select).hasClass('multiselect'),
        minimumInputLength: 0,
        query: function query(_query) {
          return _this.users(_query.term, options, function (users) {
            var anyUser, data, emailUser, index, j, len, name, nullUser, obj, ref;
            data = {
              results: users
            };
            if (_query.term.length === 0) {
              if (firstUser) {
                // Move current user to the front of the list
                ref = data.results;
                for (index = j = 0, len = ref.length; j < len; index = j += 1) {
                  obj = ref[index];
                  if (obj.username === firstUser) {
                    data.results.splice(index, 1);
                    data.results.unshift(obj);
                    break;
                  }
                }
              }
              if (showNullUser) {
                nullUser = {
                  name: '未指派',
                  id: 0
                };
                data.results.unshift(nullUser);
              }
              if (showAnyUser) {
                name = showAnyUser;
                if (name === true) {
                  name = 'Any User';
                }
                anyUser = {
                  name: name,
                  id: null
                };
                data.results.unshift(anyUser);
              }
            }
            if (showEmailUser && data.results.length === 0 && _query.term.match(/^[^@]+@[^@]+$/)) {
              var trimmed = _query.term.trim();
              emailUser = {
                name: "邀请 \"" + _query.term + "\" by email",
                username: trimmed,
                id: trimmed,
                invite: true
              };
              data.results.unshift(emailUser);
            }
            return _query.callback(data);
          });
        },
        initSelection: function initSelection() {
          var args;
          args = 1 <= arguments.length ? [].slice.call(arguments, 0) : [];
          return _this.initSelection.apply(_this, args);
        },
        formatResult: function formatResult() {
          var args;
          args = 1 <= arguments.length ? [].slice.call(arguments, 0) : [];
          return _this.formatResult.apply(_this, args);
        },
        formatSelection: function formatSelection() {
          var args;
          args = 1 <= arguments.length ? [].slice.call(arguments, 0) : [];
          return _this.formatSelection.apply(_this, args);
        },
        dropdownCssClass: "ajax-users-dropdown",
        // we do not want to escape markup since we are displaying html in results
        escapeMarkup: function escapeMarkup(m) {
          return m;
        }
      });
    };
  }(this));
}

UsersSelect.prototype.initSelection = function (element, callback) {
  var id, nullUser;
  id = $(element).val();
  if (id === "0") {
    nullUser = {
      name: '未指派'
    };
    return callback(nullUser);
  } else if (id !== "") {
    return this.user(id, callback);
  }
};

UsersSelect.prototype.formatResult = function (user) {
  var avatar;
  if (user.avatar_url) {
    avatar = user.avatar_url;
  } else {
    avatar = gon.default_avatar_url;
  }
  return "<div class='user-result " + (!user.username ? 'no-username' : void 0) + "'> <div class='user-image'><img class='avatar avatar-inline s32' src='" + avatar + "'></div> <div class='user-name dropdown-menu-user-full-name'>" + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name) + "</div> <div class='user-username dropdown-menu-user-username'>" + (!user.invite ? "@" + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.username) : "") + "</div> </div>";
};

UsersSelect.prototype.formatSelection = function (user) {
  return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name);
};

UsersSelect.prototype.user = function (user_id, callback) {
  if (!/^\d+$/.test(user_id)) {
    return false;
  }

  var url;
  url = this.buildUrl(this.userPath);
  url = url.replace(':id', user_id);
  return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(url).then(function (_ref2) {
    var data = _ref2.data;

    callback(data);
  });
};

// Return users list. Filtered by query
// Only active users retrieved
UsersSelect.prototype.users = function (query, options, callback) {
  var url = this.buildUrl(this.usersPath);
  var params = {
    search: query,
    active: true,
    project_id: options.projectId || null,
    group_id: options.groupId || null,
    skip_ldap: options.skipLdap || null,
    todo_filter: options.todoFilter || null,
    todo_state_filter: options.todoStateFilter || null,
    current_user: options.showCurrentUser || null,
    author_id: options.authorId || null,
    skip_users: options.skipUsers || null
  };
  return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(url, { params: params }).then(function (_ref3) {
    var data = _ref3.data;

    callback(data);
  });
};

UsersSelect.prototype.buildUrl = function (url) {
  if (gon.relative_url_root != null) {
    url = gon.relative_url_root.replace(/\/$/, '') + url;
  }
  return url;
};

/* harmony default export */ __webpack_exports__["a"] = (UsersSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_merge_request_widget/components/mr_widget_status_icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/ci_icon.vue + 2 modules
var ci_icon = __webpack_require__("./vue_shared/components/ci_icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_status_icon.vue




/* harmony default export */ var mr_widget_status_icon = ({
  components: {
    ciIcon: ci_icon["a" /* default */],
    loadingIcon: loading_icon["a" /* default */]
  },
  props: {
    status: {
      type: String,
      required: true
    },
    showDisabledButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isLoading: function isLoading() {
      return this.status === 'loading';
    },
    statusObj: function statusObj() {
      return {
        group: this.status,
        icon: 'status_' + this.status
      };
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b6b0385","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_status_icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-children flex-container-block append-right-10"},[(_vm.isLoading)?_c('div',{staticClass:"mr-widget-icon"},[_c('loading-icon')],1):_c('ci-icon',{attrs:{"status":_vm.statusObj}}),_vm._v(" "),(_vm.showDisabledButton)?_c('button',{staticClass:"js-disabled-merge-button btn btn-success btn-sm",attrs:{"type":"button","disabled":"true"}},[_vm._v("\n    "+_vm._s(_vm.s__("mrWidget|Merge"))+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_status_icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  mr_widget_status_icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_status_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_merge_request_widget/components/states/mr_widget_wip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mr_widget_status_icon_vue__ = __webpack_require__("./vue_merge_request_widget/components/mr_widget_status_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub__ = __webpack_require__("./vue_merge_request_widget/event_hub.js");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MRWidgetWIP',
  props: {
    mr: { type: Object, required: true },
    service: { type: Object, required: true }
  },
  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_1__vue_shared_directives_tooltip__["a" /* default */]
  },
  data: function data() {
    return {
      isMakingRequest: false
    };
  },

  components: {
    statusIcon: __WEBPACK_IMPORTED_MODULE_0__mr_widget_status_icon_vue__["a" /* default */]
  },
  methods: {
    removeWIP: function removeWIP() {
      var _this = this;

      this.isMakingRequest = true;
      this.service.removeWIP().then(function (res) {
        return res.data;
      }).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_2__event_hub__["a" /* default */].$emit('UpdateWidgetData', data);
        new window.Flash('该合并请求无法合并。', 'notice'); // eslint-disable-line
        $('.merge-request .detail-page-description .title').text(_this.mr.title);
      }).catch(function () {
        _this.isMakingRequest = false;
        new window.Flash('出现了错误，请重试。'); // eslint-disable-line
      });
    }
  },
  template: '\n    <div class="mr-widget-body media">\n      <status-icon status="warning" :show-disabled-button="Boolean(mr.removeWIPPath)" />\n      <div class="media-body space-children">\n        <span class="bold">\n          \u6B64\u5408\u5E76\u8BF7\u6C42\u5F53\u524D\u6B63\u5728\u8FDB\u884C\u4E2D\n          <i\n            v-tooltip\n            class="fa fa-question-circle"\n            title="\u5F53\u6B64\u5408\u5E76\u8BF7\u6C42\u51C6\u5907\u5C31\u7EEA\u65F6\uFF0C\u4ECE\u6807\u9898\u4E2D\u5220\u9664 WIP: \u524D\u7F00\u4EE5\u5141\u8BB8\u5176\u5408\u5E76\u3002"\n            aria-label="\u5F53\u6B64\u5408\u5E76\u8BF7\u6C42\u51C6\u5907\u5C31\u7EEA\u65F6\uFF0C\u4ECE\u6807\u9898\u4E2D\u5220\u9664 WIP: \u524D\u7F00\u4EE5\u5141\u8BB8\u5176\u5408\u5E76\u3002">\n           </i>\n        </span>\n        <button\n          v-if="mr.removeWIPPath"\n          @click="removeWIP"\n          :disabled="isMakingRequest"\n          type="button"\n          class="btn btn-default btn-xs js-remove-wip">\n          <i\n            v-if="isMakingRequest"\n            class="fa fa-spinner fa-spin"\n            aria-hidden="true" />\n            \u89E3\u51B3 WIP \u72B6\u6001\n        </button>\n      </div>\n    </div>\n  '
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_merge_request_widget/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ "./vue_shared/components/ci_badge_link.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/ci_icon.vue + 2 modules
var ci_icon = __webpack_require__("./vue_shared/components/ci_icon.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/ci_badge_link.vue



/**
 * Renders CI Badge link with CI icon and status text based on
 * API response shared between all places where it is used.
 *
 * Receives status object containing:
 * status: {
 *   details_path: "/gitlab-org/gitlab-ce/pipelines/8150156" // url
 *   group:"running" // used for CSS class
 *   icon: "icon_status_running" // used to render the icon
 *   label:"running" // used for potential tooltip
 *   text:"running" // text rendered
 * }
 *
 * Used in:
 * - Pipelines table - first column
 * - Jobs table - first column
 * - Pipeline show view - header
 * - Job show view - header
 * - MR widget
 */

/* harmony default export */ var ci_badge_link = ({
  components: {
    ciIcon: ci_icon["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    status: {
      type: Object,
      required: true
    },
    showText: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    cssClass: function cssClass() {
      var className = this.status.group;
      return className ? 'ci-status ci-' + className : 'ci-status';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a93a9e9","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_badge_link.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.cssClass,attrs:{"href":_vm.status.details_path,"title":!_vm.showText ? _vm.status.text : ''}},[_c('ci-icon',{attrs:{"status":_vm.status}}),_vm._v(" "),(_vm.showText)?[_vm._v("\n    "+_vm._s(_vm.status.text)+"\n  ")]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/ci_badge_link.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ci_badge_link,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_ci_badge_link = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/ci_icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/ci_icon.vue



/**
 * Renders CI icon based on API response shared between all places where it is used.
 *
 * Receives status object containing:
 * status: {
 *   details_path: "/gitlab-org/gitlab-ce/pipelines/8150156" // url
 *   group:"running" // used for CSS class
 *   icon: "icon_status_running" // used to render the icon
 *   label:"running" // used for potential tooltip
 *   text:"running" // text rendered
 * }
 *
 * Used in:
 * - Pipelines table Badge
 * - Pipelines table mini graph
 * - Pipeline graph
 * - Pipeline show view badge
 * - Jobs table
 * - Jobs show view header
 * - Jobs show view sidebar
 */
/* harmony default export */ var ci_icon = ({
  components: {
    icon: icon["a" /* default */]
  },
  props: {
    status: {
      type: Object,
      required: true
    }
  },

  computed: {
    cssClass: function cssClass() {
      var status = this.status.group;
      return 'ci-status-icon ci-status-icon-' + status + ' js-ci-status-icon-' + status;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36896c14","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.cssClass},[_c('icon',{attrs:{"name":_vm.status.icon}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/ci_icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ci_icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_ci_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/clipboard_button.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/clipboard_button.vue

/**
 * Falls back to the code used in `copy_to_clipboard.js`
 */


/* harmony default export */ var clipboard_button = ({
  name: 'ClipboardButton',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    text: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    },
    tooltipContainer: {
      type: [String, Boolean],
      required: false,
      default: false
    },
    cssClass: {
      type: String,
      required: false,
      default: 'btn-default'
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ceaea0ee","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/clipboard_button.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"btn",class:_vm.cssClass,attrs:{"type":"button","title":_vm.title,"data-clipboard-text":_vm.text,"data-container":_vm.tooltipContainer,"data-placement":_vm.tooltipPlacement}},[_c('i',{staticClass:"fa fa-clipboard",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/clipboard_button.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  clipboard_button,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_clipboard_button = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/commit.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_commit.svg
var _icon_commit = __webpack_require__("../../views/shared/icons/_icon_commit.svg");
var _icon_commit_default = /*#__PURE__*/__webpack_require__.n(_icon_commit);

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_link.vue + 2 modules
var user_avatar_link = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_link.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/commit.vue






/* harmony default export */ var commit = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    userAvatarLink: user_avatar_link["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    /**
     * Indicates the existance of a tag.
     * Used to render the correct icon, if true will render `fa-tag` icon,
     * if false will render a svg sprite fork icon
     */
    tag: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * If provided is used to render the branch name and url.
     * Should contain the following properties:
     * name
     * ref_url
     */
    commitRef: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    /**
     * Used to link to the commit sha.
     */
    commitUrl: {
      type: String,
      required: false,
      default: ''
    },

    /**
     * Used to show the commit short sha that links to the commit url.
     */
    shortSha: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * If provided shows the commit tile.
     */
    title: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * If provided renders information about the author of the commit.
     * When provided should include:
     * `avatar_url` to render the avatar icon
     * `web_url` to link to user profile
     * `username` to render alt and title tags
     */
    author: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    showBranch: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    /**
     * Used to verify if all the properties needed to render the commit
     * ref section were provided.
     *
     * @returns {Boolean}
     */
    hasCommitRef: function hasCommitRef() {
      return this.commitRef && this.commitRef.name && this.commitRef.ref_url;
    },

    /**
     * Used to verify if all the properties needed to render the commit
     * author section were provided.
     *
     * @returns {Boolean}
     */
    hasAuthor: function hasAuthor() {
      return this.author && this.author.avatar_url && this.author.path && this.author.username;
    },

    /**
     * If information about the author is provided will return a string
     * to be rendered as the alt attribute of the img tag.
     *
     * @returns {String}
     */
    userImageAltDescription: function userImageAltDescription() {
      return this.author && this.author.username ? this.author.username + '\'s avatar' : null;
    }
  },
  created: function created() {
    this.commitIconSvg = _icon_commit_default.a;
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03412931","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/commit.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"branch-commit"},[(_vm.hasCommitRef && _vm.showBranch)?[_c('div',{staticClass:"icon-container"},[(_vm.tag)?_c('i',{staticClass:"fa fa-tag",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(!_vm.tag)?_c('icon',{attrs:{"name":"fork"}}):_vm._e()],1),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"ref-name",attrs:{"href":_vm.commitRef.ref_url,"data-container":"body","title":_vm.commitRef.name}},[_vm._v("\n      "+_vm._s(_vm.commitRef.name)+"\n    ")])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"commit-icon js-commit-icon",domProps:{"innerHTML":_vm._s(_vm.commitIconSvg)}}),_vm._v(" "),_c('a',{staticClass:"commit-sha",attrs:{"href":_vm.commitUrl}},[_vm._v("\n    "+_vm._s(_vm.shortSha)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"commit-title flex-truncate-parent"},[(_vm.title)?_c('span',{staticClass:"flex-truncate-child"},[(_vm.hasAuthor)?_c('user-avatar-link',{staticClass:"avatar-image-container",attrs:{"link-href":_vm.author.path,"img-src":_vm.author.avatar_url,"img-alt":_vm.userImageAltDescription,"tooltip-text":_vm.author.username}}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"commit-row-message",attrs:{"href":_vm.commitUrl}},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])],1):_c('span',[_vm._v("\n      Cant find HEAD commit for this branch\n    ")])])],2)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/commit.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  commit,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_commit = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/icon.vue


/* This is a re-usable vue component for rendering a svg sprite
  icon

  Sample configuration:

  <icon
    name="retry"
    :size="32"
    css-classes="top"
  />

*/
// only allow classes in images.scss e.g. s12
var validSizes = [8, 12, 16, 18, 24, 32, 48, 72];

/* harmony default export */ var icon = ({
  props: {
    name: {
      type: String,
      required: true
    },

    size: {
      type: Number,
      required: false,
      default: 16,
      validator: function validator(value) {
        return validSizes.includes(value);
      }
    },

    cssClasses: {
      type: String,
      required: false,
      default: ''
    },

    width: {
      type: Number,
      required: false,
      default: null
    },

    height: {
      type: Number,
      required: false,
      default: null
    },

    y: {
      type: Number,
      required: false,
      default: null
    },

    x: {
      type: Number,
      required: false,
      default: null
    }
  },

  computed: {
    spriteHref: function spriteHref() {
      return gon.sprite_icons + '#' + this.name;
    },
    iconSizeClass: function iconSizeClass() {
      return this.size ? 's' + this.size : '';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43441268","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.iconSizeClass, _vm.cssClasses],attrs:{"width":_vm.width,"height":_vm.height,"x":_vm.x,"y":_vm.y}},[_c('use',_vm._b({},'use',{ 'xlink:href':_vm.spriteHref },false))])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/issue/issue_warning.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/issue/issue_warning.vue



/* harmony default export */ var issue_warning = ({
  components: {
    icon: icon["a" /* default */]
  },
  props: {
    isLocked: {
      type: Boolean,
      default: false,
      required: false
    },
    isConfidential: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    warningIcon: function warningIcon() {
      if (this.isConfidential) return 'eye-slash';
      if (this.isLocked) return 'lock';

      return '';
    },
    isLockedAndConfidential: function isLockedAndConfidential() {
      return this.isConfidential && this.isLocked;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f21ee85a","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/issue/issue_warning.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"issuable-note-warning"},[(!_vm.isLockedAndConfidential)?_c('icon',{staticClass:"icon inline",attrs:{"name":_vm.warningIcon,"size":16,"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(_vm.isLockedAndConfidential)?_c('span',[_vm._v("\n      "+_vm._s(_vm.__('This issue is confidential and locked.'))+"\n      "+_vm._s(_vm.__("People without permission will never\nget a notification and won't be able to comment."))+"\n    ")]):(_vm.isConfidential)?_c('span',[_vm._v("\n      "+_vm._s(_vm.__('This is a confidential issue.'))+"\n      "+_vm._s(_vm.__('Your comment will not be visible to the public.'))+"\n    ")]):(_vm.isLocked)?_c('span',[_vm._v("\n      "+_vm._s(_vm.__('This issue is locked.'))+"\n      "+_vm._s(_vm.__('Only project members can comment.'))+"\n    ")]):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/issue/issue_warning.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  issue_warning,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var issue_issue_warning = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/loading_button.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/loading_button.vue

/* eslint-disable vue/require-default-prop */
/* This is a re-usable vue component for rendering a button
  that will probably be sending off ajax requests and need
  to show the loading status by setting the `loading` option.
  This can also be used for initial page load when you don't
  know the action of the button yet by setting
  `loading: true, label: undefined`.

  Sample configuration:

  <loading-button
    :loading="true"
    :label="Hello"
    @click="..."
  />

*/



/* harmony default export */ var loading_button = ({
  components: {
    loadingIcon: loading_icon["a" /* default */]
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false
    },
    containerClass: {
      type: [String, Array, Object],
      required: false,
      default: 'btn btn-align-content'
    }
  },
  methods: {
    onClick: function onClick(e) {
      this.$emit('click', e);
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12fbc6dc","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/loading_button.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.containerClass,attrs:{"type":"button","disabled":_vm.loading || _vm.disabled},on:{"click":_vm.onClick}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('loading-icon',{staticClass:"js-loading-button-icon",class:{
        'append-right-5': _vm.label
      },attrs:{"inline":true}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.label)?_c('span',{staticClass:"js-loading-button-label"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e()])],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/loading_button.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  loading_button,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_loading_button = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/markdown/field.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/field.vue
var field = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/field.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f24c6ea8","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/field.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"gl-form",staticClass:"md-area js-vue-markdown-field",class:{ 'prepend-top-default append-bottom-default': _vm.addSpacingClasses }},[_c('markdown-header',{attrs:{"preview-markdown":_vm.previewMarkdown},on:{"preview-markdown":_vm.showPreviewTab,"write-markdown":_vm.showWriteTab}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.previewMarkdown),expression:"!previewMarkdown"}],staticClass:"md-write-holder"},[_c('div',{staticClass:"zen-backdrop"},[_vm._t("textarea"),_vm._v(" "),_c('a',{staticClass:"zen-control zen-control-leave js-zen-leave",attrs:{"href":"#","aria-label":"Enter zen mode"}},[_c('icon',{attrs:{"name":"screen-normal","size":32}})],1),_vm._v(" "),_c('markdown-toolbar',{attrs:{"markdown-docs-path":_vm.markdownDocsPath,"quick-actions-docs-path":_vm.quickActionsDocsPath,"can-attach-file":_vm.canAttachFile}})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.previewMarkdown),expression:"previewMarkdown"}],staticClass:"md md-preview-holder md-preview"},[_c('div',{ref:"markdown-preview",domProps:{"innerHTML":_vm._s(_vm.markdownPreview)}}),_vm._v(" "),(_vm.markdownPreviewLoading)?_c('span',[_vm._v("\n      Loading...\n    ")]):_vm._e()]),_vm._v(" "),(_vm.previewMarkdown && !_vm.markdownPreviewLoading)?[(_vm.referencedCommands)?_c('div',{staticClass:"referenced-commands",domProps:{"innerHTML":_vm._s(_vm.referencedCommands)}}):_vm._e(),_vm._v(" "),(_vm.shouldShowReferencedUsers)?_c('div',{staticClass:"referenced-users"},[_c('span',[_c('i',{staticClass:"fa fa-exclamation-triangle",attrs:{"aria-hidden":"true"}}),_vm._v("\n        You are about to add\n        "),_c('strong',[_c('span',{staticClass:"js-referenced-users-count"},[_vm._v("\n            "+_vm._s(_vm.referencedUsers.length)+"\n          ")])]),_vm._v(" people to the discussion. Proceed with caution.\n      ")])]):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/markdown/field.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  field["a" /* default */],
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var markdown_field = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/markdown/header.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/header.vue
var header = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/header.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-360119ee","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-header"},[_c('ul',{staticClass:"nav-links clearfix"},[_c('li',{staticClass:"md-header-tab",class:{ active: !_vm.previewMarkdown }},[_c('a',{staticClass:"js-write-link",attrs:{"href":"#md-write-holder","tabindex":"-1"},on:{"click":function($event){$event.preventDefault();_vm.writeMarkdownTab($event)}}},[_vm._v("\n        编写\n      ")])]),_vm._v(" "),_c('li',{staticClass:"md-header-tab",class:{ active: _vm.previewMarkdown }},[_c('a',{staticClass:"js-preview-link",attrs:{"href":"#md-preview-holder","tabindex":"-1"},on:{"click":function($event){$event.preventDefault();_vm.previewMarkdownTab($event)}}},[_vm._v("\n        预览\n      ")])]),_vm._v(" "),_c('li',{staticClass:"md-header-toolbar",class:{ active: !_vm.previewMarkdown }},[_c('toolbar-button',{attrs:{"tag":"**","button-title":"Add bold text","icon":"bold"}}),_vm._v(" "),_c('toolbar-button',{attrs:{"tag":"*","button-title":"Add italic text","icon":"italic"}}),_vm._v(" "),_c('toolbar-button',{attrs:{"tag":"> ","prepend":true,"button-title":"Insert a quote","icon":"quote"}}),_vm._v(" "),_c('toolbar-button',{attrs:{"tag":"`","tag-block":"```","button-title":"Insert code","icon":"code"}}),_vm._v(" "),_c('toolbar-button',{attrs:{"tag":"* ","prepend":true,"button-title":"Add a bullet list","icon":"list-bulleted"}}),_vm._v(" "),_c('toolbar-button',{attrs:{"tag":"1. ","prepend":true,"button-title":"Add a numbered list","icon":"list-numbered"}}),_vm._v(" "),_c('toolbar-button',{attrs:{"tag":"* [ ] ","prepend":true,"button-title":"Add a task list","icon":"task-done"}}),_vm._v(" "),_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"toolbar-btn toolbar-fullscreen-btn js-zen-enter",attrs:{"aria-label":"Go full screen","data-container":"body","tabindex":"-1","title":"Go full screen","type":"button"}},[_c('icon',{attrs:{"name":"screen-full"}})],1)],1)])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/markdown/header.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  header["a" /* default */],
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var markdown_header = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/markdown/toolbar.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/toolbar.vue

/* harmony default export */ var toolbar = ({
  props: {
    markdownDocsPath: {
      type: String,
      required: true
    },
    quickActionsDocsPath: {
      type: String,
      required: false,
      default: ''
    },
    canAttachFile: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    hasQuickActionsDocsPath: function hasQuickActionsDocsPath() {
      return this.quickActionsDocsPath !== '';
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42ea5fee","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/toolbar.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment-toolbar clearfix"},[_c('div',{staticClass:"toolbar-text"},[(!_vm.hasQuickActionsDocsPath && _vm.markdownDocsPath)?[_c('a',{attrs:{"href":_vm.markdownDocsPath,"target":"_blank","tabindex":"-1"}},[_vm._v("\n        Markdown is supported\n      ")])]:_vm._e(),_vm._v(" "),(_vm.hasQuickActionsDocsPath && _vm.markdownDocsPath)?[_c('a',{attrs:{"href":_vm.markdownDocsPath,"target":"_blank","tabindex":"-1"}},[_vm._v("\n        Markdown\n      ")]),_vm._v("\n      and\n      "),_c('a',{attrs:{"href":_vm.quickActionsDocsPath,"target":"_blank","tabindex":"-1"}},[_vm._v("\n        quick actions\n      ")]),_vm._v("\n      are supported\n    ")]:_vm._e()],2),_vm._v(" "),(_vm.canAttachFile)?_c('span',{staticClass:"uploading-container"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-xs hide button-cancel-uploading-files",attrs:{"type":"button"}},[_vm._v("\n      Cancel\n    ")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"uploading-progress-container hide"},[_c('i',{staticClass:"fa fa-file-image-o toolbar-button-icon",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"attaching-file-message"}),_vm._v(" "),_c('span',{staticClass:"uploading-progress"},[_vm._v("0%")]),_vm._v(" "),_c('span',{staticClass:"uploading-spinner"},[_c('i',{staticClass:"fa fa-spinner fa-spin toolbar-button-icon",attrs:{"aria-hidden":"true"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"uploading-error-container hide"},[_c('span',{staticClass:"uploading-error-icon"},[_c('i',{staticClass:"fa fa-file-image-o toolbar-button-icon",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"uploading-error-message"}),_vm._v(" "),_c('button',{staticClass:"retry-uploading-link",attrs:{"type":"button"}},[_vm._v("\n        Try again\n      ")]),_vm._v("\n      or\n      "),_c('button',{staticClass:"attach-new-file markdown-selector",attrs:{"type":"button"}},[_vm._v("\n        attach a new file\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"markdown-selector button-attach-file",attrs:{"tabindex":"-1","type":"button"}},[_c('i',{staticClass:"fa fa-file-image-o toolbar-button-icon",attrs:{"aria-hidden":"true"}}),_vm._v("\n      Attach a file\n    ")])}]

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/markdown/toolbar.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  toolbar,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var markdown_toolbar = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/markdown/toolbar_button.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/markdown/toolbar_button.vue




/* harmony default export */ var toolbar_button = ({
  components: {
    icon: icon["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    buttonTitle: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    tag: {
      type: String,
      required: true
    },
    tagBlock: {
      type: String,
      required: false,
      default: ''
    },
    prepend: {
      type: Boolean,
      required: false,
      default: false
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e885040","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/toolbar_button.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"toolbar-btn js-md",attrs:{"type":"button","tabindex":"-1","data-container":"body","data-md-tag":_vm.tag,"data-md-block":_vm.tagBlock,"data-md-prepend":_vm.prepend,"title":_vm.buttonTitle,"aria-label":_vm.buttonTitle}},[_c('icon',{attrs:{"name":_vm.icon}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/markdown/toolbar_button.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  toolbar_button,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var markdown_toolbar_button = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/modal.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/modal.vue
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable vue/require-default-prop */
/* harmony default export */ var modal = ({
  name: 'Modal',

  props: {
    id: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: false
    },
    hideFooter: {
      type: Boolean,
      required: false,
      default: false
    },
    kind: {
      type: String,
      required: false,
      default: 'primary'
    },
    modalDialogClass: {
      type: String,
      required: false,
      default: ''
    },
    closeKind: {
      type: String,
      required: false,
      default: 'default'
    },
    closeButtonLabel: {
      type: String,
      required: false,
      default: 'Cancel'
    },
    primaryButtonLabel: {
      type: String,
      required: false,
      default: ''
    },
    secondaryButtonLabel: {
      type: String,
      required: false,
      default: ''
    },
    submitDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    btnKindClass: function btnKindClass() {
      return _defineProperty({}, 'btn-' + this.kind, true);
    },
    btnCancelKindClass: function btnCancelKindClass() {
      return _defineProperty({}, 'btn-' + this.closeKind, true);
    }
  },

  methods: {
    emitCancel: function emitCancel(event) {
      this.$emit('cancel', event);
    },
    emitSubmit: function emitSubmit(event) {
      this.$emit('submit', event);
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e18618c","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-open"},[_c('div',{staticClass:"modal",class:_vm.id ? '' : 'show',attrs:{"id":_vm.id,"role":"dialog","tabindex":"-1"}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalDialogClass,attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('h4',{staticClass:"modal-title pull-left"},[_vm._v("\n              "+_vm._s(_vm.title)+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"close pull-right",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.emitCancel($event)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",[_c('p',[_vm._v(_vm._s(_vm.text))])],{text:_vm.text})],2),_vm._v(" "),(!_vm.hideFooter)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn",class:_vm.btnCancelKindClass,attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.emitCancel($event)}}},[_vm._v("\n            "+_vm._s(_vm.closeButtonLabel)+"\n          ")]),_vm._v(" "),(_vm.secondaryButtonLabel)?_vm._t("secondary-button",[(_vm.secondaryButtonLabel)?_c('button',{staticClass:"btn",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n              "+_vm._s(_vm.secondaryButtonLabel)+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.primaryButtonLabel)?_c('button',{staticClass:"btn js-primary-button",class:_vm.btnKindClass,attrs:{"type":"button","disabled":_vm.submitDisabled,"data-dismiss":"modal"},on:{"click":function($event){_vm.emitSubmit($event)}}},[_vm._v("\n            "+_vm._s(_vm.primaryButtonLabel)+"\n          ")]):_vm._e()],2):_vm._e()])])]),_vm._v(" "),(!_vm.id)?_c('div',{staticClass:"modal-backdrop fade in"}):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/modal.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/notes/placeholder_note.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("../../../node_modules/vuex/dist/vuex.esm.js");

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_link.vue + 2 modules
var user_avatar_link = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_link.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/notes/placeholder_note.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Common component to render a placeholder note and user information.
 *
 * This component needs to be used with a vuex store.
 * That vuex store needs to have a `getUserData` getter that contains
 * {
 *   path: String,
 *   avatar_url: String,
 *   name: String,
 *   username: String,
 * }
 *
 * @example
 * <placeholder-note
 *   :note="{body: 'This is a note'}"
 *   />
 */



/* harmony default export */ var placeholder_note = ({
  name: 'PlaceholderNote',
  components: {
    userAvatarLink: user_avatar_link["a" /* default */]
  },
  props: {
    note: {
      type: Object,
      required: true
    }
  },
  computed: _extends({}, Object(vuex_esm["c" /* mapGetters */])(['getUserData']))
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ffa173","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/notes/placeholder_note.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"note being-posted fade-in-half timeline-entry"},[_c('div',{staticClass:"timeline-entry-inner"},[_c('div',{staticClass:"timeline-icon"},[_c('user-avatar-link',{attrs:{"link-href":_vm.getUserData.path,"img-src":_vm.getUserData.avatar_url,"img-size":40}})],1),_vm._v(" "),_c('div',{staticClass:"timeline-content",class:{ discussion: !_vm.note.individual_note }},[_c('div',{staticClass:"note-header"},[_c('div',{staticClass:"note-header-info"},[_c('a',{attrs:{"href":_vm.getUserData.path}},[_c('span',{staticClass:"hidden-xs"},[_vm._v(_vm._s(_vm.getUserData.name))]),_vm._v(" "),_c('span',{staticClass:"note-headline-light"},[_vm._v("@"+_vm._s(_vm.getUserData.username))])])])]),_vm._v(" "),_c('div',{staticClass:"note-body"},[_c('div',{staticClass:"note-text"},[_c('p',[_vm._v(_vm._s(_vm.note.body))])])])])])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/notes/placeholder_note.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  placeholder_note,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var notes_placeholder_note = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/notes/placeholder_system_note.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/notes/placeholder_system_note.vue

/**
 * Common component to render a placeholder system note.
 *
 * @example
 * <placeholder-system-note
 *  :note="{ body: 'Commands are being applied'}"
 *  />
 */
/* harmony default export */ var placeholder_system_note = ({
  name: 'PlaceholderSystemNote',
  props: {
    note: {
      type: Object,
      required: true
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a7a1da2","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/notes/placeholder_system_note.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"note system-note timeline-entry being-posted fade-in-half"},[_c('div',{staticClass:"timeline-entry-inner"},[_c('div',{staticClass:"timeline-content"},[_c('em',[_vm._v(_vm._s(_vm.note.body))])])])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/notes/placeholder_system_note.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  placeholder_system_note,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var notes_placeholder_system_note = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/notes/skeleton_note.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/skeleton_loading_container.vue

/* harmony default export */ var skeleton_loading_container = ({
  props: {
    small: {
      type: Boolean,
      required: false,
      default: false
    },
    lines: {
      type: Number,
      required: false,
      default: 6
    }
  },
  computed: {
    lineClasses: function lineClasses() {
      return new Array(this.lines).fill().map(function (_, i) {
        return "skeleton-line-" + (i + 1);
      });
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56ccf578","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/skeleton_loading_container.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animation-container",class:{
    'animation-container-small': _vm.small,
  }},_vm._l((_vm.lineClasses),function(css,index){return _c('div',{key:index,class:css})}))}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/skeleton_loading_container.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  skeleton_loading_container,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_skeleton_loading_container = (Component.exports);

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/notes/skeleton_note.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var skeleton_note = ({
  components: {
    skeletonLoadingContainer: components_skeleton_loading_container
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4491f3c","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/notes/skeleton_note.vue
var skeleton_note_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"timeline-entry note"},[_c('div',{staticClass:"timeline-entry-inner"},[_c('div',{staticClass:"timeline-icon"}),_vm._v(" "),_c('div',{staticClass:"timeline-content"},[_c('div',{staticClass:"note-header"}),_vm._v(" "),_c('div',{staticClass:"note-body"},[_c('skeleton-loading-container')],1)])])])}
var skeleton_note_staticRenderFns = []

// CONCATENATED MODULE: ./vue_shared/components/notes/skeleton_note.vue
/* script */


/* template */

/* template functional */
var skeleton_note___vue_template_functional__ = false
/* styles */
var skeleton_note___vue_styles__ = null
/* scopeId */
var skeleton_note___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var skeleton_note___vue_module_identifier__ = null

var skeleton_note_Component = Object(component_normalizer["a" /* default */])(
  skeleton_note,
  skeleton_note_render,
  skeleton_note_staticRenderFns,
  skeleton_note___vue_template_functional__,
  skeleton_note___vue_styles__,
  skeleton_note___vue_scopeId__,
  skeleton_note___vue_module_identifier__
)

/* harmony default export */ var notes_skeleton_note = __webpack_exports__["a"] = (skeleton_note_Component.exports);


/***/ }),

/***/ "./vue_shared/components/notes/system_note.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("../../../node_modules/vuex/dist/vuex.esm.js");

// EXTERNAL MODULE: ./notes/components/note_header.vue + 2 modules
var note_header = __webpack_require__("./notes/components/note_header.vue");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/notes/system_note.vue
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Common component to render a system note, icon and user information.
 *
 * This component needs to be used with a vuex store.
 * That vuex store needs to have a `targetNoteHash` getter
 *
 * @example
 * <system-note
 *   :note="{
 *     id: String,
 *     author: Object,
 *     createdAt: String,
 *     note_html: String,
 *     system_note_icon_name: String
 *    }"
 *   />
 */




/* harmony default export */ var system_note = ({
  name: 'SystemNote',
  components: {
    noteHeader: note_header["a" /* default */]
  },
  props: {
    note: {
      type: Object,
      required: true
    }
  },
  computed: _extends({}, Object(vuex_esm["c" /* mapGetters */])(['targetNoteHash']), {
    noteAnchorId: function noteAnchorId() {
      return 'note_' + this.note.id;
    },
    isTargetNote: function isTargetNote() {
      return this.targetNoteHash === this.noteAnchorId;
    },
    iconHtml: function iconHtml() {
      return Object(common_utils["G" /* spriteIcon */])(this.note.system_note_icon_name);
    }
  })
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de213efc","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/notes/system_note.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"note system-note timeline-entry",class:{ target: _vm.isTargetNote },attrs:{"id":_vm.noteAnchorId}},[_c('div',{staticClass:"timeline-entry-inner"},[_c('div',{staticClass:"timeline-icon",domProps:{"innerHTML":_vm._s(_vm.iconHtml)}}),_vm._v(" "),_c('div',{staticClass:"timeline-content"},[_c('div',{staticClass:"note-header"},[_c('note-header',{attrs:{"author":_vm.note.author,"created-at":_vm.note.created_at,"note-id":_vm.note.id,"action-text-html":_vm.note.note_html}})],1)])])])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/notes/system_note.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  system_note,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var notes_system_note = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/time_ago_tooltip.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./vue_shared/mixins/timeago.js
var timeago = __webpack_require__("./vue_shared/mixins/timeago.js");

// EXTERNAL MODULE: ./lib/utils/datetime_utility.js
var datetime_utility = __webpack_require__("./lib/utils/datetime_utility.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/time_ago_tooltip.vue





/**
 * Port of ruby helper time_ago_with_tooltip
 */

/* harmony default export */ var time_ago_tooltip = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  mixins: [timeago["a" /* default */]],
  props: {
    time: {
      type: String,
      required: true
    },

    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    },

    cssClass: {
      type: String,
      required: false,
      default: ''
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-202207e1","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/time_ago_tooltip.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.cssClass,attrs:{"title":_vm.tooltipTitle(_vm.time),"data-placement":_vm.tooltipPlacement,"data-container":"body"}},[_vm._v("\n  "+_vm._s(_vm.timeFormated(_vm.time))+"\n")])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/time_ago_tooltip.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  time_ago_tooltip,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_time_ago_tooltip = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/toggle_button.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/toggle_button.vue





var ICON_ON = 'status_success_borderless';
var ICON_OFF = 'status_failed_borderless';
var LABEL_ON = Object(locale["e" /* s__ */])('ToggleButton|Toggle Status: ON');
var LABEL_OFF = Object(locale["e" /* s__ */])('ToggleButton|Toggle Status: OFF');

/* harmony default export */ var toggle_button = ({
  components: {
    icon: icon["a" /* default */],
    loadingIcon: loading_icon["a" /* default */]
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    name: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: Boolean,
      required: false,
      default: null
    },
    disabledInput: {
      type: Boolean,
      required: false,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    toggleIcon: function toggleIcon() {
      return this.value ? ICON_ON : ICON_OFF;
    },
    ariaLabel: function ariaLabel() {
      return this.value ? LABEL_ON : LABEL_OFF;
    }
  },

  methods: {
    toggleFeature: function toggleFeature() {
      if (!this.disabledInput) this.$emit('change', !this.value);
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26c91d7c","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/toggle_button.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"toggle-wrapper"},[(_vm.name)?_c('input',{attrs:{"type":"hidden","name":_vm.name},domProps:{"value":_vm.value}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"project-feature-toggle",class:{
      'is-checked': _vm.value,
      'is-disabled': _vm.disabledInput,
      'is-loading': _vm.isLoading
    },attrs:{"type":"button","aria-label":_vm.ariaLabel},on:{"click":_vm.toggleFeature}},[_c('loadingIcon',{staticClass:"loading-icon"}),_vm._v(" "),_c('span',{staticClass:"toggle-icon"},[_c('icon',{attrs:{"css-classes":"toggle-icon-svg","name":_vm.toggleIcon}})],1)],1)])}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/toggle_button.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  toggle_button,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_toggle_button = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/user_avatar/user_avatar_image.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../images/no_avatar.png
var no_avatar = __webpack_require__("../images/no_avatar.png");
var no_avatar_default = /*#__PURE__*/__webpack_require__.n(no_avatar);

// EXTERNAL MODULE: ./lazy_loader.js
var lazy_loader = __webpack_require__("./lazy_loader.js");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue


/* This is a re-usable vue component for rendering a user avatar that
  does not need to link to the user's profile. The image and an optional
  tooltip can be configured by props passed to this component.

  Sample configuration:

  <user-avatar-image
    :lazy="true"
    :img-src="userAvatarSrc"
    :img-alt="tooltipText"
    :tooltip-text="tooltipText"
    tooltip-placement="top"
  />

*/





/* harmony default export */ var user_avatar_image = ({
  name: 'UserAvatarImage',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    lazy: {
      type: Boolean,
      required: false,
      default: false
    },
    imgSrc: {
      type: String,
      required: false,
      default: no_avatar_default.a
    },
    cssClasses: {
      type: String,
      required: false,
      default: ''
    },
    imgAlt: {
      type: String,
      required: false,
      default: 'user avatar'
    },
    size: {
      type: Number,
      required: false,
      default: 20
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    }
  },
  computed: {
    // API response sends null when gravatar is disabled and
    // we provide an empty string when we use it inside user avatar link.
    // In both cases we should render the defaultAvatarUrl
    sanitizedSource: function sanitizedSource() {
      return this.imgSrc === '' || this.imgSrc === null ? no_avatar_default.a : this.imgSrc;
    },
    resultantSrcAttribute: function resultantSrcAttribute() {
      return this.lazy ? lazy_loader["b" /* placeholderImage */] : this.sanitizedSource;
    },
    tooltipContainer: function tooltipContainer() {
      return this.tooltipText ? 'body' : null;
    },
    avatarSizeClass: function avatarSizeClass() {
      return 's' + this.size;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75ce3616","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"avatar",class:( _obj = {
    lazy: _vm.lazy
  }, _obj[_vm.avatarSizeClass] = true, _obj[_vm.cssClasses] = true, _obj ),attrs:{"src":_vm.resultantSrcAttribute,"width":_vm.size,"height":_vm.size,"alt":_vm.imgAlt,"data-src":_vm.sanitizedSource,"data-container":_vm.tooltipContainer,"data-placement":_vm.tooltipPlacement,"title":_vm.tooltipText}})
var _obj;}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_avatar_image,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var user_avatar_user_avatar_image = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/user_avatar/user_avatar_link.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue + 2 modules
var user_avatar_image = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_link.vue


/* This is a re-usable vue component for rendering a user avatar wrapped in
  a clickable link (likely to the user's profile). The link, image, and
  tooltip can be configured by props passed to this component.

  Sample configuration:

  <user-avatar-link
    :link-href="userProfileUrl"
    :img-src="userAvatarSrc"
    :img-alt="tooltipText"
    :img-size="20"
    :tooltip-text="tooltipText"
    :tooltip-placement="top"
    :username="username"
  />

*/




/* harmony default export */ var user_avatar_link = ({
  name: 'UserAvatarLink',
  components: {
    userAvatarImage: user_avatar_image["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    linkHref: {
      type: String,
      required: false,
      default: ''
    },
    imgSrc: {
      type: String,
      required: false,
      default: ''
    },
    imgAlt: {
      type: String,
      required: false,
      default: ''
    },
    imgCssClasses: {
      type: String,
      required: false,
      default: ''
    },
    imgSize: {
      type: Number,
      required: false,
      default: 20
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    },
    username: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    shouldShowUsername: function shouldShowUsername() {
      return this.username.length > 0;
    },
    avatarTooltipText: function avatarTooltipText() {
      return this.shouldShowUsername ? '' : this.tooltipText;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dd80867","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_link.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"user-avatar-link",attrs:{"href":_vm.linkHref}},[_c('user-avatar-image',{attrs:{"img-src":_vm.imgSrc,"img-alt":_vm.imgAlt,"css-classes":_vm.imgCssClasses,"size":_vm.imgSize,"tooltip-text":_vm.avatarTooltipText,"tooltip-placement":_vm.tooltipPlacement}}),(_vm.shouldShowUsername)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],attrs:{"title":_vm.tooltipText,"tooltip-placement":_vm.tooltipPlacement}},[_vm._v(_vm._s(_vm.username))]):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/user_avatar/user_avatar_link.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_avatar_link,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var user_avatar_user_avatar_link = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/directives/popover.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Helper to user bootstrap popover in vue.js.
 * Follow docs for html attributes: https://getbootstrap.com/docs/3.3/javascript/#static-popover
 *
 * @example
 * import popover from 'vue_shared/directives/popover.js';
 * {
 *   directives: [popover]
 * }
 * <a v-popover="{options}">popover</a>
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    $(el).popover(binding.value);
  },
  unbind: function unbind(el) {
    $(el).popover('destroy');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_shared/directives/tooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    $(el).tooltip();
  },
  componentUpdated: function componentUpdated(el) {
    $(el).tooltip('fixTitle');
  },
  unbind: function unbind(el) {
    $(el).tooltip('destroy');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_shared/mixins/issuable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    issuableType: {
      required: true,
      type: String
    }
  },

  computed: {
    issuableDisplayName: function issuableDisplayName() {
      return this.issuableType.replace(/_/g, ' ');
    }
  }
});

/***/ }),

/***/ "./vue_shared/mixins/timeago.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");


/**
 * Mixin with time ago methods used in some vue components
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    timeFormated: function timeFormated(time) {
      var timeago = Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__["d" /* getTimeago */])();

      return timeago.format(time);
    },
    tooltipTitle: function tooltipTitle(time) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__["a" /* formatDate */])(time);
    }
  }
});

/***/ }),

/***/ "./zen_mode.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_jquery_scrollTo__ = __webpack_require__("../../../vendor/assets/javascripts/jquery.scrollTo.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_jquery_scrollTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendor_jquery_scrollTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dropzone__ = __webpack_require__("../../../node_modules/dropzone/dist/dropzone.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mousetrap_plugins_pause_mousetrap_pause__ = __webpack_require__("../../../node_modules/mousetrap/plugins/pause/mousetrap-pause.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mousetrap_plugins_pause_mousetrap_pause___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mousetrap_plugins_pause_mousetrap_pause__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-unused-vars, consistent-return, camelcase, comma-dangle, max-len, class-methods-use-this */

// Zen Mode (full screen) textarea
//
/*= provides zen_mode:enter */
/*= provides zen_mode:leave */






__WEBPACK_IMPORTED_MODULE_1_dropzone___default.a.autoDiscover = false;

//
// ### Events
//
// `zen_mode:enter`
//
// Fired when the "Edit in fullscreen" link is clicked.
//
// **Synchronicity** Sync
// **Bubbles** Yes
// **Cancelable** No
// **Target** a.js-zen-enter
//
// `zen_mode:leave`
//
// Fired when the "Leave Fullscreen" link is clicked.
//
// **Synchronicity** Sync
// **Bubbles** Yes
// **Cancelable** No
// **Target** a.js-zen-leave
//

var ZenMode = function () {
  function ZenMode() {
    _classCallCheck(this, ZenMode);

    this.active_backdrop = null;
    this.active_textarea = null;
    $(document).on('click', '.js-zen-enter', function (e) {
      e.preventDefault();
      return $(e.currentTarget).trigger('zen_mode:enter');
    });
    $(document).on('click', '.js-zen-leave', function (e) {
      e.preventDefault();
      return $(e.currentTarget).trigger('zen_mode:leave');
    });
    $(document).on('zen_mode:enter', function (_this) {
      return function (e) {
        return _this.enter($(e.target).closest('.md-area').find('.zen-backdrop'));
      };
    }(this));
    $(document).on('zen_mode:leave', function (_this) {
      return function (e) {
        return _this.exit();
      };
    }(this));
    $(document).on('keydown', function (e) {
      // Esc
      if (e.keyCode === 27) {
        e.preventDefault();
        return $(document).trigger('zen_mode:leave');
      }
    });
  }

  _createClass(ZenMode, [{
    key: 'enter',
    value: function enter(backdrop) {
      __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.pause();
      this.active_backdrop = $(backdrop);
      this.active_backdrop.addClass('fullscreen');
      this.active_textarea = this.active_backdrop.find('textarea');
      // Prevent a user-resized textarea from persisting to fullscreen
      this.active_textarea.removeAttr('style');
      this.active_textarea.focus();
    }
  }, {
    key: 'exit',
    value: function exit() {
      if (this.active_textarea) {
        __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.unpause();
        this.active_textarea.closest('.zen-backdrop').removeClass('fullscreen');
        this.scrollTo(this.active_textarea);
        this.active_textarea = null;
        this.active_backdrop = null;

        var $dropzone = $('.div-dropzone');
        if ($dropzone && !$dropzone.hasClass('js-invalid-dropzone')) {
          __WEBPACK_IMPORTED_MODULE_1_dropzone___default.a.forElement('.div-dropzone').enable();
        }
      }
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo(zen_area) {
      return $.scrollTo(zen_area, 0, {
        offset: -150
      });
    }
  }]);

  return ZenMode;
}();

/* harmony default export */ __webpack_exports__["a"] = (ZenMode);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ })

},["./pages/projects/merge_requests/show/index.js"]);


// WEBPACK FOOTER //
// pages.projects.merge_requests.show.c553ef204724fb85223d.bundle.js